import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from './fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ConditionValue: any;
  CustomFieldValue: any;
  DateTime: any;
  Email: any;
  JSON: any;
  Mixed: any;
  ObjectId: string;
  ReportFilter: any;
  ReportItemValue: any;
};

export type Activity = {
  confidence: Scalars['Float'];
  type: Scalars['String'];
};

export type AddShipmentExpenseInput = {
  /** Custom fields for the expense */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** Document for the expense */
  document?: InputMaybe<TransactionDocumentInput>;
  /** Label of the expense */
  label: Scalars['String'];
  /** Rate per unit */
  rate: Scalars['Float'];
  /** Whether to reimburse to driver */
  reimburseToDriver?: InputMaybe<Scalars['Boolean']>;
  /** Related transaction ID */
  relatedTransactionId?: InputMaybe<Scalars['ObjectId']>;
  /** ID of the shipment to add the expense to */
  shipmentId: Scalars['ObjectId'];
  /** Whether the expense is taxable */
  taxable?: InputMaybe<Scalars['Boolean']>;
  /** Type of transaction */
  type?: InputMaybe<TransactionType>;
  /** Number of units */
  unit: Scalars['Float'];
  /** Unit type for the expense */
  unitType: Scalars['String'];
};

/** Address with coordinates */
export type Address = {
  city?: Maybe<Scalars['String']>;
  coordinates: Coordinates;
  country?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AssetCustomFieldError = {
  assetId: Scalars['String'];
  assetType: Scalars['String'];
  isRequired: Scalars['Boolean'];
  message: Scalars['String'];
};

export type AssetLinking = {
  _id: Scalars['String'];
  additionalTrailers?: Maybe<Array<Trailer>>;
  driver?: Maybe<Driver>;
  endDate?: Maybe<Scalars['DateTime']>;
  isHardLinked?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  tractor?: Maybe<Tractor>;
  trailer?: Maybe<Trailer>;
};

export type AssetLinkingInput = {
  additionalTrailers?: InputMaybe<Array<Scalars['ObjectId']>>;
  driver?: InputMaybe<Scalars['ObjectId']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  isHardLinked?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  tractor?: InputMaybe<Scalars['ObjectId']>;
  trailer?: InputMaybe<Scalars['ObjectId']>;
};

export type AssetLinkingPaginatedResult = {
  count: Scalars['Int'];
  data: Array<AssetLinking>;
};

export type AssetLinkingUpdateInput = {
  additionalTrailers?: InputMaybe<Array<Scalars['ObjectId']>>;
  driver?: InputMaybe<Scalars['ObjectId']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  isHardLinked?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  tractor?: InputMaybe<Scalars['ObjectId']>;
  trailer?: InputMaybe<Scalars['ObjectId']>;
};

export enum AssetStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type AutomationConfig = {
  enabled: Scalars['Boolean'];
  forecastQuantity?: Maybe<Scalars['Float']>;
  frequencyMinutes?: Maybe<Scalars['Float']>;
  lastRunAt?: Maybe<Scalars['DateTime']>;
  nextRunAt?: Maybe<Scalars['DateTime']>;
};

export type AutomationConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  forecastQuantity?: InputMaybe<Scalars['Float']>;
  frequencyMinutes?: InputMaybe<Scalars['Float']>;
  lastRunAt?: InputMaybe<Scalars['DateTime']>;
  nextRunAt?: InputMaybe<Scalars['DateTime']>;
};

export type AverageSales = {
  averageSalesAmount: Scalars['Float'];
  dayOfWeek: Scalars['Float'];
};

export type AvoidPolygons = {
  coordinates: Array<Array<Scalars['Float']>>;
  type: Scalars['String'];
};

export type Battery = {
  is_charging: Scalars['Boolean'];
  level: Scalars['Float'];
};

export enum BillingMethod {
  FlatFee = 'FLAT_FEE',
  PercentageOfLineHaul = 'PERCENTAGE_OF_LINE_HAUL',
  PercentageOfTotal = 'PERCENTAGE_OF_TOTAL',
  PerDetentionHour = 'PER_DETENTION_HOUR',
  PerEmptyKm = 'PER_EMPTY_KM',
  PerEmptyMile = 'PER_EMPTY_MILE',
  PerGallon = 'PER_GALLON',
  PerHour = 'PER_HOUR',
  PerKg = 'PER_KG',
  PerKm = 'PER_KM',
  PerKmWithDeadhead = 'PER_KM_WITH_DEADHEAD',
  PerLiter = 'PER_LITER',
  PerLocation = 'PER_LOCATION',
  PerMile = 'PER_MILE',
  PerMileWithDeadhead = 'PER_MILE_WITH_DEADHEAD',
  PerPound = 'PER_POUND',
  PerUnit = 'PER_UNIT'
}

/** A billing rate */
export type BillingRate = {
  amount: Scalars['Float'];
  label?: Maybe<Scalars['String']>;
  method: BillingMethod;
  parameters?: Maybe<Array<BillingRateParameter>>;
  referenceNumber?: Maybe<Scalars['String']>;
  taxable?: Maybe<Scalars['Boolean']>;
};

export type BillingRateInput = {
  amount: Scalars['Float'];
  label?: InputMaybe<Scalars['String']>;
  method: BillingMethod;
  parameters?: InputMaybe<Array<BillingRateParameterInput>>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
};

export type BillingRateParameter = {
  type: BillingRateParameterType;
  value?: Maybe<Scalars['ConditionValue']>;
};

export type BillingRateParameterInput = {
  type: BillingRateParameterType;
  value?: InputMaybe<Scalars['ConditionValue']>;
};

export enum BillingRateParameterType {
  FreeLocationCount = 'FREE_LOCATION_COUNT',
  GoodProfile = 'GOOD_PROFILE',
  LocationType = 'LOCATION_TYPE',
  QuantityType = 'QUANTITY_TYPE',
  StorageFacility = 'STORAGE_FACILITY'
}

/** A customer billing rule */
export type BillingRule = {
  _id: Scalars['String'];
  /** @deprecated Use rates instead */
  amount?: Maybe<Scalars['Float']>;
  /** @deprecated Use conditions instead */
  condition: BillingRuleCondition;
  conditions: Array<BillingRuleCondition>;
  /** Custom fields for the billing rule */
  customFields?: Maybe<Array<CustomField>>;
  customer?: Maybe<BusinessEntity>;
  /** End of the effective window (inclusive, 23:59). Blank means always in effect. */
  effectiveEndDate?: Maybe<Scalars['DateTime']>;
  /** Start of the effective window (inclusive, 00:00). Blank means always in effect. */
  effectiveStartDate?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  /** @deprecated Use rates instead */
  method?: Maybe<BillingMethod>;
  priority?: Maybe<Scalars['Float']>;
  rates?: Maybe<Array<BillingRate>>;
  referenceNumber?: Maybe<Scalars['String']>;
  type: BillingRuleType;
};

export type BillingRuleCondition = {
  operator: BillingRuleConditionOperator;
  parameters?: Maybe<Array<BillingRuleConditionParameter>>;
  target: BillingRuleConditionTarget;
  value?: Maybe<Scalars['ConditionValue']>;
};

export type BillingRuleConditionInput = {
  operator: BillingRuleConditionOperator;
  parameters?: InputMaybe<Array<BillingRuleConditionParameterInput>>;
  target: BillingRuleConditionTarget;
  value?: InputMaybe<Scalars['ConditionValue']>;
};

export enum BillingRuleConditionOperator {
  Equals = 'EQUALS',
  IsBetween = 'IS_BETWEEN',
  IsGreaterThanOrEqual = 'IS_GREATER_THAN_OR_EQUAL',
  IsLessThanOrEqual = 'IS_LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS'
}

export type BillingRuleConditionParameter = {
  type: BillingRuleConditionParameterType;
  value?: Maybe<Scalars['ConditionValue']>;
};

export type BillingRuleConditionParameterInput = {
  type: BillingRuleConditionParameterType;
  value?: InputMaybe<Scalars['ConditionValue']>;
};

export enum BillingRuleConditionParameterType {
  FuelCostArea = 'FUEL_COST_AREA',
  FuelCostBasis = 'FUEL_COST_BASIS',
  FuelCostEffectiveDay = 'FUEL_COST_EFFECTIVE_DAY',
  FuelCostPeriod = 'FUEL_COST_PERIOD'
}

export enum BillingRuleConditionTarget {
  CustomerState = 'CUSTOMER_STATE',
  Date = 'DATE',
  DetentionTime = 'DETENTION_TIME',
  FuelCost = 'FUEL_COST',
  Goods = 'GOODS',
  Mileage = 'MILEAGE',
  Otherwise = 'OTHERWISE',
  Receiver = 'RECEIVER',
  ReceiverCity = 'RECEIVER_CITY',
  ReceiverState = 'RECEIVER_STATE',
  Shipper = 'SHIPPER',
  ShipperCity = 'SHIPPER_CITY',
  ShipperState = 'SHIPPER_STATE',
  Time = 'TIME',
  Tractor = 'TRACTOR',
  Trailer = 'TRAILER',
  TrailerType = 'TRAILER_TYPE',
  Volume = 'VOLUME'
}

export type BillingRulePaginatedResult = {
  count: Scalars['Int'];
  data: Array<BillingRule>;
};

export enum BillingRuleType {
  Accessorial = 'ACCESSORIAL',
  OrderCancellation = 'ORDER_CANCELLATION',
  Primary = 'PRIMARY',
  Tax = 'TAX'
}

export type BillingRuleUpdateInput = {
  amount?: InputMaybe<Scalars['Float']>;
  condition?: InputMaybe<BillingRuleConditionInput>;
  conditions?: InputMaybe<Array<BillingRuleConditionInput>>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  customer?: InputMaybe<Scalars['String']>;
  /** End of the effective window (inclusive, 23:59). Blank means always in effect. */
  effectiveEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Start of the effective window (inclusive, 00:00). Blank means always in effect. */
  effectiveStartDate?: InputMaybe<Scalars['DateTime']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<BillingMethod>;
  priority?: InputMaybe<Scalars['Float']>;
  rates?: InputMaybe<Array<BillingRateInput>>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<BillingRuleType>;
};

/** A Broker Business entity */
export type Broker = {
  _id: Scalars['String'];
  /** Token used for access to the customer portal */
  accessToken?: Maybe<Scalars['String']>;
  /** Additional contacts for the business entity. */
  additionalContacts?: Maybe<Array<Contact>>;
  /** Additional types for the business entity (e.g. a business entity could be both a customer and shipper). */
  additionalTypes?: Maybe<Array<BusinessEntityType>>;
  /** Physical address of the business entity. */
  address: Address;
  /** Timezone of the business entity address. If not provided, it will be inferred from the address. */
  addressTimezone?: Maybe<Scalars['String']>;
  /** Billing address for the business entity. */
  billingAddress?: Maybe<TextualAddress>;
  /** Billing email for the business entity. Invoices are sent here */
  billingEmail?: Maybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: Maybe<InvoiceConsolidationCriteria>;
  /** Billing terms for the business entity in days. */
  billingTermsDay?: Maybe<Scalars['Float']>;
  billingWeekStartsOn?: Maybe<Scalars['Float']>;
  /** Unique code identifying the business entity. */
  code?: Maybe<Scalars['String']>;
  /** Pre-assigned commodity profiles for this receiver. Resolved by field resolver. */
  commodities?: Maybe<Array<GoodProfile>>;
  commodityIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Primary contact for the business entity. */
  contact: Contact;
  /** For carriers only, the credit terms they offer. */
  creditTerms?: Maybe<Scalars['String']>;
  /** Custom fields for the business entity */
  customFields?: Maybe<Array<CustomField>>;
  defaultReferenceNumbers?: Maybe<Array<DefaultReferenceNumber>>;
  /** The default shipper for this business entity */
  defaultShipper?: Maybe<BusinessEntity>;
  /** ID of the default shipper for this business entity. This is used by default when a shipment is sent to this business entity */
  defaultShipperId?: Maybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: Maybe<Array<DocumentRequirement>>;
  /** Documents for the business entity */
  documents?: Maybe<Array<Document>>;
  /** DOT Number for carriers and brokers */
  dotNumber?: Maybe<Scalars['String']>;
  /** ID of the business entity in an external system. */
  externalId?: Maybe<Scalars['String']>;
  /** Federal ID for business entities */
  federalId?: Maybe<Scalars['String']>;
  goodInventoryItems?: Maybe<Array<GoodInventoryItem>>;
  /** IDs of the groups that this business entity belongs to */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** MC Number for carriers */
  mcNumber?: Maybe<Scalars['String']>;
  /** Legal name of the business entity. */
  name: Scalars['String'];
  notes?: Maybe<Array<BusinessEntityNote>>;
  /** Opening schedules for the business entity. */
  openingSchedules?: Maybe<Array<OpeningSchedule>>;
  /** The business entity that this business entity belongs to */
  parentBusinessEntity?: Maybe<BusinessEntity>;
  /** ID of the business entity that this business entity belongs to. Used for receiver/customer relations for example */
  parentBusinessEntityId?: Maybe<Scalars['ObjectId']>;
  /** The business entity that we need to pay to. Used for carriers */
  payToProfile?: Maybe<BusinessEntity>;
  /** ID of the business entity that we need to pay to. Used for carriers */
  payToProfileId?: Maybe<Scalars['ObjectId']>;
  /** Planned dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  /** For customers and brokers, the types of reference numbers they use in orders. */
  referenceNumberTypes?: Maybe<Array<ShipmentReferenceNumberType>>;
  /** Remit address for the business entity. Where payments are sent. */
  remitAddress?: Maybe<TextualAddress>;
  /** Remit company name for the business entity */
  remitCompanyName?: Maybe<Scalars['String']>;
  /** Remit email for the business entity */
  remitEmail?: Maybe<Scalars['String']>;
  /** Shipmentp documents to receive via email on completion */
  shipmentDocumentsToReceive?: Maybe<Array<Scalars['String']>>;
  /** SCAC code for carriers */
  standardCarrierAlphaCode?: Maybe<Scalars['String']>;
  status: AssetStatus;
  /** Storage facilities for the business entity. Used for tanks, warehouses, etc */
  storageFacilities?: Maybe<Array<StorageFacility>>;
  /** Tags for the business entity */
  tags?: Maybe<Array<Scalars['String']>>;
  /** For carriers only, the types of trailers they have. */
  trailerTypes?: Maybe<Array<TrailerType>>;
  /** The type of business entity. */
  type: BusinessEntityType;
};


/** A Broker Business entity */
export type BrokerStorageFacilitiesArgs = {
  includeLinkedFacilities?: InputMaybe<Scalars['Boolean']>;
};

export type BrokerPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Broker>;
};

export type BulkEditDriverInput = {
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type BulkExtensionOperationResponse = {
  failureCount: Scalars['Float'];
  message?: Maybe<Scalars['String']>;
  results: Array<BulkOperationRecordResult>;
  successCount: Scalars['Float'];
  totalProcessed: Scalars['Float'];
};

export type BulkOperationRecordResult = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  recordId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type BulkUpdateResult = {
  acknowledged: Scalars['Boolean'];
  matchedCount?: Maybe<Scalars['Int']>;
  modifiedCount?: Maybe<Scalars['Int']>;
  upsertedCount?: Maybe<Scalars['Int']>;
};

/** Business entity */
export type BusinessEntity = {
  _id: Scalars['String'];
  /** Token used for access to the customer portal */
  accessToken?: Maybe<Scalars['String']>;
  /** Additional contacts for the business entity. */
  additionalContacts?: Maybe<Array<Contact>>;
  /** Additional types for the business entity (e.g. a business entity could be both a customer and shipper). */
  additionalTypes?: Maybe<Array<BusinessEntityType>>;
  /** Physical address of the business entity. */
  address: Address;
  /** Timezone of the business entity address. If not provided, it will be inferred from the address. */
  addressTimezone?: Maybe<Scalars['String']>;
  /** Billing address for the business entity. */
  billingAddress?: Maybe<TextualAddress>;
  /** Billing email for the business entity. Invoices are sent here */
  billingEmail?: Maybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: Maybe<InvoiceConsolidationCriteria>;
  /** Billing terms for the business entity in days. */
  billingTermsDay?: Maybe<Scalars['Float']>;
  billingWeekStartsOn?: Maybe<Scalars['Float']>;
  /** Unique code identifying the business entity. */
  code?: Maybe<Scalars['String']>;
  /** Pre-assigned commodity profiles for this receiver. Resolved by field resolver. */
  commodities?: Maybe<Array<GoodProfile>>;
  commodityIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Primary contact for the business entity. */
  contact: Contact;
  /** For carriers only, the credit terms they offer. */
  creditTerms?: Maybe<Scalars['String']>;
  /** Custom fields for the business entity */
  customFields?: Maybe<Array<CustomField>>;
  defaultReferenceNumbers?: Maybe<Array<DefaultReferenceNumber>>;
  /** The default shipper for this business entity */
  defaultShipper?: Maybe<BusinessEntity>;
  /** ID of the default shipper for this business entity. This is used by default when a shipment is sent to this business entity */
  defaultShipperId?: Maybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: Maybe<Array<DocumentRequirement>>;
  /** Documents for the business entity */
  documents?: Maybe<Array<Document>>;
  /** DOT Number for carriers and brokers */
  dotNumber?: Maybe<Scalars['String']>;
  /** ID of the business entity in an external system. */
  externalId?: Maybe<Scalars['String']>;
  /** Federal ID for business entities */
  federalId?: Maybe<Scalars['String']>;
  goodInventoryItems?: Maybe<Array<GoodInventoryItem>>;
  /** IDs of the groups that this business entity belongs to */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** MC Number for carriers */
  mcNumber?: Maybe<Scalars['String']>;
  /** Legal name of the business entity. */
  name: Scalars['String'];
  notes?: Maybe<Array<BusinessEntityNote>>;
  /** Opening schedules for the business entity. */
  openingSchedules?: Maybe<Array<OpeningSchedule>>;
  /** The business entity that this business entity belongs to */
  parentBusinessEntity?: Maybe<BusinessEntity>;
  /** ID of the business entity that this business entity belongs to. Used for receiver/customer relations for example */
  parentBusinessEntityId?: Maybe<Scalars['ObjectId']>;
  /** The business entity that we need to pay to. Used for carriers */
  payToProfile?: Maybe<BusinessEntity>;
  /** ID of the business entity that we need to pay to. Used for carriers */
  payToProfileId?: Maybe<Scalars['ObjectId']>;
  /** Planned dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  /** For customers and brokers, the types of reference numbers they use in orders. */
  referenceNumberTypes?: Maybe<Array<ShipmentReferenceNumberType>>;
  /** Remit address for the business entity. Where payments are sent. */
  remitAddress?: Maybe<TextualAddress>;
  /** Remit company name for the business entity */
  remitCompanyName?: Maybe<Scalars['String']>;
  /** Remit email for the business entity */
  remitEmail?: Maybe<Scalars['String']>;
  /** Shipmentp documents to receive via email on completion */
  shipmentDocumentsToReceive?: Maybe<Array<Scalars['String']>>;
  /** SCAC code for carriers */
  standardCarrierAlphaCode?: Maybe<Scalars['String']>;
  status: AssetStatus;
  /** Storage facilities for the business entity. Used for tanks, warehouses, etc */
  storageFacilities?: Maybe<Array<StorageFacility>>;
  /** Tags for the business entity */
  tags?: Maybe<Array<Scalars['String']>>;
  /** For carriers only, the types of trailers they have. */
  trailerTypes?: Maybe<Array<TrailerType>>;
  /** The type of business entity. */
  type: BusinessEntityType;
};


/** Business entity */
export type BusinessEntityStorageFacilitiesArgs = {
  includeLinkedFacilities?: InputMaybe<Scalars['Boolean']>;
};

export type BusinessEntityNote = {
  _id?: Maybe<Scalars['ObjectId']>;
  accessLevel?: Maybe<Array<NoteAccessLevel>>;
  addToShipment: Scalars['Boolean'];
  content: Scalars['String'];
};

export type BusinessEntityNoteInput = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  accessLevel?: InputMaybe<Array<NoteAccessLevel>>;
  addToShipment?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
};

export type BusinessEntityPaginatedResult = {
  count: Scalars['Int'];
  data: Array<BusinessEntity>;
};

export enum BusinessEntityType {
  Broker = 'BROKER',
  Carrier = 'CARRIER',
  Customer = 'CUSTOMER',
  Domicile = 'DOMICILE',
  GeneralLocation = 'GENERAL_LOCATION',
  PayToProfile = 'PAY_TO_PROFILE',
  Port = 'PORT',
  Receiver = 'RECEIVER',
  Shipper = 'SHIPPER',
  Supplier = 'SUPPLIER',
  Terminal = 'TERMINAL',
  TruckStop = 'TRUCK_STOP'
}

export type BusinessEntityUpdateInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  additionalContacts?: InputMaybe<Array<NewContactInput>>;
  additionalTypes?: InputMaybe<Array<BusinessEntityType>>;
  address?: InputMaybe<NewAddressInput>;
  billingAddress?: InputMaybe<NewTextualAddressInput>;
  billingEmail?: InputMaybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: InputMaybe<InvoiceConsolidationCriteria>;
  billingTermsDay?: InputMaybe<Scalars['Float']>;
  billingWeekStartsOn?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<Scalars['String']>;
  commodityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  contact?: InputMaybe<NewContactInput>;
  creditTerms?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  defaultReferenceNumbers?: InputMaybe<Array<DefaultReferenceNumberInput>>;
  defaultShipperId?: InputMaybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: InputMaybe<Array<DocumentRequirementInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  dotNumber?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  federalId?: InputMaybe<Scalars['String']>;
  goodInventoryItems?: InputMaybe<Array<GoodInventoryItemInput>>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  mcNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Array<BusinessEntityNoteInput>>;
  openingSchedules?: InputMaybe<Array<OpeningScheduleInput>>;
  parentBusinessEntityId?: InputMaybe<Scalars['ObjectId']>;
  payToProfileId?: InputMaybe<Scalars['ObjectId']>;
  /** Dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: InputMaybe<Scalars['Float']>;
  referenceNumberTypes?: InputMaybe<Array<ShipmentReferenceNumberType>>;
  remitAddress?: InputMaybe<NewTextualAddressInput>;
  /** Remit company name for the business entity */
  remitCompanyName?: InputMaybe<Scalars['String']>;
  remitEmail?: InputMaybe<Scalars['String']>;
  shipmentDocumentsToReceive?: InputMaybe<Array<Scalars['String']>>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssetStatus>;
  storageFacilities?: InputMaybe<Array<StorageFacilityInput>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  trailerTypes?: InputMaybe<Array<TrailerType>>;
  type?: InputMaybe<Scalars['String']>;
};

/** A Carrier Business entity */
export type Carrier = {
  _id: Scalars['String'];
  /** Token used for access to the customer portal */
  accessToken?: Maybe<Scalars['String']>;
  /** Additional contacts for the business entity. */
  additionalContacts?: Maybe<Array<Contact>>;
  /** Additional types for the business entity (e.g. a business entity could be both a customer and shipper). */
  additionalTypes?: Maybe<Array<BusinessEntityType>>;
  /** Physical address of the business entity. */
  address: Address;
  /** Timezone of the business entity address. If not provided, it will be inferred from the address. */
  addressTimezone?: Maybe<Scalars['String']>;
  /** Billing address for the business entity. */
  billingAddress?: Maybe<TextualAddress>;
  /** Billing email for the business entity. Invoices are sent here */
  billingEmail?: Maybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: Maybe<InvoiceConsolidationCriteria>;
  /** Billing terms for the business entity in days. */
  billingTermsDay?: Maybe<Scalars['Float']>;
  billingWeekStartsOn?: Maybe<Scalars['Float']>;
  /** Unique code identifying the business entity. */
  code?: Maybe<Scalars['String']>;
  /** Pre-assigned commodity profiles for this receiver. Resolved by field resolver. */
  commodities?: Maybe<Array<GoodProfile>>;
  commodityIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Primary contact for the business entity. */
  contact: Contact;
  /** For carriers only, the credit terms they offer. */
  creditTerms?: Maybe<Scalars['String']>;
  /** Custom fields for the business entity */
  customFields?: Maybe<Array<CustomField>>;
  defaultReferenceNumbers?: Maybe<Array<DefaultReferenceNumber>>;
  /** The default shipper for this business entity */
  defaultShipper?: Maybe<BusinessEntity>;
  /** ID of the default shipper for this business entity. This is used by default when a shipment is sent to this business entity */
  defaultShipperId?: Maybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: Maybe<Array<DocumentRequirement>>;
  /** Documents for the business entity */
  documents?: Maybe<Array<Document>>;
  /** DOT Number for carriers and brokers */
  dotNumber?: Maybe<Scalars['String']>;
  /** ID of the business entity in an external system. */
  externalId?: Maybe<Scalars['String']>;
  /** Federal ID for business entities */
  federalId?: Maybe<Scalars['String']>;
  goodInventoryItems?: Maybe<Array<GoodInventoryItem>>;
  /** IDs of the groups that this business entity belongs to */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** MC Number for carriers */
  mcNumber?: Maybe<Scalars['String']>;
  /** Legal name of the business entity. */
  name: Scalars['String'];
  notes?: Maybe<Array<BusinessEntityNote>>;
  /** Opening schedules for the business entity. */
  openingSchedules?: Maybe<Array<OpeningSchedule>>;
  /** The business entity that this business entity belongs to */
  parentBusinessEntity?: Maybe<BusinessEntity>;
  /** ID of the business entity that this business entity belongs to. Used for receiver/customer relations for example */
  parentBusinessEntityId?: Maybe<Scalars['ObjectId']>;
  /** The business entity that we need to pay to. Used for carriers */
  payToProfile?: Maybe<BusinessEntity>;
  /** ID of the business entity that we need to pay to. Used for carriers */
  payToProfileId?: Maybe<Scalars['ObjectId']>;
  /** Planned dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  /** For customers and brokers, the types of reference numbers they use in orders. */
  referenceNumberTypes?: Maybe<Array<ShipmentReferenceNumberType>>;
  /** Remit address for the business entity. Where payments are sent. */
  remitAddress?: Maybe<TextualAddress>;
  /** Remit company name for the business entity */
  remitCompanyName?: Maybe<Scalars['String']>;
  /** Remit email for the business entity */
  remitEmail?: Maybe<Scalars['String']>;
  /** Shipmentp documents to receive via email on completion */
  shipmentDocumentsToReceive?: Maybe<Array<Scalars['String']>>;
  /** SCAC code for carriers */
  standardCarrierAlphaCode?: Maybe<Scalars['String']>;
  status: AssetStatus;
  /** Storage facilities for the business entity. Used for tanks, warehouses, etc */
  storageFacilities?: Maybe<Array<StorageFacility>>;
  /** Tags for the business entity */
  tags?: Maybe<Array<Scalars['String']>>;
  /** For carriers only, the types of trailers they have. */
  trailerTypes?: Maybe<Array<TrailerType>>;
  /** The type of business entity. */
  type: BusinessEntityType;
};


/** A Carrier Business entity */
export type CarrierStorageFacilitiesArgs = {
  includeLinkedFacilities?: InputMaybe<Scalars['Boolean']>;
};

export type ChangeTripStartTimeInput = {
  distanceToEnd?: InputMaybe<Scalars['Float']>;
  distanceToStart?: InputMaybe<Scalars['Float']>;
  etaFromPreviousTrip?: InputMaybe<Scalars['Float']>;
  etaToNextTrip?: InputMaybe<Scalars['Float']>;
  predictedLoadedDistance?: InputMaybe<Scalars['Float']>;
  startTime: Scalars['DateTime'];
  tripId: Scalars['ObjectId'];
  violations?: InputMaybe<Array<TripViolationInput>>;
};

/** Different types of charges for a shipment */
export enum ChargeType {
  Accessorial = 'ACCESSORIAL',
  Linehaul = 'LINEHAUL',
  OrderCancellation = 'ORDER_CANCELLATION',
  Tax = 'TAX'
}

/** A Chassis entity */
export type Chassis = {
  _id: Scalars['String'];
  lastKnownLocation?: Maybe<Coordinates>;
  lastKnownLocationDate?: Maybe<Scalars['DateTime']>;
  serialNumber: Scalars['String'];
  status: AssetStatus;
};

export type ChassisPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Chassis>;
};

export type CollectionTransferResult = {
  collectionName: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  recordCount: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type CompartmentVolume = {
  _id: Scalars['ObjectId'];
  commodityId?: Maybe<Scalars['String']>;
  compartmentId: Scalars['String'];
  lastShipmentId?: Maybe<Scalars['ObjectId']>;
  lastShipmentNumber?: Maybe<Scalars['String']>;
  lastUpdated: Scalars['DateTime'];
  quantity: Scalars['Float'];
  trailerId: Scalars['ObjectId'];
  updatedBy: Scalars['String'];
};

export type ConstraintValidationException = {
  data: ConstraintValidationExceptionData;
  message: Scalars['String'];
  name: ExceptionType;
  type: ExceptionType;
};

export type ConstraintValidationExceptionData = {
  failedConstraints: Array<FailedConstraint>;
};

/** Business entity contact */
export type Contact = {
  email?: Maybe<Scalars['String']>;
  extensionNumber?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  includeInDocumentSending?: Maybe<Scalars['Boolean']>;
  includeInInvoicing?: Maybe<Scalars['Boolean']>;
  lastname: Scalars['String'];
  middlename?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Coordinates = {
  altitude?: Maybe<Scalars['Float']>;
  heading?: Maybe<Scalars['Float']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  speed?: Maybe<Scalars['Float']>;
};

export type CoordinatesInput = {
  altitude?: InputMaybe<Scalars['Float']>;
  heading?: InputMaybe<Scalars['Float']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  speed?: InputMaybe<Scalars['Float']>;
};

export enum Currency {
  Cad = 'CAD',
  Eur = 'EUR',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type CustomField = {
  key: Scalars['String'];
  value?: Maybe<Scalars['CustomFieldValue']>;
};

export enum CustomFieldContext {
  Carrier = 'CARRIER',
  Commodity = 'COMMODITY',
  Customer = 'CUSTOMER',
  Domicile = 'DOMICILE',
  Driver = 'DRIVER',
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  Location = 'LOCATION',
  Receiver = 'RECEIVER',
  Shipment = 'SHIPMENT',
  Shipper = 'SHIPPER',
  StorageFacility = 'STORAGE_FACILITY',
  Supplier = 'SUPPLIER',
  TaxBillingRule = 'TAX_BILLING_RULE',
  Tractor = 'TRACTOR',
  Trailer = 'TRAILER',
  Trip = 'TRIP',
  User = 'USER'
}

/** Custom field */
export type CustomFieldDefinition = {
  _id: Scalars['String'];
  context: Array<CustomFieldContext>;
  defaultOption?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  extensionId?: Maybe<Scalars['String']>;
  isExtensionField?: Maybe<Scalars['Boolean']>;
  isRequirement?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  label: Scalars['String'];
  requirementOptions?: Maybe<CustomFieldRequirementOptions>;
  selectOptions?: Maybe<Array<CustomFieldSelectOption>>;
  selectOptionsEndpoint?: Maybe<Scalars['String']>;
  selectOptionsEntity?: Maybe<CustomFieldSelectOptionEntity>;
  type: CustomFieldType;
};

export type CustomFieldDefinitionPaginatedResult = {
  count: Scalars['Int'];
  data: Array<CustomFieldDefinition>;
};

export type CustomFieldDefinitionUpdateInput = {
  context?: InputMaybe<Array<CustomFieldContext>>;
  defaultOption?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  extensionId?: InputMaybe<Scalars['String']>;
  isExtensionField?: InputMaybe<Scalars['Boolean']>;
  isRequirement?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  requirementOptions?: InputMaybe<CustomFieldRequirementOptionsInput>;
  selectOptions?: InputMaybe<Array<CustomFieldSelectOptionInput>>;
  selectOptionsEndpoint?: InputMaybe<Scalars['String']>;
  selectOptionsEntity?: InputMaybe<CustomFieldSelectOptionEntity>;
  type?: InputMaybe<CustomFieldType>;
};

export type CustomFieldInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['CustomFieldValue']>;
};

/** Custom field requirement options */
export type CustomFieldRequirementOptions = {
  isPartial?: Maybe<Scalars['Boolean']>;
  isRange?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type CustomFieldRequirementOptionsInput = {
  isPartial?: InputMaybe<Scalars['Boolean']>;
  isRange?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
};

/** Custom field select option */
export type CustomFieldSelectOption = {
  key: Scalars['String'];
  label: Scalars['String'];
};

export enum CustomFieldSelectOptionEntity {
  Carrier = 'CARRIER',
  Commodity = 'COMMODITY',
  Customer = 'CUSTOMER',
  Domicile = 'DOMICILE',
  Driver = 'DRIVER',
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  Location = 'LOCATION',
  Receiver = 'RECEIVER',
  Shipment = 'SHIPMENT',
  Shipper = 'SHIPPER',
  StorageFacility = 'STORAGE_FACILITY',
  Supplier = 'SUPPLIER',
  TaxBillingRule = 'TAX_BILLING_RULE',
  Tractor = 'TRACTOR',
  Trailer = 'TRAILER',
  Trip = 'TRIP',
  User = 'USER'
}

export type CustomFieldSelectOptionInput = {
  key: Scalars['String'];
  label: Scalars['String'];
};

export enum CustomFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Select = 'SELECT',
  String = 'STRING',
  Time = 'TIME'
}

/** A Customer Business entity */
export type Customer = {
  _id: Scalars['String'];
  /** Token used for access to the customer portal */
  accessToken?: Maybe<Scalars['String']>;
  /** Additional contacts for the business entity. */
  additionalContacts?: Maybe<Array<Contact>>;
  /** Additional types for the business entity (e.g. a business entity could be both a customer and shipper). */
  additionalTypes?: Maybe<Array<BusinessEntityType>>;
  /** Physical address of the business entity. */
  address: Address;
  /** Timezone of the business entity address. If not provided, it will be inferred from the address. */
  addressTimezone?: Maybe<Scalars['String']>;
  /** Billing address for the business entity. */
  billingAddress?: Maybe<TextualAddress>;
  /** Billing email for the business entity. Invoices are sent here */
  billingEmail?: Maybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: Maybe<InvoiceConsolidationCriteria>;
  /** Billing terms for the business entity in days. */
  billingTermsDay?: Maybe<Scalars['Float']>;
  billingWeekStartsOn?: Maybe<Scalars['Float']>;
  /** Unique code identifying the business entity. */
  code?: Maybe<Scalars['String']>;
  /** Pre-assigned commodity profiles for this receiver. Resolved by field resolver. */
  commodities?: Maybe<Array<GoodProfile>>;
  commodityIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Primary contact for the business entity. */
  contact: Contact;
  /** For carriers only, the credit terms they offer. */
  creditTerms?: Maybe<Scalars['String']>;
  /** Custom fields for the business entity */
  customFields?: Maybe<Array<CustomField>>;
  defaultReferenceNumbers?: Maybe<Array<DefaultReferenceNumber>>;
  /** The default shipper for this business entity */
  defaultShipper?: Maybe<BusinessEntity>;
  /** ID of the default shipper for this business entity. This is used by default when a shipment is sent to this business entity */
  defaultShipperId?: Maybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: Maybe<Array<DocumentRequirement>>;
  /** Documents for the business entity */
  documents?: Maybe<Array<Document>>;
  /** DOT Number for carriers and brokers */
  dotNumber?: Maybe<Scalars['String']>;
  /** ID of the business entity in an external system. */
  externalId?: Maybe<Scalars['String']>;
  /** Federal ID for business entities */
  federalId?: Maybe<Scalars['String']>;
  goodInventoryItems?: Maybe<Array<GoodInventoryItem>>;
  /** IDs of the groups that this business entity belongs to */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** MC Number for carriers */
  mcNumber?: Maybe<Scalars['String']>;
  /** Legal name of the business entity. */
  name: Scalars['String'];
  notes?: Maybe<Array<BusinessEntityNote>>;
  /** Opening schedules for the business entity. */
  openingSchedules?: Maybe<Array<OpeningSchedule>>;
  /** The business entity that this business entity belongs to */
  parentBusinessEntity?: Maybe<BusinessEntity>;
  /** ID of the business entity that this business entity belongs to. Used for receiver/customer relations for example */
  parentBusinessEntityId?: Maybe<Scalars['ObjectId']>;
  /** The business entity that we need to pay to. Used for carriers */
  payToProfile?: Maybe<BusinessEntity>;
  /** ID of the business entity that we need to pay to. Used for carriers */
  payToProfileId?: Maybe<Scalars['ObjectId']>;
  /** Planned dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  /** For customers and brokers, the types of reference numbers they use in orders. */
  referenceNumberTypes?: Maybe<Array<ShipmentReferenceNumberType>>;
  /** Remit address for the business entity. Where payments are sent. */
  remitAddress?: Maybe<TextualAddress>;
  /** Remit company name for the business entity */
  remitCompanyName?: Maybe<Scalars['String']>;
  /** Remit email for the business entity */
  remitEmail?: Maybe<Scalars['String']>;
  /** Shipmentp documents to receive via email on completion */
  shipmentDocumentsToReceive?: Maybe<Array<Scalars['String']>>;
  /** SCAC code for carriers */
  standardCarrierAlphaCode?: Maybe<Scalars['String']>;
  status: AssetStatus;
  /** Storage facilities for the business entity. Used for tanks, warehouses, etc */
  storageFacilities?: Maybe<Array<StorageFacility>>;
  /** Tags for the business entity */
  tags?: Maybe<Array<Scalars['String']>>;
  /** For carriers only, the types of trailers they have. */
  trailerTypes?: Maybe<Array<TrailerType>>;
  /** The type of business entity. */
  type: BusinessEntityType;
};


/** A Customer Business entity */
export type CustomerStorageFacilitiesArgs = {
  includeLinkedFacilities?: InputMaybe<Scalars['Boolean']>;
};

export type CustomerPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Customer>;
};

export type DailyForecastingModelSlot = {
  dayOfWeek: Scalars['Float'];
};

export type DailyForecastingModelSlotInput = {
  dayOfWeek: Scalars['Float'];
};

export type DateRangeInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type DateTimeWindow = {
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
};

export type DateTimeWindowInput = {
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
};

/** A deduction/bonus from a driver settlement */
export type Deduction = {
  _id: Scalars['String'];
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  deductionRule?: Maybe<DeductionRule>;
  label: Scalars['String'];
  type: DeductionType;
};

/** A deduction/bonus from a driver settlement */
export type DeductionInput = {
  _id?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  label: Scalars['String'];
  type: DeductionType;
};

/** The period over which a deduction applies */
export type DeductionPeriod = {
  end: Scalars['DateTime'];
  repeatEvery: Scalars['Float'];
  start: Scalars['DateTime'];
  unit: DeductionPeriodUnit;
};

export type DeductionPeriodInput = {
  end: Scalars['DateTime'];
  repeatEvery: Scalars['Float'];
  start: Scalars['DateTime'];
  unit: DeductionPeriodUnit;
};

export enum DeductionPeriodUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** A driver deduction/bonus rule */
export type DeductionRule = {
  _id: Scalars['String'];
  amount: Scalars['Float'];
  driver?: Maybe<Driver>;
  label: Scalars['String'];
  method: DriverDeductionMethod;
  period: DeductionPeriod;
  type: DeductionType;
};

export type DeductionRulePaginatedResult = {
  count: Scalars['Int'];
  data: Array<DeductionRule>;
};

export type DeductionRuleUpdateInput = {
  amount?: InputMaybe<Scalars['Float']>;
  driver?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<DriverDeductionMethod>;
  period?: InputMaybe<DeductionPeriodInput>;
  type?: InputMaybe<DeductionType>;
};

export enum DeductionType {
  Bonus = 'BONUS',
  Deduction = 'DEDUCTION'
}

export type DefaultReferenceNumber = {
  referenceNumberType: ShipmentReferenceNumberType;
  referenceNumberValue: Scalars['String'];
};

export type DefaultReferenceNumberInput = {
  referenceNumberType: ShipmentReferenceNumberType;
  referenceNumberValue: Scalars['String'];
};

export type DeleteShipmentDocumentInput = {
  _id?: InputMaybe<Scalars['String']>;
  shipment?: InputMaybe<Scalars['String']>;
};

export type DeleteShipmentNoteInput = {
  _id?: InputMaybe<Scalars['String']>;
  shipment?: InputMaybe<Scalars['String']>;
};

export type DispatchingSettings = {
  canChangeTripOrder?: Maybe<Scalars['Boolean']>;
  canConsolidateInProgressShipments?: Maybe<Scalars['Boolean']>;
  canDriverSetAlternateSupplierPinCode?: Maybe<Scalars['Boolean']>;
  canUseAdHocAddress?: Maybe<Scalars['Boolean']>;
  /** Default Trailer Type(s) applied when creating a new liquid shipment. Absence is treated as [TANKER]. */
  defaultTrailerTypes?: Maybe<Array<TrailerType>>;
  /** Enable warnings when delivery quantity exceeds tank capacity in order entry for monitored tanks */
  enableCapacityWarnings?: Maybe<Scalars['Boolean']>;
  /** Live ETA for in progress trips. When disabled, no ETA routing calls are made. */
  enableEta?: Maybe<Scalars['Boolean']>;
  /** Default Order Type applied when creating a new Shipment. Absence is treated as FULL_TRUCK_LOAD. */
  orderTypeDefault?: Maybe<LoadType>;
  receiverDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  shipperDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  trackCommodity?: Maybe<Scalars['Boolean']>;
  /** Net and Gross Gallons: when enabled, drivers can enter Net gallons (in addition to Gross) on pickups and dropoffs, and dispatchers can see/edit both Net and Gross loaded and delivered amounts. */
  trackNetAndGrossVolumes?: Maybe<Scalars['Boolean']>;
};

export type DispatchingSettingsInput = {
  canChangeTripOrder?: InputMaybe<Scalars['Boolean']>;
  canConsolidateInProgressShipments?: InputMaybe<Scalars['Boolean']>;
  canDriverSetAlternateSupplierPinCode?: InputMaybe<Scalars['Boolean']>;
  canUseAdHocAddress?: InputMaybe<Scalars['Boolean']>;
  /** Default Trailer Type(s) applied when creating a new liquid shipment. Absence is treated as [TANKER]. */
  defaultTrailerTypes?: InputMaybe<Array<TrailerType>>;
  /** Enable warnings when delivery quantity exceeds tank capacity in order entry for monitored tanks */
  enableCapacityWarnings?: InputMaybe<Scalars['Boolean']>;
  /** Live ETA for in progress trips. When disabled, no ETA routing calls are made. */
  enableEta?: InputMaybe<Scalars['Boolean']>;
  /** Default Order Type applied when creating a new Shipment. Absence is treated as FULL_TRUCK_LOAD. */
  orderTypeDefault?: InputMaybe<LoadType>;
  receiverDwellTimeInMinutes?: InputMaybe<Scalars['Float']>;
  shipperDwellTimeInMinutes?: InputMaybe<Scalars['Float']>;
  trackCommodity?: InputMaybe<Scalars['Boolean']>;
  /** Net and Gross Gallons: when enabled, drivers can enter Net gallons (in addition to Gross) on pickups and dropoffs, and dispatchers can see/edit both Net and Gross loaded and delivered amounts. */
  trackNetAndGrossVolumes?: InputMaybe<Scalars['Boolean']>;
};

export type Document = {
  _id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type DocumentInput = {
  _id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

/** Document requirement for invoicing */
export type DocumentRequirement = {
  attachToInvoice: Scalars['Boolean'];
  documentName?: Maybe<Scalars['String']>;
  documentType: DocumentType;
  requiredForInvoicing: Scalars['Boolean'];
};

export type DocumentRequirementInput = {
  attachToInvoice?: InputMaybe<Scalars['Boolean']>;
  documentName?: InputMaybe<Scalars['String']>;
  documentType: DocumentType;
  requiredForInvoicing?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentSignedUrl = {
  key: Scalars['String'];
  url: Scalars['String'];
};

export type DocumentSignedUrlInput = {
  extension?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  operation: S3_Operation;
};

/** Types of documents that can be required by customers */
export enum DocumentType {
  CustomsForm = 'CUSTOMS_FORM',
  DeliveryBol = 'DELIVERY_BOL',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  PackingList = 'PACKING_LIST',
  PickupBol = 'PICKUP_BOL',
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  Ratecon = 'RATECON',
  WeightTicket = 'WEIGHT_TICKET'
}

/** Driver entity */
export type Driver = {
  _id: Scalars['String'];
  customFields?: Maybe<Array<CustomField>>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfPhysicalExamination?: Maybe<Scalars['DateTime']>;
  documents?: Maybe<Array<DriverDocument>>;
  /** Where the driver starts his journey everyday */
  domicile?: Maybe<Address>;
  domicileEntity?: Maybe<BusinessEntity>;
  domicileId?: Maybe<Scalars['ObjectId']>;
  eldId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  hos?: Maybe<DriverHos>;
  isOwnerOperator?: Maybe<Scalars['Boolean']>;
  lastKnownLocation?: Maybe<Coordinates>;
  lastKnownLocationDate?: Maybe<Scalars['DateTime']>;
  lastname: Scalars['String'];
  license?: Maybe<DriverLicense>;
  medical?: Maybe<DriverMedical>;
  middlename?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status: AssetStatus;
  tags?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Scalars['String']>;
};

export type DriverCreatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: DriverCreatedEventPayload;
};

export type DriverCreatedEventPayload = {
  driver: Driver;
};

export enum DriverDeductionMethod {
  FlatFee = 'FLAT_FEE'
}

export type DriverDeletedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: DriverDeletedEventPayload;
};

export type DriverDeletedEventPayload = {
  driver: Driver;
};

/** Driver document entity */
export type DriverDocument = {
  _id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type DriverDocumentInput = {
  _id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type DriverHos = {
  currentDrivingTime: Scalars['Float'];
  currentOnDutyTime: Scalars['Float'];
  currentStatus: DriverHosStatus;
  statusTime: Scalars['DateTime'];
  totalDrivingTime: Scalars['Float'];
  totalOnDutyTime: Scalars['Float'];
};

export type DriverHosInput = {
  currentDrivingTime: Scalars['Float'];
  currentOnDutyTime: Scalars['Float'];
  currentStatus: DriverHosStatus;
  statusTime: Scalars['DateTime'];
  totalDrivingTime: Scalars['Float'];
  totalOnDutyTime: Scalars['Float'];
};

export enum DriverHosStatus {
  Driving = 'DRIVING',
  OffDuty = 'OFF_DUTY',
  OnDuty = 'ON_DUTY',
  Sleeping = 'SLEEPING'
}

export type DriverLicense = {
  address?: Maybe<TextualAddress>;
  classification?: Maybe<DriverLicenseClassification>;
  endorsements?: Maybe<Array<DriverLicenseEndorsement>>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  issuedDate?: Maybe<Scalars['DateTime']>;
  issuedState?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  restriction?: Maybe<DriverLicenseRestriction>;
};

export enum DriverLicenseClassification {
  ClassA = 'CLASS_A',
  ClassB = 'CLASS_B',
  ClassC = 'CLASS_C'
}

export enum DriverLicenseEndorsement {
  Combination = 'COMBINATION',
  ComboTankHazardous = 'COMBO_TANK_HAZARDOUS',
  HazardousMaterial = 'HAZARDOUS_MATERIAL',
  PassengerVehicle = 'PASSENGER_VEHICLE',
  SchoolBus = 'SCHOOL_BUS',
  TankTruck = 'TANK_TRUCK',
  TowTruck = 'TOW_TRUCK'
}

export type DriverLicenseInput = {
  address?: InputMaybe<TextualAddressInput>;
  classification?: InputMaybe<DriverLicenseClassification>;
  endorsements?: InputMaybe<Array<DriverLicenseEndorsement>>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  issuedState?: InputMaybe<Scalars['String']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  restriction?: InputMaybe<DriverLicenseRestriction>;
};

export enum DriverLicenseRestriction {
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  T = 'T',
  Z = 'Z'
}

export type DriverMedical = {
  expiryDate?: Maybe<Scalars['DateTime']>;
  issuedDate?: Maybe<Scalars['DateTime']>;
  number?: Maybe<Scalars['String']>;
  restriction?: Maybe<Scalars['String']>;
};

export type DriverMedicalInput = {
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  number?: InputMaybe<Scalars['String']>;
  restriction?: InputMaybe<Scalars['String']>;
};

export type DriverPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Driver>;
};

export enum DriverPaymentMethod {
  PerHour = 'PER_HOUR',
  PerKm = 'PER_KM',
  PerMile = 'PER_MILE',
  RevenueShare = 'REVENUE_SHARE'
}

export type DriverPositionUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: DriverPositionUpdatedEventPayload;
};

export type DriverPositionUpdatedEventPayload = {
  driverPosition: TripDriverPosition;
};

/** A driver settlement */
export type DriverSettlement = {
  _id: Scalars['String'];
  deductions: Array<Deduction>;
  driver?: Maybe<Driver>;
  driverSettlementNumber: Scalars['String'];
  endDate: Scalars['DateTime'];
  payments: Array<TripPayment>;
  pdfDocument: DriverSettlementPdf;
  startDate: Scalars['DateTime'];
  status: DriverSettlementStatus;
  trips?: Maybe<Array<Trip>>;
};

export type DriverSettlementCreatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: DriverSettlementCreatedEventPayload;
};

export type DriverSettlementCreatedEventPayload = {
  driverSettlement: DriverSettlement;
};

export type DriverSettlementDeletedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: DriverSettlementDeletedEventPayload;
};

export type DriverSettlementDeletedEventPayload = {
  driverSettlementId: Scalars['String'];
  driverSettlementNumber: Scalars['String'];
};

export type DriverSettlementPaginatedResult = {
  count: Scalars['Int'];
  data: Array<DriverSettlement>;
};

/** A driver settlement pdf file */
export type DriverSettlementPdf = {
  error?: Maybe<Scalars['String']>;
  isGenerating: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export enum DriverSettlementStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Generated = 'GENERATED',
  NotSettled = 'NOT_SETTLED',
  OnHold = 'ON_HOLD',
  Paid = 'PAID',
  Sent = 'SENT'
}

export type DriverSettlementUpdateInput = {
  deductions?: InputMaybe<Array<DeductionInput>>;
  payments?: InputMaybe<Array<TripPaymentInput>>;
};

export type DriverShift = {
  _id: Scalars['String'];
  days: Array<Scalars['Int']>;
  domicile?: Maybe<BusinessEntity>;
  domicileId?: Maybe<Scalars['ObjectId']>;
  driverIds?: Maybe<Array<Scalars['ObjectId']>>;
  endTime: Time;
  /** Ad hoc driver shifts are one time shifts that have been assigned directly from the planning tool */
  isAdhoc?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  startTime: Time;
};

export type DriverShiftAssignment = {
  _id: Scalars['String'];
  driver?: Maybe<Driver>;
  driverId: Scalars['ObjectId'];
  driverShift?: Maybe<DriverShift>;
  driverShiftId: Scalars['ObjectId'];
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type DriverShiftAssignmentPaginatedResult = {
  count: Scalars['Int'];
  data: Array<DriverShiftAssignment>;
};

export type DriverShiftAssignmentUpdateInput = {
  driverId?: InputMaybe<Scalars['ObjectId']>;
  driverShiftId?: InputMaybe<Scalars['ObjectId']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type DriverShiftDeletedEvent = {
  name: Events;
  payload: DriverShiftDeletedEventPayload;
};

export type DriverShiftDeletedEventPayload = {
  driverShiftId: Scalars['ObjectId'];
};

export type DriverShiftPaginatedResult = {
  count: Scalars['Int'];
  data: Array<DriverShift>;
};

export type DriverShiftUpdateInput = {
  days?: InputMaybe<Array<Scalars['Int']>>;
  domicileId?: InputMaybe<Scalars['ObjectId']>;
  driverIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  endTime?: InputMaybe<TimeInput>;
  /** Ad hoc driver shifts are one time shifts that have been assigned directly from the planning tool */
  isAdhoc?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<TimeInput>;
};

export type DriverStatusChangedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: DriverStatusChangedEventPayload;
};

export type DriverStatusChangedEventPayload = {
  driverId: Scalars['String'];
  newStatus: Scalars['String'];
  oldStatus: Scalars['String'];
  organizationId: Scalars['String'];
};

export type DriverUpdateInput = {
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  dateOfPhysicalExamination?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<Array<DriverDocumentInput>>;
  /** Where the driver starts his journey everyday */
  domicile?: InputMaybe<NewAddressInput>;
  domicileId?: InputMaybe<Scalars['ObjectId']>;
  eldId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  hos?: InputMaybe<DriverHosInput>;
  isOwnerOperator?: InputMaybe<Scalars['Boolean']>;
  lastname?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<DriverLicenseInput>;
  medical?: InputMaybe<DriverMedicalInput>;
  middlename?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssetStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type DriverUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: DriverUpdatedEventPayload;
};

export type DriverUpdatedEventPayload = {
  driver: Driver;
  previousDriver: Driver;
};

export type DriverWhere = {
  domicile?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssetStatus>;
};

export type DwellTimeUptick = {
  _id: Scalars['String'];
  _organization: Scalars['String'];
  addedTimeInMinutes: Scalars['Float'];
  businessEntity?: Maybe<BusinessEntity>;
  businessEntityId: Scalars['ObjectId'];
  endDate: Scalars['DateTime'];
  groupIds?: Maybe<Array<Scalars['String']>>;
  startDate: Scalars['DateTime'];
};

export type DwellTimeUptickPaginatedResult = {
  count: Scalars['Int'];
  data: Array<DwellTimeUptick>;
};

export type EditShipmentDocumentInput = {
  _id?: InputMaybe<Scalars['String']>;
  accessLevel: Array<NoteAccessLevel>;
  associatedCharge?: InputMaybe<Scalars['String']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
  isForRatecons?: InputMaybe<Scalars['Boolean']>;
  isForReceivers?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  receiver?: InputMaybe<Scalars['String']>;
  shipment?: InputMaybe<Scalars['String']>;
  shipper?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  url: Scalars['String'];
};

export type EditShipmentNoteInput = {
  _id?: InputMaybe<Scalars['String']>;
  accessLevel: Array<NoteAccessLevel>;
  content: Scalars['String'];
  receiver?: InputMaybe<Scalars['String']>;
  shipment?: InputMaybe<Scalars['String']>;
  shipper?: InputMaybe<Scalars['String']>;
};

/** Live ETA status for trip-level planning display */
export enum EtaStatus {
  AtRisk = 'AT_RISK',
  Delayed = 'DELAYED',
  OnTime = 'ON_TIME',
  TooEarly = 'TOO_EARLY'
}

export enum Events {
  DriverCreated = 'DRIVER_CREATED',
  DriverDeleted = 'DRIVER_DELETED',
  DriverPositionUpdated = 'DRIVER_POSITION_UPDATED',
  DriverSettlementCreated = 'DRIVER_SETTLEMENT_CREATED',
  DriverSettlementDeleted = 'DRIVER_SETTLEMENT_DELETED',
  DriverShiftDeleted = 'DRIVER_SHIFT_DELETED',
  DriverStatusChanged = 'DRIVER_STATUS_CHANGED',
  DriverUpdated = 'DRIVER_UPDATED',
  ExpenseCreated = 'EXPENSE_CREATED',
  ExpenseDeleted = 'EXPENSE_DELETED',
  ForecastingLocationAdded = 'FORECASTING_LOCATION_ADDED',
  ForecastingLocationRemoved = 'FORECASTING_LOCATION_REMOVED',
  InvoiceCreated = 'INVOICE_CREATED',
  InvoiceDeleted = 'INVOICE_DELETED',
  InvoiceUpdated = 'INVOICE_UPDATED',
  OrganizationSettingsUpdated = 'ORGANIZATION_SETTINGS_UPDATED',
  OrgUserCreated = 'ORG_USER_CREATED',
  OrgUserDeleted = 'ORG_USER_DELETED',
  OrgUserRolesUpdated = 'ORG_USER_ROLES_UPDATED',
  ShipmentAssigned = 'SHIPMENT_ASSIGNED',
  ShipmentCancelled = 'SHIPMENT_CANCELLED',
  ShipmentCompleted = 'SHIPMENT_COMPLETED',
  ShipmentCreated = 'SHIPMENT_CREATED',
  ShipmentDeleted = 'SHIPMENT_DELETED',
  ShipmentEventAdded = 'SHIPMENT_EVENT_ADDED',
  ShipmentEventDeleted = 'SHIPMENT_EVENT_DELETED',
  ShipmentEventUpdated = 'SHIPMENT_EVENT_UPDATED',
  ShipmentGoodPinCodeUpdated = 'SHIPMENT_GOOD_PIN_CODE_UPDATED',
  ShipmentGoodWeightUpdated = 'SHIPMENT_GOOD_WEIGHT_UPDATED',
  ShipmentRestored = 'SHIPMENT_RESTORED',
  ShipmentSplit = 'SHIPMENT_SPLIT',
  ShipmentUpdated = 'SHIPMENT_UPDATED',
  TractorPositionUpdated = 'TRACTOR_POSITION_UPDATED',
  TrailerPositionUpdated = 'TRAILER_POSITION_UPDATED',
  TripCompleted = 'TRIP_COMPLETED',
  TripCreated = 'TRIP_CREATED',
  TripDistancesCalculated = 'TRIP_DISTANCES_CALCULATED',
  TripFullyAssigned = 'TRIP_FULLY_ASSIGNED',
  TripLiveEtaUpdated = 'TRIP_LIVE_ETA_UPDATED',
  TripUpdated = 'TRIP_UPDATED',
  UserStatusUpdated = 'USER_STATUS_UPDATED'
}

export type Exception = {
  data: Scalars['JSON'];
  message: Scalars['String'];
  name: ExceptionType;
  type: ExceptionType;
};

export enum ExceptionType {
  ConstraintValidation = 'CONSTRAINT_VALIDATION'
}

export enum ExecutionStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type ExpenseCreatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ExpenseCreatedEventPayload;
};

export type ExpenseCreatedEventPayload = {
  expense: Transaction;
};

export type ExpenseDeletedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ExpenseDeletedEventPayload;
};

export type ExpenseDeletedEventPayload = {
  expenseId: Scalars['String'];
  expenseNumber: Scalars['String'];
};

/** Extension */
export type Extension = {
  _id: Scalars['String'];
  category: Scalars['String'];
  configurationDefinitions: Array<ExtensionConfigurationDefinition>;
  coverImage?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  name: Scalars['String'];
  /** Required subscription feature for this extension to be available */
  requiredFeatureId?: Maybe<Scalars['String']>;
  settings: ExtensionSettings;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** Extension action */
export type ExtensionAction = {
  text: Scalars['String'];
  type: ExtensionActionType;
  url: Scalars['String'];
};

export enum ExtensionActionType {
  Url = 'URL'
}

/** Extension configuration definition */
export type ExtensionConfigurationDefinition = {
  defaultValue?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
  type: Scalars['String'];
};

/** Extension configuration value */
export type ExtensionConfigurationValue = {
  name: Scalars['String'];
  value: Scalars['Mixed'];
};

/** Extension configuration value */
export type ExtensionConfigurationValueInput = {
  name: Scalars['String'];
  value: Scalars['Mixed'];
};

/** Extension event handler */
export type ExtensionEventHandler = {
  endpoint: Scalars['String'];
  event: Events;
};

/** Extension hook */
export type ExtensionHook = {
  endpoint: Scalars['String'];
  operation: ExtensionHookOperation;
};

export enum ExtensionHookOperation {
  GetInvoiceTemplate = 'GET_INVOICE_TEMPLATE',
  GetLoadBoardLoadDetails = 'GET_LOAD_BOARD_LOAD_DETAILS',
  GetRoutingDirections = 'GET_ROUTING_DIRECTIONS',
  GetRoutingDistanceMatrix = 'GET_ROUTING_DISTANCE_MATRIX',
  SearchLoadBoard = 'SEARCH_LOAD_BOARD',
  SendInvoice = 'SEND_INVOICE',
  SyncDrivingPeriods = 'SYNC_DRIVING_PERIODS'
}

export type ExtensionInstallWithRedirectUrl = {
  configurationValues: Array<ExtensionConfigurationValue>;
  extension: Extension;
  installedAt: Scalars['DateTime'];
  installedBy: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
};

/** Extension message */
export type ExtensionMessage = {
  actions?: Maybe<Array<ExtensionAction>>;
  context?: Maybe<ExtensionMessageContext>;
  extensionId: Scalars['String'];
  extensionName: Scalars['String'];
  text: Scalars['String'];
  type: ExtensionMessageType;
};

export enum ExtensionMessageContext {
  OrdersList = 'ORDERS_LIST',
  PlanningTool = 'PLANNING_TOOL'
}

export enum ExtensionMessageType {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

/** Extension operation */
export type ExtensionOperation = {
  context: ExtensionOperationContext;
  description: Scalars['String'];
  endpoint: Scalars['String'];
  filter?: Maybe<Scalars['JSON']>;
  icon: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export enum ExtensionOperationContext {
  BusinessEntity = 'BUSINESS_ENTITY',
  BusinessLocation = 'BUSINESS_LOCATION',
  Invoice = 'INVOICE',
  /** @deprecated Use INVOICE instead */
  InvoiceDetails = 'INVOICE_DETAILS',
  Trip = 'TRIP'
}

export type ExtensionOperationResponse = {
  message?: Maybe<Scalars['String']>;
  openNewWindow?: Maybe<Scalars['Boolean']>;
  redirect?: Maybe<Scalars['String']>;
};

export type ExtensionOperationWithExtensionId = {
  context: ExtensionOperationContext;
  description: Scalars['String'];
  endpoint: Scalars['String'];
  extensionId: Scalars['String'];
  filter?: Maybe<Scalars['JSON']>;
  icon: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type ExtensionPaginatedResult = {
  count: Scalars['Int'];
  data: Array<ExtensionWithStatus>;
};

/** Extension settings */
export type ExtensionSettings = {
  authEndpoint: Scalars['String'];
  configureEndpoint?: Maybe<Scalars['String']>;
  customFields: Array<CustomFieldDefinition>;
  eventHandlers: Array<ExtensionEventHandler>;
  hooks: Array<ExtensionHook>;
  installEndpoint: Scalars['String'];
  messagesEndpoint?: Maybe<Scalars['String']>;
  operations: Array<ExtensionOperation>;
  rootUrl: Scalars['String'];
  uiComponents?: Maybe<Array<ExtensionUiComponent>>;
  uninstallEndpoint: Scalars['String'];
  widgets: Array<ExtensionWidget>;
};

/** Extension UI component */
export type ExtensionUiComponent = {
  endpoint: Scalars['String'];
  type: Scalars['String'];
};

export enum ExtensionUiComponentType {
  Map = 'MAP',
  MapMarker = 'MAP_MARKER',
  MapPopup = 'MAP_POPUP'
}

export type ExtensionUiComponentWithExtensionInfo = {
  endpoint: Scalars['String'];
  extensionId: Scalars['String'];
  rootUrl: Scalars['String'];
  type: Scalars['String'];
};

/** Extension widget */
export type ExtensionWidget = {
  context: ExtensionWidgetContext;
  endpoint: Scalars['String'];
  label: Scalars['String'];
};

export enum ExtensionWidgetContext {
  PlanningToolHeader = 'PLANNING_TOOL_HEADER'
}

export type ExtensionWidgetWithExtensionInfo = {
  context: ExtensionWidgetContext;
  endpoint: Scalars['String'];
  extensionId: Scalars['String'];
  label: Scalars['String'];
  rootUrl: Scalars['String'];
};

export type ExtensionWithStatus = {
  extension: Extension;
  installed: Scalars['Boolean'];
};

export type Extras = {
  tripId: Scalars['String'];
};

export type FailedConstraint = {
  constraintType: ShipmentConstraintType;
  constraintValue: Scalars['String'];
  shipmentNumber: Scalars['String'];
  trailerCapacityValue?: Maybe<Scalars['Float']>;
};

export type FeelsLike = {
  day?: Maybe<Scalars['Float']>;
  eve?: Maybe<Scalars['Float']>;
  morn?: Maybe<Scalars['Float']>;
  night?: Maybe<Scalars['Float']>;
};

export type ForecastResult = {
  shipments: Array<ForecastedShipment>;
};

export type ForecastedShipment = {
  _id: Scalars['String'];
  /** Additional trailer types that can be used for the shipment */
  additionalTrailerTypes?: Maybe<Array<TrailerType>>;
  /**
   * DEPRECATED: Charges associated with the shipment. Charges are now stored on invoices and resolved via GraphQL. This field is no longer updated and exists only for backward compatibility.
   * @deprecated Charges are now stored on invoices. Use the charges field resolved from the invoice instead. This field is maintained for backward compatibility only and will be removed in a future version.
   */
  charges: Array<ShipmentCharge>;
  /** Type of commodity being shipped. This affects what trailer types can be used */
  commodityType?: Maybe<ShipmentCommodityType>;
  /** Constraints that must be satisfied for the shipment */
  constraints?: Maybe<Array<ShipmentConstraint>>;
  /** ID of the user who created the shipment */
  createdBy: Scalars['String'];
  /** ID of the customer for whom the shipment is created */
  customer: BusinessEntity;
  /** Full truck load or less than truck load shipment type. Full truck load shipments can't be mixed with other shipments on the same trip */
  loadType: LoadType;
  /** Route information for the shipment */
  route?: Maybe<ShipmentRoute>;
  /** Locations that need to be visited for the shipment */
  shipmentLocations: Array<ShipmentLocation>;
  /** Auto incremented number for the shipment */
  shipmentNumber: Scalars['String'];
  /** Current status of the shipment */
  status: Status;
  /** Type of trailer required for the shipment */
  trailerType: TrailerType;
};

export type ForecastingExecutionLog = {
  _id: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  lockedOrdersCount?: Maybe<Scalars['Float']>;
  ordersGenerated?: Maybe<Scalars['Float']>;
  receiverForecastId: Scalars['ObjectId'];
  startedAt: Scalars['DateTime'];
  status: ExecutionStatus;
};

export type ForecastingExecutionLogPaginatedResult = {
  count: Scalars['Int'];
  data: Array<ForecastingExecutionLog>;
};

export type ForecastingLocationAddedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ForecastingLocationAddedEventPayload;
};

export type ForecastingLocationAddedEventPayload = {
  organizationId: Scalars['String'];
  receiverId: Scalars['String'];
};

export type ForecastingLocationRemovedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ForecastingLocationRemovedEventPayload;
};

export type ForecastingLocationRemovedEventPayload = {
  organizationId: Scalars['String'];
  receiverId: Scalars['String'];
};

export type ForecastingModel = {
  _id: Scalars['String'];
  contaminates?: Maybe<Scalars['Boolean']>;
  isExclusive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  maxCapacity?: Maybe<Scalars['Float']>;
  minCapacity?: Maybe<Scalars['Float']>;
  slots?: Maybe<Array<ForecastingModelSlot>>;
  storageFacilityId: Scalars['String'];
  target?: Maybe<Scalars['Float']>;
  threshold?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ForecastingModelInput = {
  _id: Scalars['String'];
  contaminates?: InputMaybe<Scalars['Boolean']>;
  isExclusive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  maxCapacity?: InputMaybe<Scalars['Float']>;
  minCapacity?: InputMaybe<Scalars['Float']>;
  slots?: InputMaybe<Array<ForecastingModelSlotInput>>;
  storageFacilityId: Scalars['String'];
  target?: InputMaybe<Scalars['Float']>;
  threshold?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ForecastingModelSlot = {
  daily?: Maybe<DailyForecastingModelSlot>;
  hourly?: Maybe<HourlyForecastingModelSlot>;
  monthly?: Maybe<MonthlyForecastingModelSlot>;
  salesAmount: Scalars['Float'];
  type: ForecastingModelSlotType;
};

export type ForecastingModelSlotInput = {
  daily?: InputMaybe<DailyForecastingModelSlotInput>;
  hourly?: InputMaybe<HourlyForecastingModelSlotInput>;
  monthly?: InputMaybe<MonthlyForecastingModelSlotInput>;
  salesAmount: Scalars['Float'];
  type: ForecastingModelSlotType;
};

export enum ForecastingModelSlotType {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type ForecastingNotification = {
  level: ForecastingNotificationLevel;
  message: Scalars['String'];
  receiverForecastId: Scalars['ObjectId'];
  receiverId: Scalars['ObjectId'];
  storageFacilityId: Scalars['String'];
};

export enum ForecastingNotificationLevel {
  Critical = 'CRITICAL',
  Danger = 'DANGER',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type ForecastingPayload = {
  endDate: Scalars['DateTime'];
  receiverForecastId: Scalars['ObjectId'];
  startDate: Scalars['DateTime'];
  upticks?: InputMaybe<Array<ForecastingUptickInput>>;
};

export type ForecastingUptickInput = {
  multiplier: Scalars['Float'];
  storageFacilityId: Scalars['String'];
};

export enum Frequency {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Minutely = 'MINUTELY',
  Monthly = 'MONTHLY',
  Secondly = 'SECONDLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum FuelCostBasis {
  FirstPickup = 'FIRST_PICKUP',
  LastDropoff = 'LAST_DROPOFF'
}

export enum FuelCostEffectiveDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum FuelCostPeriod {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type GeneralSettings = {
  currency?: Maybe<Currency>;
  driversCanSeeFutureTrips?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Language>;
  measurementSystem?: Maybe<MeasurementSystem>;
  singleClickTripCompletion?: Maybe<Scalars['Boolean']>;
  useSimpleWorkflow?: Maybe<Scalars['Boolean']>;
  weekStartsOn?: Maybe<Scalars['Float']>;
};

export type GeneralSettingsInput = {
  currency?: InputMaybe<Currency>;
  driversCanSeeFutureTrips?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Language>;
  measurementSystem?: InputMaybe<MeasurementSystem>;
  singleClickTripCompletion?: InputMaybe<Scalars['Boolean']>;
  useSimpleWorkflow?: InputMaybe<Scalars['Boolean']>;
  weekStartsOn?: InputMaybe<Scalars['Float']>;
};

export type GenerateTripInput = {
  additionalTrailers?: InputMaybe<Array<Scalars['ObjectId']>>;
  carrier?: InputMaybe<Scalars['String']>;
  chassis?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  driver?: InputMaybe<Scalars['String']>;
  etaFromPreviousTrip?: InputMaybe<Scalars['Float']>;
  etaToNextTrip?: InputMaybe<Scalars['Float']>;
  shipments: Array<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  tractor?: InputMaybe<Scalars['String']>;
  trailer?: InputMaybe<Scalars['String']>;
  trailerCompartmentAssignments?: InputMaybe<Array<TrailerCompartmentAssignmentInput>>;
  violations?: InputMaybe<Array<TripViolationInput>>;
};

export type Good = {
  _id: Scalars['String'];
  alternativePinCodes?: Maybe<Array<Scalars['String']>>;
  goodProfileId?: Maybe<Scalars['ObjectId']>;
  label: Scalars['String'];
  /** The gross quantity that was loaded by the driver */
  loadedQuantity?: Maybe<Scalars['Float']>;
  /** The net (temperature-corrected) quantity that was loaded by the driver. Only captured when the "Net and Gross Gallons" dispatching setting is enabled. */
  netLoadedQuantity?: Maybe<Scalars['Float']>;
  pallet?: Maybe<Scalars['Float']>;
  pieces?: Maybe<Scalars['Float']>;
  pinCode?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  supplier?: Maybe<BusinessEntity>;
  supplierId?: Maybe<Scalars['ObjectId']>;
  unit?: Maybe<GoodUnits>;
  unitPrice?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type GoodDistribution = {
  alternativePinCodes?: Maybe<Array<Scalars['String']>>;
  /** The gross quantity that was actually delivered to the customer */
  deliveredQuantity?: Maybe<Scalars['Float']>;
  goodId: Scalars['String'];
  goodProfile?: Maybe<GoodProfile>;
  goodProfileId?: Maybe<Scalars['ObjectId']>;
  inchesAfter?: Maybe<Scalars['Float']>;
  inchesBefore?: Maybe<Scalars['Float']>;
  /** The net (temperature-corrected) quantity that was actually delivered to the customer. Only captured when the "Net and Gross Gallons" dispatching setting is enabled. */
  netDeliveredQuantity?: Maybe<Scalars['Float']>;
  pinCode?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  shipperId?: Maybe<Scalars['ObjectId']>;
  storageFacilityId?: Maybe<Scalars['String']>;
  supplier?: Maybe<BusinessEntity>;
  supplierId?: Maybe<Scalars['ObjectId']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type GoodDistributionInput = {
  alternativePinCodes?: InputMaybe<Array<Scalars['String']>>;
  /** The gross quantity that was actually delivered to the customer */
  deliveredQuantity?: InputMaybe<Scalars['Float']>;
  goodId: Scalars['String'];
  goodProfileId?: InputMaybe<Scalars['ObjectId']>;
  inchesAfter?: InputMaybe<Scalars['Float']>;
  inchesBefore?: InputMaybe<Scalars['Float']>;
  /** The net (temperature-corrected) quantity that was actually delivered to the customer */
  netDeliveredQuantity?: InputMaybe<Scalars['Float']>;
  pinCode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  shipperId?: InputMaybe<Scalars['ObjectId']>;
  storageFacilityId?: InputMaybe<Scalars['String']>;
  supplierId?: InputMaybe<Scalars['ObjectId']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
};

export type GoodInput = {
  _id: Scalars['String'];
  alternativePinCodes?: InputMaybe<Array<Scalars['String']>>;
  goodProfileId?: InputMaybe<Scalars['ObjectId']>;
  label: Scalars['String'];
  /** The gross quantity that was loaded by the driver */
  loadedQuantity?: InputMaybe<Scalars['Float']>;
  /** The net (temperature-corrected) quantity that was loaded by the driver */
  netLoadedQuantity?: InputMaybe<Scalars['Float']>;
  pallet?: InputMaybe<Scalars['Float']>;
  pieces?: InputMaybe<Scalars['Float']>;
  pinCode?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  supplierId?: InputMaybe<Scalars['ObjectId']>;
  unit?: InputMaybe<GoodUnits>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
};

/** Good inventory item */
export type GoodInventoryItem = {
  _id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
};

export type GoodInventoryItemInput = {
  _id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  weight?: InputMaybe<Scalars['Float']>;
};

export type GoodProfile = {
  _id: Scalars['String'];
  status?: Maybe<AssetStatus>;
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<CustomField>>;
  documents?: Maybe<Array<Document>>;
  equivalences?: Maybe<Array<GoodProfileEquivalence>>;
  /** ID of the commodity profile in an external system. */
  externalId?: Maybe<Scalars['String']>;
  goodProfileClass?: Maybe<GoodProfileClass>;
  goodProfileClassId?: Maybe<Scalars['ObjectId']>;
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  label: Scalars['String'];
  liquidGravity?: Maybe<Scalars['Float']>;
  productType?: Maybe<GoodProfileProductType>;
  restrictions?: Maybe<Array<GoodProfileRestriction>>;
  shipperIds?: Maybe<Array<Scalars['ObjectId']>>;
  supplierIds?: Maybe<Array<Scalars['ObjectId']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  unit: GoodUnits;
  weight: Scalars['Float'];
};

export type GoodProfileClass = {
  _id: Scalars['ObjectId'];
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type GoodProfileClassPaginatedResult = {
  count: Scalars['Int'];
  data: Array<GoodProfileClass>;
};

export type GoodProfileClassUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type GoodProfileEquivalence = {
  conditions: Array<GoodProfileEquivalenceCondition>;
  equivalentGoodId: Scalars['ObjectId'];
};

export type GoodProfileEquivalenceCondition = {
  operator: GoodProfileEquivalenceConditionOperator;
  target: GoodProfileEquivalenceConditionTarget;
  value?: Maybe<Scalars['ConditionValue']>;
};

export type GoodProfileEquivalenceConditionInput = {
  operator: GoodProfileEquivalenceConditionOperator;
  target: GoodProfileEquivalenceConditionTarget;
  value?: InputMaybe<Scalars['ConditionValue']>;
};

export enum GoodProfileEquivalenceConditionOperator {
  Equals = 'EQUALS',
  IsBetween = 'IS_BETWEEN',
  IsGreaterThanOrEqual = 'IS_GREATER_THAN_OR_EQUAL',
  IsLessThanOrEqual = 'IS_LESS_THAN_OR_EQUAL'
}

export enum GoodProfileEquivalenceConditionTarget {
  Date = 'DATE',
  Receiver = 'RECEIVER',
  Shipper = 'SHIPPER',
  Time = 'TIME'
}

export type GoodProfileEquivalenceInput = {
  conditions: Array<GoodProfileEquivalenceConditionInput>;
  equivalentGoodId: Scalars['ObjectId'];
};

export type GoodProfilePaginatedResult = {
  count: Scalars['Int'];
  data: Array<GoodProfile>;
};

/** Whether a commodity is a heavy or light product */
export enum GoodProfileProductType {
  Heavy = 'HEAVY',
  Light = 'LIGHT'
}

export type GoodProfileRestriction = {
  type: GoodProfileRestrictionType;
  value?: Maybe<Scalars['ConditionValue']>;
};

export type GoodProfileRestrictionInput = {
  type: GoodProfileRestrictionType;
  value?: InputMaybe<Scalars['ConditionValue']>;
};

export enum GoodProfileRestrictionType {
  DriverEndorsement = 'DRIVER_ENDORSEMENT',
  ExclusiveDelivery = 'EXCLUSIVE_DELIVERY',
  TrailerWash = 'TRAILER_WASH'
}

export type GoodProfileUpdateInput = {
  status?: InputMaybe<AssetStatus>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  equivalences?: InputMaybe<Array<GoodProfileEquivalenceInput>>;
  /** ID of the commodity profile in an external system. */
  externalId?: InputMaybe<Scalars['String']>;
  goodProfileClassId?: InputMaybe<Scalars['ObjectId']>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  label?: InputMaybe<Scalars['String']>;
  liquidGravity?: InputMaybe<Scalars['Float']>;
  productType?: InputMaybe<GoodProfileProductType>;
  restrictions?: InputMaybe<Array<GoodProfileRestrictionInput>>;
  shipperIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  supplierIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  unit?: InputMaybe<GoodUnits>;
  weight?: InputMaybe<Scalars['Float']>;
};

/** The units of measure for a good */
export enum GoodUnits {
  Gallons = 'GALLONS',
  Item = 'ITEM',
  Kilograms = 'KILOGRAMS',
  Liters = 'LITERS',
  Pounds = 'POUNDS'
}

/** Group */
export type Group = {
  _id: Scalars['String'];
  /** When true, this group is auto-applied to shipments for receivers that belong to this group */
  defaultFromReceiverForOrders?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  memberIds: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type GroupPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Group>;
};

export type GroupUpdateInput = {
  /** When true, this group is auto-applied to shipments for receivers that belong to this group */
  defaultFromReceiverForOrders?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  memberIds?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type HourlyForecastingModelSlot = {
  dayOfWeek: Scalars['Float'];
  endTime: Time;
  startTime: Time;
};

export type HourlyForecastingModelSlotInput = {
  dayOfWeek: Scalars['Float'];
  endTime: TimeInput;
  startTime: TimeInput;
};

/** An invoice */
export type Invoice = {
  _id: Scalars['String'];
  charges: Array<ShipmentCharge>;
  closingNote?: Maybe<Scalars['String']>;
  /** Custom fields for the invoice */
  customFields?: Maybe<Array<CustomField>>;
  customer?: Maybe<BusinessEntity>;
  /** Set when a user separated the invoice, so auto consolidation leaves it alone */
  excludedFromAutoConsolidation?: Maybe<Scalars['Boolean']>;
  /** IDs of the groups the invoice is associated with */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** The date the invoice was created (order completion date). Once set, it is not recalculated. */
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceNumber: Scalars['String'];
  missingRequiredDocuments?: Maybe<Array<DocumentRequirement>>;
  paidAmount?: Maybe<Scalars['Float']>;
  payments?: Maybe<Array<InvoicePayment>>;
  pdfDocument: InvoicePdf;
  shipment?: Maybe<Shipment>;
  shipmentIds?: Maybe<Array<Scalars['ObjectId']>>;
  shipments?: Maybe<Array<Shipment>>;
  status: InvoiceStatus;
  taxRate?: Maybe<Scalars['Float']>;
};

export type InvoiceBatchResult = {
  invoicesUpdated: Array<Invoice>;
  textError: Scalars['String'];
  textWarning: Scalars['String'];
};

export type InvoiceBulkUpdateInput = {
  charges?: InputMaybe<Array<ShipmentChargeInput>>;
  closingNote?: InputMaybe<Scalars['String']>;
  /** Custom fields for the invoice */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** IDs of the groups the invoice is associated with */
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The date the invoice was created (order completion date). Once set, it is not recalculated. */
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  missingRequiredDocuments?: InputMaybe<Array<DocumentRequirementInput>>;
  paidAmount?: InputMaybe<Scalars['Float']>;
  payments?: InputMaybe<Array<InvoicePaymentInput>>;
  status?: InputMaybe<InvoiceStatus>;
  taxRate?: InputMaybe<Scalars['Float']>;
};

/** Criteria for invoice consolidation */
export enum InvoiceConsolidationCriteria {
  BolNumber = 'BOL_NUMBER',
  Day = 'DAY',
  Month = 'MONTH',
  PoNumber = 'PO_NUMBER',
  Trip = 'TRIP',
  Week = 'WEEK'
}

export type InvoiceCreatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: InvoiceCreatedEventPayload;
};

export type InvoiceCreatedEventPayload = {
  invoice: Invoice;
};

export type InvoiceDeletedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: InvoiceDeletedEventPayload;
};

export type InvoiceDeletedEventPayload = {
  invoiceId: Scalars['String'];
  invoiceNumber: Scalars['String'];
};

export type InvoicePaginatedResult = {
  count: Scalars['Int'];
  data: Array<Invoice>;
};

/** An invoice payment */
export type InvoicePayment = {
  _id: Scalars['ObjectId'];
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
};

export type InvoicePaymentInput = {
  _id: Scalars['ObjectId'];
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  note?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
};

/** An invoice pdf file */
export type InvoicePdf = {
  error?: Maybe<Scalars['String']>;
  isGenerating: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export enum InvoiceStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  NotInvoiced = 'NOT_INVOICED',
  OnHold = 'ON_HOLD',
  Paid = 'PAID',
  PendingCompletion = 'PENDING_COMPLETION',
  Sent = 'SENT',
  Transferred = 'TRANSFERRED'
}

export type InvoiceUpdateInput = {
  charges: Array<ShipmentChargeInput>;
  closingNote?: InputMaybe<Scalars['String']>;
  /** Custom fields for the invoice */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** IDs of the groups the invoice is associated with */
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The date the invoice was created (order completion date). Once set, it is not recalculated. */
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  missingRequiredDocuments?: InputMaybe<Array<DocumentRequirementInput>>;
  paidAmount?: InputMaybe<Scalars['Float']>;
  payments?: InputMaybe<Array<InvoicePaymentInput>>;
  status?: InputMaybe<InvoiceStatus>;
  taxRate?: InputMaybe<Scalars['Float']>;
};

export type InvoiceUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: InvoiceUpdatedEventPayload;
};

export type InvoiceUpdatedEventPayload = {
  changes?: Maybe<Invoice>;
  invoice: Invoice;
  previousInvoice: Invoice;
};

export enum InvoicingProcess {
  LoadBased = 'LOAD_BASED',
  QueueBased = 'QUEUE_BASED'
}

export type InvoicingSettings = {
  applyAllPrimaryRateTables?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use Organization.address instead */
  companyAddress?: Maybe<Scalars['String']>;
  /** @deprecated Use Organization.email instead */
  companyEmail?: Maybe<Scalars['String']>;
  /** @deprecated Use Organization.phoneNumber instead */
  companyPhone?: Maybe<Scalars['String']>;
  emailLogoUrl?: Maybe<Scalars['String']>;
  enableConsolidatedInvoicing?: Maybe<Scalars['Boolean']>;
  enableSingleNumberInvoicing?: Maybe<Scalars['Boolean']>;
  enableTaxRate?: Maybe<Scalars['Boolean']>;
  logoUrl?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  processes?: Maybe<Array<InvoicingProcess>>;
  receiverDocumentationBodyTemplate?: Maybe<Scalars['String']>;
  receiverDocumentationSubjectTemplate?: Maybe<Scalars['String']>;
  remitAddress?: Maybe<TextualAddress>;
  remitCompanyName?: Maybe<Scalars['String']>;
  remitEmail?: Maybe<Scalars['String']>;
  showLoadedDeliveredQuantities?: Maybe<Scalars['Boolean']>;
};

export type InvoicingSettingsInput = {
  applyAllPrimaryRateTables?: InputMaybe<Scalars['Boolean']>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyEmail?: InputMaybe<Scalars['String']>;
  companyPhone?: InputMaybe<Scalars['String']>;
  emailLogoUrl?: InputMaybe<Scalars['String']>;
  enableConsolidatedInvoicing?: InputMaybe<Scalars['Boolean']>;
  enableSingleNumberInvoicing?: InputMaybe<Scalars['Boolean']>;
  enableTaxRate?: InputMaybe<Scalars['Boolean']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<Array<InvoicingProcess>>;
  receiverDocumentationBodyTemplate?: InputMaybe<Scalars['String']>;
  receiverDocumentationSubjectTemplate?: InputMaybe<Scalars['String']>;
  remitAddress?: InputMaybe<TextualAddressInput>;
  remitCompanyName?: InputMaybe<Scalars['String']>;
  remitEmail?: InputMaybe<Scalars['String']>;
  showLoadedDeliveredQuantities?: InputMaybe<Scalars['Boolean']>;
};

export type KeycloakOrganizationAttributes = {
  chargebeeCustomerId?: Maybe<Scalars['String']>;
  dotNumber?: Maybe<Scalars['String']>;
};

export type KeycloakUserAttributes = {
  driverId?: Maybe<Array<Scalars['String']>>;
};

export type KeycloakUserAttributesInput = {
  driverId?: InputMaybe<Array<Scalars['String']>>;
};

export type KeycloakUserRole = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type KeycloakUserRoleInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum Language {
  En = 'EN',
  Fr = 'FR'
}

export type LoadBoardSearchCriteria = {
  destinationCity?: InputMaybe<Scalars['String']>;
  destinationCountry?: InputMaybe<Scalars['String']>;
  destinationLatitude?: InputMaybe<Scalars['Float']>;
  destinationLongitude?: InputMaybe<Scalars['Float']>;
  destinationRadius?: InputMaybe<Scalars['Float']>;
  destinationState?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  hoursOld?: InputMaybe<Scalars['Float']>;
  loadType?: InputMaybe<LoadType>;
  originCity?: InputMaybe<Scalars['String']>;
  originCountry?: InputMaybe<Scalars['String']>;
  originLatitude?: InputMaybe<Scalars['Float']>;
  originLongitude?: InputMaybe<Scalars['Float']>;
  originRadius?: InputMaybe<Scalars['Float']>;
  originState?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  trailerType?: InputMaybe<TrailerType>;
};

export type LoadBoardSearchResult = {
  _id: Scalars['String'];
  /** Additional trailer types that can be used for the shipment */
  additionalTrailerTypes?: Maybe<Array<TrailerType>>;
  /**
   * DEPRECATED: Charges associated with the shipment. Charges are now stored on invoices and resolved via GraphQL. This field is no longer updated and exists only for backward compatibility.
   * @deprecated Charges are now stored on invoices. Use the charges field resolved from the invoice instead. This field is maintained for backward compatibility only and will be removed in a future version.
   */
  charges: Array<ShipmentCharge>;
  /** Constraints that must be satisfied for the shipment */
  constraints?: Maybe<Array<ShipmentConstraint>>;
  /** ID of the customer for whom the shipment is created */
  customer: BusinessEntity;
  /** Full truck load or less than truck load shipment type. Full truck load shipments can't be mixed with other shipments on the same trip */
  loadType: LoadType;
  /** Locations that need to be visited for the shipment */
  shipmentLocations: Array<ShipmentLocation>;
  /** Type of trailer required for the shipment */
  trailerType: TrailerType;
};

export type LoadBoardSearchResultPaginatedResult = {
  count: Scalars['Int'];
  data: Array<LoadBoardSearchResult>;
};

/** Load state of a given trip */
export type LoadState = {
  distance: Scalars['Float'];
  endPosition?: Maybe<TripDriverPosition>;
  event?: Maybe<ShipmentEvent>;
  goods: Array<Good>;
  startDate: Scalars['DateTime'];
  startPosition?: Maybe<TripDriverPosition>;
};

export enum LoadType {
  FullTruckLoad = 'FULL_TRUCK_LOAD',
  LessThanTruckLoad = 'LESS_THAN_TRUCK_LOAD'
}

export type LocationTraffic = {
  arrivalLocationTime?: Maybe<Scalars['DateTime']>;
  baseDuration?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  lastUpdate: Scalars['DateTime'];
  length?: Maybe<Scalars['Float']>;
  typicalDuration?: Maybe<Scalars['Float']>;
};

export type LocationWeather = {
  clouds?: Maybe<Scalars['Float']>;
  dew_point?: Maybe<Scalars['Float']>;
  dt?: Maybe<Scalars['Float']>;
  feels_like?: Maybe<FeelsLike>;
  humidity?: Maybe<Scalars['Float']>;
  lastUpdate: Scalars['DateTime'];
  moon_phase?: Maybe<Scalars['Float']>;
  moonrise?: Maybe<Scalars['Float']>;
  moonset?: Maybe<Scalars['Float']>;
  pop?: Maybe<Scalars['Float']>;
  pressure?: Maybe<Scalars['Float']>;
  rain?: Maybe<Scalars['Float']>;
  snow?: Maybe<Scalars['Float']>;
  sunrise?: Maybe<Scalars['Float']>;
  sunset?: Maybe<Scalars['Float']>;
  temp?: Maybe<Temp>;
  timezone: Scalars['String'];
  timezone_offset: Scalars['Float'];
  uvi?: Maybe<Scalars['Float']>;
  weather?: Maybe<Array<WeatherInfo>>;
  wind_deg?: Maybe<Scalars['Float']>;
  wind_gust?: Maybe<Scalars['Float']>;
  wind_speed?: Maybe<Scalars['Float']>;
};

export type MaintenanceTask = {
  _id: Scalars['String'];
  assetId: Scalars['ObjectId'];
  assetType: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  label: Scalars['String'];
  recurrence?: Maybe<MaintenanceTaskRecurrence>;
  required?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startMileage?: Maybe<Scalars['Float']>;
  status?: Maybe<MaintenanceTaskStatus>;
};

export type MaintenanceTaskPaginatedResult = {
  count: Scalars['Int'];
  data: Array<MaintenanceTask>;
};

export type MaintenanceTaskRecurrence = {
  frequency: MaintenanceTaskRecurrenceFrequency;
  interval: Scalars['Float'];
};

export enum MaintenanceTaskRecurrenceFrequency {
  Daily = 'DAILY',
  Miles = 'MILES',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type MaintenanceTaskRecurrenceInput = {
  frequency: MaintenanceTaskRecurrenceFrequency;
  interval: Scalars['Float'];
};

export enum MaintenanceTaskStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type MaintenanceTaskUpdateInput = {
  assetId?: InputMaybe<Scalars['ObjectId']>;
  assetType?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  label?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<MaintenanceTaskRecurrenceInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startMileage?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<MaintenanceTaskStatus>;
};

export enum MeasurementSystem {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export type MetabaseEmbedToken = {
  iframeUrl: Scalars['String'];
  token: Scalars['String'];
};

export type MetabaseEmbedTokenInput = {
  resourceId: Scalars['Int'];
  resourceType: MetabaseResourceType;
  timezone?: InputMaybe<Scalars['String']>;
};

export enum MetabaseResourceType {
  Dashboard = 'DASHBOARD',
  Question = 'QUESTION'
}

/** A metric measurement at a given point in time */
export type Metric = {
  _id: Scalars['String'];
  date: Scalars['DateTime'];
  dimensions: Scalars['JSON'];
  type: Scalars['String'];
  value: Scalars['Float'];
};

/** The type of metric */
export enum MetricType {
  DeliveryCost = 'DELIVERY_COST',
  Mileage = 'MILEAGE',
  ProductPurchaseCost = 'PRODUCT_PURCHASE_COST'
}

export type MonthlyForecastingModelSlot = {
  month: Scalars['Float'];
};

export type MonthlyForecastingModelSlotInput = {
  month: Scalars['Float'];
};

export type MultiDocumentSignedUrlInput = {
  documents: Array<DocumentSignedUrlInput>;
};

export type MultiShipmentNotesInput = {
  notes: Array<ShipmentNoteInput>;
  shipment?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  activateTrial: SubscriptionInfo;
  addAssetLinking: AssetLinking;
  addBillingRule: BillingRule;
  addBroker: Broker;
  addBusinessEntity: BusinessEntity;
  addChassis: Chassis;
  addCustomFieldDefinition: CustomFieldDefinition;
  addCustomer: Customer;
  addCustomerOrder: Order;
  addDeductionRule: DeductionRule;
  addDriver: Driver;
  addDriverShift: DriverShift;
  addDriverShiftAssignment: DriverShiftAssignment;
  addDwellTimeUptick: DwellTimeUptick;
  addGoodProfile: GoodProfile;
  addGoodProfileClass: GoodProfileClass;
  addGroup: Group;
  addMaintenanceTask: MaintenanceTask;
  addNotesShipment: Shipment;
  addOrder: Order;
  addOrgDoc: OrganizationDocument;
  addOrgMaintenanceTask: OrgMaintenanceTask;
  addOrgUser: OrgUser;
  addPaymentRule: PaymentRule;
  addQualification: Qualification;
  addRateTable: RateTable;
  addReasonCode: ReasonCode;
  addReceiver: Receiver;
  addReceiverForecast: ReceiverForecast;
  addRelationship: Relationship;
  addShipment: Shipment;
  addShipmentDocument: ShipmentDocument;
  addShipmentDocuments: Array<ShipmentDocument>;
  addShipmentEvent: Shipment;
  /** Add an expense to a shipment */
  addShipmentExpense?: Maybe<Transaction>;
  addShipper: Shipper;
  addStorageFacilityReading: StorageFacilityReading;
  addSupplierContract: SupplierContract;
  addTractor: Tractor;
  addTrailer: Trailer;
  addTrailerEvent: TrailerEvent;
  addTransaction: Transaction;
  /** @deprecated Use generateTrip instead */
  addTrip: Trip;
  addTripPayment?: Maybe<Trip>;
  assignTripAsset: Trip;
  assignTripAssets?: Maybe<Trip>;
  assignTripTrailerCompartments: Trip;
  batchProcessInvoices?: Maybe<InvoiceBatchResult>;
  bulkAddBusinessEntities: Array<BusinessEntity>;
  bulkAddDrivers: Array<Driver>;
  bulkAddGoodProfileClasses: Array<GoodProfileClass>;
  bulkAddGoodProfiles: Array<GoodProfile>;
  bulkAddGroups: Array<Group>;
  bulkAddOrders: Array<Order>;
  bulkAddOrgUsers: Array<OrgUser>;
  bulkAddReceiverForecasts: Array<ReceiverForecast>;
  bulkAddStorageFacilityReadings: Array<StorageFacilityReading>;
  bulkAddSupplierContracts: Array<SupplierContract>;
  bulkAddTractors: Array<Tractor>;
  bulkAddTrailerEvents: Array<TrailerEvent>;
  bulkAddTrailers: Array<Trailer>;
  bulkAssignToGroup: Group;
  bulkEditBusinessEntities: BulkUpdateResult;
  bulkEditDrivers: BulkUpdateResult;
  bulkEditGoodProfiles: BulkUpdateResult;
  bulkEditInvoices?: Maybe<Array<Invoice>>;
  bulkEditShipments: BulkUpdateResult;
  bulkEditTractors: BulkUpdateResult;
  bulkEditTrailers: BulkUpdateResult;
  bulkUpdateContractForShipments: Array<Shipment>;
  callBulkExtensionOperation: BulkExtensionOperationResponse;
  callExtensionOperation: ExtensionOperationResponse;
  cancelShipmentSplit?: Maybe<Shipment>;
  changeTripStartTime?: Maybe<Trip>;
  checkShipmentsCombinability: Scalars['Boolean'];
  combineShipments: Trip;
  completeMaintenanceTask: MaintenanceTask;
  completeOrgMaintenanceTask: OrgMaintenanceTask;
  computeLineHaulForTrip?: Maybe<Trip>;
  consolidateInvoices?: Maybe<Invoice>;
  createSavedReport: SavedReport;
  deleteAssetLinking: Scalars['Boolean'];
  deleteBillingRule: Scalars['Boolean'];
  deleteBroker: Scalars['Boolean'];
  deleteBusinessEntity: Scalars['Boolean'];
  deleteCustomFieldDefinition: Scalars['Boolean'];
  deleteCustomer: Scalars['Boolean'];
  deleteCustomerOrder: Scalars['Boolean'];
  deleteDeductionRule: Scalars['Boolean'];
  deleteDocumentShipment: Shipment;
  deleteDriver: Scalars['Boolean'];
  deleteDriverSettlement: Scalars['Boolean'];
  deleteDriverShift: Scalars['Boolean'];
  deleteDriverShiftAssignment: Scalars['Boolean'];
  deleteDwellTimeUptick: Scalars['Boolean'];
  deleteGoodProfile: Scalars['Boolean'];
  deleteGoodProfileClass?: Maybe<Scalars['Boolean']>;
  deleteGroup: Scalars['Boolean'];
  deleteInvoice: Scalars['Boolean'];
  deleteMaintenanceTask: Scalars['Boolean'];
  deleteOrder: Scalars['Boolean'];
  deleteOrgDoc: Scalars['Boolean'];
  deleteOrgMaintenanceTask: Scalars['Boolean'];
  deleteOrgUser: Scalars['Boolean'];
  deletePaymentRule: Scalars['Boolean'];
  deleteQualification: Scalars['Boolean'];
  deleteRateTable: Scalars['Boolean'];
  deleteReasonCode: Scalars['Boolean'];
  deleteReceiver: Scalars['Boolean'];
  deleteReceiverForecast: Scalars['Boolean'];
  deleteRelationship: Scalars['Boolean'];
  deleteSavedReport: Scalars['Boolean'];
  deleteShipment: Shipment;
  deleteShipmentEvent?: Maybe<Shipment>;
  deleteShipmentNote: Shipment;
  deleteShipper: Scalars['Boolean'];
  deleteStorageFacilityReading: Scalars['Boolean'];
  deleteSupplierContract: Scalars['Boolean'];
  deleteTractor: Scalars['Boolean'];
  deleteTrailer: Scalars['Boolean'];
  deleteTrailerEvent: Scalars['Boolean'];
  deleteTransaction: Scalars['Boolean'];
  deleteTrip: Trip;
  deleteTripPayment?: Maybe<Trip>;
  documentSignedUrl: DocumentSignedUrl;
  editAssetLinking: AssetLinking;
  editBillingRule: BillingRule;
  editBroker: Broker;
  editBusinessEntity: BusinessEntity;
  editCustomFieldDefinition: CustomFieldDefinition;
  editCustomer: Customer;
  editCustomerOrder: Order;
  editDeductionRule: DeductionRule;
  editDocumentShipment: Shipment;
  editDriver: Driver;
  editDriverSettlement?: Maybe<DriverSettlement>;
  editDriverShift: DriverShift;
  editDriverShiftAssignment: DriverShiftAssignment;
  editDwellTimeUptick: DwellTimeUptick;
  /** Edit good pin code */
  editGoodPinCode?: Maybe<Shipment>;
  editGoodProfile: GoodProfile;
  editGoodProfileClass?: Maybe<GoodProfileClass>;
  /** Edit good weight */
  editGoodWeight?: Maybe<Shipment>;
  editGroup: Group;
  editInvoice?: Maybe<Invoice>;
  editMaintenanceTask: MaintenanceTask;
  editNoteShipment: Shipment;
  editOrder: Order;
  editOrgDoc: Scalars['String'];
  editOrgMaintenanceTask: OrgMaintenanceTask;
  editOrgUser: OrgUser;
  editOrganization: Scalars['String'];
  editPaymentRule?: Maybe<PaymentRule>;
  editQualification: Qualification;
  editRateTable: RateTable;
  editReasonCode: ReasonCode;
  editReceiver: Receiver;
  editReceiverForecast: ReceiverForecast;
  editRelationship: Relationship;
  editShipment: Shipment;
  editShipmentEvent?: Maybe<ShipmentEvent>;
  /** Edit shipment references */
  editShipmentReferences?: Maybe<Shipment>;
  editShipper: Shipper;
  editStorageFacilityReading: StorageFacilityReading;
  editSupplierContract: SupplierContract;
  editTractor: Tractor;
  editTrailer: Trailer;
  editTrailerEvent: TrailerEvent;
  editTransaction: Transaction;
  editTripPayment?: Maybe<Trip>;
  forecast: ForecastResult;
  generateDriverSettlement: DriverSettlement;
  generateDriverSettlementForTrips: DriverSettlement;
  generateInvoice: Invoice;
  generateReportCsv: ReportCsv;
  generateReportPdf: ReportPdf;
  generateShipmentRoute: ShipmentRoute;
  generateTrip: Trip;
  generateTripsForPendingShipments: TripGenerationResult;
  generateTripsForShipments: TripGenerationResult;
  getCheckoutSession: SubscriptionCheckoutSession;
  getSubscriptionPortalSession: SubscriptionPortalSession;
  installExtension: ExtensionInstallWithRedirectUrl;
  lockOrder: Scalars['Boolean'];
  multipleDocumentSignedUrl: Array<DocumentSignedUrl>;
  persistDrivingPeriods: Scalars['Boolean'];
  persistTractorPositions: Scalars['Boolean'];
  planTripsForDriver: Array<Trip>;
  purgeForecastedOrders: Scalars['Boolean'];
  rankSupplierContractsForPurchase: Array<SupplierContractRanking>;
  rankSupplierContractsForPurchases: Array<SupplierContractRanking>;
  recalculateInvoiceCharges?: Maybe<Invoice>;
  removeShipmentFromTrip: RemoveShipmentFromTripResult;
  reportShipmentIssue: Shipment;
  resendDocumentsToReceivers: Scalars['String'];
  resetTrailerCompartmentVolumes: Scalars['Boolean'];
  restoreLatestSnapshot: Scalars['Boolean'];
  restoreShipment: Shipment;
  saveDataSnapshot: Snapshot;
  saveOrganizationSettings?: Maybe<OrganizationSettings>;
  saveTrip: Trip;
  sendInvoice?: Maybe<Invoice>;
  sendRatecon: SendRateconResult;
  sendReportPdf: SendReportResult;
  separateInvoice: Array<Invoice>;
  setNextInvoiceNumber: Scalars['Int'];
  setupOrganization: Scalars['String'];
  splitShipment?: Maybe<Array<Shipment>>;
  startTrip: Trip;
  transferOrganizationData: TransferResult;
  triggerForecastingManualRun: Scalars['Boolean'];
  uninstallExtension: Scalars['Boolean'];
  updateAccountStatus: Scalars['Boolean'];
  updateCompartmentVolume: CompartmentVolume;
  updateDriverSettlementStatus?: Maybe<DriverSettlement>;
  updateForecastingAutomationConfig: ReceiverForecast;
  updateGoodDeliveredQuantity: Shipment;
  updateGoodDipReadings: Shipment;
  updateGoodLoadedQuantity: Shipment;
  updateInvoiceStatus?: Maybe<Invoice>;
  updateInvoiceTaxRate?: Maybe<Invoice>;
  updateMyAccount: OrgUser;
  updatePassword: Scalars['Boolean'];
  updateSavedReport?: Maybe<SavedReport>;
  updateTripOrder?: Maybe<Trip>;
  uploadStorageFacilityReadingsCsvData: Scalars['Boolean'];
  validateAssetCustomFields: Array<AssetCustomFieldError>;
  validateTripOrder?: Maybe<Array<TripViolation>>;
};


export type MutationActivateTrialArgs = {
  subscriptionType?: InputMaybe<Scalars['String']>;
};


export type MutationAddAssetLinkingArgs = {
  newAssetLinkingData: AssetLinkingInput;
};


export type MutationAddBillingRuleArgs = {
  newBillingRuleData: NewBillingRuleInput;
};


export type MutationAddBrokerArgs = {
  newBrokerData: NewBusinessEntityInput;
};


export type MutationAddBusinessEntityArgs = {
  newBusinessEntityData: NewBusinessEntityInputWithType;
};


export type MutationAddChassisArgs = {
  newChassisData: NewTractorInput;
};


export type MutationAddCustomFieldDefinitionArgs = {
  newCustomFieldDefinitionData: NewCustomFieldDefinitionInput;
};


export type MutationAddCustomerArgs = {
  newCustomerData: NewBusinessEntityInput;
};


export type MutationAddCustomerOrderArgs = {
  newOrderData: NewOrderInput;
};


export type MutationAddDeductionRuleArgs = {
  newDeductionRuleData: NewDeductionRuleInput;
};


export type MutationAddDriverArgs = {
  newDriverData: NewDriverInput;
};


export type MutationAddDriverShiftArgs = {
  newDriverShiftData: NewDriverShiftInput;
};


export type MutationAddDriverShiftAssignmentArgs = {
  newDriverShiftAssignmentData: NewDriverShiftAssignmentInput;
};


export type MutationAddDwellTimeUptickArgs = {
  newDwellTimeUptickData: NewDwellTimeUptickInput;
};


export type MutationAddGoodProfileArgs = {
  newGoodProfileData: NewGoodProfileInput;
};


export type MutationAddGoodProfileClassArgs = {
  newGoodProfileClassData: NewGoodProfileClassInput;
};


export type MutationAddGroupArgs = {
  newGroupData: NewGroupInput;
};


export type MutationAddMaintenanceTaskArgs = {
  newMaintenanceTaskData: NewMaintenanceTaskInput;
};


export type MutationAddNotesShipmentArgs = {
  newNotesData: MultiShipmentNotesInput;
};


export type MutationAddOrderArgs = {
  newOrderData: NewOrderInput;
};


export type MutationAddOrgDocArgs = {
  newOrganizationDocumentData: NewOrganizationDocumentInput;
};


export type MutationAddOrgMaintenanceTaskArgs = {
  newOrgMaintenanceTaskData: OrgMaintenanceTaskInput;
};


export type MutationAddOrgUserArgs = {
  newOrgUserData: NewOrgUserInput;
};


export type MutationAddPaymentRuleArgs = {
  newPaymentRuleData: NewPaymentRuleInput;
};


export type MutationAddQualificationArgs = {
  newQualificationData: NewQualificationInput;
};


export type MutationAddRateTableArgs = {
  newRateTableData: NewRateTableInput;
};


export type MutationAddReasonCodeArgs = {
  newReasonCodeData: NewReasonCodeInput;
};


export type MutationAddReceiverArgs = {
  newReceiverData: NewBusinessEntityInput;
};


export type MutationAddReceiverForecastArgs = {
  newReceiverForecastData: NewReceiverForecastInput;
};


export type MutationAddRelationshipArgs = {
  newRelationshipData: NewRelationshipInput;
};


export type MutationAddShipmentArgs = {
  newShipmentData: NewShipmentInput;
};


export type MutationAddShipmentDocumentArgs = {
  newDocumentData: ShipmentDocumentInput;
};


export type MutationAddShipmentDocumentsArgs = {
  newDocumentsData: Array<ShipmentDocumentInfoInput>;
  shipment: Scalars['String'];
};


export type MutationAddShipmentEventArgs = {
  shipmentEventData: ShipmentEventInput;
};


export type MutationAddShipmentExpenseArgs = {
  input: AddShipmentExpenseInput;
};


export type MutationAddShipperArgs = {
  newShipperData: NewBusinessEntityInput;
};


export type MutationAddStorageFacilityReadingArgs = {
  newStorageFacilityReadingData: NewStorageFacilityReadingInput;
};


export type MutationAddSupplierContractArgs = {
  newSupplierContractData: NewSupplierContractInput;
};


export type MutationAddTractorArgs = {
  newTractorData: NewTractorInput;
};


export type MutationAddTrailerArgs = {
  newTrailerData: NewTrailerInput;
};


export type MutationAddTrailerEventArgs = {
  newTrailerEventData: NewTrailerEventInput;
};


export type MutationAddTransactionArgs = {
  newTransactionData: TransactionInput;
};


export type MutationAddTripArgs = {
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
  newTripData: NewTripInput;
};


export type MutationAddTripPaymentArgs = {
  payment: TransactionInput;
  tripId: Scalars['String'];
};


export type MutationAssignTripAssetArgs = {
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
  tripAssetAssignmentData: TripAssetAssignment;
};


export type MutationAssignTripAssetsArgs = {
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
  tripAssetAssignmentData: Array<TripAssetAssignment>;
};


export type MutationAssignTripTrailerCompartmentsArgs = {
  trailerCompartmentAssignments: Array<TrailerCompartmentAssignmentInput>;
  tripId: Scalars['String'];
};


export type MutationBatchProcessInvoicesArgs = {
  invoiceIds: Array<Scalars['ObjectId']>;
  status: InvoiceStatus;
};


export type MutationBulkAddBusinessEntitiesArgs = {
  newBusinessEntityData: Array<NewBusinessEntityInputWithType>;
};


export type MutationBulkAddDriversArgs = {
  newDriverData: Array<NewDriverInput>;
};


export type MutationBulkAddGoodProfileClassesArgs = {
  newGoodProfileClassesData: Array<NewGoodProfileClassInput>;
};


export type MutationBulkAddGoodProfilesArgs = {
  newGoodProfilesData: Array<NewGoodProfileInput>;
};


export type MutationBulkAddGroupsArgs = {
  newGroupsData: Array<NewGroupInput>;
};


export type MutationBulkAddOrdersArgs = {
  newOrdersData: Array<NewOrderInput>;
};


export type MutationBulkAddOrgUsersArgs = {
  newOrgUsersData: Array<NewOrgUserInput>;
};


export type MutationBulkAddReceiverForecastsArgs = {
  newReceiverForecastsData: Array<NewReceiverForecastInput>;
};


export type MutationBulkAddStorageFacilityReadingsArgs = {
  newStorageFacilityReadingsData: Array<NewStorageFacilityReadingInput>;
};


export type MutationBulkAddSupplierContractsArgs = {
  newSupplierContractsData: Array<NewSupplierContractInput>;
};


export type MutationBulkAddTractorsArgs = {
  newTractorsData: Array<NewTractorInput>;
};


export type MutationBulkAddTrailerEventsArgs = {
  newTrailerEventData: Array<NewTrailerEventInput>;
};


export type MutationBulkAddTrailersArgs = {
  newTrailerData: Array<NewTrailerInput>;
};


export type MutationBulkAssignToGroupArgs = {
  groupId: Scalars['ObjectId'];
  memberIds: Array<Scalars['String']>;
};


export type MutationBulkEditBusinessEntitiesArgs = {
  editBusinessEntityData: BusinessEntityUpdateInput;
  ids: Array<Scalars['ObjectId']>;
};


export type MutationBulkEditDriversArgs = {
  editDriverData: BulkEditDriverInput;
  ids: Array<Scalars['ObjectId']>;
};


export type MutationBulkEditGoodProfilesArgs = {
  editGoodProfileData: GoodProfileUpdateInput;
  ids: Array<Scalars['ObjectId']>;
};


export type MutationBulkEditInvoicesArgs = {
  bulkEditInvoiceData: InvoiceBulkUpdateInput;
  ids: Array<Scalars['ObjectId']>;
};


export type MutationBulkEditShipmentsArgs = {
  editshipmentsData: ShipmentUpdateInput;
  ids: Array<Scalars['ObjectId']>;
};


export type MutationBulkEditTractorsArgs = {
  editTractorData: TractorUpdateInput;
  ids: Array<Scalars['ObjectId']>;
};


export type MutationBulkEditTrailersArgs = {
  editTrailerData: TrailerUpdateInput;
  ids: Array<Scalars['ObjectId']>;
};


export type MutationBulkUpdateContractForShipmentsArgs = {
  contractId: Scalars['ObjectId'];
  shipmentIds: Array<Scalars['ObjectId']>;
};


export type MutationCallBulkExtensionOperationArgs = {
  extensionId: Scalars['String'];
  operationKey: Scalars['String'];
  recordIds: Array<Scalars['String']>;
};


export type MutationCallExtensionOperationArgs = {
  extensionId: Scalars['String'];
  operationKey: Scalars['String'];
  recordId: Scalars['String'];
};


export type MutationCancelShipmentSplitArgs = {
  shipmentId: Scalars['String'];
};


export type MutationChangeTripStartTimeArgs = {
  changeTripStartTimeData: ChangeTripStartTimeInput;
};


export type MutationCheckShipmentsCombinabilityArgs = {
  generateTripData: GenerateTripInput;
};


export type MutationCombineShipmentsArgs = {
  generateTripData: GenerateTripInput;
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCompleteMaintenanceTaskArgs = {
  id: Scalars['ObjectId'];
};


export type MutationCompleteOrgMaintenanceTaskArgs = {
  id: Scalars['ObjectId'];
};


export type MutationComputeLineHaulForTripArgs = {
  tripId: Scalars['String'];
};


export type MutationConsolidateInvoicesArgs = {
  invoiceIds: Array<Scalars['ObjectId']>;
};


export type MutationCreateSavedReportArgs = {
  input: NewSavedReportInput;
};


export type MutationDeleteAssetLinkingArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBillingRuleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBrokerArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBusinessEntityArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCustomFieldDefinitionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCustomerOrderArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDeductionRuleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDocumentShipmentArgs = {
  deleteDocumentData: DeleteShipmentDocumentInput;
};


export type MutationDeleteDriverArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDriverSettlementArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDriverShiftArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDriverShiftAssignmentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDwellTimeUptickArgs = {
  id: Scalars['ObjectId'];
};


export type MutationDeleteGoodProfileArgs = {
  id: Scalars['String'];
};


export type MutationDeleteGoodProfileClassArgs = {
  id: Scalars['ObjectId'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInvoiceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMaintenanceTaskArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrgDocArgs = {
  id: Scalars['ObjectId'];
};


export type MutationDeleteOrgMaintenanceTaskArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrgUserArgs = {
  id: Scalars['String'];
};


export type MutationDeletePaymentRuleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteQualificationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteRateTableArgs = {
  id: Scalars['String'];
};


export type MutationDeleteReasonCodeArgs = {
  id: Scalars['ObjectId'];
};


export type MutationDeleteReceiverArgs = {
  id: Scalars['String'];
};


export type MutationDeleteReceiverForecastArgs = {
  id: Scalars['String'];
};


export type MutationDeleteRelationshipArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSavedReportArgs = {
  id: Scalars['ObjectId'];
};


export type MutationDeleteShipmentArgs = {
  deleteShipmentData?: InputMaybe<ShipmentDeleteInput>;
  id: Scalars['String'];
};


export type MutationDeleteShipmentEventArgs = {
  eventId: Scalars['ObjectId'];
  shipmentId: Scalars['ObjectId'];
};


export type MutationDeleteShipmentNoteArgs = {
  deleteNoteData: DeleteShipmentNoteInput;
};


export type MutationDeleteShipperArgs = {
  id: Scalars['String'];
};


export type MutationDeleteStorageFacilityReadingArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSupplierContractArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTractorArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTrailerArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTrailerEventArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTransactionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTripArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTripPaymentArgs = {
  paymentId: Scalars['String'];
  tripId: Scalars['String'];
};


export type MutationDocumentSignedUrlArgs = {
  newDocumentSignedUrl: DocumentSignedUrlInput;
};


export type MutationEditAssetLinkingArgs = {
  editAssetLinkingData: AssetLinkingUpdateInput;
  id: Scalars['String'];
};


export type MutationEditBillingRuleArgs = {
  editBillingRuleData: BillingRuleUpdateInput;
  id: Scalars['String'];
};


export type MutationEditBrokerArgs = {
  editBrokerData: BusinessEntityUpdateInput;
  id: Scalars['String'];
};


export type MutationEditBusinessEntityArgs = {
  editBusinessEntityData: BusinessEntityUpdateInput;
  id: Scalars['String'];
};


export type MutationEditCustomFieldDefinitionArgs = {
  editCustomFieldDefinitionData: CustomFieldDefinitionUpdateInput;
  id: Scalars['String'];
};


export type MutationEditCustomerArgs = {
  editCustomerData: BusinessEntityUpdateInput;
  id: Scalars['String'];
};


export type MutationEditCustomerOrderArgs = {
  editOrderData: OrderUpdateInput;
  id: Scalars['String'];
};


export type MutationEditDeductionRuleArgs = {
  editDeductionRuleData: DeductionRuleUpdateInput;
  id: Scalars['String'];
};


export type MutationEditDocumentShipmentArgs = {
  editDocumentData: EditShipmentDocumentInput;
};


export type MutationEditDriverArgs = {
  editDriverData: DriverUpdateInput;
  id: Scalars['String'];
};


export type MutationEditDriverSettlementArgs = {
  editDriverSettlementData: DriverSettlementUpdateInput;
  id: Scalars['ObjectId'];
};


export type MutationEditDriverShiftArgs = {
  editDriverShiftData: DriverShiftUpdateInput;
  id: Scalars['String'];
};


export type MutationEditDriverShiftAssignmentArgs = {
  editDriverShiftAssignmentData: DriverShiftAssignmentUpdateInput;
  id: Scalars['String'];
};


export type MutationEditDwellTimeUptickArgs = {
  editDwellTimeUptickData: NewDwellTimeUptickInput;
  id: Scalars['ObjectId'];
};


export type MutationEditGoodPinCodeArgs = {
  goodId: Scalars['String'];
  id: Scalars['ObjectId'];
  pinCode: Scalars['String'];
};


export type MutationEditGoodProfileArgs = {
  editGoodProfileData: GoodProfileUpdateInput;
  id: Scalars['String'];
};


export type MutationEditGoodProfileClassArgs = {
  editGoodProfileClassData: GoodProfileClassUpdateInput;
  id: Scalars['ObjectId'];
};


export type MutationEditGoodWeightArgs = {
  goodId: Scalars['String'];
  id: Scalars['ObjectId'];
  weight: Scalars['Float'];
};


export type MutationEditGroupArgs = {
  editGroupData: GroupUpdateInput;
  id: Scalars['String'];
};


export type MutationEditInvoiceArgs = {
  editInvoiceData: InvoiceUpdateInput;
  id: Scalars['ObjectId'];
};


export type MutationEditMaintenanceTaskArgs = {
  editMaintenanceTaskData: MaintenanceTaskUpdateInput;
  id: Scalars['String'];
};


export type MutationEditNoteShipmentArgs = {
  editNoteData: EditShipmentNoteInput;
};


export type MutationEditOrderArgs = {
  editOrderData: OrderUpdateInput;
  id: Scalars['String'];
};


export type MutationEditOrgDocArgs = {
  id: Scalars['ObjectId'];
  organizationDocumentData: OrganizationDocumentUpdateInput;
};


export type MutationEditOrgMaintenanceTaskArgs = {
  editOrgMaintenanceTaskData: OrgMaintenanceTaskUpdateInput;
  id: Scalars['String'];
};


export type MutationEditOrgUserArgs = {
  editOrgUserData: OrgUserUpdateInput;
  id: Scalars['String'];
};


export type MutationEditOrganizationArgs = {
  organizationSetupData: OrganizationUpdateInput;
};


export type MutationEditPaymentRuleArgs = {
  editPaymentRuleData: PaymentRuleUpdateInput;
  id: Scalars['String'];
};


export type MutationEditQualificationArgs = {
  editQualificationData: QualificationUpdateInput;
  id: Scalars['String'];
};


export type MutationEditRateTableArgs = {
  editRateTableData: RateTableUpdateInput;
  id: Scalars['String'];
};


export type MutationEditReasonCodeArgs = {
  editReasonCodeData: ReasonCodeUpdateInput;
  id: Scalars['ObjectId'];
};


export type MutationEditReceiverArgs = {
  editReceiverData: BusinessEntityUpdateInput;
  id: Scalars['String'];
};


export type MutationEditReceiverForecastArgs = {
  editReceiverForecastData: ReceiverForecastUpdateInput;
  id: Scalars['String'];
};


export type MutationEditRelationshipArgs = {
  editRelationshipData: RelationshipUpdateInput;
  id: Scalars['String'];
};


export type MutationEditShipmentArgs = {
  editShipmentData: ShipmentUpdateInput;
  id: Scalars['String'];
};


export type MutationEditShipmentEventArgs = {
  eventId: Scalars['ObjectId'];
  shipmentEventData: UpdateShipmentEventInput;
  shipmentId: Scalars['ObjectId'];
};


export type MutationEditShipmentReferencesArgs = {
  editReferencesData: ShipmentReferencesUpdateInput;
  id: Scalars['ObjectId'];
};


export type MutationEditShipperArgs = {
  editShipperData: BusinessEntityUpdateInput;
  id: Scalars['String'];
};


export type MutationEditStorageFacilityReadingArgs = {
  editStorageFacilityReadingData: StorageFacilityReadingUpdateInput;
  id: Scalars['String'];
};


export type MutationEditSupplierContractArgs = {
  editSupplierContractData: SupplierContractUpdateInput;
  id: Scalars['String'];
};


export type MutationEditTractorArgs = {
  editTractorData: TractorUpdateInput;
  id: Scalars['String'];
};


export type MutationEditTrailerArgs = {
  editTrailerData: TrailerUpdateInput;
  id: Scalars['String'];
};


export type MutationEditTrailerEventArgs = {
  editTrailerEventData: TrailerEventUpdateInput;
  id: Scalars['String'];
};


export type MutationEditTransactionArgs = {
  editTransactionData: TransactionUpdateInput;
  id: Scalars['String'];
};


export type MutationEditTripPaymentArgs = {
  payment: TransactionInput;
  paymentId: Scalars['String'];
  tripId: Scalars['String'];
};


export type MutationForecastArgs = {
  payload: ForecastingPayload;
};


export type MutationGenerateDriverSettlementArgs = {
  driverId: Scalars['String'];
  driverSettlementNumber?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateDriverSettlementForTripsArgs = {
  driverSettlementNumber?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  tripIds: Array<Scalars['String']>;
};


export type MutationGenerateInvoiceArgs = {
  invoiceNumber?: InputMaybe<Scalars['String']>;
  shipmentId: Scalars['String'];
};


export type MutationGenerateReportCsvArgs = {
  filter?: InputMaybe<Scalars['ReportFilter']>;
  lang: Scalars['String'];
  period: PeriodInput;
  reportType: ReportType;
  timezone: Scalars['String'];
};


export type MutationGenerateReportPdfArgs = {
  filter?: InputMaybe<Scalars['ReportFilter']>;
  lang: Scalars['String'];
  period: PeriodInput;
  reportType: ReportType;
  timezone: Scalars['String'];
};


export type MutationGenerateShipmentRouteArgs = {
  shipmentData: NewShipmentInput;
};


export type MutationGenerateTripArgs = {
  generateTripData: GenerateTripInput;
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
};


export type MutationGenerateTripsForShipmentsArgs = {
  endDate: Scalars['DateTime'];
  shipmentIds: Array<Scalars['ObjectId']>;
  startDate: Scalars['DateTime'];
};


export type MutationInstallExtensionArgs = {
  configurationValues: Array<ExtensionConfigurationValueInput>;
  extensionId: Scalars['String'];
};


export type MutationLockOrderArgs = {
  shipmentId: Scalars['ObjectId'];
};


export type MutationMultipleDocumentSignedUrlArgs = {
  newMultiDocumentSignedUrl: MultiDocumentSignedUrlInput;
};


export type MutationPersistDrivingPeriodsArgs = {
  input: Array<PersistDrivingPeriodInput>;
};


export type MutationPersistTractorPositionsArgs = {
  id: Scalars['String'];
  positions: Array<TractorPositionInput>;
};


export type MutationPlanTripsForDriverArgs = {
  additionalTrailerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  driverId: Scalars['ObjectId'];
  planTimezone?: InputMaybe<Scalars['String']>;
  tractorId?: InputMaybe<Scalars['ObjectId']>;
  trailerId?: InputMaybe<Scalars['ObjectId']>;
  trips: Array<TripForPlanningInput>;
};


export type MutationPurgeForecastedOrdersArgs = {
  receiverId: Scalars['ObjectId'];
};


export type MutationRankSupplierContractsForPurchaseArgs = {
  purchase: PurchaseInput;
};


export type MutationRankSupplierContractsForPurchasesArgs = {
  purchases: Array<PurchaseInput>;
};


export type MutationRecalculateInvoiceChargesArgs = {
  invoiceId: Scalars['String'];
};


export type MutationRemoveShipmentFromTripArgs = {
  shipmentIds: Array<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
};


export type MutationReportShipmentIssueArgs = {
  shipmentIssueData: ShipmentIssueInput;
};


export type MutationResendDocumentsToReceiversArgs = {
  shipmentId: Scalars['ObjectId'];
};


export type MutationResetTrailerCompartmentVolumesArgs = {
  trailerId: Scalars['String'];
};


export type MutationRestoreShipmentArgs = {
  id: Scalars['String'];
};


export type MutationSaveOrganizationSettingsArgs = {
  newOrganizationSettingsData: OrganizationSettingsInput;
};


export type MutationSaveTripArgs = {
  saveTripData: SaveTripInput;
};


export type MutationSendInvoiceArgs = {
  invoiceId: Scalars['String'];
};


export type MutationSendRateconArgs = {
  tripId: Scalars['String'];
};


export type MutationSendReportPdfArgs = {
  email: Scalars['String'];
  filter?: InputMaybe<Scalars['ReportFilter']>;
  lang: Scalars['String'];
  period: PeriodInput;
  reportType: ReportType;
  timezone: Scalars['String'];
};


export type MutationSeparateInvoiceArgs = {
  invoiceId: Scalars['ObjectId'];
  shipmentIds: Array<Scalars['ObjectId']>;
};


export type MutationSetNextInvoiceNumberArgs = {
  nextInvoiceNumber: Scalars['Int'];
};


export type MutationSetupOrganizationArgs = {
  organizationSetupData: NewOrganizationInput;
};


export type MutationSplitShipmentArgs = {
  locations: Array<SplitShipmentLocationInput>;
  shipmentId: Scalars['String'];
};


export type MutationStartTripArgs = {
  startTripData: StartTripInput;
};


export type MutationTransferOrganizationDataArgs = {
  input: TransferOrganizationDataInput;
};


export type MutationTriggerForecastingManualRunArgs = {
  receiverForecastId: Scalars['ObjectId'];
};


export type MutationUninstallExtensionArgs = {
  extensionId: Scalars['String'];
};


export type MutationUpdateAccountStatusArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
};


export type MutationUpdateCompartmentVolumeArgs = {
  commodityId: Scalars['String'];
  compartmentId: Scalars['String'];
  quantity: Scalars['Float'];
  trailerId: Scalars['String'];
};


export type MutationUpdateDriverSettlementStatusArgs = {
  driverSettlementId: Scalars['String'];
  status: DriverSettlementStatus;
};


export type MutationUpdateForecastingAutomationConfigArgs = {
  config: AutomationConfigInput;
  receiverForecastId: Scalars['ObjectId'];
};


export type MutationUpdateGoodDeliveredQuantityArgs = {
  input: UpdateGoodDeliveredQuantityInput;
};


export type MutationUpdateGoodDipReadingsArgs = {
  input: UpdateGoodDipReadingsInput;
};


export type MutationUpdateGoodLoadedQuantityArgs = {
  input: UpdateGoodLoadedQuantityInput;
};


export type MutationUpdateInvoiceStatusArgs = {
  closingNote?: InputMaybe<Scalars['String']>;
  invoiceId: Scalars['String'];
  paidAmount?: InputMaybe<Scalars['Float']>;
  status: InvoiceStatus;
};


export type MutationUpdateInvoiceTaxRateArgs = {
  invoiceId: Scalars['String'];
  taxRate?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdateMyAccountArgs = {
  accountData: UpdateAccountInput;
};


export type MutationUpdatePasswordArgs = {
  id: Scalars['String'];
  temporaryPassword: Scalars['String'];
};


export type MutationUpdateSavedReportArgs = {
  id: Scalars['ObjectId'];
  input: SavedReportUpdateInput;
};


export type MutationUpdateTripOrderArgs = {
  updateTripOrderData: UpdateTripOrderInput;
};


export type MutationUploadStorageFacilityReadingsCsvDataArgs = {
  data: Scalars['JSON'];
  receiverId: Scalars['ObjectId'];
};


export type MutationValidateAssetCustomFieldsArgs = {
  assetId: Scalars['ObjectId'];
  assetType: TripAssetTypes;
  shipmentId: Scalars['ObjectId'];
};


export type MutationValidateTripOrderArgs = {
  validateTripOrderData: UpdateTripOrderInput;
};

export type MyDriverSettlementPaginatedResult = {
  count: Scalars['Int'];
  data: Array<DriverSettlement>;
};

export type NewAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  coordinates: CoordinatesInput;
  country?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type NewBillingRuleInput = {
  amount?: InputMaybe<Scalars['Float']>;
  condition?: InputMaybe<BillingRuleConditionInput>;
  conditions?: InputMaybe<Array<BillingRuleConditionInput>>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  customer?: InputMaybe<Scalars['String']>;
  /** End of the effective window (inclusive, 23:59). Blank means always in effect. */
  effectiveEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Start of the effective window (inclusive, 00:00). Blank means always in effect. */
  effectiveStartDate?: InputMaybe<Scalars['DateTime']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<BillingMethod>;
  priority?: InputMaybe<Scalars['Float']>;
  rates?: InputMaybe<Array<BillingRateInput>>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  type: BillingRuleType;
};

export type NewBusinessEntityInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  additionalContacts?: InputMaybe<Array<NewContactInput>>;
  additionalTypes?: InputMaybe<Array<BusinessEntityType>>;
  address: NewAddressInput;
  billingAddress?: InputMaybe<NewTextualAddressInput>;
  billingEmail?: InputMaybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: InputMaybe<InvoiceConsolidationCriteria>;
  billingTermsDay?: InputMaybe<Scalars['Float']>;
  billingWeekStartsOn?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<Scalars['String']>;
  commodityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  contact?: InputMaybe<NewContactInput>;
  creditTerms?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  defaultReferenceNumbers?: InputMaybe<Array<DefaultReferenceNumberInput>>;
  defaultShipperId?: InputMaybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: InputMaybe<Array<DocumentRequirementInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  dotNumber?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  federalId?: InputMaybe<Scalars['String']>;
  goodInventoryItems?: InputMaybe<Array<GoodInventoryItemInput>>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  mcNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Array<BusinessEntityNoteInput>>;
  openingSchedules?: InputMaybe<Array<OpeningScheduleInput>>;
  parentBusinessEntityId?: InputMaybe<Scalars['ObjectId']>;
  payToProfileId?: InputMaybe<Scalars['ObjectId']>;
  /** Dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: InputMaybe<Scalars['Float']>;
  referenceNumberTypes?: InputMaybe<Array<ShipmentReferenceNumberType>>;
  remitAddress?: InputMaybe<NewTextualAddressInput>;
  /** Remit company name for the business entity */
  remitCompanyName?: InputMaybe<Scalars['String']>;
  remitEmail?: InputMaybe<Scalars['String']>;
  shipmentDocumentsToReceive?: InputMaybe<Array<Scalars['String']>>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssetStatus>;
  storageFacilities?: InputMaybe<Array<StorageFacilityInput>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  trailerTypes?: InputMaybe<Array<TrailerType>>;
};

export type NewBusinessEntityInputWithType = {
  accessToken?: InputMaybe<Scalars['String']>;
  additionalContacts?: InputMaybe<Array<NewContactInput>>;
  additionalTypes?: InputMaybe<Array<BusinessEntityType>>;
  address: NewAddressInput;
  billingAddress?: InputMaybe<NewTextualAddressInput>;
  billingEmail?: InputMaybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: InputMaybe<InvoiceConsolidationCriteria>;
  billingTermsDay?: InputMaybe<Scalars['Float']>;
  billingWeekStartsOn?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<Scalars['String']>;
  commodityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  contact?: InputMaybe<NewContactInput>;
  creditTerms?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  defaultReferenceNumbers?: InputMaybe<Array<DefaultReferenceNumberInput>>;
  defaultShipperId?: InputMaybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: InputMaybe<Array<DocumentRequirementInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  dotNumber?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  federalId?: InputMaybe<Scalars['String']>;
  goodInventoryItems?: InputMaybe<Array<GoodInventoryItemInput>>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  mcNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Array<BusinessEntityNoteInput>>;
  openingSchedules?: InputMaybe<Array<OpeningScheduleInput>>;
  parentBusinessEntityId?: InputMaybe<Scalars['ObjectId']>;
  payToProfileId?: InputMaybe<Scalars['ObjectId']>;
  /** Dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: InputMaybe<Scalars['Float']>;
  referenceNumberTypes?: InputMaybe<Array<ShipmentReferenceNumberType>>;
  remitAddress?: InputMaybe<NewTextualAddressInput>;
  /** Remit company name for the business entity */
  remitCompanyName?: InputMaybe<Scalars['String']>;
  remitEmail?: InputMaybe<Scalars['String']>;
  shipmentDocumentsToReceive?: InputMaybe<Array<Scalars['String']>>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssetStatus>;
  storageFacilities?: InputMaybe<Array<StorageFacilityInput>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  trailerTypes?: InputMaybe<Array<TrailerType>>;
  type: BusinessEntityType;
};

export type NewContactInput = {
  email?: InputMaybe<Scalars['String']>;
  extensionNumber?: InputMaybe<Scalars['String']>;
  faxNumber?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  includeInDocumentSending?: InputMaybe<Scalars['Boolean']>;
  includeInInvoicing?: InputMaybe<Scalars['Boolean']>;
  lastname?: InputMaybe<Scalars['String']>;
  middlename?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type NewCustomFieldDefinitionInput = {
  context: Array<CustomFieldContext>;
  defaultOption?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  extensionId?: InputMaybe<Scalars['String']>;
  isExtensionField?: InputMaybe<Scalars['Boolean']>;
  isRequirement?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  label: Scalars['String'];
  requirementOptions?: InputMaybe<CustomFieldRequirementOptionsInput>;
  selectOptions?: InputMaybe<Array<CustomFieldSelectOptionInput>>;
  selectOptionsEndpoint?: InputMaybe<Scalars['String']>;
  selectOptionsEntity?: InputMaybe<CustomFieldSelectOptionEntity>;
  type: CustomFieldType;
};

export type NewDeductionRuleInput = {
  amount: Scalars['Float'];
  driver?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  method: DriverDeductionMethod;
  period: DeductionPeriodInput;
  type: DeductionType;
};

export type NewDriverInput = {
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  dateOfPhysicalExamination?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<Array<DriverDocumentInput>>;
  /** Where the driver starts his journey everyday */
  domicile?: InputMaybe<NewAddressInput>;
  domicileId?: InputMaybe<Scalars['ObjectId']>;
  eldId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  hos?: InputMaybe<DriverHosInput>;
  isOwnerOperator?: InputMaybe<Scalars['Boolean']>;
  lastname: Scalars['String'];
  license?: InputMaybe<DriverLicenseInput>;
  medical?: InputMaybe<DriverMedicalInput>;
  middlename?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssetStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type NewDriverShiftAssignmentInput = {
  driverId: Scalars['ObjectId'];
  driverShiftId: Scalars['ObjectId'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type NewDriverShiftInput = {
  days: Array<Scalars['Int']>;
  domicileId?: InputMaybe<Scalars['ObjectId']>;
  driverIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  endTime: TimeInput;
  /** Ad hoc driver shifts are one time shifts that have been assigned directly from the planning tool */
  isAdhoc?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  startTime: TimeInput;
};

export type NewDwellTimeUptickInput = {
  addedTimeInMinutes: Scalars['Float'];
  businessEntityId: Scalars['ObjectId'];
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type NewGoodProfileClassInput = {
  description?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
};

export type NewGoodProfileInput = {
  status?: InputMaybe<AssetStatus>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  equivalences?: InputMaybe<Array<GoodProfileEquivalenceInput>>;
  /** ID of the commodity profile in an external system. */
  externalId?: InputMaybe<Scalars['String']>;
  goodProfileClassId?: InputMaybe<Scalars['ObjectId']>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  label: Scalars['String'];
  liquidGravity?: InputMaybe<Scalars['Float']>;
  productType?: InputMaybe<GoodProfileProductType>;
  restrictions?: InputMaybe<Array<GoodProfileRestrictionInput>>;
  shipperIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  supplierIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  unit: GoodUnits;
  weight: Scalars['Float'];
};

export type NewGroupInput = {
  /** When true, this group is auto-applied to shipments for receivers that belong to this group */
  defaultFromReceiverForOrders?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  memberIds: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type NewMaintenanceTaskInput = {
  assetId: Scalars['ObjectId'];
  assetType: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  label: Scalars['String'];
  recurrence?: InputMaybe<MaintenanceTaskRecurrenceInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startMileage?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<MaintenanceTaskStatus>;
};

export type NewOrderInput = {
  customerId: Scalars['ObjectId'];
  locations: Array<ShipmentLocationInput>;
  orderNumber?: InputMaybe<Scalars['String']>;
  status: Status;
};

export type NewOrgUserInput = {
  attributes?: InputMaybe<UserAttributesInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  roles: Array<KeycloakUserRoleInput>;
  username: Scalars['String'];
};

export type NewOrganizationDocumentInput = {
  _id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type NewOrganizationInput = {
  address?: InputMaybe<Scalars['String']>;
  contactFullname?: InputMaybe<Scalars['String']>;
  dotNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['Email']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type NewPaymentRuleInput = {
  amount: Scalars['Float'];
  driver?: InputMaybe<Scalars['String']>;
  method: DriverPaymentMethod;
  period?: InputMaybe<PaymentPeriodInput>;
};

export type NewQualificationInput = {
  assetId: Scalars['ObjectId'];
  assetType: Scalars['String'];
  documents?: InputMaybe<Array<DocumentInput>>;
  endDate: Scalars['DateTime'];
  label: Scalars['String'];
  number?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
};

export type NewRateTableInput = {
  /** Matrix of rate cells. For 1D tables, use cells[i][0]. For 2D tables, use cells[i][j] where i=row, j=column */
  cells: Array<Array<RateTableCellInput>>;
  /** Only required for two-dimensional tables */
  columnAxis?: InputMaybe<RateTableAxisInput>;
  description?: InputMaybe<Scalars['String']>;
  /** End of the effective window (inclusive, 23:59). Blank means always in effect. */
  effectiveEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Start of the effective window (inclusive, 00:00). Blank means always in effect. */
  effectiveStartDate?: InputMaybe<Scalars['DateTime']>;
  entityId: Scalars['ObjectId'];
  entityType: RateTableEntityType;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  priority?: InputMaybe<Scalars['Float']>;
  rateType: RateTableType;
  referenceNumber?: InputMaybe<Scalars['String']>;
  rowAxis: RateTableAxisInput;
};

export type NewReasonCodeInput = {
  description?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  shipmentId?: InputMaybe<Scalars['ObjectId']>;
  tripId?: InputMaybe<Scalars['ObjectId']>;
  type: ReasonCodeType;
};

export type NewReceiverForecastInput = {
  automationConfig?: InputMaybe<AutomationConfigInput>;
  models: Array<ForecastingModelInput>;
  readingsFileConfiguration?: InputMaybe<ReadingsFileConfigurationInput>;
  receiverId: Scalars['ObjectId'];
  trailerProfile: TrailerProfileInput;
};

export type NewRelationshipInput = {
  commodityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  customerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  receiverIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  shipperIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  supplierIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type NewSavedReportInput = {
  filters: Scalars['JSON'];
  name: Scalars['String'];
  reportKey: Scalars['String'];
};

export type NewShipmentInput = {
  additionalTrailerTypes?: InputMaybe<Array<TrailerType>>;
  assignedCarriers?: InputMaybe<Array<ShipmentCarrierAssignmentInput>>;
  billOfLadingNumber?: InputMaybe<Scalars['String']>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']>>;
  charges?: InputMaybe<Array<ShipmentChargeInput>>;
  commodityType?: InputMaybe<ShipmentCommodityType>;
  constraints?: InputMaybe<Array<ShipmentConstraintInput>>;
  createdBy?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  customer: Scalars['ObjectId'];
  dailyRotationCount?: InputMaybe<Scalars['Float']>;
  documents?: InputMaybe<Array<ShipmentDocumentInput>>;
  expenses?: InputMaybe<Array<TransactionInput>>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  loadType: LoadType;
  notes?: InputMaybe<Array<SingleShipmentNoteInput>>;
  orderId?: InputMaybe<Scalars['ObjectId']>;
  postOfficeNumber?: InputMaybe<Scalars['String']>;
  purchaseOrderNumbers?: InputMaybe<Array<Scalars['String']>>;
  rateConNumbers?: InputMaybe<Array<Scalars['String']>>;
  recurrence?: InputMaybe<ShipmentRecurrenceInput>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']>>;
  shipmentLocations: Array<ShipmentLocationInput>;
  status?: InputMaybe<Status>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  ticketNumbers?: InputMaybe<Array<Scalars['String']>>;
  trailerType: TrailerType;
};

export type NewStorageFacilityReadingInput = {
  date: Scalars['DateTime'];
  level: Scalars['Float'];
  receiverId: Scalars['ObjectId'];
  storageFacilityId: Scalars['String'];
  volumeType?: InputMaybe<VolumeType>;
};

export type NewSupplierContractInput = {
  /** The maximum quantities of product allowed by the contract */
  allocation?: InputMaybe<SupplierContractAllocationInput>;
  /** The conditions that must be met for the contract to apply */
  conditions?: InputMaybe<Array<SupplierContractConditionInput>>;
  /** The identifier of the contract */
  contractNumber: Scalars['String'];
  /** The id of the customer that the contract is for */
  customerId?: InputMaybe<Scalars['ObjectId']>;
  /** The end date of the contract. The contract cannot be used after this date */
  endDate: Scalars['DateTime'];
  /** The id of the commodity that the contract is for */
  goodProfileId: Scalars['ObjectId'];
  /** The pin code to use the contract */
  pinCode?: InputMaybe<Scalars['String']>;
  /** The id of the shipper where the commodity can be picked up at */
  shipperId?: InputMaybe<Scalars['ObjectId']>;
  /** The start date of the contract. The contract cannot be used before this date */
  startDate: Scalars['DateTime'];
  /** The id of the supplier that the contract is with */
  supplierId: Scalars['ObjectId'];
  /** The price per unit of the commodity */
  unitPrice: Scalars['Float'];
  /** The quantities of product used through this contract */
  usedAllocation?: InputMaybe<SupplierContractAllocationInput>;
};

export type NewTextualAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type NewTractorInput = {
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  domicile?: InputMaybe<NewAddressInput>;
  eldId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Float']>;
  model?: InputMaybe<Scalars['String']>;
  plateNumber?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  status?: InputMaybe<AssetStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  tareWeight?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type NewTrailerEventInput = {
  date: Scalars['DateTime'];
  trailerId: Scalars['ObjectId'];
  type: TrailerEventType;
};

export type NewTrailerInput = {
  compartments?: InputMaybe<Array<TrailerCompartmentInput>>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  domicile?: InputMaybe<NewAddressInput>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  hasMeteredPump?: InputMaybe<Scalars['Boolean']>;
  height?: InputMaybe<Scalars['Float']>;
  lastKnownLocation?: InputMaybe<CoordinatesInput>;
  length?: InputMaybe<Scalars['Float']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  maxTemperature?: InputMaybe<Scalars['Float']>;
  maxWeight?: InputMaybe<Scalars['Float']>;
  mileage?: InputMaybe<Scalars['Float']>;
  minTemperature?: InputMaybe<Scalars['Float']>;
  numberOfAxles?: InputMaybe<Scalars['Float']>;
  serial?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  status?: InputMaybe<AssetStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  type: TrailerType;
  vin?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type NewTripInput = {
  additionalTrailers?: InputMaybe<Array<Scalars['ObjectId']>>;
  carrier?: InputMaybe<Scalars['String']>;
  chassis?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  driver?: InputMaybe<Scalars['String']>;
  etaFromPreviousTrip?: InputMaybe<Scalars['Float']>;
  etaToNextTrip?: InputMaybe<Scalars['Float']>;
  shipments: Array<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  tractor?: InputMaybe<Scalars['String']>;
  trailer?: InputMaybe<Scalars['String']>;
  trailerCompartmentAssignments?: InputMaybe<Array<TrailerCompartmentAssignmentInput>>;
  violations?: InputMaybe<Array<TripViolationInput>>;
};

export enum NoteAccessLevel {
  Carrier = 'CARRIER',
  Customer = 'CUSTOMER',
  Dispatcher = 'DISPATCHER',
  Driver = 'DRIVER'
}

/** Opening schedule */
export type OpeningSchedule = {
  closingTime: Scalars['String'];
  days: Array<Scalars['Int']>;
  openingTime: Scalars['String'];
};

export type OpeningScheduleInput = {
  closingTime: Scalars['String'];
  days: Array<Scalars['Int']>;
  openingTime: Scalars['String'];
};

export type Order = {
  _id: Scalars['String'];
  customer?: Maybe<BusinessEntity>;
  customerId: Scalars['ObjectId'];
  locations: Array<ShipmentLocation>;
  orderNumber: Scalars['String'];
  shipment?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['ObjectId']>;
  status: Status;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderByItem = {
  direction: OrderByDirection;
  field: Scalars['String'];
};

export type OrderPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Order>;
};

export type OrderUpdateInput = {
  customerId?: InputMaybe<Scalars['ObjectId']>;
  locations?: InputMaybe<Array<ShipmentLocationInput>>;
  orderNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
};

export type OrgMaintenanceTask = {
  _id: Scalars['String'];
  alertBeforeDays?: Maybe<Scalars['Int']>;
  assignedTo?: Maybe<Scalars['String']>;
  assignedToUser?: Maybe<OrgUser>;
  endDate?: Maybe<Scalars['DateTime']>;
  label: Scalars['String'];
  recurrence?: Maybe<OrgMaintenanceTaskRecurrence>;
  startDate: Scalars['DateTime'];
  status?: Maybe<MaintenanceTaskStatus>;
};

export type OrgMaintenanceTaskInput = {
  alertBeforeDays?: InputMaybe<Scalars['Int']>;
  assignedTo?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  label: Scalars['String'];
  recurrence?: InputMaybe<OrgMaintenanceTaskRecurrenceInput>;
  startDate: Scalars['DateTime'];
  status?: InputMaybe<MaintenanceTaskStatus>;
};

export type OrgMaintenanceTaskPaginatedResult = {
  count: Scalars['Int'];
  data: Array<OrgMaintenanceTask>;
};

export type OrgMaintenanceTaskRecurrence = {
  frequency: OrgMaintenanceTaskRecurrenceFrequency;
  interval: Scalars['Float'];
};

export enum OrgMaintenanceTaskRecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type OrgMaintenanceTaskRecurrenceInput = {
  frequency: OrgMaintenanceTaskRecurrenceFrequency;
  interval: Scalars['Float'];
};

export type OrgMaintenanceTaskUpdateInput = {
  alertBeforeDays?: InputMaybe<Scalars['Int']>;
  assignedTo?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  label?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<OrgMaintenanceTaskRecurrenceInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<MaintenanceTaskStatus>;
};

export type OrgUser = {
  _id: Scalars['String'];
  attributes: UserAttributes;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  roles: Array<KeycloakUserRole>;
  username: Scalars['String'];
};

export type OrgUserCreatedEvent = {
  name: Events;
  payload: OrgUserCreatedEventPayload;
};

export type OrgUserCreatedEventPayload = {
  orgUser: User;
  organizationId: Scalars['String'];
};

export type OrgUserDeletedEvent = {
  name: Events;
  payload: OrgUserDeletedEventPayload;
};

export type OrgUserDeletedEventPayload = {
  orgUser: User;
  organizationId: Scalars['String'];
};

export type OrgUserPaginatedResult = {
  count: Scalars['Int'];
  data: Array<OrgUser>;
};

export type OrgUserRolesUpdatedEvent = {
  name: Events;
  payload: OrgUserRolesUpdatedEventPayload;
};

export type OrgUserRolesUpdatedEventPayload = {
  orgUser: User;
  organizationId: Scalars['String'];
};

export type OrgUserUpdateInput = {
  attributes?: InputMaybe<UserAttributesInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<KeycloakUserRoleInput>>;
  username?: InputMaybe<Scalars['String']>;
};

export type Organization = {
  _id?: Maybe<Scalars['String']>;
  _organization: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  /** @deprecated Use company fields directly */
  attributes: KeycloakOrganizationAttributes;
  contactFullname?: Maybe<Scalars['String']>;
  /** @deprecated This field is the same as name */
  displayName: Scalars['String'];
  dotNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['Email']>;
  /** @deprecated Use _id instead */
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  /** @deprecated This field should not be used by any client. The realm is the same accross all orgs */
  realm: Scalars['String'];
  taxId?: Maybe<Scalars['String']>;
};

export type OrganizationDocument = {
  _id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type OrganizationDocumentUpdateInput = {
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type OrganizationSettings = {
  _id?: Maybe<Scalars['String']>;
  dispatching?: Maybe<DispatchingSettings>;
  general?: Maybe<GeneralSettings>;
  invoicing?: Maybe<InvoicingSettings>;
  name?: Maybe<Scalars['String']>;
  ratecon?: Maybe<RateconSettings>;
  transactionTemplates?: Maybe<Array<TransactionInputObject>>;
};

export type OrganizationSettingsInput = {
  _id?: InputMaybe<Scalars['String']>;
  dispatching?: InputMaybe<DispatchingSettingsInput>;
  general?: InputMaybe<GeneralSettingsInput>;
  invoicing?: InputMaybe<InvoicingSettingsInput>;
  name?: InputMaybe<Scalars['String']>;
  ratecon?: InputMaybe<RateconSettingsInput>;
  transactionTemplates?: InputMaybe<Array<TransactionInput>>;
};

export type OrganizationUpdateInput = {
  address?: InputMaybe<Scalars['String']>;
  contactFullname?: InputMaybe<Scalars['String']>;
  dotNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['Email']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type PartialShipment = {
  _id?: Maybe<Scalars['String']>;
  /** Additional trailer types that can be used for the shipment */
  additionalTrailerTypes?: Maybe<Array<TrailerType>>;
  /** Carriers assigned to the shipment */
  assignedCarriers?: Maybe<Array<ShipmentCarrierAssignment>>;
  /**
   * Bill of lading number for the shipment
   * @deprecated Use billfOfLadingNumbers instead
   */
  billOfLadingNumber?: Maybe<Scalars['String']>;
  /** Bill of lading numbers for the shipment */
  billOfLadingNumbers?: Maybe<Array<Scalars['String']>>;
  /**
   * DEPRECATED: Charges associated with the shipment. Charges are now stored on invoices and resolved via GraphQL. This field is no longer updated and exists only for backward compatibility.
   * @deprecated Charges are now stored on invoices. Use the charges field resolved from the invoice instead. This field is maintained for backward compatibility only and will be removed in a future version.
   */
  charges?: Maybe<Array<ShipmentCharge>>;
  /** For a recurrent or split shipment, the IDs of the child shipments */
  childShipmentIds?: Maybe<Array<Scalars['String']>>;
  /** Type of commodity being shipped. This affects what trailer types can be used */
  commodityType?: Maybe<ShipmentCommodityType>;
  /** Constraints that must be satisfied for the shipment */
  constraints?: Maybe<Array<ShipmentConstraint>>;
  /** ID of the user who created the shipment */
  createdBy?: Maybe<Scalars['String']>;
  /** Custom fields associated with the shipment */
  customFields?: Maybe<Array<CustomField>>;
  /** ID of the customer for whom the shipment is created */
  customer?: Maybe<BusinessEntity>;
  /** For shipments recurring daily, the number of rotations per day */
  dailyRotationCount?: Maybe<Scalars['Float']>;
  /** Documents associated with the shipment */
  documents?: Maybe<Array<ShipmentDocument>>;
  /** Events loged by the driver for this shipment */
  events?: Maybe<Array<ShipmentEvent>>;
  /** Expenses associated with the shipment */
  expenses?: Maybe<Array<Transaction>>;
  /** IDs of the groups the shipment is associated with */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Whether the shipment is applicable for charge order cancellation */
  isApplicableChargeOrderCancellation?: Maybe<Scalars['Boolean']>;
  /** Set for child shipments of a master shipment with rotations */
  isFromRotation?: Maybe<Scalars['Boolean']>;
  /** Whether the shipment is a child of a split shipment */
  isFromSplit?: Maybe<Scalars['Boolean']>;
  /** Set to true for child shipments created from a recurrence pattern */
  isRecurrence?: Maybe<Scalars['Boolean']>;
  /** Whether the shipment is a split shipment or not */
  isSplit?: Maybe<Scalars['Boolean']>;
  /** Issues reported by the driver for this shipment */
  issues?: Maybe<Array<ShipmentIssue>>;
  /** Full truck load or less than truck load shipment type. Full truck load shipments can't be mixed with other shipments on the same trip */
  loadType?: Maybe<LoadType>;
  /** Notes associated with the shipment */
  notes?: Maybe<Array<ShipmentNote>>;
  /** Order the shipment is created from */
  order?: Maybe<Order>;
  /** ID of the order the shipment is created from */
  orderId?: Maybe<Scalars['ObjectId']>;
  /** For child shipments of a recurrent shipment, the master shipment */
  parentShipment?: Maybe<Shipment>;
  /**
   * Purchase order number for the shipment
   * @deprecated Use purchaseOrderNumbers instead
   */
  postOfficeNumber?: Maybe<Scalars['String']>;
  /** Previous shipment number (e.g., temporary number before transition to permanent) */
  previousShipmentNumber?: Maybe<Scalars['String']>;
  /** Purchase order numbers for the shipment */
  purchaseOrderNumbers?: Maybe<Array<Scalars['String']>>;
  /** Rate confirmation numbers for the shipment */
  rateConNumbers?: Maybe<Array<Scalars['String']>>;
  /** For cancelled shipments, the reason for cancellation */
  reasonForCancellation?: Maybe<Scalars['String']>;
  /** For recurrent shipments, the recurrence pattern */
  recurrence?: Maybe<ShipmentRecurrence>;
  /**
   * Reference number for the shipment
   * @deprecated Use referenceNumbers instead
   */
  referenceNumber?: Maybe<Scalars['String']>;
  /** Reference numbers for the shipment */
  referenceNumbers?: Maybe<Array<Scalars['String']>>;
  /** Set for child shipments of a master shipment with rotations */
  rotationIndex?: Maybe<Scalars['Float']>;
  /** Route information for the shipment */
  route?: Maybe<ShipmentRoute>;
  /** Locations that need to be visited for the shipment */
  shipmentLocations?: Maybe<Array<ShipmentLocation>>;
  /** Auto incremented number for the shipment */
  shipmentNumber?: Maybe<Scalars['String']>;
  /** Current status of the shipment */
  status?: Maybe<Status>;
  /** Tags associated with the shipment */
  tags?: Maybe<Array<Scalars['String']>>;
  /** Ticket numbers for the shipment */
  ticketNumbers?: Maybe<Array<Scalars['String']>>;
  /** Whether tracking emails have been sent for the shipment */
  trackingEmailsSent?: Maybe<Scalars['Boolean']>;
  /** Type of trailer required for the shipment */
  trailerType?: Maybe<TrailerType>;
  /** Trip information for the shipment */
  trip?: Maybe<ShipmentTrip>;
  /** ID of the trip the shipment is assigned to */
  tripId?: Maybe<Scalars['String']>;
};

export type PartialTrip = {
  _id?: Maybe<Scalars['String']>;
  additionalTrailers?: Maybe<Array<Trailer>>;
  carrier?: Maybe<BusinessEntity>;
  chassis?: Maybe<Chassis>;
  customFields?: Maybe<Array<CustomField>>;
  deadheadDistance?: Maybe<Scalars['Float']>;
  distanceToEnd?: Maybe<Scalars['Float']>;
  distanceToStart?: Maybe<Scalars['Float']>;
  driver?: Maybe<Driver>;
  driverPositions?: Maybe<Array<TripDriverPosition>>;
  etaFromPreviousTrip?: Maybe<Scalars['Float']>;
  etaStatus?: Maybe<EtaStatus>;
  etaToNextTrip?: Maybe<Scalars['Float']>;
  firstPickupTime?: Maybe<Scalars['DateTime']>;
  lastDropoffTime?: Maybe<Scalars['DateTime']>;
  lastTrafficCheck?: Maybe<Scalars['DateTime']>;
  lastTrailerLocation?: Maybe<Coordinates>;
  lastTrailerLocationDate?: Maybe<Scalars['DateTime']>;
  lastWeatherCheck?: Maybe<Scalars['DateTime']>;
  liveEtaUpdatedAt?: Maybe<Scalars['DateTime']>;
  loadStates?: Maybe<Array<LoadState>>;
  loadedDistance?: Maybe<Scalars['Float']>;
  payments?: Maybe<Array<TripPayment>>;
  polyline?: Maybe<Scalars['String']>;
  predictedLoadedDistance?: Maybe<Scalars['Float']>;
  routeDistance?: Maybe<Scalars['Float']>;
  shipmentLocations?: Maybe<Array<TripShipmentLocation>>;
  shipments?: Maybe<Array<Shipment>>;
  status?: Maybe<Status>;
  tags?: Maybe<Array<Scalars['String']>>;
  totalDistance?: Maybe<Scalars['Float']>;
  tractor?: Maybe<Tractor>;
  trailer?: Maybe<Trailer>;
  trailerCompartmentAssignments?: Maybe<Array<TrailerCompartmentAssignment>>;
  tripNumber?: Maybe<Scalars['String']>;
  violations?: Maybe<Array<TripViolation>>;
};

export enum PaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  CreditCard = 'CREDIT_CARD'
}

/** The period over which a payment applies */
export type PaymentPeriod = {
  end?: Maybe<Scalars['DateTime']>;
  repeatEvery: Scalars['Float'];
  start: Scalars['DateTime'];
  unit: PaymentPeriodUnit;
};

export type PaymentPeriodInput = {
  end?: InputMaybe<Scalars['DateTime']>;
  repeatEvery: Scalars['Float'];
  start: Scalars['DateTime'];
  unit: PaymentPeriodUnit;
};

export enum PaymentPeriodUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** A driver payment rule */
export type PaymentRule = {
  _id: Scalars['String'];
  amount: Scalars['Float'];
  driver?: Maybe<Driver>;
  method: DriverPaymentMethod;
  period?: Maybe<PaymentPeriod>;
};

export type PaymentRulePaginatedResult = {
  count: Scalars['Int'];
  data: Array<PaymentRule>;
};

export type PaymentRuleUpdateInput = {
  amount?: InputMaybe<Scalars['Float']>;
  driver?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<DriverPaymentMethod>;
  period?: InputMaybe<PaymentPeriodInput>;
};

export type Period = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type PeriodInput = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type PersistDrivingPeriodInput = {
  /** Distance in meters */
  distance?: InputMaybe<Scalars['Float']>;
  driverEldId?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  endKilometers?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  motiveId: Scalars['String'];
  startKilometers?: InputMaybe<Scalars['Float']>;
  startTime: Scalars['DateTime'];
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  vehicleEldId?: InputMaybe<Scalars['String']>;
};

export type PurchaseInput = {
  customerId: Scalars['ObjectId'];
  date: Scalars['DateTime'];
  dropoffLocation: CoordinatesInput;
  goodProfileId: Scalars['ObjectId'];
  quantity: Scalars['Float'];
  shipperId?: InputMaybe<Scalars['ObjectId']>;
  supplierId?: InputMaybe<Scalars['ObjectId']>;
};

export type Qualification = {
  _id: Scalars['String'];
  assetId: Scalars['ObjectId'];
  assetType: Scalars['String'];
  documents?: Maybe<Array<Document>>;
  endDate: Scalars['DateTime'];
  label: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
};

export type QualificationPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Qualification>;
};

export type QualificationUpdateInput = {
  assetId?: InputMaybe<Scalars['ObjectId']>;
  assetType?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<DocumentInput>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  label?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export enum QuantityType {
  Delivered = 'DELIVERED',
  Loaded = 'LOADED',
  Ordered = 'ORDERED'
}

export type Query = {
  assetLinkingByDriverId?: Maybe<AssetLinking>;
  assetLinkingById?: Maybe<AssetLinking>;
  assetLinkingByTractorId?: Maybe<AssetLinking>;
  assetLinkingByTrailerId?: Maybe<AssetLinking>;
  assetLinkings: AssetLinkingPaginatedResult;
  assignedTrips: TripPaginatedResult;
  billingRuleById: BillingRule;
  billingRules: BillingRulePaginatedResult;
  brokerById: Broker;
  brokers: BrokerPaginatedResult;
  bulkMetrics: Array<Array<Metric>>;
  businessEntities: BusinessEntityPaginatedResult;
  businessEntityByExternalId?: Maybe<BusinessEntity>;
  businessEntityById: BusinessEntity;
  chassis: ChassisPaginatedResult;
  chassisById: Chassis;
  customFieldDefinitionById: CustomFieldDefinition;
  customerById: Customer;
  customerOrderById: Order;
  customerOrders: OrderPaginatedResult;
  customerRateTables: RateTablePaginatedResult;
  customerShipments: ShipmentPaginatedResult;
  customers: CustomerPaginatedResult;
  cutomFieldDefinitions: CustomFieldDefinitionPaginatedResult;
  deductionRuleById: DeductionRule;
  deductionRules: DeductionRulePaginatedResult;
  driverByEldId?: Maybe<Driver>;
  driverById: Driver;
  driverByLicenseNumber?: Maybe<Driver>;
  driverRateTables: RateTablePaginatedResult;
  driverSettlementById?: Maybe<DriverSettlement>;
  driverSettlementByNumber: DriverSettlement;
  driverSettlements: DriverSettlementPaginatedResult;
  driverShiftAssignmentByDriverId?: Maybe<DriverShiftAssignment>;
  driverShiftAssignmentById?: Maybe<DriverShiftAssignment>;
  driverShiftAssignments: DriverShiftAssignmentPaginatedResult;
  driverShiftByDriverId?: Maybe<DriverShift>;
  driverShiftById?: Maybe<DriverShift>;
  driverShifts: DriverShiftPaginatedResult;
  drivers: DriverPaginatedResult;
  dwellTimeUptickById: DwellTimeUptick;
  dwellTimeUpticks: DwellTimeUptickPaginatedResult;
  extensionById: Extension;
  extensions: ExtensionPaginatedResult;
  extensionsMessages: Array<ExtensionMessage>;
  extensionsOperations: Array<ExtensionOperationWithExtensionId>;
  extensionsUIComponents: Array<ExtensionUiComponentWithExtensionInfo>;
  extensionsWidgets: Array<ExtensionWidgetWithExtensionInfo>;
  forecastingExecutionLogs: ForecastingExecutionLogPaginatedResult;
  forecastingNotifications: Array<ForecastingNotification>;
  goodProfileById: GoodProfile;
  goodProfileClassById?: Maybe<GoodProfileClass>;
  goodProfileClasses: GoodProfileClassPaginatedResult;
  goodProfiles: GoodProfilePaginatedResult;
  groupById: Group;
  groups: GroupPaginatedResult;
  invoiceById: Invoice;
  invoiceByInvoiceNumber?: Maybe<Invoice>;
  invoiceByShipmentId?: Maybe<Invoice>;
  invoices: InvoicePaginatedResult;
  isSubscribed: Scalars['Boolean'];
  loadBoardLoadById?: Maybe<Shipment>;
  loadBoardLoads: LoadBoardSearchResultPaginatedResult;
  maintenanceTaskByDriverId?: Maybe<MaintenanceTask>;
  maintenanceTaskById?: Maybe<MaintenanceTask>;
  maintenanceTasks: MaintenanceTaskPaginatedResult;
  metabaseEmbedToken: MetabaseEmbedToken;
  metrics: Array<Metric>;
  myDocuments: Array<OrganizationDocument>;
  myDriverSettlements: MyDriverSettlementPaginatedResult;
  myOrganization: Organization;
  nextInvoiceNumber: Scalars['Int'];
  orderById: Order;
  orders: OrderPaginatedResult;
  orgMaintenanceTaskById?: Maybe<OrgMaintenanceTask>;
  orgMaintenanceTasks: OrgMaintenanceTaskPaginatedResult;
  orgUserById: OrgUser;
  orgUsers: OrgUserPaginatedResult;
  organizationSettings?: Maybe<OrganizationSettings>;
  organizations: Array<Organization>;
  organizationsForStage: Array<Organization>;
  ownedTrailerTypes: Array<TrailerType>;
  paymentRuleById: PaymentRule;
  paymentRules: PaymentRulePaginatedResult;
  qualificationByDriverId?: Maybe<Qualification>;
  qualificationById?: Maybe<Qualification>;
  qualifications: QualificationPaginatedResult;
  rateTableById: RateTable;
  rateTables: RateTablePaginatedResult;
  reasonCodeById?: Maybe<ReasonCode>;
  reasonCodes: ReasonCodePaginatedResult;
  reasonCodesByShipment: ReasonCodePaginatedResult;
  reasonCodesByTrip: ReasonCodePaginatedResult;
  receiverById: Receiver;
  receiverForecastById: ReceiverForecast;
  receiverForecasts: ReceiverForecastPaginatedResult;
  receivers: ReceiverPaginatedResult;
  relationshipByDriverId?: Maybe<Relationship>;
  relationshipById?: Maybe<Relationship>;
  relationships: RelationshipPaginatedResult;
  reportData: ReportData;
  reportingDashboard?: Maybe<Report>;
  reportingDashboardEmbedToken: MetabaseEmbedToken;
  roles: Array<KeycloakUserRole>;
  savedReport?: Maybe<SavedReport>;
  savedReports: Array<SavedReport>;
  shipmentById: Shipment;
  shipments: ShipmentPaginatedResult;
  shipperById: Shipper;
  shippers: ShipperPaginatedResult;
  storageFacilityAverageDailySales: Array<AverageSales>;
  storageFacilityReadingById: StorageFacilityReading;
  storageFacilityReadings: StorageFacilityReadingPaginatedResult;
  storageFacilitySales: Array<StorageFacilityDateRangeSales>;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  supplierContractById: SupplierContract;
  supplierContracts: SupplierContractPaginatedResult;
  trackShipment: ShipmentTrackingInfos;
  trackShipmentById: ShipmentTrackingInfos;
  tractorByEldId?: Maybe<Tractor>;
  tractorById: Tractor;
  tractorByLicenseNumber?: Maybe<Tractor>;
  tractorByPlateNumber?: Maybe<Tractor>;
  tractorBySerialNumber?: Maybe<Tractor>;
  tractors: TractorPaginatedResult;
  trailerById: Trailer;
  trailerEventById: TrailerEvent;
  trailerEvents: TrailerEventPaginatedResult;
  trailers: TrailerPaginatedResult;
  transactionById: Transaction;
  transactions: TransactionPaginatedResult;
  tripById?: Maybe<Trip>;
  tripPositions: Array<TripDriverPosition>;
  trips: TripPaginatedResult;
};


export type QueryAssetLinkingByDriverIdArgs = {
  driverId: Scalars['ObjectId'];
};


export type QueryAssetLinkingByIdArgs = {
  id: Scalars['String'];
};


export type QueryAssetLinkingByTractorIdArgs = {
  tractorId: Scalars['ObjectId'];
};


export type QueryAssetLinkingByTrailerIdArgs = {
  trailerId: Scalars['ObjectId'];
};


export type QueryAssetLinkingsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAssignedTripsArgs = {
  driver?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSON']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TripSort>;
  status?: InputMaybe<Status>;
  take?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryBillingRuleByIdArgs = {
  id: Scalars['String'];
};


export type QueryBillingRulesArgs = {
  customer?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBrokerByIdArgs = {
  id: Scalars['String'];
};


export type QueryBrokersArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBulkMetricsArgs = {
  aggregateBy: Array<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  types: Array<MetricType>;
};


export type QueryBusinessEntitiesArgs = {
  businessEntityTypes?: InputMaybe<Array<BusinessEntityType>>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBusinessEntityByExternalIdArgs = {
  externalId: Scalars['String'];
};


export type QueryBusinessEntityByIdArgs = {
  id: Scalars['String'];
};


export type QueryChassisArgs = {
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryChassisByIdArgs = {
  id: Scalars['String'];
};


export type QueryCustomFieldDefinitionByIdArgs = {
  id: Scalars['String'];
};


export type QueryCustomerByIdArgs = {
  id: Scalars['String'];
};


export type QueryCustomerOrderByIdArgs = {
  id: Scalars['String'];
};


export type QueryCustomerOrdersArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Status>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerRateTablesArgs = {
  customerId?: InputMaybe<Scalars['ObjectId']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  rateType?: InputMaybe<RateTableType>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerShipmentsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Status>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCutomFieldDefinitionsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDeductionRuleByIdArgs = {
  id: Scalars['String'];
};


export type QueryDeductionRulesArgs = {
  driver?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDriverByEldIdArgs = {
  eldId: Scalars['String'];
};


export type QueryDriverByIdArgs = {
  id: Scalars['String'];
};


export type QueryDriverByLicenseNumberArgs = {
  licenseNumber: Scalars['String'];
};


export type QueryDriverRateTablesArgs = {
  driverId?: InputMaybe<Scalars['ObjectId']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  rateType?: InputMaybe<RateTableType>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDriverSettlementByIdArgs = {
  id: Scalars['String'];
};


export type QueryDriverSettlementByNumberArgs = {
  driverSettlementNumber: Scalars['String'];
};


export type QueryDriverSettlementsArgs = {
  driver?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<DriverSettlementStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDriverShiftAssignmentByDriverIdArgs = {
  driverId: Scalars['ObjectId'];
};


export type QueryDriverShiftAssignmentByIdArgs = {
  id: Scalars['String'];
};


export type QueryDriverShiftAssignmentsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDriverShiftByDriverIdArgs = {
  driverId: Scalars['ObjectId'];
};


export type QueryDriverShiftByIdArgs = {
  id: Scalars['String'];
};


export type QueryDriverShiftsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDriversArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DriverWhere>;
};


export type QueryDwellTimeUptickByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryDwellTimeUpticksArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryExtensionByIdArgs = {
  id: Scalars['String'];
};


export type QueryExtensionsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryExtensionsOperationsArgs = {
  context: ExtensionOperationContext;
};


export type QueryExtensionsUiComponentsArgs = {
  type: ExtensionUiComponentType;
};


export type QueryExtensionsWidgetsArgs = {
  context: ExtensionWidgetContext;
};


export type QueryForecastingExecutionLogsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  receiverForecastId: Scalars['ObjectId'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryForecastingNotificationsArgs = {
  receiverId?: InputMaybe<Scalars['ObjectId']>;
};


export type QueryGoodProfileByIdArgs = {
  id: Scalars['String'];
};


export type QueryGoodProfileClassByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryGoodProfileClassesArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGoodProfilesArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGroupByIdArgs = {
  id: Scalars['String'];
};


export type QueryGroupsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryInvoiceByIdArgs = {
  id: Scalars['String'];
};


export type QueryInvoiceByInvoiceNumberArgs = {
  invoiceNumber: Scalars['String'];
};


export type QueryInvoiceByShipmentIdArgs = {
  shipmentId: Scalars['String'];
};


export type QueryInvoicesArgs = {
  customer?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<InvoiceStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLoadBoardLoadByIdArgs = {
  id: Scalars['String'];
};


export type QueryLoadBoardLoadsArgs = {
  searchCriteria: LoadBoardSearchCriteria;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMaintenanceTaskByDriverIdArgs = {
  driverId: Scalars['ObjectId'];
};


export type QueryMaintenanceTaskByIdArgs = {
  id: Scalars['String'];
};


export type QueryMaintenanceTasksArgs = {
  assetId?: InputMaybe<Scalars['ObjectId']>;
  assetType?: InputMaybe<TripAssetTypes>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<MaintenanceTaskStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMetabaseEmbedTokenArgs = {
  input: MetabaseEmbedTokenInput;
};


export type QueryReportingDashboardEmbedTokenArgs = {
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryMetricsArgs = {
  aggregateBy: Array<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
  type: MetricType;
};


export type QueryMyDriverSettlementsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderByIdArgs = {
  id: Scalars['String'];
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Status>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrgMaintenanceTaskByIdArgs = {
  id: Scalars['String'];
};


export type QueryOrgMaintenanceTasksArgs = {
  assetId?: InputMaybe<Scalars['ObjectId']>;
  assetType?: InputMaybe<TripAssetTypes>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<MaintenanceTaskStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrgUserByIdArgs = {
  id: Scalars['String'];
};


export type QueryOrgUsersArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrganizationsForStageArgs = {
  stage: Scalars['String'];
};


export type QueryPaymentRuleByIdArgs = {
  id: Scalars['String'];
};


export type QueryPaymentRulesArgs = {
  driver?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryQualificationByDriverIdArgs = {
  driverId: Scalars['ObjectId'];
};


export type QueryQualificationByIdArgs = {
  id: Scalars['String'];
};


export type QueryQualificationsArgs = {
  assetId?: InputMaybe<Scalars['ObjectId']>;
  assetType?: InputMaybe<TripAssetTypes>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryRateTableByIdArgs = {
  id: Scalars['String'];
};


export type QueryRateTablesArgs = {
  entityId?: InputMaybe<Scalars['ObjectId']>;
  entityType?: InputMaybe<RateTableEntityType>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  rateType?: InputMaybe<RateTableType>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryReasonCodeByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryReasonCodesArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryReasonCodesByShipmentArgs = {
  shipmentId: Scalars['ObjectId'];
};


export type QueryReasonCodesByTripArgs = {
  tripId: Scalars['ObjectId'];
};


export type QueryReceiverByIdArgs = {
  id: Scalars['String'];
};


export type QueryReceiverForecastByIdArgs = {
  id: Scalars['String'];
};


export type QueryReceiverForecastsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryReceiversArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryRelationshipByDriverIdArgs = {
  driverId: Scalars['ObjectId'];
};


export type QueryRelationshipByIdArgs = {
  id: Scalars['String'];
};


export type QueryRelationshipsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryReportDataArgs = {
  filter?: InputMaybe<Scalars['ReportFilter']>;
  lang: Scalars['String'];
  period: PeriodInput;
  reportType: ReportType;
};


export type QuerySavedReportArgs = {
  id: Scalars['ObjectId'];
};


export type QueryShipmentByIdArgs = {
  id: Scalars['String'];
};


export type QueryShipmentsArgs = {
  excludePastShipments?: InputMaybe<Scalars['Boolean']>;
  excludeRecurrentShipments?: InputMaybe<Scalars['Boolean']>;
  excludeRotationShipments?: InputMaybe<Scalars['Boolean']>;
  excludeSplitShipments?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['JSON']>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  parentShipmentId?: InputMaybe<Scalars['String']>;
  plannedForToday?: InputMaybe<Scalars['Boolean']>;
  receiverId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ShipmentSort>;
  status?: InputMaybe<Status>;
  statuses?: InputMaybe<Array<Status>>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryShipperByIdArgs = {
  id: Scalars['String'];
};


export type QueryShippersArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryStorageFacilityAverageDailySalesArgs = {
  receiverId: Scalars['ObjectId'];
  storageFacilityId: Scalars['String'];
};


export type QueryStorageFacilityReadingByIdArgs = {
  id: Scalars['String'];
};


export type QueryStorageFacilityReadingsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  receiverId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  storageFacilityId?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryStorageFacilitySalesArgs = {
  dateRanges: Array<DateRangeInput>;
  storageFacilityId: Scalars['String'];
};


export type QuerySupplierContractByIdArgs = {
  id: Scalars['String'];
};


export type QuerySupplierContractsArgs = {
  customerId?: InputMaybe<Scalars['ObjectId']>;
  filter?: InputMaybe<Scalars['JSON']>;
  goodProfileId?: InputMaybe<Scalars['ObjectId']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  shipperId?: InputMaybe<Scalars['ObjectId']>;
  skip?: InputMaybe<Scalars['Int']>;
  supplierId?: InputMaybe<Scalars['ObjectId']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTrackShipmentArgs = {
  token: Scalars['String'];
};


export type QueryTrackShipmentByIdArgs = {
  shipmentId: Scalars['ObjectId'];
};


export type QueryTractorByEldIdArgs = {
  eldId: Scalars['String'];
};


export type QueryTractorByIdArgs = {
  id: Scalars['String'];
};


export type QueryTractorByLicenseNumberArgs = {
  licenseNumber: Scalars['String'];
};


export type QueryTractorByPlateNumberArgs = {
  plateNumber: Scalars['String'];
};


export type QueryTractorBySerialNumberArgs = {
  serialNumber: Scalars['String'];
};


export type QueryTractorsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTrailerByIdArgs = {
  id: Scalars['String'];
};


export type QueryTrailerEventByIdArgs = {
  id: Scalars['String'];
};


export type QueryTrailerEventsArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTrailersArgs = {
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTransactionByIdArgs = {
  id: Scalars['String'];
};


export type QueryTransactionsArgs = {
  customer?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTripByIdArgs = {
  id: Scalars['String'];
};


export type QueryTripPositionsArgs = {
  tripId: Scalars['String'];
};


export type QueryTripsArgs = {
  driver?: InputMaybe<Scalars['String']>;
  excludeCarrierAssigned?: InputMaybe<Scalars['Boolean']>;
  excludeDriverAssigned?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem>>;
  plannedForToday?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TripSort>;
  status?: InputMaybe<Status>;
  take?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** A unified rate table for automated billing and driver settlements */
export type RateTable = {
  _id: Scalars['String'];
  /** Matrix of rate cells. For 1D tables, use cells[i][0]. For 2D tables, use cells[i][j] where i=row, j=column */
  cells: Array<Array<RateTableCell>>;
  /** Only required for two-dimensional tables */
  columnAxis?: Maybe<RateTableAxis>;
  createdAt: Scalars['DateTime'];
  customer?: Maybe<BusinessEntity>;
  description?: Maybe<Scalars['String']>;
  driver?: Maybe<Driver>;
  /** End of the effective window (inclusive, 23:59). Blank means always in effect. */
  effectiveEndDate?: Maybe<Scalars['DateTime']>;
  /** Start of the effective window (inclusive, 00:00). Blank means always in effect. */
  effectiveStartDate?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['ObjectId'];
  entityType: RateTableEntityType;
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  priority?: Maybe<Scalars['Float']>;
  rateType: RateTableType;
  referenceNumber?: Maybe<Scalars['String']>;
  rowAxis: RateTableAxis;
  updatedAt: Scalars['DateTime'];
};

export type RateTableAxis = {
  conditions: Array<BillingRuleCondition>;
};

export type RateTableAxisInput = {
  conditions: Array<BillingRuleConditionInput>;
};

export type RateTableCell = {
  rates: Array<BillingRate>;
};

export type RateTableCellInput = {
  rates: Array<BillingRateInput>;
};

export enum RateTableEntityType {
  Customer = 'CUSTOMER',
  Driver = 'DRIVER'
}

export type RateTablePaginatedResult = {
  count: Scalars['Int'];
  data: Array<RateTable>;
};

export enum RateTableType {
  Accessorial = 'ACCESSORIAL',
  Bonus = 'BONUS',
  Deduction = 'DEDUCTION',
  OrderCancellation = 'ORDER_CANCELLATION',
  Primary = 'PRIMARY',
  Tax = 'TAX'
}

export type RateTableUpdateInput = {
  /** Matrix of rate cells. For 1D tables, use cells[i][0]. For 2D tables, use cells[i][j] where i=row, j=column */
  cells?: InputMaybe<Array<Array<RateTableCellInput>>>;
  /** Only required for two-dimensional tables */
  columnAxis?: InputMaybe<RateTableAxisInput>;
  description?: InputMaybe<Scalars['String']>;
  /** End of the effective window (inclusive, 23:59). Blank means always in effect. */
  effectiveEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Start of the effective window (inclusive, 00:00). Blank means always in effect. */
  effectiveStartDate?: InputMaybe<Scalars['DateTime']>;
  entityId?: InputMaybe<Scalars['ObjectId']>;
  entityType?: InputMaybe<RateTableEntityType>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
  rateType?: InputMaybe<RateTableType>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  rowAxis?: InputMaybe<RateTableAxisInput>;
};

export type RateconSettings = {
  bodyTemplate?: Maybe<Scalars['String']>;
  /** @deprecated Use Organization.address instead */
  companyAddress?: Maybe<Scalars['String']>;
  /** @deprecated Use Organization.email instead */
  companyEmail?: Maybe<Scalars['String']>;
  /** @deprecated Use Organization.phoneNumber instead */
  companyPhone?: Maybe<Scalars['String']>;
  subjectTemplate?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
};

export type RateconSettingsInput = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyEmail?: InputMaybe<Scalars['String']>;
  companyPhone?: InputMaybe<Scalars['String']>;
  subjectTemplate?: InputMaybe<Scalars['String']>;
  termsAndConditions?: InputMaybe<Scalars['String']>;
};

export type Reading = {
  date: Scalars['DateTime'];
  level: Scalars['Float'];
  volumeType?: Maybe<VolumeType>;
};

export type ReadingInput = {
  date: Scalars['DateTime'];
  level: Scalars['Float'];
  volumeType?: InputMaybe<VolumeType>;
};

export type ReadingsFileConfiguration = {
  dateColumn: Scalars['String'];
  dateFormat: Scalars['String'];
  levelColumn: Scalars['String'];
  /** The threshold for the difference between the last reading and the expected reading to trigger an error, in percentage */
  readingDeviationCriticalThreshold?: Maybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the expected reading to trigger an error, in percentage */
  readingDeviationDangerThreshold?: Maybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the expected reading to trigger a warning, in percentage */
  readingDeviationWarningThreshold?: Maybe<Scalars['Float']>;
  runoutCriticalThreshold?: Maybe<Scalars['Float']>;
  runoutDangerThreshold?: Maybe<Scalars['Float']>;
  runoutWarningThreshold?: Maybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the current reading to trigger an error, in minutes */
  staleReadingCriticalThreshold?: Maybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the current reading to trigger an error, in minutes */
  staleReadingDangerThreshold?: Maybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the current reading to trigger a warning, in minutes */
  staleReadingWarningThreshold?: Maybe<Scalars['Float']>;
  storeColumn?: Maybe<Scalars['String']>;
  tankIdColumn: Scalars['String'];
  timeColumn: Scalars['String'];
  timeFormat: Scalars['String'];
};

export type ReadingsFileConfigurationInput = {
  dateColumn: Scalars['String'];
  dateFormat: Scalars['String'];
  levelColumn: Scalars['String'];
  /** The threshold for the difference between the last reading and the expected reading to trigger an error, in percentage */
  readingDeviationCriticalThreshold?: InputMaybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the expected reading to trigger an error, in percentage */
  readingDeviationDangerThreshold?: InputMaybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the expected reading to trigger a warning, in percentage */
  readingDeviationWarningThreshold?: InputMaybe<Scalars['Float']>;
  runoutCriticalThreshold?: InputMaybe<Scalars['Float']>;
  runoutDangerThreshold?: InputMaybe<Scalars['Float']>;
  runoutWarningThreshold?: InputMaybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the current reading to trigger an error, in minutes */
  staleReadingCriticalThreshold?: InputMaybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the current reading to trigger an error, in minutes */
  staleReadingDangerThreshold?: InputMaybe<Scalars['Float']>;
  /** The threshold for the difference between the last reading and the current reading to trigger a warning, in minutes */
  staleReadingWarningThreshold?: InputMaybe<Scalars['Float']>;
  storeColumn?: InputMaybe<Scalars['String']>;
  tankIdColumn: Scalars['String'];
  timeColumn: Scalars['String'];
  timeFormat: Scalars['String'];
};

export type ReasonCode = {
  _id: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  shipmentId?: Maybe<Scalars['ObjectId']>;
  tripId?: Maybe<Scalars['ObjectId']>;
  type: ReasonCodeType;
  updatedAt: Scalars['DateTime'];
};

export type ReasonCodePaginatedResult = {
  count: Scalars['Int'];
  data: Array<ReasonCode>;
};

/** Types of reason codes for exceptional situations */
export enum ReasonCodeType {
  Customer = 'CUSTOMER',
  Damage = 'DAMAGE',
  Delay = 'DELAY',
  DeliveredQuantityMismatch = 'DELIVERED_QUANTITY_MISMATCH',
  LoadedQuantityMismatch = 'LOADED_QUANTITY_MISMATCH',
  Mechanical = 'MECHANICAL',
  Other = 'OTHER',
  Traffic = 'TRAFFIC',
  Weather = 'WEATHER'
}

export type ReasonCodeUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ObjectId'];
  locationId?: InputMaybe<Scalars['String']>;
  shipmentId?: InputMaybe<Scalars['ObjectId']>;
  tripId?: InputMaybe<Scalars['ObjectId']>;
};

/** A Receiver Business entity */
export type Receiver = {
  _id: Scalars['String'];
  /** Token used for access to the customer portal */
  accessToken?: Maybe<Scalars['String']>;
  /** Additional contacts for the business entity. */
  additionalContacts?: Maybe<Array<Contact>>;
  /** Additional types for the business entity (e.g. a business entity could be both a customer and shipper). */
  additionalTypes?: Maybe<Array<BusinessEntityType>>;
  /** Physical address of the business entity. */
  address: Address;
  /** Timezone of the business entity address. If not provided, it will be inferred from the address. */
  addressTimezone?: Maybe<Scalars['String']>;
  /** Billing address for the business entity. */
  billingAddress?: Maybe<TextualAddress>;
  /** Billing email for the business entity. Invoices are sent here */
  billingEmail?: Maybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: Maybe<InvoiceConsolidationCriteria>;
  /** Billing terms for the business entity in days. */
  billingTermsDay?: Maybe<Scalars['Float']>;
  billingWeekStartsOn?: Maybe<Scalars['Float']>;
  /** Unique code identifying the business entity. */
  code?: Maybe<Scalars['String']>;
  /** Pre-assigned commodity profiles for this receiver. Resolved by field resolver. */
  commodities?: Maybe<Array<GoodProfile>>;
  commodityIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Primary contact for the business entity. */
  contact: Contact;
  /** For carriers only, the credit terms they offer. */
  creditTerms?: Maybe<Scalars['String']>;
  /** Custom fields for the business entity */
  customFields?: Maybe<Array<CustomField>>;
  defaultReferenceNumbers?: Maybe<Array<DefaultReferenceNumber>>;
  /** The default shipper for this business entity */
  defaultShipper?: Maybe<BusinessEntity>;
  /** ID of the default shipper for this business entity. This is used by default when a shipment is sent to this business entity */
  defaultShipperId?: Maybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: Maybe<Array<DocumentRequirement>>;
  /** Documents for the business entity */
  documents?: Maybe<Array<Document>>;
  /** DOT Number for carriers and brokers */
  dotNumber?: Maybe<Scalars['String']>;
  /** ID of the business entity in an external system. */
  externalId?: Maybe<Scalars['String']>;
  /** Federal ID for business entities */
  federalId?: Maybe<Scalars['String']>;
  goodInventoryItems?: Maybe<Array<GoodInventoryItem>>;
  /** IDs of the groups that this business entity belongs to */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** MC Number for carriers */
  mcNumber?: Maybe<Scalars['String']>;
  /** Legal name of the business entity. */
  name: Scalars['String'];
  notes?: Maybe<Array<BusinessEntityNote>>;
  /** Opening schedules for the business entity. */
  openingSchedules?: Maybe<Array<OpeningSchedule>>;
  /** The business entity that this business entity belongs to */
  parentBusinessEntity?: Maybe<BusinessEntity>;
  /** ID of the business entity that this business entity belongs to. Used for receiver/customer relations for example */
  parentBusinessEntityId?: Maybe<Scalars['ObjectId']>;
  /** The business entity that we need to pay to. Used for carriers */
  payToProfile?: Maybe<BusinessEntity>;
  /** ID of the business entity that we need to pay to. Used for carriers */
  payToProfileId?: Maybe<Scalars['ObjectId']>;
  /** Planned dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  /** For customers and brokers, the types of reference numbers they use in orders. */
  referenceNumberTypes?: Maybe<Array<ShipmentReferenceNumberType>>;
  /** Remit address for the business entity. Where payments are sent. */
  remitAddress?: Maybe<TextualAddress>;
  /** Remit company name for the business entity */
  remitCompanyName?: Maybe<Scalars['String']>;
  /** Remit email for the business entity */
  remitEmail?: Maybe<Scalars['String']>;
  /** Shipmentp documents to receive via email on completion */
  shipmentDocumentsToReceive?: Maybe<Array<Scalars['String']>>;
  /** SCAC code for carriers */
  standardCarrierAlphaCode?: Maybe<Scalars['String']>;
  status: AssetStatus;
  /** Storage facilities for the business entity. Used for tanks, warehouses, etc */
  storageFacilities?: Maybe<Array<StorageFacility>>;
  /** Tags for the business entity */
  tags?: Maybe<Array<Scalars['String']>>;
  /** For carriers only, the types of trailers they have. */
  trailerTypes?: Maybe<Array<TrailerType>>;
  /** The type of business entity. */
  type: BusinessEntityType;
};


/** A Receiver Business entity */
export type ReceiverStorageFacilitiesArgs = {
  includeLinkedFacilities?: InputMaybe<Scalars['Boolean']>;
};

export type ReceiverForecast = {
  _id: Scalars['String'];
  automationConfig?: Maybe<AutomationConfig>;
  models: Array<ForecastingModel>;
  readingsFileConfiguration?: Maybe<ReadingsFileConfiguration>;
  receiver?: Maybe<BusinessEntity>;
  receiverId: Scalars['ObjectId'];
  trailerProfile: TrailerProfile;
};

export type ReceiverForecastPaginatedResult = {
  count: Scalars['Int'];
  data: Array<ReceiverForecast>;
};

export type ReceiverForecastUpdateInput = {
  automationConfig?: InputMaybe<AutomationConfigInput>;
  models?: InputMaybe<Array<ForecastingModelInput>>;
  readingsFileConfiguration?: InputMaybe<ReadingsFileConfigurationInput>;
  receiverId?: InputMaybe<Scalars['ObjectId']>;
  trailerProfile?: InputMaybe<TrailerProfileInput>;
};

export type ReceiverPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Receiver>;
};

export type Relationship = {
  _id: Scalars['String'];
  commodities?: Maybe<Array<GoodProfile>>;
  commodityIds?: Maybe<Array<Scalars['ObjectId']>>;
  customerIds?: Maybe<Array<Scalars['ObjectId']>>;
  customers?: Maybe<Array<BusinessEntity>>;
  receiverIds?: Maybe<Array<Scalars['ObjectId']>>;
  receivers?: Maybe<Array<BusinessEntity>>;
  shipperIds?: Maybe<Array<Scalars['ObjectId']>>;
  shippers?: Maybe<Array<BusinessEntity>>;
  supplierIds?: Maybe<Array<Scalars['ObjectId']>>;
  suppliers?: Maybe<Array<BusinessEntity>>;
};

export type RelationshipPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Relationship>;
};

export type RelationshipUpdateInput = {
  commodityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  customerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  receiverIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  shipperIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  supplierIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type RemoveShipmentFromTripResult = {
  trip?: Maybe<Trip>;
};

export type Report = {
  description?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  label: Scalars['String'];
  resourceType: MetabaseResourceType;
};

export type ReportCsv = {
  url: Scalars['String'];
};

export type ReportData = {
  data: Array<ReportItem>;
  period?: Maybe<Period>;
  xAxisLabel: Scalars['String'];
};

export type ReportItem = {
  _id: ReportItemId;
  values: Scalars['ReportItemValue'];
};

export type ReportItemId = {
  group?: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type ReportPdf = {
  url: Scalars['String'];
};

export enum ReportType {
  CustomerRevenue = 'CUSTOMER_REVENUE',
  DeliveryReport = 'DELIVERY_REPORT',
  DriverMileagePerTrip = 'DRIVER_MILEAGE_PER_TRIP',
  RevenueByLoad = 'REVENUE_BY_LOAD',
  RevenuePerDay = 'REVENUE_PER_DAY',
  RevenuePerMile = 'REVENUE_PER_MILE',
  TripSheet = 'TRIP_SHEET'
}

export type Restrictions = {
  height: Scalars['Float'];
  weight: Scalars['Float'];
};

export enum Role {
  Accounting = 'Accounting',
  CarrierAdmin = 'CarrierAdmin',
  CarrierDriver = 'CarrierDriver',
  Clerical = 'Clerical',
  Dispatcher = 'Dispatcher',
  Hr = 'HR',
  Manager = 'Manager'
}

export type Route = {
  geometry: Scalars['String'];
  segments: Array<Segment>;
  summary: Summary;
};

export enum RouteProfile {
  DrivingCar = 'DRIVING_CAR',
  DrivingHgv = 'DRIVING_HGV'
}

export type RoutingDirections = {
  routes: Array<Route>;
};

export type RoutingDirectionsInput = {
  avoidPolygons?: InputMaybe<AvoidPolygons>;
  avoidables?: InputMaybe<Array<Scalars['String']>>;
  coordinates: Array<Array<Scalars['Float']>>;
  customerId: Scalars['ObjectId'];
  extraInfos?: InputMaybe<Array<Scalars['String']>>;
  profile?: InputMaybe<RouteProfile>;
  restrictions?: InputMaybe<Restrictions>;
  shipmentId: Scalars['ObjectId'];
  tripId: Scalars['ObjectId'];
};

export type RoutingDistanceMatrix = {
  distances: Array<Array<Scalars['Float']>>;
  durations: Array<Array<Scalars['Float']>>;
};

export enum S3_Operation {
  GetObject = 'getObject',
  PutObject = 'putObject'
}

export type SaveTripInput = {
  additionalTrailers?: InputMaybe<Array<Scalars['ObjectId']>>;
  carrier?: InputMaybe<Scalars['ObjectId']>;
  chassis?: InputMaybe<Scalars['ObjectId']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  deadheadDistance?: InputMaybe<Scalars['Float']>;
  distanceToEnd: Scalars['Float'];
  distanceToStart: Scalars['Float'];
  driver?: InputMaybe<Scalars['ObjectId']>;
  etaFromPreviousTrip?: InputMaybe<Scalars['Float']>;
  etaStatus?: InputMaybe<EtaStatus>;
  etaToNextTrip?: InputMaybe<Scalars['Float']>;
  firstPickupTime?: InputMaybe<Scalars['DateTime']>;
  lastDropoffTime?: InputMaybe<Scalars['DateTime']>;
  lastTrafficCheck?: InputMaybe<Scalars['DateTime']>;
  lastTrailerLocation?: InputMaybe<CoordinatesInput>;
  lastTrailerLocationDate?: InputMaybe<Scalars['DateTime']>;
  lastWeatherCheck?: InputMaybe<Scalars['DateTime']>;
  liveEtaUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  loadedDistance?: InputMaybe<Scalars['Float']>;
  polyline: Scalars['String'];
  predictedLoadedDistance?: InputMaybe<Scalars['Float']>;
  routeDistance: Scalars['Float'];
  shipmentLocations: Array<TripShipmentLocationInput>;
  shipments?: InputMaybe<Array<Scalars['ObjectId']>>;
  status: Status;
  tags?: InputMaybe<Array<Scalars['String']>>;
  totalDistance?: InputMaybe<Scalars['Float']>;
  tractor?: InputMaybe<Scalars['ObjectId']>;
  trailer?: InputMaybe<Scalars['ObjectId']>;
  trailerCompartmentAssignments?: InputMaybe<Array<TrailerCompartmentAssignmentInput>>;
  violations?: InputMaybe<Array<TripViolationInput>>;
};

export type SavedReport = {
  _id: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  filters: Scalars['JSON'];
  name: Scalars['String'];
  reportKey: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SavedReportUpdateInput = {
  filters?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  reportKey?: InputMaybe<Scalars['String']>;
};

export type Segment = {
  distance: Scalars['Float'];
  duration: Scalars['Float'];
  steps: Array<Step>;
};

export type SendRateconResult = {
  success: Scalars['Boolean'];
};

export type SendReportResult = {
  success: Scalars['Boolean'];
};

/** Shipment entity */
export type Shipment = {
  _id: Scalars['String'];
  /** Additional trailer types that can be used for the shipment */
  additionalTrailerTypes?: Maybe<Array<TrailerType>>;
  /** Carriers assigned to the shipment */
  assignedCarriers?: Maybe<Array<ShipmentCarrierAssignment>>;
  /**
   * Bill of lading number for the shipment
   * @deprecated Use billfOfLadingNumbers instead
   */
  billOfLadingNumber?: Maybe<Scalars['String']>;
  /** Bill of lading numbers for the shipment */
  billOfLadingNumbers?: Maybe<Array<Scalars['String']>>;
  /**
   * DEPRECATED: Charges associated with the shipment. Charges are now stored on invoices and resolved via GraphQL. This field is no longer updated and exists only for backward compatibility.
   * @deprecated Charges are now stored on invoices. Use the charges field resolved from the invoice instead. This field is maintained for backward compatibility only and will be removed in a future version.
   */
  charges: Array<ShipmentCharge>;
  /** For a recurrent or split shipment, the IDs of the child shipments */
  childShipmentIds?: Maybe<Array<Scalars['String']>>;
  /** Type of commodity being shipped. This affects what trailer types can be used */
  commodityType?: Maybe<ShipmentCommodityType>;
  /** Constraints that must be satisfied for the shipment */
  constraints?: Maybe<Array<ShipmentConstraint>>;
  /** ID of the user who created the shipment */
  createdBy: Scalars['String'];
  /** Custom fields associated with the shipment */
  customFields?: Maybe<Array<CustomField>>;
  /** ID of the customer for whom the shipment is created */
  customer: BusinessEntity;
  /** For shipments recurring daily, the number of rotations per day */
  dailyRotationCount?: Maybe<Scalars['Float']>;
  dispatcher?: Maybe<Scalars['String']>;
  /** Documents associated with the shipment */
  documents?: Maybe<Array<ShipmentDocument>>;
  /** Events loged by the driver for this shipment */
  events?: Maybe<Array<ShipmentEvent>>;
  /** Expenses associated with the shipment */
  expenses?: Maybe<Array<Transaction>>;
  /** IDs of the groups the shipment is associated with */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Whether the shipment is applicable for charge order cancellation */
  isApplicableChargeOrderCancellation?: Maybe<Scalars['Boolean']>;
  /** Set for child shipments of a master shipment with rotations */
  isFromRotation?: Maybe<Scalars['Boolean']>;
  /** Whether the shipment is a child of a split shipment */
  isFromSplit?: Maybe<Scalars['Boolean']>;
  /** Set to true for child shipments created from a recurrence pattern */
  isRecurrence?: Maybe<Scalars['Boolean']>;
  /** Whether the shipment is a split shipment or not */
  isSplit?: Maybe<Scalars['Boolean']>;
  /** Issues reported by the driver for this shipment */
  issues?: Maybe<Array<ShipmentIssue>>;
  /** Full truck load or less than truck load shipment type. Full truck load shipments can't be mixed with other shipments on the same trip */
  loadType: LoadType;
  /** Notes associated with the shipment */
  notes?: Maybe<Array<ShipmentNote>>;
  /** Order the shipment is created from */
  order?: Maybe<Order>;
  /** ID of the order the shipment is created from */
  orderId?: Maybe<Scalars['ObjectId']>;
  /** For child shipments of a recurrent shipment, the master shipment */
  parentShipment?: Maybe<Shipment>;
  /**
   * Purchase order number for the shipment
   * @deprecated Use purchaseOrderNumbers instead
   */
  postOfficeNumber?: Maybe<Scalars['String']>;
  /** Previous shipment number (e.g., temporary number before transition to permanent) */
  previousShipmentNumber?: Maybe<Scalars['String']>;
  /** Purchase order numbers for the shipment */
  purchaseOrderNumbers?: Maybe<Array<Scalars['String']>>;
  /** Rate confirmation numbers for the shipment */
  rateConNumbers?: Maybe<Array<Scalars['String']>>;
  /** For cancelled shipments, the reason for cancellation */
  reasonForCancellation?: Maybe<Scalars['String']>;
  /** For recurrent shipments, the recurrence pattern */
  recurrence?: Maybe<ShipmentRecurrence>;
  /**
   * Reference number for the shipment
   * @deprecated Use referenceNumbers instead
   */
  referenceNumber?: Maybe<Scalars['String']>;
  /** Reference numbers for the shipment */
  referenceNumbers?: Maybe<Array<Scalars['String']>>;
  /** Set for child shipments of a master shipment with rotations */
  rotationIndex?: Maybe<Scalars['Float']>;
  /** Route information for the shipment */
  route?: Maybe<ShipmentRoute>;
  /** Locations that need to be visited for the shipment */
  shipmentLocations: Array<ShipmentLocation>;
  /** Auto incremented number for the shipment */
  shipmentNumber: Scalars['String'];
  /** Current status of the shipment */
  status: Status;
  /** Tags associated with the shipment */
  tags?: Maybe<Array<Scalars['String']>>;
  /** Ticket numbers for the shipment */
  ticketNumbers?: Maybe<Array<Scalars['String']>>;
  /** Whether tracking emails have been sent for the shipment */
  trackingEmailsSent?: Maybe<Scalars['Boolean']>;
  /** Type of trailer required for the shipment */
  trailerType: TrailerType;
  /** Trip information for the shipment */
  trip?: Maybe<ShipmentTrip>;
  /** ID of the trip the shipment is assigned to */
  tripId?: Maybe<Scalars['String']>;
};

export type ShipmentAssignedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentAssignedEventPayload;
};

export type ShipmentAssignedEventPayload = {
  additionalTrailerIds?: Maybe<Array<Scalars['String']>>;
  carrierId?: Maybe<Scalars['String']>;
  chassisId?: Maybe<Scalars['String']>;
  driverId?: Maybe<Scalars['String']>;
  shipmentId: Scalars['ObjectId'];
  tractorId?: Maybe<Scalars['String']>;
  trailerId?: Maybe<Scalars['String']>;
};

export type ShipmentCancelledEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentCancelledEventPayload;
};

export type ShipmentCancelledEventPayload = {
  shipment: Shipment;
};

export type ShipmentCarrierAssignment = {
  accepted: Scalars['Boolean'];
  idCarrier: Scalars['String'];
};

export type ShipmentCarrierAssignmentInput = {
  accepted: Scalars['Boolean'];
  idCarrier: Scalars['String'];
};

export type ShipmentCharge = {
  _id: Scalars['String'];
  /** Billing rule for this charge */
  billingRule?: Maybe<BillingRule>;
  /** Type of charge */
  chargeType?: Maybe<ChargeType>;
  /** Custom fields for the transaction */
  customFields?: Maybe<Array<CustomField>>;
  /** Document for the transaction */
  document?: Maybe<TransactionDocument>;
  /** Label of the transaction */
  label: Scalars['String'];
  /** Transaction number */
  number?: Maybe<Scalars['String']>;
  /** Rate per unit */
  rate: Scalars['Float'];
  /** Rating table for this charge */
  ratingTable?: Maybe<RateTable>;
  /** Whether to reimburse to driver */
  reimburseToDriver?: Maybe<Scalars['Boolean']>;
  /** Related transaction ID */
  relatedTransactionId?: Maybe<Scalars['ObjectId']>;
  /** Shipment ID this charge is for */
  shipmentId?: Maybe<Scalars['ObjectId']>;
  /** Whether the transaction is taxable */
  taxable?: Maybe<Scalars['Boolean']>;
  /** Total amount of the charge */
  total: Scalars['Float'];
  /** Type of transaction */
  type?: Maybe<TransactionType>;
  /** Number of units */
  unit: Scalars['Float'];
  /** Unit type for the transaction */
  unitType: Scalars['String'];
};

export type ShipmentChargeInput = {
  _id?: InputMaybe<Scalars['String']>;
  billingRule?: InputMaybe<Scalars['String']>;
  /** Type of charge */
  chargeType?: InputMaybe<ChargeType>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  document?: InputMaybe<TransactionDocumentInput>;
  label: Scalars['String'];
  rate: Scalars['Float'];
  ratingTable?: InputMaybe<Scalars['String']>;
  reimburseToDriver?: InputMaybe<Scalars['Boolean']>;
  relatedTransactionId?: InputMaybe<Scalars['ObjectId']>;
  /** Shipment ID this charge is for */
  shipmentId?: InputMaybe<Scalars['ObjectId']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<TransactionType>;
  unit: Scalars['Float'];
  unitType: Scalars['String'];
};

/** The type of commodity to be delivered in the shipment */
export enum ShipmentCommodityType {
  Dry = 'DRY',
  Liquid = 'LIQUID'
}

export type ShipmentCompletedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentCompletedEventPayload;
};

export type ShipmentCompletedEventPayload = {
  shipmentId: Scalars['ObjectId'];
};

export type ShipmentConstraint = {
  type: ShipmentConstraintType;
  unit?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type ShipmentConstraintInput = {
  type: ShipmentConstraintType;
  unit?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export enum ShipmentConstraintType {
  Height = 'HEIGHT',
  Length = 'LENGTH',
  MaxTemperature = 'MAX_TEMPERATURE',
  MinTemperature = 'MIN_TEMPERATURE',
  Width = 'WIDTH'
}

export type ShipmentCreatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentCreatedEventPayload;
};

export type ShipmentCreatedEventPayload = {
  shipment: Shipment;
};

export type ShipmentDeleteInput = {
  isApplicableChargeOrderCancellation?: InputMaybe<Scalars['Boolean']>;
  reason: Scalars['String'];
};

export type ShipmentDeletedEventPayload = {
  reason?: Maybe<Scalars['String']>;
  shipmentId: Scalars['String'];
};

export type ShipmentDocument = {
  _id: Scalars['String'];
  accessLevel: Array<NoteAccessLevel>;
  associatedCharge?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  isBillable: Scalars['Boolean'];
  isForRatecons: Scalars['Boolean'];
  isForReceivers: Scalars['Boolean'];
  lastUpdatedBy: Scalars['String'];
  name: Scalars['String'];
  receiver?: Maybe<BusinessEntity>;
  shipper?: Maybe<BusinessEntity>;
  /** The type of document (BOL, DELIVERY_RECEIPT, etc.) */
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type ShipmentDocumentInfoInput = {
  accessLevel: Array<NoteAccessLevel>;
  associatedCharge?: InputMaybe<Scalars['String']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
  isForRatecons?: InputMaybe<Scalars['Boolean']>;
  isForReceivers?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  receiver?: InputMaybe<Scalars['String']>;
  shipper?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ShipmentDocumentInput = {
  accessLevel: Array<NoteAccessLevel>;
  associatedCharge?: InputMaybe<Scalars['String']>;
  isBillable?: InputMaybe<Scalars['Boolean']>;
  isForRatecons?: InputMaybe<Scalars['Boolean']>;
  isForReceivers?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  receiver?: InputMaybe<Scalars['String']>;
  shipment?: InputMaybe<Scalars['String']>;
  shipper?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ShipmentEvent = {
  _id: Scalars['String'];
  coordinates?: Maybe<Coordinates>;
  createdBy: Scalars['String'];
  date: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  shipmentLocation?: Maybe<Scalars['String']>;
  tripShipmentLocation?: Maybe<Scalars['String']>;
  type: ShipmentEventType;
};

export type ShipmentEventAddedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentEventAddedEventPayload;
};

export type ShipmentEventAddedEventPayload = {
  event: ShipmentEvent;
  shipment: Shipment;
};

export type ShipmentEventDeletedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentEventDeletedEventPayload;
};

export type ShipmentEventDeletedEventPayload = {
  eventId: Scalars['String'];
  shipment: Shipment;
};

export type ShipmentEventInput = {
  _id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  location: CoordinatesInput;
  metadata?: InputMaybe<Scalars['JSON']>;
  shipment: Scalars['String'];
  shipmentLocation?: InputMaybe<Scalars['String']>;
  trip?: InputMaybe<Scalars['String']>;
  tripShipmentLocation?: InputMaybe<Scalars['String']>;
  type: ShipmentEventType;
};

export enum ShipmentEventType {
  CheckCall = 'CHECK_CALL',
  CompartmentLoaded = 'COMPARTMENT_LOADED',
  CompartmentUnloaded = 'COMPARTMENT_UNLOADED',
  DropoffCheckpointUnloadStart = 'DROPOFF_CHECKPOINT_UNLOAD_START',
  DropOffCheckpointArrive = 'DROP_OFF_CHECKPOINT_ARRIVE',
  DropOffCheckpointLeft = 'DROP_OFF_CHECKPOINT_LEFT',
  PickupCheckpointArrive = 'PICKUP_CHECKPOINT_ARRIVE',
  PickupCheckpointLeft = 'PICKUP_CHECKPOINT_LEFT',
  PickupCheckpointLoadStart = 'PICKUP_CHECKPOINT_LOAD_START',
  ShipmentAccepted = 'SHIPMENT_ACCEPTED',
  ShipmentComplete = 'SHIPMENT_COMPLETE',
  TripAssetAssignmentUpdated = 'TRIP_ASSET_ASSIGNMENT_UPDATED',
  TripBreakStarted = 'TRIP_BREAK_STARTED',
  TripEnd = 'TRIP_END',
  TripResumed = 'TRIP_RESUMED',
  TripStarted = 'TRIP_STARTED'
}

export type ShipmentEventUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentEventUpdatedEventPayload;
};

export type ShipmentEventUpdatedEventPayload = {
  event: ShipmentEvent;
  shipment: Shipment;
};

export type ShipmentGoodPinCodeUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentGoodPinCodeUpdatedPayload;
};

export type ShipmentGoodPinCodeUpdatedPayload = {
  goodId: Scalars['String'];
  goodPinCode: Scalars['String'];
  shipmentId: Scalars['String'];
};

export type ShipmentGoodWeightUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentGoodWeightUpdatedPayload;
};

export type ShipmentGoodWeightUpdatedPayload = {
  goodId: Scalars['String'];
  goodWeight: Scalars['Float'];
  shipmentId: Scalars['String'];
};

export type ShipmentIssue = {
  _id: Scalars['String'];
  attachedDocuments: Array<Scalars['String']>;
  content: Scalars['String'];
  coordinates?: Maybe<Coordinates>;
  createdBy?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  delayAmount?: Maybe<Scalars['Float']>;
  shipmentLocation?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ShipmentIssueInput = {
  _id?: InputMaybe<Scalars['String']>;
  attachedDocuments: Array<Scalars['String']>;
  content: Scalars['String'];
  delayAmount?: InputMaybe<Scalars['Float']>;
  location: CoordinatesInput;
  shipment: Scalars['String'];
  shipmentLocation?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ShipmentLocation = {
  _id: Scalars['String'];
  addressLabel?: Maybe<Scalars['String']>;
  addressTimezone?: Maybe<Scalars['String']>;
  location: Coordinates;
  locationType: ShipmentLocationType;
  name?: Maybe<Scalars['String']>;
  receivedGoods?: Maybe<Array<GoodDistribution>>;
  receiver?: Maybe<BusinessEntity>;
  shippedGoods?: Maybe<Array<Good>>;
  shipper?: Maybe<BusinessEntity>;
  timeWindows: Array<DateTimeWindow>;
  trafficInfo?: Maybe<LocationTraffic>;
  weatherInfo?: Maybe<LocationWeather>;
};

export type ShipmentLocationInput = {
  _id?: InputMaybe<Scalars['String']>;
  addressLabel?: InputMaybe<Scalars['String']>;
  addressTimezone?: InputMaybe<Scalars['String']>;
  location: CoordinatesInput;
  locationType: ShipmentLocationType;
  name?: InputMaybe<Scalars['String']>;
  receivedGoods: Array<GoodDistributionInput>;
  receiver?: InputMaybe<Scalars['String']>;
  shippedGoods: Array<GoodInput>;
  shipper?: InputMaybe<Scalars['String']>;
  timeWindows: Array<DateTimeWindowInput>;
};

export type ShipmentLocationInputForPlanning = {
  _id: Scalars['ObjectId'];
  arrivalTime: Scalars['DateTime'];
  locationType: Scalars['String'];
  shipmentId?: InputMaybe<Scalars['String']>;
  /** Array of shipment IDs associated with this location */
  shipmentIds?: InputMaybe<Array<Scalars['String']>>;
  /** Array of shipment location IDs (_id) that this trip location represents */
  shipmentLocationIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum ShipmentLocationType {
  Break = 'BREAK',
  DropForHook = 'DROP_FOR_HOOK',
  DropOff = 'DROP_OFF',
  Pickup = 'PICKUP',
  TrailerPickup = 'TRAILER_PICKUP'
}

export type ShipmentLocationWithShipment = {
  _id: Scalars['String'];
  addressLabel?: Maybe<Scalars['String']>;
  addressTimezone?: Maybe<Scalars['String']>;
  location: Coordinates;
  locationType: ShipmentLocationType;
  name?: Maybe<Scalars['String']>;
  receivedGoods?: Maybe<Array<GoodDistribution>>;
  receiver?: Maybe<BusinessEntity>;
  shipment: Shipment;
  shippedGoods?: Maybe<Array<Good>>;
  shipper?: Maybe<BusinessEntity>;
  timeWindows: Array<DateTimeWindow>;
  trafficInfo?: Maybe<LocationTraffic>;
  weatherInfo?: Maybe<LocationWeather>;
};

export type ShipmentNote = {
  _id: Scalars['String'];
  accessLevel: Array<NoteAccessLevel>;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  lastUpdatedBy: Scalars['String'];
  receiver?: Maybe<BusinessEntity>;
  shipper?: Maybe<BusinessEntity>;
  updatedAt: Scalars['DateTime'];
};

export type ShipmentNoteInput = {
  _id?: InputMaybe<Scalars['String']>;
  accessLevel: Array<NoteAccessLevel>;
  content: Scalars['String'];
  receiver?: InputMaybe<Scalars['String']>;
  shipper?: InputMaybe<Scalars['String']>;
};

export type ShipmentPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Shipment>;
};

export type ShipmentRecurrence = {
  _id?: Maybe<Scalars['String']>;
  byhour?: Maybe<Array<Scalars['Float']>>;
  byminute?: Maybe<Array<Scalars['Float']>>;
  bymonth?: Maybe<Array<Scalars['Float']>>;
  bymonthday?: Maybe<Array<Scalars['Float']>>;
  bynmonthday?: Maybe<Array<Scalars['Float']>>;
  bysecond?: Maybe<Array<Scalars['Float']>>;
  bysetpos?: Maybe<Array<Scalars['Float']>>;
  byweekday?: Maybe<Array<ShipmentRecurrenceWeekday>>;
  byweekno?: Maybe<Array<Scalars['Float']>>;
  byyearday?: Maybe<Array<Scalars['Float']>>;
  count?: Maybe<Scalars['Float']>;
  dtstart: Scalars['DateTime'];
  freq: Frequency;
  interval: Scalars['Float'];
  tzid?: Maybe<Scalars['String']>;
  until: Scalars['DateTime'];
};

export type ShipmentRecurrenceInput = {
  _id?: InputMaybe<Scalars['String']>;
  byhour?: InputMaybe<Array<Scalars['Float']>>;
  byminute?: InputMaybe<Array<Scalars['Float']>>;
  bymonth?: InputMaybe<Array<Scalars['Float']>>;
  bymonthday?: InputMaybe<Array<Scalars['Float']>>;
  bynmonthday?: InputMaybe<Array<Scalars['Float']>>;
  bysecond?: InputMaybe<Array<Scalars['Float']>>;
  bysetpos?: InputMaybe<Array<Scalars['Float']>>;
  byweekday?: InputMaybe<Array<ShipmentRecurrenceWeekdayInput>>;
  byweekno?: InputMaybe<Array<Scalars['Float']>>;
  byyearday?: InputMaybe<Array<Scalars['Float']>>;
  count?: InputMaybe<Scalars['Float']>;
  dtstart: Scalars['DateTime'];
  freq: Frequency;
  interval: Scalars['Float'];
  tzid?: InputMaybe<Scalars['String']>;
  until: Scalars['DateTime'];
};

export type ShipmentRecurrenceWeekday = {
  n?: Maybe<Scalars['Float']>;
  weekday: Scalars['Float'];
};

export type ShipmentRecurrenceWeekdayInput = {
  n?: InputMaybe<Scalars['Float']>;
  weekday: Scalars['Float'];
};

export enum ShipmentReferenceNumberType {
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  PurchaseOrderNumber = 'PURCHASE_ORDER_NUMBER',
  RateConNumber = 'RATE_CON_NUMBER',
  ReferenceNumber = 'REFERENCE_NUMBER',
  TicketNumber = 'TICKET_NUMBER'
}

export type ShipmentReferencesUpdateInput = {
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']>>;
  purchaseOrderNumbers?: InputMaybe<Array<Scalars['String']>>;
  rateConNumbers?: InputMaybe<Array<Scalars['String']>>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']>>;
  ticketNumbers?: InputMaybe<Array<Scalars['String']>>;
};

export type ShipmentRestoredEvent = {
  name: Events;
  payload: ShipmentRestoredEventPayload;
};

export type ShipmentRestoredEventPayload = {
  shipment: Shipment;
};

export type ShipmentRoute = {
  distanceToEnd: Scalars['Float'];
  distanceToStart: Scalars['Float'];
  /** Effective end time including drive-to-next-trip time. Used for filtering and display purposes. */
  effectiveEndTime?: Maybe<Scalars['DateTime']>;
  /** Effective start time including drive-to-pickup time. Used for filtering and display purposes. */
  effectiveStartTime?: Maybe<Scalars['DateTime']>;
  firstPickupTime: Scalars['DateTime'];
  lastDropoffTime: Scalars['DateTime'];
  locations?: Maybe<Array<TripShipmentLocation>>;
  predictedLoadedDistance?: Maybe<Scalars['Float']>;
  routeDistance: Scalars['Float'];
  violations?: Maybe<Array<TripViolation>>;
};

export type ShipmentSort = {
  criteria: ShipmentSortCriteria;
  desc?: InputMaybe<Scalars['Boolean']>;
};

export enum ShipmentSortCriteria {
  DropoffDate = 'DROPOFF_DATE',
  DropoffDistance = 'DROPOFF_DISTANCE',
  PickupDate = 'PICKUP_DATE',
  PickupDistance = 'PICKUP_DISTANCE',
  Revenue = 'REVENUE',
  RevenuePerMile = 'REVENUE_PER_MILE',
  ShipmentNumber = 'SHIPMENT_NUMBER'
}

export type ShipmentSplitEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentSplitEventPayload;
};

export type ShipmentSplitEventPayload = {
  childShipmentIds: Array<Scalars['ObjectId']>;
  parentShipmentId: Scalars['ObjectId'];
  tripId: Scalars['ObjectId'];
};

export type ShipmentTrackingInfos = {
  /** @deprecated Use trip.lastTrailerLocation directly */
  lastKnownTrailerLocation?: Maybe<Coordinates>;
  shipment: Shipment;
  trip?: Maybe<Trip>;
};

export type ShipmentTrip = {
  _id: Scalars['String'];
  additionalTrailers?: Maybe<Array<Scalars['String']>>;
  carrier?: Maybe<Scalars['String']>;
  carrierEntity?: Maybe<Carrier>;
  deadheadDistance?: Maybe<Scalars['Float']>;
  distanceToEnd: Scalars['Float'];
  distanceToStart: Scalars['Float'];
  driver?: Maybe<Scalars['String']>;
  driverEntity?: Maybe<Driver>;
  etaFromPreviousTrip?: Maybe<Scalars['Float']>;
  etaStatus?: Maybe<EtaStatus>;
  etaToDeliveryMinutes?: Maybe<Scalars['Int']>;
  etaToNextStopMinutes?: Maybe<Scalars['Int']>;
  etaToNextTrip?: Maybe<Scalars['Float']>;
  firstPickupTime?: Maybe<Scalars['DateTime']>;
  lastDropoffTime?: Maybe<Scalars['DateTime']>;
  liveEtaUpdatedAt?: Maybe<Scalars['DateTime']>;
  loadedDistance?: Maybe<Scalars['Float']>;
  nextStopName?: Maybe<Scalars['String']>;
  polyline: Scalars['String'];
  predictedLoadedDistance?: Maybe<Scalars['Float']>;
  routeDistance: Scalars['Float'];
  shipmentLocations: Array<TripShipmentLocation>;
  status: Status;
  totalDistance?: Maybe<Scalars['Float']>;
  tractor?: Maybe<Scalars['String']>;
  tractorEntity?: Maybe<Tractor>;
  trailer?: Maybe<Scalars['String']>;
  trailerEntity?: Maybe<Trailer>;
  tripNumber?: Maybe<Scalars['String']>;
  violations?: Maybe<Array<TripViolation>>;
};

export type ShipmentUpdateInput = {
  additionalTrailerTypes?: InputMaybe<Array<TrailerType>>;
  assignedCarriers?: InputMaybe<Array<ShipmentCarrierAssignmentInput>>;
  billOfLadingNumber?: InputMaybe<Scalars['String']>;
  billOfLadingNumbers?: InputMaybe<Array<Scalars['String']>>;
  charges?: InputMaybe<Array<ShipmentChargeInput>>;
  commodityType?: InputMaybe<ShipmentCommodityType>;
  constraints?: InputMaybe<Array<ShipmentConstraintInput>>;
  createdBy?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  customer?: InputMaybe<Scalars['ObjectId']>;
  dailyRotationCount?: InputMaybe<Scalars['Float']>;
  documents?: InputMaybe<Array<ShipmentDocumentInput>>;
  expenses?: InputMaybe<Array<TransactionInput>>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  loadType?: InputMaybe<LoadType>;
  notes?: InputMaybe<Array<SingleShipmentNoteInput>>;
  orderId?: InputMaybe<Scalars['ObjectId']>;
  postOfficeNumber?: InputMaybe<Scalars['String']>;
  purchaseOrderNumbers?: InputMaybe<Array<Scalars['String']>>;
  rateConNumbers?: InputMaybe<Array<Scalars['String']>>;
  recurrence?: InputMaybe<ShipmentRecurrenceInput>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']>>;
  shipmentLocations?: InputMaybe<Array<ShipmentLocationInput>>;
  status?: InputMaybe<Status>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  ticketNumbers?: InputMaybe<Array<Scalars['String']>>;
  trailerType?: InputMaybe<TrailerType>;
};

export type ShipmentUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: ShipmentUpdatedEventPayload;
};

export type ShipmentUpdatedEventPayload = {
  changes: PartialShipment;
  previousShipment: Shipment;
  shipment: Shipment;
};

/** A Shipper Business entity */
export type Shipper = {
  _id: Scalars['String'];
  /** Token used for access to the customer portal */
  accessToken?: Maybe<Scalars['String']>;
  /** Additional contacts for the business entity. */
  additionalContacts?: Maybe<Array<Contact>>;
  /** Additional types for the business entity (e.g. a business entity could be both a customer and shipper). */
  additionalTypes?: Maybe<Array<BusinessEntityType>>;
  /** Physical address of the business entity. */
  address: Address;
  /** Timezone of the business entity address. If not provided, it will be inferred from the address. */
  addressTimezone?: Maybe<Scalars['String']>;
  /** Billing address for the business entity. */
  billingAddress?: Maybe<TextualAddress>;
  /** Billing email for the business entity. Invoices are sent here */
  billingEmail?: Maybe<Scalars['String']>;
  /** Criteria for invoice consolidation */
  billingInvoiceConsolidationCriteria?: Maybe<InvoiceConsolidationCriteria>;
  /** Billing terms for the business entity in days. */
  billingTermsDay?: Maybe<Scalars['Float']>;
  billingWeekStartsOn?: Maybe<Scalars['Float']>;
  /** Unique code identifying the business entity. */
  code?: Maybe<Scalars['String']>;
  /** Pre-assigned commodity profiles for this receiver. Resolved by field resolver. */
  commodities?: Maybe<Array<GoodProfile>>;
  commodityIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** Primary contact for the business entity. */
  contact: Contact;
  /** For carriers only, the credit terms they offer. */
  creditTerms?: Maybe<Scalars['String']>;
  /** Custom fields for the business entity */
  customFields?: Maybe<Array<CustomField>>;
  defaultReferenceNumbers?: Maybe<Array<DefaultReferenceNumber>>;
  /** The default shipper for this business entity */
  defaultShipper?: Maybe<BusinessEntity>;
  /** ID of the default shipper for this business entity. This is used by default when a shipment is sent to this business entity */
  defaultShipperId?: Maybe<Scalars['ObjectId']>;
  /** Document requirements for invoicing for this business entity */
  documentRequirements?: Maybe<Array<DocumentRequirement>>;
  /** Documents for the business entity */
  documents?: Maybe<Array<Document>>;
  /** DOT Number for carriers and brokers */
  dotNumber?: Maybe<Scalars['String']>;
  /** ID of the business entity in an external system. */
  externalId?: Maybe<Scalars['String']>;
  /** Federal ID for business entities */
  federalId?: Maybe<Scalars['String']>;
  goodInventoryItems?: Maybe<Array<GoodInventoryItem>>;
  /** IDs of the groups that this business entity belongs to */
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** MC Number for carriers */
  mcNumber?: Maybe<Scalars['String']>;
  /** Legal name of the business entity. */
  name: Scalars['String'];
  notes?: Maybe<Array<BusinessEntityNote>>;
  /** Opening schedules for the business entity. */
  openingSchedules?: Maybe<Array<OpeningSchedule>>;
  /** The business entity that this business entity belongs to */
  parentBusinessEntity?: Maybe<BusinessEntity>;
  /** ID of the business entity that this business entity belongs to. Used for receiver/customer relations for example */
  parentBusinessEntityId?: Maybe<Scalars['ObjectId']>;
  /** The business entity that we need to pay to. Used for carriers */
  payToProfile?: Maybe<BusinessEntity>;
  /** ID of the business entity that we need to pay to. Used for carriers */
  payToProfileId?: Maybe<Scalars['ObjectId']>;
  /** Planned dwell time in minutes for the business entity */
  plannedDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  /** For customers and brokers, the types of reference numbers they use in orders. */
  referenceNumberTypes?: Maybe<Array<ShipmentReferenceNumberType>>;
  /** Remit address for the business entity. Where payments are sent. */
  remitAddress?: Maybe<TextualAddress>;
  /** Remit company name for the business entity */
  remitCompanyName?: Maybe<Scalars['String']>;
  /** Remit email for the business entity */
  remitEmail?: Maybe<Scalars['String']>;
  /** Shipmentp documents to receive via email on completion */
  shipmentDocumentsToReceive?: Maybe<Array<Scalars['String']>>;
  /** SCAC code for carriers */
  standardCarrierAlphaCode?: Maybe<Scalars['String']>;
  status: AssetStatus;
  /** Storage facilities for the business entity. Used for tanks, warehouses, etc */
  storageFacilities?: Maybe<Array<StorageFacility>>;
  /** Tags for the business entity */
  tags?: Maybe<Array<Scalars['String']>>;
  /** For carriers only, the types of trailers they have. */
  trailerTypes?: Maybe<Array<TrailerType>>;
  /** The type of business entity. */
  type: BusinessEntityType;
};


/** A Shipper Business entity */
export type ShipperStorageFacilitiesArgs = {
  includeLinkedFacilities?: InputMaybe<Scalars['Boolean']>;
};

export type ShipperPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Shipper>;
};

export type SingleShipmentNoteInput = {
  _id?: InputMaybe<Scalars['String']>;
  accessLevel: Array<NoteAccessLevel>;
  content: Scalars['String'];
  receiver?: InputMaybe<Scalars['String']>;
  shipment?: InputMaybe<Scalars['String']>;
  shipper?: InputMaybe<Scalars['String']>;
};

/** A Snapshot entity */
export type Snapshot = {
  _id: Scalars['String'];
  date: Scalars['DateTime'];
};

export type SplitShipmentLocationInput = {
  _id?: InputMaybe<Scalars['String']>;
  addressLabel?: InputMaybe<Scalars['String']>;
  addressTimezone?: InputMaybe<Scalars['String']>;
  arrivalTimeWindows?: InputMaybe<Array<DateTimeWindowInput>>;
  departureTimeWindows?: InputMaybe<Array<DateTimeWindowInput>>;
  location: CoordinatesInput;
  locationType: ShipmentLocationType;
  name?: InputMaybe<Scalars['String']>;
};

export type StartTripInput = {
  location: CoordinatesInput;
  tripId: Scalars['String'];
};

export enum Status {
  Active = 'ACTIVE',
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  Forecasted = 'FORECASTED',
  ForecastedLocked = 'FORECASTED_LOCKED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  Pending = 'PENDING',
  Planned = 'PLANNED',
  Unassigned = 'UNASSIGNED',
  Unplanned = 'UNPLANNED',
  WaitingForApproval = 'WAITING_FOR_APPROVAL',
  WaitingForAssignment = 'WAITING_FOR_ASSIGNMENT'
}

export type Step = {
  distance: Scalars['Float'];
  duration: Scalars['Float'];
  instruction: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['Float'];
  way_points: Array<Scalars['Float']>;
};

/** Represents a storage facility at a given receiver */
export type StorageFacility = {
  _id: Scalars['String'];
  capacity: Scalars['Float'];
  commodities?: Maybe<Array<GoodProfile>>;
  /** @deprecated Use commodities instead */
  commodity?: Maybe<GoodProfile>;
  /** @deprecated Use commodityIds instead */
  commodityId?: Maybe<Scalars['ObjectId']>;
  commodityIds: Array<Scalars['ObjectId']>;
  currentForecastedReading?: Maybe<Reading>;
  currentSalesTrend?: Maybe<Scalars['Float']>;
  customFields?: Maybe<Array<CustomField>>;
  defaultPinCode?: Maybe<Scalars['String']>;
  defaultSupplier?: Maybe<BusinessEntity>;
  defaultSupplierId?: Maybe<Scalars['ObjectId']>;
  identifier: Scalars['String'];
  latestReading?: Maybe<Reading>;
  linkedStorageFacilityIds?: Maybe<Array<Scalars['String']>>;
  /** Dwell time in minutes for the storage facility */
  plannedDwellTimeInMinutes?: Maybe<Scalars['Float']>;
  runoutDate?: Maybe<Scalars['DateTime']>;
  runoutDateAfterNextShipment?: Maybe<Scalars['DateTime']>;
  safeFillLevel?: Maybe<Scalars['Float']>;
  shutDownLevel?: Maybe<Scalars['Float']>;
  unit: StorageFacilityUnit;
};

export type StorageFacilityDateRangeSales = {
  endDate: Scalars['DateTime'];
  salesAmount: Scalars['Float'];
  startDate: Scalars['DateTime'];
};

export type StorageFacilityInput = {
  capacity: Scalars['Float'];
  commodityId?: InputMaybe<Scalars['ObjectId']>;
  commodityIds: Array<Scalars['ObjectId']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  defaultPinCode?: InputMaybe<Scalars['String']>;
  defaultSupplierId?: InputMaybe<Scalars['ObjectId']>;
  identifier: Scalars['String'];
  linkedStorageFacilityIds?: InputMaybe<Array<Scalars['String']>>;
  /** Dwell time in minutes for the storage facility */
  plannedDwellTimeInMinutes?: InputMaybe<Scalars['Float']>;
  safeFillLevel?: InputMaybe<Scalars['Float']>;
  safeFillPercentage?: InputMaybe<Scalars['Float']>;
  shutDownLevel?: InputMaybe<Scalars['Float']>;
  shutDownPercentage?: InputMaybe<Scalars['Float']>;
  unit: StorageFacilityUnit;
};

export type StorageFacilityReading = {
  _id: Scalars['String'];
  date: Scalars['DateTime'];
  level: Scalars['Float'];
  receiver?: Maybe<BusinessEntity>;
  receiverId: Scalars['ObjectId'];
  storageFacilityId: Scalars['String'];
  volumeType?: Maybe<VolumeType>;
};

export type StorageFacilityReadingPaginatedResult = {
  count: Scalars['Int'];
  data: Array<StorageFacilityReading>;
};

export type StorageFacilityReadingUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  level?: InputMaybe<Scalars['Float']>;
  receiverId?: InputMaybe<Scalars['ObjectId']>;
  storageFacilityId?: InputMaybe<Scalars['String']>;
  volumeType?: InputMaybe<VolumeType>;
};

/** The units of measure for the capacity of a receiver storage facility */
export enum StorageFacilityUnit {
  Gallons = 'GALLONS',
  Liters = 'LITERS',
  Units = 'UNITS'
}

export type SubscriptionCheckoutSession = {
  url: Scalars['String'];
};

export enum SubscriptionEntitlementAvailability {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type SubscriptionEntitlementInfo = {
  featureId: Scalars['String'];
  value: SubscriptionEntitlementAvailability;
};

export type SubscriptionInfo = {
  activatedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entitlements?: Maybe<Array<SubscriptionEntitlementInfo>>;
  id: Scalars['String'];
  isLegacy?: Maybe<Scalars['Boolean']>;
  lastSyncStatus?: Maybe<Scalars['String']>;
  lastSyncTimestamp?: Maybe<Scalars['DateTime']>;
  lastUpdated: Scalars['DateTime'];
  mrr: Scalars['Float'];
  numberOfAdminSeats?: Maybe<Scalars['Float']>;
  numberOfDriverSeats?: Maybe<Scalars['Float']>;
  numberOfForecastingLocations?: Maybe<Scalars['Float']>;
  planType?: Maybe<Scalars['String']>;
  status: SubscriptionStatus;
  trialEnd?: Maybe<Scalars['DateTime']>;
  trialStart?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionPortalSession = {
  url: Scalars['String'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Future = 'FUTURE',
  InTrial = 'IN_TRIAL',
  None = 'NONE',
  NonRenewing = 'NON_RENEWING',
  Paused = 'PAUSED',
  Unknown = 'UNKNOWN'
}

export type Summary = {
  distance: Scalars['Float'];
  duration: Scalars['Float'];
};

/** Supplier contract */
export type SupplierContract = {
  _id: Scalars['String'];
  /** The maximum quantities of product allowed by the contract */
  allocation?: Maybe<SupplierContractAllocation>;
  /** The conditions that must be met for the contract to apply */
  conditions?: Maybe<Array<SupplierContractCondition>>;
  /** The identifier of the contract */
  contractNumber: Scalars['String'];
  customer?: Maybe<BusinessEntity>;
  /** The id of the customer that the contract is for */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** The end date of the contract. The contract cannot be used after this date */
  endDate: Scalars['DateTime'];
  goodProfile?: Maybe<GoodProfile>;
  /** The id of the commodity that the contract is for */
  goodProfileId: Scalars['ObjectId'];
  /** The pin code to use the contract */
  pinCode?: Maybe<Scalars['String']>;
  shipper?: Maybe<BusinessEntity>;
  /** The id of the shipper where the commodity can be picked up at */
  shipperId?: Maybe<Scalars['ObjectId']>;
  /** The start date of the contract. The contract cannot be used before this date */
  startDate: Scalars['DateTime'];
  supplier?: Maybe<BusinessEntity>;
  /** The id of the supplier that the contract is with */
  supplierId: Scalars['ObjectId'];
  /** The price per unit of the commodity */
  unitPrice: Scalars['Float'];
  /** The quantities of product used through this contract */
  usedAllocation?: Maybe<SupplierContractAllocation>;
};

/** Allocation definition for a supplier contract */
export type SupplierContractAllocation = {
  /** Daily quantity */
  dailyQuantity?: Maybe<Scalars['Float']>;
  /** Monthly quantity */
  monthlyQuantity?: Maybe<Scalars['Float']>;
  /** Total quantity */
  totalQuantity?: Maybe<Scalars['Float']>;
  /** Weekly quantity */
  weeklyQuantity?: Maybe<Scalars['Float']>;
};

export type SupplierContractAllocationInput = {
  /** Daily quantity */
  dailyQuantity?: InputMaybe<Scalars['Float']>;
  /** Monthly quantity */
  monthlyQuantity?: InputMaybe<Scalars['Float']>;
  /** Total quantity */
  totalQuantity?: InputMaybe<Scalars['Float']>;
  /** Weekly quantity */
  weeklyQuantity?: InputMaybe<Scalars['Float']>;
};

export type SupplierContractCondition = {
  operator: BillingRuleConditionOperator;
  target: SupplierContractConditionTarget;
  value?: Maybe<Scalars['ConditionValue']>;
};

export type SupplierContractConditionInput = {
  operator: BillingRuleConditionOperator;
  target: SupplierContractConditionTarget;
  value?: InputMaybe<Scalars['ConditionValue']>;
};

export enum SupplierContractConditionTarget {
  PurchaseQuantity = 'PURCHASE_QUANTITY',
  PurchaseTime = 'PURCHASE_TIME'
}

export type SupplierContractPaginatedResult = {
  count: Scalars['Int'];
  data: Array<SupplierContract>;
};

/** Supplier contract ranking for a shipment */
export type SupplierContractRanking = {
  /** Cost per mile */
  costPerMile: Scalars['Float'];
  /** Mileage between the shipper and receiver */
  mileage: Scalars['Float'];
  /** Cost of purchasing the product */
  productCost: Scalars['Float'];
  /** Quantity of the product */
  quantity: Scalars['Float'];
  /** Cost of shipping the product */
  shippingCost: Scalars['Float'];
  /** The contract data */
  supplierContract: SupplierContract;
  /** Total cost of using the contract for the shipment */
  totalCost: Scalars['Float'];
  /** Unit price of the product */
  unitPrice: Scalars['Float'];
};

export type SupplierContractUpdateInput = {
  /** The maximum quantities of product allowed by the contract */
  allocation?: InputMaybe<SupplierContractAllocationInput>;
  /** The conditions that must be met for the contract to apply */
  conditions?: InputMaybe<Array<SupplierContractConditionInput>>;
  /** The identifier of the contract */
  contractNumber?: InputMaybe<Scalars['String']>;
  /** The id of the customer that the contract is for */
  customerId?: InputMaybe<Scalars['ObjectId']>;
  /** The end date of the contract. The contract cannot be used after this date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The id of the commodity that the contract is for */
  goodProfileId?: InputMaybe<Scalars['ObjectId']>;
  /** The pin code to use the contract */
  pinCode?: InputMaybe<Scalars['String']>;
  /** The id of the shipper where the commodity can be picked up at */
  shipperId?: InputMaybe<Scalars['ObjectId']>;
  /** The start date of the contract. The contract cannot be used before this date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The id of the supplier that the contract is with */
  supplierId?: InputMaybe<Scalars['ObjectId']>;
  /** The price per unit of the commodity */
  unitPrice?: InputMaybe<Scalars['Float']>;
  /** The quantities of product used through this contract */
  usedAllocation?: InputMaybe<SupplierContractAllocationInput>;
};

export type Temp = {
  day?: Maybe<Scalars['Float']>;
  eve?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  morn?: Maybe<Scalars['Float']>;
  night?: Maybe<Scalars['Float']>;
};

/** Address with textual description */
export type TextualAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type TextualAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type Time = {
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type TimeInput = {
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

/** A Tractor entity */
export type Tractor = {
  _id: Scalars['String'];
  currentDriverEldId?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<CustomField>>;
  documents?: Maybe<Array<Document>>;
  domicile?: Maybe<Address>;
  eldId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  /** The last known location from the ELD. This is the safest location to use if you want to know the exact location of the tractor but it might not update as often */
  lastKnownEldLocation?: Maybe<Coordinates>;
  lastKnownEldLocationDate?: Maybe<Scalars['DateTime']>;
  /** The last known location by combining both ELD data and driver app data. This location is not as accurate as the ELD location but it updates more often */
  lastKnownLocation?: Maybe<Coordinates>;
  lastKnownLocationDate?: Maybe<Scalars['DateTime']>;
  licenseNumber?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Float']>;
  model?: Maybe<Scalars['String']>;
  plateNumber?: Maybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  status: AssetStatus;
  tags?: Maybe<Array<Scalars['String']>>;
  tareWeight?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type TractorPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Tractor>;
};

/** A Tractor entity */
export type TractorPosition = {
  _id?: Maybe<Scalars['String']>;
  coords: Coordinates;
  driverEldId?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['Float']>;
  timestamp: Scalars['DateTime'];
  tractor: Scalars['String'];
};

export type TractorPositionInput = {
  _id?: InputMaybe<Scalars['String']>;
  coords: CoordinatesInput;
  driverEldId?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['Float']>;
  timestamp: Scalars['DateTime'];
  tractor: Scalars['String'];
};

export type TractorPositionUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: TractorPositionUpdatedEventPayload;
};

export type TractorPositionUpdatedEventPayload = {
  previousOdometer?: Maybe<Scalars['Float']>;
  tractorPosition: TractorPosition;
};

export type TractorUpdateInput = {
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  domicile?: InputMaybe<NewAddressInput>;
  eldId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Float']>;
  model?: InputMaybe<Scalars['String']>;
  plateNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssetStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  tareWeight?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['Float']>;
};

/** A Trailer entity */
export type Trailer = {
  _id: Scalars['String'];
  compartmentVolumes?: Maybe<Array<CompartmentVolume>>;
  compartments?: Maybe<Array<TrailerCompartment>>;
  customFields?: Maybe<Array<CustomField>>;
  documents?: Maybe<Array<Document>>;
  domicile?: Maybe<Address>;
  groupIds?: Maybe<Array<Scalars['ObjectId']>>;
  hasMeteredPump?: Maybe<Scalars['Boolean']>;
  height?: Maybe<Scalars['Float']>;
  lastKnownLocation?: Maybe<Coordinates>;
  lastKnownLocationDate?: Maybe<Scalars['DateTime']>;
  length?: Maybe<Scalars['Float']>;
  licenseNumber?: Maybe<Scalars['String']>;
  maxTemperature?: Maybe<Scalars['Float']>;
  maxWeight?: Maybe<Scalars['Float']>;
  mileage?: Maybe<Scalars['Float']>;
  minTemperature?: Maybe<Scalars['Float']>;
  numberOfAxles?: Maybe<Scalars['Float']>;
  serial?: Maybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  status: AssetStatus;
  tags?: Maybe<Array<Scalars['String']>>;
  type: TrailerType;
  vin?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

/** Represents a storage facility at a given receiver */
export type TrailerCompartment = {
  capacity: Scalars['Float'];
  hasDoubleBulkheadAfter?: Maybe<Scalars['Boolean']>;
  heavyOnly?: Maybe<Scalars['Boolean']>;
  identifier: Scalars['String'];
  maxVolume?: Maybe<Scalars['Float']>;
  minVolume?: Maybe<Scalars['Float']>;
  unit: TrailerCompartmentUnit;
};

/** Assignment of a commodity to a trailer compartment */
export type TrailerCompartmentAssignment = {
  commodityId: Scalars['String'];
  compartmentId: Scalars['String'];
  quantity: Scalars['Float'];
  targetStorageFacilityId?: Maybe<Scalars['String']>;
  trailerId?: Maybe<Scalars['ObjectId']>;
};

export type TrailerCompartmentAssignmentInput = {
  commodityId: Scalars['String'];
  compartmentId: Scalars['String'];
  quantity: Scalars['Float'];
  targetStorageFacilityId?: InputMaybe<Scalars['String']>;
  trailerId?: InputMaybe<Scalars['ObjectId']>;
};

export type TrailerCompartmentInput = {
  capacity: Scalars['Float'];
  hasDoubleBulkheadAfter?: InputMaybe<Scalars['Boolean']>;
  heavyOnly?: InputMaybe<Scalars['Boolean']>;
  identifier: Scalars['String'];
  maxVolume?: InputMaybe<Scalars['Float']>;
  minVolume?: InputMaybe<Scalars['Float']>;
  unit: TrailerCompartmentUnit;
};

/** The units of measure for the capacity of a trailer compartment */
export enum TrailerCompartmentUnit {
  Gallons = 'GALLONS',
  Liters = 'LITERS',
  Units = 'UNITS'
}

export type TrailerEvent = {
  _id: Scalars['String'];
  date: Scalars['DateTime'];
  trailerId: Scalars['ObjectId'];
  type: TrailerEventType;
};

export type TrailerEventInput = {
  _id: Scalars['String'];
  date: Scalars['DateTime'];
  trailerId: Scalars['ObjectId'];
  type: TrailerEventType;
};

export type TrailerEventPaginatedResult = {
  count: Scalars['Int'];
  data: Array<TrailerEvent>;
};

/** Type of trailer event */
export enum TrailerEventType {
  TrailerWash = 'TRAILER_WASH'
}

export type TrailerEventUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  trailerId?: InputMaybe<Scalars['ObjectId']>;
  type?: InputMaybe<TrailerEventType>;
};

export type TrailerPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Trailer>;
};

export type TrailerProfile = {
  compartments: Array<TrailerProfileCompartment>;
};

export type TrailerProfileCompartment = {
  capacity: Scalars['Float'];
  hasSeparatorAfter: Scalars['Boolean'];
  hasSeparatorBefore: Scalars['Boolean'];
  label: Scalars['String'];
  maxWeight: Scalars['Float'];
  minUsage: Scalars['Float'];
};

export type TrailerProfileCompartmentInput = {
  capacity: Scalars['Float'];
  hasSeparatorAfter: Scalars['Boolean'];
  hasSeparatorBefore: Scalars['Boolean'];
  label: Scalars['String'];
  maxWeight: Scalars['Float'];
  minUsage: Scalars['Float'];
};

export type TrailerProfileInput = {
  compartments: Array<TrailerProfileCompartmentInput>;
};

export enum TrailerType {
  AutoCarrier = 'AUTO_CARRIER',
  Conestoga = 'CONESTOGA',
  Container = 'CONTAINER',
  Conveyor = 'CONVEYOR',
  DryBulk = 'DRY_BULK',
  Enclosed = 'ENCLOSED',
  FlatBed = 'FLAT_BED',
  HazardousMaterials = 'HAZARDOUS_MATERIALS',
  Lowboy = 'LOWBOY',
  MultiCar = 'MULTI_CAR',
  Other = 'OTHER',
  PowerOnly = 'POWER_ONLY',
  Refrigerated = 'REFRIGERATED',
  SpecializedDeck = 'SPECIALIZED_DECK',
  SprinterVan = 'SPRINTER_VAN',
  StandardDeck = 'STANDARD_DECK',
  StraightBoxTruck = 'STRAIGHT_BOX_TRUCK',
  Tanker = 'TANKER',
  TankWagon = 'TANK_WAGON',
  Van = 'VAN'
}

export type TrailerUpdateInput = {
  compartments?: InputMaybe<Array<TrailerCompartmentInput>>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  documents?: InputMaybe<Array<DocumentInput>>;
  domicile?: InputMaybe<NewAddressInput>;
  groupIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  hasMeteredPump?: InputMaybe<Scalars['Boolean']>;
  height?: InputMaybe<Scalars['Float']>;
  lastKnownLocation?: InputMaybe<CoordinatesInput>;
  length?: InputMaybe<Scalars['Float']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  maxTemperature?: InputMaybe<Scalars['Float']>;
  maxWeight?: InputMaybe<Scalars['Float']>;
  mileage?: InputMaybe<Scalars['Float']>;
  minTemperature?: InputMaybe<Scalars['Float']>;
  numberOfAxles?: InputMaybe<Scalars['Float']>;
  serial?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssetStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<TrailerType>;
  vin?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type Transaction = {
  _id: Scalars['String'];
  /** Custom fields for the transaction */
  customFields?: Maybe<Array<CustomField>>;
  /** Document for the transaction */
  document?: Maybe<TransactionDocument>;
  /** Label of the transaction */
  label: Scalars['String'];
  /** Transaction number */
  number?: Maybe<Scalars['String']>;
  /** Rate per unit */
  rate: Scalars['Float'];
  /** Whether to reimburse to driver */
  reimburseToDriver?: Maybe<Scalars['Boolean']>;
  /** Related transaction ID */
  relatedTransactionId?: Maybe<Scalars['ObjectId']>;
  /** Shipment ID this charge is for */
  shipmentId?: Maybe<Scalars['ObjectId']>;
  /** Whether the transaction is taxable */
  taxable?: Maybe<Scalars['Boolean']>;
  /** Type of transaction */
  type?: Maybe<TransactionType>;
  /** Number of units */
  unit: Scalars['Float'];
  /** Unit type for the transaction */
  unitType: Scalars['String'];
};

export type TransactionDocument = {
  _id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type TransactionDocumentInput = {
  _id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type TransactionInput = {
  _id?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  document?: InputMaybe<TransactionDocumentInput>;
  label: Scalars['String'];
  rate: Scalars['Float'];
  reimburseToDriver?: InputMaybe<Scalars['Boolean']>;
  relatedTransactionId?: InputMaybe<Scalars['ObjectId']>;
  /** Shipment ID this charge is for */
  shipmentId?: InputMaybe<Scalars['ObjectId']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<TransactionType>;
  unit: Scalars['Float'];
  unitType: Scalars['String'];
};

export type TransactionInputObject = {
  _id?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<CustomField>>;
  document?: Maybe<TransactionDocument>;
  label: Scalars['String'];
  rate: Scalars['Float'];
  reimburseToDriver?: Maybe<Scalars['Boolean']>;
  relatedTransactionId?: Maybe<Scalars['ObjectId']>;
  /** Shipment ID this charge is for */
  shipmentId?: Maybe<Scalars['ObjectId']>;
  taxable?: Maybe<Scalars['Boolean']>;
  type?: Maybe<TransactionType>;
  unit: Scalars['Float'];
  unitType: Scalars['String'];
};

export type TransactionPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Transaction>;
};

export enum TransactionType {
  Expense = 'EXPENSE',
  Income = 'INCOME'
}

export type TransactionUpdateInput = {
  _id?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  document?: InputMaybe<TransactionDocumentInput>;
  label?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
  reimburseToDriver?: InputMaybe<Scalars['Boolean']>;
  relatedTransactionId?: InputMaybe<Scalars['ObjectId']>;
  /** Shipment ID this charge is for */
  shipmentId?: InputMaybe<Scalars['ObjectId']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<TransactionType>;
  unit?: InputMaybe<Scalars['Float']>;
  unitType?: InputMaybe<Scalars['String']>;
};

export type TransferOrganizationDataInput = {
  deleteExistingData?: InputMaybe<Scalars['Boolean']>;
  sourceOrganizationId: Scalars['String'];
  sourceStage: Scalars['String'];
  targetOrganizationId: Scalars['String'];
  targetStage: Scalars['String'];
};

export type TransferResult = {
  duration: Scalars['Int'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  timestamp: Scalars['DateTime'];
  totalRecordsTransferred: Scalars['Int'];
  transferredCollections: Array<CollectionTransferResult>;
};

/** Trip entity */
export type Trip = {
  _id: Scalars['String'];
  additionalTrailers?: Maybe<Array<Trailer>>;
  carrier?: Maybe<BusinessEntity>;
  chassis?: Maybe<Chassis>;
  customFields?: Maybe<Array<CustomField>>;
  deadheadDistance?: Maybe<Scalars['Float']>;
  distanceToEnd: Scalars['Float'];
  distanceToStart: Scalars['Float'];
  driver?: Maybe<Driver>;
  driverPositions?: Maybe<Array<TripDriverPosition>>;
  etaFromPreviousTrip?: Maybe<Scalars['Float']>;
  etaStatus?: Maybe<EtaStatus>;
  etaToDeliveryMinutes?: Maybe<Scalars['Int']>;
  etaToNextStopMinutes?: Maybe<Scalars['Int']>;
  etaToNextTrip?: Maybe<Scalars['Float']>;
  firstPickupTime?: Maybe<Scalars['DateTime']>;
  lastDropoffTime?: Maybe<Scalars['DateTime']>;
  lastTrafficCheck?: Maybe<Scalars['DateTime']>;
  lastTrailerLocation?: Maybe<Coordinates>;
  lastTrailerLocationDate?: Maybe<Scalars['DateTime']>;
  lastWeatherCheck?: Maybe<Scalars['DateTime']>;
  liveEtaUpdatedAt?: Maybe<Scalars['DateTime']>;
  loadStates?: Maybe<Array<LoadState>>;
  loadedDistance?: Maybe<Scalars['Float']>;
  nextStopName?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<TripPayment>>;
  polyline: Scalars['String'];
  predictedLoadedDistance?: Maybe<Scalars['Float']>;
  routeDistance: Scalars['Float'];
  routeEndPoint?: Maybe<TripRouteEndpoint>;
  routeStartPoint?: Maybe<TripRouteEndpoint>;
  shipmentLocations: Array<TripShipmentLocation>;
  shipments: Array<Shipment>;
  status: Status;
  tags?: Maybe<Array<Scalars['String']>>;
  totalDistance?: Maybe<Scalars['Float']>;
  tractor?: Maybe<Tractor>;
  trailer?: Maybe<Trailer>;
  trailerCompartmentAssignments?: Maybe<Array<TrailerCompartmentAssignment>>;
  tripNumber?: Maybe<Scalars['String']>;
  violations?: Maybe<Array<TripViolation>>;
};

export type TripAssetAssignment = {
  assetId?: InputMaybe<Scalars['String']>;
  assetType: TripAssetTypes;
  restartTrip?: InputMaybe<Scalars['Boolean']>;
  tripId: Scalars['String'];
};

export enum TripAssetTypes {
  AdditionalTrailers = 'ADDITIONAL_TRAILERS',
  Carrier = 'CARRIER',
  Chassis = 'CHASSIS',
  Driver = 'DRIVER',
  Tractor = 'TRACTOR',
  Trailer = 'TRAILER'
}

export type TripCompletedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: TripCompletedEventPayload;
};

export type TripCompletedEventPayload = {
  trip: Trip;
};

export type TripCreatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: TripCreatedEventPayload;
};

export type TripCreatedEventPayload = {
  trip: Trip;
};

export type TripDistancesCalculatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: TripDistancesCalculatedEventPayload;
};

export type TripDistancesCalculatedEventPayload = {
  tripId: Scalars['ObjectId'];
};

/** TripDriverPosition entity */
export type TripDriverPosition = {
  activity: Activity;
  battery: Battery;
  coords: Coordinates;
  event: Scalars['String'];
  extras: Extras;
  is_moving: Scalars['Boolean'];
  odometer: Scalars['Float'];
  timestamp: Scalars['String'];
  trip: Scalars['String'];
  uuid: Scalars['String'];
};

export type TripForPlanningInput = {
  canMoveBackward?: InputMaybe<Scalars['Boolean']>;
  canMoveForward?: InputMaybe<Scalars['Boolean']>;
  firstPickupTime?: InputMaybe<Scalars['DateTime']>;
  lastDropoffTime?: InputMaybe<Scalars['DateTime']>;
  shipmentIds: Array<Scalars['String']>;
  shipmentLocations: Array<ShipmentLocationInputForPlanning>;
};

export type TripFullyAssignedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: TripFullyAssignedEventPayload;
};

export type TripFullyAssignedEventPayload = {
  shipmentIds: Array<Scalars['String']>;
};

/** Result of generating trips */
export type TripGenerationResult = {
  trips: Array<Trip>;
  unassignedShipmentLocations: Array<ShipmentLocationWithShipment>;
  unplannedShipments: Array<Shipment>;
};

export type TripLiveEtaUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: TripLiveEtaUpdatedEventPayload;
};

export type TripLiveEtaUpdatedEventPayload = {
  trip: Trip;
};

export type TripPaginatedResult = {
  count: Scalars['Int'];
  data: Array<Trip>;
};

export type TripPayment = {
  _id: Scalars['String'];
  label: Scalars['String'];
  paymentRule?: Maybe<PaymentRule>;
  rate: Scalars['Float'];
  rateTableId?: Maybe<Scalars['ObjectId']>;
  trip: Scalars['ObjectId'];
  unit: Scalars['Float'];
  unitType: Scalars['String'];
};

export type TripPaymentInput = {
  _id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  rate: Scalars['Float'];
  unit: Scalars['Float'];
  unitType: Scalars['String'];
};

export type TripRouteEndpoint = {
  addressLabel: Scalars['String'];
  /** Distance in meters to/from the adjacent stop */
  distance: Scalars['Float'];
  label: Scalars['String'];
  name: Scalars['String'];
  type: TripRouteEndpointType;
};

/** Whether a trip route endpoint is a domicile or prior delivery */
export enum TripRouteEndpointType {
  Domicile = 'DOMICILE',
  PreviousDelivery = 'PREVIOUS_DELIVERY'
}

/** Trip shipment location entity */
export type TripShipmentLocation = {
  _id: Scalars['String'];
  addressLabel?: Maybe<Scalars['String']>;
  addressTimezone?: Maybe<Scalars['String']>;
  arrivalTime: Scalars['DateTime'];
  distanceTo?: Maybe<Scalars['Float']>;
  estimatedArrivalTime?: Maybe<Scalars['DateTime']>;
  location: Coordinates;
  locationType: ShipmentLocationType;
  name?: Maybe<Scalars['String']>;
  receivedGoods?: Maybe<Array<GoodDistribution>>;
  receiver?: Maybe<BusinessEntity>;
  rotationIndex?: Maybe<Scalars['Float']>;
  serviceDuration: Scalars['Float'];
  setupDuration: Scalars['Float'];
  /** @deprecated Use shipmentIds instead. This field returns the first shipment ID only. */
  shipmentId?: Maybe<Scalars['String']>;
  /** Array of shipment IDs associated with this location */
  shipmentIds: Array<Scalars['String']>;
  /** Array of shipment location IDs (from individual shipments) that this trip location represents */
  shipmentLocationIds: Array<Scalars['String']>;
  shippedGoods?: Maybe<Array<Good>>;
  shipper?: Maybe<BusinessEntity>;
  timeWindows: Array<DateTimeWindow>;
  trafficInfo?: Maybe<LocationTraffic>;
  /** This is the ID of the shipment location as defined in the trip */
  tripShipmentLocationId: Scalars['String'];
  waitingDuration: Scalars['Float'];
  weatherInfo?: Maybe<LocationWeather>;
};

/** Trip shipment location entity */
export type TripShipmentLocationInput = {
  _id?: InputMaybe<Scalars['String']>;
  addressLabel?: InputMaybe<Scalars['String']>;
  addressTimezone?: InputMaybe<Scalars['String']>;
  arrivalTime: Scalars['DateTime'];
  distanceTo?: InputMaybe<Scalars['Float']>;
  location: CoordinatesInput;
  locationType: ShipmentLocationType;
  name?: InputMaybe<Scalars['String']>;
  receivedGoods: Array<GoodDistributionInput>;
  receiver?: InputMaybe<Scalars['String']>;
  rotationIndex?: InputMaybe<Scalars['Float']>;
  serviceDuration: Scalars['Float'];
  setupDuration: Scalars['Float'];
  shipmentId?: InputMaybe<Scalars['String']>;
  /** Array of shipment IDs associated with this location */
  shipmentIds?: InputMaybe<Array<Scalars['String']>>;
  /** Array of shipment location IDs (from individual shipments) that this trip location represents */
  shipmentLocationIds?: InputMaybe<Array<Scalars['String']>>;
  shippedGoods: Array<GoodInput>;
  shipper?: InputMaybe<Scalars['String']>;
  timeWindows: Array<DateTimeWindowInput>;
  /** This is the ID of the shipment location as defined in the trip */
  tripShipmentLocationId: Scalars['String'];
  waitingDuration: Scalars['Float'];
};

export type TripSort = {
  criteria: TripSortCriteria;
  desc?: InputMaybe<Scalars['Boolean']>;
};

export enum TripSortCriteria {
  CreatedAt = 'CREATED_AT',
  EndLocation = 'END_LOCATION',
  FinishDate = 'FINISH_DATE',
  StartDate = 'START_DATE',
  StartLocation = 'START_LOCATION'
}

export type TripUpdatedEvent = {
  name: Events;
  organizationId?: Maybe<Scalars['String']>;
  payload: TripUpdatedEventPayload;
};

export type TripUpdatedEventPayload = {
  changes: PartialTrip;
  trip: Trip;
};

export type TripViolation = {
  cause: ViolationCause;
  duration?: Maybe<Scalars['Float']>;
  locationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  shipmentNumber?: Maybe<Scalars['String']>;
  timeWindowEnd?: Maybe<Scalars['Float']>;
  timeWindowStart?: Maybe<Scalars['Float']>;
};

export type TripViolationInput = {
  cause: ViolationCause;
  duration?: InputMaybe<Scalars['Float']>;
  locationId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  shipmentNumber?: InputMaybe<Scalars['String']>;
  timeWindowEnd?: InputMaybe<Scalars['Float']>;
  timeWindowStart?: InputMaybe<Scalars['Float']>;
};

export type UpdateAccountAttributesInput = {
  freshchatRestoreId?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountInput = {
  attributes?: InputMaybe<UpdateAccountAttributesInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateGoodDeliveredQuantityInput = {
  /** The gross quantity that was actually delivered to the customer */
  deliveredQuantity: Scalars['Float'];
  goodId: Scalars['String'];
  /** The net (temperature-corrected) quantity that was actually delivered to the customer */
  netDeliveredQuantity?: InputMaybe<Scalars['Float']>;
  shipmentId: Scalars['String'];
  /** Optional shipment location ID to target a specific location when multiple locations share the same storageFacilityId and good */
  shipmentLocationId?: InputMaybe<Scalars['String']>;
  storageFacilityId?: InputMaybe<Scalars['String']>;
};

export type UpdateGoodDipReadingsInput = {
  goodId: Scalars['String'];
  inchesAfter?: InputMaybe<Scalars['Float']>;
  inchesBefore?: InputMaybe<Scalars['Float']>;
  shipmentId: Scalars['String'];
  shipmentLocationId: Scalars['String'];
  storageFacilityId?: InputMaybe<Scalars['String']>;
};

export type UpdateGoodLoadedQuantityInput = {
  goodId: Scalars['String'];
  /** The gross quantity that was loaded by the driver */
  loadedQuantity: Scalars['Float'];
  /** The net (temperature-corrected) quantity that was loaded by the driver */
  netLoadedQuantity?: InputMaybe<Scalars['Float']>;
  shipmentId: Scalars['String'];
  /** Optional shipment location ID to target a specific location when multiple locations share the same good */
  shipmentLocationId?: InputMaybe<Scalars['String']>;
};

export type UpdateShipmentEventInput = {
  date?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateTripOrderInput = {
  shipmentLocationsOrder: Array<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
};

export type User = {
  attributes: UserAttributes;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  roles: Array<KeycloakUserRole>;
  username: Scalars['String'];
};

export type UserAttributes = {
  customFields?: Maybe<Scalars['String']>;
  driverId?: Maybe<Scalars['String']>;
  freshchatRestoreId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']>;
  promoCode?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  trialDays?: Maybe<Scalars['String']>;
};

export type UserAttributesInput = {
  customFields?: InputMaybe<Scalars['String']>;
  driverId?: InputMaybe<Scalars['String']>;
  freshchatRestoreId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']>;
  promoCode?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  trialDays?: InputMaybe<Scalars['String']>;
};

export type UserStatusUpdatedEvent = {
  name: Events;
  organizationId: Scalars['String'];
  payload: UserStatusUpdatedEventPayload;
};

export type UserStatusUpdatedEventPayload = {
  enabled: Scalars['Boolean'];
  userId: Scalars['String'];
};

/** The cause of the violation */
export enum ViolationCause {
  BreakDelay = 'BREAK_DELAY',
  BreakLeadTime = 'BREAK_LEAD_TIME',
  Delay = 'DELAY',
  EndDelay = 'END_DELAY',
  EndLeadTime = 'END_LEAD_TIME',
  EtaDelay = 'ETA_DELAY',
  LeadTime = 'LEAD_TIME',
  Load = 'LOAD',
  MaxDistance = 'MAX_DISTANCE',
  MaxLoad = 'MAX_LOAD',
  MaxTasks = 'MAX_TASKS',
  MaxTravelTime = 'MAX_TRAVEL_TIME',
  MissingBreak = 'MISSING_BREAK',
  Precedence = 'PRECEDENCE',
  Skills = 'SKILLS'
}

export enum VolumeType {
  Gross = 'GROSS',
  Net = 'NET'
}

export enum VroomError {
  InfeasibleRoute = 'INFEASIBLE_ROUTE',
  InternalError = 'INTERNAL_ERROR'
}

export type WeatherInfo = {
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  main?: Maybe<Scalars['String']>;
};

export type SetupOrganizationMutationVariables = Exact<{
  organizationSetupData: NewOrganizationInput;
}>;


export type SetupOrganizationMutation = { setupOrganization: string };

export type ActivateTrialMutationVariables = Exact<{
  subscriptionType: Scalars['String'];
}>;


export type ActivateTrialMutation = { activateTrial: { status: SubscriptionStatus, id: string, trialStart?: any | null, trialEnd?: any | null, createdAt?: any | null, activatedAt?: any | null, mrr: number, lastUpdated: any } };

export type CheckSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckSubscriptionQuery = { isSubscribed: boolean };

export type GetCheckoutSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type GetCheckoutSessionMutation = { getCheckoutSession: { url: string } };

export type GetSubscriptionPortalSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionPortalSessionMutation = { getSubscriptionPortalSession: { url: string } };

export type UpdateMyAccountMutationVariables = Exact<{
  accountData: UpdateAccountInput;
}>;


export type UpdateMyAccountMutation = { updateMyAccount: { _id: string } };

export type GetOrganizationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationSettingsQuery = { organizationSettings?: { general?: { language?: Language | null, measurementSystem?: MeasurementSystem | null, useSimpleWorkflow?: boolean | null, currency?: Currency | null, driversCanSeeFutureTrips?: boolean | null, singleClickTripCompletion?: boolean | null, weekStartsOn?: number | null } | null, dispatching?: { canConsolidateInProgressShipments?: boolean | null, canChangeTripOrder?: boolean | null, canUseAdHocAddress?: boolean | null, canDriverSetAlternateSupplierPinCode?: boolean | null, enableCapacityWarnings?: boolean | null, shipperDwellTimeInMinutes?: number | null, receiverDwellTimeInMinutes?: number | null, orderTypeDefault?: LoadType | null, defaultTrailerTypes?: Array<TrailerType> | null, trackCommodity?: boolean | null, trackNetAndGrossVolumes?: boolean | null, enableEta?: boolean | null } | null, invoicing?: { prefix?: string | null, logoUrl?: string | null, emailLogoUrl?: string | null, primaryColor?: string | null, companyAddress?: string | null, companyPhone?: string | null, companyEmail?: string | null, processes?: Array<InvoicingProcess> | null, enableTaxRate?: boolean | null, remitCompanyName?: string | null, remitEmail?: string | null, enableConsolidatedInvoicing?: boolean | null, enableSingleNumberInvoicing?: boolean | null, showLoadedDeliveredQuantities?: boolean | null, applyAllPrimaryRateTables?: boolean | null, receiverDocumentationSubjectTemplate?: string | null, receiverDocumentationBodyTemplate?: string | null, remitAddress?: { line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, googlePlaceId?: string | null, postalCode?: string | null, state?: string | null } | null } | null, ratecon?: { termsAndConditions?: string | null, companyAddress?: string | null, companyPhone?: string | null, companyEmail?: string | null, subjectTemplate?: string | null, bodyTemplate?: string | null } | null, transactionTemplates?: Array<{ _id?: string | null, type?: TransactionType | null, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null }> | null } | null };

export type SaveOrganizationSettingsMutationVariables = Exact<{
  orgSettings: OrganizationSettingsInput;
}>;


export type SaveOrganizationSettingsMutation = { saveOrganizationSettings?: { _id?: string | null } | null };

export type SaveDataSnapshotMutationVariables = Exact<{ [key: string]: never; }>;


export type SaveDataSnapshotMutation = { saveDataSnapshot: { _id: string, date: any } };

export type RestoreLatestSnapshotMutationVariables = Exact<{ [key: string]: never; }>;


export type RestoreLatestSnapshotMutation = { restoreLatestSnapshot: boolean };

export type GetSubscriptionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionInfoQuery = { subscriptionInfo?: { status: SubscriptionStatus, id: string, trialStart?: any | null, trialEnd?: any | null, createdAt?: any | null, activatedAt?: any | null, numberOfAdminSeats?: number | null, numberOfDriverSeats?: number | null, mrr: number, lastUpdated: any, entitlements?: Array<{ featureId: string, value: SubscriptionEntitlementAvailability }> | null } | null };

export type GetOrgUsersListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  roles?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['JSON']>;
}>;


export type GetOrgUsersListQuery = { orgUsers: { count: number, data: Array<{ _id: string, email?: string | null, enabled?: boolean | null, username: string, firstName?: string | null, lastName?: string | null, roles: Array<{ id: string, name: string }>, attributes: { driverId?: string | null, tags?: string | null, customFields?: string | null } }> } };

export type GetOrgUserDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrgUserDetailsQuery = { orgUserById: { _id: string, email?: string | null, username: string, firstName?: string | null, lastName?: string | null, enabled?: boolean | null, attributes: { driverId?: string | null, tags?: string | null, customFields?: string | null }, roles: Array<{ id: string, name: string }> } };

export type DeleteOrgUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteOrgUserMutation = { deleteOrgUser: boolean };

export type AddOrgUserMutationVariables = Exact<{
  newOrgUserData: NewOrgUserInput;
}>;


export type AddOrgUserMutation = { addOrgUser: { _id: string } };

export type EditOrgUserMutationVariables = Exact<{
  id: Scalars['String'];
  editOrgUserData: OrgUserUpdateInput;
}>;


export type EditOrgUserMutation = { editOrgUser: { _id: string } };

export type UpdatePasswordMutationVariables = Exact<{
  id: Scalars['String'];
  temporaryPassword: Scalars['String'];
}>;


export type UpdatePasswordMutation = { updatePassword: boolean };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { roles: Array<{ id: string, name: string }> };

export type BulkAddOrgUsersMutationVariables = Exact<{
  newOrgUsersData: Array<NewOrgUserInput> | NewOrgUserInput;
}>;


export type BulkAddOrgUsersMutation = { bulkAddOrgUsers: Array<{ _id: string }> };

export type UpdateAccountStatusMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
}>;


export type UpdateAccountStatusMutation = { updateAccountStatus: boolean };

export type GetCustomerBillingRulesQueryVariables = Exact<{
  customer: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  filter?: InputMaybe<Scalars['JSON']>;
}>;


export type GetCustomerBillingRulesQuery = { billingRules: { count: number, data: Array<{ type: BillingRuleType, _id: string, label?: string | null, referenceNumber?: string | null, method?: BillingMethod | null, amount?: number | null, priority?: number | null, effectiveStartDate?: any | null, effectiveEndDate?: any | null, isActive: boolean, conditions: Array<{ target: BillingRuleConditionTarget, operator: BillingRuleConditionOperator, value?: any | null, parameters?: Array<{ type: BillingRuleConditionParameterType, value?: any | null }> | null }>, rates?: Array<{ method: BillingMethod, amount: number, referenceNumber?: string | null, label?: string | null, taxable?: boolean | null, parameters?: Array<{ type: BillingRateParameterType, value?: any | null }> | null }> | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type EditBillingRuleMutationVariables = Exact<{
  id: Scalars['String'];
  editBillingRuleData: BillingRuleUpdateInput;
}>;


export type EditBillingRuleMutation = { editBillingRule: { _id: string } };

export type AddBillingRuleMutationVariables = Exact<{
  newBillingRuleData: NewBillingRuleInput;
}>;


export type AddBillingRuleMutation = { addBillingRule: { _id: string } };

export type DeleteBillingRuleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBillingRuleMutation = { deleteBillingRule: boolean };

export type GetDriverDeductionRulesQueryVariables = Exact<{
  driver: Scalars['String'];
}>;


export type GetDriverDeductionRulesQuery = { deductionRules: { data: Array<{ _id: string, method: DriverDeductionMethod, amount: number, label: string, type: DeductionType, period: { start: any, repeatEvery: number, unit: DeductionPeriodUnit, end: any } }> } };

export type EditDeductionRuleMutationVariables = Exact<{
  id: Scalars['String'];
  editDeductionRuleData: DeductionRuleUpdateInput;
}>;


export type EditDeductionRuleMutation = { editDeductionRule: { _id: string } };

export type AddDeductionRuleMutationVariables = Exact<{
  newDeductionRuleData: NewDeductionRuleInput;
}>;


export type AddDeductionRuleMutation = { addDeductionRule: { _id: string } };

export type DeleteDeductionRuleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDeductionRuleMutation = { deleteDeductionRule: boolean };

export type GetInvoiceListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<InvoiceStatus>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetInvoiceListQuery = { invoices: { count: number, data: Array<{ _id: string, invoiceNumber: string, status: InvoiceStatus, closingNote?: string | null, taxRate?: number | null, groupIds?: Array<any> | null, pdfDocument: { isGenerating: boolean, error?: string | null, url?: string | null }, charges: Array<{ _id: string, unit: number, rate: number, taxable?: boolean | null }>, customer?: { _id: string, name: string, contact: { email?: string | null }, customFields?: Array<{ key: string, value?: any | null }> | null } | null, shipment?: { _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null } | null, shipments?: Array<{ _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null, purchaseOrderNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, billOfLadingNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, tags?: Array<string> | null, route?: { lastDropoffTime: any } | null, trip?: { lastDropoffTime?: any | null } | null, shipmentLocations: Array<{ shipper?: { _id: string, name: string } | null, receiver?: { _id: string, name: string } | null }> }> | null }> } };

export type GetInvoiceDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInvoiceDetailsQuery = { invoiceById: { _id: string, invoiceNumber: string, taxRate?: number | null, status: InvoiceStatus, paidAmount?: number | null, groupIds?: Array<any> | null, pdfDocument: { isGenerating: boolean, error?: string | null, url?: string | null }, charges: Array<{ _id: string, unit: number, rate: number, taxable?: boolean | null, label: string, unitType: string, chargeType?: ChargeType | null, shipmentId?: any | null, customFields?: Array<{ key: string, value?: any | null }> | null, billingRule?: { _id: string, label?: string | null, referenceNumber?: string | null } | null, ratingTable?: { _id: string, label: string, referenceNumber?: string | null } | null, document?: { name: string, url: string } | null }>, customer?: { _id: string, name: string, contact: { email?: string | null }, additionalContacts?: Array<{ email?: string | null, includeInInvoicing?: boolean | null }> | null, customFields?: Array<{ key: string, value?: any | null }> | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null, payments?: Array<{ _id: any, amount: number, date: any, paymentMethod?: PaymentMethod | null, note?: string | null }> | null, shipments?: Array<{ _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null, purchaseOrderNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, billOfLadingNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, route?: { lastDropoffTime: any } | null, trip?: { lastDropoffTime?: any | null } | null, customer: { _id: string, name: string, type: BusinessEntityType, code?: string | null } }> | null } };

export type GetShipmentInvoiceDetailsQueryVariables = Exact<{
  shipmentId: Scalars['String'];
}>;


export type GetShipmentInvoiceDetailsQuery = { invoiceByShipmentId?: { _id: string, invoiceNumber: string, taxRate?: number | null, status: InvoiceStatus, paidAmount?: number | null, groupIds?: Array<any> | null, pdfDocument: { isGenerating: boolean, url?: string | null, error?: string | null }, customer?: { _id: string, name: string, contact: { email?: string | null }, additionalContacts?: Array<{ email?: string | null, includeInInvoicing?: boolean | null }> | null, customFields?: Array<{ key: string, value?: any | null }> | null } | null, charges: Array<{ _id: string, unit: number, rate: number, taxable?: boolean | null, label: string, unitType: string, chargeType?: ChargeType | null }>, shipments?: Array<{ _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null, purchaseOrderNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, billOfLadingNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, route?: { lastDropoffTime: any } | null, trip?: { lastDropoffTime?: any | null } | null }> | null } | null };

export type GenerateInvoiceMutationVariables = Exact<{
  shipmentId: Scalars['String'];
  invoiceNumber?: InputMaybe<Scalars['String']>;
}>;


export type GenerateInvoiceMutation = { generateInvoice: { _id: string } };

export type BatchProcessInvoicesMutationVariables = Exact<{
  invoiceIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  status: InvoiceStatus;
}>;


export type BatchProcessInvoicesMutation = { batchProcessInvoices?: { textError: string, textWarning: string, invoicesUpdated: Array<{ _id: string, status: InvoiceStatus }> } | null };

export type DeleteInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteInvoiceMutation = { deleteInvoice: boolean };

export type BulkEditInvoicesMutationVariables = Exact<{
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  bulkEditInvoiceData: InvoiceBulkUpdateInput;
}>;


export type BulkEditInvoicesMutation = { bulkEditInvoices?: Array<{ _id: string }> | null };

export type SendInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type SendInvoiceMutation = { sendInvoice?: { _id: string, status: InvoiceStatus } | null };

export type UpdateInvoiceStatusMutationVariables = Exact<{
  invoiceId: Scalars['String'];
  status: InvoiceStatus;
  closingNote?: InputMaybe<Scalars['String']>;
  paidAmount?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateInvoiceStatusMutation = { updateInvoiceStatus?: { _id: string, status: InvoiceStatus } | null };

export type UpdateInvoiceTaxRateMutationVariables = Exact<{
  invoiceId: Scalars['String'];
  taxRate?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateInvoiceTaxRateMutation = { updateInvoiceTaxRate?: { _id: string, taxRate?: number | null } | null };

export type ConsolidateInvoicesMutationVariables = Exact<{
  invoiceIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type ConsolidateInvoicesMutation = { consolidateInvoices?: { _id: string } | null };

export type SeparateInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ObjectId'];
  shipmentIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type SeparateInvoiceMutation = { separateInvoice: Array<{ _id: string, invoiceNumber: string }> };

export type EditInvoiceMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  editInvoiceData: InvoiceUpdateInput;
}>;


export type EditInvoiceMutation = { editInvoice?: { _id: string } | null };

export type RecalculateInvoiceChargesMutationVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type RecalculateInvoiceChargesMutation = { recalculateInvoiceCharges?: { _id: string } | null };

export type NextInvoiceNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type NextInvoiceNumberQuery = { nextInvoiceNumber: number };

export type SetNextInvoiceNumberMutationVariables = Exact<{
  nextInvoiceNumber: Scalars['Int'];
}>;


export type SetNextInvoiceNumberMutation = { setNextInvoiceNumber: number };

export type GetDriverPaymentRulesQueryVariables = Exact<{
  driver: Scalars['String'];
}>;


export type GetDriverPaymentRulesQuery = { paymentRules: { data: Array<{ _id: string, method: DriverPaymentMethod, amount: number, period?: { start: any, end?: any | null, repeatEvery: number, unit: PaymentPeriodUnit } | null }> } };

export type EditPaymentRuleMutationVariables = Exact<{
  id: Scalars['String'];
  editPaymentRuleData: PaymentRuleUpdateInput;
}>;


export type EditPaymentRuleMutation = { editPaymentRule?: { _id: string } | null };

export type AddPaymentRuleMutationVariables = Exact<{
  newPaymentRuleData: NewPaymentRuleInput;
}>;


export type AddPaymentRuleMutation = { addPaymentRule: { _id: string } };

export type DeletePaymentRuleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePaymentRuleMutation = { deletePaymentRule: boolean };

export type GetRateTablesQueryVariables = Exact<{
  entityType?: InputMaybe<RateTableEntityType>;
  entityId: Scalars['ObjectId'];
}>;


export type GetRateTablesQuery = { rateTables: { data: Array<{ _id: string, priority?: number | null, referenceNumber?: string | null, entityType: RateTableEntityType, entityId: any, label: string, description?: string | null, rateType: RateTableType, isActive: boolean, effectiveStartDate?: any | null, effectiveEndDate?: any | null, createdAt: any, updatedAt: any, rowAxis: { conditions: Array<{ target: BillingRuleConditionTarget, operator: BillingRuleConditionOperator, value?: any | null, parameters?: Array<{ type: BillingRuleConditionParameterType, value?: any | null }> | null }> }, columnAxis?: { conditions: Array<{ target: BillingRuleConditionTarget, operator: BillingRuleConditionOperator, value?: any | null, parameters?: Array<{ type: BillingRuleConditionParameterType, value?: any | null }> | null }> } | null, cells: Array<Array<{ rates: Array<{ label?: string | null, method: BillingMethod, amount: number, referenceNumber?: string | null, taxable?: boolean | null, parameters?: Array<{ type: BillingRateParameterType, value?: any | null }> | null }> }>> }> } };

export type EditRateTableMutationVariables = Exact<{
  id: Scalars['String'];
  editRateTableData: RateTableUpdateInput;
}>;


export type EditRateTableMutation = { editRateTable: { _id: string } };

export type AddRateTableMutationVariables = Exact<{
  newRateTableData: NewRateTableInput;
}>;


export type AddRateTableMutation = { addRateTable: { _id: string } };

export type DeleteRateTableMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteRateTableMutation = { deleteRateTable: boolean };

export type GetDriverSettlementsForDriverQueryVariables = Exact<{
  driverId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetDriverSettlementsForDriverQuery = { driverSettlements: { count: number, data: Array<{ _id: string, driverSettlementNumber: string, startDate: any, endDate: any, status: DriverSettlementStatus, pdfDocument: { isGenerating: boolean, url?: string | null, error?: string | null }, payments: Array<{ _id: string, unit: number, rate: number }>, deductions: Array<{ amount: number }>, trips?: Array<{ _id: string, tripNumber?: string | null }> | null }> } };

export type GetDriverSettlementListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  status?: InputMaybe<DriverSettlementStatus>;
}>;


export type GetDriverSettlementListQuery = { driverSettlements: { count: number, data: Array<{ _id: string, driverSettlementNumber: string, startDate: any, endDate: any, status: DriverSettlementStatus, pdfDocument: { isGenerating: boolean, url?: string | null, error?: string | null }, payments: Array<{ _id: string, unit: number, rate: number }>, deductions: Array<{ type: DeductionType, amount: number }>, trips?: Array<{ _id: string, tripNumber?: string | null }> | null, driver?: { _id: string, firstname: string, lastname: string } | null }> } };

export type GetDriverSettlementDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDriverSettlementDetailsQuery = { driverSettlementById?: { _id: string, driverSettlementNumber: string, startDate: any, endDate: any, trips?: Array<{ _id: string, tripNumber?: string | null }> | null, pdfDocument: { url?: string | null }, payments: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string, trip: any }>, deductions: Array<{ _id: string, label: string, amount: number, date: any, type: DeductionType }> } | null };

export type EditDriverSettlementMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  editDriverSettlementData: DriverSettlementUpdateInput;
}>;


export type EditDriverSettlementMutation = { editDriverSettlement?: { _id: string } | null };

export type DeleteDriverSettlementMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDriverSettlementMutation = { deleteDriverSettlement: boolean };

export type GenerateDriverSettlementMutationVariables = Exact<{
  driverId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type GenerateDriverSettlementMutation = { generateDriverSettlement: { _id: string, driverSettlementNumber: string, pdfDocument: { isGenerating: boolean, url?: string | null, error?: string | null } } };

export type GenerateDriverSettlementForTripsMutationVariables = Exact<{
  tripIds: Array<Scalars['String']> | Scalars['String'];
  driverSettlementNumber?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type GenerateDriverSettlementForTripsMutation = { generateDriverSettlementForTrips: { _id: string, driverSettlementNumber: string, pdfDocument: { isGenerating: boolean, url?: string | null, error?: string | null } } };

export type UpdateDriverSettlementStatusMutationVariables = Exact<{
  driverSettlementId: Scalars['String'];
  status: DriverSettlementStatus;
}>;


export type UpdateDriverSettlementStatusMutation = { updateDriverSettlementStatus?: { _id: string, status: DriverSettlementStatus } | null };

export type SendRateconMutationVariables = Exact<{
  tripId: Scalars['String'];
}>;


export type SendRateconMutation = { sendRatecon: { success: boolean } };

export type GetInvoicesForShipmentsQueryVariables = Exact<{
  shipmentIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetInvoicesForShipmentsQuery = { invoices: { data: Array<{ _id: string, invoiceNumber: string, status: InvoiceStatus, shipmentIds?: Array<any> | null, paidAmount?: number | null, taxRate?: number | null, charges: Array<{ _id: string, total: number, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, relatedTransactionId?: any | null, taxable?: boolean | null, shipmentId?: any | null, chargeType?: ChargeType | null, billingRule?: { _id: string, label?: string | null, referenceNumber?: string | null } | null, ratingTable?: { _id: string, label: string, referenceNumber?: string | null } | null, document?: { name: string, url: string } | null }>, customer?: { _id: string, name: string } | null }> } };

export type GetInvoiceForShipmentQueryVariables = Exact<{
  shipmentId: Scalars['String'];
}>;


export type GetInvoiceForShipmentQuery = { invoices: { data: Array<{ _id: string, invoiceNumber: string, status: InvoiceStatus, shipmentIds?: Array<any> | null, paidAmount?: number | null, taxRate?: number | null, charges: Array<{ _id: string, total: number, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, relatedTransactionId?: any | null, taxable?: boolean | null, shipmentId?: any | null, chargeType?: ChargeType | null, billingRule?: { _id: string, label?: string | null, referenceNumber?: string | null } | null, ratingTable?: { _id: string, label: string, referenceNumber?: string | null } | null, document?: { name: string, url: string } | null }>, customer?: { _id: string, name: string } | null }> } };

export type GetShipmentChargeTotalsQueryVariables = Exact<{
  shipmentIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetShipmentChargeTotalsQuery = { invoices: { data: Array<{ _id: string, invoiceNumber: string, status: InvoiceStatus, shipmentIds?: Array<any> | null, charges: Array<{ total: number, shipmentId?: any | null }> }> } };

export type GetTransactionListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetTransactionListQuery = { transactions: { count: number, data: Array<{ _id: string, number?: string | null, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, document?: { name: string, url: string } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type DeleteTransactionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTransactionMutation = { deleteTransaction: boolean };

export type AddTransactionMutationVariables = Exact<{
  newTransactionData: TransactionInput;
}>;


export type AddTransactionMutation = { addTransaction: { _id: string } };

export type EditTransactionMutationVariables = Exact<{
  id: Scalars['String'];
  editTransactionData: TransactionUpdateInput;
}>;


export type EditTransactionMutation = { editTransaction: { _id: string } };

export type GetTransactionTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionTemplatesQuery = { templates?: { transactionTemplates?: Array<{ _id?: string | null, type?: TransactionType | null, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null }> | null } | null };

export type GetTripForPaymentsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTripForPaymentsQuery = { tripById?: { _id: string, tripNumber?: string | null, status: Status, payments?: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string }> | null } | null };

export type AddTripPaymentMutationVariables = Exact<{
  tripId: Scalars['String'];
  payment: TransactionInput;
}>;


export type AddTripPaymentMutation = { addTripPayment?: { _id: string, tripNumber?: string | null, status: Status, payments?: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string }> | null } | null };

export type EditTripPaymentMutationVariables = Exact<{
  tripId: Scalars['String'];
  paymentId: Scalars['String'];
  payment: TransactionInput;
}>;


export type EditTripPaymentMutation = { editTripPayment?: { _id: string, tripNumber?: string | null, status: Status, payments?: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string }> | null } | null };

export type DeleteTripPaymentMutationVariables = Exact<{
  tripId: Scalars['String'];
  paymentId: Scalars['String'];
}>;


export type DeleteTripPaymentMutation = { deleteTripPayment?: { _id: string, tripNumber?: string | null, status: Status, payments?: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string }> | null } | null };

export type ComputeLineHaulForTripMutationVariables = Exact<{
  tripId: Scalars['String'];
}>;


export type ComputeLineHaulForTripMutation = { computeLineHaulForTrip?: { _id: string, tripNumber?: string | null, status: Status, payments?: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string }> | null } | null };

export type GetAssetLinkingsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']>;
}>;


export type GetAssetLinkingsQuery = { assetLinkings: { count: number, data: Array<{ _id: string, startDate?: any | null, endDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, tractor?: { _id: string, serialNumber: string } | null, trailer?: { _id: string, serialNumber: string } | null, additionalTrailers?: Array<{ _id: string, serialNumber: string }> | null }> } };

export type GetAssetLinkingDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAssetLinkingDetailsQuery = { assetLinking?: { _id: string, startDate?: any | null, endDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, tractor?: { _id: string, serialNumber: string } | null, trailer?: { _id: string, serialNumber: string } | null, additionalTrailers?: Array<{ _id: string, serialNumber: string }> | null } | null };

export type GetAssetLinkingDetailsForDriverQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type GetAssetLinkingDetailsForDriverQuery = { assetLinking?: { _id: string, startDate?: any | null, endDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, tractor?: { _id: string, serialNumber: string } | null, trailer?: { _id: string, serialNumber: string } | null, additionalTrailers?: Array<{ _id: string, serialNumber: string }> | null } | null };

export type GetAssetLinkingDetailsForTractorQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type GetAssetLinkingDetailsForTractorQuery = { assetLinking?: { _id: string, startDate?: any | null, endDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, tractor?: { _id: string, serialNumber: string } | null, trailer?: { _id: string, serialNumber: string } | null, additionalTrailers?: Array<{ _id: string, serialNumber: string }> | null } | null };

export type GetAssetLinkingDetailsForTrailerQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type GetAssetLinkingDetailsForTrailerQuery = { assetLinking?: { _id: string, startDate?: any | null, endDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, tractor?: { _id: string, serialNumber: string } | null, trailer?: { _id: string, serialNumber: string } | null, additionalTrailers?: Array<{ _id: string, serialNumber: string }> | null } | null };

export type AddAssetLinkingMutationVariables = Exact<{
  newAssetLinkingData: AssetLinkingInput;
}>;


export type AddAssetLinkingMutation = { addAssetLinking: { _id: string } };

export type EditAssetLinkingMutationVariables = Exact<{
  id: Scalars['String'];
  editAssetLinkingData: AssetLinkingUpdateInput;
}>;


export type EditAssetLinkingMutation = { editAssetLinking: { _id: string } };

export type DeleteAssetLinkingMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAssetLinkingMutation = { deleteAssetLinking: boolean };

export type GetBrokerListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBrokerListQuery = { brokers: { count: number, data: Array<{ _id: string, code?: string | null, name: string, type: BusinessEntityType, tags?: Array<string> | null, address: { label: string }, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string } }> } };

export type GetBrokerDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBrokerDetailsQuery = { brokerById: { _id: string, name: string, code?: string | null, additionalTypes?: Array<BusinessEntityType> | null, billingEmail?: string | null, billingTermsDay?: number | null, remitEmail?: string | null, type: BusinessEntityType, tags?: Array<string> | null, address: { label: string, city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, coordinates: { latitude: number, longitude: number } }, billingAddress?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, remitAddress?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, contact: { email?: string | null, firstname: string, lastname: string, phoneNumber: string }, openingSchedules?: Array<{ openingTime: string, closingTime: string, days: Array<number> }> | null, additionalContacts?: Array<{ firstname: string, lastname: string, email?: string | null, phoneNumber: string }> | null, goodInventoryItems?: Array<{ _id?: string | null, label: string, weight?: number | null }> | null } };

export type AddBrokerMutationVariables = Exact<{
  newBrokerData: NewBusinessEntityInput;
}>;


export type AddBrokerMutation = { addBroker: { _id: string } };

export type EditBrokerMutationVariables = Exact<{
  id: Scalars['String'];
  editBrokerData: BusinessEntityUpdateInput;
}>;


export type EditBrokerMutation = { editBroker: { _id: string } };

export type DeleteBrokerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBrokerMutation = { deleteBroker: boolean };

export type GetBusinessEntityListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  businessEntityTypes?: InputMaybe<Array<BusinessEntityType> | BusinessEntityType>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBusinessEntityListQuery = { businessEntities: { count: number, data: Array<{ _id: string, code?: string | null, mcNumber?: string | null, dotNumber?: string | null, standardCarrierAlphaCode?: string | null, federalId?: string | null, name: string, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, tags?: Array<string> | null, groupIds?: Array<any> | null, status: AssetStatus, trailerTypes?: Array<TrailerType> | null, commodityIds?: Array<any> | null, address: { label: string, coordinates: { latitude: number, longitude: number } }, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string, title?: string | null, faxNumber?: string | null, extensionNumber?: string | null, url?: string | null }, customFields?: Array<{ key: string, value?: any | null }> | null, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, linkedStorageFacilityIds?: Array<string> | null, latestReading?: { date: any, level: number, volumeType?: VolumeType | null } | null, commodities?: Array<{ _id: string, label: string, unit: GoodUnits, weight: number }> | null, customFields?: Array<{ key: string, value?: any | null }> | null }> | null, commodities?: Array<{ _id: string, label: string, unit: GoodUnits }> | null }> } };

export type GetBusinessEntityDetailsQueryVariables = Exact<{
  id: Scalars['String'];
  includeLinkedFacilities?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBusinessEntityDetailsQuery = { businessEntityById: { _id: string, name: string, code?: string | null, parentBusinessEntityId?: any | null, defaultShipperId?: any | null, accessToken?: string | null, mcNumber?: string | null, standardCarrierAlphaCode?: string | null, dotNumber?: string | null, federalId?: string | null, payToProfileId?: any | null, referenceNumberTypes?: Array<ShipmentReferenceNumberType> | null, additionalTypes?: Array<BusinessEntityType> | null, trailerTypes?: Array<TrailerType> | null, addressTimezone?: string | null, billingEmail?: string | null, billingTermsDay?: number | null, billingInvoiceConsolidationCriteria?: InvoiceConsolidationCriteria | null, billingWeekStartsOn?: number | null, remitCompanyName?: string | null, remitEmail?: string | null, commodityIds?: Array<any> | null, type: BusinessEntityType, shipmentDocumentsToReceive?: Array<string> | null, tags?: Array<string> | null, groupIds?: Array<any> | null, status: AssetStatus, plannedDwellTimeInMinutes?: number | null, defaultShipper?: { name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, defaultReferenceNumbers?: Array<{ referenceNumberType: ShipmentReferenceNumberType, referenceNumberValue: string }> | null, address: { label: string, city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, coordinates: { latitude: number, longitude: number } }, billingAddress?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, remitAddress?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, contact: { email?: string | null, firstname: string, lastname: string, phoneNumber: string, title?: string | null, faxNumber?: string | null, extensionNumber?: string | null, url?: string | null, includeInDocumentSending?: boolean | null }, openingSchedules?: Array<{ openingTime: string, closingTime: string, days: Array<number> }> | null, additionalContacts?: Array<{ firstname: string, lastname: string, email?: string | null, phoneNumber: string, includeInInvoicing?: boolean | null, includeInDocumentSending?: boolean | null, title?: string | null, url?: string | null, faxNumber?: string | null, extensionNumber?: string | null }> | null, goodInventoryItems?: Array<{ _id?: string | null, label: string, weight?: number | null }> | null, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, defaultPinCode?: string | null, defaultSupplierId?: any | null, plannedDwellTimeInMinutes?: number | null, linkedStorageFacilityIds?: Array<string> | null, commodities?: Array<{ code?: string | null, label: string }> | null, defaultSupplier?: { code?: string | null, name: string } | null, latestReading?: { date: any, level: number, volumeType?: VolumeType | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> | null, commodities?: Array<{ _id: string, code?: string | null, label: string, unit: GoodUnits }> | null, documents?: Array<{ name: string, url: string }> | null, notes?: Array<{ content: string, accessLevel?: Array<NoteAccessLevel> | null, addToShipment: boolean }> | null, documentRequirements?: Array<{ documentName?: string | null, documentType: DocumentType, attachToInvoice: boolean, requiredForInvoicing: boolean }> | null, customFields?: Array<{ key: string, value?: any | null }> | null } };

export type AddBusinessEntityMutationVariables = Exact<{
  newBusinessEntityData: NewBusinessEntityInputWithType;
}>;


export type AddBusinessEntityMutation = { addBusinessEntity: { _id: string } };

export type EditBusinessEntityMutationVariables = Exact<{
  id: Scalars['String'];
  editBusinessEntityData: BusinessEntityUpdateInput;
}>;


export type EditBusinessEntityMutation = { editBusinessEntity: { _id: string } };

export type DeleteBusinessEntityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBusinessEntityMutation = { deleteBusinessEntity: boolean };

export type BulkAddBusinessEntitiesMutationVariables = Exact<{
  newBusinessEntityData: Array<NewBusinessEntityInputWithType> | NewBusinessEntityInputWithType;
}>;


export type BulkAddBusinessEntitiesMutation = { bulkAddBusinessEntities: Array<{ _id: string }> };

export type GetBusinessStorageFacilitiesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBusinessStorageFacilitiesQuery = { businessEntityById: { _id: string, type: BusinessEntityType, name: string, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, linkedStorageFacilityIds?: Array<string> | null, commodities?: Array<{ _id: string, code?: string | null, label: string, unit: GoodUnits, weight: number }> | null, customFields?: Array<{ key: string, value?: any | null }> | null }> | null } };

export type BulkEditBusinessEntitiesMutationVariables = Exact<{
  editBusinessEntityData: BusinessEntityUpdateInput;
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type BulkEditBusinessEntitiesMutation = { bulkEditBusinessEntities: { matchedCount?: number | null, modifiedCount?: number | null, upsertedCount?: number | null } };

export type GetCustomFieldDefinitionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetCustomFieldDefinitionsQuery = { cutomFieldDefinitions: { data: Array<{ _id: string, key: string, label: string, description: string, defaultOption?: string | null, selectOptionsEntity?: CustomFieldSelectOptionEntity | null, selectOptionsEndpoint?: string | null, type: CustomFieldType, context: Array<CustomFieldContext>, isRequirement?: boolean | null, extensionId?: string | null, isExtensionField?: boolean | null, selectOptions?: Array<{ key: string, label: string }> | null, requirementOptions?: { isPartial?: boolean | null, isRange?: boolean | null, isRequired?: boolean | null } | null }> } };

export type GetCustomFieldDefinitionDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCustomFieldDefinitionDetailsQuery = { customFieldDefinitionById: { _id: string, key: string, label: string, description: string, defaultOption?: string | null, selectOptionsEntity?: CustomFieldSelectOptionEntity | null, selectOptionsEndpoint?: string | null, type: CustomFieldType, context: Array<CustomFieldContext>, isRequirement?: boolean | null, extensionId?: string | null, isExtensionField?: boolean | null, selectOptions?: Array<{ key: string, label: string }> | null, requirementOptions?: { isPartial?: boolean | null, isRange?: boolean | null, isRequired?: boolean | null } | null } };

export type AddCustomFieldDefinitionMutationVariables = Exact<{
  newCustomFieldDefinitionData: NewCustomFieldDefinitionInput;
}>;


export type AddCustomFieldDefinitionMutation = { addCustomFieldDefinition: { _id: string } };

export type EditCustomFieldDefinitionMutationVariables = Exact<{
  id: Scalars['String'];
  editCustomFieldDefinitionData: CustomFieldDefinitionUpdateInput;
}>;


export type EditCustomFieldDefinitionMutation = { editCustomFieldDefinition: { _id: string } };

export type DeleteCustomFieldDefinitionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCustomFieldDefinitionMutation = { deleteCustomFieldDefinition: boolean };

export type GetCustomerListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCustomerListQuery = { customers: { count: number, data: Array<{ _id: string, code?: string | null, name: string, type: BusinessEntityType, tags?: Array<string> | null, address: { label: string }, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string } }> } };

export type GetCustomerDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCustomerDetailsQuery = { customerById: { _id: string, name: string, code?: string | null, additionalTypes?: Array<BusinessEntityType> | null, addressTimezone?: string | null, billingEmail?: string | null, billingTermsDay?: number | null, remitEmail?: string | null, type: BusinessEntityType, tags?: Array<string> | null, referenceNumberTypes?: Array<ShipmentReferenceNumberType> | null, address: { label: string, city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, coordinates: { latitude: number, longitude: number } }, billingAddress?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, remitAddress?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, contact: { email?: string | null, firstname: string, lastname: string, phoneNumber: string }, openingSchedules?: Array<{ openingTime: string, closingTime: string, days: Array<number> }> | null, additionalContacts?: Array<{ firstname: string, lastname: string, email?: string | null, phoneNumber: string }> | null, goodInventoryItems?: Array<{ _id?: string | null, label: string, weight?: number | null }> | null, defaultReferenceNumbers?: Array<{ referenceNumberType: ShipmentReferenceNumberType, referenceNumberValue: string }> | null } };

export type AddCustomerMutationVariables = Exact<{
  newCustomerData: NewBusinessEntityInput;
}>;


export type AddCustomerMutation = { addCustomer: { _id: string } };

export type EditCustomerMutationVariables = Exact<{
  id: Scalars['String'];
  editCustomerData: BusinessEntityUpdateInput;
}>;


export type EditCustomerMutation = { editCustomer: { _id: string } };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCustomerMutation = { deleteCustomer: boolean };

export type GetDriverListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  where?: InputMaybe<DriverWhere>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDriverListQuery = { drivers: { count: number, data: Array<{ _id: string, eldId?: string | null, externalId?: string | null, firstname: string, lastname: string, phoneNumber?: string | null, status: AssetStatus, domicileId?: any | null, tags?: Array<string> | null, groupIds?: Array<any> | null, domicileEntity?: { _id: string, name: string, addressTimezone?: string | null } | null, license?: { licenseNumber?: string | null, expiryDate?: any | null } | null, medical?: { number?: string | null, expiryDate?: any | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type GetDriverDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDriverDetailsQuery = { driverById: { _id: string, dateOfBirth?: any | null, dateOfPhysicalExamination?: any | null, domicileId?: any | null, eldId?: string | null, externalId?: string | null, firstname: string, isOwnerOperator?: boolean | null, middlename?: string | null, lastname: string, phoneNumber?: string | null, status: AssetStatus, userId?: string | null, tags?: Array<string> | null, groupIds?: Array<any> | null, documents?: Array<{ _id: string, name: string, url: string }> | null, domicileEntity?: { _id: string, name: string, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, license?: { classification?: DriverLicenseClassification | null, endorsements?: Array<DriverLicenseEndorsement> | null, expiryDate?: any | null, issuedDate?: any | null, issuedState?: string | null, licenseNumber?: string | null, restriction?: DriverLicenseRestriction | null, address?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null } | null, medical?: { number?: string | null, expiryDate?: any | null, issuedDate?: any | null, restriction?: string | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null } };

export type DeleteDriverMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDriverMutation = { deleteDriver: boolean };

export type AddDriverMutationVariables = Exact<{
  newDriverData: NewDriverInput;
}>;


export type AddDriverMutation = { addDriver: { _id: string, userId?: string | null } };

export type EditDriverMutationVariables = Exact<{
  id: Scalars['String'];
  editDriverData: DriverUpdateInput;
}>;


export type EditDriverMutation = { editDriver: { _id: string } };

export type BulkAddDriversMutationVariables = Exact<{
  newDriverData: Array<NewDriverInput> | NewDriverInput;
}>;


export type BulkAddDriversMutation = { bulkAddDrivers: Array<{ _id: string }> };

export type BulkEditDriversMutationVariables = Exact<{
  editDriverData: BulkEditDriverInput;
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type BulkEditDriversMutation = { bulkEditDrivers: { matchedCount?: number | null, modifiedCount?: number | null, upsertedCount?: number | null } };

export type AddDwellTimeUptickMutationVariables = Exact<{
  newDwellTimeUptickData: NewDwellTimeUptickInput;
}>;


export type AddDwellTimeUptickMutation = { addDwellTimeUptick: { _id: string } };

export type EditDwellTimeUptickMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  editDwellTimeUptickData: NewDwellTimeUptickInput;
}>;


export type EditDwellTimeUptickMutation = { editDwellTimeUptick: { _id: string } };

export type DeleteDwellTimeUptickMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type DeleteDwellTimeUptickMutation = { deleteDwellTimeUptick: boolean };

export type DwellTimeUpticksQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
}>;


export type DwellTimeUpticksQuery = { dwellTimeUpticks: { count: number, data: Array<{ _id: string, startDate: any, endDate: any, addedTimeInMinutes: number, groupIds?: Array<string> | null }> } };

export type GetGroupsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetGroupsQuery = { groups: { data: Array<{ _id: string, name: string, memberIds: Array<string>, defaultFromReceiverForOrders?: boolean | null }> } };

export type GetGroupDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGroupDetailsQuery = { groupById: { _id: string, name: string, memberIds: Array<string>, defaultFromReceiverForOrders?: boolean | null } };

export type AddGroupMutationVariables = Exact<{
  newGroupData: NewGroupInput;
}>;


export type AddGroupMutation = { addGroup: { _id: string } };

export type EditGroupMutationVariables = Exact<{
  id: Scalars['String'];
  editGroupData: GroupUpdateInput;
}>;


export type EditGroupMutation = { editGroup: { _id: string } };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteGroupMutation = { deleteGroup: boolean };

export type GetReceiverListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetReceiverListQuery = { receivers: { count: number, data: Array<{ _id: string, code?: string | null, name: string, type: BusinessEntityType, tags?: Array<string> | null, status: AssetStatus, groupIds?: Array<any> | null, address: { label: string }, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string } }> } };

export type GetReceiverDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReceiverDetailsQuery = { receiverById: { _id: string, name: string, code?: string | null, additionalTypes?: Array<BusinessEntityType> | null, addressTimezone?: string | null, type: BusinessEntityType, tags?: Array<string> | null, status: AssetStatus, groupIds?: Array<any> | null, address: { label: string, city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, coordinates: { latitude: number, longitude: number } }, remitAddress?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, contact: { email?: string | null, firstname: string, lastname: string, phoneNumber: string }, openingSchedules?: Array<{ openingTime: string, closingTime: string, days: Array<number> }> | null, additionalContacts?: Array<{ firstname: string, lastname: string, email?: string | null, phoneNumber: string }> | null, parentBusinessEntity?: { type: BusinessEntityType, _id: string } | null } };

export type GetReceiverListWithStorageFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReceiverListWithStorageFacilitiesQuery = { businessEntities: { data: Array<{ _id: string, code?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } }, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, linkedStorageFacilityIds?: Array<string> | null }> | null }> } };

export type AddReceiverMutationVariables = Exact<{
  newReceiverData: NewBusinessEntityInput;
}>;


export type AddReceiverMutation = { addReceiver: { _id: string } };

export type EditReceiverMutationVariables = Exact<{
  id: Scalars['String'];
  editReceiverData: BusinessEntityUpdateInput;
}>;


export type EditReceiverMutation = { editReceiver: { _id: string } };

export type DeleteReceiverMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteReceiverMutation = { deleteReceiver: boolean };

export type GetShipperListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetShipperListQuery = { shippers: { count: number, data: Array<{ _id: string, code?: string | null, name: string, type: BusinessEntityType, tags?: Array<string> | null, status: AssetStatus, address: { label: string }, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string } }> } };

export type GetShipperDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetShipperDetailsQuery = { shipperById: { _id: string, name: string, code?: string | null, additionalTypes?: Array<BusinessEntityType> | null, addressTimezone?: string | null, type: BusinessEntityType, tags?: Array<string> | null, status: AssetStatus, address: { label: string, city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, coordinates: { latitude: number, longitude: number } }, remitAddress?: { city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, contact: { email?: string | null, firstname: string, lastname: string, phoneNumber: string }, openingSchedules?: Array<{ openingTime: string, closingTime: string, days: Array<number> }> | null, additionalContacts?: Array<{ firstname: string, lastname: string, email?: string | null, phoneNumber: string }> | null } };

export type AddShipperMutationVariables = Exact<{
  newShipperData: NewBusinessEntityInput;
}>;


export type AddShipperMutation = { addShipper: { _id: string } };

export type EditShipperMutationVariables = Exact<{
  id: Scalars['String'];
  editShipperData: BusinessEntityUpdateInput;
}>;


export type EditShipperMutation = { editShipper: { _id: string } };

export type DeleteShipperMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteShipperMutation = { deleteShipper: boolean };

export type GetTractorListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetTractorListQuery = { tractors: { count: number, data: Array<{ _id: string, licenseNumber?: string | null, make?: string | null, model?: string | null, serialNumber: string, plateNumber?: string | null, status: AssetStatus, tareWeight?: number | null, year?: number | null, tags?: Array<string> | null, groupIds?: Array<any> | null, domicile?: { city?: string | null, country?: string | null, label: string } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type GetTractorDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTractorDetailsQuery = { tractorById: { _id: string, eldId?: string | null, externalId?: string | null, licenseNumber?: string | null, plateNumber?: string | null, make?: string | null, model?: string | null, serialNumber: string, status: AssetStatus, tareWeight?: number | null, mileage?: number | null, year?: number | null, tags?: Array<string> | null, groupIds?: Array<any> | null, documents?: Array<{ _id?: string | null, name: string, url: string }> | null, domicile?: { label: string, city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, coordinates: { latitude: number, longitude: number } } | null, customFields?: Array<{ key: string, value?: any | null }> | null } };

export type DeleteTractorMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTractorMutation = { deleteTractor: boolean };

export type AddTractorMutationVariables = Exact<{
  newTractorData: NewTractorInput;
}>;


export type AddTractorMutation = { addTractor: { _id: string } };

export type EditTractorMutationVariables = Exact<{
  id: Scalars['String'];
  editTractorData: TractorUpdateInput;
}>;


export type EditTractorMutation = { editTractor: { _id: string } };

export type BulkAddTractorsMutationVariables = Exact<{
  newTractorsData: Array<NewTractorInput> | NewTractorInput;
}>;


export type BulkAddTractorsMutation = { bulkAddTractors: Array<{ _id: string }> };

export type BulkEditTractorsMutationVariables = Exact<{
  editTractorData: TractorUpdateInput;
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type BulkEditTractorsMutation = { bulkEditTractors: { matchedCount?: number | null, modifiedCount?: number | null, upsertedCount?: number | null } };

export type GetTrailersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrailersQuery = { trailers: { data: Array<{ _id: string, serialNumber: string, status: AssetStatus, type: TrailerType, maxWeight?: number | null, tags?: Array<string> | null, lastKnownLocation?: { latitude: number, longitude: number } | null, customFields?: Array<{ key: string, value?: any | null }> | null, compartments?: Array<{ identifier: string, capacity: number, unit: TrailerCompartmentUnit, minVolume?: number | null, maxVolume?: number | null, heavyOnly?: boolean | null, hasDoubleBulkheadAfter?: boolean | null }> | null }> } };

export type GetTrailerListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetTrailerListQuery = { trailers: { count: number, data: Array<{ _id: string, licenseNumber?: string | null, serialNumber: string, status: AssetStatus, type: TrailerType, hasMeteredPump?: boolean | null, tags?: Array<string> | null, groupIds?: Array<any> | null, domicile?: { label: string, city?: string | null, country?: string | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type GetTrailerDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTrailerDetailsQuery = { trailerById: { _id: string, width?: number | null, height?: number | null, length?: number | null, maxWeight?: number | null, licenseNumber?: string | null, maxTemperature?: number | null, minTemperature?: number | null, numberOfAxles?: number | null, serialNumber: string, vin?: string | null, serial?: string | null, mileage?: number | null, status: AssetStatus, type: TrailerType, hasMeteredPump?: boolean | null, tags?: Array<string> | null, groupIds?: Array<any> | null, documents?: Array<{ _id?: string | null, name: string, url: string }> | null, domicile?: { label: string, city?: string | null, country?: string | null, googlePlaceId?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null, coordinates: { latitude: number, longitude: number } } | null, compartments?: Array<{ identifier: string, capacity: number, unit: TrailerCompartmentUnit, minVolume?: number | null, maxVolume?: number | null, heavyOnly?: boolean | null, hasDoubleBulkheadAfter?: boolean | null }> | null, compartmentVolumes?: Array<{ _id: any, compartmentId: string, commodityId?: string | null, quantity: number, lastUpdated: any, lastShipmentId?: any | null, lastShipmentNumber?: string | null, updatedBy: string }> | null, customFields?: Array<{ key: string, value?: any | null }> | null } };

export type UpdateCompartmentVolumeMutationVariables = Exact<{
  trailerId: Scalars['String'];
  compartmentId: Scalars['String'];
  commodityId: Scalars['String'];
  quantity: Scalars['Float'];
}>;


export type UpdateCompartmentVolumeMutation = { updateCompartmentVolume: { _id: any, compartmentId: string, commodityId?: string | null, quantity: number, lastUpdated: any, updatedBy: string } };

export type ResetTrailerCompartmentVolumesMutationVariables = Exact<{
  trailerId: Scalars['String'];
}>;


export type ResetTrailerCompartmentVolumesMutation = { resetTrailerCompartmentVolumes: boolean };

export type DeleteTrailerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTrailerMutation = { deleteTrailer: boolean };

export type AddTrailerMutationVariables = Exact<{
  newTrailerData: NewTrailerInput;
}>;


export type AddTrailerMutation = { addTrailer: { _id: string } };

export type EditTrailerMutationVariables = Exact<{
  id: Scalars['String'];
  editTrailerData: TrailerUpdateInput;
}>;


export type EditTrailerMutation = { editTrailer: { _id: string } };

export type BulkAddTrailersMutationVariables = Exact<{
  newTrailerData: Array<NewTrailerInput> | NewTrailerInput;
}>;


export type BulkAddTrailersMutation = { bulkAddTrailers: Array<{ _id: string }> };

export type BulkEditTrailersMutationVariables = Exact<{
  editTrailerData: TrailerUpdateInput;
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type BulkEditTrailersMutation = { bulkEditTrailers: { matchedCount?: number | null, modifiedCount?: number | null, upsertedCount?: number | null } };

export type TrailerEventsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type TrailerEventsQuery = { trailerEvents: { count: number, data: Array<{ _id: string, date: any, trailerId: any, type: TrailerEventType }> } };

export type AddTrailerEventMutationVariables = Exact<{
  newTrailerEventData: NewTrailerEventInput;
}>;


export type AddTrailerEventMutation = { addTrailerEvent: { _id: string } };

export type EditTrailerEventMutationVariables = Exact<{
  id: Scalars['String'];
  editTrailerEventData: TrailerEventUpdateInput;
}>;


export type EditTrailerEventMutation = { editTrailerEvent: { _id: string } };

export type DeleteTrailerEventMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTrailerEventMutation = { deleteTrailerEvent: boolean };

export type SupplierContractsQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ObjectId']>;
  goodProfileId?: InputMaybe<Scalars['ObjectId']>;
  search?: InputMaybe<Scalars['String']>;
  shipperId?: InputMaybe<Scalars['ObjectId']>;
  skip?: InputMaybe<Scalars['Int']>;
  supplierId?: InputMaybe<Scalars['ObjectId']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type SupplierContractsQuery = { supplierContracts: { count: number, data: Array<{ _id: string, contractNumber: string, customerId?: any | null, endDate: any, goodProfileId: any, shipperId?: any | null, startDate: any, supplierId: any, unitPrice: number, pinCode?: string | null, allocation?: { dailyQuantity?: number | null, monthlyQuantity?: number | null, weeklyQuantity?: number | null, totalQuantity?: number | null } | null, usedAllocation?: { dailyQuantity?: number | null, monthlyQuantity?: number | null, weeklyQuantity?: number | null, totalQuantity?: number | null } | null, customer?: { _id: string, code?: string | null, name: string, type: BusinessEntityType } | null, goodProfile?: { _id: string, code?: string | null, label: string } | null, shipper?: { _id: string, name: string, type: BusinessEntityType, code?: string | null } | null }> } };

export type SupplierContractByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SupplierContractByIdQuery = { supplierContractById: { _id: string, contractNumber: string, customerId?: any | null, endDate: any, goodProfileId: any, shipperId?: any | null, startDate: any, supplierId: any, unitPrice: number, pinCode?: string | null, allocation?: { dailyQuantity?: number | null, monthlyQuantity?: number | null, weeklyQuantity?: number | null, totalQuantity?: number | null } | null, usedAllocation?: { dailyQuantity?: number | null, monthlyQuantity?: number | null, weeklyQuantity?: number | null, totalQuantity?: number | null } | null, customer?: { _id: string, code?: string | null, name: string, type: BusinessEntityType } | null, goodProfile?: { _id: string, code?: string | null, label: string } | null, shipper?: { _id: string, name: string, type: BusinessEntityType, code?: string | null } | null, conditions?: Array<{ target: SupplierContractConditionTarget, operator: BillingRuleConditionOperator, value?: any | null }> | null } };

export type EditSupplierContractMutationVariables = Exact<{
  editSupplierContractData: SupplierContractUpdateInput;
  id: Scalars['String'];
}>;


export type EditSupplierContractMutation = { editSupplierContract: { _id: string } };

export type AddSupplierContractMutationVariables = Exact<{
  newSupplierContractData: NewSupplierContractInput;
}>;


export type AddSupplierContractMutation = { addSupplierContract: { _id: string } };

export type DeleteSupplierContractMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSupplierContractMutation = { deleteSupplierContract: boolean };

export type GetShipmentsForBestBuyBulkUpdateQueryVariables = Exact<{
  shipmentIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type GetShipmentsForBestBuyBulkUpdateQuery = { shipments: { data: Array<{ _id: string, shipmentNumber: string, customer: { _id: string }, shipmentLocations: Array<{ location: { latitude: number, longitude: number }, shippedGoods?: Array<{ _id: string, goodProfileId?: any | null, label: string, quantity: number, unit?: GoodUnits | null, weight?: number | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, goodProfileId?: any | null }> | null }>, route?: { firstPickupTime: any, lastDropoffTime: any } | null }> } };

export type RankSupplierContractsForPurchaseMutationVariables = Exact<{
  purchase: PurchaseInput;
}>;


export type RankSupplierContractsForPurchaseMutation = { rankSupplierContractsForPurchase: Array<{ costPerMile: number, mileage: number, productCost: number, quantity: number, shippingCost: number, totalCost: number, unitPrice: number, supplierContract: { _id: string, contractNumber: string, shipperId?: any | null, supplierId: any, pinCode?: string | null, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, supplier?: { _id: string, name: string } | null } }> };

export type RankSupplierContractsForPurchasesMutationVariables = Exact<{
  purchases: Array<PurchaseInput> | PurchaseInput;
}>;


export type RankSupplierContractsForPurchasesMutation = { rankSupplierContractsForPurchases: Array<{ costPerMile: number, mileage: number, productCost: number, quantity: number, shippingCost: number, totalCost: number, unitPrice: number, supplierContract: { _id: string, contractNumber: string, shipperId?: any | null, supplierId: any, pinCode?: string | null, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, supplier?: { _id: string, name: string } | null } }> };

export type BulkUpdateContractForShipmentsMutationVariables = Exact<{
  shipmentIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  contractId: Scalars['ObjectId'];
}>;


export type BulkUpdateContractForShipmentsMutation = { bulkUpdateContractForShipments: Array<{ _id: string }> };

export type GetGoodProfileClassListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetGoodProfileClassListQuery = { goodProfileClasses: { count: number, data: Array<{ _id: any, label: string, description?: string | null }> } };

export type GetGoodProfileClassDetailsQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type GetGoodProfileClassDetailsQuery = { goodProfileClassById?: { _id: any, label: string, description?: string | null } | null };

export type DeleteGoodProfileClassMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type DeleteGoodProfileClassMutation = { deleteGoodProfileClass?: boolean | null };

export type AddGoodProfileClassMutationVariables = Exact<{
  newGoodProfileClassData: NewGoodProfileClassInput;
}>;


export type AddGoodProfileClassMutation = { addGoodProfileClass: { _id: any } };

export type EditGoodProfileClassMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  editGoodProfileClassData: GoodProfileClassUpdateInput;
}>;


export type EditGoodProfileClassMutation = { editGoodProfileClass?: { _id: any } | null };

export type BulkAddGoodProfileClassesMutationVariables = Exact<{
  newGoodProfileClassesData: Array<NewGoodProfileClassInput> | NewGoodProfileClassInput;
}>;


export type BulkAddGoodProfileClassesMutation = { bulkAddGoodProfileClasses: Array<{ _id: any }> };

export type GetGoodProfileListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGoodProfileListQuery = { goodProfiles: { count: number, data: Array<{ _id: string, code?: string | null, label: string, status?: AssetStatus | null, weight: number, liquidGravity?: number | null, unit: GoodUnits, productType?: GoodProfileProductType | null, supplierIds?: Array<any> | null, shipperIds?: Array<any> | null, color?: string | null, goodProfileClassId?: any | null, tags?: Array<string> | null, groupIds?: Array<any> | null, goodProfileClass?: { _id: any, label: string } | null, equivalences?: Array<{ equivalentGoodId: any, conditions: Array<{ operator: GoodProfileEquivalenceConditionOperator, target: GoodProfileEquivalenceConditionTarget, value?: any | null }> }> | null, restrictions?: Array<{ type: GoodProfileRestrictionType, value?: any | null }> | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type GetGoodProfileDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGoodProfileDetailsQuery = { goodProfileById: { _id: string, code?: string | null, label: string, status?: AssetStatus | null, weight: number, liquidGravity?: number | null, unit: GoodUnits, productType?: GoodProfileProductType | null, supplierIds?: Array<any> | null, shipperIds?: Array<any> | null, color?: string | null, goodProfileClassId?: any | null, tags?: Array<string> | null, groupIds?: Array<any> | null, documents?: Array<{ _id?: string | null, name: string, url: string }> | null, goodProfileClass?: { _id: any, label: string } | null, equivalences?: Array<{ equivalentGoodId: any, conditions: Array<{ operator: GoodProfileEquivalenceConditionOperator, target: GoodProfileEquivalenceConditionTarget, value?: any | null }> }> | null, restrictions?: Array<{ type: GoodProfileRestrictionType, value?: any | null }> | null, customFields?: Array<{ key: string, value?: any | null }> | null } };

export type DeleteGoodProfileMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteGoodProfileMutation = { deleteGoodProfile: boolean };

export type AddGoodProfileMutationVariables = Exact<{
  newGoodProfileData: NewGoodProfileInput;
}>;


export type AddGoodProfileMutation = { addGoodProfile: { _id: string } };

export type EditGoodProfileMutationVariables = Exact<{
  id: Scalars['String'];
  editGoodProfileData: GoodProfileUpdateInput;
}>;


export type EditGoodProfileMutation = { editGoodProfile: { _id: string } };

export type BulkAddGoodProfilesMutationVariables = Exact<{
  newGoodProfilesData: Array<NewGoodProfileInput> | NewGoodProfileInput;
}>;


export type BulkAddGoodProfilesMutation = { bulkAddGoodProfiles: Array<{ _id: string }> };

export type BulkEditGoodProfilesMutationVariables = Exact<{
  editGoodProfileData: GoodProfileUpdateInput;
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type BulkEditGoodProfilesMutation = { bulkEditGoodProfiles: { matchedCount?: number | null, modifiedCount?: number | null, upsertedCount?: number | null } };

export type GetCustomerOrderListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetCustomerOrderListQuery = { customerOrders: { count: number, data: Array<{ _id: string, orderNumber: string, status: Status, customer?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shipment?: { _id: string, shipmentNumber: string, commodityType?: ShipmentCommodityType | null, purchaseOrderNumbers?: Array<string> | null, billOfLadingNumbers?: Array<string> | null, referenceNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, status: Status, createdBy: string, trailerType: TrailerType, additionalTrailerTypes?: Array<TrailerType> | null, loadType: LoadType, tripId?: string | null, reasonForCancellation?: string | null, events?: Array<{ _id: string, createdBy: string, date: any, shipmentLocation?: string | null, type: ShipmentEventType, label?: string | null, description?: string | null, metadata?: any | null, coordinates?: { altitude?: number | null, heading?: number | null, latitude: number, longitude: number, speed?: number | null } | null }> | null, issues?: Array<{ _id: string, type: string, content: string, date: any, shipmentLocation?: string | null, delayAmount?: number | null, attachedDocuments: Array<string> }> | null, constraints?: Array<{ type: ShipmentConstraintType, value: string, unit?: string | null }> | null, documents?: Array<{ _id: string, associatedCharge?: string | null, accessLevel: Array<NoteAccessLevel>, isBillable: boolean, isForRatecons: boolean, isForReceivers: boolean, name: string, type: string, url: string, shipper?: { _id: string, name: string } | null, receiver?: { _id: string, name: string } | null }> | null, notes?: Array<{ _id: string, accessLevel: Array<NoteAccessLevel>, content: string, receiver?: { _id: string, name: string } | null, shipper?: { _id: string, name: string } | null }> | null, customer: { _id: string, name: string, referenceNumberTypes?: Array<ShipmentReferenceNumberType> | null, type: BusinessEntityType, address: { label: string, coordinates: { latitude: number, longitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string } }, shipmentLocations: Array<{ _id: string, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, shippedGoods?: Array<{ _id: string, quantity: number, weight?: number | null, label: string, unit?: GoodUnits | null, goodProfileId?: any | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number } }>, charges: Array<{ _id: string, total: number, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, relatedTransactionId?: any | null, billingRule?: { _id: string, label?: string | null, referenceNumber?: string | null } | null, document?: { name: string, url: string } | null }>, expenses?: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, document?: { name: string, url: string } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> | null, route?: { routeDistance: number, firstPickupTime: any, predictedLoadedDistance?: number | null, locations?: Array<{ _id: string, shipper?: { _id: string } | null, receiver?: { _id: string } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null } | null, locations: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }>, receivedGoods?: Array<{ goodId: string, goodProfileId?: any | null, quantity?: number | null, goodProfile?: { _id: string, label: string, code?: string | null, unit: GoodUnits, weight: number } | null }> | null }> }> } };

export type GetCustomerShipmentListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  status?: InputMaybe<Status>;
}>;


export type GetCustomerShipmentListQuery = { customerShipments: { count: number, data: Array<{ _id: string, shipmentNumber: string, purchaseOrderNumbers?: Array<string> | null, billOfLadingNumbers?: Array<string> | null, referenceNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, status: Status, trailerType: TrailerType, additionalTrailerTypes?: Array<TrailerType> | null, tripId?: string | null, isSplit?: boolean | null, isFromSplit?: boolean | null, isFromRotation?: boolean | null, tags?: Array<string> | null, groupIds?: Array<any> | null, order?: { _id: string, status: Status, orderNumber: string, locations: Array<{ addressLabel?: string | null }> } | null, shipmentLocations: Array<{ _id: string, locationType: ShipmentLocationType, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number }, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, shippedGoods?: Array<{ _id: string, goodProfileId?: any | null, label: string, quantity: number, unit?: GoodUnits | null, weight?: number | null, supplierId?: any | null }> | null, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null }>, route?: { routeDistance: number, firstPickupTime: any, lastDropoffTime: any, locations?: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null, charges: Array<{ _id: string, rate: number, unit: number }>, trip?: { _id: string, tripNumber?: string | null, driver?: string | null, tractor?: string | null, trailer?: string | null, carrier?: string | null, driverEntity?: { _id: string, firstname: string, lastname: string, phoneNumber?: string | null, status: AssetStatus } | null, tractorEntity?: { _id: string, serialNumber: string, licenseNumber?: string | null, status: AssetStatus } | null, trailerEntity?: { _id: string, serialNumber: string, licenseNumber?: string | null, status: AssetStatus, type: TrailerType } | null, carrierEntity?: { _id: string, name: string, status: AssetStatus, type: BusinessEntityType, contact: { firstname: string, lastname: string, phoneNumber: string }, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null } | null, parentShipment?: { _id: string } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type GetCustomerOrderDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCustomerOrderDetailsQuery = { customerOrderById: { _id: string, orderNumber: string, customerId: any, status: Status, customer?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, locations: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }>, receivedGoods?: Array<{ goodId: string, goodProfileId?: any | null, quantity?: number | null, goodProfile?: { _id: string, label: string, code?: string | null, unit: GoodUnits, weight: number } | null }> | null }> } };

export type DeleteCustomerOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCustomerOrderMutation = { deleteCustomerOrder: boolean };

export type AddCustomerOrderMutationVariables = Exact<{
  newOrderData: NewOrderInput;
}>;


export type AddCustomerOrderMutation = { addCustomerOrder: { _id: string } };

export type EditCustomerOrderMutationVariables = Exact<{
  id: Scalars['String'];
  editOrderData: OrderUpdateInput;
}>;


export type EditCustomerOrderMutation = { editCustomerOrder: { _id: string } };

export type ListOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrganizationsQuery = { organizations: Array<{ _id?: string | null, _organization: string, name: string, dotNumber?: string | null }> };

export type OrganizationsForStageQueryVariables = Exact<{
  stage: Scalars['String'];
}>;


export type OrganizationsForStageQuery = { organizationsForStage: Array<{ _id?: string | null, _organization: string, name: string, dotNumber?: string | null }> };

export type TransferOrganizationDataMutationVariables = Exact<{
  input: TransferOrganizationDataInput;
}>;


export type TransferOrganizationDataMutation = { transferOrganizationData: { success: boolean, message: string, totalRecordsTransferred: number, duration: number, timestamp: any, transferredCollections: Array<{ collectionName: string, recordCount: number, success: boolean, error?: string | null }> } };

export type GetDriverShiftAssignmentsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']>;
}>;


export type GetDriverShiftAssignmentsQuery = { driverShiftAssignments: { count: number, data: Array<{ _id: string, driverId: any, driverShiftId: any, startDate?: any | null, endDate?: any | null, driver?: { _id: string, firstname: string, lastname: string, domicileEntity?: { _id: string, name: string, addressTimezone?: string | null } | null } | null, driverShift?: { _id: string, label?: string | null } | null }> } };

export type GetDriverShiftAssignmentDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDriverShiftAssignmentDetailsQuery = { driverShiftAssignment?: { _id: string, driverId: any, driverShiftId: any, startDate?: any | null, endDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, driverShift?: { _id: string, label?: string | null } | null } | null };

export type AddDriverShiftAssignmentMutationVariables = Exact<{
  newDriverShiftAssignmentData: NewDriverShiftAssignmentInput;
}>;


export type AddDriverShiftAssignmentMutation = { addDriverShiftAssignment: { _id: string } };

export type EditDriverShiftAssignmentMutationVariables = Exact<{
  id: Scalars['String'];
  editDriverShiftAssignmentData: DriverShiftAssignmentUpdateInput;
}>;


export type EditDriverShiftAssignmentMutation = { editDriverShiftAssignment: { _id: string } };

export type DeleteDriverShiftAssignmentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDriverShiftAssignmentMutation = { deleteDriverShiftAssignment: boolean };

export type GetDriverShiftListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetDriverShiftListQuery = { driverShifts: { count: number, data: Array<{ _id: string, label?: string | null, days: Array<number>, driverIds?: Array<any> | null, domicileId?: any | null, isAdhoc?: boolean | null, startTime: { hour: number, minute: number }, endTime: { hour: number, minute: number }, domicile?: { _id: string, name: string } | null }> } };

export type GetDriverShiftDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDriverShiftDetailsQuery = { driverShiftById?: { _id: string, label?: string | null, days: Array<number>, driverIds?: Array<any> | null, domicileId?: any | null, isAdhoc?: boolean | null, startTime: { hour: number, minute: number }, endTime: { hour: number, minute: number } } | null };

export type GetDriverShiftDetailsForDriverQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type GetDriverShiftDetailsForDriverQuery = { driverShiftByDriverId?: { _id: string, days: Array<number>, label?: string | null, driverIds?: Array<any> | null, domicileId?: any | null, isAdhoc?: boolean | null, startTime: { hour: number, minute: number }, endTime: { hour: number, minute: number } } | null };

export type AddDriverShiftMutationVariables = Exact<{
  newDriverShiftData: NewDriverShiftInput;
}>;


export type AddDriverShiftMutation = { addDriverShift: { _id: string } };

export type EditDriverShiftMutationVariables = Exact<{
  id: Scalars['String'];
  editDriverShiftData: DriverShiftUpdateInput;
}>;


export type EditDriverShiftMutation = { editDriverShift: { _id: string } };

export type DeleteDriverShiftMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDriverShiftMutation = { deleteDriverShift: boolean };

export type GetAllDriversAndShiftsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDriversAndShiftsQuery = { drivers: { data: Array<{ _id: string, firstname: string, lastname: string, phoneNumber?: string | null, domicileId?: any | null }> }, driverShifts: { data: Array<{ _id: string, label?: string | null, days: Array<number>, driverIds?: Array<any> | null, domicileId?: any | null, isAdhoc?: boolean | null, startTime: { hour: number, minute: number }, endTime: { hour: number, minute: number } }> } };

export type GetAllDriverShiftsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDriverShiftsQuery = { driverShifts: { data: Array<{ _id: string, label?: string | null, days: Array<number>, driverIds?: Array<any> | null, domicileId?: any | null, isAdhoc?: boolean | null, startTime: { hour: number, minute: number }, endTime: { hour: number, minute: number }, domicile?: { addressTimezone?: string | null } | null }> } };

export type GetExtensionsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']>;
}>;


export type GetExtensionsQuery = { extensions: { data: Array<{ installed: boolean, extension: { _id: string, name: string, description: string, coverImage?: string | null, websiteUrl?: string | null, configurationDefinitions: Array<{ name: string, description: string, type: string, defaultValue?: string | null, required: boolean }>, settings: { rootUrl: string, configureEndpoint?: string | null } } }> } };

export type InstallExtensionMutationVariables = Exact<{
  extensionId: Scalars['String'];
  configurationValues: Array<ExtensionConfigurationValueInput> | ExtensionConfigurationValueInput;
}>;


export type InstallExtensionMutation = { installExtension: { redirectUrl?: string | null, configurationValues: Array<{ name: string, value: any }> } };

export type UninstallExtensionMutationVariables = Exact<{
  extensionId: Scalars['String'];
}>;


export type UninstallExtensionMutation = { uninstallExtension: boolean };

export type GetExtensionsMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExtensionsMessagesQuery = { extensionsMessages: Array<{ text: string, type: ExtensionMessageType, extensionId: string, extensionName: string, context?: ExtensionMessageContext | null, actions?: Array<{ text: string, type: ExtensionActionType, url: string }> | null }> };

export type GetExtensionsOperationsQueryVariables = Exact<{
  context: ExtensionOperationContext;
}>;


export type GetExtensionsOperationsQuery = { extensionsOperations: Array<{ key: string, name: string, description: string, icon: string, extensionId: string, filter?: any | null, context: ExtensionOperationContext, endpoint: string }> };

export type GetExtensionsWidgetsQueryVariables = Exact<{
  context: ExtensionWidgetContext;
}>;


export type GetExtensionsWidgetsQuery = { extensionsWidgets: Array<{ label: string, endpoint: string, rootUrl: string }> };

export type CallExtensionOperationMutationVariables = Exact<{
  extensionId: Scalars['String'];
  operationKey: Scalars['String'];
  recordId: Scalars['String'];
}>;


export type CallExtensionOperationMutation = { callExtensionOperation: { message?: string | null, redirect?: string | null, openNewWindow?: boolean | null } };

export type CallBulkExtensionOperationMutationVariables = Exact<{
  extensionId: Scalars['String'];
  operationKey: Scalars['String'];
  recordIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CallBulkExtensionOperationMutation = { callBulkExtensionOperation: { totalProcessed: number, successCount: number, failureCount: number, message?: string | null, results: Array<{ recordId: string, success: boolean, message?: string | null, error?: string | null }> } };

export type GetExtensionsUiComponentsQueryVariables = Exact<{
  type: ExtensionUiComponentType;
}>;


export type GetExtensionsUiComponentsQuery = { extensionsUIComponents: Array<{ extensionId: string, type: string, rootUrl: string, endpoint: string }> };

export type ForecastMutationVariables = Exact<{
  payload: ForecastingPayload;
}>;


export type ForecastMutation = { forecast: { shipments: Array<{ _id: string, status: Status, createdBy: string, shipmentNumber: string, loadType: LoadType, commodityType?: ShipmentCommodityType | null, trailerType: TrailerType, customer: { _id: string, name: string, code?: string | null, referenceNumberTypes?: Array<ShipmentReferenceNumberType> | null, type: BusinessEntityType, address: { label: string, coordinates: { latitude: number, longitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string } }, shipmentLocations: Array<{ _id: string, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, name?: string | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number, altitude?: number | null }, shippedGoods?: Array<{ _id: string, goodProfileId?: any | null, label: string, quantity: number, unit?: GoodUnits | null, weight?: number | null, pinCode?: string | null }> | null, receivedGoods?: Array<{ goodId: string, goodProfileId?: any | null, quantity?: number | null, shipperId?: any | null, supplierId?: any | null, unitPrice?: number | null, pinCode?: string | null, storageFacilityId?: string | null }> | null, shipper?: { _id: string, name: string, code?: string | null, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, receiver?: { _id: string, name: string, code?: string | null, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null }>, charges: Array<{ _id: string, total: number, label: string, rate: number, unit: number, unitType: string }>, route?: { routeDistance: number, firstPickupTime: any, lastDropoffTime: any, locations?: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null }> } };

export type PurgeForecastedOrdersMutationVariables = Exact<{
  receiverId: Scalars['ObjectId'];
}>;


export type PurgeForecastedOrdersMutation = { purgeForecastedOrders: boolean };

export type LockOrderMutationVariables = Exact<{
  shipmentId: Scalars['ObjectId'];
}>;


export type LockOrderMutation = { lockOrder: boolean };

export type GetForecastingNotificationsQueryVariables = Exact<{
  receiverId?: InputMaybe<Scalars['ObjectId']>;
}>;


export type GetForecastingNotificationsQuery = { forecastingNotifications: Array<{ level: ForecastingNotificationLevel, message: string, receiverId: any, storageFacilityId: string, receiverForecastId: any }> };

export type UpdateForecastingAutomationConfigMutationVariables = Exact<{
  receiverForecastId: Scalars['ObjectId'];
  config: AutomationConfigInput;
}>;


export type UpdateForecastingAutomationConfigMutation = { updateForecastingAutomationConfig: { _id: string, automationConfig?: { enabled: boolean, frequencyMinutes?: number | null, forecastQuantity?: number | null, lastRunAt?: any | null, nextRunAt?: any | null } | null } };

export type TriggerForecastingManualRunMutationVariables = Exact<{
  receiverForecastId: Scalars['ObjectId'];
}>;


export type TriggerForecastingManualRunMutation = { triggerForecastingManualRun: boolean };

export type ForecastingExecutionLogsQueryVariables = Exact<{
  receiverForecastId: Scalars['ObjectId'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type ForecastingExecutionLogsQuery = { forecastingExecutionLogs: { count: number, data: Array<{ _id: string, receiverForecastId: any, status: ExecutionStatus, startedAt: any, completedAt?: any | null, ordersGenerated?: number | null, lockedOrdersCount?: number | null, errorMessage?: string | null }> } };

export type GetReceiverForecastListForDashboardQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetReceiverForecastListForDashboardQuery = { receiverForecasts: { count: number, data: Array<{ _id: string, receiverId: any, receiver?: { _id: string, name: string, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, runoutDate?: any | null, runoutDateAfterNextShipment?: any | null, currentSalesTrend?: number | null, linkedStorageFacilityIds?: Array<string> | null, commodities?: Array<{ _id: string, label: string, code?: string | null, unit: GoodUnits, weight: number }> | null }> | null, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string } } | null, models: Array<{ _id: string, label?: string | null, storageFacilityId: string, target?: number | null, threshold?: number | null }> }> } };

export type GetReceiverForecastDetailsForDashboardQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReceiverForecastDetailsForDashboardQuery = { receiverForecastById: { _id: string, receiverId: any, receiver?: { _id: string, name: string, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, runoutDate?: any | null, runoutDateAfterNextShipment?: any | null, currentSalesTrend?: number | null, linkedStorageFacilityIds?: Array<string> | null, latestReading?: { date: any, level: number, volumeType?: VolumeType | null } | null, currentForecastedReading?: { date: any, level: number, volumeType?: VolumeType | null } | null, commodities?: Array<{ _id: string, label: string, unit: GoodUnits, code?: string | null, weight: number }> | null }> | null } | null, models: Array<{ _id: string, target?: number | null, threshold?: number | null, weight?: number | null, contaminates?: boolean | null, isExclusive?: boolean | null, label?: string | null, minCapacity?: number | null, maxCapacity?: number | null, storageFacilityId: string, slots?: Array<{ type: ForecastingModelSlotType, salesAmount: number, hourly?: { dayOfWeek: number, startTime: { hour: number, minute: number }, endTime: { hour: number, minute: number } } | null, daily?: { dayOfWeek: number } | null, monthly?: { month: number } | null }> | null }>, trailerProfile: { compartments: Array<{ label: string, capacity: number, maxWeight: number, hasSeparatorBefore: boolean, hasSeparatorAfter: boolean, minUsage: number }> }, readingsFileConfiguration?: { tankIdColumn: string, dateColumn: string, dateFormat: string, timeColumn: string, timeFormat: string, levelColumn: string, storeColumn?: string | null, readingDeviationCriticalThreshold?: number | null, readingDeviationDangerThreshold?: number | null, readingDeviationWarningThreshold?: number | null, runoutCriticalThreshold?: number | null, runoutDangerThreshold?: number | null, runoutWarningThreshold?: number | null, staleReadingCriticalThreshold?: number | null, staleReadingDangerThreshold?: number | null, staleReadingWarningThreshold?: number | null } | null } };

export type DeleteReceiverForecastMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteReceiverForecastMutation = { deleteReceiverForecast: boolean };

export type AddReceiverForecastMutationVariables = Exact<{
  newReceiverForecastData: NewReceiverForecastInput;
}>;


export type AddReceiverForecastMutation = { addReceiverForecast: { _id: string } };

export type EditReceiverForecastMutationVariables = Exact<{
  id: Scalars['String'];
  editReceiverForecastData: ReceiverForecastUpdateInput;
}>;


export type EditReceiverForecastMutation = { editReceiverForecast: { _id: string } };

export type BulkAddReceiverForecastsMutationVariables = Exact<{
  newReceiverForecastsData: Array<NewReceiverForecastInput> | NewReceiverForecastInput;
}>;


export type BulkAddReceiverForecastsMutation = { bulkAddReceiverForecasts: Array<{ _id: string }> };

export type UploadStorageFacilityReadingsCsvDataMutationVariables = Exact<{
  data: Scalars['JSON'];
  receiverId: Scalars['ObjectId'];
}>;


export type UploadStorageFacilityReadingsCsvDataMutation = { uploadStorageFacilityReadingsCsvData: boolean };

export type GetReceiverReadingsQueryVariables = Exact<{
  receiverId: Scalars['ObjectId'];
}>;


export type GetReceiverReadingsQuery = { storageFacilityReadings: { data: Array<{ _id: string, storageFacilityId: string, date: any, level: number, volumeType?: VolumeType | null }> } };

export type AddStorageFacilityReadingMutationVariables = Exact<{
  newStorageFacilityReadingData: NewStorageFacilityReadingInput;
}>;


export type AddStorageFacilityReadingMutation = { addStorageFacilityReading: { _id: string } };

export type GetReceiverForecastListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetReceiverForecastListQuery = { receiverForecasts: { count: number, data: Array<{ _id: string, receiverId: any, receiver?: { _id: string, name: string, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, linkedStorageFacilityIds?: Array<string> | null, commodities?: Array<{ _id: string, label: string, code?: string | null, unit: GoodUnits, weight: number }> | null }> | null, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string } } | null, models: Array<{ _id: string, label?: string | null, storageFacilityId: string, target?: number | null, threshold?: number | null }> }> } };

export type GetReceiverForecastDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReceiverForecastDetailsQuery = { receiverForecastById: { _id: string, receiverId: any, receiver?: { _id: string, name: string, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, linkedStorageFacilityIds?: Array<string> | null, latestReading?: { date: any, level: number, volumeType?: VolumeType | null } | null, commodities?: Array<{ _id: string, label: string, unit: GoodUnits, code?: string | null, weight: number }> | null }> | null } | null, models: Array<{ _id: string, target?: number | null, threshold?: number | null, weight?: number | null, contaminates?: boolean | null, isExclusive?: boolean | null, label?: string | null, minCapacity?: number | null, maxCapacity?: number | null, storageFacilityId: string, slots?: Array<{ type: ForecastingModelSlotType, salesAmount: number, hourly?: { dayOfWeek: number, startTime: { hour: number, minute: number }, endTime: { hour: number, minute: number } } | null, daily?: { dayOfWeek: number } | null, monthly?: { month: number } | null }> | null }>, trailerProfile: { compartments: Array<{ label: string, capacity: number, maxWeight: number, hasSeparatorBefore: boolean, hasSeparatorAfter: boolean, minUsage: number }> }, automationConfig?: { enabled: boolean, frequencyMinutes?: number | null, forecastQuantity?: number | null, lastRunAt?: any | null, nextRunAt?: any | null } | null, readingsFileConfiguration?: { tankIdColumn: string, dateColumn: string, dateFormat: string, timeColumn: string, timeFormat: string, levelColumn: string, storeColumn?: string | null, readingDeviationCriticalThreshold?: number | null, readingDeviationDangerThreshold?: number | null, readingDeviationWarningThreshold?: number | null, runoutCriticalThreshold?: number | null, runoutDangerThreshold?: number | null, runoutWarningThreshold?: number | null, staleReadingCriticalThreshold?: number | null, staleReadingDangerThreshold?: number | null, staleReadingWarningThreshold?: number | null } | null } };

export type GetBrokersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokersQuery = { brokers: { data: Array<{ _id: string, name: string, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, code?: string | null, mcNumber?: string | null, status: AssetStatus, address: { label: string, coordinates: { longitude: number, latitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string } }> } };

export type GetShippersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShippersQuery = { shippers: { data: Array<{ _id: string, name: string, addressTimezone?: string | null, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, code?: string | null, mcNumber?: string | null, status: AssetStatus, address: { label: string, coordinates: { longitude: number, latitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string }, openingSchedules?: Array<{ openingTime: string, closingTime: string, days: Array<number> }> | null }> } };

export type GetReceiversQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReceiversQuery = { receivers: { data: Array<{ _id: string, name: string, addressTimezone?: string | null, parentBusinessEntityId?: any | null, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, code?: string | null, mcNumber?: string | null, status: AssetStatus, groupIds?: Array<any> | null, address: { label: string, coordinates: { longitude: number, latitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string }, openingSchedules?: Array<{ openingTime: string, closingTime: string, days: Array<number> }> | null }> } };

export type GetCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomersQuery = { customers: { data: Array<{ _id: string, addressTimezone?: string | null, name: string, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, code?: string | null, mcNumber?: string | null, status: AssetStatus, address: { label: string, coordinates: { longitude: number, latitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string } }> } };

export type GetPayToProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayToProfilesQuery = { businessEntities: { data: Array<{ _id: string, addressTimezone?: string | null, name: string, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, code?: string | null, mcNumber?: string | null, status: AssetStatus, address: { label: string, coordinates: { longitude: number, latitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string } }> } };

export type GetSuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuppliersQuery = { businessEntities: { data: Array<{ _id: string, addressTimezone?: string | null, name: string, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, code?: string | null, mcNumber?: string | null, status: AssetStatus, address: { label: string, coordinates: { longitude: number, latitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string } }> } };

export type GetDomicilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDomicilesQuery = { businessEntities: { data: Array<{ _id: string, addressTimezone?: string | null, name: string, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, code?: string | null, mcNumber?: string | null, status: AssetStatus, address: { label: string, coordinates: { longitude: number, latitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string } }> } };

export type GetBusinessEntitiesQueryVariables = Exact<{
  businessEntityTypes?: InputMaybe<Array<BusinessEntityType> | BusinessEntityType>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSON']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBusinessEntitiesQuery = { businessEntities: { data: Array<{ _id: string, addressTimezone?: string | null, name: string, type: BusinessEntityType, additionalTypes?: Array<BusinessEntityType> | null, code?: string | null, mcNumber?: string | null, status: AssetStatus, address: { label: string, coordinates: { longitude: number, latitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string }, storageFacilities?: Array<{ identifier: string, capacity: number, unit: StorageFacilityUnit, commodityIds: Array<any>, safeFillLevel?: number | null, shutDownLevel?: number | null, defaultPinCode?: string | null, defaultSupplierId?: any | null, linkedStorageFacilityIds?: Array<string> | null, commodities?: Array<{ code?: string | null, label: string }> | null, defaultSupplier?: { code?: string | null, name: string } | null }> | null, openingSchedules?: Array<{ closingTime: string, days: Array<number>, openingTime: string }> | null }> } };

export type GetLoadBoardLoadsQueryVariables = Exact<{
  searchCriteria: LoadBoardSearchCriteria;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetLoadBoardLoadsQuery = { loadBoardLoads: { count: number, data: Array<{ _id: string, trailerType: TrailerType, additionalTrailerTypes?: Array<TrailerType> | null, loadType: LoadType, shipmentLocations: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, timeWindows: Array<{ fromDate: any, toDate: any }>, shippedGoods?: Array<{ weight?: number | null, quantity: number, unit?: GoodUnits | null }> | null }>, customer: { name: string, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string } }, charges: Array<{ label: string, total: number }> }> } };

export type GetLoadBoardLoadDetailsQueryVariables = Exact<{
  loadId: Scalars['String'];
}>;


export type GetLoadBoardLoadDetailsQuery = { loadBoardLoadById?: { _id: string, shipmentNumber: string, purchaseOrderNumbers?: Array<string> | null, billOfLadingNumbers?: Array<string> | null, referenceNumbers?: Array<string> | null, status: Status, createdBy: string, trailerType: TrailerType, additionalTrailerTypes?: Array<TrailerType> | null, loadType: LoadType, tripId?: string | null, reasonForCancellation?: string | null, events?: Array<{ _id: string, createdBy: string, date: any, shipmentLocation?: string | null, type: ShipmentEventType, coordinates?: { altitude?: number | null, heading?: number | null, latitude: number, longitude: number, speed?: number | null } | null }> | null, issues?: Array<{ _id: string, type: string, content: string, date: any, shipmentLocation?: string | null, delayAmount?: number | null, attachedDocuments: Array<string> }> | null, constraints?: Array<{ type: ShipmentConstraintType, value: string, unit?: string | null }> | null, documents?: Array<{ _id: string, associatedCharge?: string | null, accessLevel: Array<NoteAccessLevel>, isBillable: boolean, isForRatecons: boolean, isForReceivers: boolean, name: string, type: string, url: string, shipper?: { _id: string, name: string } | null, receiver?: { _id: string, name: string } | null }> | null, notes?: Array<{ _id: string, accessLevel: Array<NoteAccessLevel>, content: string, receiver?: { _id: string, name: string } | null, shipper?: { _id: string, name: string } | null }> | null, customer: { _id: string, name: string, type: BusinessEntityType, address: { label: string, coordinates: { latitude: number, longitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string } }, shipmentLocations: Array<{ _id: string, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, shippedGoods?: Array<{ _id: string, quantity: number, weight?: number | null, unit?: GoodUnits | null, label: string }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number } }>, charges: Array<{ _id: string, total: number, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, billingRule?: { _id: string, label?: string | null, referenceNumber?: string | null } | null, document?: { name: string, url: string } | null }>, expenses?: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, document?: { name: string, url: string } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> | null, route?: { routeDistance: number, firstPickupTime: any } | null } | null };

export type GetMaintenanceTasksQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  assetType?: InputMaybe<TripAssetTypes>;
  assetId?: InputMaybe<Scalars['ObjectId']>;
  status?: InputMaybe<MaintenanceTaskStatus>;
}>;


export type GetMaintenanceTasksQuery = { maintenanceTasks: { data: Array<{ _id: string, assetType: string, assetId: any, status?: MaintenanceTaskStatus | null, label: string, required?: boolean | null, startDate?: any | null, startMileage?: number | null, endDate?: any | null, recurrence?: { interval: number, frequency: MaintenanceTaskRecurrenceFrequency } | null }> } };

export type GetMaintenanceTaskDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMaintenanceTaskDetailsQuery = { maintenanceTaskById?: { _id: string, assetType: string, assetId: any, label: string, startDate?: any | null, startMileage?: number | null, endDate?: any | null, required?: boolean | null, status?: MaintenanceTaskStatus | null, recurrence?: { interval: number, frequency: MaintenanceTaskRecurrenceFrequency } | null } | null };

export type AddMaintenanceTaskMutationVariables = Exact<{
  newMaintenanceTaskData: NewMaintenanceTaskInput;
}>;


export type AddMaintenanceTaskMutation = { addMaintenanceTask: { _id: string } };

export type EditMaintenanceTaskMutationVariables = Exact<{
  id: Scalars['String'];
  editMaintenanceTaskData: MaintenanceTaskUpdateInput;
}>;


export type EditMaintenanceTaskMutation = { editMaintenanceTask: { _id: string } };

export type DeleteMaintenanceTaskMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMaintenanceTaskMutation = { deleteMaintenanceTask: boolean };

export type GetAllMaintenanceTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMaintenanceTasksQuery = { maintenanceTasks: { data: Array<{ _id: string, assetType: string, assetId: any, label: string, startDate?: any | null, startMileage?: number | null, endDate?: any | null, required?: boolean | null, status?: MaintenanceTaskStatus | null }> } };

export type CompleteMaintenanceTaskMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type CompleteMaintenanceTaskMutation = { completeMaintenanceTask: { _id: string } };

export type GetTractorMileageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTractorMileageQuery = { tractorById: { _id: string, mileage?: number | null } };

export type GetTrailerMileageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTrailerMileageQuery = { trailerById: { _id: string, mileage?: number | null } };

export type GetOrgMaintenanceTasksQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  status?: InputMaybe<MaintenanceTaskStatus>;
}>;


export type GetOrgMaintenanceTasksQuery = { orgMaintenanceTasks: { data: Array<{ _id: string, status?: MaintenanceTaskStatus | null, label: string, startDate: any, endDate?: any | null, assignedTo?: string | null, alertBeforeDays?: number | null, recurrence?: { interval: number, frequency: OrgMaintenanceTaskRecurrenceFrequency } | null, assignedToUser?: { firstName?: string | null, lastName?: string | null, username: string, _id: string } | null }> } };

export type GetOrgMaintenanceTaskDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrgMaintenanceTaskDetailsQuery = { orgMaintenanceTaskById?: { _id: string, label: string, startDate: any, endDate?: any | null, status?: MaintenanceTaskStatus | null, assignedTo?: string | null, alertBeforeDays?: number | null, recurrence?: { interval: number, frequency: OrgMaintenanceTaskRecurrenceFrequency } | null, assignedToUser?: { firstName?: string | null, lastName?: string | null, username: string, _id: string } | null } | null };

export type AddOrgMaintenanceTaskMutationVariables = Exact<{
  newOrgMaintenanceTaskData: OrgMaintenanceTaskInput;
}>;


export type AddOrgMaintenanceTaskMutation = { addOrgMaintenanceTask: { _id: string } };

export type EditOrgMaintenanceTaskMutationVariables = Exact<{
  id: Scalars['String'];
  editOrgMaintenanceTaskData: OrgMaintenanceTaskUpdateInput;
}>;


export type EditOrgMaintenanceTaskMutation = { editOrgMaintenanceTask: { _id: string } };

export type DeleteOrgMaintenanceTaskMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteOrgMaintenanceTaskMutation = { deleteOrgMaintenanceTask: boolean };

export type GetAllOrgMaintenanceTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrgMaintenanceTasksQuery = { orgMaintenanceTasks: { data: Array<{ _id: string, label: string, startDate: any, endDate?: any | null, status?: MaintenanceTaskStatus | null }> } };

export type CompleteOrgMaintenanceTaskMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type CompleteOrgMaintenanceTaskMutation = { completeOrgMaintenanceTask: { _id: string } };

export type ReportingDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportingDashboardQuery = { reportingDashboard?: { key: string, label: string, description?: string | null, resourceType: MetabaseResourceType } | null };

export type ReportingDashboardEmbedTokenQueryVariables = Exact<{
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type ReportingDashboardEmbedTokenQuery = { reportingDashboardEmbedToken: { token: string, iframeUrl: string } };

export type GetAllAssetsLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetsLocationsQuery = { tractors: { data: Array<{ _id: string, serialNumber: string, lastKnownLocationDate?: any | null, lastKnownLocation?: { latitude: number, longitude: number, heading?: number | null, speed?: number | null } | null }> }, trailers: { data: Array<{ _id: string, serialNumber: string, type: TrailerType, lastKnownLocationDate?: any | null, lastKnownLocation?: { latitude: number, longitude: number, heading?: number | null, speed?: number | null } | null }> }, drivers: { data: Array<{ _id: string, firstname: string, lastname: string, phoneNumber?: string | null, lastKnownLocationDate?: any | null, status: AssetStatus, lastKnownLocation?: { latitude: number, longitude: number, heading?: number | null, speed?: number | null } | null, hos?: { currentDrivingTime: number, currentOnDutyTime: number, currentStatus: DriverHosStatus, statusTime: any, totalDrivingTime: number, totalOnDutyTime: number } | null }> }, chassis: { data: Array<{ _id: string, serialNumber: string, lastKnownLocationDate?: any | null, lastKnownLocation?: { latitude: number, longitude: number, heading?: number | null, speed?: number | null } | null }> } };

export type GetTodayTripsQueryVariables = Exact<{
  timezone: Scalars['String'];
}>;


export type GetTodayTripsQuery = { trips: { count: number, data: Array<{ _id: string, tripNumber?: string | null, routeDistance: number, firstPickupTime?: any | null, status: Status, polyline: string, driver?: { firstname: string, lastname: string, _id: string } | null, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, locationType: ShipmentLocationType, arrivalTime: any, waitingDuration: number, setupDuration: number, serviceDuration: number, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, shipments: Array<{ _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null, trailerType: TrailerType, status: Status, shipmentLocations: Array<{ _id: string, locationType: ShipmentLocationType, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null, supplier?: { _id: string, name: string } | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, charges: Array<{ _id: string, rate: number, unit: number, total: number }>, customer: { _id: string, name: string }, route?: { routeDistance: number, firstPickupTime: any, locations?: Array<{ _id: string, locationType: ShipmentLocationType, shipper?: { _id: string, name: string, address: { label: string } } | null, receiver?: { _id: string, name: string, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null, events?: Array<{ _id: string, type: ShipmentEventType, label?: string | null, description?: string | null, date: any, shipmentLocation?: string | null, metadata?: any | null }> | null, issues?: Array<{ _id: string, type: string, content: string, date: any, shipmentLocation?: string | null, delayAmount?: number | null, attachedDocuments: Array<string> }> | null }>, trailer?: { _id: string, type: TrailerType, serialNumber: string } | null, tractor?: { _id: string, serialNumber: string } | null, carrier?: { _id: string, name: string } | null }> } };

export type GetLoadTrackingBoardShipmentsQueryVariables = Exact<{
  status?: InputMaybe<Status>;
  plannedForToday?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type GetLoadTrackingBoardShipmentsQuery = { shipments: { data: Array<{ _id: string, billOfLadingNumbers?: Array<string> | null, purchaseOrderNumbers?: Array<string> | null, shipmentNumber: string, referenceNumbers?: Array<string> | null, trailerType: TrailerType, status: Status, createdBy: string, route?: { routeDistance: number, firstPickupTime: any, locations?: Array<{ _id: string, shipper?: { _id: string } | null, receiver?: { _id: string } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null, charges: Array<{ _id: string, total: number, label: string, rate: number, unit: number, unitType: string, billingRule?: { _id: string, label?: string | null, referenceNumber?: string | null } | null }>, customer: { _id: string, name: string }, shipmentLocations: Array<{ _id: string, locationType: ShipmentLocationType, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, events?: Array<{ _id: string, type: ShipmentEventType, label?: string | null, description?: string | null, date: any, shipmentLocation?: string | null, metadata?: any | null }> | null, issues?: Array<{ _id: string, type: string, content: string, date: any, shipmentLocation?: string | null, delayAmount?: number | null, attachedDocuments: Array<string> }> | null }> } };

export type GetOrderListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  status?: InputMaybe<Status>;
}>;


export type GetOrderListQuery = { orders: { count: number, data: Array<{ _id: string, orderNumber: string, status: Status, customer?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, locations: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }>, receivedGoods?: Array<{ goodId: string, goodProfileId?: any | null, quantity?: number | null, goodProfile?: { _id: string, label: string, code?: string | null, unit: GoodUnits, weight: number } | null }> | null }> }> } };

export type GetOrderDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrderDetailsQuery = { orderById: { _id: string, orderNumber: string, customerId: any, status: Status, customer?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, locations: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }>, receivedGoods?: Array<{ goodId: string, goodProfileId?: any | null, quantity?: number | null, goodProfile?: { _id: string, label: string, code?: string | null, unit: GoodUnits, weight: number } | null }> | null }> } };

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteOrderMutation = { deleteOrder: boolean };

export type AddOrderMutationVariables = Exact<{
  newOrderData: NewOrderInput;
}>;


export type AddOrderMutation = { addOrder: { _id: string } };

export type EditOrderMutationVariables = Exact<{
  id: Scalars['String'];
  editOrderData: OrderUpdateInput;
}>;


export type EditOrderMutation = { editOrder: { _id: string } };

export type BulkAddOrdersMutationVariables = Exact<{
  newOrdersData: Array<NewOrderInput> | NewOrderInput;
}>;


export type BulkAddOrdersMutation = { bulkAddOrders: Array<{ _id: string }> };

export type BulkEditShipmentsMutationVariables = Exact<{
  editshipmentsData: ShipmentUpdateInput;
  ids: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type BulkEditShipmentsMutation = { bulkEditShipments: { matchedCount?: number | null, modifiedCount?: number | null, upsertedCount?: number | null } };

export type MyDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDocumentsQuery = { myDocuments: Array<{ _id?: string | null, name: string, url?: string | null }> };

export type AddOrgDocMutationVariables = Exact<{
  newOrganizationDocumentData: NewOrganizationDocumentInput;
}>;


export type AddOrgDocMutation = { addOrgDoc: { _id?: string | null, name: string, url?: string | null } };

export type EditOrgDocMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  organizationDocumentData: OrganizationDocumentUpdateInput;
}>;


export type EditOrgDocMutation = { editOrgDoc: string };

export type DeleteOrgDocMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type DeleteOrgDocMutation = { deleteOrgDoc: boolean };

export type MyOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOrganizationQuery = { myOrganization: { _id?: string | null, address?: string | null, contactFullname?: string | null, dotNumber?: string | null, email?: any | null, name: string, phoneNumber?: string | null, taxId?: string | null } };

export type EditOrganizationMutationVariables = Exact<{
  organizationSetupData: OrganizationUpdateInput;
}>;


export type EditOrganizationMutation = { editOrganization: string };

export type GetQualificationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  assetType?: InputMaybe<TripAssetTypes>;
  assetId?: InputMaybe<Scalars['ObjectId']>;
}>;


export type GetQualificationsQuery = { qualifications: { data: Array<{ _id: string, assetType: string, assetId: any, label: string, number?: string | null, required?: boolean | null, startDate: any, endDate: any, documents?: Array<{ _id?: string | null, name: string, url: string }> | null }> } };

export type GetQualificationDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetQualificationDetailsQuery = { qualificationById?: { _id: string, assetType: string, assetId: any, label: string, number?: string | null, startDate: any, endDate: any, required?: boolean | null, documents?: Array<{ _id?: string | null, name: string, url: string }> | null } | null };

export type AddQualificationMutationVariables = Exact<{
  newQualificationData: NewQualificationInput;
}>;


export type AddQualificationMutation = { addQualification: { _id: string } };

export type EditQualificationMutationVariables = Exact<{
  id: Scalars['String'];
  editQualificationData: QualificationUpdateInput;
}>;


export type EditQualificationMutation = { editQualification: { _id: string } };

export type DeleteQualificationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteQualificationMutation = { deleteQualification: boolean };

export type GetAllQualificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllQualificationsQuery = { qualifications: { data: Array<{ _id: string, assetType: string, assetId: any, label: string, startDate: any, endDate: any, required?: boolean | null }> } };

export type GetReasonCodesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
}>;


export type GetReasonCodesQuery = { reasonCodes: { data: Array<{ _id: any, createdAt: any, createdBy: string, description?: string | null, shipmentId?: any | null, tripId?: any | null, locationId?: string | null, type: ReasonCodeType, updatedAt: any }> } };

export type GetReasonCodeDetailsQueryVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type GetReasonCodeDetailsQuery = { reasonCodeById?: { _id: any, createdAt: any, createdBy: string, description?: string | null, shipmentId?: any | null, tripId?: any | null, locationId?: string | null, type: ReasonCodeType, updatedAt: any } | null };

export type AddReasonCodeMutationVariables = Exact<{
  newReasonCodeData: NewReasonCodeInput;
}>;


export type AddReasonCodeMutation = { addReasonCode: { _id: any } };

export type EditReasonCodeMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  editReasonCodeData: ReasonCodeUpdateInput;
}>;


export type EditReasonCodeMutation = { editReasonCode: { _id: any } };

export type DeleteReasonCodeMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type DeleteReasonCodeMutation = { deleteReasonCode: boolean };

export type GetRelationshipListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetRelationshipListQuery = { relationships: { count: number, data: Array<{ _id: string, suppliers?: Array<{ _id: string, code?: string | null, name: string }> | null, shippers?: Array<{ _id: string, code?: string | null, name: string }> | null, commodities?: Array<{ _id: string, code?: string | null, label: string }> | null, receivers?: Array<{ _id: string, code?: string | null, name: string }> | null, customers?: Array<{ _id: string, code?: string | null, name: string }> | null }> } };

export type GetRelationshipDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRelationshipDetailsQuery = { relationshipById?: { _id: string, supplierIds?: Array<any> | null, shipperIds?: Array<any> | null, commodityIds?: Array<any> | null, receiverIds?: Array<any> | null, customerIds?: Array<any> | null, suppliers?: Array<{ _id: string, name: string }> | null, shippers?: Array<{ _id: string, name: string }> | null, commodities?: Array<{ _id: string, label: string }> | null, receivers?: Array<{ _id: string, name: string }> | null, customers?: Array<{ _id: string, name: string }> | null } | null };

export type AddRelationshipMutationVariables = Exact<{
  newRelationshipData: NewRelationshipInput;
}>;


export type AddRelationshipMutation = { addRelationship: { _id: string } };

export type EditRelationshipMutationVariables = Exact<{
  id: Scalars['String'];
  editRelationshipData: RelationshipUpdateInput;
}>;


export type EditRelationshipMutation = { editRelationship: { _id: string } };

export type DeleteRelationshipMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteRelationshipMutation = { deleteRelationship: boolean };

export type GetAllRelationshipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRelationshipsQuery = { relationships: { data: Array<{ supplierIds?: Array<any> | null, shipperIds?: Array<any> | null, commodityIds?: Array<any> | null, receiverIds?: Array<any> | null, customerIds?: Array<any> | null }> } };

export type GenerateReportPdfMutationVariables = Exact<{
  reportType: ReportType;
  period: PeriodInput;
  timezone: Scalars['String'];
  filter?: InputMaybe<Scalars['ReportFilter']>;
  lang: Scalars['String'];
}>;


export type GenerateReportPdfMutation = { generateReportPdf: { url: string } };

export type GenerateReportCsvMutationVariables = Exact<{
  reportType: ReportType;
  period: PeriodInput;
  timezone: Scalars['String'];
  filter?: InputMaybe<Scalars['ReportFilter']>;
  lang: Scalars['String'];
}>;


export type GenerateReportCsvMutation = { generateReportCsv: { url: string } };

export type SendReportPdfMutationVariables = Exact<{
  reportType: ReportType;
  period: PeriodInput;
  timezone: Scalars['String'];
  filter?: InputMaybe<Scalars['ReportFilter']>;
  email: Scalars['String'];
  lang: Scalars['String'];
}>;


export type SendReportPdfMutation = { sendReportPdf: { success: boolean } };

export type GetMetricsQueryVariables = Exact<{
  type: MetricType;
  aggregateBy: Array<Scalars['String']> | Scalars['String'];
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type GetMetricsQuery = { metrics: Array<{ dimensions: any, type: string, value: number }> };

export type GetBulkMetricsQueryVariables = Exact<{
  types: Array<MetricType> | MetricType;
  aggregateBy: Array<Scalars['String']> | Scalars['String'];
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type GetBulkMetricsQuery = { bulkMetrics: Array<Array<{ dimensions: any, type: string, value: number }>> };

export type SavedReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedReportsQuery = { savedReports: Array<{ _id: any, name: string, reportKey: string, filters: any, createdBy: string, createdAt: any, updatedAt: any }> };

export type CreateSavedReportMutationVariables = Exact<{
  input: NewSavedReportInput;
}>;


export type CreateSavedReportMutation = { createSavedReport: { _id: any, name: string, reportKey: string, filters: any } };

export type UpdateSavedReportMutationVariables = Exact<{
  id: Scalars['ObjectId'];
  input: SavedReportUpdateInput;
}>;


export type UpdateSavedReportMutation = { updateSavedReport?: { _id: any, name: string, reportKey: string, filters: any } | null };

export type DeleteSavedReportMutationVariables = Exact<{
  id: Scalars['ObjectId'];
}>;


export type DeleteSavedReportMutation = { deleteSavedReport: boolean };

export type SplitShipmentMutationVariables = Exact<{
  shipmentId: Scalars['String'];
  locations: Array<SplitShipmentLocationInput> | SplitShipmentLocationInput;
}>;


export type SplitShipmentMutation = { splitShipment?: Array<{ _id: string, tripId?: string | null, isFromSplit?: boolean | null, parentShipment?: { _id: string } | null }> | null };

export type CancelShipmentSplitMutationVariables = Exact<{
  shipmentId: Scalars['String'];
}>;


export type CancelShipmentSplitMutation = { cancelShipmentSplit?: { _id: string } | null };

export type GetShipmentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetShipmentQuery = { shipmentById: { _id: string, shipmentNumber: string, isApplicableChargeOrderCancellation?: boolean | null, commodityType?: ShipmentCommodityType | null, additionalTrailerTypes?: Array<TrailerType> | null, purchaseOrderNumbers?: Array<string> | null, billOfLadingNumbers?: Array<string> | null, referenceNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, status: Status, createdBy: string, dispatcher?: string | null, trailerType: TrailerType, loadType: LoadType, tripId?: string | null, reasonForCancellation?: string | null, isSplit?: boolean | null, isFromSplit?: boolean | null, childShipmentIds?: Array<string> | null, dailyRotationCount?: number | null, tags?: Array<string> | null, groupIds?: Array<any> | null, events?: Array<{ _id: string, createdBy: string, date: any, shipmentLocation?: string | null, type: ShipmentEventType, label?: string | null, description?: string | null, metadata?: any | null, coordinates?: { altitude?: number | null, heading?: number | null, latitude: number, longitude: number, speed?: number | null } | null }> | null, issues?: Array<{ _id: string, type: string, content: string, date: any, shipmentLocation?: string | null, delayAmount?: number | null, attachedDocuments: Array<string> }> | null, constraints?: Array<{ type: ShipmentConstraintType, value: string, unit?: string | null }> | null, documents?: Array<{ _id: string, associatedCharge?: string | null, accessLevel: Array<NoteAccessLevel>, isBillable: boolean, isForRatecons: boolean, isForReceivers: boolean, name: string, type: string, url: string, shipper?: { _id: string, name: string } | null, receiver?: { _id: string, name: string } | null }> | null, notes?: Array<{ _id: string, accessLevel: Array<NoteAccessLevel>, content: string, receiver?: { _id: string, name: string } | null, shipper?: { _id: string, name: string } | null }> | null, customer: { _id: string, name: string, referenceNumberTypes?: Array<ShipmentReferenceNumberType> | null, type: BusinessEntityType, address: { label: string, coordinates: { latitude: number, longitude: number } }, contact: { firstname: string, lastname: string, phoneNumber: string }, documentRequirements?: Array<{ documentName?: string | null, documentType: DocumentType, attachToInvoice: boolean, requiredForInvoicing: boolean }> | null }, shipmentLocations: Array<{ _id: string, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } }, storageFacilities?: Array<{ _id: string, identifier: string }> | null } | null, shippedGoods?: Array<{ _id: string, quantity: number, loadedQuantity?: number | null, netLoadedQuantity?: number | null, weight?: number | null, label: string, unit?: GoodUnits | null, goodProfileId?: any | null, supplierId?: any | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, supplier?: { _id: string, name: string } | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, deliveredQuantity?: number | null, netDeliveredQuantity?: number | null, goodProfileId?: any | null, shipperId?: any | null, supplierId?: any | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, storageFacilityId?: string | null, inchesBefore?: number | null, inchesAfter?: number | null, supplier?: { _id: string, name: string } | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number } }>, charges: Array<{ _id: string, total: number, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, relatedTransactionId?: any | null, taxable?: boolean | null, billingRule?: { _id: string, label?: string | null, referenceNumber?: string | null } | null, ratingTable?: { _id: string, label: string, referenceNumber?: string | null } | null, document?: { name: string, url: string } | null }>, expenses?: Array<{ _id: string, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, document?: { name: string, url: string } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> | null, route?: { routeDistance: number, predictedLoadedDistance?: number | null, distanceToStart: number, distanceToEnd: number, firstPickupTime: any, locations?: Array<{ _id: string, distanceTo?: number | null, locationType: ShipmentLocationType, shipmentLocationIds: Array<string>, shipper?: { _id: string, name: string } | null, receiver?: { _id: string, name: string } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null, recurrence?: { freq: Frequency, interval: number, dtstart: any, until: any, count?: number | null, bysetpos?: Array<number> | null, bymonth?: Array<number> | null, bymonthday?: Array<number> | null, bynmonthday?: Array<number> | null, byyearday?: Array<number> | null, byweekno?: Array<number> | null, byhour?: Array<number> | null, byminute?: Array<number> | null, bysecond?: Array<number> | null, byweekday?: Array<{ weekday: number, n?: number | null }> | null } | null, parentShipment?: { _id: string } | null, customFields?: Array<{ key: string, value?: any | null }> | null }, invoices: { data: Array<{ _id: string, invoiceNumber: string, status: InvoiceStatus, shipmentIds?: Array<any> | null, charges: Array<{ _id: string, total: number, label: string, rate: number, unit: number, unitType: string, reimburseToDriver?: boolean | null, relatedTransactionId?: any | null, taxable?: boolean | null, shipmentId?: any | null, billingRule?: { _id: string, label?: string | null, referenceNumber?: string | null } | null, ratingTable?: { _id: string, label: string, referenceNumber?: string | null } | null, document?: { name: string, url: string } | null }> }> } };

export type GetShipmentSummaryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetShipmentSummaryQuery = { shipmentById: { _id: string, billOfLadingNumbers?: Array<string> | null, purchaseOrderNumbers?: Array<string> | null, shipmentNumber: string, isApplicableChargeOrderCancellation?: boolean | null, referenceNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, trailerType: TrailerType, additionalTrailerTypes?: Array<TrailerType> | null, status: Status, createdBy: string, tripId?: string | null, charges: Array<{ total: number }>, customer: { _id: string, name: string, referenceNumberTypes?: Array<ShipmentReferenceNumberType> | null }, shipmentLocations: Array<{ _id: string, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, loadedQuantity?: number | null, netLoadedQuantity?: number | null, weight?: number | null, unit?: GoodUnits | null, goodProfileId?: any | null, supplierId?: any | null, pinCode?: string | null, supplier?: { _id: string, name: string } | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, deliveredQuantity?: number | null, netDeliveredQuantity?: number | null, goodProfileId?: any | null, supplierId?: any | null, inchesBefore?: number | null, inchesAfter?: number | null, supplier?: { _id: string, name: string } | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, route?: { routeDistance: number, firstPickupTime: any, predictedLoadedDistance?: number | null, locations?: Array<{ _id: string, shipper?: { _id: string } | null, receiver?: { _id: string } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null }, invoices: { data: Array<{ _id: string, invoiceNumber: string, status: InvoiceStatus, shipmentIds?: Array<any> | null, charges: Array<{ total: number, shipmentId?: any | null }> }> } };

export type DeleteShipmentMutationVariables = Exact<{
  deleteShipmentData?: InputMaybe<ShipmentDeleteInput>;
  id: Scalars['String'];
}>;


export type DeleteShipmentMutation = { deleteShipment: { _id: string } };

export type RestoreShipmentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreShipmentMutation = { restoreShipment: { _id: string } };

export type AddShipmentDocumentsMutationVariables = Exact<{
  data: Array<ShipmentDocumentInfoInput> | ShipmentDocumentInfoInput;
  shipment: Scalars['String'];
}>;


export type AddShipmentDocumentsMutation = { addShipmentDocuments: Array<{ _id: string }> };

export type AddShipmentNotesMutationVariables = Exact<{
  data: MultiShipmentNotesInput;
}>;


export type AddShipmentNotesMutation = { addNotesShipment: { _id: string } };

export type EditShipmentNoteMutationVariables = Exact<{
  data: EditShipmentNoteInput;
}>;


export type EditShipmentNoteMutation = { editNoteShipment: { _id: string } };

export type DeleteShipmentNoteMutationVariables = Exact<{
  data: DeleteShipmentNoteInput;
}>;


export type DeleteShipmentNoteMutation = { deleteShipmentNote: { _id: string } };

export type DeleteDocumentShipmentMutationVariables = Exact<{
  data: DeleteShipmentDocumentInput;
}>;


export type DeleteDocumentShipmentMutation = { deleteDocumentShipment: { _id: string } };

export type EditDocumentShipmentMutationVariables = Exact<{
  data: EditShipmentDocumentInput;
}>;


export type EditDocumentShipmentMutation = { editDocumentShipment: { _id: string } };

export type ResendDocumentsToReceiversMutationVariables = Exact<{
  shipmentId: Scalars['ObjectId'];
}>;


export type ResendDocumentsToReceiversMutation = { resendDocumentsToReceivers: string };

export type CreateShipmentMutationVariables = Exact<{
  shipment: NewShipmentInput;
}>;


export type CreateShipmentMutation = { addShipment: { _id: string, shipmentLocations: Array<{ shipper?: { _id: string } | null }> } };

export type GenerateShipmentRouteMutationVariables = Exact<{
  shipment: NewShipmentInput;
}>;


export type GenerateShipmentRouteMutation = { generateShipmentRoute: { routeDistance: number, firstPickupTime: any, distanceToStart: number, distanceToEnd: number, lastDropoffTime: any, locations?: Array<{ _id: string, locationType: ShipmentLocationType, arrivalTime: any, serviceDuration: number, setupDuration: number, tripShipmentLocationId: string, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, waitingDuration: number, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number } }> | null } };

export type UpdateShipmentMutationVariables = Exact<{
  editShipmentData: ShipmentUpdateInput;
  id: Scalars['String'];
}>;


export type UpdateShipmentMutation = { editShipment: { _id: string, shipmentLocations: Array<{ shipper?: { _id: string } | null }> } };

export type GetOwnedTrailerTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnedTrailerTypesQuery = { ownedTrailerTypes: Array<TrailerType> };

export type GetSignedUrlMutationVariables = Exact<{
  document: DocumentSignedUrlInput;
}>;


export type GetSignedUrlMutation = { documentSignedUrl: { key: string, url: string } };

export type GetShipmentListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ShipmentSort>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Status>;
  statuses?: InputMaybe<Array<Status> | Status>;
  receiverId?: InputMaybe<Scalars['String']>;
  excludePastShipments?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
}>;


export type GetShipmentListQuery = { shipments: { count: number, data: Array<{ _id: string, isApplicableChargeOrderCancellation?: boolean | null, shipmentNumber: string, purchaseOrderNumbers?: Array<string> | null, billOfLadingNumbers?: Array<string> | null, referenceNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, status: Status, trailerType: TrailerType, additionalTrailerTypes?: Array<TrailerType> | null, tripId?: string | null, isSplit?: boolean | null, isFromSplit?: boolean | null, isFromRotation?: boolean | null, dailyRotationCount?: number | null, tags?: Array<string> | null, groupIds?: Array<any> | null, shipmentLocations: Array<{ _id: string, locationType: ShipmentLocationType, timeWindows: Array<{ fromDate: any, toDate: any }>, shippedGoods?: Array<{ _id: string, goodProfileId?: any | null, label: string, quantity: number, unit?: GoodUnits | null, weight?: number | null, supplierId?: any | null }> | null, shipper?: { _id: string } | null }>, route?: { firstPickupTime: any, lastDropoffTime: any, locations?: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null, trip?: { _id: string, tripNumber?: string | null, driver?: string | null, tractor?: string | null, trailer?: string | null, carrier?: string | null, driverEntity?: { _id: string, firstname: string, lastname: string, phoneNumber?: string | null, status: AssetStatus } | null, tractorEntity?: { _id: string, serialNumber: string, licenseNumber?: string | null, status: AssetStatus } | null, trailerEntity?: { _id: string, serialNumber: string, licenseNumber?: string | null, status: AssetStatus, type: TrailerType } | null, carrierEntity?: { _id: string, name: string, status: AssetStatus, type: BusinessEntityType, contact: { firstname: string, lastname: string, phoneNumber: string }, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null } | null, parentShipment?: { _id: string } | null, recurrence?: { freq: Frequency } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type GetShipmentsByIdsQueryVariables = Exact<{
  shipmentIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type GetShipmentsByIdsQuery = { shipments: { data: Array<{ _id: string, shipmentNumber: string, commodityType?: ShipmentCommodityType | null, tripId?: string | null, referenceNumbers?: Array<string> | null, isFromSplit?: boolean | null, isFromRotation?: boolean | null, additionalTrailerTypes?: Array<TrailerType> | null, shipmentLocations: Array<{ _id: string, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, shipper?: { _id: string, name: string, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, shippedGoods?: Array<{ _id: string, quantity: number, loadedQuantity?: number | null, netLoadedQuantity?: number | null, weight?: number | null, label: string, unit?: GoodUnits | null, goodProfileId?: any | null, supplierId?: any | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, supplier?: { _id: string, name: string } | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, deliveredQuantity?: number | null, netDeliveredQuantity?: number | null, goodProfileId?: any | null, shipperId?: any | null, supplierId?: any | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, storageFacilityId?: string | null, supplier?: { _id: string, name: string } | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number } }>, parentShipment?: { _id: string } | null, events?: Array<{ type: ShipmentEventType, shipmentLocation?: string | null }> | null }> } };

export type TrackShipmentQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type TrackShipmentQuery = { trackShipment: { shipment: { _id: string, trailerType: TrailerType, loadType: LoadType, shipmentNumber: string, referenceNumbers?: Array<string> | null, events?: Array<{ _id: string, type: ShipmentEventType, label?: string | null, description?: string | null, date: any, shipmentLocation?: string | null, metadata?: any | null }> | null, shipmentLocations: Array<{ _id: string, locationType: ShipmentLocationType }> }, trip?: { _id: string, polyline: string, status: Status, tripNumber?: string | null, routeDistance: number, firstPickupTime?: any | null, lastTrailerLocationDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, locationType: ShipmentLocationType, arrivalTime: any, waitingDuration: number, setupDuration: number, serviceDuration: number, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, unit?: GoodUnits | null, weight?: number | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, shipments: Array<{ _id: string, status: Status, trailerType: TrailerType, shipmentNumber: string, referenceNumbers?: Array<string> | null, events?: Array<{ _id: string, type: ShipmentEventType, label?: string | null, description?: string | null, date: any, shipmentLocation?: string | null, metadata?: any | null }> | null, charges: Array<{ _id: string, rate: number, unit: number, total: number }> }>, lastTrailerLocation?: { latitude: number, longitude: number, heading?: number | null, speed?: number | null } | null } | null } };

export type TrackShipmentByIdQueryVariables = Exact<{
  shipmentId: Scalars['ObjectId'];
}>;


export type TrackShipmentByIdQuery = { trackShipment: { shipment: { _id: string, trailerType: TrailerType, loadType: LoadType, shipmentNumber: string, referenceNumbers?: Array<string> | null, events?: Array<{ _id: string, type: ShipmentEventType, label?: string | null, description?: string | null, date: any, shipmentLocation?: string | null, metadata?: any | null }> | null, shipmentLocations: Array<{ _id: string, locationType: ShipmentLocationType }> }, trip?: { _id: string, polyline: string, status: Status, tripNumber?: string | null, routeDistance: number, firstPickupTime?: any | null, lastTrailerLocationDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, locationType: ShipmentLocationType, arrivalTime: any, waitingDuration: number, setupDuration: number, serviceDuration: number, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, unit?: GoodUnits | null, weight?: number | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, shipments: Array<{ _id: string, status: Status, trailerType: TrailerType, shipmentNumber: string, referenceNumbers?: Array<string> | null, events?: Array<{ _id: string, type: ShipmentEventType, label?: string | null, description?: string | null, date: any, shipmentLocation?: string | null, metadata?: any | null }> | null, charges: Array<{ _id: string, rate: number, unit: number, total: number }> }>, lastTrailerLocation?: { latitude: number, longitude: number, heading?: number | null, speed?: number | null } | null } | null } };

export type AddTripMutationVariables = Exact<{
  newTripData: NewTripInput;
}>;


export type AddTripMutation = { addTrip: { _id: string } };

export type GetShipmentListForAutoPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShipmentListForAutoPlanQuery = { shipments: { data: Array<{ _id: string, billOfLadingNumbers?: Array<string> | null, purchaseOrderNumbers?: Array<string> | null, shipmentNumber: string, referenceNumbers?: Array<string> | null, trailerType: TrailerType, loadType: LoadType, status: Status, createdBy: string, tripId?: string | null, tags?: Array<string> | null, groupIds?: Array<any> | null, route?: { routeDistance: number, firstPickupTime: any, lastDropoffTime: any, locations?: Array<{ _id: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, arrivalTime: any, shipmentId?: string | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null, violations?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null }> | null } | null, charges: Array<{ total: number }>, customer: { _id: string, name: string, code?: string | null }, shipmentLocations: Array<{ _id: string, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, code?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, code?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, trip?: { _id: string, tripNumber?: string | null, driver?: string | null, tractor?: string | null, trailer?: string | null, firstPickupTime?: any | null, lastDropoffTime?: any | null, routeDistance: number, predictedLoadedDistance?: number | null, etaFromPreviousTrip?: number | null, etaToNextTrip?: number | null, status: Status, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, name?: string | null, locationType: ShipmentLocationType, arrivalTime: any, timeWindows: Array<{ fromDate: any, toDate: any }> }>, violations?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null }> | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type GetShipmentListForPlanningQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']>;
}>;


export type GetShipmentListForPlanningQuery = { shipments: { data: Array<{ _id: string, billOfLadingNumbers?: Array<string> | null, purchaseOrderNumbers?: Array<string> | null, ticketNumbers?: Array<string> | null, rateConNumbers?: Array<string> | null, shipmentNumber: string, referenceNumbers?: Array<string> | null, trailerType: TrailerType, loadType: LoadType, status: Status, createdBy: string, tripId?: string | null, additionalTrailerTypes?: Array<TrailerType> | null, tags?: Array<string> | null, groupIds?: Array<any> | null, route?: { routeDistance: number, firstPickupTime: any, lastDropoffTime: any, locations?: Array<{ _id: string, tripShipmentLocationId: string, locationType: ShipmentLocationType, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, arrivalTime: any, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, waitingDuration: number, setupDuration: number, serviceDuration: number, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }>, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, pieces?: number | null, pallet?: number | null, loadedQuantity?: number | null, supplierId?: any | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, deliveredQuantity?: number | null, shipperId?: any | null, supplierId?: any | null, storageFacilityId?: string | null }> | null }> | null, violations?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null, message?: string | null }> | null } | null, charges: Array<{ _id: string, rate: number, unit: number, total: number }>, customer: { _id: string, name: string, code?: string | null }, shipmentLocations: Array<{ _id: string, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, code?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, code?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, pieces?: number | null, pallet?: number | null, loadedQuantity?: number | null, supplierId?: any | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, deliveredQuantity?: number | null, shipperId?: any | null, supplierId?: any | null, storageFacilityId?: string | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, trip?: { _id: string, tripNumber?: string | null, driver?: string | null, tractor?: string | null, trailer?: string | null, carrier?: string | null, additionalTrailers?: Array<string> | null, firstPickupTime?: any | null, lastDropoffTime?: any | null, routeDistance: number, predictedLoadedDistance?: number | null, etaFromPreviousTrip?: number | null, etaToNextTrip?: number | null, etaStatus?: EtaStatus | null, nextStopName?: string | null, etaToNextStopMinutes?: number | null, etaToDeliveryMinutes?: number | null, liveEtaUpdatedAt?: any | null, status: Status, polyline: string, distanceToStart: number, distanceToEnd: number, totalDistance?: number | null, driverEntity?: { _id: string, firstname: string, lastname: string, phoneNumber?: string | null, status: AssetStatus } | null, tractorEntity?: { _id: string, serialNumber: string, licenseNumber?: string | null, status: AssetStatus } | null, trailerEntity?: { _id: string, serialNumber: string, licenseNumber?: string | null, status: AssetStatus, type: TrailerType } | null, carrierEntity?: { _id: string, name: string, status: AssetStatus, type: BusinessEntityType, contact: { firstname: string, lastname: string, phoneNumber: string }, address: { label: string, coordinates: { latitude: number, longitude: number } } } | null, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, arrivalTime: any, estimatedArrivalTime?: any | null, waitingDuration: number, setupDuration: number, serviceDuration: number, distanceTo?: number | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number }, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, pieces?: number | null, pallet?: number | null, loadedQuantity?: number | null, supplierId?: any | null, supplier?: { _id: string, name: string } | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, deliveredQuantity?: number | null, shipperId?: any | null, supplierId?: any | null, storageFacilityId?: string | null }> | null }>, violations?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null, message?: string | null }> | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null, recurrence?: { freq: Frequency } | null }> } };

export type PlanTripsForDriverMutationVariables = Exact<{
  driverId: Scalars['ObjectId'];
  trips: Array<TripForPlanningInput> | TripForPlanningInput;
  tractorId?: InputMaybe<Scalars['ObjectId']>;
  trailerId?: InputMaybe<Scalars['ObjectId']>;
  additionalTrailerIds?: InputMaybe<Array<Scalars['ObjectId']> | Scalars['ObjectId']>;
}>;


export type PlanTripsForDriverMutation = { planTripsForDriver: Array<{ _id: string, tripNumber?: string | null, firstPickupTime?: any | null, lastDropoffTime?: any | null, routeDistance: number, predictedLoadedDistance?: number | null, etaFromPreviousTrip?: number | null, etaToNextTrip?: number | null, distanceToStart: number, distanceToEnd: number, status: Status, polyline: string, totalDistance?: number | null, shipments: Array<{ _id: string, shipmentNumber: string }>, driver?: { _id: string } | null, tractor?: { _id: string } | null, trailer?: { _id: string } | null, additionalTrailers?: Array<{ _id: string }> | null, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, arrivalTime: any, waitingDuration: number, setupDuration: number, serviceDuration: number, distanceTo?: number | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number }, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, pieces?: number | null, pallet?: number | null, loadedQuantity?: number | null, supplierId?: any | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, deliveredQuantity?: number | null, shipperId?: any | null, supplierId?: any | null, storageFacilityId?: string | null }> | null, shipper?: { _id: string, name: string } | null, receiver?: { _id: string, name: string } | null }>, violations?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null, message?: string | null }> | null }> };

export type SaveTripMutationVariables = Exact<{
  saveTripData: SaveTripInput;
}>;


export type SaveTripMutation = { saveTrip: { _id: string } };

export type CombineShipmentsMutationVariables = Exact<{
  generateTripData: GenerateTripInput;
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
}>;


export type CombineShipmentsMutation = { combineShipments: { _id: string, tripNumber?: string | null, firstPickupTime?: any | null, lastDropoffTime?: any | null, routeDistance: number, predictedLoadedDistance?: number | null, etaFromPreviousTrip?: number | null, etaToNextTrip?: number | null, totalDistance?: number | null, distanceToStart: number, distanceToEnd: number, status: Status, polyline: string, shipments: Array<{ _id: string, shipmentNumber: string }>, driver?: { _id: string } | null, tractor?: { _id: string } | null, trailer?: { _id: string } | null, additionalTrailers?: Array<{ _id: string }> | null, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, arrivalTime: any, waitingDuration: number, setupDuration: number, serviceDuration: number, distanceTo?: number | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number }, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, pieces?: number | null, pallet?: number | null, loadedQuantity?: number | null, supplierId?: any | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, goodProfileId?: any | null, unitPrice?: number | null, pinCode?: string | null, alternativePinCodes?: Array<string> | null, deliveredQuantity?: number | null, shipperId?: any | null, supplierId?: any | null, storageFacilityId?: string | null }> | null, shipper?: { _id: string, name: string } | null, receiver?: { _id: string, name: string } | null }>, violations?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null }> | null } };

export type GetAssignmentAssetsQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAssignmentAssetsQuery = { trailers: { data: Array<{ _id: string, serialNumber: string, status: AssetStatus, type: TrailerType, lastKnownLocationDate?: any | null, mileage?: number | null, lastKnownLocation?: { latitude: number, longitude: number } | null, compartments?: Array<{ identifier: string, capacity: number, unit: TrailerCompartmentUnit, minVolume?: number | null, maxVolume?: number | null, heavyOnly?: boolean | null, hasDoubleBulkheadAfter?: boolean | null }> | null, compartmentVolumes?: Array<{ _id: any, compartmentId: string, commodityId?: string | null, quantity: number, lastUpdated: any, lastShipmentId?: any | null, lastShipmentNumber?: string | null, updatedBy: string }> | null }> }, tractors: { data: Array<{ _id: string, serialNumber: string, status: AssetStatus, lastKnownLocationDate?: any | null, mileage?: number | null, lastKnownLocation?: { latitude: number, longitude: number } | null }> }, drivers: { data: Array<{ _id: string, firstname: string, lastname: string, status: AssetStatus, lastKnownLocationDate?: any | null, phoneNumber?: string | null, domicileId?: any | null, lastKnownLocation?: { latitude: number, longitude: number } | null, domicile?: { city?: string | null, country?: string | null, label: string } | null, domicileEntity?: { name: string, addressTimezone?: string | null } | null, license?: { licenseNumber?: string | null, expiryDate?: any | null } | null, medical?: { number?: string | null, expiryDate?: any | null } | null }> }, carriers: { count: number, data: Array<{ _id: string, code?: string | null, mcNumber?: string | null, name: string, type: BusinessEntityType, trailerTypes?: Array<TrailerType> | null, status: AssetStatus, address: { label: string }, contact: { firstname: string, lastname: string, email?: string | null, phoneNumber: string } }> }, assetLinkings: { count: number, data: Array<{ _id: string, isHardLinked?: boolean | null, startDate?: any | null, endDate?: any | null, driver?: { _id: string, firstname: string, lastname: string } | null, tractor?: { _id: string, serialNumber: string, mileage?: number | null } | null, trailer?: { _id: string, serialNumber: string, type: TrailerType, mileage?: number | null } | null, additionalTrailers?: Array<{ _id: string, serialNumber: string, type: TrailerType, mileage?: number | null }> | null }> } };

export type AssignTripAssetMutationVariables = Exact<{
  assignmentData: TripAssetAssignment;
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
}>;


export type AssignTripAssetMutation = { assignTripAsset: { _id: string } };

export type AssignTripAssetsMutationVariables = Exact<{
  assignmentData: Array<TripAssetAssignment> | TripAssetAssignment;
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
}>;


export type AssignTripAssetsMutation = { assignTripAssets?: { _id: string } | null };

export type AssignTripTrailerCompartmentsMutationVariables = Exact<{
  tripId: Scalars['String'];
  trailerCompartmentAssignments: Array<TrailerCompartmentAssignmentInput> | TrailerCompartmentAssignmentInput;
}>;


export type AssignTripTrailerCompartmentsMutation = { assignTripTrailerCompartments: { _id: string } };

export type ValidateAssetCustomFieldsMutationVariables = Exact<{
  shipmentId: Scalars['ObjectId'];
  assetType: TripAssetTypes;
  assetId: Scalars['ObjectId'];
}>;


export type ValidateAssetCustomFieldsMutation = { validateAssetCustomFields: Array<{ assetId: string, assetType: string, isRequired: boolean, message: string }> };

export type GetShipmentSummariesQueryVariables = Exact<{
  status?: InputMaybe<Status>;
  plannedForToday?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type GetShipmentSummariesQuery = { shipments: { data: Array<{ _id: string, billOfLadingNumbers?: Array<string> | null, purchaseOrderNumbers?: Array<string> | null, shipmentNumber: string, referenceNumbers?: Array<string> | null, commodityType?: ShipmentCommodityType | null, trailerType: TrailerType, status: Status, createdBy: string, tripId?: string | null, route?: { routeDistance: number, firstPickupTime: any, locations?: Array<{ _id: string, shipper?: { _id: string } | null, receiver?: { _id: string } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null, charges: Array<{ total: number }>, customer: { _id: string, name: string }, shipmentLocations: Array<{ _id: string, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, loadedQuantity?: number | null, weight?: number | null, unit?: GoodUnits | null, supplierId?: any | null, pinCode?: string | null, goodProfileId?: any | null, supplier?: { _id: string, name: string } | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, deliveredQuantity?: number | null, storageFacilityId?: string | null, goodProfileId?: any | null, supplierId?: any | null, supplier?: { _id: string, name: string } | null }> | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> }> } };

export type GenerateTripMutationVariables = Exact<{
  generateTripData: GenerateTripInput;
  ignoreDriverShifts?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateTripMutation = { generateTrip: { _id: string } };

export type CheckShipmentsCombinabilityMutationVariables = Exact<{
  generateTripData: GenerateTripInput;
}>;


export type CheckShipmentsCombinabilityMutation = { checkShipmentsCombinability: boolean };

export type ChangeTripStartTimeMutationVariables = Exact<{
  changeTripStartTimeData: ChangeTripStartTimeInput;
}>;


export type ChangeTripStartTimeMutation = { changeTripStartTime?: { _id: string } | null };

export type DeleteTripMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTripMutation = { deleteTrip: { _id: string } };

export type GetTripQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTripQuery = { tripById?: { _id: string, tripNumber?: string | null, status: Status, routeDistance: number, totalDistance?: number | null, loadedDistance?: number | null, predictedLoadedDistance?: number | null, deadheadDistance?: number | null, distanceToStart: number, distanceToEnd: number, firstPickupTime?: any | null, polyline: string, lastTrailerLocationDate?: any | null, liveEtaUpdatedAt?: any | null, etaStatus?: EtaStatus | null, tags?: Array<string> | null, routeStartPoint?: { label: string, name: string, addressLabel: string, type: TripRouteEndpointType, distance: number } | null, routeEndPoint?: { label: string, name: string, addressLabel: string, type: TripRouteEndpointType, distance: number } | null, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, arrivalTime: any, estimatedArrivalTime?: any | null, waitingDuration: number, setupDuration: number, serviceDuration: number, distanceTo?: number | null, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }>, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, loadedQuantity?: number | null, netLoadedQuantity?: number | null, weight?: number | null, unit?: GoodUnits | null, goodProfileId?: any | null, supplierId?: any | null, pinCode?: string | null, supplier?: { _id: string, name: string } | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, deliveredQuantity?: number | null, netDeliveredQuantity?: number | null, goodProfileId?: any | null, storageFacilityId?: string | null }> | null }>, violations?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null }> | null, shipments: Array<{ _id: string, isFromSplit?: boolean | null, isFromRotation?: boolean | null, tags?: Array<string> | null, shipmentNumber: string, referenceNumbers?: Array<string> | null, status: Status, trailerType: TrailerType, additionalTrailerTypes?: Array<TrailerType> | null, tripId?: string | null, parentShipment?: { _id: string } | null, charges: Array<{ _id: string, rate: number, unit: number, total: number }>, events?: Array<{ _id: string, type: ShipmentEventType, label?: string | null, description?: string | null, date: any, shipmentLocation?: string | null, metadata?: any | null, coordinates?: { latitude: number, longitude: number } | null }> | null, issues?: Array<{ _id: string, type: string, content: string, date: any, shipmentLocation?: string | null, delayAmount?: number | null, attachedDocuments: Array<string> }> | null, route?: { locations?: Array<{ locationType: ShipmentLocationType, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }> | null } | null }>, trailer?: { _id: string, type: TrailerType, serialNumber: string } | null, additionalTrailers?: Array<{ _id: string, type: TrailerType, serialNumber: string }> | null, tractor?: { _id: string, serialNumber: string } | null, driver?: { _id: string, firstname: string, lastname: string } | null, trailerCompartmentAssignments?: Array<{ trailerId?: any | null, compartmentId: string, commodityId: string, quantity: number, targetStorageFacilityId?: string | null }> | null, carrier?: { _id: string, name: string, code?: string | null, contact: { email?: string | null }, additionalContacts?: Array<{ email?: string | null, includeInInvoicing?: boolean | null }> | null } | null, lastTrailerLocation?: { latitude: number, longitude: number, heading?: number | null, speed?: number | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null } | null };

export type GetTripPositionsQueryVariables = Exact<{
  tripId: Scalars['String'];
}>;


export type GetTripPositionsQuery = { tripPositions: Array<{ is_moving: boolean, timestamp: string, coords: { latitude: number, longitude: number, speed?: number | null } }> };

export type StartTripMutationVariables = Exact<{
  startTripData: StartTripInput;
}>;


export type StartTripMutation = { startTrip: { _id: string } };

export type AddShipmentEventMutationVariables = Exact<{
  shipmentEventData: ShipmentEventInput;
}>;


export type AddShipmentEventMutation = { addShipmentEvent: { _id: string } };

export type EditShipmentEventMutationVariables = Exact<{
  shipmentId: Scalars['ObjectId'];
  eventId: Scalars['ObjectId'];
  shipmentEventData: UpdateShipmentEventInput;
}>;


export type EditShipmentEventMutation = { editShipmentEvent?: { _id: string } | null };

export type DeleteShipmentEventMutationVariables = Exact<{
  shipmentId: Scalars['ObjectId'];
  eventId: Scalars['ObjectId'];
}>;


export type DeleteShipmentEventMutation = { deleteShipmentEvent?: { _id: string } | null };

export type UpdateGoodDeliveredQuantityMutationVariables = Exact<{
  input: UpdateGoodDeliveredQuantityInput;
}>;


export type UpdateGoodDeliveredQuantityMutation = { updateGoodDeliveredQuantity: { _id: string } };

export type UpdateGoodLoadedQuantityMutationVariables = Exact<{
  input: UpdateGoodLoadedQuantityInput;
}>;


export type UpdateGoodLoadedQuantityMutation = { updateGoodLoadedQuantity: { _id: string } };

export type GenerateTripsForPendingShipmentsMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateTripsForPendingShipmentsMutation = { generateTripsForPendingShipments: { trips: Array<{ _id: string, polyline: string, status: Status, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, locationType: ShipmentLocationType, arrivalTime: any, waitingDuration: number, setupDuration: number, serviceDuration: number, location: { latitude: number, longitude: number }, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null }>, trailer?: { _id: string, type: TrailerType, serialNumber: string } | null, tractor?: { _id: string, serialNumber: string } | null, driver?: { _id: string, firstname: string, lastname: string } | null, shipments: Array<{ _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null, charges: Array<{ _id: string, rate: number, unit: number }> }> }>, unassignedShipmentLocations: Array<{ _id: string, locationType: ShipmentLocationType, location: { latitude: number, longitude: number }, timeWindows: Array<{ fromDate: any, toDate: any }>, shipper?: { _id: string, name: string, address: { label: string } } | null, receiver?: { _id: string, name: string, address: { label: string } } | null, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null }> | null, shipment: { _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null, shipmentLocations: Array<{ _id: string, shippedGoods?: Array<{ _id: string, label: string, weight?: number | null, quantity: number, unit?: GoodUnits | null }> | null }> } }> } };

export type GenerateTripsForShipmentsMutationVariables = Exact<{
  shipmentIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GenerateTripsForShipmentsMutation = { generateTripsForShipments: { trips: Array<{ _id: string, tripNumber?: string | null, firstPickupTime?: any | null, lastDropoffTime?: any | null, routeDistance: number, predictedLoadedDistance?: number | null, etaFromPreviousTrip?: number | null, etaToNextTrip?: number | null, totalDistance?: number | null, distanceToStart: number, distanceToEnd: number, status: Status, polyline: string, shipments: Array<{ _id: string, shipmentNumber: string }>, driver?: { _id: string } | null, tractor?: { _id: string } | null, trailer?: { _id: string } | null, shipmentLocations: Array<{ _id: string, name?: string | null, tripShipmentLocationId: string, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, arrivalTime: any, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, waitingDuration: number, setupDuration: number, serviceDuration: number, distanceTo?: number | null, timeWindows: Array<{ fromDate: any, toDate: any }>, location: { latitude: number, longitude: number }, shippedGoods?: Array<{ _id: string, label: string, quantity: number, weight?: number | null, unit?: GoodUnits | null, goodProfileId?: any | null }> | null, receivedGoods?: Array<{ goodId: string, quantity?: number | null, goodProfileId?: any | null }> | null }>, violations?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null }> | null }>, unplannedShipments: Array<{ _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null }> } };

export type GetTripListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<TripSort>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['JSON']>;
  orderBy?: InputMaybe<Array<OrderByItem> | OrderByItem>;
  status?: InputMaybe<Status>;
  excludeCarrierAssigned?: InputMaybe<Scalars['Boolean']>;
  excludeDriverAssigned?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetTripListQuery = { trips: { count: number, data: Array<{ _id: string, tripNumber?: string | null, status: Status, firstPickupTime?: any | null, lastDropoffTime?: any | null, tags?: Array<string> | null, shipments: Array<{ _id: string, shipmentNumber: string, referenceNumbers?: Array<string> | null, isFromSplit?: boolean | null, isFromRotation?: boolean | null, parentShipment?: { _id: string } | null }>, shipmentLocations: Array<{ _id: string, tripShipmentLocationId: string, shipmentId?: string | null, shipmentIds: Array<string>, shipmentLocationIds: Array<string>, name?: string | null, addressLabel?: string | null, addressTimezone?: string | null, locationType: ShipmentLocationType, arrivalTime: any, waitingDuration: number, setupDuration: number, serviceDuration: number, shipper?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, receiver?: { _id: string, name: string, addressTimezone?: string | null, address: { label: string } } | null, timeWindows: Array<{ fromDate: any, toDate: any }> }>, trailer?: { _id: string, type: TrailerType, serialNumber: string } | null, tractor?: { _id: string, serialNumber: string } | null, driver?: { _id: string, firstname: string, lastname: string } | null, carrier?: { _id: string, name: string, code?: string | null } | null, customFields?: Array<{ key: string, value?: any | null }> | null }> } };

export type UpdateTripOrderMutationVariables = Exact<{
  data: UpdateTripOrderInput;
}>;


export type UpdateTripOrderMutation = { updateTripOrder?: { _id: string } | null };

export type ValidateTripOrderMutationVariables = Exact<{
  data: UpdateTripOrderInput;
}>;


export type ValidateTripOrderMutation = { validateTripOrder?: Array<{ cause: ViolationCause, duration?: number | null, locationId?: string | null }> | null };

export type RemoveShipmentFromTripMutationVariables = Exact<{
  shipmentIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  tripId: Scalars['ObjectId'];
}>;


export type RemoveShipmentFromTripMutation = { removeShipmentFromTrip: { trip?: { _id: string } | null } };


export const SetupOrganizationDocument = `
    mutation setupOrganization($organizationSetupData: NewOrganizationInput!) {
  setupOrganization(organizationSetupData: $organizationSetupData)
}
    `;
export const useSetupOrganizationMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SetupOrganizationMutation, TError, SetupOrganizationMutationVariables, TContext>) =>
    useMutation<SetupOrganizationMutation, TError, SetupOrganizationMutationVariables, TContext>(
      ['setupOrganization'],
      (variables?: SetupOrganizationMutationVariables) => fetcher<SetupOrganizationMutation, SetupOrganizationMutationVariables>(SetupOrganizationDocument, variables)(),
      options
    );
useSetupOrganizationMutation.getKey = () => ['setupOrganization'];

useSetupOrganizationMutation.fetcher = (variables: SetupOrganizationMutationVariables, options?: RequestInit['headers']) => fetcher<SetupOrganizationMutation, SetupOrganizationMutationVariables>(SetupOrganizationDocument, variables, options);
export const ActivateTrialDocument = `
    mutation activateTrial($subscriptionType: String!) {
  activateTrial(subscriptionType: $subscriptionType) {
    status
    id
    trialStart
    trialEnd
    createdAt
    activatedAt
    mrr
    lastUpdated
  }
}
    `;
export const useActivateTrialMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ActivateTrialMutation, TError, ActivateTrialMutationVariables, TContext>) =>
    useMutation<ActivateTrialMutation, TError, ActivateTrialMutationVariables, TContext>(
      ['activateTrial'],
      (variables?: ActivateTrialMutationVariables) => fetcher<ActivateTrialMutation, ActivateTrialMutationVariables>(ActivateTrialDocument, variables)(),
      options
    );
useActivateTrialMutation.getKey = () => ['activateTrial'];

useActivateTrialMutation.fetcher = (variables: ActivateTrialMutationVariables, options?: RequestInit['headers']) => fetcher<ActivateTrialMutation, ActivateTrialMutationVariables>(ActivateTrialDocument, variables, options);
export const CheckSubscriptionDocument = `
    query checkSubscription {
  isSubscribed
}
    `;
export const useCheckSubscriptionQuery = <
      TData = CheckSubscriptionQuery,
      TError = Exception
    >(
      variables?: CheckSubscriptionQueryVariables,
      options?: UseQueryOptions<CheckSubscriptionQuery, TError, TData>
    ) =>
    useQuery<CheckSubscriptionQuery, TError, TData>(
      variables === undefined ? ['checkSubscription'] : ['checkSubscription', variables],
      fetcher<CheckSubscriptionQuery, CheckSubscriptionQueryVariables>(CheckSubscriptionDocument, variables),
      options
    );

useCheckSubscriptionQuery.getKey = (variables?: CheckSubscriptionQueryVariables) => variables === undefined ? ['checkSubscription'] : ['checkSubscription', variables];
;

useCheckSubscriptionQuery.fetcher = (variables?: CheckSubscriptionQueryVariables, options?: RequestInit['headers']) => fetcher<CheckSubscriptionQuery, CheckSubscriptionQueryVariables>(CheckSubscriptionDocument, variables, options);
export const GetCheckoutSessionDocument = `
    mutation getCheckoutSession {
  getCheckoutSession {
    url
  }
}
    `;
export const useGetCheckoutSessionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GetCheckoutSessionMutation, TError, GetCheckoutSessionMutationVariables, TContext>) =>
    useMutation<GetCheckoutSessionMutation, TError, GetCheckoutSessionMutationVariables, TContext>(
      ['getCheckoutSession'],
      (variables?: GetCheckoutSessionMutationVariables) => fetcher<GetCheckoutSessionMutation, GetCheckoutSessionMutationVariables>(GetCheckoutSessionDocument, variables)(),
      options
    );
useGetCheckoutSessionMutation.getKey = () => ['getCheckoutSession'];

useGetCheckoutSessionMutation.fetcher = (variables?: GetCheckoutSessionMutationVariables, options?: RequestInit['headers']) => fetcher<GetCheckoutSessionMutation, GetCheckoutSessionMutationVariables>(GetCheckoutSessionDocument, variables, options);
export const GetSubscriptionPortalSessionDocument = `
    mutation getSubscriptionPortalSession {
  getSubscriptionPortalSession {
    url
  }
}
    `;
export const useGetSubscriptionPortalSessionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GetSubscriptionPortalSessionMutation, TError, GetSubscriptionPortalSessionMutationVariables, TContext>) =>
    useMutation<GetSubscriptionPortalSessionMutation, TError, GetSubscriptionPortalSessionMutationVariables, TContext>(
      ['getSubscriptionPortalSession'],
      (variables?: GetSubscriptionPortalSessionMutationVariables) => fetcher<GetSubscriptionPortalSessionMutation, GetSubscriptionPortalSessionMutationVariables>(GetSubscriptionPortalSessionDocument, variables)(),
      options
    );
useGetSubscriptionPortalSessionMutation.getKey = () => ['getSubscriptionPortalSession'];

useGetSubscriptionPortalSessionMutation.fetcher = (variables?: GetSubscriptionPortalSessionMutationVariables, options?: RequestInit['headers']) => fetcher<GetSubscriptionPortalSessionMutation, GetSubscriptionPortalSessionMutationVariables>(GetSubscriptionPortalSessionDocument, variables, options);
export const UpdateMyAccountDocument = `
    mutation updateMyAccount($accountData: UpdateAccountInput!) {
  updateMyAccount(accountData: $accountData) {
    _id
  }
}
    `;
export const useUpdateMyAccountMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMyAccountMutation, TError, UpdateMyAccountMutationVariables, TContext>) =>
    useMutation<UpdateMyAccountMutation, TError, UpdateMyAccountMutationVariables, TContext>(
      ['updateMyAccount'],
      (variables?: UpdateMyAccountMutationVariables) => fetcher<UpdateMyAccountMutation, UpdateMyAccountMutationVariables>(UpdateMyAccountDocument, variables)(),
      options
    );
useUpdateMyAccountMutation.getKey = () => ['updateMyAccount'];

useUpdateMyAccountMutation.fetcher = (variables: UpdateMyAccountMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateMyAccountMutation, UpdateMyAccountMutationVariables>(UpdateMyAccountDocument, variables, options);
export const GetOrganizationSettingsDocument = `
    query getOrganizationSettings {
  organizationSettings {
    general {
      language
      measurementSystem
      useSimpleWorkflow
      currency
      driversCanSeeFutureTrips
      singleClickTripCompletion
      weekStartsOn
    }
    dispatching {
      canConsolidateInProgressShipments
      canChangeTripOrder
      canUseAdHocAddress
      canDriverSetAlternateSupplierPinCode
      enableCapacityWarnings
      shipperDwellTimeInMinutes
      receiverDwellTimeInMinutes
      orderTypeDefault
      defaultTrailerTypes
      trackCommodity
      trackNetAndGrossVolumes
      enableEta
    }
    invoicing {
      prefix
      logoUrl
      emailLogoUrl
      primaryColor
      companyAddress
      companyPhone
      companyEmail
      processes
      enableTaxRate
      remitCompanyName
      remitEmail
      remitAddress {
        line1
        line2
        city
        country
        googlePlaceId
        postalCode
        state
      }
      enableConsolidatedInvoicing
      enableSingleNumberInvoicing
      showLoadedDeliveredQuantities
      applyAllPrimaryRateTables
      receiverDocumentationSubjectTemplate
      receiverDocumentationBodyTemplate
    }
    ratecon {
      termsAndConditions
      companyAddress
      companyPhone
      companyEmail
      subjectTemplate
      bodyTemplate
    }
    transactionTemplates {
      _id
      type
      label
      rate
      unit
      unitType
      reimburseToDriver
    }
  }
}
    `;
export const useGetOrganizationSettingsQuery = <
      TData = GetOrganizationSettingsQuery,
      TError = Exception
    >(
      variables?: GetOrganizationSettingsQueryVariables,
      options?: UseQueryOptions<GetOrganizationSettingsQuery, TError, TData>
    ) =>
    useQuery<GetOrganizationSettingsQuery, TError, TData>(
      variables === undefined ? ['getOrganizationSettings'] : ['getOrganizationSettings', variables],
      fetcher<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, variables),
      options
    );

useGetOrganizationSettingsQuery.getKey = (variables?: GetOrganizationSettingsQueryVariables) => variables === undefined ? ['getOrganizationSettings'] : ['getOrganizationSettings', variables];
;

useGetOrganizationSettingsQuery.fetcher = (variables?: GetOrganizationSettingsQueryVariables, options?: RequestInit['headers']) => fetcher<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, variables, options);
export const SaveOrganizationSettingsDocument = `
    mutation saveOrganizationSettings($orgSettings: OrganizationSettingsInput!) {
  saveOrganizationSettings(newOrganizationSettingsData: $orgSettings) {
    _id
  }
}
    `;
export const useSaveOrganizationSettingsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SaveOrganizationSettingsMutation, TError, SaveOrganizationSettingsMutationVariables, TContext>) =>
    useMutation<SaveOrganizationSettingsMutation, TError, SaveOrganizationSettingsMutationVariables, TContext>(
      ['saveOrganizationSettings'],
      (variables?: SaveOrganizationSettingsMutationVariables) => fetcher<SaveOrganizationSettingsMutation, SaveOrganizationSettingsMutationVariables>(SaveOrganizationSettingsDocument, variables)(),
      options
    );
useSaveOrganizationSettingsMutation.getKey = () => ['saveOrganizationSettings'];

useSaveOrganizationSettingsMutation.fetcher = (variables: SaveOrganizationSettingsMutationVariables, options?: RequestInit['headers']) => fetcher<SaveOrganizationSettingsMutation, SaveOrganizationSettingsMutationVariables>(SaveOrganizationSettingsDocument, variables, options);
export const SaveDataSnapshotDocument = `
    mutation saveDataSnapshot {
  saveDataSnapshot {
    _id
    date
  }
}
    `;
export const useSaveDataSnapshotMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SaveDataSnapshotMutation, TError, SaveDataSnapshotMutationVariables, TContext>) =>
    useMutation<SaveDataSnapshotMutation, TError, SaveDataSnapshotMutationVariables, TContext>(
      ['saveDataSnapshot'],
      (variables?: SaveDataSnapshotMutationVariables) => fetcher<SaveDataSnapshotMutation, SaveDataSnapshotMutationVariables>(SaveDataSnapshotDocument, variables)(),
      options
    );
useSaveDataSnapshotMutation.getKey = () => ['saveDataSnapshot'];

useSaveDataSnapshotMutation.fetcher = (variables?: SaveDataSnapshotMutationVariables, options?: RequestInit['headers']) => fetcher<SaveDataSnapshotMutation, SaveDataSnapshotMutationVariables>(SaveDataSnapshotDocument, variables, options);
export const RestoreLatestSnapshotDocument = `
    mutation restoreLatestSnapshot {
  restoreLatestSnapshot
}
    `;
export const useRestoreLatestSnapshotMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<RestoreLatestSnapshotMutation, TError, RestoreLatestSnapshotMutationVariables, TContext>) =>
    useMutation<RestoreLatestSnapshotMutation, TError, RestoreLatestSnapshotMutationVariables, TContext>(
      ['restoreLatestSnapshot'],
      (variables?: RestoreLatestSnapshotMutationVariables) => fetcher<RestoreLatestSnapshotMutation, RestoreLatestSnapshotMutationVariables>(RestoreLatestSnapshotDocument, variables)(),
      options
    );
useRestoreLatestSnapshotMutation.getKey = () => ['restoreLatestSnapshot'];

useRestoreLatestSnapshotMutation.fetcher = (variables?: RestoreLatestSnapshotMutationVariables, options?: RequestInit['headers']) => fetcher<RestoreLatestSnapshotMutation, RestoreLatestSnapshotMutationVariables>(RestoreLatestSnapshotDocument, variables, options);
export const GetSubscriptionInfoDocument = `
    query getSubscriptionInfo {
  subscriptionInfo {
    status
    id
    trialStart
    trialEnd
    createdAt
    activatedAt
    numberOfAdminSeats
    numberOfDriverSeats
    mrr
    lastUpdated
    entitlements {
      featureId
      value
    }
  }
}
    `;
export const useGetSubscriptionInfoQuery = <
      TData = GetSubscriptionInfoQuery,
      TError = Exception
    >(
      variables?: GetSubscriptionInfoQueryVariables,
      options?: UseQueryOptions<GetSubscriptionInfoQuery, TError, TData>
    ) =>
    useQuery<GetSubscriptionInfoQuery, TError, TData>(
      variables === undefined ? ['getSubscriptionInfo'] : ['getSubscriptionInfo', variables],
      fetcher<GetSubscriptionInfoQuery, GetSubscriptionInfoQueryVariables>(GetSubscriptionInfoDocument, variables),
      options
    );

useGetSubscriptionInfoQuery.getKey = (variables?: GetSubscriptionInfoQueryVariables) => variables === undefined ? ['getSubscriptionInfo'] : ['getSubscriptionInfo', variables];
;

useGetSubscriptionInfoQuery.fetcher = (variables?: GetSubscriptionInfoQueryVariables, options?: RequestInit['headers']) => fetcher<GetSubscriptionInfoQuery, GetSubscriptionInfoQueryVariables>(GetSubscriptionInfoDocument, variables, options);
export const GetOrgUsersListDocument = `
    query getOrgUsersList($search: String, $skip: Int, $take: Int, $roles: [String!], $enabled: Boolean, $filter: JSON) {
  orgUsers(
    search: $search
    skip: $skip
    take: $take
    roles: $roles
    enabled: $enabled
    filter: $filter
  ) {
    data {
      _id
      email
      enabled
      username
      firstName
      lastName
      roles {
        id
        name
      }
      attributes {
        driverId
        tags
        customFields
      }
    }
    count
  }
}
    `;
export const useGetOrgUsersListQuery = <
      TData = GetOrgUsersListQuery,
      TError = Exception
    >(
      variables?: GetOrgUsersListQueryVariables,
      options?: UseQueryOptions<GetOrgUsersListQuery, TError, TData>
    ) =>
    useQuery<GetOrgUsersListQuery, TError, TData>(
      variables === undefined ? ['getOrgUsersList'] : ['getOrgUsersList', variables],
      fetcher<GetOrgUsersListQuery, GetOrgUsersListQueryVariables>(GetOrgUsersListDocument, variables),
      options
    );

useGetOrgUsersListQuery.getKey = (variables?: GetOrgUsersListQueryVariables) => variables === undefined ? ['getOrgUsersList'] : ['getOrgUsersList', variables];
;

useGetOrgUsersListQuery.fetcher = (variables?: GetOrgUsersListQueryVariables, options?: RequestInit['headers']) => fetcher<GetOrgUsersListQuery, GetOrgUsersListQueryVariables>(GetOrgUsersListDocument, variables, options);
export const GetOrgUserDetailsDocument = `
    query getOrgUserDetails($id: String!) {
  orgUserById(id: $id) {
    _id
    email
    username
    firstName
    lastName
    enabled
    attributes {
      driverId
      tags
      customFields
    }
    roles {
      id
      name
    }
  }
}
    `;
export const useGetOrgUserDetailsQuery = <
      TData = GetOrgUserDetailsQuery,
      TError = Exception
    >(
      variables: GetOrgUserDetailsQueryVariables,
      options?: UseQueryOptions<GetOrgUserDetailsQuery, TError, TData>
    ) =>
    useQuery<GetOrgUserDetailsQuery, TError, TData>(
      ['getOrgUserDetails', variables],
      fetcher<GetOrgUserDetailsQuery, GetOrgUserDetailsQueryVariables>(GetOrgUserDetailsDocument, variables),
      options
    );

useGetOrgUserDetailsQuery.getKey = (variables: GetOrgUserDetailsQueryVariables) => ['getOrgUserDetails', variables];
;

useGetOrgUserDetailsQuery.fetcher = (variables: GetOrgUserDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetOrgUserDetailsQuery, GetOrgUserDetailsQueryVariables>(GetOrgUserDetailsDocument, variables, options);
export const DeleteOrgUserDocument = `
    mutation deleteOrgUser($id: String!) {
  deleteOrgUser(id: $id)
}
    `;
export const useDeleteOrgUserMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOrgUserMutation, TError, DeleteOrgUserMutationVariables, TContext>) =>
    useMutation<DeleteOrgUserMutation, TError, DeleteOrgUserMutationVariables, TContext>(
      ['deleteOrgUser'],
      (variables?: DeleteOrgUserMutationVariables) => fetcher<DeleteOrgUserMutation, DeleteOrgUserMutationVariables>(DeleteOrgUserDocument, variables)(),
      options
    );
useDeleteOrgUserMutation.getKey = () => ['deleteOrgUser'];

useDeleteOrgUserMutation.fetcher = (variables: DeleteOrgUserMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteOrgUserMutation, DeleteOrgUserMutationVariables>(DeleteOrgUserDocument, variables, options);
export const AddOrgUserDocument = `
    mutation addOrgUser($newOrgUserData: NewOrgUserInput!) {
  addOrgUser(newOrgUserData: $newOrgUserData) {
    _id
  }
}
    `;
export const useAddOrgUserMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddOrgUserMutation, TError, AddOrgUserMutationVariables, TContext>) =>
    useMutation<AddOrgUserMutation, TError, AddOrgUserMutationVariables, TContext>(
      ['addOrgUser'],
      (variables?: AddOrgUserMutationVariables) => fetcher<AddOrgUserMutation, AddOrgUserMutationVariables>(AddOrgUserDocument, variables)(),
      options
    );
useAddOrgUserMutation.getKey = () => ['addOrgUser'];

useAddOrgUserMutation.fetcher = (variables: AddOrgUserMutationVariables, options?: RequestInit['headers']) => fetcher<AddOrgUserMutation, AddOrgUserMutationVariables>(AddOrgUserDocument, variables, options);
export const EditOrgUserDocument = `
    mutation editOrgUser($id: String!, $editOrgUserData: OrgUserUpdateInput!) {
  editOrgUser(id: $id, editOrgUserData: $editOrgUserData) {
    _id
  }
}
    `;
export const useEditOrgUserMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditOrgUserMutation, TError, EditOrgUserMutationVariables, TContext>) =>
    useMutation<EditOrgUserMutation, TError, EditOrgUserMutationVariables, TContext>(
      ['editOrgUser'],
      (variables?: EditOrgUserMutationVariables) => fetcher<EditOrgUserMutation, EditOrgUserMutationVariables>(EditOrgUserDocument, variables)(),
      options
    );
useEditOrgUserMutation.getKey = () => ['editOrgUser'];

useEditOrgUserMutation.fetcher = (variables: EditOrgUserMutationVariables, options?: RequestInit['headers']) => fetcher<EditOrgUserMutation, EditOrgUserMutationVariables>(EditOrgUserDocument, variables, options);
export const UpdatePasswordDocument = `
    mutation updatePassword($id: String!, $temporaryPassword: String!) {
  updatePassword(id: $id, temporaryPassword: $temporaryPassword)
}
    `;
export const useUpdatePasswordMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePasswordMutation, TError, UpdatePasswordMutationVariables, TContext>) =>
    useMutation<UpdatePasswordMutation, TError, UpdatePasswordMutationVariables, TContext>(
      ['updatePassword'],
      (variables?: UpdatePasswordMutationVariables) => fetcher<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, variables)(),
      options
    );
useUpdatePasswordMutation.getKey = () => ['updatePassword'];

useUpdatePasswordMutation.fetcher = (variables: UpdatePasswordMutationVariables, options?: RequestInit['headers']) => fetcher<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, variables, options);
export const GetRolesDocument = `
    query getRoles {
  roles {
    id
    name
  }
}
    `;
export const useGetRolesQuery = <
      TData = GetRolesQuery,
      TError = Exception
    >(
      variables?: GetRolesQueryVariables,
      options?: UseQueryOptions<GetRolesQuery, TError, TData>
    ) =>
    useQuery<GetRolesQuery, TError, TData>(
      variables === undefined ? ['getRoles'] : ['getRoles', variables],
      fetcher<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, variables),
      options
    );

useGetRolesQuery.getKey = (variables?: GetRolesQueryVariables) => variables === undefined ? ['getRoles'] : ['getRoles', variables];
;

useGetRolesQuery.fetcher = (variables?: GetRolesQueryVariables, options?: RequestInit['headers']) => fetcher<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, variables, options);
export const BulkAddOrgUsersDocument = `
    mutation bulkAddOrgUsers($newOrgUsersData: [NewOrgUserInput!]!) {
  bulkAddOrgUsers(newOrgUsersData: $newOrgUsersData) {
    _id
  }
}
    `;
export const useBulkAddOrgUsersMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddOrgUsersMutation, TError, BulkAddOrgUsersMutationVariables, TContext>) =>
    useMutation<BulkAddOrgUsersMutation, TError, BulkAddOrgUsersMutationVariables, TContext>(
      ['bulkAddOrgUsers'],
      (variables?: BulkAddOrgUsersMutationVariables) => fetcher<BulkAddOrgUsersMutation, BulkAddOrgUsersMutationVariables>(BulkAddOrgUsersDocument, variables)(),
      options
    );
useBulkAddOrgUsersMutation.getKey = () => ['bulkAddOrgUsers'];

useBulkAddOrgUsersMutation.fetcher = (variables: BulkAddOrgUsersMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddOrgUsersMutation, BulkAddOrgUsersMutationVariables>(BulkAddOrgUsersDocument, variables, options);
export const UpdateAccountStatusDocument = `
    mutation updateAccountStatus($enabled: Boolean!, $id: String!) {
  updateAccountStatus(enabled: $enabled, id: $id)
}
    `;
export const useUpdateAccountStatusMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAccountStatusMutation, TError, UpdateAccountStatusMutationVariables, TContext>) =>
    useMutation<UpdateAccountStatusMutation, TError, UpdateAccountStatusMutationVariables, TContext>(
      ['updateAccountStatus'],
      (variables?: UpdateAccountStatusMutationVariables) => fetcher<UpdateAccountStatusMutation, UpdateAccountStatusMutationVariables>(UpdateAccountStatusDocument, variables)(),
      options
    );
useUpdateAccountStatusMutation.getKey = () => ['updateAccountStatus'];

useUpdateAccountStatusMutation.fetcher = (variables: UpdateAccountStatusMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateAccountStatusMutation, UpdateAccountStatusMutationVariables>(UpdateAccountStatusDocument, variables, options);
export const GetCustomerBillingRulesDocument = `
    query getCustomerBillingRules($customer: String!, $skip: Int, $take: Int, $search: String, $orderBy: [OrderByItem!], $filter: JSON) {
  billingRules(
    customer: $customer
    skip: $skip
    take: $take
    search: $search
    orderBy: $orderBy
    filter: $filter
  ) {
    count
    data {
      type
      _id
      label
      referenceNumber
      conditions {
        target
        parameters {
          type
          value
        }
        operator
        value
      }
      rates {
        method
        amount
        referenceNumber
        label
        taxable
        parameters {
          type
          value
        }
      }
      method
      amount
      priority
      effectiveStartDate
      effectiveEndDate
      isActive
      customFields {
        key
        value
      }
    }
  }
}
    `;
export const useGetCustomerBillingRulesQuery = <
      TData = GetCustomerBillingRulesQuery,
      TError = Exception
    >(
      variables: GetCustomerBillingRulesQueryVariables,
      options?: UseQueryOptions<GetCustomerBillingRulesQuery, TError, TData>
    ) =>
    useQuery<GetCustomerBillingRulesQuery, TError, TData>(
      ['getCustomerBillingRules', variables],
      fetcher<GetCustomerBillingRulesQuery, GetCustomerBillingRulesQueryVariables>(GetCustomerBillingRulesDocument, variables),
      options
    );

useGetCustomerBillingRulesQuery.getKey = (variables: GetCustomerBillingRulesQueryVariables) => ['getCustomerBillingRules', variables];
;

useGetCustomerBillingRulesQuery.fetcher = (variables: GetCustomerBillingRulesQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomerBillingRulesQuery, GetCustomerBillingRulesQueryVariables>(GetCustomerBillingRulesDocument, variables, options);
export const EditBillingRuleDocument = `
    mutation editBillingRule($id: String!, $editBillingRuleData: BillingRuleUpdateInput!) {
  editBillingRule(editBillingRuleData: $editBillingRuleData, id: $id) {
    _id
  }
}
    `;
export const useEditBillingRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditBillingRuleMutation, TError, EditBillingRuleMutationVariables, TContext>) =>
    useMutation<EditBillingRuleMutation, TError, EditBillingRuleMutationVariables, TContext>(
      ['editBillingRule'],
      (variables?: EditBillingRuleMutationVariables) => fetcher<EditBillingRuleMutation, EditBillingRuleMutationVariables>(EditBillingRuleDocument, variables)(),
      options
    );
useEditBillingRuleMutation.getKey = () => ['editBillingRule'];

useEditBillingRuleMutation.fetcher = (variables: EditBillingRuleMutationVariables, options?: RequestInit['headers']) => fetcher<EditBillingRuleMutation, EditBillingRuleMutationVariables>(EditBillingRuleDocument, variables, options);
export const AddBillingRuleDocument = `
    mutation addBillingRule($newBillingRuleData: NewBillingRuleInput!) {
  addBillingRule(newBillingRuleData: $newBillingRuleData) {
    _id
  }
}
    `;
export const useAddBillingRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddBillingRuleMutation, TError, AddBillingRuleMutationVariables, TContext>) =>
    useMutation<AddBillingRuleMutation, TError, AddBillingRuleMutationVariables, TContext>(
      ['addBillingRule'],
      (variables?: AddBillingRuleMutationVariables) => fetcher<AddBillingRuleMutation, AddBillingRuleMutationVariables>(AddBillingRuleDocument, variables)(),
      options
    );
useAddBillingRuleMutation.getKey = () => ['addBillingRule'];

useAddBillingRuleMutation.fetcher = (variables: AddBillingRuleMutationVariables, options?: RequestInit['headers']) => fetcher<AddBillingRuleMutation, AddBillingRuleMutationVariables>(AddBillingRuleDocument, variables, options);
export const DeleteBillingRuleDocument = `
    mutation deleteBillingRule($id: String!) {
  deleteBillingRule(id: $id)
}
    `;
export const useDeleteBillingRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBillingRuleMutation, TError, DeleteBillingRuleMutationVariables, TContext>) =>
    useMutation<DeleteBillingRuleMutation, TError, DeleteBillingRuleMutationVariables, TContext>(
      ['deleteBillingRule'],
      (variables?: DeleteBillingRuleMutationVariables) => fetcher<DeleteBillingRuleMutation, DeleteBillingRuleMutationVariables>(DeleteBillingRuleDocument, variables)(),
      options
    );
useDeleteBillingRuleMutation.getKey = () => ['deleteBillingRule'];

useDeleteBillingRuleMutation.fetcher = (variables: DeleteBillingRuleMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteBillingRuleMutation, DeleteBillingRuleMutationVariables>(DeleteBillingRuleDocument, variables, options);
export const GetDriverDeductionRulesDocument = `
    query getDriverDeductionRules($driver: String!) {
  deductionRules(driver: $driver) {
    data {
      _id
      method
      amount
      label
      type
      period {
        start
        repeatEvery
        unit
        end
      }
    }
  }
}
    `;
export const useGetDriverDeductionRulesQuery = <
      TData = GetDriverDeductionRulesQuery,
      TError = Exception
    >(
      variables: GetDriverDeductionRulesQueryVariables,
      options?: UseQueryOptions<GetDriverDeductionRulesQuery, TError, TData>
    ) =>
    useQuery<GetDriverDeductionRulesQuery, TError, TData>(
      ['getDriverDeductionRules', variables],
      fetcher<GetDriverDeductionRulesQuery, GetDriverDeductionRulesQueryVariables>(GetDriverDeductionRulesDocument, variables),
      options
    );

useGetDriverDeductionRulesQuery.getKey = (variables: GetDriverDeductionRulesQueryVariables) => ['getDriverDeductionRules', variables];
;

useGetDriverDeductionRulesQuery.fetcher = (variables: GetDriverDeductionRulesQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverDeductionRulesQuery, GetDriverDeductionRulesQueryVariables>(GetDriverDeductionRulesDocument, variables, options);
export const EditDeductionRuleDocument = `
    mutation editDeductionRule($id: String!, $editDeductionRuleData: DeductionRuleUpdateInput!) {
  editDeductionRule(editDeductionRuleData: $editDeductionRuleData, id: $id) {
    _id
  }
}
    `;
export const useEditDeductionRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditDeductionRuleMutation, TError, EditDeductionRuleMutationVariables, TContext>) =>
    useMutation<EditDeductionRuleMutation, TError, EditDeductionRuleMutationVariables, TContext>(
      ['editDeductionRule'],
      (variables?: EditDeductionRuleMutationVariables) => fetcher<EditDeductionRuleMutation, EditDeductionRuleMutationVariables>(EditDeductionRuleDocument, variables)(),
      options
    );
useEditDeductionRuleMutation.getKey = () => ['editDeductionRule'];

useEditDeductionRuleMutation.fetcher = (variables: EditDeductionRuleMutationVariables, options?: RequestInit['headers']) => fetcher<EditDeductionRuleMutation, EditDeductionRuleMutationVariables>(EditDeductionRuleDocument, variables, options);
export const AddDeductionRuleDocument = `
    mutation addDeductionRule($newDeductionRuleData: NewDeductionRuleInput!) {
  addDeductionRule(newDeductionRuleData: $newDeductionRuleData) {
    _id
  }
}
    `;
export const useAddDeductionRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddDeductionRuleMutation, TError, AddDeductionRuleMutationVariables, TContext>) =>
    useMutation<AddDeductionRuleMutation, TError, AddDeductionRuleMutationVariables, TContext>(
      ['addDeductionRule'],
      (variables?: AddDeductionRuleMutationVariables) => fetcher<AddDeductionRuleMutation, AddDeductionRuleMutationVariables>(AddDeductionRuleDocument, variables)(),
      options
    );
useAddDeductionRuleMutation.getKey = () => ['addDeductionRule'];

useAddDeductionRuleMutation.fetcher = (variables: AddDeductionRuleMutationVariables, options?: RequestInit['headers']) => fetcher<AddDeductionRuleMutation, AddDeductionRuleMutationVariables>(AddDeductionRuleDocument, variables, options);
export const DeleteDeductionRuleDocument = `
    mutation deleteDeductionRule($id: String!) {
  deleteDeductionRule(id: $id)
}
    `;
export const useDeleteDeductionRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDeductionRuleMutation, TError, DeleteDeductionRuleMutationVariables, TContext>) =>
    useMutation<DeleteDeductionRuleMutation, TError, DeleteDeductionRuleMutationVariables, TContext>(
      ['deleteDeductionRule'],
      (variables?: DeleteDeductionRuleMutationVariables) => fetcher<DeleteDeductionRuleMutation, DeleteDeductionRuleMutationVariables>(DeleteDeductionRuleDocument, variables)(),
      options
    );
useDeleteDeductionRuleMutation.getKey = () => ['deleteDeductionRule'];

useDeleteDeductionRuleMutation.fetcher = (variables: DeleteDeductionRuleMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteDeductionRuleMutation, DeleteDeductionRuleMutationVariables>(DeleteDeductionRuleDocument, variables, options);
export const GetInvoiceListDocument = `
    query getInvoiceList($search: String, $skip: Int, $take: Int, $status: InvoiceStatus, $filter: JSON, $orderBy: [OrderByItem!]) {
  invoices(
    search: $search
    skip: $skip
    take: $take
    status: $status
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      invoiceNumber
      status
      closingNote
      pdfDocument {
        isGenerating
        error
        url
      }
      charges {
        _id
        unit
        rate
        taxable
      }
      customer {
        _id
        name
        contact {
          email
        }
        customFields {
          key
          value
        }
      }
      shipment {
        _id
        shipmentNumber
        referenceNumbers
      }
      shipments {
        _id
        shipmentNumber
        referenceNumbers
        purchaseOrderNumbers
        ticketNumbers
        billOfLadingNumbers
        rateConNumbers
        route {
          lastDropoffTime
        }
        trip {
          lastDropoffTime
        }
        tags
        shipmentLocations {
          shipper {
            _id
            name
          }
          receiver {
            _id
            name
          }
        }
      }
      taxRate
      groupIds
    }
    count
  }
}
    `;
export const useGetInvoiceListQuery = <
      TData = GetInvoiceListQuery,
      TError = Exception
    >(
      variables?: GetInvoiceListQueryVariables,
      options?: UseQueryOptions<GetInvoiceListQuery, TError, TData>
    ) =>
    useQuery<GetInvoiceListQuery, TError, TData>(
      variables === undefined ? ['getInvoiceList'] : ['getInvoiceList', variables],
      fetcher<GetInvoiceListQuery, GetInvoiceListQueryVariables>(GetInvoiceListDocument, variables),
      options
    );

useGetInvoiceListQuery.getKey = (variables?: GetInvoiceListQueryVariables) => variables === undefined ? ['getInvoiceList'] : ['getInvoiceList', variables];
;

useGetInvoiceListQuery.fetcher = (variables?: GetInvoiceListQueryVariables, options?: RequestInit['headers']) => fetcher<GetInvoiceListQuery, GetInvoiceListQueryVariables>(GetInvoiceListDocument, variables, options);
export const GetInvoiceDetailsDocument = `
    query getInvoiceDetails($id: String!) {
  invoiceById(id: $id) {
    _id
    invoiceNumber
    pdfDocument {
      isGenerating
      error
      url
    }
    charges {
      _id
      unit
      rate
      taxable
      label
      unitType
      chargeType
      shipmentId
      customFields {
        key
        value
      }
      billingRule {
        _id
        label
        referenceNumber
      }
      ratingTable {
        _id
        label
        referenceNumber
      }
      document {
        name
        url
      }
    }
    customer {
      _id
      name
      contact {
        email
      }
      additionalContacts {
        email
        includeInInvoicing
      }
      customFields {
        key
        value
      }
    }
    customFields {
      key
      value
    }
    taxRate
    status
    paidAmount
    payments {
      _id
      amount
      date
      paymentMethod
      note
    }
    shipments {
      _id
      shipmentNumber
      referenceNumbers
      purchaseOrderNumbers
      ticketNumbers
      billOfLadingNumbers
      rateConNumbers
      route {
        lastDropoffTime
      }
      trip {
        lastDropoffTime
      }
      customer {
        _id
        name
        type
        code
      }
    }
    groupIds
  }
}
    `;
export const useGetInvoiceDetailsQuery = <
      TData = GetInvoiceDetailsQuery,
      TError = Exception
    >(
      variables: GetInvoiceDetailsQueryVariables,
      options?: UseQueryOptions<GetInvoiceDetailsQuery, TError, TData>
    ) =>
    useQuery<GetInvoiceDetailsQuery, TError, TData>(
      ['getInvoiceDetails', variables],
      fetcher<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>(GetInvoiceDetailsDocument, variables),
      options
    );

useGetInvoiceDetailsQuery.getKey = (variables: GetInvoiceDetailsQueryVariables) => ['getInvoiceDetails', variables];
;

useGetInvoiceDetailsQuery.fetcher = (variables: GetInvoiceDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetInvoiceDetailsQuery, GetInvoiceDetailsQueryVariables>(GetInvoiceDetailsDocument, variables, options);
export const GetShipmentInvoiceDetailsDocument = `
    query getShipmentInvoiceDetails($shipmentId: String!) {
  invoiceByShipmentId(shipmentId: $shipmentId) {
    _id
    invoiceNumber
    pdfDocument {
      isGenerating
      url
      error
    }
    customer {
      _id
      name
      contact {
        email
      }
      additionalContacts {
        email
        includeInInvoicing
      }
      customFields {
        key
        value
      }
    }
    charges {
      _id
      unit
      rate
      taxable
      label
      unitType
      chargeType
    }
    taxRate
    status
    paidAmount
    shipments {
      _id
      shipmentNumber
      referenceNumbers
      purchaseOrderNumbers
      ticketNumbers
      billOfLadingNumbers
      rateConNumbers
      route {
        lastDropoffTime
      }
      trip {
        lastDropoffTime
      }
    }
    groupIds
  }
}
    `;
export const useGetShipmentInvoiceDetailsQuery = <
      TData = GetShipmentInvoiceDetailsQuery,
      TError = Exception
    >(
      variables: GetShipmentInvoiceDetailsQueryVariables,
      options?: UseQueryOptions<GetShipmentInvoiceDetailsQuery, TError, TData>
    ) =>
    useQuery<GetShipmentInvoiceDetailsQuery, TError, TData>(
      ['getShipmentInvoiceDetails', variables],
      fetcher<GetShipmentInvoiceDetailsQuery, GetShipmentInvoiceDetailsQueryVariables>(GetShipmentInvoiceDetailsDocument, variables),
      options
    );

useGetShipmentInvoiceDetailsQuery.getKey = (variables: GetShipmentInvoiceDetailsQueryVariables) => ['getShipmentInvoiceDetails', variables];
;

useGetShipmentInvoiceDetailsQuery.fetcher = (variables: GetShipmentInvoiceDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentInvoiceDetailsQuery, GetShipmentInvoiceDetailsQueryVariables>(GetShipmentInvoiceDetailsDocument, variables, options);
export const GenerateInvoiceDocument = `
    mutation generateInvoice($shipmentId: String!, $invoiceNumber: String) {
  generateInvoice(shipmentId: $shipmentId, invoiceNumber: $invoiceNumber) {
    _id
  }
}
    `;
export const useGenerateInvoiceMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateInvoiceMutation, TError, GenerateInvoiceMutationVariables, TContext>) =>
    useMutation<GenerateInvoiceMutation, TError, GenerateInvoiceMutationVariables, TContext>(
      ['generateInvoice'],
      (variables?: GenerateInvoiceMutationVariables) => fetcher<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>(GenerateInvoiceDocument, variables)(),
      options
    );
useGenerateInvoiceMutation.getKey = () => ['generateInvoice'];

useGenerateInvoiceMutation.fetcher = (variables: GenerateInvoiceMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>(GenerateInvoiceDocument, variables, options);
export const BatchProcessInvoicesDocument = `
    mutation batchProcessInvoices($invoiceIds: [ObjectId!]!, $status: InvoiceStatus!) {
  batchProcessInvoices(invoiceIds: $invoiceIds, status: $status) {
    invoicesUpdated {
      _id
      status
    }
    textError
    textWarning
  }
}
    `;
export const useBatchProcessInvoicesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BatchProcessInvoicesMutation, TError, BatchProcessInvoicesMutationVariables, TContext>) =>
    useMutation<BatchProcessInvoicesMutation, TError, BatchProcessInvoicesMutationVariables, TContext>(
      ['batchProcessInvoices'],
      (variables?: BatchProcessInvoicesMutationVariables) => fetcher<BatchProcessInvoicesMutation, BatchProcessInvoicesMutationVariables>(BatchProcessInvoicesDocument, variables)(),
      options
    );
useBatchProcessInvoicesMutation.getKey = () => ['batchProcessInvoices'];

useBatchProcessInvoicesMutation.fetcher = (variables: BatchProcessInvoicesMutationVariables, options?: RequestInit['headers']) => fetcher<BatchProcessInvoicesMutation, BatchProcessInvoicesMutationVariables>(BatchProcessInvoicesDocument, variables, options);
export const DeleteInvoiceDocument = `
    mutation deleteInvoice($id: String!) {
  deleteInvoice(id: $id)
}
    `;
export const useDeleteInvoiceMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteInvoiceMutation, TError, DeleteInvoiceMutationVariables, TContext>) =>
    useMutation<DeleteInvoiceMutation, TError, DeleteInvoiceMutationVariables, TContext>(
      ['deleteInvoice'],
      (variables?: DeleteInvoiceMutationVariables) => fetcher<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, variables)(),
      options
    );
useDeleteInvoiceMutation.getKey = () => ['deleteInvoice'];

useDeleteInvoiceMutation.fetcher = (variables: DeleteInvoiceMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, variables, options);
export const BulkEditInvoicesDocument = `
    mutation bulkEditInvoices($ids: [ObjectId!]!, $bulkEditInvoiceData: InvoiceBulkUpdateInput!) {
  bulkEditInvoices(ids: $ids, bulkEditInvoiceData: $bulkEditInvoiceData) {
    _id
  }
}
    `;
export const useBulkEditInvoicesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkEditInvoicesMutation, TError, BulkEditInvoicesMutationVariables, TContext>) =>
    useMutation<BulkEditInvoicesMutation, TError, BulkEditInvoicesMutationVariables, TContext>(
      ['bulkEditInvoices'],
      (variables?: BulkEditInvoicesMutationVariables) => fetcher<BulkEditInvoicesMutation, BulkEditInvoicesMutationVariables>(BulkEditInvoicesDocument, variables)(),
      options
    );
useBulkEditInvoicesMutation.getKey = () => ['bulkEditInvoices'];

useBulkEditInvoicesMutation.fetcher = (variables: BulkEditInvoicesMutationVariables, options?: RequestInit['headers']) => fetcher<BulkEditInvoicesMutation, BulkEditInvoicesMutationVariables>(BulkEditInvoicesDocument, variables, options);
export const SendInvoiceDocument = `
    mutation sendInvoice($invoiceId: String!) {
  sendInvoice(invoiceId: $invoiceId) {
    _id
    status
  }
}
    `;
export const useSendInvoiceMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SendInvoiceMutation, TError, SendInvoiceMutationVariables, TContext>) =>
    useMutation<SendInvoiceMutation, TError, SendInvoiceMutationVariables, TContext>(
      ['sendInvoice'],
      (variables?: SendInvoiceMutationVariables) => fetcher<SendInvoiceMutation, SendInvoiceMutationVariables>(SendInvoiceDocument, variables)(),
      options
    );
useSendInvoiceMutation.getKey = () => ['sendInvoice'];

useSendInvoiceMutation.fetcher = (variables: SendInvoiceMutationVariables, options?: RequestInit['headers']) => fetcher<SendInvoiceMutation, SendInvoiceMutationVariables>(SendInvoiceDocument, variables, options);
export const UpdateInvoiceStatusDocument = `
    mutation updateInvoiceStatus($invoiceId: String!, $status: InvoiceStatus!, $closingNote: String, $paidAmount: Float) {
  updateInvoiceStatus(
    invoiceId: $invoiceId
    status: $status
    closingNote: $closingNote
    paidAmount: $paidAmount
  ) {
    _id
    status
  }
}
    `;
export const useUpdateInvoiceStatusMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInvoiceStatusMutation, TError, UpdateInvoiceStatusMutationVariables, TContext>) =>
    useMutation<UpdateInvoiceStatusMutation, TError, UpdateInvoiceStatusMutationVariables, TContext>(
      ['updateInvoiceStatus'],
      (variables?: UpdateInvoiceStatusMutationVariables) => fetcher<UpdateInvoiceStatusMutation, UpdateInvoiceStatusMutationVariables>(UpdateInvoiceStatusDocument, variables)(),
      options
    );
useUpdateInvoiceStatusMutation.getKey = () => ['updateInvoiceStatus'];

useUpdateInvoiceStatusMutation.fetcher = (variables: UpdateInvoiceStatusMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateInvoiceStatusMutation, UpdateInvoiceStatusMutationVariables>(UpdateInvoiceStatusDocument, variables, options);
export const UpdateInvoiceTaxRateDocument = `
    mutation updateInvoiceTaxRate($invoiceId: String!, $taxRate: Float) {
  updateInvoiceTaxRate(invoiceId: $invoiceId, taxRate: $taxRate) {
    _id
    taxRate
  }
}
    `;
export const useUpdateInvoiceTaxRateMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInvoiceTaxRateMutation, TError, UpdateInvoiceTaxRateMutationVariables, TContext>) =>
    useMutation<UpdateInvoiceTaxRateMutation, TError, UpdateInvoiceTaxRateMutationVariables, TContext>(
      ['updateInvoiceTaxRate'],
      (variables?: UpdateInvoiceTaxRateMutationVariables) => fetcher<UpdateInvoiceTaxRateMutation, UpdateInvoiceTaxRateMutationVariables>(UpdateInvoiceTaxRateDocument, variables)(),
      options
    );
useUpdateInvoiceTaxRateMutation.getKey = () => ['updateInvoiceTaxRate'];

useUpdateInvoiceTaxRateMutation.fetcher = (variables: UpdateInvoiceTaxRateMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateInvoiceTaxRateMutation, UpdateInvoiceTaxRateMutationVariables>(UpdateInvoiceTaxRateDocument, variables, options);
export const ConsolidateInvoicesDocument = `
    mutation consolidateInvoices($invoiceIds: [ObjectId!]!) {
  consolidateInvoices(invoiceIds: $invoiceIds) {
    _id
  }
}
    `;
export const useConsolidateInvoicesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ConsolidateInvoicesMutation, TError, ConsolidateInvoicesMutationVariables, TContext>) =>
    useMutation<ConsolidateInvoicesMutation, TError, ConsolidateInvoicesMutationVariables, TContext>(
      ['consolidateInvoices'],
      (variables?: ConsolidateInvoicesMutationVariables) => fetcher<ConsolidateInvoicesMutation, ConsolidateInvoicesMutationVariables>(ConsolidateInvoicesDocument, variables)(),
      options
    );
useConsolidateInvoicesMutation.getKey = () => ['consolidateInvoices'];

useConsolidateInvoicesMutation.fetcher = (variables: ConsolidateInvoicesMutationVariables, options?: RequestInit['headers']) => fetcher<ConsolidateInvoicesMutation, ConsolidateInvoicesMutationVariables>(ConsolidateInvoicesDocument, variables, options);
export const SeparateInvoiceDocument = `
    mutation separateInvoice($invoiceId: ObjectId!, $shipmentIds: [ObjectId!]!) {
  separateInvoice(invoiceId: $invoiceId, shipmentIds: $shipmentIds) {
    _id
    invoiceNumber
  }
}
    `;
export const useSeparateInvoiceMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SeparateInvoiceMutation, TError, SeparateInvoiceMutationVariables, TContext>) =>
    useMutation<SeparateInvoiceMutation, TError, SeparateInvoiceMutationVariables, TContext>(
      ['separateInvoice'],
      (variables?: SeparateInvoiceMutationVariables) => fetcher<SeparateInvoiceMutation, SeparateInvoiceMutationVariables>(SeparateInvoiceDocument, variables)(),
      options
    );
useSeparateInvoiceMutation.getKey = () => ['separateInvoice'];

useSeparateInvoiceMutation.fetcher = (variables: SeparateInvoiceMutationVariables, options?: RequestInit['headers']) => fetcher<SeparateInvoiceMutation, SeparateInvoiceMutationVariables>(SeparateInvoiceDocument, variables, options);
export const EditInvoiceDocument = `
    mutation editInvoice($id: ObjectId!, $editInvoiceData: InvoiceUpdateInput!) {
  editInvoice(id: $id, editInvoiceData: $editInvoiceData) {
    _id
  }
}
    `;
export const useEditInvoiceMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditInvoiceMutation, TError, EditInvoiceMutationVariables, TContext>) =>
    useMutation<EditInvoiceMutation, TError, EditInvoiceMutationVariables, TContext>(
      ['editInvoice'],
      (variables?: EditInvoiceMutationVariables) => fetcher<EditInvoiceMutation, EditInvoiceMutationVariables>(EditInvoiceDocument, variables)(),
      options
    );
useEditInvoiceMutation.getKey = () => ['editInvoice'];

useEditInvoiceMutation.fetcher = (variables: EditInvoiceMutationVariables, options?: RequestInit['headers']) => fetcher<EditInvoiceMutation, EditInvoiceMutationVariables>(EditInvoiceDocument, variables, options);
export const RecalculateInvoiceChargesDocument = `
    mutation recalculateInvoiceCharges($invoiceId: String!) {
  recalculateInvoiceCharges(invoiceId: $invoiceId) {
    _id
  }
}
    `;
export const useRecalculateInvoiceChargesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<RecalculateInvoiceChargesMutation, TError, RecalculateInvoiceChargesMutationVariables, TContext>) =>
    useMutation<RecalculateInvoiceChargesMutation, TError, RecalculateInvoiceChargesMutationVariables, TContext>(
      ['recalculateInvoiceCharges'],
      (variables?: RecalculateInvoiceChargesMutationVariables) => fetcher<RecalculateInvoiceChargesMutation, RecalculateInvoiceChargesMutationVariables>(RecalculateInvoiceChargesDocument, variables)(),
      options
    );
useRecalculateInvoiceChargesMutation.getKey = () => ['recalculateInvoiceCharges'];

useRecalculateInvoiceChargesMutation.fetcher = (variables: RecalculateInvoiceChargesMutationVariables, options?: RequestInit['headers']) => fetcher<RecalculateInvoiceChargesMutation, RecalculateInvoiceChargesMutationVariables>(RecalculateInvoiceChargesDocument, variables, options);
export const NextInvoiceNumberDocument = `
    query nextInvoiceNumber {
  nextInvoiceNumber
}
    `;
export const useNextInvoiceNumberQuery = <
      TData = NextInvoiceNumberQuery,
      TError = Exception
    >(
      variables?: NextInvoiceNumberQueryVariables,
      options?: UseQueryOptions<NextInvoiceNumberQuery, TError, TData>
    ) =>
    useQuery<NextInvoiceNumberQuery, TError, TData>(
      variables === undefined ? ['nextInvoiceNumber'] : ['nextInvoiceNumber', variables],
      fetcher<NextInvoiceNumberQuery, NextInvoiceNumberQueryVariables>(NextInvoiceNumberDocument, variables),
      options
    );

useNextInvoiceNumberQuery.getKey = (variables?: NextInvoiceNumberQueryVariables) => variables === undefined ? ['nextInvoiceNumber'] : ['nextInvoiceNumber', variables];
;

useNextInvoiceNumberQuery.fetcher = (variables?: NextInvoiceNumberQueryVariables, options?: RequestInit['headers']) => fetcher<NextInvoiceNumberQuery, NextInvoiceNumberQueryVariables>(NextInvoiceNumberDocument, variables, options);
export const SetNextInvoiceNumberDocument = `
    mutation setNextInvoiceNumber($nextInvoiceNumber: Int!) {
  setNextInvoiceNumber(nextInvoiceNumber: $nextInvoiceNumber)
}
    `;
export const useSetNextInvoiceNumberMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SetNextInvoiceNumberMutation, TError, SetNextInvoiceNumberMutationVariables, TContext>) =>
    useMutation<SetNextInvoiceNumberMutation, TError, SetNextInvoiceNumberMutationVariables, TContext>(
      ['setNextInvoiceNumber'],
      (variables?: SetNextInvoiceNumberMutationVariables) => fetcher<SetNextInvoiceNumberMutation, SetNextInvoiceNumberMutationVariables>(SetNextInvoiceNumberDocument, variables)(),
      options
    );
useSetNextInvoiceNumberMutation.getKey = () => ['setNextInvoiceNumber'];

useSetNextInvoiceNumberMutation.fetcher = (variables: SetNextInvoiceNumberMutationVariables, options?: RequestInit['headers']) => fetcher<SetNextInvoiceNumberMutation, SetNextInvoiceNumberMutationVariables>(SetNextInvoiceNumberDocument, variables, options);
export const GetDriverPaymentRulesDocument = `
    query getDriverPaymentRules($driver: String!) {
  paymentRules(driver: $driver) {
    data {
      _id
      method
      amount
      period {
        start
        end
        repeatEvery
        unit
      }
    }
  }
}
    `;
export const useGetDriverPaymentRulesQuery = <
      TData = GetDriverPaymentRulesQuery,
      TError = Exception
    >(
      variables: GetDriverPaymentRulesQueryVariables,
      options?: UseQueryOptions<GetDriverPaymentRulesQuery, TError, TData>
    ) =>
    useQuery<GetDriverPaymentRulesQuery, TError, TData>(
      ['getDriverPaymentRules', variables],
      fetcher<GetDriverPaymentRulesQuery, GetDriverPaymentRulesQueryVariables>(GetDriverPaymentRulesDocument, variables),
      options
    );

useGetDriverPaymentRulesQuery.getKey = (variables: GetDriverPaymentRulesQueryVariables) => ['getDriverPaymentRules', variables];
;

useGetDriverPaymentRulesQuery.fetcher = (variables: GetDriverPaymentRulesQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverPaymentRulesQuery, GetDriverPaymentRulesQueryVariables>(GetDriverPaymentRulesDocument, variables, options);
export const EditPaymentRuleDocument = `
    mutation editPaymentRule($id: String!, $editPaymentRuleData: PaymentRuleUpdateInput!) {
  editPaymentRule(editPaymentRuleData: $editPaymentRuleData, id: $id) {
    _id
  }
}
    `;
export const useEditPaymentRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditPaymentRuleMutation, TError, EditPaymentRuleMutationVariables, TContext>) =>
    useMutation<EditPaymentRuleMutation, TError, EditPaymentRuleMutationVariables, TContext>(
      ['editPaymentRule'],
      (variables?: EditPaymentRuleMutationVariables) => fetcher<EditPaymentRuleMutation, EditPaymentRuleMutationVariables>(EditPaymentRuleDocument, variables)(),
      options
    );
useEditPaymentRuleMutation.getKey = () => ['editPaymentRule'];

useEditPaymentRuleMutation.fetcher = (variables: EditPaymentRuleMutationVariables, options?: RequestInit['headers']) => fetcher<EditPaymentRuleMutation, EditPaymentRuleMutationVariables>(EditPaymentRuleDocument, variables, options);
export const AddPaymentRuleDocument = `
    mutation addPaymentRule($newPaymentRuleData: NewPaymentRuleInput!) {
  addPaymentRule(newPaymentRuleData: $newPaymentRuleData) {
    _id
  }
}
    `;
export const useAddPaymentRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddPaymentRuleMutation, TError, AddPaymentRuleMutationVariables, TContext>) =>
    useMutation<AddPaymentRuleMutation, TError, AddPaymentRuleMutationVariables, TContext>(
      ['addPaymentRule'],
      (variables?: AddPaymentRuleMutationVariables) => fetcher<AddPaymentRuleMutation, AddPaymentRuleMutationVariables>(AddPaymentRuleDocument, variables)(),
      options
    );
useAddPaymentRuleMutation.getKey = () => ['addPaymentRule'];

useAddPaymentRuleMutation.fetcher = (variables: AddPaymentRuleMutationVariables, options?: RequestInit['headers']) => fetcher<AddPaymentRuleMutation, AddPaymentRuleMutationVariables>(AddPaymentRuleDocument, variables, options);
export const DeletePaymentRuleDocument = `
    mutation deletePaymentRule($id: String!) {
  deletePaymentRule(id: $id)
}
    `;
export const useDeletePaymentRuleMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePaymentRuleMutation, TError, DeletePaymentRuleMutationVariables, TContext>) =>
    useMutation<DeletePaymentRuleMutation, TError, DeletePaymentRuleMutationVariables, TContext>(
      ['deletePaymentRule'],
      (variables?: DeletePaymentRuleMutationVariables) => fetcher<DeletePaymentRuleMutation, DeletePaymentRuleMutationVariables>(DeletePaymentRuleDocument, variables)(),
      options
    );
useDeletePaymentRuleMutation.getKey = () => ['deletePaymentRule'];

useDeletePaymentRuleMutation.fetcher = (variables: DeletePaymentRuleMutationVariables, options?: RequestInit['headers']) => fetcher<DeletePaymentRuleMutation, DeletePaymentRuleMutationVariables>(DeletePaymentRuleDocument, variables, options);
export const GetRateTablesDocument = `
    query getRateTables($entityType: RateTableEntityType, $entityId: ObjectId!) {
  rateTables(entityType: $entityType, entityId: $entityId) {
    data {
      _id
      priority
      referenceNumber
      rowAxis {
        conditions {
          target
          parameters {
            type
            value
          }
          operator
          value
        }
      }
      columnAxis {
        conditions {
          target
          parameters {
            type
            value
          }
          operator
          value
        }
      }
      cells {
        rates {
          label
          method
          parameters {
            type
            value
          }
          amount
          referenceNumber
          taxable
        }
      }
      entityType
      entityId
      label
      description
      rateType
      isActive
      effectiveStartDate
      effectiveEndDate
      createdAt
      updatedAt
    }
  }
}
    `;
export const useGetRateTablesQuery = <
      TData = GetRateTablesQuery,
      TError = Exception
    >(
      variables: GetRateTablesQueryVariables,
      options?: UseQueryOptions<GetRateTablesQuery, TError, TData>
    ) =>
    useQuery<GetRateTablesQuery, TError, TData>(
      ['getRateTables', variables],
      fetcher<GetRateTablesQuery, GetRateTablesQueryVariables>(GetRateTablesDocument, variables),
      options
    );

useGetRateTablesQuery.getKey = (variables: GetRateTablesQueryVariables) => ['getRateTables', variables];
;

useGetRateTablesQuery.fetcher = (variables: GetRateTablesQueryVariables, options?: RequestInit['headers']) => fetcher<GetRateTablesQuery, GetRateTablesQueryVariables>(GetRateTablesDocument, variables, options);
export const EditRateTableDocument = `
    mutation editRateTable($id: String!, $editRateTableData: RateTableUpdateInput!) {
  editRateTable(editRateTableData: $editRateTableData, id: $id) {
    _id
  }
}
    `;
export const useEditRateTableMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditRateTableMutation, TError, EditRateTableMutationVariables, TContext>) =>
    useMutation<EditRateTableMutation, TError, EditRateTableMutationVariables, TContext>(
      ['editRateTable'],
      (variables?: EditRateTableMutationVariables) => fetcher<EditRateTableMutation, EditRateTableMutationVariables>(EditRateTableDocument, variables)(),
      options
    );
useEditRateTableMutation.getKey = () => ['editRateTable'];

useEditRateTableMutation.fetcher = (variables: EditRateTableMutationVariables, options?: RequestInit['headers']) => fetcher<EditRateTableMutation, EditRateTableMutationVariables>(EditRateTableDocument, variables, options);
export const AddRateTableDocument = `
    mutation addRateTable($newRateTableData: NewRateTableInput!) {
  addRateTable(newRateTableData: $newRateTableData) {
    _id
  }
}
    `;
export const useAddRateTableMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddRateTableMutation, TError, AddRateTableMutationVariables, TContext>) =>
    useMutation<AddRateTableMutation, TError, AddRateTableMutationVariables, TContext>(
      ['addRateTable'],
      (variables?: AddRateTableMutationVariables) => fetcher<AddRateTableMutation, AddRateTableMutationVariables>(AddRateTableDocument, variables)(),
      options
    );
useAddRateTableMutation.getKey = () => ['addRateTable'];

useAddRateTableMutation.fetcher = (variables: AddRateTableMutationVariables, options?: RequestInit['headers']) => fetcher<AddRateTableMutation, AddRateTableMutationVariables>(AddRateTableDocument, variables, options);
export const DeleteRateTableDocument = `
    mutation deleteRateTable($id: String!) {
  deleteRateTable(id: $id)
}
    `;
export const useDeleteRateTableMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRateTableMutation, TError, DeleteRateTableMutationVariables, TContext>) =>
    useMutation<DeleteRateTableMutation, TError, DeleteRateTableMutationVariables, TContext>(
      ['deleteRateTable'],
      (variables?: DeleteRateTableMutationVariables) => fetcher<DeleteRateTableMutation, DeleteRateTableMutationVariables>(DeleteRateTableDocument, variables)(),
      options
    );
useDeleteRateTableMutation.getKey = () => ['deleteRateTable'];

useDeleteRateTableMutation.fetcher = (variables: DeleteRateTableMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteRateTableMutation, DeleteRateTableMutationVariables>(DeleteRateTableDocument, variables, options);
export const GetDriverSettlementsForDriverDocument = `
    query getDriverSettlementsForDriver($driverId: String!, $search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  driverSettlements(
    driver: $driverId
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      driverSettlementNumber
      startDate
      endDate
      pdfDocument {
        isGenerating
        url
        error
      }
      status
      payments {
        _id
        unit
        rate
      }
      deductions {
        amount
      }
      trips {
        _id
        tripNumber
      }
    }
    count
  }
}
    `;
export const useGetDriverSettlementsForDriverQuery = <
      TData = GetDriverSettlementsForDriverQuery,
      TError = Exception
    >(
      variables: GetDriverSettlementsForDriverQueryVariables,
      options?: UseQueryOptions<GetDriverSettlementsForDriverQuery, TError, TData>
    ) =>
    useQuery<GetDriverSettlementsForDriverQuery, TError, TData>(
      ['getDriverSettlementsForDriver', variables],
      fetcher<GetDriverSettlementsForDriverQuery, GetDriverSettlementsForDriverQueryVariables>(GetDriverSettlementsForDriverDocument, variables),
      options
    );

useGetDriverSettlementsForDriverQuery.getKey = (variables: GetDriverSettlementsForDriverQueryVariables) => ['getDriverSettlementsForDriver', variables];
;

useGetDriverSettlementsForDriverQuery.fetcher = (variables: GetDriverSettlementsForDriverQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverSettlementsForDriverQuery, GetDriverSettlementsForDriverQueryVariables>(GetDriverSettlementsForDriverDocument, variables, options);
export const GetDriverSettlementListDocument = `
    query getDriverSettlementList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $status: DriverSettlementStatus) {
  driverSettlements(
    search: $search
    skip: $skip
    take: $take
    status: $status
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      driverSettlementNumber
      startDate
      endDate
      pdfDocument {
        isGenerating
        url
        error
      }
      status
      payments {
        _id
        unit
        rate
      }
      deductions {
        type
        amount
      }
      trips {
        _id
        tripNumber
      }
      driver {
        _id
        firstname
        lastname
      }
    }
    count
  }
}
    `;
export const useGetDriverSettlementListQuery = <
      TData = GetDriverSettlementListQuery,
      TError = Exception
    >(
      variables?: GetDriverSettlementListQueryVariables,
      options?: UseQueryOptions<GetDriverSettlementListQuery, TError, TData>
    ) =>
    useQuery<GetDriverSettlementListQuery, TError, TData>(
      variables === undefined ? ['getDriverSettlementList'] : ['getDriverSettlementList', variables],
      fetcher<GetDriverSettlementListQuery, GetDriverSettlementListQueryVariables>(GetDriverSettlementListDocument, variables),
      options
    );

useGetDriverSettlementListQuery.getKey = (variables?: GetDriverSettlementListQueryVariables) => variables === undefined ? ['getDriverSettlementList'] : ['getDriverSettlementList', variables];
;

useGetDriverSettlementListQuery.fetcher = (variables?: GetDriverSettlementListQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverSettlementListQuery, GetDriverSettlementListQueryVariables>(GetDriverSettlementListDocument, variables, options);
export const GetDriverSettlementDetailsDocument = `
    query getDriverSettlementDetails($id: String!) {
  driverSettlementById(id: $id) {
    _id
    driverSettlementNumber
    startDate
    endDate
    trips {
      _id
      tripNumber
    }
    pdfDocument {
      url
    }
    payments {
      _id
      label
      rate
      unit
      unitType
      trip
    }
    deductions {
      _id
      label
      amount
      date
      label
      type
    }
  }
}
    `;
export const useGetDriverSettlementDetailsQuery = <
      TData = GetDriverSettlementDetailsQuery,
      TError = Exception
    >(
      variables: GetDriverSettlementDetailsQueryVariables,
      options?: UseQueryOptions<GetDriverSettlementDetailsQuery, TError, TData>
    ) =>
    useQuery<GetDriverSettlementDetailsQuery, TError, TData>(
      ['getDriverSettlementDetails', variables],
      fetcher<GetDriverSettlementDetailsQuery, GetDriverSettlementDetailsQueryVariables>(GetDriverSettlementDetailsDocument, variables),
      options
    );

useGetDriverSettlementDetailsQuery.getKey = (variables: GetDriverSettlementDetailsQueryVariables) => ['getDriverSettlementDetails', variables];
;

useGetDriverSettlementDetailsQuery.fetcher = (variables: GetDriverSettlementDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverSettlementDetailsQuery, GetDriverSettlementDetailsQueryVariables>(GetDriverSettlementDetailsDocument, variables, options);
export const EditDriverSettlementDocument = `
    mutation editDriverSettlement($id: ObjectId!, $editDriverSettlementData: DriverSettlementUpdateInput!) {
  editDriverSettlement(
    id: $id
    editDriverSettlementData: $editDriverSettlementData
  ) {
    _id
  }
}
    `;
export const useEditDriverSettlementMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditDriverSettlementMutation, TError, EditDriverSettlementMutationVariables, TContext>) =>
    useMutation<EditDriverSettlementMutation, TError, EditDriverSettlementMutationVariables, TContext>(
      ['editDriverSettlement'],
      (variables?: EditDriverSettlementMutationVariables) => fetcher<EditDriverSettlementMutation, EditDriverSettlementMutationVariables>(EditDriverSettlementDocument, variables)(),
      options
    );
useEditDriverSettlementMutation.getKey = () => ['editDriverSettlement'];

useEditDriverSettlementMutation.fetcher = (variables: EditDriverSettlementMutationVariables, options?: RequestInit['headers']) => fetcher<EditDriverSettlementMutation, EditDriverSettlementMutationVariables>(EditDriverSettlementDocument, variables, options);
export const DeleteDriverSettlementDocument = `
    mutation deleteDriverSettlement($id: String!) {
  deleteDriverSettlement(id: $id)
}
    `;
export const useDeleteDriverSettlementMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDriverSettlementMutation, TError, DeleteDriverSettlementMutationVariables, TContext>) =>
    useMutation<DeleteDriverSettlementMutation, TError, DeleteDriverSettlementMutationVariables, TContext>(
      ['deleteDriverSettlement'],
      (variables?: DeleteDriverSettlementMutationVariables) => fetcher<DeleteDriverSettlementMutation, DeleteDriverSettlementMutationVariables>(DeleteDriverSettlementDocument, variables)(),
      options
    );
useDeleteDriverSettlementMutation.getKey = () => ['deleteDriverSettlement'];

useDeleteDriverSettlementMutation.fetcher = (variables: DeleteDriverSettlementMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteDriverSettlementMutation, DeleteDriverSettlementMutationVariables>(DeleteDriverSettlementDocument, variables, options);
export const GenerateDriverSettlementDocument = `
    mutation generateDriverSettlement($driverId: String!, $startDate: DateTime!, $endDate: DateTime!, $timezone: String) {
  generateDriverSettlement(
    driverId: $driverId
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
  ) {
    _id
    driverSettlementNumber
    pdfDocument {
      isGenerating
      url
      error
    }
  }
}
    `;
export const useGenerateDriverSettlementMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateDriverSettlementMutation, TError, GenerateDriverSettlementMutationVariables, TContext>) =>
    useMutation<GenerateDriverSettlementMutation, TError, GenerateDriverSettlementMutationVariables, TContext>(
      ['generateDriverSettlement'],
      (variables?: GenerateDriverSettlementMutationVariables) => fetcher<GenerateDriverSettlementMutation, GenerateDriverSettlementMutationVariables>(GenerateDriverSettlementDocument, variables)(),
      options
    );
useGenerateDriverSettlementMutation.getKey = () => ['generateDriverSettlement'];

useGenerateDriverSettlementMutation.fetcher = (variables: GenerateDriverSettlementMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateDriverSettlementMutation, GenerateDriverSettlementMutationVariables>(GenerateDriverSettlementDocument, variables, options);
export const GenerateDriverSettlementForTripsDocument = `
    mutation generateDriverSettlementForTrips($tripIds: [String!]!, $driverSettlementNumber: String, $timezone: String) {
  generateDriverSettlementForTrips(
    tripIds: $tripIds
    driverSettlementNumber: $driverSettlementNumber
    timezone: $timezone
  ) {
    _id
    driverSettlementNumber
    pdfDocument {
      isGenerating
      url
      error
    }
  }
}
    `;
export const useGenerateDriverSettlementForTripsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateDriverSettlementForTripsMutation, TError, GenerateDriverSettlementForTripsMutationVariables, TContext>) =>
    useMutation<GenerateDriverSettlementForTripsMutation, TError, GenerateDriverSettlementForTripsMutationVariables, TContext>(
      ['generateDriverSettlementForTrips'],
      (variables?: GenerateDriverSettlementForTripsMutationVariables) => fetcher<GenerateDriverSettlementForTripsMutation, GenerateDriverSettlementForTripsMutationVariables>(GenerateDriverSettlementForTripsDocument, variables)(),
      options
    );
useGenerateDriverSettlementForTripsMutation.getKey = () => ['generateDriverSettlementForTrips'];

useGenerateDriverSettlementForTripsMutation.fetcher = (variables: GenerateDriverSettlementForTripsMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateDriverSettlementForTripsMutation, GenerateDriverSettlementForTripsMutationVariables>(GenerateDriverSettlementForTripsDocument, variables, options);
export const UpdateDriverSettlementStatusDocument = `
    mutation updateDriverSettlementStatus($driverSettlementId: String!, $status: DriverSettlementStatus!) {
  updateDriverSettlementStatus(
    driverSettlementId: $driverSettlementId
    status: $status
  ) {
    _id
    status
  }
}
    `;
export const useUpdateDriverSettlementStatusMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDriverSettlementStatusMutation, TError, UpdateDriverSettlementStatusMutationVariables, TContext>) =>
    useMutation<UpdateDriverSettlementStatusMutation, TError, UpdateDriverSettlementStatusMutationVariables, TContext>(
      ['updateDriverSettlementStatus'],
      (variables?: UpdateDriverSettlementStatusMutationVariables) => fetcher<UpdateDriverSettlementStatusMutation, UpdateDriverSettlementStatusMutationVariables>(UpdateDriverSettlementStatusDocument, variables)(),
      options
    );
useUpdateDriverSettlementStatusMutation.getKey = () => ['updateDriverSettlementStatus'];

useUpdateDriverSettlementStatusMutation.fetcher = (variables: UpdateDriverSettlementStatusMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateDriverSettlementStatusMutation, UpdateDriverSettlementStatusMutationVariables>(UpdateDriverSettlementStatusDocument, variables, options);
export const SendRateconDocument = `
    mutation sendRatecon($tripId: String!) {
  sendRatecon(tripId: $tripId) {
    success
  }
}
    `;
export const useSendRateconMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SendRateconMutation, TError, SendRateconMutationVariables, TContext>) =>
    useMutation<SendRateconMutation, TError, SendRateconMutationVariables, TContext>(
      ['sendRatecon'],
      (variables?: SendRateconMutationVariables) => fetcher<SendRateconMutation, SendRateconMutationVariables>(SendRateconDocument, variables)(),
      options
    );
useSendRateconMutation.getKey = () => ['sendRatecon'];

useSendRateconMutation.fetcher = (variables: SendRateconMutationVariables, options?: RequestInit['headers']) => fetcher<SendRateconMutation, SendRateconMutationVariables>(SendRateconDocument, variables, options);
export const GetInvoicesForShipmentsDocument = `
    query getInvoicesForShipments($shipmentIds: [String!]!) {
  invoices(filter: {shipmentIds: $shipmentIds}) {
    data {
      _id
      invoiceNumber
      status
      shipmentIds
      charges {
        _id
        total
        label
        rate
        unit
        unitType
        reimburseToDriver
        relatedTransactionId
        billingRule {
          _id
          label
          referenceNumber
        }
        ratingTable {
          _id
          label
          referenceNumber
        }
        document {
          name
          url
        }
        taxable
        shipmentId
        chargeType
      }
      customer {
        _id
        name
      }
      paidAmount
      taxRate
    }
  }
}
    `;
export const useGetInvoicesForShipmentsQuery = <
      TData = GetInvoicesForShipmentsQuery,
      TError = Exception
    >(
      variables: GetInvoicesForShipmentsQueryVariables,
      options?: UseQueryOptions<GetInvoicesForShipmentsQuery, TError, TData>
    ) =>
    useQuery<GetInvoicesForShipmentsQuery, TError, TData>(
      ['getInvoicesForShipments', variables],
      fetcher<GetInvoicesForShipmentsQuery, GetInvoicesForShipmentsQueryVariables>(GetInvoicesForShipmentsDocument, variables),
      options
    );

useGetInvoicesForShipmentsQuery.getKey = (variables: GetInvoicesForShipmentsQueryVariables) => ['getInvoicesForShipments', variables];
;

useGetInvoicesForShipmentsQuery.fetcher = (variables: GetInvoicesForShipmentsQueryVariables, options?: RequestInit['headers']) => fetcher<GetInvoicesForShipmentsQuery, GetInvoicesForShipmentsQueryVariables>(GetInvoicesForShipmentsDocument, variables, options);
export const GetInvoiceForShipmentDocument = `
    query getInvoiceForShipment($shipmentId: String!) {
  invoices(filter: {shipmentIds: $shipmentId}) {
    data {
      _id
      invoiceNumber
      status
      shipmentIds
      charges {
        _id
        total
        label
        rate
        unit
        unitType
        reimburseToDriver
        relatedTransactionId
        billingRule {
          _id
          label
          referenceNumber
        }
        ratingTable {
          _id
          label
          referenceNumber
        }
        document {
          name
          url
        }
        taxable
        shipmentId
        chargeType
      }
      customer {
        _id
        name
      }
      paidAmount
      taxRate
    }
  }
}
    `;
export const useGetInvoiceForShipmentQuery = <
      TData = GetInvoiceForShipmentQuery,
      TError = Exception
    >(
      variables: GetInvoiceForShipmentQueryVariables,
      options?: UseQueryOptions<GetInvoiceForShipmentQuery, TError, TData>
    ) =>
    useQuery<GetInvoiceForShipmentQuery, TError, TData>(
      ['getInvoiceForShipment', variables],
      fetcher<GetInvoiceForShipmentQuery, GetInvoiceForShipmentQueryVariables>(GetInvoiceForShipmentDocument, variables),
      options
    );

useGetInvoiceForShipmentQuery.getKey = (variables: GetInvoiceForShipmentQueryVariables) => ['getInvoiceForShipment', variables];
;

useGetInvoiceForShipmentQuery.fetcher = (variables: GetInvoiceForShipmentQueryVariables, options?: RequestInit['headers']) => fetcher<GetInvoiceForShipmentQuery, GetInvoiceForShipmentQueryVariables>(GetInvoiceForShipmentDocument, variables, options);
export const GetShipmentChargeTotalsDocument = `
    query getShipmentChargeTotals($shipmentIds: [String!]!) {
  invoices(filter: {shipmentIds: $shipmentIds}) {
    data {
      _id
      invoiceNumber
      status
      shipmentIds
      charges {
        total
        shipmentId
      }
    }
  }
}
    `;
export const useGetShipmentChargeTotalsQuery = <
      TData = GetShipmentChargeTotalsQuery,
      TError = Exception
    >(
      variables: GetShipmentChargeTotalsQueryVariables,
      options?: UseQueryOptions<GetShipmentChargeTotalsQuery, TError, TData>
    ) =>
    useQuery<GetShipmentChargeTotalsQuery, TError, TData>(
      ['getShipmentChargeTotals', variables],
      fetcher<GetShipmentChargeTotalsQuery, GetShipmentChargeTotalsQueryVariables>(GetShipmentChargeTotalsDocument, variables),
      options
    );

useGetShipmentChargeTotalsQuery.getKey = (variables: GetShipmentChargeTotalsQueryVariables) => ['getShipmentChargeTotals', variables];
;

useGetShipmentChargeTotalsQuery.fetcher = (variables: GetShipmentChargeTotalsQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentChargeTotalsQuery, GetShipmentChargeTotalsQueryVariables>(GetShipmentChargeTotalsDocument, variables, options);
export const GetTransactionListDocument = `
    query getTransactionList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  transactions(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      number
      label
      rate
      unit
      unitType
      reimburseToDriver
      document {
        name
        url
      }
      customFields {
        key
        value
      }
    }
    count
  }
}
    `;
export const useGetTransactionListQuery = <
      TData = GetTransactionListQuery,
      TError = Exception
    >(
      variables?: GetTransactionListQueryVariables,
      options?: UseQueryOptions<GetTransactionListQuery, TError, TData>
    ) =>
    useQuery<GetTransactionListQuery, TError, TData>(
      variables === undefined ? ['getTransactionList'] : ['getTransactionList', variables],
      fetcher<GetTransactionListQuery, GetTransactionListQueryVariables>(GetTransactionListDocument, variables),
      options
    );

useGetTransactionListQuery.getKey = (variables?: GetTransactionListQueryVariables) => variables === undefined ? ['getTransactionList'] : ['getTransactionList', variables];
;

useGetTransactionListQuery.fetcher = (variables?: GetTransactionListQueryVariables, options?: RequestInit['headers']) => fetcher<GetTransactionListQuery, GetTransactionListQueryVariables>(GetTransactionListDocument, variables, options);
export const DeleteTransactionDocument = `
    mutation deleteTransaction($id: String!) {
  deleteTransaction(id: $id)
}
    `;
export const useDeleteTransactionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTransactionMutation, TError, DeleteTransactionMutationVariables, TContext>) =>
    useMutation<DeleteTransactionMutation, TError, DeleteTransactionMutationVariables, TContext>(
      ['deleteTransaction'],
      (variables?: DeleteTransactionMutationVariables) => fetcher<DeleteTransactionMutation, DeleteTransactionMutationVariables>(DeleteTransactionDocument, variables)(),
      options
    );
useDeleteTransactionMutation.getKey = () => ['deleteTransaction'];

useDeleteTransactionMutation.fetcher = (variables: DeleteTransactionMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteTransactionMutation, DeleteTransactionMutationVariables>(DeleteTransactionDocument, variables, options);
export const AddTransactionDocument = `
    mutation addTransaction($newTransactionData: TransactionInput!) {
  addTransaction(newTransactionData: $newTransactionData) {
    _id
  }
}
    `;
export const useAddTransactionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddTransactionMutation, TError, AddTransactionMutationVariables, TContext>) =>
    useMutation<AddTransactionMutation, TError, AddTransactionMutationVariables, TContext>(
      ['addTransaction'],
      (variables?: AddTransactionMutationVariables) => fetcher<AddTransactionMutation, AddTransactionMutationVariables>(AddTransactionDocument, variables)(),
      options
    );
useAddTransactionMutation.getKey = () => ['addTransaction'];

useAddTransactionMutation.fetcher = (variables: AddTransactionMutationVariables, options?: RequestInit['headers']) => fetcher<AddTransactionMutation, AddTransactionMutationVariables>(AddTransactionDocument, variables, options);
export const EditTransactionDocument = `
    mutation editTransaction($id: String!, $editTransactionData: TransactionUpdateInput!) {
  editTransaction(id: $id, editTransactionData: $editTransactionData) {
    _id
  }
}
    `;
export const useEditTransactionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditTransactionMutation, TError, EditTransactionMutationVariables, TContext>) =>
    useMutation<EditTransactionMutation, TError, EditTransactionMutationVariables, TContext>(
      ['editTransaction'],
      (variables?: EditTransactionMutationVariables) => fetcher<EditTransactionMutation, EditTransactionMutationVariables>(EditTransactionDocument, variables)(),
      options
    );
useEditTransactionMutation.getKey = () => ['editTransaction'];

useEditTransactionMutation.fetcher = (variables: EditTransactionMutationVariables, options?: RequestInit['headers']) => fetcher<EditTransactionMutation, EditTransactionMutationVariables>(EditTransactionDocument, variables, options);
export const GetTransactionTemplatesDocument = `
    query getTransactionTemplates {
  templates: organizationSettings {
    transactionTemplates {
      _id
      type
      label
      rate
      unit
      unitType
      reimburseToDriver
    }
  }
}
    `;
export const useGetTransactionTemplatesQuery = <
      TData = GetTransactionTemplatesQuery,
      TError = Exception
    >(
      variables?: GetTransactionTemplatesQueryVariables,
      options?: UseQueryOptions<GetTransactionTemplatesQuery, TError, TData>
    ) =>
    useQuery<GetTransactionTemplatesQuery, TError, TData>(
      variables === undefined ? ['getTransactionTemplates'] : ['getTransactionTemplates', variables],
      fetcher<GetTransactionTemplatesQuery, GetTransactionTemplatesQueryVariables>(GetTransactionTemplatesDocument, variables),
      options
    );

useGetTransactionTemplatesQuery.getKey = (variables?: GetTransactionTemplatesQueryVariables) => variables === undefined ? ['getTransactionTemplates'] : ['getTransactionTemplates', variables];
;

useGetTransactionTemplatesQuery.fetcher = (variables?: GetTransactionTemplatesQueryVariables, options?: RequestInit['headers']) => fetcher<GetTransactionTemplatesQuery, GetTransactionTemplatesQueryVariables>(GetTransactionTemplatesDocument, variables, options);
export const GetTripForPaymentsDocument = `
    query getTripForPayments($id: String!) {
  tripById(id: $id) {
    _id
    tripNumber
    status
    payments {
      _id
      label
      rate
      unit
      unitType
    }
  }
}
    `;
export const useGetTripForPaymentsQuery = <
      TData = GetTripForPaymentsQuery,
      TError = Exception
    >(
      variables: GetTripForPaymentsQueryVariables,
      options?: UseQueryOptions<GetTripForPaymentsQuery, TError, TData>
    ) =>
    useQuery<GetTripForPaymentsQuery, TError, TData>(
      ['getTripForPayments', variables],
      fetcher<GetTripForPaymentsQuery, GetTripForPaymentsQueryVariables>(GetTripForPaymentsDocument, variables),
      options
    );

useGetTripForPaymentsQuery.getKey = (variables: GetTripForPaymentsQueryVariables) => ['getTripForPayments', variables];
;

useGetTripForPaymentsQuery.fetcher = (variables: GetTripForPaymentsQueryVariables, options?: RequestInit['headers']) => fetcher<GetTripForPaymentsQuery, GetTripForPaymentsQueryVariables>(GetTripForPaymentsDocument, variables, options);
export const AddTripPaymentDocument = `
    mutation addTripPayment($tripId: String!, $payment: TransactionInput!) {
  addTripPayment(tripId: $tripId, payment: $payment) {
    _id
    tripNumber
    status
    payments {
      _id
      label
      rate
      unit
      unitType
    }
  }
}
    `;
export const useAddTripPaymentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddTripPaymentMutation, TError, AddTripPaymentMutationVariables, TContext>) =>
    useMutation<AddTripPaymentMutation, TError, AddTripPaymentMutationVariables, TContext>(
      ['addTripPayment'],
      (variables?: AddTripPaymentMutationVariables) => fetcher<AddTripPaymentMutation, AddTripPaymentMutationVariables>(AddTripPaymentDocument, variables)(),
      options
    );
useAddTripPaymentMutation.getKey = () => ['addTripPayment'];

useAddTripPaymentMutation.fetcher = (variables: AddTripPaymentMutationVariables, options?: RequestInit['headers']) => fetcher<AddTripPaymentMutation, AddTripPaymentMutationVariables>(AddTripPaymentDocument, variables, options);
export const EditTripPaymentDocument = `
    mutation editTripPayment($tripId: String!, $paymentId: String!, $payment: TransactionInput!) {
  editTripPayment(tripId: $tripId, paymentId: $paymentId, payment: $payment) {
    _id
    tripNumber
    status
    payments {
      _id
      label
      rate
      unit
      unitType
    }
  }
}
    `;
export const useEditTripPaymentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditTripPaymentMutation, TError, EditTripPaymentMutationVariables, TContext>) =>
    useMutation<EditTripPaymentMutation, TError, EditTripPaymentMutationVariables, TContext>(
      ['editTripPayment'],
      (variables?: EditTripPaymentMutationVariables) => fetcher<EditTripPaymentMutation, EditTripPaymentMutationVariables>(EditTripPaymentDocument, variables)(),
      options
    );
useEditTripPaymentMutation.getKey = () => ['editTripPayment'];

useEditTripPaymentMutation.fetcher = (variables: EditTripPaymentMutationVariables, options?: RequestInit['headers']) => fetcher<EditTripPaymentMutation, EditTripPaymentMutationVariables>(EditTripPaymentDocument, variables, options);
export const DeleteTripPaymentDocument = `
    mutation deleteTripPayment($tripId: String!, $paymentId: String!) {
  deleteTripPayment(tripId: $tripId, paymentId: $paymentId) {
    _id
    tripNumber
    status
    payments {
      _id
      label
      rate
      unit
      unitType
    }
  }
}
    `;
export const useDeleteTripPaymentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTripPaymentMutation, TError, DeleteTripPaymentMutationVariables, TContext>) =>
    useMutation<DeleteTripPaymentMutation, TError, DeleteTripPaymentMutationVariables, TContext>(
      ['deleteTripPayment'],
      (variables?: DeleteTripPaymentMutationVariables) => fetcher<DeleteTripPaymentMutation, DeleteTripPaymentMutationVariables>(DeleteTripPaymentDocument, variables)(),
      options
    );
useDeleteTripPaymentMutation.getKey = () => ['deleteTripPayment'];

useDeleteTripPaymentMutation.fetcher = (variables: DeleteTripPaymentMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteTripPaymentMutation, DeleteTripPaymentMutationVariables>(DeleteTripPaymentDocument, variables, options);
export const ComputeLineHaulForTripDocument = `
    mutation computeLineHaulForTrip($tripId: String!) {
  computeLineHaulForTrip(tripId: $tripId) {
    _id
    tripNumber
    status
    payments {
      _id
      label
      rate
      unit
      unitType
    }
  }
}
    `;
export const useComputeLineHaulForTripMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ComputeLineHaulForTripMutation, TError, ComputeLineHaulForTripMutationVariables, TContext>) =>
    useMutation<ComputeLineHaulForTripMutation, TError, ComputeLineHaulForTripMutationVariables, TContext>(
      ['computeLineHaulForTrip'],
      (variables?: ComputeLineHaulForTripMutationVariables) => fetcher<ComputeLineHaulForTripMutation, ComputeLineHaulForTripMutationVariables>(ComputeLineHaulForTripDocument, variables)(),
      options
    );
useComputeLineHaulForTripMutation.getKey = () => ['computeLineHaulForTrip'];

useComputeLineHaulForTripMutation.fetcher = (variables: ComputeLineHaulForTripMutationVariables, options?: RequestInit['headers']) => fetcher<ComputeLineHaulForTripMutation, ComputeLineHaulForTripMutationVariables>(ComputeLineHaulForTripDocument, variables, options);
export const GetAssetLinkingsDocument = `
    query getAssetLinkings($filter: JSON) {
  assetLinkings(filter: $filter) {
    data {
      _id
      driver {
        _id
        firstname
        lastname
      }
      tractor {
        _id
        serialNumber
      }
      trailer {
        _id
        serialNumber
      }
      additionalTrailers {
        _id
        serialNumber
      }
      startDate
      endDate
    }
    count
  }
}
    `;
export const useGetAssetLinkingsQuery = <
      TData = GetAssetLinkingsQuery,
      TError = Exception
    >(
      variables?: GetAssetLinkingsQueryVariables,
      options?: UseQueryOptions<GetAssetLinkingsQuery, TError, TData>
    ) =>
    useQuery<GetAssetLinkingsQuery, TError, TData>(
      variables === undefined ? ['getAssetLinkings'] : ['getAssetLinkings', variables],
      fetcher<GetAssetLinkingsQuery, GetAssetLinkingsQueryVariables>(GetAssetLinkingsDocument, variables),
      options
    );

useGetAssetLinkingsQuery.getKey = (variables?: GetAssetLinkingsQueryVariables) => variables === undefined ? ['getAssetLinkings'] : ['getAssetLinkings', variables];
;

useGetAssetLinkingsQuery.fetcher = (variables?: GetAssetLinkingsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAssetLinkingsQuery, GetAssetLinkingsQueryVariables>(GetAssetLinkingsDocument, variables, options);
export const GetAssetLinkingDetailsDocument = `
    query getAssetLinkingDetails($id: String!) {
  assetLinking: assetLinkingById(id: $id) {
    _id
    driver {
      _id
      firstname
      lastname
    }
    tractor {
      _id
      serialNumber
    }
    trailer {
      _id
      serialNumber
    }
    additionalTrailers {
      _id
      serialNumber
    }
    startDate
    endDate
  }
}
    `;
export const useGetAssetLinkingDetailsQuery = <
      TData = GetAssetLinkingDetailsQuery,
      TError = Exception
    >(
      variables: GetAssetLinkingDetailsQueryVariables,
      options?: UseQueryOptions<GetAssetLinkingDetailsQuery, TError, TData>
    ) =>
    useQuery<GetAssetLinkingDetailsQuery, TError, TData>(
      ['getAssetLinkingDetails', variables],
      fetcher<GetAssetLinkingDetailsQuery, GetAssetLinkingDetailsQueryVariables>(GetAssetLinkingDetailsDocument, variables),
      options
    );

useGetAssetLinkingDetailsQuery.getKey = (variables: GetAssetLinkingDetailsQueryVariables) => ['getAssetLinkingDetails', variables];
;

useGetAssetLinkingDetailsQuery.fetcher = (variables: GetAssetLinkingDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAssetLinkingDetailsQuery, GetAssetLinkingDetailsQueryVariables>(GetAssetLinkingDetailsDocument, variables, options);
export const GetAssetLinkingDetailsForDriverDocument = `
    query getAssetLinkingDetailsForDriver($id: ObjectId!) {
  assetLinking: assetLinkingByDriverId(driverId: $id) {
    _id
    driver {
      _id
      firstname
      lastname
    }
    tractor {
      _id
      serialNumber
    }
    trailer {
      _id
      serialNumber
    }
    additionalTrailers {
      _id
      serialNumber
    }
    startDate
    endDate
  }
}
    `;
export const useGetAssetLinkingDetailsForDriverQuery = <
      TData = GetAssetLinkingDetailsForDriverQuery,
      TError = Exception
    >(
      variables: GetAssetLinkingDetailsForDriverQueryVariables,
      options?: UseQueryOptions<GetAssetLinkingDetailsForDriverQuery, TError, TData>
    ) =>
    useQuery<GetAssetLinkingDetailsForDriverQuery, TError, TData>(
      ['getAssetLinkingDetailsForDriver', variables],
      fetcher<GetAssetLinkingDetailsForDriverQuery, GetAssetLinkingDetailsForDriverQueryVariables>(GetAssetLinkingDetailsForDriverDocument, variables),
      options
    );

useGetAssetLinkingDetailsForDriverQuery.getKey = (variables: GetAssetLinkingDetailsForDriverQueryVariables) => ['getAssetLinkingDetailsForDriver', variables];
;

useGetAssetLinkingDetailsForDriverQuery.fetcher = (variables: GetAssetLinkingDetailsForDriverQueryVariables, options?: RequestInit['headers']) => fetcher<GetAssetLinkingDetailsForDriverQuery, GetAssetLinkingDetailsForDriverQueryVariables>(GetAssetLinkingDetailsForDriverDocument, variables, options);
export const GetAssetLinkingDetailsForTractorDocument = `
    query getAssetLinkingDetailsForTractor($id: ObjectId!) {
  assetLinking: assetLinkingByTractorId(tractorId: $id) {
    _id
    driver {
      _id
      firstname
      lastname
    }
    tractor {
      _id
      serialNumber
    }
    trailer {
      _id
      serialNumber
    }
    additionalTrailers {
      _id
      serialNumber
    }
    startDate
    endDate
  }
}
    `;
export const useGetAssetLinkingDetailsForTractorQuery = <
      TData = GetAssetLinkingDetailsForTractorQuery,
      TError = Exception
    >(
      variables: GetAssetLinkingDetailsForTractorQueryVariables,
      options?: UseQueryOptions<GetAssetLinkingDetailsForTractorQuery, TError, TData>
    ) =>
    useQuery<GetAssetLinkingDetailsForTractorQuery, TError, TData>(
      ['getAssetLinkingDetailsForTractor', variables],
      fetcher<GetAssetLinkingDetailsForTractorQuery, GetAssetLinkingDetailsForTractorQueryVariables>(GetAssetLinkingDetailsForTractorDocument, variables),
      options
    );

useGetAssetLinkingDetailsForTractorQuery.getKey = (variables: GetAssetLinkingDetailsForTractorQueryVariables) => ['getAssetLinkingDetailsForTractor', variables];
;

useGetAssetLinkingDetailsForTractorQuery.fetcher = (variables: GetAssetLinkingDetailsForTractorQueryVariables, options?: RequestInit['headers']) => fetcher<GetAssetLinkingDetailsForTractorQuery, GetAssetLinkingDetailsForTractorQueryVariables>(GetAssetLinkingDetailsForTractorDocument, variables, options);
export const GetAssetLinkingDetailsForTrailerDocument = `
    query getAssetLinkingDetailsForTrailer($id: ObjectId!) {
  assetLinking: assetLinkingByTrailerId(trailerId: $id) {
    _id
    driver {
      _id
      firstname
      lastname
    }
    tractor {
      _id
      serialNumber
    }
    trailer {
      _id
      serialNumber
    }
    additionalTrailers {
      _id
      serialNumber
    }
    startDate
    endDate
  }
}
    `;
export const useGetAssetLinkingDetailsForTrailerQuery = <
      TData = GetAssetLinkingDetailsForTrailerQuery,
      TError = Exception
    >(
      variables: GetAssetLinkingDetailsForTrailerQueryVariables,
      options?: UseQueryOptions<GetAssetLinkingDetailsForTrailerQuery, TError, TData>
    ) =>
    useQuery<GetAssetLinkingDetailsForTrailerQuery, TError, TData>(
      ['getAssetLinkingDetailsForTrailer', variables],
      fetcher<GetAssetLinkingDetailsForTrailerQuery, GetAssetLinkingDetailsForTrailerQueryVariables>(GetAssetLinkingDetailsForTrailerDocument, variables),
      options
    );

useGetAssetLinkingDetailsForTrailerQuery.getKey = (variables: GetAssetLinkingDetailsForTrailerQueryVariables) => ['getAssetLinkingDetailsForTrailer', variables];
;

useGetAssetLinkingDetailsForTrailerQuery.fetcher = (variables: GetAssetLinkingDetailsForTrailerQueryVariables, options?: RequestInit['headers']) => fetcher<GetAssetLinkingDetailsForTrailerQuery, GetAssetLinkingDetailsForTrailerQueryVariables>(GetAssetLinkingDetailsForTrailerDocument, variables, options);
export const AddAssetLinkingDocument = `
    mutation addAssetLinking($newAssetLinkingData: AssetLinkingInput!) {
  addAssetLinking(newAssetLinkingData: $newAssetLinkingData) {
    _id
  }
}
    `;
export const useAddAssetLinkingMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddAssetLinkingMutation, TError, AddAssetLinkingMutationVariables, TContext>) =>
    useMutation<AddAssetLinkingMutation, TError, AddAssetLinkingMutationVariables, TContext>(
      ['addAssetLinking'],
      (variables?: AddAssetLinkingMutationVariables) => fetcher<AddAssetLinkingMutation, AddAssetLinkingMutationVariables>(AddAssetLinkingDocument, variables)(),
      options
    );
useAddAssetLinkingMutation.getKey = () => ['addAssetLinking'];

useAddAssetLinkingMutation.fetcher = (variables: AddAssetLinkingMutationVariables, options?: RequestInit['headers']) => fetcher<AddAssetLinkingMutation, AddAssetLinkingMutationVariables>(AddAssetLinkingDocument, variables, options);
export const EditAssetLinkingDocument = `
    mutation editAssetLinking($id: String!, $editAssetLinkingData: AssetLinkingUpdateInput!) {
  editAssetLinking(id: $id, editAssetLinkingData: $editAssetLinkingData) {
    _id
  }
}
    `;
export const useEditAssetLinkingMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditAssetLinkingMutation, TError, EditAssetLinkingMutationVariables, TContext>) =>
    useMutation<EditAssetLinkingMutation, TError, EditAssetLinkingMutationVariables, TContext>(
      ['editAssetLinking'],
      (variables?: EditAssetLinkingMutationVariables) => fetcher<EditAssetLinkingMutation, EditAssetLinkingMutationVariables>(EditAssetLinkingDocument, variables)(),
      options
    );
useEditAssetLinkingMutation.getKey = () => ['editAssetLinking'];

useEditAssetLinkingMutation.fetcher = (variables: EditAssetLinkingMutationVariables, options?: RequestInit['headers']) => fetcher<EditAssetLinkingMutation, EditAssetLinkingMutationVariables>(EditAssetLinkingDocument, variables, options);
export const DeleteAssetLinkingDocument = `
    mutation deleteAssetLinking($id: String!) {
  deleteAssetLinking(id: $id)
}
    `;
export const useDeleteAssetLinkingMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAssetLinkingMutation, TError, DeleteAssetLinkingMutationVariables, TContext>) =>
    useMutation<DeleteAssetLinkingMutation, TError, DeleteAssetLinkingMutationVariables, TContext>(
      ['deleteAssetLinking'],
      (variables?: DeleteAssetLinkingMutationVariables) => fetcher<DeleteAssetLinkingMutation, DeleteAssetLinkingMutationVariables>(DeleteAssetLinkingDocument, variables)(),
      options
    );
useDeleteAssetLinkingMutation.getKey = () => ['deleteAssetLinking'];

useDeleteAssetLinkingMutation.fetcher = (variables: DeleteAssetLinkingMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteAssetLinkingMutation, DeleteAssetLinkingMutationVariables>(DeleteAssetLinkingDocument, variables, options);
export const GetBrokerListDocument = `
    query getBrokerList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $includeInactive: Boolean) {
  brokers(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      address {
        label
      }
      code
      contact {
        firstname
        lastname
        email
        phoneNumber
      }
      name
      type
      tags
    }
    count
  }
}
    `;
export const useGetBrokerListQuery = <
      TData = GetBrokerListQuery,
      TError = Exception
    >(
      variables?: GetBrokerListQueryVariables,
      options?: UseQueryOptions<GetBrokerListQuery, TError, TData>
    ) =>
    useQuery<GetBrokerListQuery, TError, TData>(
      variables === undefined ? ['getBrokerList'] : ['getBrokerList', variables],
      fetcher<GetBrokerListQuery, GetBrokerListQueryVariables>(GetBrokerListDocument, variables),
      options
    );

useGetBrokerListQuery.getKey = (variables?: GetBrokerListQueryVariables) => variables === undefined ? ['getBrokerList'] : ['getBrokerList', variables];
;

useGetBrokerListQuery.fetcher = (variables?: GetBrokerListQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrokerListQuery, GetBrokerListQueryVariables>(GetBrokerListDocument, variables, options);
export const GetBrokerDetailsDocument = `
    query getBrokerDetails($id: String!) {
  brokerById(id: $id) {
    _id
    name
    code
    additionalTypes
    address {
      label
      coordinates {
        latitude
        longitude
      }
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    billingAddress {
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    billingEmail
    billingTermsDay
    remitAddress {
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    remitEmail
    contact {
      email
      firstname
      lastname
      phoneNumber
    }
    openingSchedules {
      openingTime
      closingTime
      days
    }
    additionalContacts {
      firstname
      lastname
      email
      phoneNumber
    }
    goodInventoryItems {
      _id
      label
      weight
    }
    type
    tags
  }
}
    `;
export const useGetBrokerDetailsQuery = <
      TData = GetBrokerDetailsQuery,
      TError = Exception
    >(
      variables: GetBrokerDetailsQueryVariables,
      options?: UseQueryOptions<GetBrokerDetailsQuery, TError, TData>
    ) =>
    useQuery<GetBrokerDetailsQuery, TError, TData>(
      ['getBrokerDetails', variables],
      fetcher<GetBrokerDetailsQuery, GetBrokerDetailsQueryVariables>(GetBrokerDetailsDocument, variables),
      options
    );

useGetBrokerDetailsQuery.getKey = (variables: GetBrokerDetailsQueryVariables) => ['getBrokerDetails', variables];
;

useGetBrokerDetailsQuery.fetcher = (variables: GetBrokerDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrokerDetailsQuery, GetBrokerDetailsQueryVariables>(GetBrokerDetailsDocument, variables, options);
export const AddBrokerDocument = `
    mutation addBroker($newBrokerData: NewBusinessEntityInput!) {
  addBroker(newBrokerData: $newBrokerData) {
    _id
  }
}
    `;
export const useAddBrokerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddBrokerMutation, TError, AddBrokerMutationVariables, TContext>) =>
    useMutation<AddBrokerMutation, TError, AddBrokerMutationVariables, TContext>(
      ['addBroker'],
      (variables?: AddBrokerMutationVariables) => fetcher<AddBrokerMutation, AddBrokerMutationVariables>(AddBrokerDocument, variables)(),
      options
    );
useAddBrokerMutation.getKey = () => ['addBroker'];

useAddBrokerMutation.fetcher = (variables: AddBrokerMutationVariables, options?: RequestInit['headers']) => fetcher<AddBrokerMutation, AddBrokerMutationVariables>(AddBrokerDocument, variables, options);
export const EditBrokerDocument = `
    mutation editBroker($id: String!, $editBrokerData: BusinessEntityUpdateInput!) {
  editBroker(id: $id, editBrokerData: $editBrokerData) {
    _id
  }
}
    `;
export const useEditBrokerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditBrokerMutation, TError, EditBrokerMutationVariables, TContext>) =>
    useMutation<EditBrokerMutation, TError, EditBrokerMutationVariables, TContext>(
      ['editBroker'],
      (variables?: EditBrokerMutationVariables) => fetcher<EditBrokerMutation, EditBrokerMutationVariables>(EditBrokerDocument, variables)(),
      options
    );
useEditBrokerMutation.getKey = () => ['editBroker'];

useEditBrokerMutation.fetcher = (variables: EditBrokerMutationVariables, options?: RequestInit['headers']) => fetcher<EditBrokerMutation, EditBrokerMutationVariables>(EditBrokerDocument, variables, options);
export const DeleteBrokerDocument = `
    mutation deleteBroker($id: String!) {
  deleteBroker(id: $id)
}
    `;
export const useDeleteBrokerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBrokerMutation, TError, DeleteBrokerMutationVariables, TContext>) =>
    useMutation<DeleteBrokerMutation, TError, DeleteBrokerMutationVariables, TContext>(
      ['deleteBroker'],
      (variables?: DeleteBrokerMutationVariables) => fetcher<DeleteBrokerMutation, DeleteBrokerMutationVariables>(DeleteBrokerDocument, variables)(),
      options
    );
useDeleteBrokerMutation.getKey = () => ['deleteBroker'];

useDeleteBrokerMutation.fetcher = (variables: DeleteBrokerMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteBrokerMutation, DeleteBrokerMutationVariables>(DeleteBrokerDocument, variables, options);
export const GetBusinessEntityListDocument = `
    query getBusinessEntityList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $businessEntityTypes: [BusinessEntityType!], $includeInactive: Boolean) {
  businessEntities(
    search: $search
    skip: $skip
    take: $take
    businessEntityTypes: $businessEntityTypes
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      address {
        label
        coordinates {
          latitude
          longitude
        }
      }
      code
      mcNumber
      dotNumber
      standardCarrierAlphaCode
      federalId
      contact {
        firstname
        lastname
        email
        phoneNumber
        title
        faxNumber
        extensionNumber
        url
      }
      name
      type
      additionalTypes
      tags
      customFields {
        key
        value
      }
      groupIds
      status
      trailerTypes
      storageFacilities {
        identifier
        capacity
        unit
        commodityIds
        safeFillLevel
        shutDownLevel
        latestReading {
          date
          level
          volumeType
        }
        commodities {
          _id
          label
          unit
          weight
        }
        linkedStorageFacilityIds
        customFields {
          key
          value
        }
      }
      commodityIds
      commodities {
        _id
        label
        unit
      }
    }
    count
  }
}
    `;
export const useGetBusinessEntityListQuery = <
      TData = GetBusinessEntityListQuery,
      TError = Exception
    >(
      variables?: GetBusinessEntityListQueryVariables,
      options?: UseQueryOptions<GetBusinessEntityListQuery, TError, TData>
    ) =>
    useQuery<GetBusinessEntityListQuery, TError, TData>(
      variables === undefined ? ['getBusinessEntityList'] : ['getBusinessEntityList', variables],
      fetcher<GetBusinessEntityListQuery, GetBusinessEntityListQueryVariables>(GetBusinessEntityListDocument, variables),
      options
    );

useGetBusinessEntityListQuery.getKey = (variables?: GetBusinessEntityListQueryVariables) => variables === undefined ? ['getBusinessEntityList'] : ['getBusinessEntityList', variables];
;

useGetBusinessEntityListQuery.fetcher = (variables?: GetBusinessEntityListQueryVariables, options?: RequestInit['headers']) => fetcher<GetBusinessEntityListQuery, GetBusinessEntityListQueryVariables>(GetBusinessEntityListDocument, variables, options);
export const GetBusinessEntityDetailsDocument = `
    query getBusinessEntityDetails($id: String!, $includeLinkedFacilities: Boolean) {
  businessEntityById(id: $id) {
    _id
    name
    code
    parentBusinessEntityId
    defaultShipperId
    defaultShipper {
      name
      address {
        label
        coordinates {
          latitude
          longitude
        }
      }
      addressTimezone
    }
    accessToken
    mcNumber
    standardCarrierAlphaCode
    dotNumber
    federalId
    payToProfileId
    referenceNumberTypes
    defaultReferenceNumbers {
      referenceNumberType
      referenceNumberValue
    }
    additionalTypes
    trailerTypes
    address {
      label
      coordinates {
        latitude
        longitude
      }
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    addressTimezone
    billingAddress {
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    billingEmail
    billingTermsDay
    billingInvoiceConsolidationCriteria
    billingWeekStartsOn
    remitAddress {
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    remitCompanyName
    remitEmail
    contact {
      email
      firstname
      lastname
      phoneNumber
      title
      faxNumber
      extensionNumber
      url
      includeInDocumentSending
    }
    openingSchedules {
      openingTime
      closingTime
      days
    }
    additionalContacts {
      firstname
      lastname
      email
      phoneNumber
      includeInInvoicing
      includeInDocumentSending
      title
      url
      faxNumber
      extensionNumber
    }
    goodInventoryItems {
      _id
      label
      weight
    }
    storageFacilities(includeLinkedFacilities: $includeLinkedFacilities) {
      identifier
      capacity
      unit
      commodityIds
      commodities {
        code
        label
      }
      safeFillLevel
      shutDownLevel
      defaultPinCode
      defaultSupplierId
      plannedDwellTimeInMinutes
      defaultSupplier {
        code
        name
      }
      safeFillLevel
      shutDownLevel
      latestReading {
        date
        level
        volumeType
      }
      linkedStorageFacilityIds
      customFields {
        key
        value
      }
    }
    commodityIds
    commodities {
      _id
      code
      label
      unit
    }
    type
    documents {
      name
      url
    }
    notes {
      content
      accessLevel
      addToShipment
    }
    documentRequirements {
      documentName
      documentType
      attachToInvoice
      requiredForInvoicing
    }
    shipmentDocumentsToReceive
    tags
    customFields {
      key
      value
    }
    groupIds
    status
    plannedDwellTimeInMinutes
  }
}
    `;
export const useGetBusinessEntityDetailsQuery = <
      TData = GetBusinessEntityDetailsQuery,
      TError = Exception
    >(
      variables: GetBusinessEntityDetailsQueryVariables,
      options?: UseQueryOptions<GetBusinessEntityDetailsQuery, TError, TData>
    ) =>
    useQuery<GetBusinessEntityDetailsQuery, TError, TData>(
      ['getBusinessEntityDetails', variables],
      fetcher<GetBusinessEntityDetailsQuery, GetBusinessEntityDetailsQueryVariables>(GetBusinessEntityDetailsDocument, variables),
      options
    );

useGetBusinessEntityDetailsQuery.getKey = (variables: GetBusinessEntityDetailsQueryVariables) => ['getBusinessEntityDetails', variables];
;

useGetBusinessEntityDetailsQuery.fetcher = (variables: GetBusinessEntityDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetBusinessEntityDetailsQuery, GetBusinessEntityDetailsQueryVariables>(GetBusinessEntityDetailsDocument, variables, options);
export const AddBusinessEntityDocument = `
    mutation addBusinessEntity($newBusinessEntityData: NewBusinessEntityInputWithType!) {
  addBusinessEntity(newBusinessEntityData: $newBusinessEntityData) {
    _id
  }
}
    `;
export const useAddBusinessEntityMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddBusinessEntityMutation, TError, AddBusinessEntityMutationVariables, TContext>) =>
    useMutation<AddBusinessEntityMutation, TError, AddBusinessEntityMutationVariables, TContext>(
      ['addBusinessEntity'],
      (variables?: AddBusinessEntityMutationVariables) => fetcher<AddBusinessEntityMutation, AddBusinessEntityMutationVariables>(AddBusinessEntityDocument, variables)(),
      options
    );
useAddBusinessEntityMutation.getKey = () => ['addBusinessEntity'];

useAddBusinessEntityMutation.fetcher = (variables: AddBusinessEntityMutationVariables, options?: RequestInit['headers']) => fetcher<AddBusinessEntityMutation, AddBusinessEntityMutationVariables>(AddBusinessEntityDocument, variables, options);
export const EditBusinessEntityDocument = `
    mutation editBusinessEntity($id: String!, $editBusinessEntityData: BusinessEntityUpdateInput!) {
  editBusinessEntity(id: $id, editBusinessEntityData: $editBusinessEntityData) {
    _id
  }
}
    `;
export const useEditBusinessEntityMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditBusinessEntityMutation, TError, EditBusinessEntityMutationVariables, TContext>) =>
    useMutation<EditBusinessEntityMutation, TError, EditBusinessEntityMutationVariables, TContext>(
      ['editBusinessEntity'],
      (variables?: EditBusinessEntityMutationVariables) => fetcher<EditBusinessEntityMutation, EditBusinessEntityMutationVariables>(EditBusinessEntityDocument, variables)(),
      options
    );
useEditBusinessEntityMutation.getKey = () => ['editBusinessEntity'];

useEditBusinessEntityMutation.fetcher = (variables: EditBusinessEntityMutationVariables, options?: RequestInit['headers']) => fetcher<EditBusinessEntityMutation, EditBusinessEntityMutationVariables>(EditBusinessEntityDocument, variables, options);
export const DeleteBusinessEntityDocument = `
    mutation deleteBusinessEntity($id: String!) {
  deleteBusinessEntity(id: $id)
}
    `;
export const useDeleteBusinessEntityMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBusinessEntityMutation, TError, DeleteBusinessEntityMutationVariables, TContext>) =>
    useMutation<DeleteBusinessEntityMutation, TError, DeleteBusinessEntityMutationVariables, TContext>(
      ['deleteBusinessEntity'],
      (variables?: DeleteBusinessEntityMutationVariables) => fetcher<DeleteBusinessEntityMutation, DeleteBusinessEntityMutationVariables>(DeleteBusinessEntityDocument, variables)(),
      options
    );
useDeleteBusinessEntityMutation.getKey = () => ['deleteBusinessEntity'];

useDeleteBusinessEntityMutation.fetcher = (variables: DeleteBusinessEntityMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteBusinessEntityMutation, DeleteBusinessEntityMutationVariables>(DeleteBusinessEntityDocument, variables, options);
export const BulkAddBusinessEntitiesDocument = `
    mutation bulkAddBusinessEntities($newBusinessEntityData: [NewBusinessEntityInputWithType!]!) {
  bulkAddBusinessEntities(newBusinessEntityData: $newBusinessEntityData) {
    _id
  }
}
    `;
export const useBulkAddBusinessEntitiesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddBusinessEntitiesMutation, TError, BulkAddBusinessEntitiesMutationVariables, TContext>) =>
    useMutation<BulkAddBusinessEntitiesMutation, TError, BulkAddBusinessEntitiesMutationVariables, TContext>(
      ['bulkAddBusinessEntities'],
      (variables?: BulkAddBusinessEntitiesMutationVariables) => fetcher<BulkAddBusinessEntitiesMutation, BulkAddBusinessEntitiesMutationVariables>(BulkAddBusinessEntitiesDocument, variables)(),
      options
    );
useBulkAddBusinessEntitiesMutation.getKey = () => ['bulkAddBusinessEntities'];

useBulkAddBusinessEntitiesMutation.fetcher = (variables: BulkAddBusinessEntitiesMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddBusinessEntitiesMutation, BulkAddBusinessEntitiesMutationVariables>(BulkAddBusinessEntitiesDocument, variables, options);
export const GetBusinessStorageFacilitiesDocument = `
    query getBusinessStorageFacilities($id: String!) {
  businessEntityById(id: $id) {
    _id
    type
    name
    storageFacilities {
      identifier
      capacity
      unit
      commodityIds
      safeFillLevel
      shutDownLevel
      commodities {
        _id
        code
        label
        unit
        weight
      }
      linkedStorageFacilityIds
      customFields {
        key
        value
      }
    }
  }
}
    `;
export const useGetBusinessStorageFacilitiesQuery = <
      TData = GetBusinessStorageFacilitiesQuery,
      TError = Exception
    >(
      variables: GetBusinessStorageFacilitiesQueryVariables,
      options?: UseQueryOptions<GetBusinessStorageFacilitiesQuery, TError, TData>
    ) =>
    useQuery<GetBusinessStorageFacilitiesQuery, TError, TData>(
      ['getBusinessStorageFacilities', variables],
      fetcher<GetBusinessStorageFacilitiesQuery, GetBusinessStorageFacilitiesQueryVariables>(GetBusinessStorageFacilitiesDocument, variables),
      options
    );

useGetBusinessStorageFacilitiesQuery.getKey = (variables: GetBusinessStorageFacilitiesQueryVariables) => ['getBusinessStorageFacilities', variables];
;

useGetBusinessStorageFacilitiesQuery.fetcher = (variables: GetBusinessStorageFacilitiesQueryVariables, options?: RequestInit['headers']) => fetcher<GetBusinessStorageFacilitiesQuery, GetBusinessStorageFacilitiesQueryVariables>(GetBusinessStorageFacilitiesDocument, variables, options);
export const BulkEditBusinessEntitiesDocument = `
    mutation bulkEditBusinessEntities($editBusinessEntityData: BusinessEntityUpdateInput!, $ids: [ObjectId!]!) {
  bulkEditBusinessEntities(
    editBusinessEntityData: $editBusinessEntityData
    ids: $ids
  ) {
    matchedCount
    modifiedCount
    upsertedCount
  }
}
    `;
export const useBulkEditBusinessEntitiesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkEditBusinessEntitiesMutation, TError, BulkEditBusinessEntitiesMutationVariables, TContext>) =>
    useMutation<BulkEditBusinessEntitiesMutation, TError, BulkEditBusinessEntitiesMutationVariables, TContext>(
      ['bulkEditBusinessEntities'],
      (variables?: BulkEditBusinessEntitiesMutationVariables) => fetcher<BulkEditBusinessEntitiesMutation, BulkEditBusinessEntitiesMutationVariables>(BulkEditBusinessEntitiesDocument, variables)(),
      options
    );
useBulkEditBusinessEntitiesMutation.getKey = () => ['bulkEditBusinessEntities'];

useBulkEditBusinessEntitiesMutation.fetcher = (variables: BulkEditBusinessEntitiesMutationVariables, options?: RequestInit['headers']) => fetcher<BulkEditBusinessEntitiesMutation, BulkEditBusinessEntitiesMutationVariables>(BulkEditBusinessEntitiesDocument, variables, options);
export const GetCustomFieldDefinitionsDocument = `
    query getCustomFieldDefinitions($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  cutomFieldDefinitions(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      key
      label
      description
      selectOptions {
        key
        label
      }
      defaultOption
      selectOptionsEntity
      selectOptionsEndpoint
      type
      context
      isRequirement
      requirementOptions {
        isPartial
        isRange
        isRequired
      }
      extensionId
      isExtensionField
    }
  }
}
    `;
export const useGetCustomFieldDefinitionsQuery = <
      TData = GetCustomFieldDefinitionsQuery,
      TError = Exception
    >(
      variables?: GetCustomFieldDefinitionsQueryVariables,
      options?: UseQueryOptions<GetCustomFieldDefinitionsQuery, TError, TData>
    ) =>
    useQuery<GetCustomFieldDefinitionsQuery, TError, TData>(
      variables === undefined ? ['getCustomFieldDefinitions'] : ['getCustomFieldDefinitions', variables],
      fetcher<GetCustomFieldDefinitionsQuery, GetCustomFieldDefinitionsQueryVariables>(GetCustomFieldDefinitionsDocument, variables),
      options
    );

useGetCustomFieldDefinitionsQuery.getKey = (variables?: GetCustomFieldDefinitionsQueryVariables) => variables === undefined ? ['getCustomFieldDefinitions'] : ['getCustomFieldDefinitions', variables];
;

useGetCustomFieldDefinitionsQuery.fetcher = (variables?: GetCustomFieldDefinitionsQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomFieldDefinitionsQuery, GetCustomFieldDefinitionsQueryVariables>(GetCustomFieldDefinitionsDocument, variables, options);
export const GetCustomFieldDefinitionDetailsDocument = `
    query getCustomFieldDefinitionDetails($id: String!) {
  customFieldDefinitionById(id: $id) {
    _id
    key
    label
    description
    selectOptions {
      key
      label
    }
    defaultOption
    selectOptionsEntity
    selectOptionsEndpoint
    type
    context
    isRequirement
    requirementOptions {
      isPartial
      isRange
      isRequired
    }
    extensionId
    isExtensionField
  }
}
    `;
export const useGetCustomFieldDefinitionDetailsQuery = <
      TData = GetCustomFieldDefinitionDetailsQuery,
      TError = Exception
    >(
      variables: GetCustomFieldDefinitionDetailsQueryVariables,
      options?: UseQueryOptions<GetCustomFieldDefinitionDetailsQuery, TError, TData>
    ) =>
    useQuery<GetCustomFieldDefinitionDetailsQuery, TError, TData>(
      ['getCustomFieldDefinitionDetails', variables],
      fetcher<GetCustomFieldDefinitionDetailsQuery, GetCustomFieldDefinitionDetailsQueryVariables>(GetCustomFieldDefinitionDetailsDocument, variables),
      options
    );

useGetCustomFieldDefinitionDetailsQuery.getKey = (variables: GetCustomFieldDefinitionDetailsQueryVariables) => ['getCustomFieldDefinitionDetails', variables];
;

useGetCustomFieldDefinitionDetailsQuery.fetcher = (variables: GetCustomFieldDefinitionDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomFieldDefinitionDetailsQuery, GetCustomFieldDefinitionDetailsQueryVariables>(GetCustomFieldDefinitionDetailsDocument, variables, options);
export const AddCustomFieldDefinitionDocument = `
    mutation addCustomFieldDefinition($newCustomFieldDefinitionData: NewCustomFieldDefinitionInput!) {
  addCustomFieldDefinition(
    newCustomFieldDefinitionData: $newCustomFieldDefinitionData
  ) {
    _id
  }
}
    `;
export const useAddCustomFieldDefinitionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddCustomFieldDefinitionMutation, TError, AddCustomFieldDefinitionMutationVariables, TContext>) =>
    useMutation<AddCustomFieldDefinitionMutation, TError, AddCustomFieldDefinitionMutationVariables, TContext>(
      ['addCustomFieldDefinition'],
      (variables?: AddCustomFieldDefinitionMutationVariables) => fetcher<AddCustomFieldDefinitionMutation, AddCustomFieldDefinitionMutationVariables>(AddCustomFieldDefinitionDocument, variables)(),
      options
    );
useAddCustomFieldDefinitionMutation.getKey = () => ['addCustomFieldDefinition'];

useAddCustomFieldDefinitionMutation.fetcher = (variables: AddCustomFieldDefinitionMutationVariables, options?: RequestInit['headers']) => fetcher<AddCustomFieldDefinitionMutation, AddCustomFieldDefinitionMutationVariables>(AddCustomFieldDefinitionDocument, variables, options);
export const EditCustomFieldDefinitionDocument = `
    mutation editCustomFieldDefinition($id: String!, $editCustomFieldDefinitionData: CustomFieldDefinitionUpdateInput!) {
  editCustomFieldDefinition(
    id: $id
    editCustomFieldDefinitionData: $editCustomFieldDefinitionData
  ) {
    _id
  }
}
    `;
export const useEditCustomFieldDefinitionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditCustomFieldDefinitionMutation, TError, EditCustomFieldDefinitionMutationVariables, TContext>) =>
    useMutation<EditCustomFieldDefinitionMutation, TError, EditCustomFieldDefinitionMutationVariables, TContext>(
      ['editCustomFieldDefinition'],
      (variables?: EditCustomFieldDefinitionMutationVariables) => fetcher<EditCustomFieldDefinitionMutation, EditCustomFieldDefinitionMutationVariables>(EditCustomFieldDefinitionDocument, variables)(),
      options
    );
useEditCustomFieldDefinitionMutation.getKey = () => ['editCustomFieldDefinition'];

useEditCustomFieldDefinitionMutation.fetcher = (variables: EditCustomFieldDefinitionMutationVariables, options?: RequestInit['headers']) => fetcher<EditCustomFieldDefinitionMutation, EditCustomFieldDefinitionMutationVariables>(EditCustomFieldDefinitionDocument, variables, options);
export const DeleteCustomFieldDefinitionDocument = `
    mutation deleteCustomFieldDefinition($id: String!) {
  deleteCustomFieldDefinition(id: $id)
}
    `;
export const useDeleteCustomFieldDefinitionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomFieldDefinitionMutation, TError, DeleteCustomFieldDefinitionMutationVariables, TContext>) =>
    useMutation<DeleteCustomFieldDefinitionMutation, TError, DeleteCustomFieldDefinitionMutationVariables, TContext>(
      ['deleteCustomFieldDefinition'],
      (variables?: DeleteCustomFieldDefinitionMutationVariables) => fetcher<DeleteCustomFieldDefinitionMutation, DeleteCustomFieldDefinitionMutationVariables>(DeleteCustomFieldDefinitionDocument, variables)(),
      options
    );
useDeleteCustomFieldDefinitionMutation.getKey = () => ['deleteCustomFieldDefinition'];

useDeleteCustomFieldDefinitionMutation.fetcher = (variables: DeleteCustomFieldDefinitionMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteCustomFieldDefinitionMutation, DeleteCustomFieldDefinitionMutationVariables>(DeleteCustomFieldDefinitionDocument, variables, options);
export const GetCustomerListDocument = `
    query getCustomerList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $includeInactive: Boolean) {
  customers(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      address {
        label
      }
      code
      contact {
        firstname
        lastname
        email
        phoneNumber
      }
      name
      type
      tags
    }
    count
  }
}
    `;
export const useGetCustomerListQuery = <
      TData = GetCustomerListQuery,
      TError = Exception
    >(
      variables?: GetCustomerListQueryVariables,
      options?: UseQueryOptions<GetCustomerListQuery, TError, TData>
    ) =>
    useQuery<GetCustomerListQuery, TError, TData>(
      variables === undefined ? ['getCustomerList'] : ['getCustomerList', variables],
      fetcher<GetCustomerListQuery, GetCustomerListQueryVariables>(GetCustomerListDocument, variables),
      options
    );

useGetCustomerListQuery.getKey = (variables?: GetCustomerListQueryVariables) => variables === undefined ? ['getCustomerList'] : ['getCustomerList', variables];
;

useGetCustomerListQuery.fetcher = (variables?: GetCustomerListQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomerListQuery, GetCustomerListQueryVariables>(GetCustomerListDocument, variables, options);
export const GetCustomerDetailsDocument = `
    query getCustomerDetails($id: String!) {
  customerById(id: $id) {
    _id
    name
    code
    additionalTypes
    address {
      label
      coordinates {
        latitude
        longitude
      }
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    addressTimezone
    billingAddress {
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    billingEmail
    billingTermsDay
    remitAddress {
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    remitEmail
    contact {
      email
      firstname
      lastname
      phoneNumber
    }
    openingSchedules {
      openingTime
      closingTime
      days
    }
    additionalContacts {
      firstname
      lastname
      email
      phoneNumber
    }
    goodInventoryItems {
      _id
      label
      weight
    }
    type
    tags
    defaultReferenceNumbers {
      referenceNumberType
      referenceNumberValue
    }
    referenceNumberTypes
  }
}
    `;
export const useGetCustomerDetailsQuery = <
      TData = GetCustomerDetailsQuery,
      TError = Exception
    >(
      variables: GetCustomerDetailsQueryVariables,
      options?: UseQueryOptions<GetCustomerDetailsQuery, TError, TData>
    ) =>
    useQuery<GetCustomerDetailsQuery, TError, TData>(
      ['getCustomerDetails', variables],
      fetcher<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, variables),
      options
    );

useGetCustomerDetailsQuery.getKey = (variables: GetCustomerDetailsQueryVariables) => ['getCustomerDetails', variables];
;

useGetCustomerDetailsQuery.fetcher = (variables: GetCustomerDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, variables, options);
export const AddCustomerDocument = `
    mutation addCustomer($newCustomerData: NewBusinessEntityInput!) {
  addCustomer(newCustomerData: $newCustomerData) {
    _id
  }
}
    `;
export const useAddCustomerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddCustomerMutation, TError, AddCustomerMutationVariables, TContext>) =>
    useMutation<AddCustomerMutation, TError, AddCustomerMutationVariables, TContext>(
      ['addCustomer'],
      (variables?: AddCustomerMutationVariables) => fetcher<AddCustomerMutation, AddCustomerMutationVariables>(AddCustomerDocument, variables)(),
      options
    );
useAddCustomerMutation.getKey = () => ['addCustomer'];

useAddCustomerMutation.fetcher = (variables: AddCustomerMutationVariables, options?: RequestInit['headers']) => fetcher<AddCustomerMutation, AddCustomerMutationVariables>(AddCustomerDocument, variables, options);
export const EditCustomerDocument = `
    mutation editCustomer($id: String!, $editCustomerData: BusinessEntityUpdateInput!) {
  editCustomer(id: $id, editCustomerData: $editCustomerData) {
    _id
  }
}
    `;
export const useEditCustomerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditCustomerMutation, TError, EditCustomerMutationVariables, TContext>) =>
    useMutation<EditCustomerMutation, TError, EditCustomerMutationVariables, TContext>(
      ['editCustomer'],
      (variables?: EditCustomerMutationVariables) => fetcher<EditCustomerMutation, EditCustomerMutationVariables>(EditCustomerDocument, variables)(),
      options
    );
useEditCustomerMutation.getKey = () => ['editCustomer'];

useEditCustomerMutation.fetcher = (variables: EditCustomerMutationVariables, options?: RequestInit['headers']) => fetcher<EditCustomerMutation, EditCustomerMutationVariables>(EditCustomerDocument, variables, options);
export const DeleteCustomerDocument = `
    mutation deleteCustomer($id: String!) {
  deleteCustomer(id: $id)
}
    `;
export const useDeleteCustomerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomerMutation, TError, DeleteCustomerMutationVariables, TContext>) =>
    useMutation<DeleteCustomerMutation, TError, DeleteCustomerMutationVariables, TContext>(
      ['deleteCustomer'],
      (variables?: DeleteCustomerMutationVariables) => fetcher<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, variables)(),
      options
    );
useDeleteCustomerMutation.getKey = () => ['deleteCustomer'];

useDeleteCustomerMutation.fetcher = (variables: DeleteCustomerMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, variables, options);
export const GetDriverListDocument = `
    query getDriverList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $where: DriverWhere, $includeInactive: Boolean) {
  drivers(
    search: $search
    skip: $skip
    take: $take
    where: $where
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      eldId
      externalId
      firstname
      lastname
      phoneNumber
      domicileEntity {
        _id
        name
        addressTimezone
      }
      status
      license {
        licenseNumber
        expiryDate
      }
      medical {
        number
        expiryDate
      }
      domicileId
      tags
      customFields {
        key
        value
      }
      groupIds
    }
    count
  }
}
    `;
export const useGetDriverListQuery = <
      TData = GetDriverListQuery,
      TError = Exception
    >(
      variables?: GetDriverListQueryVariables,
      options?: UseQueryOptions<GetDriverListQuery, TError, TData>
    ) =>
    useQuery<GetDriverListQuery, TError, TData>(
      variables === undefined ? ['getDriverList'] : ['getDriverList', variables],
      fetcher<GetDriverListQuery, GetDriverListQueryVariables>(GetDriverListDocument, variables),
      options
    );

useGetDriverListQuery.getKey = (variables?: GetDriverListQueryVariables) => variables === undefined ? ['getDriverList'] : ['getDriverList', variables];
;

useGetDriverListQuery.fetcher = (variables?: GetDriverListQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverListQuery, GetDriverListQueryVariables>(GetDriverListDocument, variables, options);
export const GetDriverDetailsDocument = `
    query getDriverDetails($id: String!) {
  driverById(id: $id) {
    _id
    dateOfBirth
    dateOfPhysicalExamination
    documents {
      _id
      name
      url
    }
    domicileId
    domicileEntity {
      _id
      name
      address {
        label
        coordinates {
          latitude
          longitude
        }
      }
    }
    eldId
    externalId
    firstname
    isOwnerOperator
    middlename
    lastname
    phoneNumber
    status
    license {
      address {
        city
        country
        googlePlaceId
        line1
        line2
        postalCode
        state
      }
      classification
      endorsements
      expiryDate
      issuedDate
      issuedState
      licenseNumber
      restriction
    }
    medical {
      number
      expiryDate
      issuedDate
      restriction
    }
    userId
    tags
    customFields {
      key
      value
    }
    groupIds
  }
}
    `;
export const useGetDriverDetailsQuery = <
      TData = GetDriverDetailsQuery,
      TError = Exception
    >(
      variables: GetDriverDetailsQueryVariables,
      options?: UseQueryOptions<GetDriverDetailsQuery, TError, TData>
    ) =>
    useQuery<GetDriverDetailsQuery, TError, TData>(
      ['getDriverDetails', variables],
      fetcher<GetDriverDetailsQuery, GetDriverDetailsQueryVariables>(GetDriverDetailsDocument, variables),
      options
    );

useGetDriverDetailsQuery.getKey = (variables: GetDriverDetailsQueryVariables) => ['getDriverDetails', variables];
;

useGetDriverDetailsQuery.fetcher = (variables: GetDriverDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverDetailsQuery, GetDriverDetailsQueryVariables>(GetDriverDetailsDocument, variables, options);
export const DeleteDriverDocument = `
    mutation deleteDriver($id: String!) {
  deleteDriver(id: $id)
}
    `;
export const useDeleteDriverMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDriverMutation, TError, DeleteDriverMutationVariables, TContext>) =>
    useMutation<DeleteDriverMutation, TError, DeleteDriverMutationVariables, TContext>(
      ['deleteDriver'],
      (variables?: DeleteDriverMutationVariables) => fetcher<DeleteDriverMutation, DeleteDriverMutationVariables>(DeleteDriverDocument, variables)(),
      options
    );
useDeleteDriverMutation.getKey = () => ['deleteDriver'];

useDeleteDriverMutation.fetcher = (variables: DeleteDriverMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteDriverMutation, DeleteDriverMutationVariables>(DeleteDriverDocument, variables, options);
export const AddDriverDocument = `
    mutation addDriver($newDriverData: NewDriverInput!) {
  addDriver(newDriverData: $newDriverData) {
    _id
    userId
  }
}
    `;
export const useAddDriverMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddDriverMutation, TError, AddDriverMutationVariables, TContext>) =>
    useMutation<AddDriverMutation, TError, AddDriverMutationVariables, TContext>(
      ['addDriver'],
      (variables?: AddDriverMutationVariables) => fetcher<AddDriverMutation, AddDriverMutationVariables>(AddDriverDocument, variables)(),
      options
    );
useAddDriverMutation.getKey = () => ['addDriver'];

useAddDriverMutation.fetcher = (variables: AddDriverMutationVariables, options?: RequestInit['headers']) => fetcher<AddDriverMutation, AddDriverMutationVariables>(AddDriverDocument, variables, options);
export const EditDriverDocument = `
    mutation editDriver($id: String!, $editDriverData: DriverUpdateInput!) {
  editDriver(id: $id, editDriverData: $editDriverData) {
    _id
  }
}
    `;
export const useEditDriverMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditDriverMutation, TError, EditDriverMutationVariables, TContext>) =>
    useMutation<EditDriverMutation, TError, EditDriverMutationVariables, TContext>(
      ['editDriver'],
      (variables?: EditDriverMutationVariables) => fetcher<EditDriverMutation, EditDriverMutationVariables>(EditDriverDocument, variables)(),
      options
    );
useEditDriverMutation.getKey = () => ['editDriver'];

useEditDriverMutation.fetcher = (variables: EditDriverMutationVariables, options?: RequestInit['headers']) => fetcher<EditDriverMutation, EditDriverMutationVariables>(EditDriverDocument, variables, options);
export const BulkAddDriversDocument = `
    mutation bulkAddDrivers($newDriverData: [NewDriverInput!]!) {
  bulkAddDrivers(newDriverData: $newDriverData) {
    _id
  }
}
    `;
export const useBulkAddDriversMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddDriversMutation, TError, BulkAddDriversMutationVariables, TContext>) =>
    useMutation<BulkAddDriversMutation, TError, BulkAddDriversMutationVariables, TContext>(
      ['bulkAddDrivers'],
      (variables?: BulkAddDriversMutationVariables) => fetcher<BulkAddDriversMutation, BulkAddDriversMutationVariables>(BulkAddDriversDocument, variables)(),
      options
    );
useBulkAddDriversMutation.getKey = () => ['bulkAddDrivers'];

useBulkAddDriversMutation.fetcher = (variables: BulkAddDriversMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddDriversMutation, BulkAddDriversMutationVariables>(BulkAddDriversDocument, variables, options);
export const BulkEditDriversDocument = `
    mutation bulkEditDrivers($editDriverData: BulkEditDriverInput!, $ids: [ObjectId!]!) {
  bulkEditDrivers(editDriverData: $editDriverData, ids: $ids) {
    matchedCount
    modifiedCount
    upsertedCount
  }
}
    `;
export const useBulkEditDriversMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkEditDriversMutation, TError, BulkEditDriversMutationVariables, TContext>) =>
    useMutation<BulkEditDriversMutation, TError, BulkEditDriversMutationVariables, TContext>(
      ['bulkEditDrivers'],
      (variables?: BulkEditDriversMutationVariables) => fetcher<BulkEditDriversMutation, BulkEditDriversMutationVariables>(BulkEditDriversDocument, variables)(),
      options
    );
useBulkEditDriversMutation.getKey = () => ['bulkEditDrivers'];

useBulkEditDriversMutation.fetcher = (variables: BulkEditDriversMutationVariables, options?: RequestInit['headers']) => fetcher<BulkEditDriversMutation, BulkEditDriversMutationVariables>(BulkEditDriversDocument, variables, options);
export const AddDwellTimeUptickDocument = `
    mutation addDwellTimeUptick($newDwellTimeUptickData: NewDwellTimeUptickInput!) {
  addDwellTimeUptick(newDwellTimeUptickData: $newDwellTimeUptickData) {
    _id
  }
}
    `;
export const useAddDwellTimeUptickMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddDwellTimeUptickMutation, TError, AddDwellTimeUptickMutationVariables, TContext>) =>
    useMutation<AddDwellTimeUptickMutation, TError, AddDwellTimeUptickMutationVariables, TContext>(
      ['addDwellTimeUptick'],
      (variables?: AddDwellTimeUptickMutationVariables) => fetcher<AddDwellTimeUptickMutation, AddDwellTimeUptickMutationVariables>(AddDwellTimeUptickDocument, variables)(),
      options
    );
useAddDwellTimeUptickMutation.getKey = () => ['addDwellTimeUptick'];

useAddDwellTimeUptickMutation.fetcher = (variables: AddDwellTimeUptickMutationVariables, options?: RequestInit['headers']) => fetcher<AddDwellTimeUptickMutation, AddDwellTimeUptickMutationVariables>(AddDwellTimeUptickDocument, variables, options);
export const EditDwellTimeUptickDocument = `
    mutation editDwellTimeUptick($id: ObjectId!, $editDwellTimeUptickData: NewDwellTimeUptickInput!) {
  editDwellTimeUptick(id: $id, editDwellTimeUptickData: $editDwellTimeUptickData) {
    _id
  }
}
    `;
export const useEditDwellTimeUptickMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditDwellTimeUptickMutation, TError, EditDwellTimeUptickMutationVariables, TContext>) =>
    useMutation<EditDwellTimeUptickMutation, TError, EditDwellTimeUptickMutationVariables, TContext>(
      ['editDwellTimeUptick'],
      (variables?: EditDwellTimeUptickMutationVariables) => fetcher<EditDwellTimeUptickMutation, EditDwellTimeUptickMutationVariables>(EditDwellTimeUptickDocument, variables)(),
      options
    );
useEditDwellTimeUptickMutation.getKey = () => ['editDwellTimeUptick'];

useEditDwellTimeUptickMutation.fetcher = (variables: EditDwellTimeUptickMutationVariables, options?: RequestInit['headers']) => fetcher<EditDwellTimeUptickMutation, EditDwellTimeUptickMutationVariables>(EditDwellTimeUptickDocument, variables, options);
export const DeleteDwellTimeUptickDocument = `
    mutation deleteDwellTimeUptick($id: ObjectId!) {
  deleteDwellTimeUptick(id: $id)
}
    `;
export const useDeleteDwellTimeUptickMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDwellTimeUptickMutation, TError, DeleteDwellTimeUptickMutationVariables, TContext>) =>
    useMutation<DeleteDwellTimeUptickMutation, TError, DeleteDwellTimeUptickMutationVariables, TContext>(
      ['deleteDwellTimeUptick'],
      (variables?: DeleteDwellTimeUptickMutationVariables) => fetcher<DeleteDwellTimeUptickMutation, DeleteDwellTimeUptickMutationVariables>(DeleteDwellTimeUptickDocument, variables)(),
      options
    );
useDeleteDwellTimeUptickMutation.getKey = () => ['deleteDwellTimeUptick'];

useDeleteDwellTimeUptickMutation.fetcher = (variables: DeleteDwellTimeUptickMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteDwellTimeUptickMutation, DeleteDwellTimeUptickMutationVariables>(DeleteDwellTimeUptickDocument, variables, options);
export const DwellTimeUpticksDocument = `
    query dwellTimeUpticks($skip: Int, $take: Int, $filter: JSON) {
  dwellTimeUpticks(skip: $skip, take: $take, filter: $filter) {
    data {
      _id
      startDate
      endDate
      addedTimeInMinutes
      groupIds
    }
    count
  }
}
    `;
export const useDwellTimeUpticksQuery = <
      TData = DwellTimeUpticksQuery,
      TError = Exception
    >(
      variables?: DwellTimeUpticksQueryVariables,
      options?: UseQueryOptions<DwellTimeUpticksQuery, TError, TData>
    ) =>
    useQuery<DwellTimeUpticksQuery, TError, TData>(
      variables === undefined ? ['dwellTimeUpticks'] : ['dwellTimeUpticks', variables],
      fetcher<DwellTimeUpticksQuery, DwellTimeUpticksQueryVariables>(DwellTimeUpticksDocument, variables),
      options
    );

useDwellTimeUpticksQuery.getKey = (variables?: DwellTimeUpticksQueryVariables) => variables === undefined ? ['dwellTimeUpticks'] : ['dwellTimeUpticks', variables];
;

useDwellTimeUpticksQuery.fetcher = (variables?: DwellTimeUpticksQueryVariables, options?: RequestInit['headers']) => fetcher<DwellTimeUpticksQuery, DwellTimeUpticksQueryVariables>(DwellTimeUpticksDocument, variables, options);
export const GetGroupsDocument = `
    query getGroups($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  groups(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      name
      memberIds
      defaultFromReceiverForOrders
    }
  }
}
    `;
export const useGetGroupsQuery = <
      TData = GetGroupsQuery,
      TError = Exception
    >(
      variables?: GetGroupsQueryVariables,
      options?: UseQueryOptions<GetGroupsQuery, TError, TData>
    ) =>
    useQuery<GetGroupsQuery, TError, TData>(
      variables === undefined ? ['getGroups'] : ['getGroups', variables],
      fetcher<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, variables),
      options
    );

useGetGroupsQuery.getKey = (variables?: GetGroupsQueryVariables) => variables === undefined ? ['getGroups'] : ['getGroups', variables];
;

useGetGroupsQuery.fetcher = (variables?: GetGroupsQueryVariables, options?: RequestInit['headers']) => fetcher<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, variables, options);
export const GetGroupDetailsDocument = `
    query getGroupDetails($id: String!) {
  groupById(id: $id) {
    _id
    name
    memberIds
    defaultFromReceiverForOrders
  }
}
    `;
export const useGetGroupDetailsQuery = <
      TData = GetGroupDetailsQuery,
      TError = Exception
    >(
      variables: GetGroupDetailsQueryVariables,
      options?: UseQueryOptions<GetGroupDetailsQuery, TError, TData>
    ) =>
    useQuery<GetGroupDetailsQuery, TError, TData>(
      ['getGroupDetails', variables],
      fetcher<GetGroupDetailsQuery, GetGroupDetailsQueryVariables>(GetGroupDetailsDocument, variables),
      options
    );

useGetGroupDetailsQuery.getKey = (variables: GetGroupDetailsQueryVariables) => ['getGroupDetails', variables];
;

useGetGroupDetailsQuery.fetcher = (variables: GetGroupDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetGroupDetailsQuery, GetGroupDetailsQueryVariables>(GetGroupDetailsDocument, variables, options);
export const AddGroupDocument = `
    mutation addGroup($newGroupData: NewGroupInput!) {
  addGroup(newGroupData: $newGroupData) {
    _id
  }
}
    `;
export const useAddGroupMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddGroupMutation, TError, AddGroupMutationVariables, TContext>) =>
    useMutation<AddGroupMutation, TError, AddGroupMutationVariables, TContext>(
      ['addGroup'],
      (variables?: AddGroupMutationVariables) => fetcher<AddGroupMutation, AddGroupMutationVariables>(AddGroupDocument, variables)(),
      options
    );
useAddGroupMutation.getKey = () => ['addGroup'];

useAddGroupMutation.fetcher = (variables: AddGroupMutationVariables, options?: RequestInit['headers']) => fetcher<AddGroupMutation, AddGroupMutationVariables>(AddGroupDocument, variables, options);
export const EditGroupDocument = `
    mutation editGroup($id: String!, $editGroupData: GroupUpdateInput!) {
  editGroup(id: $id, editGroupData: $editGroupData) {
    _id
  }
}
    `;
export const useEditGroupMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditGroupMutation, TError, EditGroupMutationVariables, TContext>) =>
    useMutation<EditGroupMutation, TError, EditGroupMutationVariables, TContext>(
      ['editGroup'],
      (variables?: EditGroupMutationVariables) => fetcher<EditGroupMutation, EditGroupMutationVariables>(EditGroupDocument, variables)(),
      options
    );
useEditGroupMutation.getKey = () => ['editGroup'];

useEditGroupMutation.fetcher = (variables: EditGroupMutationVariables, options?: RequestInit['headers']) => fetcher<EditGroupMutation, EditGroupMutationVariables>(EditGroupDocument, variables, options);
export const DeleteGroupDocument = `
    mutation deleteGroup($id: String!) {
  deleteGroup(id: $id)
}
    `;
export const useDeleteGroupMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGroupMutation, TError, DeleteGroupMutationVariables, TContext>) =>
    useMutation<DeleteGroupMutation, TError, DeleteGroupMutationVariables, TContext>(
      ['deleteGroup'],
      (variables?: DeleteGroupMutationVariables) => fetcher<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, variables)(),
      options
    );
useDeleteGroupMutation.getKey = () => ['deleteGroup'];

useDeleteGroupMutation.fetcher = (variables: DeleteGroupMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, variables, options);
export const GetReceiverListDocument = `
    query getReceiverList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $includeInactive: Boolean) {
  receivers(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      address {
        label
      }
      code
      contact {
        firstname
        lastname
        email
        phoneNumber
      }
      name
      type
      tags
      status
      groupIds
    }
    count
  }
}
    `;
export const useGetReceiverListQuery = <
      TData = GetReceiverListQuery,
      TError = Exception
    >(
      variables?: GetReceiverListQueryVariables,
      options?: UseQueryOptions<GetReceiverListQuery, TError, TData>
    ) =>
    useQuery<GetReceiverListQuery, TError, TData>(
      variables === undefined ? ['getReceiverList'] : ['getReceiverList', variables],
      fetcher<GetReceiverListQuery, GetReceiverListQueryVariables>(GetReceiverListDocument, variables),
      options
    );

useGetReceiverListQuery.getKey = (variables?: GetReceiverListQueryVariables) => variables === undefined ? ['getReceiverList'] : ['getReceiverList', variables];
;

useGetReceiverListQuery.fetcher = (variables?: GetReceiverListQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiverListQuery, GetReceiverListQueryVariables>(GetReceiverListDocument, variables, options);
export const GetReceiverDetailsDocument = `
    query getReceiverDetails($id: String!) {
  receiverById(id: $id) {
    _id
    name
    code
    additionalTypes
    addressTimezone
    address {
      label
      coordinates {
        latitude
        longitude
      }
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    remitAddress {
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    contact {
      email
      firstname
      lastname
      phoneNumber
    }
    openingSchedules {
      openingTime
      closingTime
      days
    }
    additionalContacts {
      firstname
      lastname
      email
      phoneNumber
    }
    type
    tags
    parentBusinessEntity {
      type
      _id
    }
    status
    groupIds
  }
}
    `;
export const useGetReceiverDetailsQuery = <
      TData = GetReceiverDetailsQuery,
      TError = Exception
    >(
      variables: GetReceiverDetailsQueryVariables,
      options?: UseQueryOptions<GetReceiverDetailsQuery, TError, TData>
    ) =>
    useQuery<GetReceiverDetailsQuery, TError, TData>(
      ['getReceiverDetails', variables],
      fetcher<GetReceiverDetailsQuery, GetReceiverDetailsQueryVariables>(GetReceiverDetailsDocument, variables),
      options
    );

useGetReceiverDetailsQuery.getKey = (variables: GetReceiverDetailsQueryVariables) => ['getReceiverDetails', variables];
;

useGetReceiverDetailsQuery.fetcher = (variables: GetReceiverDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiverDetailsQuery, GetReceiverDetailsQueryVariables>(GetReceiverDetailsDocument, variables, options);
export const GetReceiverListWithStorageFacilitiesDocument = `
    query getReceiverListWithStorageFacilities {
  businessEntities(businessEntityTypes: RECEIVER) {
    data {
      _id
      address {
        label
        coordinates {
          latitude
          longitude
        }
      }
      code
      storageFacilities {
        identifier
        capacity
        unit
        commodityIds
        safeFillLevel
        shutDownLevel
        linkedStorageFacilityIds
      }
    }
  }
}
    `;
export const useGetReceiverListWithStorageFacilitiesQuery = <
      TData = GetReceiverListWithStorageFacilitiesQuery,
      TError = Exception
    >(
      variables?: GetReceiverListWithStorageFacilitiesQueryVariables,
      options?: UseQueryOptions<GetReceiverListWithStorageFacilitiesQuery, TError, TData>
    ) =>
    useQuery<GetReceiverListWithStorageFacilitiesQuery, TError, TData>(
      variables === undefined ? ['getReceiverListWithStorageFacilities'] : ['getReceiverListWithStorageFacilities', variables],
      fetcher<GetReceiverListWithStorageFacilitiesQuery, GetReceiverListWithStorageFacilitiesQueryVariables>(GetReceiverListWithStorageFacilitiesDocument, variables),
      options
    );

useGetReceiverListWithStorageFacilitiesQuery.getKey = (variables?: GetReceiverListWithStorageFacilitiesQueryVariables) => variables === undefined ? ['getReceiverListWithStorageFacilities'] : ['getReceiverListWithStorageFacilities', variables];
;

useGetReceiverListWithStorageFacilitiesQuery.fetcher = (variables?: GetReceiverListWithStorageFacilitiesQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiverListWithStorageFacilitiesQuery, GetReceiverListWithStorageFacilitiesQueryVariables>(GetReceiverListWithStorageFacilitiesDocument, variables, options);
export const AddReceiverDocument = `
    mutation addReceiver($newReceiverData: NewBusinessEntityInput!) {
  addReceiver(newReceiverData: $newReceiverData) {
    _id
  }
}
    `;
export const useAddReceiverMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddReceiverMutation, TError, AddReceiverMutationVariables, TContext>) =>
    useMutation<AddReceiverMutation, TError, AddReceiverMutationVariables, TContext>(
      ['addReceiver'],
      (variables?: AddReceiverMutationVariables) => fetcher<AddReceiverMutation, AddReceiverMutationVariables>(AddReceiverDocument, variables)(),
      options
    );
useAddReceiverMutation.getKey = () => ['addReceiver'];

useAddReceiverMutation.fetcher = (variables: AddReceiverMutationVariables, options?: RequestInit['headers']) => fetcher<AddReceiverMutation, AddReceiverMutationVariables>(AddReceiverDocument, variables, options);
export const EditReceiverDocument = `
    mutation editReceiver($id: String!, $editReceiverData: BusinessEntityUpdateInput!) {
  editReceiver(id: $id, editReceiverData: $editReceiverData) {
    _id
  }
}
    `;
export const useEditReceiverMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditReceiverMutation, TError, EditReceiverMutationVariables, TContext>) =>
    useMutation<EditReceiverMutation, TError, EditReceiverMutationVariables, TContext>(
      ['editReceiver'],
      (variables?: EditReceiverMutationVariables) => fetcher<EditReceiverMutation, EditReceiverMutationVariables>(EditReceiverDocument, variables)(),
      options
    );
useEditReceiverMutation.getKey = () => ['editReceiver'];

useEditReceiverMutation.fetcher = (variables: EditReceiverMutationVariables, options?: RequestInit['headers']) => fetcher<EditReceiverMutation, EditReceiverMutationVariables>(EditReceiverDocument, variables, options);
export const DeleteReceiverDocument = `
    mutation deleteReceiver($id: String!) {
  deleteReceiver(id: $id)
}
    `;
export const useDeleteReceiverMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReceiverMutation, TError, DeleteReceiverMutationVariables, TContext>) =>
    useMutation<DeleteReceiverMutation, TError, DeleteReceiverMutationVariables, TContext>(
      ['deleteReceiver'],
      (variables?: DeleteReceiverMutationVariables) => fetcher<DeleteReceiverMutation, DeleteReceiverMutationVariables>(DeleteReceiverDocument, variables)(),
      options
    );
useDeleteReceiverMutation.getKey = () => ['deleteReceiver'];

useDeleteReceiverMutation.fetcher = (variables: DeleteReceiverMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteReceiverMutation, DeleteReceiverMutationVariables>(DeleteReceiverDocument, variables, options);
export const GetShipperListDocument = `
    query getShipperList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $includeInactive: Boolean) {
  shippers(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      address {
        label
      }
      code
      contact {
        firstname
        lastname
        email
        phoneNumber
      }
      name
      type
      tags
      status
    }
    count
  }
}
    `;
export const useGetShipperListQuery = <
      TData = GetShipperListQuery,
      TError = Exception
    >(
      variables?: GetShipperListQueryVariables,
      options?: UseQueryOptions<GetShipperListQuery, TError, TData>
    ) =>
    useQuery<GetShipperListQuery, TError, TData>(
      variables === undefined ? ['getShipperList'] : ['getShipperList', variables],
      fetcher<GetShipperListQuery, GetShipperListQueryVariables>(GetShipperListDocument, variables),
      options
    );

useGetShipperListQuery.getKey = (variables?: GetShipperListQueryVariables) => variables === undefined ? ['getShipperList'] : ['getShipperList', variables];
;

useGetShipperListQuery.fetcher = (variables?: GetShipperListQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipperListQuery, GetShipperListQueryVariables>(GetShipperListDocument, variables, options);
export const GetShipperDetailsDocument = `
    query getShipperDetails($id: String!) {
  shipperById(id: $id) {
    _id
    name
    code
    additionalTypes
    addressTimezone
    address {
      label
      coordinates {
        latitude
        longitude
      }
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    remitAddress {
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    contact {
      email
      firstname
      lastname
      phoneNumber
    }
    openingSchedules {
      openingTime
      closingTime
      days
    }
    additionalContacts {
      firstname
      lastname
      email
      phoneNumber
    }
    type
    tags
    status
  }
}
    `;
export const useGetShipperDetailsQuery = <
      TData = GetShipperDetailsQuery,
      TError = Exception
    >(
      variables: GetShipperDetailsQueryVariables,
      options?: UseQueryOptions<GetShipperDetailsQuery, TError, TData>
    ) =>
    useQuery<GetShipperDetailsQuery, TError, TData>(
      ['getShipperDetails', variables],
      fetcher<GetShipperDetailsQuery, GetShipperDetailsQueryVariables>(GetShipperDetailsDocument, variables),
      options
    );

useGetShipperDetailsQuery.getKey = (variables: GetShipperDetailsQueryVariables) => ['getShipperDetails', variables];
;

useGetShipperDetailsQuery.fetcher = (variables: GetShipperDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipperDetailsQuery, GetShipperDetailsQueryVariables>(GetShipperDetailsDocument, variables, options);
export const AddShipperDocument = `
    mutation addShipper($newShipperData: NewBusinessEntityInput!) {
  addShipper(newShipperData: $newShipperData) {
    _id
  }
}
    `;
export const useAddShipperMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddShipperMutation, TError, AddShipperMutationVariables, TContext>) =>
    useMutation<AddShipperMutation, TError, AddShipperMutationVariables, TContext>(
      ['addShipper'],
      (variables?: AddShipperMutationVariables) => fetcher<AddShipperMutation, AddShipperMutationVariables>(AddShipperDocument, variables)(),
      options
    );
useAddShipperMutation.getKey = () => ['addShipper'];

useAddShipperMutation.fetcher = (variables: AddShipperMutationVariables, options?: RequestInit['headers']) => fetcher<AddShipperMutation, AddShipperMutationVariables>(AddShipperDocument, variables, options);
export const EditShipperDocument = `
    mutation editShipper($id: String!, $editShipperData: BusinessEntityUpdateInput!) {
  editShipper(id: $id, editShipperData: $editShipperData) {
    _id
  }
}
    `;
export const useEditShipperMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditShipperMutation, TError, EditShipperMutationVariables, TContext>) =>
    useMutation<EditShipperMutation, TError, EditShipperMutationVariables, TContext>(
      ['editShipper'],
      (variables?: EditShipperMutationVariables) => fetcher<EditShipperMutation, EditShipperMutationVariables>(EditShipperDocument, variables)(),
      options
    );
useEditShipperMutation.getKey = () => ['editShipper'];

useEditShipperMutation.fetcher = (variables: EditShipperMutationVariables, options?: RequestInit['headers']) => fetcher<EditShipperMutation, EditShipperMutationVariables>(EditShipperDocument, variables, options);
export const DeleteShipperDocument = `
    mutation deleteShipper($id: String!) {
  deleteShipper(id: $id)
}
    `;
export const useDeleteShipperMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteShipperMutation, TError, DeleteShipperMutationVariables, TContext>) =>
    useMutation<DeleteShipperMutation, TError, DeleteShipperMutationVariables, TContext>(
      ['deleteShipper'],
      (variables?: DeleteShipperMutationVariables) => fetcher<DeleteShipperMutation, DeleteShipperMutationVariables>(DeleteShipperDocument, variables)(),
      options
    );
useDeleteShipperMutation.getKey = () => ['deleteShipper'];

useDeleteShipperMutation.fetcher = (variables: DeleteShipperMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteShipperMutation, DeleteShipperMutationVariables>(DeleteShipperDocument, variables, options);
export const GetTractorListDocument = `
    query getTractorList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $includeInactive: Boolean) {
  tractors(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      domicile {
        city
        country
        label
      }
      licenseNumber
      make
      model
      serialNumber
      plateNumber
      status
      tareWeight
      year
      tags
      customFields {
        key
        value
      }
      groupIds
    }
    count
  }
}
    `;
export const useGetTractorListQuery = <
      TData = GetTractorListQuery,
      TError = Exception
    >(
      variables?: GetTractorListQueryVariables,
      options?: UseQueryOptions<GetTractorListQuery, TError, TData>
    ) =>
    useQuery<GetTractorListQuery, TError, TData>(
      variables === undefined ? ['getTractorList'] : ['getTractorList', variables],
      fetcher<GetTractorListQuery, GetTractorListQueryVariables>(GetTractorListDocument, variables),
      options
    );

useGetTractorListQuery.getKey = (variables?: GetTractorListQueryVariables) => variables === undefined ? ['getTractorList'] : ['getTractorList', variables];
;

useGetTractorListQuery.fetcher = (variables?: GetTractorListQueryVariables, options?: RequestInit['headers']) => fetcher<GetTractorListQuery, GetTractorListQueryVariables>(GetTractorListDocument, variables, options);
export const GetTractorDetailsDocument = `
    query getTractorDetails($id: String!) {
  tractorById(id: $id) {
    _id
    documents {
      _id
      name
      url
    }
    eldId
    externalId
    domicile {
      label
      coordinates {
        latitude
        longitude
      }
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    eldId
    externalId
    licenseNumber
    plateNumber
    make
    model
    serialNumber
    status
    tareWeight
    mileage
    year
    tags
    customFields {
      key
      value
    }
    groupIds
  }
}
    `;
export const useGetTractorDetailsQuery = <
      TData = GetTractorDetailsQuery,
      TError = Exception
    >(
      variables: GetTractorDetailsQueryVariables,
      options?: UseQueryOptions<GetTractorDetailsQuery, TError, TData>
    ) =>
    useQuery<GetTractorDetailsQuery, TError, TData>(
      ['getTractorDetails', variables],
      fetcher<GetTractorDetailsQuery, GetTractorDetailsQueryVariables>(GetTractorDetailsDocument, variables),
      options
    );

useGetTractorDetailsQuery.getKey = (variables: GetTractorDetailsQueryVariables) => ['getTractorDetails', variables];
;

useGetTractorDetailsQuery.fetcher = (variables: GetTractorDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetTractorDetailsQuery, GetTractorDetailsQueryVariables>(GetTractorDetailsDocument, variables, options);
export const DeleteTractorDocument = `
    mutation deleteTractor($id: String!) {
  deleteTractor(id: $id)
}
    `;
export const useDeleteTractorMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTractorMutation, TError, DeleteTractorMutationVariables, TContext>) =>
    useMutation<DeleteTractorMutation, TError, DeleteTractorMutationVariables, TContext>(
      ['deleteTractor'],
      (variables?: DeleteTractorMutationVariables) => fetcher<DeleteTractorMutation, DeleteTractorMutationVariables>(DeleteTractorDocument, variables)(),
      options
    );
useDeleteTractorMutation.getKey = () => ['deleteTractor'];

useDeleteTractorMutation.fetcher = (variables: DeleteTractorMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteTractorMutation, DeleteTractorMutationVariables>(DeleteTractorDocument, variables, options);
export const AddTractorDocument = `
    mutation addTractor($newTractorData: NewTractorInput!) {
  addTractor(newTractorData: $newTractorData) {
    _id
  }
}
    `;
export const useAddTractorMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddTractorMutation, TError, AddTractorMutationVariables, TContext>) =>
    useMutation<AddTractorMutation, TError, AddTractorMutationVariables, TContext>(
      ['addTractor'],
      (variables?: AddTractorMutationVariables) => fetcher<AddTractorMutation, AddTractorMutationVariables>(AddTractorDocument, variables)(),
      options
    );
useAddTractorMutation.getKey = () => ['addTractor'];

useAddTractorMutation.fetcher = (variables: AddTractorMutationVariables, options?: RequestInit['headers']) => fetcher<AddTractorMutation, AddTractorMutationVariables>(AddTractorDocument, variables, options);
export const EditTractorDocument = `
    mutation editTractor($id: String!, $editTractorData: TractorUpdateInput!) {
  editTractor(id: $id, editTractorData: $editTractorData) {
    _id
  }
}
    `;
export const useEditTractorMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditTractorMutation, TError, EditTractorMutationVariables, TContext>) =>
    useMutation<EditTractorMutation, TError, EditTractorMutationVariables, TContext>(
      ['editTractor'],
      (variables?: EditTractorMutationVariables) => fetcher<EditTractorMutation, EditTractorMutationVariables>(EditTractorDocument, variables)(),
      options
    );
useEditTractorMutation.getKey = () => ['editTractor'];

useEditTractorMutation.fetcher = (variables: EditTractorMutationVariables, options?: RequestInit['headers']) => fetcher<EditTractorMutation, EditTractorMutationVariables>(EditTractorDocument, variables, options);
export const BulkAddTractorsDocument = `
    mutation bulkAddTractors($newTractorsData: [NewTractorInput!]!) {
  bulkAddTractors(newTractorsData: $newTractorsData) {
    _id
  }
}
    `;
export const useBulkAddTractorsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddTractorsMutation, TError, BulkAddTractorsMutationVariables, TContext>) =>
    useMutation<BulkAddTractorsMutation, TError, BulkAddTractorsMutationVariables, TContext>(
      ['bulkAddTractors'],
      (variables?: BulkAddTractorsMutationVariables) => fetcher<BulkAddTractorsMutation, BulkAddTractorsMutationVariables>(BulkAddTractorsDocument, variables)(),
      options
    );
useBulkAddTractorsMutation.getKey = () => ['bulkAddTractors'];

useBulkAddTractorsMutation.fetcher = (variables: BulkAddTractorsMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddTractorsMutation, BulkAddTractorsMutationVariables>(BulkAddTractorsDocument, variables, options);
export const BulkEditTractorsDocument = `
    mutation bulkEditTractors($editTractorData: TractorUpdateInput!, $ids: [ObjectId!]!) {
  bulkEditTractors(editTractorData: $editTractorData, ids: $ids) {
    matchedCount
    modifiedCount
    upsertedCount
  }
}
    `;
export const useBulkEditTractorsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkEditTractorsMutation, TError, BulkEditTractorsMutationVariables, TContext>) =>
    useMutation<BulkEditTractorsMutation, TError, BulkEditTractorsMutationVariables, TContext>(
      ['bulkEditTractors'],
      (variables?: BulkEditTractorsMutationVariables) => fetcher<BulkEditTractorsMutation, BulkEditTractorsMutationVariables>(BulkEditTractorsDocument, variables)(),
      options
    );
useBulkEditTractorsMutation.getKey = () => ['bulkEditTractors'];

useBulkEditTractorsMutation.fetcher = (variables: BulkEditTractorsMutationVariables, options?: RequestInit['headers']) => fetcher<BulkEditTractorsMutation, BulkEditTractorsMutationVariables>(BulkEditTractorsDocument, variables, options);
export const GetTrailersDocument = `
    query getTrailers {
  trailers(includeInactive: true) {
    data {
      _id
      serialNumber
      status
      type
      maxWeight
      lastKnownLocation {
        latitude
        longitude
      }
      tags
      customFields {
        key
        value
      }
      compartments {
        identifier
        capacity
        unit
        minVolume
        maxVolume
        heavyOnly
        hasDoubleBulkheadAfter
      }
    }
  }
}
    `;
export const useGetTrailersQuery = <
      TData = GetTrailersQuery,
      TError = Exception
    >(
      variables?: GetTrailersQueryVariables,
      options?: UseQueryOptions<GetTrailersQuery, TError, TData>
    ) =>
    useQuery<GetTrailersQuery, TError, TData>(
      variables === undefined ? ['getTrailers'] : ['getTrailers', variables],
      fetcher<GetTrailersQuery, GetTrailersQueryVariables>(GetTrailersDocument, variables),
      options
    );

useGetTrailersQuery.getKey = (variables?: GetTrailersQueryVariables) => variables === undefined ? ['getTrailers'] : ['getTrailers', variables];
;

useGetTrailersQuery.fetcher = (variables?: GetTrailersQueryVariables, options?: RequestInit['headers']) => fetcher<GetTrailersQuery, GetTrailersQueryVariables>(GetTrailersDocument, variables, options);
export const GetTrailerListDocument = `
    query getTrailerList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $includeInactive: Boolean) {
  trailers(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      domicile {
        label
        city
        country
      }
      licenseNumber
      serialNumber
      status
      type
      hasMeteredPump
      tags
      groupIds
      customFields {
        key
        value
      }
    }
    count
  }
}
    `;
export const useGetTrailerListQuery = <
      TData = GetTrailerListQuery,
      TError = Exception
    >(
      variables?: GetTrailerListQueryVariables,
      options?: UseQueryOptions<GetTrailerListQuery, TError, TData>
    ) =>
    useQuery<GetTrailerListQuery, TError, TData>(
      variables === undefined ? ['getTrailerList'] : ['getTrailerList', variables],
      fetcher<GetTrailerListQuery, GetTrailerListQueryVariables>(GetTrailerListDocument, variables),
      options
    );

useGetTrailerListQuery.getKey = (variables?: GetTrailerListQueryVariables) => variables === undefined ? ['getTrailerList'] : ['getTrailerList', variables];
;

useGetTrailerListQuery.fetcher = (variables?: GetTrailerListQueryVariables, options?: RequestInit['headers']) => fetcher<GetTrailerListQuery, GetTrailerListQueryVariables>(GetTrailerListDocument, variables, options);
export const GetTrailerDetailsDocument = `
    query getTrailerDetails($id: String!) {
  trailerById(id: $id) {
    _id
    documents {
      _id
      name
      url
    }
    domicile {
      label
      coordinates {
        latitude
        longitude
      }
      city
      country
      googlePlaceId
      line1
      line2
      postalCode
      state
    }
    width
    height
    length
    maxWeight
    licenseNumber
    maxTemperature
    minTemperature
    numberOfAxles
    serialNumber
    vin
    serial
    mileage
    status
    type
    hasMeteredPump
    compartments {
      identifier
      capacity
      unit
      minVolume
      maxVolume
      heavyOnly
      hasDoubleBulkheadAfter
    }
    compartmentVolumes {
      _id
      compartmentId
      commodityId
      quantity
      lastUpdated
      lastShipmentId
      lastShipmentNumber
      updatedBy
    }
    customFields {
      key
      value
    }
    tags
    groupIds
  }
}
    `;
export const useGetTrailerDetailsQuery = <
      TData = GetTrailerDetailsQuery,
      TError = Exception
    >(
      variables: GetTrailerDetailsQueryVariables,
      options?: UseQueryOptions<GetTrailerDetailsQuery, TError, TData>
    ) =>
    useQuery<GetTrailerDetailsQuery, TError, TData>(
      ['getTrailerDetails', variables],
      fetcher<GetTrailerDetailsQuery, GetTrailerDetailsQueryVariables>(GetTrailerDetailsDocument, variables),
      options
    );

useGetTrailerDetailsQuery.getKey = (variables: GetTrailerDetailsQueryVariables) => ['getTrailerDetails', variables];
;

useGetTrailerDetailsQuery.fetcher = (variables: GetTrailerDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetTrailerDetailsQuery, GetTrailerDetailsQueryVariables>(GetTrailerDetailsDocument, variables, options);
export const UpdateCompartmentVolumeDocument = `
    mutation updateCompartmentVolume($trailerId: String!, $compartmentId: String!, $commodityId: String!, $quantity: Float!) {
  updateCompartmentVolume(
    trailerId: $trailerId
    compartmentId: $compartmentId
    commodityId: $commodityId
    quantity: $quantity
  ) {
    _id
    compartmentId
    commodityId
    quantity
    lastUpdated
    updatedBy
  }
}
    `;
export const useUpdateCompartmentVolumeMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCompartmentVolumeMutation, TError, UpdateCompartmentVolumeMutationVariables, TContext>) =>
    useMutation<UpdateCompartmentVolumeMutation, TError, UpdateCompartmentVolumeMutationVariables, TContext>(
      ['updateCompartmentVolume'],
      (variables?: UpdateCompartmentVolumeMutationVariables) => fetcher<UpdateCompartmentVolumeMutation, UpdateCompartmentVolumeMutationVariables>(UpdateCompartmentVolumeDocument, variables)(),
      options
    );
useUpdateCompartmentVolumeMutation.getKey = () => ['updateCompartmentVolume'];

useUpdateCompartmentVolumeMutation.fetcher = (variables: UpdateCompartmentVolumeMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateCompartmentVolumeMutation, UpdateCompartmentVolumeMutationVariables>(UpdateCompartmentVolumeDocument, variables, options);
export const ResetTrailerCompartmentVolumesDocument = `
    mutation resetTrailerCompartmentVolumes($trailerId: String!) {
  resetTrailerCompartmentVolumes(trailerId: $trailerId)
}
    `;
export const useResetTrailerCompartmentVolumesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ResetTrailerCompartmentVolumesMutation, TError, ResetTrailerCompartmentVolumesMutationVariables, TContext>) =>
    useMutation<ResetTrailerCompartmentVolumesMutation, TError, ResetTrailerCompartmentVolumesMutationVariables, TContext>(
      ['resetTrailerCompartmentVolumes'],
      (variables?: ResetTrailerCompartmentVolumesMutationVariables) => fetcher<ResetTrailerCompartmentVolumesMutation, ResetTrailerCompartmentVolumesMutationVariables>(ResetTrailerCompartmentVolumesDocument, variables)(),
      options
    );
useResetTrailerCompartmentVolumesMutation.getKey = () => ['resetTrailerCompartmentVolumes'];

useResetTrailerCompartmentVolumesMutation.fetcher = (variables: ResetTrailerCompartmentVolumesMutationVariables, options?: RequestInit['headers']) => fetcher<ResetTrailerCompartmentVolumesMutation, ResetTrailerCompartmentVolumesMutationVariables>(ResetTrailerCompartmentVolumesDocument, variables, options);
export const DeleteTrailerDocument = `
    mutation deleteTrailer($id: String!) {
  deleteTrailer(id: $id)
}
    `;
export const useDeleteTrailerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTrailerMutation, TError, DeleteTrailerMutationVariables, TContext>) =>
    useMutation<DeleteTrailerMutation, TError, DeleteTrailerMutationVariables, TContext>(
      ['deleteTrailer'],
      (variables?: DeleteTrailerMutationVariables) => fetcher<DeleteTrailerMutation, DeleteTrailerMutationVariables>(DeleteTrailerDocument, variables)(),
      options
    );
useDeleteTrailerMutation.getKey = () => ['deleteTrailer'];

useDeleteTrailerMutation.fetcher = (variables: DeleteTrailerMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteTrailerMutation, DeleteTrailerMutationVariables>(DeleteTrailerDocument, variables, options);
export const AddTrailerDocument = `
    mutation addTrailer($newTrailerData: NewTrailerInput!) {
  addTrailer(newTrailerData: $newTrailerData) {
    _id
  }
}
    `;
export const useAddTrailerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddTrailerMutation, TError, AddTrailerMutationVariables, TContext>) =>
    useMutation<AddTrailerMutation, TError, AddTrailerMutationVariables, TContext>(
      ['addTrailer'],
      (variables?: AddTrailerMutationVariables) => fetcher<AddTrailerMutation, AddTrailerMutationVariables>(AddTrailerDocument, variables)(),
      options
    );
useAddTrailerMutation.getKey = () => ['addTrailer'];

useAddTrailerMutation.fetcher = (variables: AddTrailerMutationVariables, options?: RequestInit['headers']) => fetcher<AddTrailerMutation, AddTrailerMutationVariables>(AddTrailerDocument, variables, options);
export const EditTrailerDocument = `
    mutation editTrailer($id: String!, $editTrailerData: TrailerUpdateInput!) {
  editTrailer(id: $id, editTrailerData: $editTrailerData) {
    _id
  }
}
    `;
export const useEditTrailerMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditTrailerMutation, TError, EditTrailerMutationVariables, TContext>) =>
    useMutation<EditTrailerMutation, TError, EditTrailerMutationVariables, TContext>(
      ['editTrailer'],
      (variables?: EditTrailerMutationVariables) => fetcher<EditTrailerMutation, EditTrailerMutationVariables>(EditTrailerDocument, variables)(),
      options
    );
useEditTrailerMutation.getKey = () => ['editTrailer'];

useEditTrailerMutation.fetcher = (variables: EditTrailerMutationVariables, options?: RequestInit['headers']) => fetcher<EditTrailerMutation, EditTrailerMutationVariables>(EditTrailerDocument, variables, options);
export const BulkAddTrailersDocument = `
    mutation bulkAddTrailers($newTrailerData: [NewTrailerInput!]!) {
  bulkAddTrailers(newTrailerData: $newTrailerData) {
    _id
  }
}
    `;
export const useBulkAddTrailersMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddTrailersMutation, TError, BulkAddTrailersMutationVariables, TContext>) =>
    useMutation<BulkAddTrailersMutation, TError, BulkAddTrailersMutationVariables, TContext>(
      ['bulkAddTrailers'],
      (variables?: BulkAddTrailersMutationVariables) => fetcher<BulkAddTrailersMutation, BulkAddTrailersMutationVariables>(BulkAddTrailersDocument, variables)(),
      options
    );
useBulkAddTrailersMutation.getKey = () => ['bulkAddTrailers'];

useBulkAddTrailersMutation.fetcher = (variables: BulkAddTrailersMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddTrailersMutation, BulkAddTrailersMutationVariables>(BulkAddTrailersDocument, variables, options);
export const BulkEditTrailersDocument = `
    mutation bulkEditTrailers($editTrailerData: TrailerUpdateInput!, $ids: [ObjectId!]!) {
  bulkEditTrailers(editTrailerData: $editTrailerData, ids: $ids) {
    matchedCount
    modifiedCount
    upsertedCount
  }
}
    `;
export const useBulkEditTrailersMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkEditTrailersMutation, TError, BulkEditTrailersMutationVariables, TContext>) =>
    useMutation<BulkEditTrailersMutation, TError, BulkEditTrailersMutationVariables, TContext>(
      ['bulkEditTrailers'],
      (variables?: BulkEditTrailersMutationVariables) => fetcher<BulkEditTrailersMutation, BulkEditTrailersMutationVariables>(BulkEditTrailersDocument, variables)(),
      options
    );
useBulkEditTrailersMutation.getKey = () => ['bulkEditTrailers'];

useBulkEditTrailersMutation.fetcher = (variables: BulkEditTrailersMutationVariables, options?: RequestInit['headers']) => fetcher<BulkEditTrailersMutation, BulkEditTrailersMutationVariables>(BulkEditTrailersDocument, variables, options);
export const TrailerEventsDocument = `
    query trailerEvents($filter: JSON, $orderBy: [OrderByItem!], $search: String, $skip: Int, $take: Int) {
  trailerEvents(
    filter: $filter
    orderBy: $orderBy
    search: $search
    skip: $skip
    take: $take
  ) {
    count
    data {
      _id
      date
      trailerId
      type
    }
  }
}
    `;
export const useTrailerEventsQuery = <
      TData = TrailerEventsQuery,
      TError = Exception
    >(
      variables?: TrailerEventsQueryVariables,
      options?: UseQueryOptions<TrailerEventsQuery, TError, TData>
    ) =>
    useQuery<TrailerEventsQuery, TError, TData>(
      variables === undefined ? ['trailerEvents'] : ['trailerEvents', variables],
      fetcher<TrailerEventsQuery, TrailerEventsQueryVariables>(TrailerEventsDocument, variables),
      options
    );

useTrailerEventsQuery.getKey = (variables?: TrailerEventsQueryVariables) => variables === undefined ? ['trailerEvents'] : ['trailerEvents', variables];
;

useTrailerEventsQuery.fetcher = (variables?: TrailerEventsQueryVariables, options?: RequestInit['headers']) => fetcher<TrailerEventsQuery, TrailerEventsQueryVariables>(TrailerEventsDocument, variables, options);
export const AddTrailerEventDocument = `
    mutation addTrailerEvent($newTrailerEventData: NewTrailerEventInput!) {
  addTrailerEvent(newTrailerEventData: $newTrailerEventData) {
    _id
  }
}
    `;
export const useAddTrailerEventMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddTrailerEventMutation, TError, AddTrailerEventMutationVariables, TContext>) =>
    useMutation<AddTrailerEventMutation, TError, AddTrailerEventMutationVariables, TContext>(
      ['addTrailerEvent'],
      (variables?: AddTrailerEventMutationVariables) => fetcher<AddTrailerEventMutation, AddTrailerEventMutationVariables>(AddTrailerEventDocument, variables)(),
      options
    );
useAddTrailerEventMutation.getKey = () => ['addTrailerEvent'];

useAddTrailerEventMutation.fetcher = (variables: AddTrailerEventMutationVariables, options?: RequestInit['headers']) => fetcher<AddTrailerEventMutation, AddTrailerEventMutationVariables>(AddTrailerEventDocument, variables, options);
export const EditTrailerEventDocument = `
    mutation editTrailerEvent($id: String!, $editTrailerEventData: TrailerEventUpdateInput!) {
  editTrailerEvent(id: $id, editTrailerEventData: $editTrailerEventData) {
    _id
  }
}
    `;
export const useEditTrailerEventMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditTrailerEventMutation, TError, EditTrailerEventMutationVariables, TContext>) =>
    useMutation<EditTrailerEventMutation, TError, EditTrailerEventMutationVariables, TContext>(
      ['editTrailerEvent'],
      (variables?: EditTrailerEventMutationVariables) => fetcher<EditTrailerEventMutation, EditTrailerEventMutationVariables>(EditTrailerEventDocument, variables)(),
      options
    );
useEditTrailerEventMutation.getKey = () => ['editTrailerEvent'];

useEditTrailerEventMutation.fetcher = (variables: EditTrailerEventMutationVariables, options?: RequestInit['headers']) => fetcher<EditTrailerEventMutation, EditTrailerEventMutationVariables>(EditTrailerEventDocument, variables, options);
export const DeleteTrailerEventDocument = `
    mutation deleteTrailerEvent($id: String!) {
  deleteTrailerEvent(id: $id)
}
    `;
export const useDeleteTrailerEventMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTrailerEventMutation, TError, DeleteTrailerEventMutationVariables, TContext>) =>
    useMutation<DeleteTrailerEventMutation, TError, DeleteTrailerEventMutationVariables, TContext>(
      ['deleteTrailerEvent'],
      (variables?: DeleteTrailerEventMutationVariables) => fetcher<DeleteTrailerEventMutation, DeleteTrailerEventMutationVariables>(DeleteTrailerEventDocument, variables)(),
      options
    );
useDeleteTrailerEventMutation.getKey = () => ['deleteTrailerEvent'];

useDeleteTrailerEventMutation.fetcher = (variables: DeleteTrailerEventMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteTrailerEventMutation, DeleteTrailerEventMutationVariables>(DeleteTrailerEventDocument, variables, options);
export const SupplierContractsDocument = `
    query supplierContracts($customerId: ObjectId, $goodProfileId: ObjectId, $search: String, $shipperId: ObjectId, $skip: Int, $supplierId: ObjectId, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  supplierContracts(
    customerId: $customerId
    goodProfileId: $goodProfileId
    search: $search
    shipperId: $shipperId
    skip: $skip
    supplierId: $supplierId
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    count
    data {
      _id
      contractNumber
      customerId
      endDate
      goodProfileId
      shipperId
      startDate
      supplierId
      unitPrice
      pinCode
      allocation {
        dailyQuantity
        monthlyQuantity
        weeklyQuantity
        totalQuantity
      }
      usedAllocation {
        dailyQuantity
        monthlyQuantity
        weeklyQuantity
        totalQuantity
      }
      customer {
        _id
        code
        name
        type
      }
      goodProfile {
        _id
        code
        label
      }
      shipper {
        _id
        name
        type
        code
      }
    }
  }
}
    `;
export const useSupplierContractsQuery = <
      TData = SupplierContractsQuery,
      TError = Exception
    >(
      variables?: SupplierContractsQueryVariables,
      options?: UseQueryOptions<SupplierContractsQuery, TError, TData>
    ) =>
    useQuery<SupplierContractsQuery, TError, TData>(
      variables === undefined ? ['supplierContracts'] : ['supplierContracts', variables],
      fetcher<SupplierContractsQuery, SupplierContractsQueryVariables>(SupplierContractsDocument, variables),
      options
    );

useSupplierContractsQuery.getKey = (variables?: SupplierContractsQueryVariables) => variables === undefined ? ['supplierContracts'] : ['supplierContracts', variables];
;

useSupplierContractsQuery.fetcher = (variables?: SupplierContractsQueryVariables, options?: RequestInit['headers']) => fetcher<SupplierContractsQuery, SupplierContractsQueryVariables>(SupplierContractsDocument, variables, options);
export const SupplierContractByIdDocument = `
    query supplierContractById($id: String!) {
  supplierContractById(id: $id) {
    _id
    contractNumber
    customerId
    endDate
    goodProfileId
    shipperId
    startDate
    supplierId
    unitPrice
    pinCode
    allocation {
      dailyQuantity
      monthlyQuantity
      weeklyQuantity
      totalQuantity
    }
    usedAllocation {
      dailyQuantity
      monthlyQuantity
      weeklyQuantity
      totalQuantity
    }
    customer {
      _id
      code
      name
      type
    }
    goodProfile {
      _id
      code
      label
    }
    shipper {
      _id
      name
      type
      code
    }
    conditions {
      target
      operator
      value
    }
  }
}
    `;
export const useSupplierContractByIdQuery = <
      TData = SupplierContractByIdQuery,
      TError = Exception
    >(
      variables: SupplierContractByIdQueryVariables,
      options?: UseQueryOptions<SupplierContractByIdQuery, TError, TData>
    ) =>
    useQuery<SupplierContractByIdQuery, TError, TData>(
      ['supplierContractById', variables],
      fetcher<SupplierContractByIdQuery, SupplierContractByIdQueryVariables>(SupplierContractByIdDocument, variables),
      options
    );

useSupplierContractByIdQuery.getKey = (variables: SupplierContractByIdQueryVariables) => ['supplierContractById', variables];
;

useSupplierContractByIdQuery.fetcher = (variables: SupplierContractByIdQueryVariables, options?: RequestInit['headers']) => fetcher<SupplierContractByIdQuery, SupplierContractByIdQueryVariables>(SupplierContractByIdDocument, variables, options);
export const EditSupplierContractDocument = `
    mutation editSupplierContract($editSupplierContractData: SupplierContractUpdateInput!, $id: String!) {
  editSupplierContract(
    editSupplierContractData: $editSupplierContractData
    id: $id
  ) {
    _id
  }
}
    `;
export const useEditSupplierContractMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditSupplierContractMutation, TError, EditSupplierContractMutationVariables, TContext>) =>
    useMutation<EditSupplierContractMutation, TError, EditSupplierContractMutationVariables, TContext>(
      ['editSupplierContract'],
      (variables?: EditSupplierContractMutationVariables) => fetcher<EditSupplierContractMutation, EditSupplierContractMutationVariables>(EditSupplierContractDocument, variables)(),
      options
    );
useEditSupplierContractMutation.getKey = () => ['editSupplierContract'];

useEditSupplierContractMutation.fetcher = (variables: EditSupplierContractMutationVariables, options?: RequestInit['headers']) => fetcher<EditSupplierContractMutation, EditSupplierContractMutationVariables>(EditSupplierContractDocument, variables, options);
export const AddSupplierContractDocument = `
    mutation addSupplierContract($newSupplierContractData: NewSupplierContractInput!) {
  addSupplierContract(newSupplierContractData: $newSupplierContractData) {
    _id
  }
}
    `;
export const useAddSupplierContractMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddSupplierContractMutation, TError, AddSupplierContractMutationVariables, TContext>) =>
    useMutation<AddSupplierContractMutation, TError, AddSupplierContractMutationVariables, TContext>(
      ['addSupplierContract'],
      (variables?: AddSupplierContractMutationVariables) => fetcher<AddSupplierContractMutation, AddSupplierContractMutationVariables>(AddSupplierContractDocument, variables)(),
      options
    );
useAddSupplierContractMutation.getKey = () => ['addSupplierContract'];

useAddSupplierContractMutation.fetcher = (variables: AddSupplierContractMutationVariables, options?: RequestInit['headers']) => fetcher<AddSupplierContractMutation, AddSupplierContractMutationVariables>(AddSupplierContractDocument, variables, options);
export const DeleteSupplierContractDocument = `
    mutation deleteSupplierContract($id: String!) {
  deleteSupplierContract(id: $id)
}
    `;
export const useDeleteSupplierContractMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSupplierContractMutation, TError, DeleteSupplierContractMutationVariables, TContext>) =>
    useMutation<DeleteSupplierContractMutation, TError, DeleteSupplierContractMutationVariables, TContext>(
      ['deleteSupplierContract'],
      (variables?: DeleteSupplierContractMutationVariables) => fetcher<DeleteSupplierContractMutation, DeleteSupplierContractMutationVariables>(DeleteSupplierContractDocument, variables)(),
      options
    );
useDeleteSupplierContractMutation.getKey = () => ['deleteSupplierContract'];

useDeleteSupplierContractMutation.fetcher = (variables: DeleteSupplierContractMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteSupplierContractMutation, DeleteSupplierContractMutationVariables>(DeleteSupplierContractDocument, variables, options);
export const GetShipmentsForBestBuyBulkUpdateDocument = `
    query getShipmentsForBestBuyBulkUpdate($shipmentIds: [ObjectId!]!) {
  shipments(ids: $shipmentIds) {
    data {
      _id
      shipmentNumber
      customer {
        _id
      }
      shipmentLocations {
        location {
          latitude
          longitude
        }
        shippedGoods {
          _id
          goodProfileId
          label
          quantity
          unit
          weight
        }
        receivedGoods {
          goodId
          quantity
          goodProfileId
        }
      }
      route {
        firstPickupTime
        lastDropoffTime
      }
    }
  }
}
    `;
export const useGetShipmentsForBestBuyBulkUpdateQuery = <
      TData = GetShipmentsForBestBuyBulkUpdateQuery,
      TError = Exception
    >(
      variables: GetShipmentsForBestBuyBulkUpdateQueryVariables,
      options?: UseQueryOptions<GetShipmentsForBestBuyBulkUpdateQuery, TError, TData>
    ) =>
    useQuery<GetShipmentsForBestBuyBulkUpdateQuery, TError, TData>(
      ['getShipmentsForBestBuyBulkUpdate', variables],
      fetcher<GetShipmentsForBestBuyBulkUpdateQuery, GetShipmentsForBestBuyBulkUpdateQueryVariables>(GetShipmentsForBestBuyBulkUpdateDocument, variables),
      options
    );

useGetShipmentsForBestBuyBulkUpdateQuery.getKey = (variables: GetShipmentsForBestBuyBulkUpdateQueryVariables) => ['getShipmentsForBestBuyBulkUpdate', variables];
;

useGetShipmentsForBestBuyBulkUpdateQuery.fetcher = (variables: GetShipmentsForBestBuyBulkUpdateQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentsForBestBuyBulkUpdateQuery, GetShipmentsForBestBuyBulkUpdateQueryVariables>(GetShipmentsForBestBuyBulkUpdateDocument, variables, options);
export const RankSupplierContractsForPurchaseDocument = `
    mutation rankSupplierContractsForPurchase($purchase: PurchaseInput!) {
  rankSupplierContractsForPurchase(purchase: $purchase) {
    costPerMile
    mileage
    productCost
    quantity
    shippingCost
    totalCost
    unitPrice
    supplierContract {
      _id
      contractNumber
      shipperId
      supplierId
      pinCode
      shipper {
        _id
        name
        address {
          label
          coordinates {
            latitude
            longitude
          }
        }
        addressTimezone
      }
      supplier {
        _id
        name
      }
    }
  }
}
    `;
export const useRankSupplierContractsForPurchaseMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<RankSupplierContractsForPurchaseMutation, TError, RankSupplierContractsForPurchaseMutationVariables, TContext>) =>
    useMutation<RankSupplierContractsForPurchaseMutation, TError, RankSupplierContractsForPurchaseMutationVariables, TContext>(
      ['rankSupplierContractsForPurchase'],
      (variables?: RankSupplierContractsForPurchaseMutationVariables) => fetcher<RankSupplierContractsForPurchaseMutation, RankSupplierContractsForPurchaseMutationVariables>(RankSupplierContractsForPurchaseDocument, variables)(),
      options
    );
useRankSupplierContractsForPurchaseMutation.getKey = () => ['rankSupplierContractsForPurchase'];

useRankSupplierContractsForPurchaseMutation.fetcher = (variables: RankSupplierContractsForPurchaseMutationVariables, options?: RequestInit['headers']) => fetcher<RankSupplierContractsForPurchaseMutation, RankSupplierContractsForPurchaseMutationVariables>(RankSupplierContractsForPurchaseDocument, variables, options);
export const RankSupplierContractsForPurchasesDocument = `
    mutation rankSupplierContractsForPurchases($purchases: [PurchaseInput!]!) {
  rankSupplierContractsForPurchases(purchases: $purchases) {
    costPerMile
    mileage
    productCost
    quantity
    shippingCost
    totalCost
    unitPrice
    supplierContract {
      _id
      contractNumber
      shipperId
      supplierId
      pinCode
      shipper {
        _id
        name
        address {
          label
          coordinates {
            latitude
            longitude
          }
        }
        addressTimezone
      }
      supplier {
        _id
        name
      }
    }
  }
}
    `;
export const useRankSupplierContractsForPurchasesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<RankSupplierContractsForPurchasesMutation, TError, RankSupplierContractsForPurchasesMutationVariables, TContext>) =>
    useMutation<RankSupplierContractsForPurchasesMutation, TError, RankSupplierContractsForPurchasesMutationVariables, TContext>(
      ['rankSupplierContractsForPurchases'],
      (variables?: RankSupplierContractsForPurchasesMutationVariables) => fetcher<RankSupplierContractsForPurchasesMutation, RankSupplierContractsForPurchasesMutationVariables>(RankSupplierContractsForPurchasesDocument, variables)(),
      options
    );
useRankSupplierContractsForPurchasesMutation.getKey = () => ['rankSupplierContractsForPurchases'];

useRankSupplierContractsForPurchasesMutation.fetcher = (variables: RankSupplierContractsForPurchasesMutationVariables, options?: RequestInit['headers']) => fetcher<RankSupplierContractsForPurchasesMutation, RankSupplierContractsForPurchasesMutationVariables>(RankSupplierContractsForPurchasesDocument, variables, options);
export const BulkUpdateContractForShipmentsDocument = `
    mutation bulkUpdateContractForShipments($shipmentIds: [ObjectId!]!, $contractId: ObjectId!) {
  bulkUpdateContractForShipments(
    shipmentIds: $shipmentIds
    contractId: $contractId
  ) {
    _id
  }
}
    `;
export const useBulkUpdateContractForShipmentsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkUpdateContractForShipmentsMutation, TError, BulkUpdateContractForShipmentsMutationVariables, TContext>) =>
    useMutation<BulkUpdateContractForShipmentsMutation, TError, BulkUpdateContractForShipmentsMutationVariables, TContext>(
      ['bulkUpdateContractForShipments'],
      (variables?: BulkUpdateContractForShipmentsMutationVariables) => fetcher<BulkUpdateContractForShipmentsMutation, BulkUpdateContractForShipmentsMutationVariables>(BulkUpdateContractForShipmentsDocument, variables)(),
      options
    );
useBulkUpdateContractForShipmentsMutation.getKey = () => ['bulkUpdateContractForShipments'];

useBulkUpdateContractForShipmentsMutation.fetcher = (variables: BulkUpdateContractForShipmentsMutationVariables, options?: RequestInit['headers']) => fetcher<BulkUpdateContractForShipmentsMutation, BulkUpdateContractForShipmentsMutationVariables>(BulkUpdateContractForShipmentsDocument, variables, options);
export const GetGoodProfileClassListDocument = `
    query getGoodProfileClassList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  goodProfileClasses(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      label
      description
    }
    count
  }
}
    `;
export const useGetGoodProfileClassListQuery = <
      TData = GetGoodProfileClassListQuery,
      TError = Exception
    >(
      variables?: GetGoodProfileClassListQueryVariables,
      options?: UseQueryOptions<GetGoodProfileClassListQuery, TError, TData>
    ) =>
    useQuery<GetGoodProfileClassListQuery, TError, TData>(
      variables === undefined ? ['getGoodProfileClassList'] : ['getGoodProfileClassList', variables],
      fetcher<GetGoodProfileClassListQuery, GetGoodProfileClassListQueryVariables>(GetGoodProfileClassListDocument, variables),
      options
    );

useGetGoodProfileClassListQuery.getKey = (variables?: GetGoodProfileClassListQueryVariables) => variables === undefined ? ['getGoodProfileClassList'] : ['getGoodProfileClassList', variables];
;

useGetGoodProfileClassListQuery.fetcher = (variables?: GetGoodProfileClassListQueryVariables, options?: RequestInit['headers']) => fetcher<GetGoodProfileClassListQuery, GetGoodProfileClassListQueryVariables>(GetGoodProfileClassListDocument, variables, options);
export const GetGoodProfileClassDetailsDocument = `
    query getGoodProfileClassDetails($id: ObjectId!) {
  goodProfileClassById(id: $id) {
    _id
    label
    description
  }
}
    `;
export const useGetGoodProfileClassDetailsQuery = <
      TData = GetGoodProfileClassDetailsQuery,
      TError = Exception
    >(
      variables: GetGoodProfileClassDetailsQueryVariables,
      options?: UseQueryOptions<GetGoodProfileClassDetailsQuery, TError, TData>
    ) =>
    useQuery<GetGoodProfileClassDetailsQuery, TError, TData>(
      ['getGoodProfileClassDetails', variables],
      fetcher<GetGoodProfileClassDetailsQuery, GetGoodProfileClassDetailsQueryVariables>(GetGoodProfileClassDetailsDocument, variables),
      options
    );

useGetGoodProfileClassDetailsQuery.getKey = (variables: GetGoodProfileClassDetailsQueryVariables) => ['getGoodProfileClassDetails', variables];
;

useGetGoodProfileClassDetailsQuery.fetcher = (variables: GetGoodProfileClassDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetGoodProfileClassDetailsQuery, GetGoodProfileClassDetailsQueryVariables>(GetGoodProfileClassDetailsDocument, variables, options);
export const DeleteGoodProfileClassDocument = `
    mutation deleteGoodProfileClass($id: ObjectId!) {
  deleteGoodProfileClass(id: $id)
}
    `;
export const useDeleteGoodProfileClassMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGoodProfileClassMutation, TError, DeleteGoodProfileClassMutationVariables, TContext>) =>
    useMutation<DeleteGoodProfileClassMutation, TError, DeleteGoodProfileClassMutationVariables, TContext>(
      ['deleteGoodProfileClass'],
      (variables?: DeleteGoodProfileClassMutationVariables) => fetcher<DeleteGoodProfileClassMutation, DeleteGoodProfileClassMutationVariables>(DeleteGoodProfileClassDocument, variables)(),
      options
    );
useDeleteGoodProfileClassMutation.getKey = () => ['deleteGoodProfileClass'];

useDeleteGoodProfileClassMutation.fetcher = (variables: DeleteGoodProfileClassMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteGoodProfileClassMutation, DeleteGoodProfileClassMutationVariables>(DeleteGoodProfileClassDocument, variables, options);
export const AddGoodProfileClassDocument = `
    mutation addGoodProfileClass($newGoodProfileClassData: NewGoodProfileClassInput!) {
  addGoodProfileClass(newGoodProfileClassData: $newGoodProfileClassData) {
    _id
  }
}
    `;
export const useAddGoodProfileClassMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddGoodProfileClassMutation, TError, AddGoodProfileClassMutationVariables, TContext>) =>
    useMutation<AddGoodProfileClassMutation, TError, AddGoodProfileClassMutationVariables, TContext>(
      ['addGoodProfileClass'],
      (variables?: AddGoodProfileClassMutationVariables) => fetcher<AddGoodProfileClassMutation, AddGoodProfileClassMutationVariables>(AddGoodProfileClassDocument, variables)(),
      options
    );
useAddGoodProfileClassMutation.getKey = () => ['addGoodProfileClass'];

useAddGoodProfileClassMutation.fetcher = (variables: AddGoodProfileClassMutationVariables, options?: RequestInit['headers']) => fetcher<AddGoodProfileClassMutation, AddGoodProfileClassMutationVariables>(AddGoodProfileClassDocument, variables, options);
export const EditGoodProfileClassDocument = `
    mutation editGoodProfileClass($id: ObjectId!, $editGoodProfileClassData: GoodProfileClassUpdateInput!) {
  editGoodProfileClass(
    id: $id
    editGoodProfileClassData: $editGoodProfileClassData
  ) {
    _id
  }
}
    `;
export const useEditGoodProfileClassMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditGoodProfileClassMutation, TError, EditGoodProfileClassMutationVariables, TContext>) =>
    useMutation<EditGoodProfileClassMutation, TError, EditGoodProfileClassMutationVariables, TContext>(
      ['editGoodProfileClass'],
      (variables?: EditGoodProfileClassMutationVariables) => fetcher<EditGoodProfileClassMutation, EditGoodProfileClassMutationVariables>(EditGoodProfileClassDocument, variables)(),
      options
    );
useEditGoodProfileClassMutation.getKey = () => ['editGoodProfileClass'];

useEditGoodProfileClassMutation.fetcher = (variables: EditGoodProfileClassMutationVariables, options?: RequestInit['headers']) => fetcher<EditGoodProfileClassMutation, EditGoodProfileClassMutationVariables>(EditGoodProfileClassDocument, variables, options);
export const BulkAddGoodProfileClassesDocument = `
    mutation bulkAddGoodProfileClasses($newGoodProfileClassesData: [NewGoodProfileClassInput!]!) {
  bulkAddGoodProfileClasses(newGoodProfileClassesData: $newGoodProfileClassesData) {
    _id
  }
}
    `;
export const useBulkAddGoodProfileClassesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddGoodProfileClassesMutation, TError, BulkAddGoodProfileClassesMutationVariables, TContext>) =>
    useMutation<BulkAddGoodProfileClassesMutation, TError, BulkAddGoodProfileClassesMutationVariables, TContext>(
      ['bulkAddGoodProfileClasses'],
      (variables?: BulkAddGoodProfileClassesMutationVariables) => fetcher<BulkAddGoodProfileClassesMutation, BulkAddGoodProfileClassesMutationVariables>(BulkAddGoodProfileClassesDocument, variables)(),
      options
    );
useBulkAddGoodProfileClassesMutation.getKey = () => ['bulkAddGoodProfileClasses'];

useBulkAddGoodProfileClassesMutation.fetcher = (variables: BulkAddGoodProfileClassesMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddGoodProfileClassesMutation, BulkAddGoodProfileClassesMutationVariables>(BulkAddGoodProfileClassesDocument, variables, options);
export const GetGoodProfileListDocument = `
    query getGoodProfileList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $includeInactive: Boolean) {
  goodProfiles(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
    includeInactive: $includeInactive
  ) {
    data {
      _id
      code
      label
      status
      weight
      liquidGravity
      unit
      productType
      supplierIds
      shipperIds
      color
      goodProfileClassId
      goodProfileClass {
        _id
        label
      }
      equivalences {
        equivalentGoodId
        conditions {
          operator
          target
          value
        }
      }
      restrictions {
        type
        value
      }
      tags
      customFields {
        key
        value
      }
      groupIds
    }
    count
  }
}
    `;
export const useGetGoodProfileListQuery = <
      TData = GetGoodProfileListQuery,
      TError = Exception
    >(
      variables?: GetGoodProfileListQueryVariables,
      options?: UseQueryOptions<GetGoodProfileListQuery, TError, TData>
    ) =>
    useQuery<GetGoodProfileListQuery, TError, TData>(
      variables === undefined ? ['getGoodProfileList'] : ['getGoodProfileList', variables],
      fetcher<GetGoodProfileListQuery, GetGoodProfileListQueryVariables>(GetGoodProfileListDocument, variables),
      options
    );

useGetGoodProfileListQuery.getKey = (variables?: GetGoodProfileListQueryVariables) => variables === undefined ? ['getGoodProfileList'] : ['getGoodProfileList', variables];
;

useGetGoodProfileListQuery.fetcher = (variables?: GetGoodProfileListQueryVariables, options?: RequestInit['headers']) => fetcher<GetGoodProfileListQuery, GetGoodProfileListQueryVariables>(GetGoodProfileListDocument, variables, options);
export const GetGoodProfileDetailsDocument = `
    query getGoodProfileDetails($id: String!) {
  goodProfileById(id: $id) {
    _id
    code
    label
    status
    documents {
      _id
      name
      url
    }
    weight
    liquidGravity
    unit
    productType
    supplierIds
    shipperIds
    color
    goodProfileClassId
    goodProfileClass {
      _id
      label
    }
    equivalences {
      equivalentGoodId
      conditions {
        operator
        target
        value
      }
    }
    restrictions {
      type
      value
    }
    tags
    customFields {
      key
      value
    }
    groupIds
  }
}
    `;
export const useGetGoodProfileDetailsQuery = <
      TData = GetGoodProfileDetailsQuery,
      TError = Exception
    >(
      variables: GetGoodProfileDetailsQueryVariables,
      options?: UseQueryOptions<GetGoodProfileDetailsQuery, TError, TData>
    ) =>
    useQuery<GetGoodProfileDetailsQuery, TError, TData>(
      ['getGoodProfileDetails', variables],
      fetcher<GetGoodProfileDetailsQuery, GetGoodProfileDetailsQueryVariables>(GetGoodProfileDetailsDocument, variables),
      options
    );

useGetGoodProfileDetailsQuery.getKey = (variables: GetGoodProfileDetailsQueryVariables) => ['getGoodProfileDetails', variables];
;

useGetGoodProfileDetailsQuery.fetcher = (variables: GetGoodProfileDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetGoodProfileDetailsQuery, GetGoodProfileDetailsQueryVariables>(GetGoodProfileDetailsDocument, variables, options);
export const DeleteGoodProfileDocument = `
    mutation deleteGoodProfile($id: String!) {
  deleteGoodProfile(id: $id)
}
    `;
export const useDeleteGoodProfileMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGoodProfileMutation, TError, DeleteGoodProfileMutationVariables, TContext>) =>
    useMutation<DeleteGoodProfileMutation, TError, DeleteGoodProfileMutationVariables, TContext>(
      ['deleteGoodProfile'],
      (variables?: DeleteGoodProfileMutationVariables) => fetcher<DeleteGoodProfileMutation, DeleteGoodProfileMutationVariables>(DeleteGoodProfileDocument, variables)(),
      options
    );
useDeleteGoodProfileMutation.getKey = () => ['deleteGoodProfile'];

useDeleteGoodProfileMutation.fetcher = (variables: DeleteGoodProfileMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteGoodProfileMutation, DeleteGoodProfileMutationVariables>(DeleteGoodProfileDocument, variables, options);
export const AddGoodProfileDocument = `
    mutation addGoodProfile($newGoodProfileData: NewGoodProfileInput!) {
  addGoodProfile(newGoodProfileData: $newGoodProfileData) {
    _id
  }
}
    `;
export const useAddGoodProfileMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddGoodProfileMutation, TError, AddGoodProfileMutationVariables, TContext>) =>
    useMutation<AddGoodProfileMutation, TError, AddGoodProfileMutationVariables, TContext>(
      ['addGoodProfile'],
      (variables?: AddGoodProfileMutationVariables) => fetcher<AddGoodProfileMutation, AddGoodProfileMutationVariables>(AddGoodProfileDocument, variables)(),
      options
    );
useAddGoodProfileMutation.getKey = () => ['addGoodProfile'];

useAddGoodProfileMutation.fetcher = (variables: AddGoodProfileMutationVariables, options?: RequestInit['headers']) => fetcher<AddGoodProfileMutation, AddGoodProfileMutationVariables>(AddGoodProfileDocument, variables, options);
export const EditGoodProfileDocument = `
    mutation editGoodProfile($id: String!, $editGoodProfileData: GoodProfileUpdateInput!) {
  editGoodProfile(id: $id, editGoodProfileData: $editGoodProfileData) {
    _id
  }
}
    `;
export const useEditGoodProfileMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditGoodProfileMutation, TError, EditGoodProfileMutationVariables, TContext>) =>
    useMutation<EditGoodProfileMutation, TError, EditGoodProfileMutationVariables, TContext>(
      ['editGoodProfile'],
      (variables?: EditGoodProfileMutationVariables) => fetcher<EditGoodProfileMutation, EditGoodProfileMutationVariables>(EditGoodProfileDocument, variables)(),
      options
    );
useEditGoodProfileMutation.getKey = () => ['editGoodProfile'];

useEditGoodProfileMutation.fetcher = (variables: EditGoodProfileMutationVariables, options?: RequestInit['headers']) => fetcher<EditGoodProfileMutation, EditGoodProfileMutationVariables>(EditGoodProfileDocument, variables, options);
export const BulkAddGoodProfilesDocument = `
    mutation bulkAddGoodProfiles($newGoodProfilesData: [NewGoodProfileInput!]!) {
  bulkAddGoodProfiles(newGoodProfilesData: $newGoodProfilesData) {
    _id
  }
}
    `;
export const useBulkAddGoodProfilesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddGoodProfilesMutation, TError, BulkAddGoodProfilesMutationVariables, TContext>) =>
    useMutation<BulkAddGoodProfilesMutation, TError, BulkAddGoodProfilesMutationVariables, TContext>(
      ['bulkAddGoodProfiles'],
      (variables?: BulkAddGoodProfilesMutationVariables) => fetcher<BulkAddGoodProfilesMutation, BulkAddGoodProfilesMutationVariables>(BulkAddGoodProfilesDocument, variables)(),
      options
    );
useBulkAddGoodProfilesMutation.getKey = () => ['bulkAddGoodProfiles'];

useBulkAddGoodProfilesMutation.fetcher = (variables: BulkAddGoodProfilesMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddGoodProfilesMutation, BulkAddGoodProfilesMutationVariables>(BulkAddGoodProfilesDocument, variables, options);
export const BulkEditGoodProfilesDocument = `
    mutation bulkEditGoodProfiles($editGoodProfileData: GoodProfileUpdateInput!, $ids: [ObjectId!]!) {
  bulkEditGoodProfiles(editGoodProfileData: $editGoodProfileData, ids: $ids) {
    matchedCount
    modifiedCount
    upsertedCount
  }
}
    `;
export const useBulkEditGoodProfilesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkEditGoodProfilesMutation, TError, BulkEditGoodProfilesMutationVariables, TContext>) =>
    useMutation<BulkEditGoodProfilesMutation, TError, BulkEditGoodProfilesMutationVariables, TContext>(
      ['bulkEditGoodProfiles'],
      (variables?: BulkEditGoodProfilesMutationVariables) => fetcher<BulkEditGoodProfilesMutation, BulkEditGoodProfilesMutationVariables>(BulkEditGoodProfilesDocument, variables)(),
      options
    );
useBulkEditGoodProfilesMutation.getKey = () => ['bulkEditGoodProfiles'];

useBulkEditGoodProfilesMutation.fetcher = (variables: BulkEditGoodProfilesMutationVariables, options?: RequestInit['headers']) => fetcher<BulkEditGoodProfilesMutation, BulkEditGoodProfilesMutationVariables>(BulkEditGoodProfilesDocument, variables, options);
export const GetCustomerOrderListDocument = `
    query getCustomerOrderList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  customerOrders(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      orderNumber
      customer {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      shipment {
        _id
        shipmentNumber
        commodityType
        events {
          _id
          coordinates {
            altitude
            heading
            latitude
            longitude
            speed
          }
          createdBy
          date
          shipmentLocation
          type
          label
          description
          metadata
        }
        issues {
          _id
          type
          content
          date
          shipmentLocation
          delayAmount
          attachedDocuments
        }
        constraints {
          type
          value
          unit
        }
        documents {
          _id
          associatedCharge
          accessLevel
          isBillable
          isForRatecons
          isForReceivers
          name
          type
          url
          shipper {
            _id
            name
          }
          receiver {
            _id
            name
          }
        }
        notes {
          _id
          accessLevel
          receiver {
            _id
            name
          }
          shipper {
            _id
            name
          }
          content
        }
        customer {
          _id
          name
          referenceNumberTypes
          address {
            coordinates {
              latitude
              longitude
            }
            label
          }
          contact {
            firstname
            lastname
            phoneNumber
          }
          name
          type
        }
        purchaseOrderNumbers
        billOfLadingNumbers
        referenceNumbers
        purchaseOrderNumbers
        billOfLadingNumbers
        referenceNumbers
        ticketNumbers
        rateConNumbers
        status
        shipmentLocations {
          _id
          name
          addressLabel
          addressTimezone
          addressTimezone
          shipper {
            _id
            name
            address {
              coordinates {
                latitude
                longitude
              }
              label
            }
            addressTimezone
          }
          receiver {
            _id
            name
            address {
              coordinates {
                latitude
                longitude
              }
              label
            }
            addressTimezone
          }
          shippedGoods {
            _id
            quantity
            weight
            label
            unit
            goodProfileId
          }
          receivedGoods {
            goodId
            quantity
          }
          timeWindows {
            fromDate
            toDate
          }
          location {
            latitude
            longitude
          }
          locationType
        }
        constraints {
          type
          value
          unit
        }
        charges {
          _id
          total
          label
          rate
          unit
          unitType
          reimburseToDriver
          relatedTransactionId
          billingRule {
            _id
            label
            referenceNumber
          }
          document {
            name
            url
          }
        }
        expenses {
          _id
          label
          rate
          unit
          unitType
          reimburseToDriver
          document {
            name
            url
          }
          customFields {
            key
            value
          }
        }
        route {
          routeDistance
          firstPickupTime
          predictedLoadedDistance
          locations {
            _id
            shipper {
              _id
            }
            receiver {
              _id
            }
            timeWindows {
              fromDate
              toDate
            }
          }
        }
        createdBy
        trailerType
        additionalTrailerTypes
        loadType
        tripId
        reasonForCancellation
      }
      status
      locations {
        _id
        locationType
        location {
          latitude
          longitude
        }
        name
        addressLabel
        addressTimezone
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        timeWindows {
          fromDate
          toDate
        }
        receivedGoods {
          goodId
          goodProfileId
          goodProfile {
            _id
            label
            code
            unit
            weight
          }
          quantity
        }
      }
    }
    count
  }
}
    `;
export const useGetCustomerOrderListQuery = <
      TData = GetCustomerOrderListQuery,
      TError = Exception
    >(
      variables?: GetCustomerOrderListQueryVariables,
      options?: UseQueryOptions<GetCustomerOrderListQuery, TError, TData>
    ) =>
    useQuery<GetCustomerOrderListQuery, TError, TData>(
      variables === undefined ? ['getCustomerOrderList'] : ['getCustomerOrderList', variables],
      fetcher<GetCustomerOrderListQuery, GetCustomerOrderListQueryVariables>(GetCustomerOrderListDocument, variables),
      options
    );

useGetCustomerOrderListQuery.getKey = (variables?: GetCustomerOrderListQueryVariables) => variables === undefined ? ['getCustomerOrderList'] : ['getCustomerOrderList', variables];
;

useGetCustomerOrderListQuery.fetcher = (variables?: GetCustomerOrderListQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomerOrderListQuery, GetCustomerOrderListQueryVariables>(GetCustomerOrderListDocument, variables, options);
export const GetCustomerShipmentListDocument = `
    query getCustomerShipmentList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $status: Status) {
  customerShipments(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
    status: $status
  ) {
    data {
      _id
      shipmentNumber
      purchaseOrderNumbers
      billOfLadingNumbers
      referenceNumbers
      ticketNumbers
      rateConNumbers
      status
      order {
        _id
        status
        orderNumber
        status
        locations {
          addressLabel
        }
      }
      trailerType
      additionalTrailerTypes
      shipmentLocations {
        _id
        locationType
        timeWindows {
          fromDate
          toDate
        }
        location {
          latitude
          longitude
        }
        receivedGoods {
          goodId
          quantity
        }
        shippedGoods {
          _id
          goodProfileId
          label
          quantity
          unit
          weight
          supplierId
        }
        shipper {
          _id
          name
          addressTimezone
          address {
            label
          }
        }
        receiver {
          _id
          name
          addressTimezone
          address {
            label
          }
        }
      }
      route {
        locations {
          _id
          locationType
          location {
            latitude
            longitude
          }
          name
          addressLabel
          addressTimezone
          shipper {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          receiver {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          timeWindows {
            fromDate
            toDate
          }
        }
        routeDistance
        firstPickupTime
        lastDropoffTime
      }
      charges {
        _id
        rate
        unit
      }
      tripId
      trip {
        _id
        tripNumber
        driver
        tractor
        trailer
        driverEntity {
          _id
          firstname
          lastname
          phoneNumber
          status
        }
        tractorEntity {
          _id
          serialNumber
          licenseNumber
          status
        }
        trailerEntity {
          _id
          serialNumber
          licenseNumber
          status
          type
        }
        carrier
        carrierEntity {
          _id
          name
          contact {
            firstname
            lastname
            phoneNumber
          }
          status
          type
          address {
            label
            coordinates {
              latitude
              longitude
            }
          }
        }
      }
      isSplit
      isFromSplit
      isFromRotation
      parentShipment {
        _id
      }
      tags
      customFields {
        key
        value
      }
      groupIds
    }
    count
  }
}
    `;
export const useGetCustomerShipmentListQuery = <
      TData = GetCustomerShipmentListQuery,
      TError = Exception
    >(
      variables?: GetCustomerShipmentListQueryVariables,
      options?: UseQueryOptions<GetCustomerShipmentListQuery, TError, TData>
    ) =>
    useQuery<GetCustomerShipmentListQuery, TError, TData>(
      variables === undefined ? ['getCustomerShipmentList'] : ['getCustomerShipmentList', variables],
      fetcher<GetCustomerShipmentListQuery, GetCustomerShipmentListQueryVariables>(GetCustomerShipmentListDocument, variables),
      options
    );

useGetCustomerShipmentListQuery.getKey = (variables?: GetCustomerShipmentListQueryVariables) => variables === undefined ? ['getCustomerShipmentList'] : ['getCustomerShipmentList', variables];
;

useGetCustomerShipmentListQuery.fetcher = (variables?: GetCustomerShipmentListQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomerShipmentListQuery, GetCustomerShipmentListQueryVariables>(GetCustomerShipmentListDocument, variables, options);
export const GetCustomerOrderDetailsDocument = `
    query getCustomerOrderDetails($id: String!) {
  customerOrderById(id: $id) {
    _id
    orderNumber
    customerId
    customer {
      _id
      name
      address {
        label
      }
      addressTimezone
    }
    status
    locations {
      _id
      locationType
      location {
        latitude
        longitude
      }
      name
      addressLabel
      addressTimezone
      shipper {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      receiver {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      timeWindows {
        fromDate
        toDate
      }
      receivedGoods {
        goodId
        goodProfileId
        goodProfile {
          _id
          label
          code
          unit
          weight
        }
        quantity
      }
    }
  }
}
    `;
export const useGetCustomerOrderDetailsQuery = <
      TData = GetCustomerOrderDetailsQuery,
      TError = Exception
    >(
      variables: GetCustomerOrderDetailsQueryVariables,
      options?: UseQueryOptions<GetCustomerOrderDetailsQuery, TError, TData>
    ) =>
    useQuery<GetCustomerOrderDetailsQuery, TError, TData>(
      ['getCustomerOrderDetails', variables],
      fetcher<GetCustomerOrderDetailsQuery, GetCustomerOrderDetailsQueryVariables>(GetCustomerOrderDetailsDocument, variables),
      options
    );

useGetCustomerOrderDetailsQuery.getKey = (variables: GetCustomerOrderDetailsQueryVariables) => ['getCustomerOrderDetails', variables];
;

useGetCustomerOrderDetailsQuery.fetcher = (variables: GetCustomerOrderDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomerOrderDetailsQuery, GetCustomerOrderDetailsQueryVariables>(GetCustomerOrderDetailsDocument, variables, options);
export const DeleteCustomerOrderDocument = `
    mutation deleteCustomerOrder($id: String!) {
  deleteCustomerOrder(id: $id)
}
    `;
export const useDeleteCustomerOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomerOrderMutation, TError, DeleteCustomerOrderMutationVariables, TContext>) =>
    useMutation<DeleteCustomerOrderMutation, TError, DeleteCustomerOrderMutationVariables, TContext>(
      ['deleteCustomerOrder'],
      (variables?: DeleteCustomerOrderMutationVariables) => fetcher<DeleteCustomerOrderMutation, DeleteCustomerOrderMutationVariables>(DeleteCustomerOrderDocument, variables)(),
      options
    );
useDeleteCustomerOrderMutation.getKey = () => ['deleteCustomerOrder'];

useDeleteCustomerOrderMutation.fetcher = (variables: DeleteCustomerOrderMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteCustomerOrderMutation, DeleteCustomerOrderMutationVariables>(DeleteCustomerOrderDocument, variables, options);
export const AddCustomerOrderDocument = `
    mutation addCustomerOrder($newOrderData: NewOrderInput!) {
  addCustomerOrder(newOrderData: $newOrderData) {
    _id
  }
}
    `;
export const useAddCustomerOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddCustomerOrderMutation, TError, AddCustomerOrderMutationVariables, TContext>) =>
    useMutation<AddCustomerOrderMutation, TError, AddCustomerOrderMutationVariables, TContext>(
      ['addCustomerOrder'],
      (variables?: AddCustomerOrderMutationVariables) => fetcher<AddCustomerOrderMutation, AddCustomerOrderMutationVariables>(AddCustomerOrderDocument, variables)(),
      options
    );
useAddCustomerOrderMutation.getKey = () => ['addCustomerOrder'];

useAddCustomerOrderMutation.fetcher = (variables: AddCustomerOrderMutationVariables, options?: RequestInit['headers']) => fetcher<AddCustomerOrderMutation, AddCustomerOrderMutationVariables>(AddCustomerOrderDocument, variables, options);
export const EditCustomerOrderDocument = `
    mutation editCustomerOrder($id: String!, $editOrderData: OrderUpdateInput!) {
  editCustomerOrder(id: $id, editOrderData: $editOrderData) {
    _id
  }
}
    `;
export const useEditCustomerOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditCustomerOrderMutation, TError, EditCustomerOrderMutationVariables, TContext>) =>
    useMutation<EditCustomerOrderMutation, TError, EditCustomerOrderMutationVariables, TContext>(
      ['editCustomerOrder'],
      (variables?: EditCustomerOrderMutationVariables) => fetcher<EditCustomerOrderMutation, EditCustomerOrderMutationVariables>(EditCustomerOrderDocument, variables)(),
      options
    );
useEditCustomerOrderMutation.getKey = () => ['editCustomerOrder'];

useEditCustomerOrderMutation.fetcher = (variables: EditCustomerOrderMutationVariables, options?: RequestInit['headers']) => fetcher<EditCustomerOrderMutation, EditCustomerOrderMutationVariables>(EditCustomerOrderDocument, variables, options);
export const ListOrganizationsDocument = `
    query listOrganizations {
  organizations {
    _id
    _organization
    name
    dotNumber
  }
}
    `;
export const useListOrganizationsQuery = <
      TData = ListOrganizationsQuery,
      TError = Exception
    >(
      variables?: ListOrganizationsQueryVariables,
      options?: UseQueryOptions<ListOrganizationsQuery, TError, TData>
    ) =>
    useQuery<ListOrganizationsQuery, TError, TData>(
      variables === undefined ? ['listOrganizations'] : ['listOrganizations', variables],
      fetcher<ListOrganizationsQuery, ListOrganizationsQueryVariables>(ListOrganizationsDocument, variables),
      options
    );

useListOrganizationsQuery.getKey = (variables?: ListOrganizationsQueryVariables) => variables === undefined ? ['listOrganizations'] : ['listOrganizations', variables];
;

useListOrganizationsQuery.fetcher = (variables?: ListOrganizationsQueryVariables, options?: RequestInit['headers']) => fetcher<ListOrganizationsQuery, ListOrganizationsQueryVariables>(ListOrganizationsDocument, variables, options);
export const OrganizationsForStageDocument = `
    query organizationsForStage($stage: String!) {
  organizationsForStage(stage: $stage) {
    _id
    _organization
    name
    dotNumber
  }
}
    `;
export const useOrganizationsForStageQuery = <
      TData = OrganizationsForStageQuery,
      TError = Exception
    >(
      variables: OrganizationsForStageQueryVariables,
      options?: UseQueryOptions<OrganizationsForStageQuery, TError, TData>
    ) =>
    useQuery<OrganizationsForStageQuery, TError, TData>(
      ['organizationsForStage', variables],
      fetcher<OrganizationsForStageQuery, OrganizationsForStageQueryVariables>(OrganizationsForStageDocument, variables),
      options
    );

useOrganizationsForStageQuery.getKey = (variables: OrganizationsForStageQueryVariables) => ['organizationsForStage', variables];
;

useOrganizationsForStageQuery.fetcher = (variables: OrganizationsForStageQueryVariables, options?: RequestInit['headers']) => fetcher<OrganizationsForStageQuery, OrganizationsForStageQueryVariables>(OrganizationsForStageDocument, variables, options);
export const TransferOrganizationDataDocument = `
    mutation transferOrganizationData($input: TransferOrganizationDataInput!) {
  transferOrganizationData(input: $input) {
    success
    message
    transferredCollections {
      collectionName
      recordCount
      success
      error
    }
    totalRecordsTransferred
    duration
    timestamp
  }
}
    `;
export const useTransferOrganizationDataMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<TransferOrganizationDataMutation, TError, TransferOrganizationDataMutationVariables, TContext>) =>
    useMutation<TransferOrganizationDataMutation, TError, TransferOrganizationDataMutationVariables, TContext>(
      ['transferOrganizationData'],
      (variables?: TransferOrganizationDataMutationVariables) => fetcher<TransferOrganizationDataMutation, TransferOrganizationDataMutationVariables>(TransferOrganizationDataDocument, variables)(),
      options
    );
useTransferOrganizationDataMutation.getKey = () => ['transferOrganizationData'];

useTransferOrganizationDataMutation.fetcher = (variables: TransferOrganizationDataMutationVariables, options?: RequestInit['headers']) => fetcher<TransferOrganizationDataMutation, TransferOrganizationDataMutationVariables>(TransferOrganizationDataDocument, variables, options);
export const GetDriverShiftAssignmentsDocument = `
    query getDriverShiftAssignments($filter: JSON) {
  driverShiftAssignments(filter: $filter) {
    data {
      _id
      driverId
      driverShiftId
      driver {
        _id
        firstname
        lastname
        domicileEntity {
          _id
          name
          addressTimezone
        }
      }
      driverShift {
        _id
        label
      }
      startDate
      endDate
    }
    count
  }
}
    `;
export const useGetDriverShiftAssignmentsQuery = <
      TData = GetDriverShiftAssignmentsQuery,
      TError = Exception
    >(
      variables?: GetDriverShiftAssignmentsQueryVariables,
      options?: UseQueryOptions<GetDriverShiftAssignmentsQuery, TError, TData>
    ) =>
    useQuery<GetDriverShiftAssignmentsQuery, TError, TData>(
      variables === undefined ? ['getDriverShiftAssignments'] : ['getDriverShiftAssignments', variables],
      fetcher<GetDriverShiftAssignmentsQuery, GetDriverShiftAssignmentsQueryVariables>(GetDriverShiftAssignmentsDocument, variables),
      options
    );

useGetDriverShiftAssignmentsQuery.getKey = (variables?: GetDriverShiftAssignmentsQueryVariables) => variables === undefined ? ['getDriverShiftAssignments'] : ['getDriverShiftAssignments', variables];
;

useGetDriverShiftAssignmentsQuery.fetcher = (variables?: GetDriverShiftAssignmentsQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverShiftAssignmentsQuery, GetDriverShiftAssignmentsQueryVariables>(GetDriverShiftAssignmentsDocument, variables, options);
export const GetDriverShiftAssignmentDetailsDocument = `
    query getDriverShiftAssignmentDetails($id: String!) {
  driverShiftAssignment: driverShiftAssignmentById(id: $id) {
    _id
    driverId
    driverShiftId
    driver {
      _id
      firstname
      lastname
    }
    driverShift {
      _id
      label
    }
    startDate
    endDate
  }
}
    `;
export const useGetDriverShiftAssignmentDetailsQuery = <
      TData = GetDriverShiftAssignmentDetailsQuery,
      TError = Exception
    >(
      variables: GetDriverShiftAssignmentDetailsQueryVariables,
      options?: UseQueryOptions<GetDriverShiftAssignmentDetailsQuery, TError, TData>
    ) =>
    useQuery<GetDriverShiftAssignmentDetailsQuery, TError, TData>(
      ['getDriverShiftAssignmentDetails', variables],
      fetcher<GetDriverShiftAssignmentDetailsQuery, GetDriverShiftAssignmentDetailsQueryVariables>(GetDriverShiftAssignmentDetailsDocument, variables),
      options
    );

useGetDriverShiftAssignmentDetailsQuery.getKey = (variables: GetDriverShiftAssignmentDetailsQueryVariables) => ['getDriverShiftAssignmentDetails', variables];
;

useGetDriverShiftAssignmentDetailsQuery.fetcher = (variables: GetDriverShiftAssignmentDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverShiftAssignmentDetailsQuery, GetDriverShiftAssignmentDetailsQueryVariables>(GetDriverShiftAssignmentDetailsDocument, variables, options);
export const AddDriverShiftAssignmentDocument = `
    mutation addDriverShiftAssignment($newDriverShiftAssignmentData: NewDriverShiftAssignmentInput!) {
  addDriverShiftAssignment(
    newDriverShiftAssignmentData: $newDriverShiftAssignmentData
  ) {
    _id
  }
}
    `;
export const useAddDriverShiftAssignmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddDriverShiftAssignmentMutation, TError, AddDriverShiftAssignmentMutationVariables, TContext>) =>
    useMutation<AddDriverShiftAssignmentMutation, TError, AddDriverShiftAssignmentMutationVariables, TContext>(
      ['addDriverShiftAssignment'],
      (variables?: AddDriverShiftAssignmentMutationVariables) => fetcher<AddDriverShiftAssignmentMutation, AddDriverShiftAssignmentMutationVariables>(AddDriverShiftAssignmentDocument, variables)(),
      options
    );
useAddDriverShiftAssignmentMutation.getKey = () => ['addDriverShiftAssignment'];

useAddDriverShiftAssignmentMutation.fetcher = (variables: AddDriverShiftAssignmentMutationVariables, options?: RequestInit['headers']) => fetcher<AddDriverShiftAssignmentMutation, AddDriverShiftAssignmentMutationVariables>(AddDriverShiftAssignmentDocument, variables, options);
export const EditDriverShiftAssignmentDocument = `
    mutation editDriverShiftAssignment($id: String!, $editDriverShiftAssignmentData: DriverShiftAssignmentUpdateInput!) {
  editDriverShiftAssignment(
    id: $id
    editDriverShiftAssignmentData: $editDriverShiftAssignmentData
  ) {
    _id
  }
}
    `;
export const useEditDriverShiftAssignmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditDriverShiftAssignmentMutation, TError, EditDriverShiftAssignmentMutationVariables, TContext>) =>
    useMutation<EditDriverShiftAssignmentMutation, TError, EditDriverShiftAssignmentMutationVariables, TContext>(
      ['editDriverShiftAssignment'],
      (variables?: EditDriverShiftAssignmentMutationVariables) => fetcher<EditDriverShiftAssignmentMutation, EditDriverShiftAssignmentMutationVariables>(EditDriverShiftAssignmentDocument, variables)(),
      options
    );
useEditDriverShiftAssignmentMutation.getKey = () => ['editDriverShiftAssignment'];

useEditDriverShiftAssignmentMutation.fetcher = (variables: EditDriverShiftAssignmentMutationVariables, options?: RequestInit['headers']) => fetcher<EditDriverShiftAssignmentMutation, EditDriverShiftAssignmentMutationVariables>(EditDriverShiftAssignmentDocument, variables, options);
export const DeleteDriverShiftAssignmentDocument = `
    mutation deleteDriverShiftAssignment($id: String!) {
  deleteDriverShiftAssignment(id: $id)
}
    `;
export const useDeleteDriverShiftAssignmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDriverShiftAssignmentMutation, TError, DeleteDriverShiftAssignmentMutationVariables, TContext>) =>
    useMutation<DeleteDriverShiftAssignmentMutation, TError, DeleteDriverShiftAssignmentMutationVariables, TContext>(
      ['deleteDriverShiftAssignment'],
      (variables?: DeleteDriverShiftAssignmentMutationVariables) => fetcher<DeleteDriverShiftAssignmentMutation, DeleteDriverShiftAssignmentMutationVariables>(DeleteDriverShiftAssignmentDocument, variables)(),
      options
    );
useDeleteDriverShiftAssignmentMutation.getKey = () => ['deleteDriverShiftAssignment'];

useDeleteDriverShiftAssignmentMutation.fetcher = (variables: DeleteDriverShiftAssignmentMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteDriverShiftAssignmentMutation, DeleteDriverShiftAssignmentMutationVariables>(DeleteDriverShiftAssignmentDocument, variables, options);
export const GetDriverShiftListDocument = `
    query getDriverShiftList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  driverShifts(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      label
      days
      startTime {
        hour
        minute
      }
      endTime {
        hour
        minute
      }
      driverIds
      domicileId
      domicile {
        _id
        name
      }
      isAdhoc
    }
    count
  }
}
    `;
export const useGetDriverShiftListQuery = <
      TData = GetDriverShiftListQuery,
      TError = Exception
    >(
      variables?: GetDriverShiftListQueryVariables,
      options?: UseQueryOptions<GetDriverShiftListQuery, TError, TData>
    ) =>
    useQuery<GetDriverShiftListQuery, TError, TData>(
      variables === undefined ? ['getDriverShiftList'] : ['getDriverShiftList', variables],
      fetcher<GetDriverShiftListQuery, GetDriverShiftListQueryVariables>(GetDriverShiftListDocument, variables),
      options
    );

useGetDriverShiftListQuery.getKey = (variables?: GetDriverShiftListQueryVariables) => variables === undefined ? ['getDriverShiftList'] : ['getDriverShiftList', variables];
;

useGetDriverShiftListQuery.fetcher = (variables?: GetDriverShiftListQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverShiftListQuery, GetDriverShiftListQueryVariables>(GetDriverShiftListDocument, variables, options);
export const GetDriverShiftDetailsDocument = `
    query getDriverShiftDetails($id: String!) {
  driverShiftById(id: $id) {
    _id
    label
    days
    startTime {
      hour
      minute
    }
    endTime {
      hour
      minute
    }
    driverIds
    domicileId
    isAdhoc
  }
}
    `;
export const useGetDriverShiftDetailsQuery = <
      TData = GetDriverShiftDetailsQuery,
      TError = Exception
    >(
      variables: GetDriverShiftDetailsQueryVariables,
      options?: UseQueryOptions<GetDriverShiftDetailsQuery, TError, TData>
    ) =>
    useQuery<GetDriverShiftDetailsQuery, TError, TData>(
      ['getDriverShiftDetails', variables],
      fetcher<GetDriverShiftDetailsQuery, GetDriverShiftDetailsQueryVariables>(GetDriverShiftDetailsDocument, variables),
      options
    );

useGetDriverShiftDetailsQuery.getKey = (variables: GetDriverShiftDetailsQueryVariables) => ['getDriverShiftDetails', variables];
;

useGetDriverShiftDetailsQuery.fetcher = (variables: GetDriverShiftDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverShiftDetailsQuery, GetDriverShiftDetailsQueryVariables>(GetDriverShiftDetailsDocument, variables, options);
export const GetDriverShiftDetailsForDriverDocument = `
    query getDriverShiftDetailsForDriver($id: ObjectId!) {
  driverShiftByDriverId(driverId: $id) {
    _id
    days
    label
    startTime {
      hour
      minute
    }
    endTime {
      hour
      minute
    }
    driverIds
    domicileId
    isAdhoc
  }
}
    `;
export const useGetDriverShiftDetailsForDriverQuery = <
      TData = GetDriverShiftDetailsForDriverQuery,
      TError = Exception
    >(
      variables: GetDriverShiftDetailsForDriverQueryVariables,
      options?: UseQueryOptions<GetDriverShiftDetailsForDriverQuery, TError, TData>
    ) =>
    useQuery<GetDriverShiftDetailsForDriverQuery, TError, TData>(
      ['getDriverShiftDetailsForDriver', variables],
      fetcher<GetDriverShiftDetailsForDriverQuery, GetDriverShiftDetailsForDriverQueryVariables>(GetDriverShiftDetailsForDriverDocument, variables),
      options
    );

useGetDriverShiftDetailsForDriverQuery.getKey = (variables: GetDriverShiftDetailsForDriverQueryVariables) => ['getDriverShiftDetailsForDriver', variables];
;

useGetDriverShiftDetailsForDriverQuery.fetcher = (variables: GetDriverShiftDetailsForDriverQueryVariables, options?: RequestInit['headers']) => fetcher<GetDriverShiftDetailsForDriverQuery, GetDriverShiftDetailsForDriverQueryVariables>(GetDriverShiftDetailsForDriverDocument, variables, options);
export const AddDriverShiftDocument = `
    mutation addDriverShift($newDriverShiftData: NewDriverShiftInput!) {
  addDriverShift(newDriverShiftData: $newDriverShiftData) {
    _id
  }
}
    `;
export const useAddDriverShiftMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddDriverShiftMutation, TError, AddDriverShiftMutationVariables, TContext>) =>
    useMutation<AddDriverShiftMutation, TError, AddDriverShiftMutationVariables, TContext>(
      ['addDriverShift'],
      (variables?: AddDriverShiftMutationVariables) => fetcher<AddDriverShiftMutation, AddDriverShiftMutationVariables>(AddDriverShiftDocument, variables)(),
      options
    );
useAddDriverShiftMutation.getKey = () => ['addDriverShift'];

useAddDriverShiftMutation.fetcher = (variables: AddDriverShiftMutationVariables, options?: RequestInit['headers']) => fetcher<AddDriverShiftMutation, AddDriverShiftMutationVariables>(AddDriverShiftDocument, variables, options);
export const EditDriverShiftDocument = `
    mutation editDriverShift($id: String!, $editDriverShiftData: DriverShiftUpdateInput!) {
  editDriverShift(id: $id, editDriverShiftData: $editDriverShiftData) {
    _id
  }
}
    `;
export const useEditDriverShiftMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditDriverShiftMutation, TError, EditDriverShiftMutationVariables, TContext>) =>
    useMutation<EditDriverShiftMutation, TError, EditDriverShiftMutationVariables, TContext>(
      ['editDriverShift'],
      (variables?: EditDriverShiftMutationVariables) => fetcher<EditDriverShiftMutation, EditDriverShiftMutationVariables>(EditDriverShiftDocument, variables)(),
      options
    );
useEditDriverShiftMutation.getKey = () => ['editDriverShift'];

useEditDriverShiftMutation.fetcher = (variables: EditDriverShiftMutationVariables, options?: RequestInit['headers']) => fetcher<EditDriverShiftMutation, EditDriverShiftMutationVariables>(EditDriverShiftDocument, variables, options);
export const DeleteDriverShiftDocument = `
    mutation deleteDriverShift($id: String!) {
  deleteDriverShift(id: $id)
}
    `;
export const useDeleteDriverShiftMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDriverShiftMutation, TError, DeleteDriverShiftMutationVariables, TContext>) =>
    useMutation<DeleteDriverShiftMutation, TError, DeleteDriverShiftMutationVariables, TContext>(
      ['deleteDriverShift'],
      (variables?: DeleteDriverShiftMutationVariables) => fetcher<DeleteDriverShiftMutation, DeleteDriverShiftMutationVariables>(DeleteDriverShiftDocument, variables)(),
      options
    );
useDeleteDriverShiftMutation.getKey = () => ['deleteDriverShift'];

useDeleteDriverShiftMutation.fetcher = (variables: DeleteDriverShiftMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteDriverShiftMutation, DeleteDriverShiftMutationVariables>(DeleteDriverShiftDocument, variables, options);
export const GetAllDriversAndShiftsDocument = `
    query getAllDriversAndShifts {
  drivers {
    data {
      _id
      firstname
      lastname
      phoneNumber
      domicileId
    }
  }
  driverShifts {
    data {
      _id
      label
      days
      startTime {
        hour
        minute
      }
      endTime {
        hour
        minute
      }
      days
      driverIds
      domicileId
      isAdhoc
    }
  }
}
    `;
export const useGetAllDriversAndShiftsQuery = <
      TData = GetAllDriversAndShiftsQuery,
      TError = Exception
    >(
      variables?: GetAllDriversAndShiftsQueryVariables,
      options?: UseQueryOptions<GetAllDriversAndShiftsQuery, TError, TData>
    ) =>
    useQuery<GetAllDriversAndShiftsQuery, TError, TData>(
      variables === undefined ? ['getAllDriversAndShifts'] : ['getAllDriversAndShifts', variables],
      fetcher<GetAllDriversAndShiftsQuery, GetAllDriversAndShiftsQueryVariables>(GetAllDriversAndShiftsDocument, variables),
      options
    );

useGetAllDriversAndShiftsQuery.getKey = (variables?: GetAllDriversAndShiftsQueryVariables) => variables === undefined ? ['getAllDriversAndShifts'] : ['getAllDriversAndShifts', variables];
;

useGetAllDriversAndShiftsQuery.fetcher = (variables?: GetAllDriversAndShiftsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllDriversAndShiftsQuery, GetAllDriversAndShiftsQueryVariables>(GetAllDriversAndShiftsDocument, variables, options);
export const GetAllDriverShiftsDocument = `
    query getAllDriverShifts {
  driverShifts {
    data {
      _id
      label
      days
      startTime {
        hour
        minute
      }
      endTime {
        hour
        minute
      }
      days
      driverIds
      domicileId
      domicile {
        addressTimezone
      }
      isAdhoc
    }
  }
}
    `;
export const useGetAllDriverShiftsQuery = <
      TData = GetAllDriverShiftsQuery,
      TError = Exception
    >(
      variables?: GetAllDriverShiftsQueryVariables,
      options?: UseQueryOptions<GetAllDriverShiftsQuery, TError, TData>
    ) =>
    useQuery<GetAllDriverShiftsQuery, TError, TData>(
      variables === undefined ? ['getAllDriverShifts'] : ['getAllDriverShifts', variables],
      fetcher<GetAllDriverShiftsQuery, GetAllDriverShiftsQueryVariables>(GetAllDriverShiftsDocument, variables),
      options
    );

useGetAllDriverShiftsQuery.getKey = (variables?: GetAllDriverShiftsQueryVariables) => variables === undefined ? ['getAllDriverShifts'] : ['getAllDriverShifts', variables];
;

useGetAllDriverShiftsQuery.fetcher = (variables?: GetAllDriverShiftsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllDriverShiftsQuery, GetAllDriverShiftsQueryVariables>(GetAllDriverShiftsDocument, variables, options);
export const GetExtensionsDocument = `
    query getExtensions($filter: JSON) {
  extensions(filter: $filter) {
    data {
      extension {
        _id
        name
        description
        coverImage
        websiteUrl
        configurationDefinitions {
          name
          description
          type
          defaultValue
          required
        }
        settings {
          rootUrl
          configureEndpoint
        }
      }
      installed
    }
  }
}
    `;
export const useGetExtensionsQuery = <
      TData = GetExtensionsQuery,
      TError = Exception
    >(
      variables?: GetExtensionsQueryVariables,
      options?: UseQueryOptions<GetExtensionsQuery, TError, TData>
    ) =>
    useQuery<GetExtensionsQuery, TError, TData>(
      variables === undefined ? ['getExtensions'] : ['getExtensions', variables],
      fetcher<GetExtensionsQuery, GetExtensionsQueryVariables>(GetExtensionsDocument, variables),
      options
    );

useGetExtensionsQuery.getKey = (variables?: GetExtensionsQueryVariables) => variables === undefined ? ['getExtensions'] : ['getExtensions', variables];
;

useGetExtensionsQuery.fetcher = (variables?: GetExtensionsQueryVariables, options?: RequestInit['headers']) => fetcher<GetExtensionsQuery, GetExtensionsQueryVariables>(GetExtensionsDocument, variables, options);
export const InstallExtensionDocument = `
    mutation installExtension($extensionId: String!, $configurationValues: [ExtensionConfigurationValueInput!]!) {
  installExtension(
    extensionId: $extensionId
    configurationValues: $configurationValues
  ) {
    configurationValues {
      name
      value
    }
    redirectUrl
  }
}
    `;
export const useInstallExtensionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<InstallExtensionMutation, TError, InstallExtensionMutationVariables, TContext>) =>
    useMutation<InstallExtensionMutation, TError, InstallExtensionMutationVariables, TContext>(
      ['installExtension'],
      (variables?: InstallExtensionMutationVariables) => fetcher<InstallExtensionMutation, InstallExtensionMutationVariables>(InstallExtensionDocument, variables)(),
      options
    );
useInstallExtensionMutation.getKey = () => ['installExtension'];

useInstallExtensionMutation.fetcher = (variables: InstallExtensionMutationVariables, options?: RequestInit['headers']) => fetcher<InstallExtensionMutation, InstallExtensionMutationVariables>(InstallExtensionDocument, variables, options);
export const UninstallExtensionDocument = `
    mutation uninstallExtension($extensionId: String!) {
  uninstallExtension(extensionId: $extensionId)
}
    `;
export const useUninstallExtensionMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UninstallExtensionMutation, TError, UninstallExtensionMutationVariables, TContext>) =>
    useMutation<UninstallExtensionMutation, TError, UninstallExtensionMutationVariables, TContext>(
      ['uninstallExtension'],
      (variables?: UninstallExtensionMutationVariables) => fetcher<UninstallExtensionMutation, UninstallExtensionMutationVariables>(UninstallExtensionDocument, variables)(),
      options
    );
useUninstallExtensionMutation.getKey = () => ['uninstallExtension'];

useUninstallExtensionMutation.fetcher = (variables: UninstallExtensionMutationVariables, options?: RequestInit['headers']) => fetcher<UninstallExtensionMutation, UninstallExtensionMutationVariables>(UninstallExtensionDocument, variables, options);
export const GetExtensionsMessagesDocument = `
    query getExtensionsMessages {
  extensionsMessages {
    text
    type
    extensionId
    extensionName
    context
    actions {
      text
      type
      url
    }
  }
}
    `;
export const useGetExtensionsMessagesQuery = <
      TData = GetExtensionsMessagesQuery,
      TError = Exception
    >(
      variables?: GetExtensionsMessagesQueryVariables,
      options?: UseQueryOptions<GetExtensionsMessagesQuery, TError, TData>
    ) =>
    useQuery<GetExtensionsMessagesQuery, TError, TData>(
      variables === undefined ? ['getExtensionsMessages'] : ['getExtensionsMessages', variables],
      fetcher<GetExtensionsMessagesQuery, GetExtensionsMessagesQueryVariables>(GetExtensionsMessagesDocument, variables),
      options
    );

useGetExtensionsMessagesQuery.getKey = (variables?: GetExtensionsMessagesQueryVariables) => variables === undefined ? ['getExtensionsMessages'] : ['getExtensionsMessages', variables];
;

useGetExtensionsMessagesQuery.fetcher = (variables?: GetExtensionsMessagesQueryVariables, options?: RequestInit['headers']) => fetcher<GetExtensionsMessagesQuery, GetExtensionsMessagesQueryVariables>(GetExtensionsMessagesDocument, variables, options);
export const GetExtensionsOperationsDocument = `
    query getExtensionsOperations($context: ExtensionOperationContext!) {
  extensionsOperations(context: $context) {
    key
    name
    description
    icon
    extensionId
    filter
    context
    endpoint
  }
}
    `;
export const useGetExtensionsOperationsQuery = <
      TData = GetExtensionsOperationsQuery,
      TError = Exception
    >(
      variables: GetExtensionsOperationsQueryVariables,
      options?: UseQueryOptions<GetExtensionsOperationsQuery, TError, TData>
    ) =>
    useQuery<GetExtensionsOperationsQuery, TError, TData>(
      ['getExtensionsOperations', variables],
      fetcher<GetExtensionsOperationsQuery, GetExtensionsOperationsQueryVariables>(GetExtensionsOperationsDocument, variables),
      options
    );

useGetExtensionsOperationsQuery.getKey = (variables: GetExtensionsOperationsQueryVariables) => ['getExtensionsOperations', variables];
;

useGetExtensionsOperationsQuery.fetcher = (variables: GetExtensionsOperationsQueryVariables, options?: RequestInit['headers']) => fetcher<GetExtensionsOperationsQuery, GetExtensionsOperationsQueryVariables>(GetExtensionsOperationsDocument, variables, options);
export const GetExtensionsWidgetsDocument = `
    query getExtensionsWidgets($context: ExtensionWidgetContext!) {
  extensionsWidgets(context: $context) {
    label
    endpoint
    rootUrl
  }
}
    `;
export const useGetExtensionsWidgetsQuery = <
      TData = GetExtensionsWidgetsQuery,
      TError = Exception
    >(
      variables: GetExtensionsWidgetsQueryVariables,
      options?: UseQueryOptions<GetExtensionsWidgetsQuery, TError, TData>
    ) =>
    useQuery<GetExtensionsWidgetsQuery, TError, TData>(
      ['getExtensionsWidgets', variables],
      fetcher<GetExtensionsWidgetsQuery, GetExtensionsWidgetsQueryVariables>(GetExtensionsWidgetsDocument, variables),
      options
    );

useGetExtensionsWidgetsQuery.getKey = (variables: GetExtensionsWidgetsQueryVariables) => ['getExtensionsWidgets', variables];
;

useGetExtensionsWidgetsQuery.fetcher = (variables: GetExtensionsWidgetsQueryVariables, options?: RequestInit['headers']) => fetcher<GetExtensionsWidgetsQuery, GetExtensionsWidgetsQueryVariables>(GetExtensionsWidgetsDocument, variables, options);
export const CallExtensionOperationDocument = `
    mutation callExtensionOperation($extensionId: String!, $operationKey: String!, $recordId: String!) {
  callExtensionOperation(
    extensionId: $extensionId
    operationKey: $operationKey
    recordId: $recordId
  ) {
    message
    redirect
    openNewWindow
  }
}
    `;
export const useCallExtensionOperationMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CallExtensionOperationMutation, TError, CallExtensionOperationMutationVariables, TContext>) =>
    useMutation<CallExtensionOperationMutation, TError, CallExtensionOperationMutationVariables, TContext>(
      ['callExtensionOperation'],
      (variables?: CallExtensionOperationMutationVariables) => fetcher<CallExtensionOperationMutation, CallExtensionOperationMutationVariables>(CallExtensionOperationDocument, variables)(),
      options
    );
useCallExtensionOperationMutation.getKey = () => ['callExtensionOperation'];

useCallExtensionOperationMutation.fetcher = (variables: CallExtensionOperationMutationVariables, options?: RequestInit['headers']) => fetcher<CallExtensionOperationMutation, CallExtensionOperationMutationVariables>(CallExtensionOperationDocument, variables, options);
export const CallBulkExtensionOperationDocument = `
    mutation callBulkExtensionOperation($extensionId: String!, $operationKey: String!, $recordIds: [String!]!) {
  callBulkExtensionOperation(
    extensionId: $extensionId
    operationKey: $operationKey
    recordIds: $recordIds
  ) {
    results {
      recordId
      success
      message
      error
    }
    totalProcessed
    successCount
    failureCount
    message
  }
}
    `;
export const useCallBulkExtensionOperationMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CallBulkExtensionOperationMutation, TError, CallBulkExtensionOperationMutationVariables, TContext>) =>
    useMutation<CallBulkExtensionOperationMutation, TError, CallBulkExtensionOperationMutationVariables, TContext>(
      ['callBulkExtensionOperation'],
      (variables?: CallBulkExtensionOperationMutationVariables) => fetcher<CallBulkExtensionOperationMutation, CallBulkExtensionOperationMutationVariables>(CallBulkExtensionOperationDocument, variables)(),
      options
    );
useCallBulkExtensionOperationMutation.getKey = () => ['callBulkExtensionOperation'];

useCallBulkExtensionOperationMutation.fetcher = (variables: CallBulkExtensionOperationMutationVariables, options?: RequestInit['headers']) => fetcher<CallBulkExtensionOperationMutation, CallBulkExtensionOperationMutationVariables>(CallBulkExtensionOperationDocument, variables, options);
export const GetExtensionsUiComponentsDocument = `
    query getExtensionsUIComponents($type: ExtensionUIComponentType!) {
  extensionsUIComponents(type: $type) {
    extensionId
    type
    rootUrl
    endpoint
  }
}
    `;
export const useGetExtensionsUiComponentsQuery = <
      TData = GetExtensionsUiComponentsQuery,
      TError = Exception
    >(
      variables: GetExtensionsUiComponentsQueryVariables,
      options?: UseQueryOptions<GetExtensionsUiComponentsQuery, TError, TData>
    ) =>
    useQuery<GetExtensionsUiComponentsQuery, TError, TData>(
      ['getExtensionsUIComponents', variables],
      fetcher<GetExtensionsUiComponentsQuery, GetExtensionsUiComponentsQueryVariables>(GetExtensionsUiComponentsDocument, variables),
      options
    );

useGetExtensionsUiComponentsQuery.getKey = (variables: GetExtensionsUiComponentsQueryVariables) => ['getExtensionsUIComponents', variables];
;

useGetExtensionsUiComponentsQuery.fetcher = (variables: GetExtensionsUiComponentsQueryVariables, options?: RequestInit['headers']) => fetcher<GetExtensionsUiComponentsQuery, GetExtensionsUiComponentsQueryVariables>(GetExtensionsUiComponentsDocument, variables, options);
export const ForecastDocument = `
    mutation forecast($payload: ForecastingPayload!) {
  forecast(payload: $payload) {
    shipments {
      _id
      status
      createdBy
      customer {
        _id
        name
        code
        referenceNumberTypes
        address {
          coordinates {
            latitude
            longitude
          }
          label
        }
        contact {
          firstname
          lastname
          phoneNumber
        }
        type
      }
      shipmentNumber
      loadType
      commodityType
      shipmentLocations {
        _id
        timeWindows {
          fromDate
          toDate
        }
        addressLabel
        addressTimezone
        location {
          latitude
          longitude
          altitude
        }
        locationType
        name
        shippedGoods {
          _id
          goodProfileId
          label
          quantity
          unit
          weight
          pinCode
        }
        receivedGoods {
          goodId
          goodProfileId
          quantity
          shipperId
          supplierId
          unitPrice
          pinCode
          storageFacilityId
        }
        shipper {
          _id
          name
          code
          address {
            coordinates {
              latitude
              longitude
            }
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          code
          address {
            coordinates {
              latitude
              longitude
            }
            label
          }
          addressTimezone
        }
      }
      trailerType
      charges {
        _id
        total
        label
        rate
        unit
        unitType
      }
      route {
        routeDistance
        locations {
          _id
          locationType
          location {
            latitude
            longitude
          }
          name
          addressLabel
          addressTimezone
          shipper {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          receiver {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          timeWindows {
            fromDate
            toDate
          }
        }
        firstPickupTime
        lastDropoffTime
      }
    }
  }
}
    `;
export const useForecastMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ForecastMutation, TError, ForecastMutationVariables, TContext>) =>
    useMutation<ForecastMutation, TError, ForecastMutationVariables, TContext>(
      ['forecast'],
      (variables?: ForecastMutationVariables) => fetcher<ForecastMutation, ForecastMutationVariables>(ForecastDocument, variables)(),
      options
    );
useForecastMutation.getKey = () => ['forecast'];

useForecastMutation.fetcher = (variables: ForecastMutationVariables, options?: RequestInit['headers']) => fetcher<ForecastMutation, ForecastMutationVariables>(ForecastDocument, variables, options);
export const PurgeForecastedOrdersDocument = `
    mutation purgeForecastedOrders($receiverId: ObjectId!) {
  purgeForecastedOrders(receiverId: $receiverId)
}
    `;
export const usePurgeForecastedOrdersMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<PurgeForecastedOrdersMutation, TError, PurgeForecastedOrdersMutationVariables, TContext>) =>
    useMutation<PurgeForecastedOrdersMutation, TError, PurgeForecastedOrdersMutationVariables, TContext>(
      ['purgeForecastedOrders'],
      (variables?: PurgeForecastedOrdersMutationVariables) => fetcher<PurgeForecastedOrdersMutation, PurgeForecastedOrdersMutationVariables>(PurgeForecastedOrdersDocument, variables)(),
      options
    );
usePurgeForecastedOrdersMutation.getKey = () => ['purgeForecastedOrders'];

usePurgeForecastedOrdersMutation.fetcher = (variables: PurgeForecastedOrdersMutationVariables, options?: RequestInit['headers']) => fetcher<PurgeForecastedOrdersMutation, PurgeForecastedOrdersMutationVariables>(PurgeForecastedOrdersDocument, variables, options);
export const LockOrderDocument = `
    mutation lockOrder($shipmentId: ObjectId!) {
  lockOrder(shipmentId: $shipmentId)
}
    `;
export const useLockOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<LockOrderMutation, TError, LockOrderMutationVariables, TContext>) =>
    useMutation<LockOrderMutation, TError, LockOrderMutationVariables, TContext>(
      ['lockOrder'],
      (variables?: LockOrderMutationVariables) => fetcher<LockOrderMutation, LockOrderMutationVariables>(LockOrderDocument, variables)(),
      options
    );
useLockOrderMutation.getKey = () => ['lockOrder'];

useLockOrderMutation.fetcher = (variables: LockOrderMutationVariables, options?: RequestInit['headers']) => fetcher<LockOrderMutation, LockOrderMutationVariables>(LockOrderDocument, variables, options);
export const GetForecastingNotificationsDocument = `
    query getForecastingNotifications($receiverId: ObjectId) {
  forecastingNotifications(receiverId: $receiverId) {
    level
    message
    receiverId
    storageFacilityId
    receiverForecastId
  }
}
    `;
export const useGetForecastingNotificationsQuery = <
      TData = GetForecastingNotificationsQuery,
      TError = Exception
    >(
      variables?: GetForecastingNotificationsQueryVariables,
      options?: UseQueryOptions<GetForecastingNotificationsQuery, TError, TData>
    ) =>
    useQuery<GetForecastingNotificationsQuery, TError, TData>(
      variables === undefined ? ['getForecastingNotifications'] : ['getForecastingNotifications', variables],
      fetcher<GetForecastingNotificationsQuery, GetForecastingNotificationsQueryVariables>(GetForecastingNotificationsDocument, variables),
      options
    );

useGetForecastingNotificationsQuery.getKey = (variables?: GetForecastingNotificationsQueryVariables) => variables === undefined ? ['getForecastingNotifications'] : ['getForecastingNotifications', variables];
;

useGetForecastingNotificationsQuery.fetcher = (variables?: GetForecastingNotificationsQueryVariables, options?: RequestInit['headers']) => fetcher<GetForecastingNotificationsQuery, GetForecastingNotificationsQueryVariables>(GetForecastingNotificationsDocument, variables, options);
export const UpdateForecastingAutomationConfigDocument = `
    mutation updateForecastingAutomationConfig($receiverForecastId: ObjectId!, $config: AutomationConfigInput!) {
  updateForecastingAutomationConfig(
    receiverForecastId: $receiverForecastId
    config: $config
  ) {
    _id
    automationConfig {
      enabled
      frequencyMinutes
      forecastQuantity
      lastRunAt
      nextRunAt
    }
  }
}
    `;
export const useUpdateForecastingAutomationConfigMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateForecastingAutomationConfigMutation, TError, UpdateForecastingAutomationConfigMutationVariables, TContext>) =>
    useMutation<UpdateForecastingAutomationConfigMutation, TError, UpdateForecastingAutomationConfigMutationVariables, TContext>(
      ['updateForecastingAutomationConfig'],
      (variables?: UpdateForecastingAutomationConfigMutationVariables) => fetcher<UpdateForecastingAutomationConfigMutation, UpdateForecastingAutomationConfigMutationVariables>(UpdateForecastingAutomationConfigDocument, variables)(),
      options
    );
useUpdateForecastingAutomationConfigMutation.getKey = () => ['updateForecastingAutomationConfig'];

useUpdateForecastingAutomationConfigMutation.fetcher = (variables: UpdateForecastingAutomationConfigMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateForecastingAutomationConfigMutation, UpdateForecastingAutomationConfigMutationVariables>(UpdateForecastingAutomationConfigDocument, variables, options);
export const TriggerForecastingManualRunDocument = `
    mutation triggerForecastingManualRun($receiverForecastId: ObjectId!) {
  triggerForecastingManualRun(receiverForecastId: $receiverForecastId)
}
    `;
export const useTriggerForecastingManualRunMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<TriggerForecastingManualRunMutation, TError, TriggerForecastingManualRunMutationVariables, TContext>) =>
    useMutation<TriggerForecastingManualRunMutation, TError, TriggerForecastingManualRunMutationVariables, TContext>(
      ['triggerForecastingManualRun'],
      (variables?: TriggerForecastingManualRunMutationVariables) => fetcher<TriggerForecastingManualRunMutation, TriggerForecastingManualRunMutationVariables>(TriggerForecastingManualRunDocument, variables)(),
      options
    );
useTriggerForecastingManualRunMutation.getKey = () => ['triggerForecastingManualRun'];

useTriggerForecastingManualRunMutation.fetcher = (variables: TriggerForecastingManualRunMutationVariables, options?: RequestInit['headers']) => fetcher<TriggerForecastingManualRunMutation, TriggerForecastingManualRunMutationVariables>(TriggerForecastingManualRunDocument, variables, options);
export const ForecastingExecutionLogsDocument = `
    query forecastingExecutionLogs($receiverForecastId: ObjectId!, $skip: Int, $take: Int, $orderBy: [OrderByItem!]) {
  forecastingExecutionLogs(
    receiverForecastId: $receiverForecastId
    skip: $skip
    take: $take
    orderBy: $orderBy
  ) {
    data {
      _id
      receiverForecastId
      status
      startedAt
      completedAt
      ordersGenerated
      lockedOrdersCount
      errorMessage
    }
    count
  }
}
    `;
export const useForecastingExecutionLogsQuery = <
      TData = ForecastingExecutionLogsQuery,
      TError = Exception
    >(
      variables: ForecastingExecutionLogsQueryVariables,
      options?: UseQueryOptions<ForecastingExecutionLogsQuery, TError, TData>
    ) =>
    useQuery<ForecastingExecutionLogsQuery, TError, TData>(
      ['forecastingExecutionLogs', variables],
      fetcher<ForecastingExecutionLogsQuery, ForecastingExecutionLogsQueryVariables>(ForecastingExecutionLogsDocument, variables),
      options
    );

useForecastingExecutionLogsQuery.getKey = (variables: ForecastingExecutionLogsQueryVariables) => ['forecastingExecutionLogs', variables];
;

useForecastingExecutionLogsQuery.fetcher = (variables: ForecastingExecutionLogsQueryVariables, options?: RequestInit['headers']) => fetcher<ForecastingExecutionLogsQuery, ForecastingExecutionLogsQueryVariables>(ForecastingExecutionLogsDocument, variables, options);
export const GetReceiverForecastListForDashboardDocument = `
    query getReceiverForecastListForDashboard($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  receiverForecasts(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      receiverId
      receiver {
        _id
        name
        storageFacilities {
          identifier
          capacity
          unit
          commodityIds
          safeFillLevel
          shutDownLevel
          runoutDate
          runoutDateAfterNextShipment
          currentSalesTrend
          commodities {
            _id
            label
            code
            unit
            weight
          }
          linkedStorageFacilityIds
        }
        contact {
          firstname
          lastname
          email
          phoneNumber
        }
      }
      models {
        _id
        label
        storageFacilityId
        target
        threshold
      }
    }
    count
  }
}
    `;
export const useGetReceiverForecastListForDashboardQuery = <
      TData = GetReceiverForecastListForDashboardQuery,
      TError = Exception
    >(
      variables?: GetReceiverForecastListForDashboardQueryVariables,
      options?: UseQueryOptions<GetReceiverForecastListForDashboardQuery, TError, TData>
    ) =>
    useQuery<GetReceiverForecastListForDashboardQuery, TError, TData>(
      variables === undefined ? ['getReceiverForecastListForDashboard'] : ['getReceiverForecastListForDashboard', variables],
      fetcher<GetReceiverForecastListForDashboardQuery, GetReceiverForecastListForDashboardQueryVariables>(GetReceiverForecastListForDashboardDocument, variables),
      options
    );

useGetReceiverForecastListForDashboardQuery.getKey = (variables?: GetReceiverForecastListForDashboardQueryVariables) => variables === undefined ? ['getReceiverForecastListForDashboard'] : ['getReceiverForecastListForDashboard', variables];
;

useGetReceiverForecastListForDashboardQuery.fetcher = (variables?: GetReceiverForecastListForDashboardQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiverForecastListForDashboardQuery, GetReceiverForecastListForDashboardQueryVariables>(GetReceiverForecastListForDashboardDocument, variables, options);
export const GetReceiverForecastDetailsForDashboardDocument = `
    query getReceiverForecastDetailsForDashboard($id: String!) {
  receiverForecastById(id: $id) {
    _id
    receiverId
    receiver {
      _id
      name
      storageFacilities {
        identifier
        capacity
        unit
        commodityIds
        safeFillLevel
        shutDownLevel
        latestReading {
          date
          level
          volumeType
        }
        currentForecastedReading {
          date
          level
          volumeType
        }
        runoutDate
        runoutDateAfterNextShipment
        currentSalesTrend
        commodities {
          _id
          label
          unit
          code
          weight
        }
        linkedStorageFacilityIds
      }
    }
    models {
      _id
      target
      threshold
      weight
      contaminates
      isExclusive
      label
      minCapacity
      maxCapacity
      slots {
        type
        salesAmount
        hourly {
          dayOfWeek
          startTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
        }
        daily {
          dayOfWeek
        }
        monthly {
          month
        }
      }
      storageFacilityId
    }
    trailerProfile {
      compartments {
        label
        capacity
        maxWeight
        hasSeparatorBefore
        hasSeparatorAfter
        minUsage
      }
    }
    readingsFileConfiguration {
      tankIdColumn
      dateColumn
      dateFormat
      timeColumn
      timeFormat
      levelColumn
      storeColumn
      readingDeviationCriticalThreshold
      readingDeviationDangerThreshold
      readingDeviationWarningThreshold
      runoutCriticalThreshold
      runoutDangerThreshold
      runoutWarningThreshold
      staleReadingCriticalThreshold
      staleReadingDangerThreshold
      staleReadingWarningThreshold
    }
  }
}
    `;
export const useGetReceiverForecastDetailsForDashboardQuery = <
      TData = GetReceiverForecastDetailsForDashboardQuery,
      TError = Exception
    >(
      variables: GetReceiverForecastDetailsForDashboardQueryVariables,
      options?: UseQueryOptions<GetReceiverForecastDetailsForDashboardQuery, TError, TData>
    ) =>
    useQuery<GetReceiverForecastDetailsForDashboardQuery, TError, TData>(
      ['getReceiverForecastDetailsForDashboard', variables],
      fetcher<GetReceiverForecastDetailsForDashboardQuery, GetReceiverForecastDetailsForDashboardQueryVariables>(GetReceiverForecastDetailsForDashboardDocument, variables),
      options
    );

useGetReceiverForecastDetailsForDashboardQuery.getKey = (variables: GetReceiverForecastDetailsForDashboardQueryVariables) => ['getReceiverForecastDetailsForDashboard', variables];
;

useGetReceiverForecastDetailsForDashboardQuery.fetcher = (variables: GetReceiverForecastDetailsForDashboardQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiverForecastDetailsForDashboardQuery, GetReceiverForecastDetailsForDashboardQueryVariables>(GetReceiverForecastDetailsForDashboardDocument, variables, options);
export const DeleteReceiverForecastDocument = `
    mutation deleteReceiverForecast($id: String!) {
  deleteReceiverForecast(id: $id)
}
    `;
export const useDeleteReceiverForecastMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReceiverForecastMutation, TError, DeleteReceiverForecastMutationVariables, TContext>) =>
    useMutation<DeleteReceiverForecastMutation, TError, DeleteReceiverForecastMutationVariables, TContext>(
      ['deleteReceiverForecast'],
      (variables?: DeleteReceiverForecastMutationVariables) => fetcher<DeleteReceiverForecastMutation, DeleteReceiverForecastMutationVariables>(DeleteReceiverForecastDocument, variables)(),
      options
    );
useDeleteReceiverForecastMutation.getKey = () => ['deleteReceiverForecast'];

useDeleteReceiverForecastMutation.fetcher = (variables: DeleteReceiverForecastMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteReceiverForecastMutation, DeleteReceiverForecastMutationVariables>(DeleteReceiverForecastDocument, variables, options);
export const AddReceiverForecastDocument = `
    mutation addReceiverForecast($newReceiverForecastData: NewReceiverForecastInput!) {
  addReceiverForecast(newReceiverForecastData: $newReceiverForecastData) {
    _id
  }
}
    `;
export const useAddReceiverForecastMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddReceiverForecastMutation, TError, AddReceiverForecastMutationVariables, TContext>) =>
    useMutation<AddReceiverForecastMutation, TError, AddReceiverForecastMutationVariables, TContext>(
      ['addReceiverForecast'],
      (variables?: AddReceiverForecastMutationVariables) => fetcher<AddReceiverForecastMutation, AddReceiverForecastMutationVariables>(AddReceiverForecastDocument, variables)(),
      options
    );
useAddReceiverForecastMutation.getKey = () => ['addReceiverForecast'];

useAddReceiverForecastMutation.fetcher = (variables: AddReceiverForecastMutationVariables, options?: RequestInit['headers']) => fetcher<AddReceiverForecastMutation, AddReceiverForecastMutationVariables>(AddReceiverForecastDocument, variables, options);
export const EditReceiverForecastDocument = `
    mutation editReceiverForecast($id: String!, $editReceiverForecastData: ReceiverForecastUpdateInput!) {
  editReceiverForecast(
    id: $id
    editReceiverForecastData: $editReceiverForecastData
  ) {
    _id
  }
}
    `;
export const useEditReceiverForecastMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditReceiverForecastMutation, TError, EditReceiverForecastMutationVariables, TContext>) =>
    useMutation<EditReceiverForecastMutation, TError, EditReceiverForecastMutationVariables, TContext>(
      ['editReceiverForecast'],
      (variables?: EditReceiverForecastMutationVariables) => fetcher<EditReceiverForecastMutation, EditReceiverForecastMutationVariables>(EditReceiverForecastDocument, variables)(),
      options
    );
useEditReceiverForecastMutation.getKey = () => ['editReceiverForecast'];

useEditReceiverForecastMutation.fetcher = (variables: EditReceiverForecastMutationVariables, options?: RequestInit['headers']) => fetcher<EditReceiverForecastMutation, EditReceiverForecastMutationVariables>(EditReceiverForecastDocument, variables, options);
export const BulkAddReceiverForecastsDocument = `
    mutation bulkAddReceiverForecasts($newReceiverForecastsData: [NewReceiverForecastInput!]!) {
  bulkAddReceiverForecasts(newReceiverForecastsData: $newReceiverForecastsData) {
    _id
  }
}
    `;
export const useBulkAddReceiverForecastsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddReceiverForecastsMutation, TError, BulkAddReceiverForecastsMutationVariables, TContext>) =>
    useMutation<BulkAddReceiverForecastsMutation, TError, BulkAddReceiverForecastsMutationVariables, TContext>(
      ['bulkAddReceiverForecasts'],
      (variables?: BulkAddReceiverForecastsMutationVariables) => fetcher<BulkAddReceiverForecastsMutation, BulkAddReceiverForecastsMutationVariables>(BulkAddReceiverForecastsDocument, variables)(),
      options
    );
useBulkAddReceiverForecastsMutation.getKey = () => ['bulkAddReceiverForecasts'];

useBulkAddReceiverForecastsMutation.fetcher = (variables: BulkAddReceiverForecastsMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddReceiverForecastsMutation, BulkAddReceiverForecastsMutationVariables>(BulkAddReceiverForecastsDocument, variables, options);
export const UploadStorageFacilityReadingsCsvDataDocument = `
    mutation uploadStorageFacilityReadingsCsvData($data: JSON!, $receiverId: ObjectId!) {
  uploadStorageFacilityReadingsCsvData(data: $data, receiverId: $receiverId)
}
    `;
export const useUploadStorageFacilityReadingsCsvDataMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UploadStorageFacilityReadingsCsvDataMutation, TError, UploadStorageFacilityReadingsCsvDataMutationVariables, TContext>) =>
    useMutation<UploadStorageFacilityReadingsCsvDataMutation, TError, UploadStorageFacilityReadingsCsvDataMutationVariables, TContext>(
      ['uploadStorageFacilityReadingsCsvData'],
      (variables?: UploadStorageFacilityReadingsCsvDataMutationVariables) => fetcher<UploadStorageFacilityReadingsCsvDataMutation, UploadStorageFacilityReadingsCsvDataMutationVariables>(UploadStorageFacilityReadingsCsvDataDocument, variables)(),
      options
    );
useUploadStorageFacilityReadingsCsvDataMutation.getKey = () => ['uploadStorageFacilityReadingsCsvData'];

useUploadStorageFacilityReadingsCsvDataMutation.fetcher = (variables: UploadStorageFacilityReadingsCsvDataMutationVariables, options?: RequestInit['headers']) => fetcher<UploadStorageFacilityReadingsCsvDataMutation, UploadStorageFacilityReadingsCsvDataMutationVariables>(UploadStorageFacilityReadingsCsvDataDocument, variables, options);
export const GetReceiverReadingsDocument = `
    query getReceiverReadings($receiverId: ObjectId!) {
  storageFacilityReadings(receiverId: $receiverId) {
    data {
      _id
      storageFacilityId
      date
      level
      volumeType
    }
  }
}
    `;
export const useGetReceiverReadingsQuery = <
      TData = GetReceiverReadingsQuery,
      TError = Exception
    >(
      variables: GetReceiverReadingsQueryVariables,
      options?: UseQueryOptions<GetReceiverReadingsQuery, TError, TData>
    ) =>
    useQuery<GetReceiverReadingsQuery, TError, TData>(
      ['getReceiverReadings', variables],
      fetcher<GetReceiverReadingsQuery, GetReceiverReadingsQueryVariables>(GetReceiverReadingsDocument, variables),
      options
    );

useGetReceiverReadingsQuery.getKey = (variables: GetReceiverReadingsQueryVariables) => ['getReceiverReadings', variables];
;

useGetReceiverReadingsQuery.fetcher = (variables: GetReceiverReadingsQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiverReadingsQuery, GetReceiverReadingsQueryVariables>(GetReceiverReadingsDocument, variables, options);
export const AddStorageFacilityReadingDocument = `
    mutation addStorageFacilityReading($newStorageFacilityReadingData: NewStorageFacilityReadingInput!) {
  addStorageFacilityReading(
    newStorageFacilityReadingData: $newStorageFacilityReadingData
  ) {
    _id
  }
}
    `;
export const useAddStorageFacilityReadingMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddStorageFacilityReadingMutation, TError, AddStorageFacilityReadingMutationVariables, TContext>) =>
    useMutation<AddStorageFacilityReadingMutation, TError, AddStorageFacilityReadingMutationVariables, TContext>(
      ['addStorageFacilityReading'],
      (variables?: AddStorageFacilityReadingMutationVariables) => fetcher<AddStorageFacilityReadingMutation, AddStorageFacilityReadingMutationVariables>(AddStorageFacilityReadingDocument, variables)(),
      options
    );
useAddStorageFacilityReadingMutation.getKey = () => ['addStorageFacilityReading'];

useAddStorageFacilityReadingMutation.fetcher = (variables: AddStorageFacilityReadingMutationVariables, options?: RequestInit['headers']) => fetcher<AddStorageFacilityReadingMutation, AddStorageFacilityReadingMutationVariables>(AddStorageFacilityReadingDocument, variables, options);
export const GetReceiverForecastListDocument = `
    query getReceiverForecastList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  receiverForecasts(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      receiverId
      receiver {
        _id
        name
        storageFacilities {
          identifier
          capacity
          unit
          commodityIds
          safeFillLevel
          shutDownLevel
          commodities {
            _id
            label
            code
            unit
            weight
          }
          linkedStorageFacilityIds
        }
        contact {
          firstname
          lastname
          email
          phoneNumber
        }
      }
      models {
        _id
        label
        storageFacilityId
        target
        threshold
      }
    }
    count
  }
}
    `;
export const useGetReceiverForecastListQuery = <
      TData = GetReceiverForecastListQuery,
      TError = Exception
    >(
      variables?: GetReceiverForecastListQueryVariables,
      options?: UseQueryOptions<GetReceiverForecastListQuery, TError, TData>
    ) =>
    useQuery<GetReceiverForecastListQuery, TError, TData>(
      variables === undefined ? ['getReceiverForecastList'] : ['getReceiverForecastList', variables],
      fetcher<GetReceiverForecastListQuery, GetReceiverForecastListQueryVariables>(GetReceiverForecastListDocument, variables),
      options
    );

useGetReceiverForecastListQuery.getKey = (variables?: GetReceiverForecastListQueryVariables) => variables === undefined ? ['getReceiverForecastList'] : ['getReceiverForecastList', variables];
;

useGetReceiverForecastListQuery.fetcher = (variables?: GetReceiverForecastListQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiverForecastListQuery, GetReceiverForecastListQueryVariables>(GetReceiverForecastListDocument, variables, options);
export const GetReceiverForecastDetailsDocument = `
    query getReceiverForecastDetails($id: String!) {
  receiverForecastById(id: $id) {
    _id
    receiverId
    receiver {
      _id
      name
      storageFacilities {
        identifier
        capacity
        unit
        commodityIds
        safeFillLevel
        shutDownLevel
        latestReading {
          date
          level
          volumeType
        }
        commodities {
          _id
          label
          unit
          code
          weight
        }
        linkedStorageFacilityIds
      }
    }
    models {
      _id
      target
      threshold
      weight
      contaminates
      isExclusive
      label
      minCapacity
      maxCapacity
      slots {
        type
        salesAmount
        hourly {
          dayOfWeek
          startTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
        }
        daily {
          dayOfWeek
        }
        monthly {
          month
        }
      }
      storageFacilityId
    }
    trailerProfile {
      compartments {
        label
        capacity
        maxWeight
        hasSeparatorBefore
        hasSeparatorAfter
        minUsage
      }
    }
    automationConfig {
      enabled
      frequencyMinutes
      forecastQuantity
      lastRunAt
      nextRunAt
    }
    readingsFileConfiguration {
      tankIdColumn
      dateColumn
      dateFormat
      timeColumn
      timeFormat
      levelColumn
      storeColumn
      readingDeviationCriticalThreshold
      readingDeviationDangerThreshold
      readingDeviationWarningThreshold
      runoutCriticalThreshold
      runoutDangerThreshold
      runoutWarningThreshold
      staleReadingCriticalThreshold
      staleReadingDangerThreshold
      staleReadingWarningThreshold
    }
  }
}
    `;
export const useGetReceiverForecastDetailsQuery = <
      TData = GetReceiverForecastDetailsQuery,
      TError = Exception
    >(
      variables: GetReceiverForecastDetailsQueryVariables,
      options?: UseQueryOptions<GetReceiverForecastDetailsQuery, TError, TData>
    ) =>
    useQuery<GetReceiverForecastDetailsQuery, TError, TData>(
      ['getReceiverForecastDetails', variables],
      fetcher<GetReceiverForecastDetailsQuery, GetReceiverForecastDetailsQueryVariables>(GetReceiverForecastDetailsDocument, variables),
      options
    );

useGetReceiverForecastDetailsQuery.getKey = (variables: GetReceiverForecastDetailsQueryVariables) => ['getReceiverForecastDetails', variables];
;

useGetReceiverForecastDetailsQuery.fetcher = (variables: GetReceiverForecastDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiverForecastDetailsQuery, GetReceiverForecastDetailsQueryVariables>(GetReceiverForecastDetailsDocument, variables, options);
export const GetBrokersDocument = `
    query getBrokers {
  brokers(includeInactive: true) {
    data {
      _id
      address {
        coordinates {
          longitude
          latitude
        }
        label
      }
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
      additionalTypes
      code
      mcNumber
      status
    }
  }
}
    `;
export const useGetBrokersQuery = <
      TData = GetBrokersQuery,
      TError = Exception
    >(
      variables?: GetBrokersQueryVariables,
      options?: UseQueryOptions<GetBrokersQuery, TError, TData>
    ) =>
    useQuery<GetBrokersQuery, TError, TData>(
      variables === undefined ? ['getBrokers'] : ['getBrokers', variables],
      fetcher<GetBrokersQuery, GetBrokersQueryVariables>(GetBrokersDocument, variables),
      options
    );

useGetBrokersQuery.getKey = (variables?: GetBrokersQueryVariables) => variables === undefined ? ['getBrokers'] : ['getBrokers', variables];
;

useGetBrokersQuery.fetcher = (variables?: GetBrokersQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrokersQuery, GetBrokersQueryVariables>(GetBrokersDocument, variables, options);
export const GetShippersDocument = `
    query getShippers {
  shippers(includeInactive: true) {
    data {
      _id
      name
      address {
        coordinates {
          longitude
          latitude
        }
        label
      }
      addressTimezone
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
      additionalTypes
      code
      mcNumber
      openingSchedules {
        openingTime
        closingTime
        days
      }
      status
    }
  }
}
    `;
export const useGetShippersQuery = <
      TData = GetShippersQuery,
      TError = Exception
    >(
      variables?: GetShippersQueryVariables,
      options?: UseQueryOptions<GetShippersQuery, TError, TData>
    ) =>
    useQuery<GetShippersQuery, TError, TData>(
      variables === undefined ? ['getShippers'] : ['getShippers', variables],
      fetcher<GetShippersQuery, GetShippersQueryVariables>(GetShippersDocument, variables),
      options
    );

useGetShippersQuery.getKey = (variables?: GetShippersQueryVariables) => variables === undefined ? ['getShippers'] : ['getShippers', variables];
;

useGetShippersQuery.fetcher = (variables?: GetShippersQueryVariables, options?: RequestInit['headers']) => fetcher<GetShippersQuery, GetShippersQueryVariables>(GetShippersDocument, variables, options);
export const GetReceiversDocument = `
    query getReceivers {
  receivers(includeInactive: true) {
    data {
      _id
      name
      address {
        coordinates {
          longitude
          latitude
        }
        label
      }
      addressTimezone
      contact {
        firstname
        lastname
        phoneNumber
      }
      parentBusinessEntityId
      name
      type
      additionalTypes
      code
      mcNumber
      openingSchedules {
        openingTime
        closingTime
        days
      }
      status
      groupIds
    }
  }
}
    `;
export const useGetReceiversQuery = <
      TData = GetReceiversQuery,
      TError = Exception
    >(
      variables?: GetReceiversQueryVariables,
      options?: UseQueryOptions<GetReceiversQuery, TError, TData>
    ) =>
    useQuery<GetReceiversQuery, TError, TData>(
      variables === undefined ? ['getReceivers'] : ['getReceivers', variables],
      fetcher<GetReceiversQuery, GetReceiversQueryVariables>(GetReceiversDocument, variables),
      options
    );

useGetReceiversQuery.getKey = (variables?: GetReceiversQueryVariables) => variables === undefined ? ['getReceivers'] : ['getReceivers', variables];
;

useGetReceiversQuery.fetcher = (variables?: GetReceiversQueryVariables, options?: RequestInit['headers']) => fetcher<GetReceiversQuery, GetReceiversQueryVariables>(GetReceiversDocument, variables, options);
export const GetCustomersDocument = `
    query getCustomers {
  customers(includeInactive: true) {
    data {
      _id
      address {
        coordinates {
          longitude
          latitude
        }
        label
      }
      addressTimezone
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
      additionalTypes
      code
      mcNumber
      status
    }
  }
}
    `;
export const useGetCustomersQuery = <
      TData = GetCustomersQuery,
      TError = Exception
    >(
      variables?: GetCustomersQueryVariables,
      options?: UseQueryOptions<GetCustomersQuery, TError, TData>
    ) =>
    useQuery<GetCustomersQuery, TError, TData>(
      variables === undefined ? ['getCustomers'] : ['getCustomers', variables],
      fetcher<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, variables),
      options
    );

useGetCustomersQuery.getKey = (variables?: GetCustomersQueryVariables) => variables === undefined ? ['getCustomers'] : ['getCustomers', variables];
;

useGetCustomersQuery.fetcher = (variables?: GetCustomersQueryVariables, options?: RequestInit['headers']) => fetcher<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, variables, options);
export const GetPayToProfilesDocument = `
    query getPayToProfiles {
  businessEntities(businessEntityTypes: [PAY_TO_PROFILE], includeInactive: true) {
    data {
      _id
      address {
        coordinates {
          longitude
          latitude
        }
        label
      }
      addressTimezone
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
      additionalTypes
      code
      mcNumber
      status
    }
  }
}
    `;
export const useGetPayToProfilesQuery = <
      TData = GetPayToProfilesQuery,
      TError = Exception
    >(
      variables?: GetPayToProfilesQueryVariables,
      options?: UseQueryOptions<GetPayToProfilesQuery, TError, TData>
    ) =>
    useQuery<GetPayToProfilesQuery, TError, TData>(
      variables === undefined ? ['getPayToProfiles'] : ['getPayToProfiles', variables],
      fetcher<GetPayToProfilesQuery, GetPayToProfilesQueryVariables>(GetPayToProfilesDocument, variables),
      options
    );

useGetPayToProfilesQuery.getKey = (variables?: GetPayToProfilesQueryVariables) => variables === undefined ? ['getPayToProfiles'] : ['getPayToProfiles', variables];
;

useGetPayToProfilesQuery.fetcher = (variables?: GetPayToProfilesQueryVariables, options?: RequestInit['headers']) => fetcher<GetPayToProfilesQuery, GetPayToProfilesQueryVariables>(GetPayToProfilesDocument, variables, options);
export const GetSuppliersDocument = `
    query getSuppliers {
  businessEntities(businessEntityTypes: [SUPPLIER], includeInactive: true) {
    data {
      _id
      address {
        coordinates {
          longitude
          latitude
        }
        label
      }
      addressTimezone
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
      additionalTypes
      code
      mcNumber
      status
    }
  }
}
    `;
export const useGetSuppliersQuery = <
      TData = GetSuppliersQuery,
      TError = Exception
    >(
      variables?: GetSuppliersQueryVariables,
      options?: UseQueryOptions<GetSuppliersQuery, TError, TData>
    ) =>
    useQuery<GetSuppliersQuery, TError, TData>(
      variables === undefined ? ['getSuppliers'] : ['getSuppliers', variables],
      fetcher<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, variables),
      options
    );

useGetSuppliersQuery.getKey = (variables?: GetSuppliersQueryVariables) => variables === undefined ? ['getSuppliers'] : ['getSuppliers', variables];
;

useGetSuppliersQuery.fetcher = (variables?: GetSuppliersQueryVariables, options?: RequestInit['headers']) => fetcher<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, variables, options);
export const GetDomicilesDocument = `
    query getDomiciles {
  businessEntities(businessEntityTypes: [DOMICILE]) {
    data {
      _id
      address {
        coordinates {
          longitude
          latitude
        }
        label
      }
      addressTimezone
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
      additionalTypes
      code
      mcNumber
      status
    }
  }
}
    `;
export const useGetDomicilesQuery = <
      TData = GetDomicilesQuery,
      TError = Exception
    >(
      variables?: GetDomicilesQueryVariables,
      options?: UseQueryOptions<GetDomicilesQuery, TError, TData>
    ) =>
    useQuery<GetDomicilesQuery, TError, TData>(
      variables === undefined ? ['getDomiciles'] : ['getDomiciles', variables],
      fetcher<GetDomicilesQuery, GetDomicilesQueryVariables>(GetDomicilesDocument, variables),
      options
    );

useGetDomicilesQuery.getKey = (variables?: GetDomicilesQueryVariables) => variables === undefined ? ['getDomiciles'] : ['getDomiciles', variables];
;

useGetDomicilesQuery.fetcher = (variables?: GetDomicilesQueryVariables, options?: RequestInit['headers']) => fetcher<GetDomicilesQuery, GetDomicilesQueryVariables>(GetDomicilesDocument, variables, options);
export const GetBusinessEntitiesDocument = `
    query getBusinessEntities($businessEntityTypes: [BusinessEntityType!], $search: String, $filter: JSON, $includeInactive: Boolean) {
  businessEntities(
    businessEntityTypes: $businessEntityTypes
    search: $search
    filter: $filter
    includeInactive: $includeInactive
  ) {
    data {
      _id
      address {
        coordinates {
          longitude
          latitude
        }
        label
      }
      addressTimezone
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
      additionalTypes
      code
      mcNumber
      storageFacilities {
        identifier
        capacity
        unit
        commodityIds
        commodities {
          code
          label
        }
        safeFillLevel
        shutDownLevel
        defaultPinCode
        defaultSupplierId
        defaultSupplier {
          code
          name
        }
        linkedStorageFacilityIds
      }
      openingSchedules {
        closingTime
        days
        openingTime
      }
      status
    }
  }
}
    `;
export const useGetBusinessEntitiesQuery = <
      TData = GetBusinessEntitiesQuery,
      TError = Exception
    >(
      variables?: GetBusinessEntitiesQueryVariables,
      options?: UseQueryOptions<GetBusinessEntitiesQuery, TError, TData>
    ) =>
    useQuery<GetBusinessEntitiesQuery, TError, TData>(
      variables === undefined ? ['getBusinessEntities'] : ['getBusinessEntities', variables],
      fetcher<GetBusinessEntitiesQuery, GetBusinessEntitiesQueryVariables>(GetBusinessEntitiesDocument, variables),
      options
    );

useGetBusinessEntitiesQuery.getKey = (variables?: GetBusinessEntitiesQueryVariables) => variables === undefined ? ['getBusinessEntities'] : ['getBusinessEntities', variables];
;

useGetBusinessEntitiesQuery.fetcher = (variables?: GetBusinessEntitiesQueryVariables, options?: RequestInit['headers']) => fetcher<GetBusinessEntitiesQuery, GetBusinessEntitiesQueryVariables>(GetBusinessEntitiesDocument, variables, options);
export const GetLoadBoardLoadsDocument = `
    query getLoadBoardLoads($searchCriteria: LoadBoardSearchCriteria!, $skip: Int, $take: Int) {
  loadBoardLoads(searchCriteria: $searchCriteria, skip: $skip, take: $take) {
    data {
      _id
      trailerType
      additionalTrailerTypes
      loadType
      shipmentLocations {
        _id
        locationType
        name
        addressLabel
        addressTimezone
        timeWindows {
          fromDate
          toDate
        }
        shippedGoods {
          weight
          quantity
          unit
        }
      }
      customer {
        name
        contact {
          firstname
          lastname
          email
          phoneNumber
        }
      }
      charges {
        label
        total
      }
    }
    count
  }
}
    `;
export const useGetLoadBoardLoadsQuery = <
      TData = GetLoadBoardLoadsQuery,
      TError = Exception
    >(
      variables: GetLoadBoardLoadsQueryVariables,
      options?: UseQueryOptions<GetLoadBoardLoadsQuery, TError, TData>
    ) =>
    useQuery<GetLoadBoardLoadsQuery, TError, TData>(
      ['getLoadBoardLoads', variables],
      fetcher<GetLoadBoardLoadsQuery, GetLoadBoardLoadsQueryVariables>(GetLoadBoardLoadsDocument, variables),
      options
    );

useGetLoadBoardLoadsQuery.getKey = (variables: GetLoadBoardLoadsQueryVariables) => ['getLoadBoardLoads', variables];
;

useGetLoadBoardLoadsQuery.fetcher = (variables: GetLoadBoardLoadsQueryVariables, options?: RequestInit['headers']) => fetcher<GetLoadBoardLoadsQuery, GetLoadBoardLoadsQueryVariables>(GetLoadBoardLoadsDocument, variables, options);
export const GetLoadBoardLoadDetailsDocument = `
    query getLoadBoardLoadDetails($loadId: String!) {
  loadBoardLoadById(id: $loadId) {
    _id
    shipmentNumber
    events {
      _id
      coordinates {
        altitude
        heading
        latitude
        longitude
        speed
      }
      createdBy
      date
      shipmentLocation
      type
    }
    issues {
      _id
      type
      content
      date
      shipmentLocation
      delayAmount
      attachedDocuments
    }
    constraints {
      type
      value
      unit
    }
    documents {
      _id
      associatedCharge
      accessLevel
      isBillable
      isForRatecons
      isForReceivers
      name
      type
      url
      shipper {
        _id
        name
      }
      receiver {
        _id
        name
      }
    }
    notes {
      _id
      accessLevel
      receiver {
        _id
        name
      }
      shipper {
        _id
        name
      }
      content
    }
    customer {
      _id
      name
      address {
        coordinates {
          latitude
          longitude
        }
        label
      }
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
    }
    purchaseOrderNumbers
    billOfLadingNumbers
    referenceNumbers
    status
    shipmentLocations {
      _id
      name
      addressLabel
      addressTimezone
      shipper {
        _id
        name
        address {
          coordinates {
            latitude
            longitude
          }
          label
        }
        addressTimezone
      }
      receiver {
        _id
        name
        address {
          coordinates {
            latitude
            longitude
          }
          label
        }
        addressTimezone
      }
      shippedGoods {
        _id
        quantity
        weight
        unit
        label
      }
      receivedGoods {
        goodId
        quantity
      }
      timeWindows {
        fromDate
        toDate
      }
      location {
        latitude
        longitude
      }
      locationType
    }
    constraints {
      type
      value
      unit
    }
    charges {
      _id
      total
      label
      rate
      unit
      unitType
      reimburseToDriver
      billingRule {
        _id
        label
        referenceNumber
      }
      document {
        name
        url
      }
    }
    expenses {
      _id
      label
      rate
      unit
      unitType
      reimburseToDriver
      document {
        name
        url
      }
      customFields {
        key
        value
      }
    }
    route {
      routeDistance
      firstPickupTime
    }
    createdBy
    trailerType
    additionalTrailerTypes
    loadType
    tripId
    reasonForCancellation
  }
}
    `;
export const useGetLoadBoardLoadDetailsQuery = <
      TData = GetLoadBoardLoadDetailsQuery,
      TError = Exception
    >(
      variables: GetLoadBoardLoadDetailsQueryVariables,
      options?: UseQueryOptions<GetLoadBoardLoadDetailsQuery, TError, TData>
    ) =>
    useQuery<GetLoadBoardLoadDetailsQuery, TError, TData>(
      ['getLoadBoardLoadDetails', variables],
      fetcher<GetLoadBoardLoadDetailsQuery, GetLoadBoardLoadDetailsQueryVariables>(GetLoadBoardLoadDetailsDocument, variables),
      options
    );

useGetLoadBoardLoadDetailsQuery.getKey = (variables: GetLoadBoardLoadDetailsQueryVariables) => ['getLoadBoardLoadDetails', variables];
;

useGetLoadBoardLoadDetailsQuery.fetcher = (variables: GetLoadBoardLoadDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetLoadBoardLoadDetailsQuery, GetLoadBoardLoadDetailsQueryVariables>(GetLoadBoardLoadDetailsDocument, variables, options);
export const GetMaintenanceTasksDocument = `
    query getMaintenanceTasks($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $assetType: TripAssetTypes, $assetId: ObjectId, $status: MaintenanceTaskStatus) {
  maintenanceTasks(
    search: $search
    skip: $skip
    take: $take
    assetType: $assetType
    assetId: $assetId
    status: $status
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      assetType
      assetId
      status
      label
      required
      startDate
      startMileage
      endDate
      recurrence {
        interval
        frequency
      }
    }
  }
}
    `;
export const useGetMaintenanceTasksQuery = <
      TData = GetMaintenanceTasksQuery,
      TError = Exception
    >(
      variables?: GetMaintenanceTasksQueryVariables,
      options?: UseQueryOptions<GetMaintenanceTasksQuery, TError, TData>
    ) =>
    useQuery<GetMaintenanceTasksQuery, TError, TData>(
      variables === undefined ? ['getMaintenanceTasks'] : ['getMaintenanceTasks', variables],
      fetcher<GetMaintenanceTasksQuery, GetMaintenanceTasksQueryVariables>(GetMaintenanceTasksDocument, variables),
      options
    );

useGetMaintenanceTasksQuery.getKey = (variables?: GetMaintenanceTasksQueryVariables) => variables === undefined ? ['getMaintenanceTasks'] : ['getMaintenanceTasks', variables];
;

useGetMaintenanceTasksQuery.fetcher = (variables?: GetMaintenanceTasksQueryVariables, options?: RequestInit['headers']) => fetcher<GetMaintenanceTasksQuery, GetMaintenanceTasksQueryVariables>(GetMaintenanceTasksDocument, variables, options);
export const GetMaintenanceTaskDetailsDocument = `
    query getMaintenanceTaskDetails($id: String!) {
  maintenanceTaskById(id: $id) {
    _id
    assetType
    assetId
    label
    startDate
    startMileage
    endDate
    required
    recurrence {
      interval
      frequency
    }
    status
  }
}
    `;
export const useGetMaintenanceTaskDetailsQuery = <
      TData = GetMaintenanceTaskDetailsQuery,
      TError = Exception
    >(
      variables: GetMaintenanceTaskDetailsQueryVariables,
      options?: UseQueryOptions<GetMaintenanceTaskDetailsQuery, TError, TData>
    ) =>
    useQuery<GetMaintenanceTaskDetailsQuery, TError, TData>(
      ['getMaintenanceTaskDetails', variables],
      fetcher<GetMaintenanceTaskDetailsQuery, GetMaintenanceTaskDetailsQueryVariables>(GetMaintenanceTaskDetailsDocument, variables),
      options
    );

useGetMaintenanceTaskDetailsQuery.getKey = (variables: GetMaintenanceTaskDetailsQueryVariables) => ['getMaintenanceTaskDetails', variables];
;

useGetMaintenanceTaskDetailsQuery.fetcher = (variables: GetMaintenanceTaskDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetMaintenanceTaskDetailsQuery, GetMaintenanceTaskDetailsQueryVariables>(GetMaintenanceTaskDetailsDocument, variables, options);
export const AddMaintenanceTaskDocument = `
    mutation addMaintenanceTask($newMaintenanceTaskData: NewMaintenanceTaskInput!) {
  addMaintenanceTask(newMaintenanceTaskData: $newMaintenanceTaskData) {
    _id
  }
}
    `;
export const useAddMaintenanceTaskMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddMaintenanceTaskMutation, TError, AddMaintenanceTaskMutationVariables, TContext>) =>
    useMutation<AddMaintenanceTaskMutation, TError, AddMaintenanceTaskMutationVariables, TContext>(
      ['addMaintenanceTask'],
      (variables?: AddMaintenanceTaskMutationVariables) => fetcher<AddMaintenanceTaskMutation, AddMaintenanceTaskMutationVariables>(AddMaintenanceTaskDocument, variables)(),
      options
    );
useAddMaintenanceTaskMutation.getKey = () => ['addMaintenanceTask'];

useAddMaintenanceTaskMutation.fetcher = (variables: AddMaintenanceTaskMutationVariables, options?: RequestInit['headers']) => fetcher<AddMaintenanceTaskMutation, AddMaintenanceTaskMutationVariables>(AddMaintenanceTaskDocument, variables, options);
export const EditMaintenanceTaskDocument = `
    mutation editMaintenanceTask($id: String!, $editMaintenanceTaskData: MaintenanceTaskUpdateInput!) {
  editMaintenanceTask(id: $id, editMaintenanceTaskData: $editMaintenanceTaskData) {
    _id
  }
}
    `;
export const useEditMaintenanceTaskMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditMaintenanceTaskMutation, TError, EditMaintenanceTaskMutationVariables, TContext>) =>
    useMutation<EditMaintenanceTaskMutation, TError, EditMaintenanceTaskMutationVariables, TContext>(
      ['editMaintenanceTask'],
      (variables?: EditMaintenanceTaskMutationVariables) => fetcher<EditMaintenanceTaskMutation, EditMaintenanceTaskMutationVariables>(EditMaintenanceTaskDocument, variables)(),
      options
    );
useEditMaintenanceTaskMutation.getKey = () => ['editMaintenanceTask'];

useEditMaintenanceTaskMutation.fetcher = (variables: EditMaintenanceTaskMutationVariables, options?: RequestInit['headers']) => fetcher<EditMaintenanceTaskMutation, EditMaintenanceTaskMutationVariables>(EditMaintenanceTaskDocument, variables, options);
export const DeleteMaintenanceTaskDocument = `
    mutation deleteMaintenanceTask($id: String!) {
  deleteMaintenanceTask(id: $id)
}
    `;
export const useDeleteMaintenanceTaskMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMaintenanceTaskMutation, TError, DeleteMaintenanceTaskMutationVariables, TContext>) =>
    useMutation<DeleteMaintenanceTaskMutation, TError, DeleteMaintenanceTaskMutationVariables, TContext>(
      ['deleteMaintenanceTask'],
      (variables?: DeleteMaintenanceTaskMutationVariables) => fetcher<DeleteMaintenanceTaskMutation, DeleteMaintenanceTaskMutationVariables>(DeleteMaintenanceTaskDocument, variables)(),
      options
    );
useDeleteMaintenanceTaskMutation.getKey = () => ['deleteMaintenanceTask'];

useDeleteMaintenanceTaskMutation.fetcher = (variables: DeleteMaintenanceTaskMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteMaintenanceTaskMutation, DeleteMaintenanceTaskMutationVariables>(DeleteMaintenanceTaskDocument, variables, options);
export const GetAllMaintenanceTasksDocument = `
    query getAllMaintenanceTasks {
  maintenanceTasks {
    data {
      _id
      assetType
      assetId
      label
      startDate
      startMileage
      endDate
      required
      status
    }
  }
}
    `;
export const useGetAllMaintenanceTasksQuery = <
      TData = GetAllMaintenanceTasksQuery,
      TError = Exception
    >(
      variables?: GetAllMaintenanceTasksQueryVariables,
      options?: UseQueryOptions<GetAllMaintenanceTasksQuery, TError, TData>
    ) =>
    useQuery<GetAllMaintenanceTasksQuery, TError, TData>(
      variables === undefined ? ['getAllMaintenanceTasks'] : ['getAllMaintenanceTasks', variables],
      fetcher<GetAllMaintenanceTasksQuery, GetAllMaintenanceTasksQueryVariables>(GetAllMaintenanceTasksDocument, variables),
      options
    );

useGetAllMaintenanceTasksQuery.getKey = (variables?: GetAllMaintenanceTasksQueryVariables) => variables === undefined ? ['getAllMaintenanceTasks'] : ['getAllMaintenanceTasks', variables];
;

useGetAllMaintenanceTasksQuery.fetcher = (variables?: GetAllMaintenanceTasksQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllMaintenanceTasksQuery, GetAllMaintenanceTasksQueryVariables>(GetAllMaintenanceTasksDocument, variables, options);
export const CompleteMaintenanceTaskDocument = `
    mutation completeMaintenanceTask($id: ObjectId!) {
  completeMaintenanceTask(id: $id) {
    _id
  }
}
    `;
export const useCompleteMaintenanceTaskMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteMaintenanceTaskMutation, TError, CompleteMaintenanceTaskMutationVariables, TContext>) =>
    useMutation<CompleteMaintenanceTaskMutation, TError, CompleteMaintenanceTaskMutationVariables, TContext>(
      ['completeMaintenanceTask'],
      (variables?: CompleteMaintenanceTaskMutationVariables) => fetcher<CompleteMaintenanceTaskMutation, CompleteMaintenanceTaskMutationVariables>(CompleteMaintenanceTaskDocument, variables)(),
      options
    );
useCompleteMaintenanceTaskMutation.getKey = () => ['completeMaintenanceTask'];

useCompleteMaintenanceTaskMutation.fetcher = (variables: CompleteMaintenanceTaskMutationVariables, options?: RequestInit['headers']) => fetcher<CompleteMaintenanceTaskMutation, CompleteMaintenanceTaskMutationVariables>(CompleteMaintenanceTaskDocument, variables, options);
export const GetTractorMileageDocument = `
    query getTractorMileage($id: String!) {
  tractorById(id: $id) {
    _id
    mileage
  }
}
    `;
export const useGetTractorMileageQuery = <
      TData = GetTractorMileageQuery,
      TError = Exception
    >(
      variables: GetTractorMileageQueryVariables,
      options?: UseQueryOptions<GetTractorMileageQuery, TError, TData>
    ) =>
    useQuery<GetTractorMileageQuery, TError, TData>(
      ['getTractorMileage', variables],
      fetcher<GetTractorMileageQuery, GetTractorMileageQueryVariables>(GetTractorMileageDocument, variables),
      options
    );

useGetTractorMileageQuery.getKey = (variables: GetTractorMileageQueryVariables) => ['getTractorMileage', variables];
;

useGetTractorMileageQuery.fetcher = (variables: GetTractorMileageQueryVariables, options?: RequestInit['headers']) => fetcher<GetTractorMileageQuery, GetTractorMileageQueryVariables>(GetTractorMileageDocument, variables, options);
export const GetTrailerMileageDocument = `
    query getTrailerMileage($id: String!) {
  trailerById(id: $id) {
    _id
    mileage
  }
}
    `;
export const useGetTrailerMileageQuery = <
      TData = GetTrailerMileageQuery,
      TError = Exception
    >(
      variables: GetTrailerMileageQueryVariables,
      options?: UseQueryOptions<GetTrailerMileageQuery, TError, TData>
    ) =>
    useQuery<GetTrailerMileageQuery, TError, TData>(
      ['getTrailerMileage', variables],
      fetcher<GetTrailerMileageQuery, GetTrailerMileageQueryVariables>(GetTrailerMileageDocument, variables),
      options
    );

useGetTrailerMileageQuery.getKey = (variables: GetTrailerMileageQueryVariables) => ['getTrailerMileage', variables];
;

useGetTrailerMileageQuery.fetcher = (variables: GetTrailerMileageQueryVariables, options?: RequestInit['headers']) => fetcher<GetTrailerMileageQuery, GetTrailerMileageQueryVariables>(GetTrailerMileageDocument, variables, options);
export const GetOrgMaintenanceTasksDocument = `
    query getOrgMaintenanceTasks($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $status: MaintenanceTaskStatus) {
  orgMaintenanceTasks(
    search: $search
    skip: $skip
    take: $take
    status: $status
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      status
      label
      startDate
      endDate
      recurrence {
        interval
        frequency
      }
      assignedTo
      assignedToUser {
        firstName
        lastName
        username
        _id
      }
      alertBeforeDays
    }
  }
}
    `;
export const useGetOrgMaintenanceTasksQuery = <
      TData = GetOrgMaintenanceTasksQuery,
      TError = Exception
    >(
      variables?: GetOrgMaintenanceTasksQueryVariables,
      options?: UseQueryOptions<GetOrgMaintenanceTasksQuery, TError, TData>
    ) =>
    useQuery<GetOrgMaintenanceTasksQuery, TError, TData>(
      variables === undefined ? ['getOrgMaintenanceTasks'] : ['getOrgMaintenanceTasks', variables],
      fetcher<GetOrgMaintenanceTasksQuery, GetOrgMaintenanceTasksQueryVariables>(GetOrgMaintenanceTasksDocument, variables),
      options
    );

useGetOrgMaintenanceTasksQuery.getKey = (variables?: GetOrgMaintenanceTasksQueryVariables) => variables === undefined ? ['getOrgMaintenanceTasks'] : ['getOrgMaintenanceTasks', variables];
;

useGetOrgMaintenanceTasksQuery.fetcher = (variables?: GetOrgMaintenanceTasksQueryVariables, options?: RequestInit['headers']) => fetcher<GetOrgMaintenanceTasksQuery, GetOrgMaintenanceTasksQueryVariables>(GetOrgMaintenanceTasksDocument, variables, options);
export const GetOrgMaintenanceTaskDetailsDocument = `
    query getOrgMaintenanceTaskDetails($id: String!) {
  orgMaintenanceTaskById(id: $id) {
    _id
    label
    startDate
    endDate
    recurrence {
      interval
      frequency
    }
    status
    assignedTo
    assignedToUser {
      firstName
      lastName
      username
      _id
    }
    alertBeforeDays
  }
}
    `;
export const useGetOrgMaintenanceTaskDetailsQuery = <
      TData = GetOrgMaintenanceTaskDetailsQuery,
      TError = Exception
    >(
      variables: GetOrgMaintenanceTaskDetailsQueryVariables,
      options?: UseQueryOptions<GetOrgMaintenanceTaskDetailsQuery, TError, TData>
    ) =>
    useQuery<GetOrgMaintenanceTaskDetailsQuery, TError, TData>(
      ['getOrgMaintenanceTaskDetails', variables],
      fetcher<GetOrgMaintenanceTaskDetailsQuery, GetOrgMaintenanceTaskDetailsQueryVariables>(GetOrgMaintenanceTaskDetailsDocument, variables),
      options
    );

useGetOrgMaintenanceTaskDetailsQuery.getKey = (variables: GetOrgMaintenanceTaskDetailsQueryVariables) => ['getOrgMaintenanceTaskDetails', variables];
;

useGetOrgMaintenanceTaskDetailsQuery.fetcher = (variables: GetOrgMaintenanceTaskDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetOrgMaintenanceTaskDetailsQuery, GetOrgMaintenanceTaskDetailsQueryVariables>(GetOrgMaintenanceTaskDetailsDocument, variables, options);
export const AddOrgMaintenanceTaskDocument = `
    mutation addOrgMaintenanceTask($newOrgMaintenanceTaskData: OrgMaintenanceTaskInput!) {
  addOrgMaintenanceTask(newOrgMaintenanceTaskData: $newOrgMaintenanceTaskData) {
    _id
  }
}
    `;
export const useAddOrgMaintenanceTaskMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddOrgMaintenanceTaskMutation, TError, AddOrgMaintenanceTaskMutationVariables, TContext>) =>
    useMutation<AddOrgMaintenanceTaskMutation, TError, AddOrgMaintenanceTaskMutationVariables, TContext>(
      ['addOrgMaintenanceTask'],
      (variables?: AddOrgMaintenanceTaskMutationVariables) => fetcher<AddOrgMaintenanceTaskMutation, AddOrgMaintenanceTaskMutationVariables>(AddOrgMaintenanceTaskDocument, variables)(),
      options
    );
useAddOrgMaintenanceTaskMutation.getKey = () => ['addOrgMaintenanceTask'];

useAddOrgMaintenanceTaskMutation.fetcher = (variables: AddOrgMaintenanceTaskMutationVariables, options?: RequestInit['headers']) => fetcher<AddOrgMaintenanceTaskMutation, AddOrgMaintenanceTaskMutationVariables>(AddOrgMaintenanceTaskDocument, variables, options);
export const EditOrgMaintenanceTaskDocument = `
    mutation editOrgMaintenanceTask($id: String!, $editOrgMaintenanceTaskData: OrgMaintenanceTaskUpdateInput!) {
  editOrgMaintenanceTask(
    id: $id
    editOrgMaintenanceTaskData: $editOrgMaintenanceTaskData
  ) {
    _id
  }
}
    `;
export const useEditOrgMaintenanceTaskMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditOrgMaintenanceTaskMutation, TError, EditOrgMaintenanceTaskMutationVariables, TContext>) =>
    useMutation<EditOrgMaintenanceTaskMutation, TError, EditOrgMaintenanceTaskMutationVariables, TContext>(
      ['editOrgMaintenanceTask'],
      (variables?: EditOrgMaintenanceTaskMutationVariables) => fetcher<EditOrgMaintenanceTaskMutation, EditOrgMaintenanceTaskMutationVariables>(EditOrgMaintenanceTaskDocument, variables)(),
      options
    );
useEditOrgMaintenanceTaskMutation.getKey = () => ['editOrgMaintenanceTask'];

useEditOrgMaintenanceTaskMutation.fetcher = (variables: EditOrgMaintenanceTaskMutationVariables, options?: RequestInit['headers']) => fetcher<EditOrgMaintenanceTaskMutation, EditOrgMaintenanceTaskMutationVariables>(EditOrgMaintenanceTaskDocument, variables, options);
export const DeleteOrgMaintenanceTaskDocument = `
    mutation deleteOrgMaintenanceTask($id: String!) {
  deleteOrgMaintenanceTask(id: $id)
}
    `;
export const useDeleteOrgMaintenanceTaskMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOrgMaintenanceTaskMutation, TError, DeleteOrgMaintenanceTaskMutationVariables, TContext>) =>
    useMutation<DeleteOrgMaintenanceTaskMutation, TError, DeleteOrgMaintenanceTaskMutationVariables, TContext>(
      ['deleteOrgMaintenanceTask'],
      (variables?: DeleteOrgMaintenanceTaskMutationVariables) => fetcher<DeleteOrgMaintenanceTaskMutation, DeleteOrgMaintenanceTaskMutationVariables>(DeleteOrgMaintenanceTaskDocument, variables)(),
      options
    );
useDeleteOrgMaintenanceTaskMutation.getKey = () => ['deleteOrgMaintenanceTask'];

useDeleteOrgMaintenanceTaskMutation.fetcher = (variables: DeleteOrgMaintenanceTaskMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteOrgMaintenanceTaskMutation, DeleteOrgMaintenanceTaskMutationVariables>(DeleteOrgMaintenanceTaskDocument, variables, options);
export const GetAllOrgMaintenanceTasksDocument = `
    query getAllOrgMaintenanceTasks {
  orgMaintenanceTasks {
    data {
      _id
      label
      startDate
      endDate
      status
    }
  }
}
    `;
export const useGetAllOrgMaintenanceTasksQuery = <
      TData = GetAllOrgMaintenanceTasksQuery,
      TError = Exception
    >(
      variables?: GetAllOrgMaintenanceTasksQueryVariables,
      options?: UseQueryOptions<GetAllOrgMaintenanceTasksQuery, TError, TData>
    ) =>
    useQuery<GetAllOrgMaintenanceTasksQuery, TError, TData>(
      variables === undefined ? ['getAllOrgMaintenanceTasks'] : ['getAllOrgMaintenanceTasks', variables],
      fetcher<GetAllOrgMaintenanceTasksQuery, GetAllOrgMaintenanceTasksQueryVariables>(GetAllOrgMaintenanceTasksDocument, variables),
      options
    );

useGetAllOrgMaintenanceTasksQuery.getKey = (variables?: GetAllOrgMaintenanceTasksQueryVariables) => variables === undefined ? ['getAllOrgMaintenanceTasks'] : ['getAllOrgMaintenanceTasks', variables];
;

useGetAllOrgMaintenanceTasksQuery.fetcher = (variables?: GetAllOrgMaintenanceTasksQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllOrgMaintenanceTasksQuery, GetAllOrgMaintenanceTasksQueryVariables>(GetAllOrgMaintenanceTasksDocument, variables, options);
export const CompleteOrgMaintenanceTaskDocument = `
    mutation completeOrgMaintenanceTask($id: ObjectId!) {
  completeOrgMaintenanceTask(id: $id) {
    _id
  }
}
    `;
export const useCompleteOrgMaintenanceTaskMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteOrgMaintenanceTaskMutation, TError, CompleteOrgMaintenanceTaskMutationVariables, TContext>) =>
    useMutation<CompleteOrgMaintenanceTaskMutation, TError, CompleteOrgMaintenanceTaskMutationVariables, TContext>(
      ['completeOrgMaintenanceTask'],
      (variables?: CompleteOrgMaintenanceTaskMutationVariables) => fetcher<CompleteOrgMaintenanceTaskMutation, CompleteOrgMaintenanceTaskMutationVariables>(CompleteOrgMaintenanceTaskDocument, variables)(),
      options
    );
useCompleteOrgMaintenanceTaskMutation.getKey = () => ['completeOrgMaintenanceTask'];

useCompleteOrgMaintenanceTaskMutation.fetcher = (variables: CompleteOrgMaintenanceTaskMutationVariables, options?: RequestInit['headers']) => fetcher<CompleteOrgMaintenanceTaskMutation, CompleteOrgMaintenanceTaskMutationVariables>(CompleteOrgMaintenanceTaskDocument, variables, options);
export const ReportingDashboardDocument = `
    query reportingDashboard {
  reportingDashboard {
    key
    label
    description
    resourceType
  }
}
    `;
export const useReportingDashboardQuery = <
      TData = ReportingDashboardQuery,
      TError = Exception
    >(
      variables?: ReportingDashboardQueryVariables,
      options?: UseQueryOptions<ReportingDashboardQuery, TError, TData>
    ) =>
    useQuery<ReportingDashboardQuery, TError, TData>(
      variables === undefined ? ['reportingDashboard'] : ['reportingDashboard', variables],
      fetcher<ReportingDashboardQuery, ReportingDashboardQueryVariables>(ReportingDashboardDocument, variables),
      options
    );

useReportingDashboardQuery.getKey = (variables?: ReportingDashboardQueryVariables) => variables === undefined ? ['reportingDashboard'] : ['reportingDashboard', variables];
;

useReportingDashboardQuery.fetcher = (variables?: ReportingDashboardQueryVariables, options?: RequestInit['headers']) => fetcher<ReportingDashboardQuery, ReportingDashboardQueryVariables>(ReportingDashboardDocument, variables, options);
export const ReportingDashboardEmbedTokenDocument = `
    query reportingDashboardEmbedToken($timezone: String) {
  reportingDashboardEmbedToken(timezone: $timezone) {
    token
    iframeUrl
  }
}
    `;
export const useReportingDashboardEmbedTokenQuery = <
      TData = ReportingDashboardEmbedTokenQuery,
      TError = Exception
    >(
      variables?: ReportingDashboardEmbedTokenQueryVariables,
      options?: UseQueryOptions<ReportingDashboardEmbedTokenQuery, TError, TData>
    ) =>
    useQuery<ReportingDashboardEmbedTokenQuery, TError, TData>(
      variables === undefined ? ['reportingDashboardEmbedToken'] : ['reportingDashboardEmbedToken', variables],
      fetcher<ReportingDashboardEmbedTokenQuery, ReportingDashboardEmbedTokenQueryVariables>(ReportingDashboardEmbedTokenDocument, variables),
      options
    );

useReportingDashboardEmbedTokenQuery.getKey = (variables?: ReportingDashboardEmbedTokenQueryVariables) => variables === undefined ? ['reportingDashboardEmbedToken'] : ['reportingDashboardEmbedToken', variables];
;

useReportingDashboardEmbedTokenQuery.fetcher = (variables?: ReportingDashboardEmbedTokenQueryVariables, options?: RequestInit['headers']) => fetcher<ReportingDashboardEmbedTokenQuery, ReportingDashboardEmbedTokenQueryVariables>(ReportingDashboardEmbedTokenDocument, variables, options);
export const GetAllAssetsLocationsDocument = `
    query getAllAssetsLocations {
  tractors {
    data {
      _id
      serialNumber
      lastKnownLocation {
        latitude
        longitude
        heading
        speed
      }
      lastKnownLocationDate
    }
  }
  trailers {
    data {
      _id
      serialNumber
      type
      lastKnownLocation {
        latitude
        longitude
        heading
        speed
      }
      lastKnownLocationDate
    }
  }
  drivers {
    data {
      _id
      firstname
      lastname
      phoneNumber
      lastKnownLocation {
        latitude
        longitude
        heading
        speed
      }
      lastKnownLocationDate
      status
      hos {
        currentDrivingTime
        currentOnDutyTime
        currentStatus
        statusTime
        totalDrivingTime
        totalOnDutyTime
      }
    }
  }
  chassis {
    data {
      _id
      serialNumber
      lastKnownLocation {
        latitude
        longitude
        heading
        speed
      }
      lastKnownLocationDate
    }
  }
}
    `;
export const useGetAllAssetsLocationsQuery = <
      TData = GetAllAssetsLocationsQuery,
      TError = Exception
    >(
      variables?: GetAllAssetsLocationsQueryVariables,
      options?: UseQueryOptions<GetAllAssetsLocationsQuery, TError, TData>
    ) =>
    useQuery<GetAllAssetsLocationsQuery, TError, TData>(
      variables === undefined ? ['getAllAssetsLocations'] : ['getAllAssetsLocations', variables],
      fetcher<GetAllAssetsLocationsQuery, GetAllAssetsLocationsQueryVariables>(GetAllAssetsLocationsDocument, variables),
      options
    );

useGetAllAssetsLocationsQuery.getKey = (variables?: GetAllAssetsLocationsQueryVariables) => variables === undefined ? ['getAllAssetsLocations'] : ['getAllAssetsLocations', variables];
;

useGetAllAssetsLocationsQuery.fetcher = (variables?: GetAllAssetsLocationsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllAssetsLocationsQuery, GetAllAssetsLocationsQueryVariables>(GetAllAssetsLocationsDocument, variables, options);
export const GetTodayTripsDocument = `
    query getTodayTrips($timezone: String!) {
  trips(plannedForToday: true, timezone: $timezone) {
    data {
      _id
      tripNumber
      routeDistance
      firstPickupTime
      status
      driver {
        firstname
        lastname
      }
      shipmentLocations {
        _id
        tripShipmentLocationId
        shipmentId
        shipmentIds
        shipmentLocationIds
        location {
          latitude
          longitude
        }
        locationType
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        shippedGoods {
          _id
          label
          quantity
          weight
          unit
        }
        receivedGoods {
          goodId
          quantity
        }
        arrivalTime
        waitingDuration
        setupDuration
        serviceDuration
        timeWindows {
          fromDate
          toDate
        }
      }
      shipments {
        _id
        shipmentNumber
        referenceNumbers
        shipmentLocations {
          _id
          location {
            latitude
            longitude
          }
          locationType
          shipper {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          receiver {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          shippedGoods {
            _id
            label
            quantity
            weight
            unit
            supplier {
              _id
              name
            }
          }
          receivedGoods {
            goodId
            quantity
          }
          timeWindows {
            fromDate
            toDate
          }
        }
        charges {
          _id
          rate
          unit
          total
        }
        trailerType
        status
        customer {
          _id
          name
        }
        route {
          routeDistance
          firstPickupTime
          locations {
            _id
            locationType
            shipper {
              _id
              name
              address {
                label
              }
            }
            receiver {
              _id
              name
              address {
                label
              }
            }
            timeWindows {
              fromDate
              toDate
            }
          }
        }
        events {
          _id
          type
          label
          description
          date
          shipmentLocation
          metadata
        }
        issues {
          _id
          type
          content
          date
          shipmentLocation
          delayAmount
          attachedDocuments
        }
      }
      polyline
      trailer {
        _id
        type
        serialNumber
      }
      tractor {
        _id
        serialNumber
      }
      driver {
        _id
        firstname
        lastname
      }
      carrier {
        _id
        name
      }
    }
    count
  }
}
    `;
export const useGetTodayTripsQuery = <
      TData = GetTodayTripsQuery,
      TError = Exception
    >(
      variables: GetTodayTripsQueryVariables,
      options?: UseQueryOptions<GetTodayTripsQuery, TError, TData>
    ) =>
    useQuery<GetTodayTripsQuery, TError, TData>(
      ['getTodayTrips', variables],
      fetcher<GetTodayTripsQuery, GetTodayTripsQueryVariables>(GetTodayTripsDocument, variables),
      options
    );

useGetTodayTripsQuery.getKey = (variables: GetTodayTripsQueryVariables) => ['getTodayTrips', variables];
;

useGetTodayTripsQuery.fetcher = (variables: GetTodayTripsQueryVariables, options?: RequestInit['headers']) => fetcher<GetTodayTripsQuery, GetTodayTripsQueryVariables>(GetTodayTripsDocument, variables, options);
export const GetLoadTrackingBoardShipmentsDocument = `
    query getLoadTrackingBoardShipments($status: Status, $plannedForToday: Boolean, $timezone: String) {
  shipments(
    status: $status
    plannedForToday: $plannedForToday
    timezone: $timezone
  ) {
    data {
      _id
      billOfLadingNumbers
      purchaseOrderNumbers
      shipmentNumber
      referenceNumbers
      route {
        routeDistance
        firstPickupTime
      }
      charges {
        _id
        total
        label
        rate
        unit
        unitType
        billingRule {
          _id
          label
          referenceNumber
        }
      }
      trailerType
      status
      customer {
        _id
        name
      }
      createdBy
      shipmentLocations {
        _id
        location {
          latitude
          longitude
        }
        locationType
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        shippedGoods {
          _id
          label
          quantity
          weight
          unit
        }
        receivedGoods {
          goodId
          quantity
        }
        timeWindows {
          fromDate
          toDate
        }
      }
      route {
        routeDistance
        firstPickupTime
        locations {
          _id
          shipper {
            _id
          }
          receiver {
            _id
          }
          timeWindows {
            fromDate
            toDate
          }
        }
      }
      events {
        _id
        type
        label
        description
        date
        shipmentLocation
        metadata
      }
      issues {
        _id
        type
        content
        date
        shipmentLocation
        delayAmount
        attachedDocuments
      }
    }
  }
}
    `;
export const useGetLoadTrackingBoardShipmentsQuery = <
      TData = GetLoadTrackingBoardShipmentsQuery,
      TError = Exception
    >(
      variables?: GetLoadTrackingBoardShipmentsQueryVariables,
      options?: UseQueryOptions<GetLoadTrackingBoardShipmentsQuery, TError, TData>
    ) =>
    useQuery<GetLoadTrackingBoardShipmentsQuery, TError, TData>(
      variables === undefined ? ['getLoadTrackingBoardShipments'] : ['getLoadTrackingBoardShipments', variables],
      fetcher<GetLoadTrackingBoardShipmentsQuery, GetLoadTrackingBoardShipmentsQueryVariables>(GetLoadTrackingBoardShipmentsDocument, variables),
      options
    );

useGetLoadTrackingBoardShipmentsQuery.getKey = (variables?: GetLoadTrackingBoardShipmentsQueryVariables) => variables === undefined ? ['getLoadTrackingBoardShipments'] : ['getLoadTrackingBoardShipments', variables];
;

useGetLoadTrackingBoardShipmentsQuery.fetcher = (variables?: GetLoadTrackingBoardShipmentsQueryVariables, options?: RequestInit['headers']) => fetcher<GetLoadTrackingBoardShipmentsQuery, GetLoadTrackingBoardShipmentsQueryVariables>(GetLoadTrackingBoardShipmentsDocument, variables, options);
export const GetOrderListDocument = `
    query getOrderList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $status: Status) {
  orders(
    search: $search
    skip: $skip
    take: $take
    status: $status
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      orderNumber
      customer {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      status
      locations {
        _id
        locationType
        location {
          latitude
          longitude
        }
        name
        addressLabel
        addressTimezone
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        timeWindows {
          fromDate
          toDate
        }
        receivedGoods {
          goodId
          goodProfileId
          goodProfile {
            _id
            label
            code
            unit
            weight
          }
          quantity
        }
      }
    }
    count
  }
}
    `;
export const useGetOrderListQuery = <
      TData = GetOrderListQuery,
      TError = Exception
    >(
      variables?: GetOrderListQueryVariables,
      options?: UseQueryOptions<GetOrderListQuery, TError, TData>
    ) =>
    useQuery<GetOrderListQuery, TError, TData>(
      variables === undefined ? ['getOrderList'] : ['getOrderList', variables],
      fetcher<GetOrderListQuery, GetOrderListQueryVariables>(GetOrderListDocument, variables),
      options
    );

useGetOrderListQuery.getKey = (variables?: GetOrderListQueryVariables) => variables === undefined ? ['getOrderList'] : ['getOrderList', variables];
;

useGetOrderListQuery.fetcher = (variables?: GetOrderListQueryVariables, options?: RequestInit['headers']) => fetcher<GetOrderListQuery, GetOrderListQueryVariables>(GetOrderListDocument, variables, options);
export const GetOrderDetailsDocument = `
    query getOrderDetails($id: String!) {
  orderById(id: $id) {
    _id
    orderNumber
    customerId
    customer {
      _id
      name
      address {
        label
      }
      addressTimezone
    }
    status
    locations {
      _id
      locationType
      location {
        latitude
        longitude
      }
      name
      addressLabel
      addressTimezone
      shipper {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      receiver {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      timeWindows {
        fromDate
        toDate
      }
      receivedGoods {
        goodId
        goodProfileId
        goodProfile {
          _id
          label
          code
          unit
          weight
        }
        quantity
      }
    }
  }
}
    `;
export const useGetOrderDetailsQuery = <
      TData = GetOrderDetailsQuery,
      TError = Exception
    >(
      variables: GetOrderDetailsQueryVariables,
      options?: UseQueryOptions<GetOrderDetailsQuery, TError, TData>
    ) =>
    useQuery<GetOrderDetailsQuery, TError, TData>(
      ['getOrderDetails', variables],
      fetcher<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>(GetOrderDetailsDocument, variables),
      options
    );

useGetOrderDetailsQuery.getKey = (variables: GetOrderDetailsQueryVariables) => ['getOrderDetails', variables];
;

useGetOrderDetailsQuery.fetcher = (variables: GetOrderDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>(GetOrderDetailsDocument, variables, options);
export const DeleteOrderDocument = `
    mutation deleteOrder($id: String!) {
  deleteOrder(id: $id)
}
    `;
export const useDeleteOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOrderMutation, TError, DeleteOrderMutationVariables, TContext>) =>
    useMutation<DeleteOrderMutation, TError, DeleteOrderMutationVariables, TContext>(
      ['deleteOrder'],
      (variables?: DeleteOrderMutationVariables) => fetcher<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, variables)(),
      options
    );
useDeleteOrderMutation.getKey = () => ['deleteOrder'];

useDeleteOrderMutation.fetcher = (variables: DeleteOrderMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, variables, options);
export const AddOrderDocument = `
    mutation addOrder($newOrderData: NewOrderInput!) {
  addOrder(newOrderData: $newOrderData) {
    _id
  }
}
    `;
export const useAddOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddOrderMutation, TError, AddOrderMutationVariables, TContext>) =>
    useMutation<AddOrderMutation, TError, AddOrderMutationVariables, TContext>(
      ['addOrder'],
      (variables?: AddOrderMutationVariables) => fetcher<AddOrderMutation, AddOrderMutationVariables>(AddOrderDocument, variables)(),
      options
    );
useAddOrderMutation.getKey = () => ['addOrder'];

useAddOrderMutation.fetcher = (variables: AddOrderMutationVariables, options?: RequestInit['headers']) => fetcher<AddOrderMutation, AddOrderMutationVariables>(AddOrderDocument, variables, options);
export const EditOrderDocument = `
    mutation editOrder($id: String!, $editOrderData: OrderUpdateInput!) {
  editOrder(id: $id, editOrderData: $editOrderData) {
    _id
  }
}
    `;
export const useEditOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditOrderMutation, TError, EditOrderMutationVariables, TContext>) =>
    useMutation<EditOrderMutation, TError, EditOrderMutationVariables, TContext>(
      ['editOrder'],
      (variables?: EditOrderMutationVariables) => fetcher<EditOrderMutation, EditOrderMutationVariables>(EditOrderDocument, variables)(),
      options
    );
useEditOrderMutation.getKey = () => ['editOrder'];

useEditOrderMutation.fetcher = (variables: EditOrderMutationVariables, options?: RequestInit['headers']) => fetcher<EditOrderMutation, EditOrderMutationVariables>(EditOrderDocument, variables, options);
export const BulkAddOrdersDocument = `
    mutation bulkAddOrders($newOrdersData: [NewOrderInput!]!) {
  bulkAddOrders(newOrdersData: $newOrdersData) {
    _id
  }
}
    `;
export const useBulkAddOrdersMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddOrdersMutation, TError, BulkAddOrdersMutationVariables, TContext>) =>
    useMutation<BulkAddOrdersMutation, TError, BulkAddOrdersMutationVariables, TContext>(
      ['bulkAddOrders'],
      (variables?: BulkAddOrdersMutationVariables) => fetcher<BulkAddOrdersMutation, BulkAddOrdersMutationVariables>(BulkAddOrdersDocument, variables)(),
      options
    );
useBulkAddOrdersMutation.getKey = () => ['bulkAddOrders'];

useBulkAddOrdersMutation.fetcher = (variables: BulkAddOrdersMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddOrdersMutation, BulkAddOrdersMutationVariables>(BulkAddOrdersDocument, variables, options);
export const BulkEditShipmentsDocument = `
    mutation bulkEditShipments($editshipmentsData: ShipmentUpdateInput!, $ids: [ObjectId!]!) {
  bulkEditShipments(editshipmentsData: $editshipmentsData, ids: $ids) {
    matchedCount
    modifiedCount
    upsertedCount
  }
}
    `;
export const useBulkEditShipmentsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<BulkEditShipmentsMutation, TError, BulkEditShipmentsMutationVariables, TContext>) =>
    useMutation<BulkEditShipmentsMutation, TError, BulkEditShipmentsMutationVariables, TContext>(
      ['bulkEditShipments'],
      (variables?: BulkEditShipmentsMutationVariables) => fetcher<BulkEditShipmentsMutation, BulkEditShipmentsMutationVariables>(BulkEditShipmentsDocument, variables)(),
      options
    );
useBulkEditShipmentsMutation.getKey = () => ['bulkEditShipments'];

useBulkEditShipmentsMutation.fetcher = (variables: BulkEditShipmentsMutationVariables, options?: RequestInit['headers']) => fetcher<BulkEditShipmentsMutation, BulkEditShipmentsMutationVariables>(BulkEditShipmentsDocument, variables, options);
export const MyDocumentsDocument = `
    query myDocuments {
  myDocuments {
    _id
    name
    url
  }
}
    `;
export const useMyDocumentsQuery = <
      TData = MyDocumentsQuery,
      TError = Exception
    >(
      variables?: MyDocumentsQueryVariables,
      options?: UseQueryOptions<MyDocumentsQuery, TError, TData>
    ) =>
    useQuery<MyDocumentsQuery, TError, TData>(
      variables === undefined ? ['myDocuments'] : ['myDocuments', variables],
      fetcher<MyDocumentsQuery, MyDocumentsQueryVariables>(MyDocumentsDocument, variables),
      options
    );

useMyDocumentsQuery.getKey = (variables?: MyDocumentsQueryVariables) => variables === undefined ? ['myDocuments'] : ['myDocuments', variables];
;

useMyDocumentsQuery.fetcher = (variables?: MyDocumentsQueryVariables, options?: RequestInit['headers']) => fetcher<MyDocumentsQuery, MyDocumentsQueryVariables>(MyDocumentsDocument, variables, options);
export const AddOrgDocDocument = `
    mutation addOrgDoc($newOrganizationDocumentData: NewOrganizationDocumentInput!) {
  addOrgDoc(newOrganizationDocumentData: $newOrganizationDocumentData) {
    _id
    name
    url
  }
}
    `;
export const useAddOrgDocMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddOrgDocMutation, TError, AddOrgDocMutationVariables, TContext>) =>
    useMutation<AddOrgDocMutation, TError, AddOrgDocMutationVariables, TContext>(
      ['addOrgDoc'],
      (variables?: AddOrgDocMutationVariables) => fetcher<AddOrgDocMutation, AddOrgDocMutationVariables>(AddOrgDocDocument, variables)(),
      options
    );
useAddOrgDocMutation.getKey = () => ['addOrgDoc'];

useAddOrgDocMutation.fetcher = (variables: AddOrgDocMutationVariables, options?: RequestInit['headers']) => fetcher<AddOrgDocMutation, AddOrgDocMutationVariables>(AddOrgDocDocument, variables, options);
export const EditOrgDocDocument = `
    mutation editOrgDoc($id: ObjectId!, $organizationDocumentData: OrganizationDocumentUpdateInput!) {
  editOrgDoc(id: $id, organizationDocumentData: $organizationDocumentData)
}
    `;
export const useEditOrgDocMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditOrgDocMutation, TError, EditOrgDocMutationVariables, TContext>) =>
    useMutation<EditOrgDocMutation, TError, EditOrgDocMutationVariables, TContext>(
      ['editOrgDoc'],
      (variables?: EditOrgDocMutationVariables) => fetcher<EditOrgDocMutation, EditOrgDocMutationVariables>(EditOrgDocDocument, variables)(),
      options
    );
useEditOrgDocMutation.getKey = () => ['editOrgDoc'];

useEditOrgDocMutation.fetcher = (variables: EditOrgDocMutationVariables, options?: RequestInit['headers']) => fetcher<EditOrgDocMutation, EditOrgDocMutationVariables>(EditOrgDocDocument, variables, options);
export const DeleteOrgDocDocument = `
    mutation deleteOrgDoc($id: ObjectId!) {
  deleteOrgDoc(id: $id)
}
    `;
export const useDeleteOrgDocMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOrgDocMutation, TError, DeleteOrgDocMutationVariables, TContext>) =>
    useMutation<DeleteOrgDocMutation, TError, DeleteOrgDocMutationVariables, TContext>(
      ['deleteOrgDoc'],
      (variables?: DeleteOrgDocMutationVariables) => fetcher<DeleteOrgDocMutation, DeleteOrgDocMutationVariables>(DeleteOrgDocDocument, variables)(),
      options
    );
useDeleteOrgDocMutation.getKey = () => ['deleteOrgDoc'];

useDeleteOrgDocMutation.fetcher = (variables: DeleteOrgDocMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteOrgDocMutation, DeleteOrgDocMutationVariables>(DeleteOrgDocDocument, variables, options);
export const MyOrganizationDocument = `
    query myOrganization {
  myOrganization {
    _id
    address
    contactFullname
    dotNumber
    email
    name
    phoneNumber
    taxId
  }
}
    `;
export const useMyOrganizationQuery = <
      TData = MyOrganizationQuery,
      TError = Exception
    >(
      variables?: MyOrganizationQueryVariables,
      options?: UseQueryOptions<MyOrganizationQuery, TError, TData>
    ) =>
    useQuery<MyOrganizationQuery, TError, TData>(
      variables === undefined ? ['myOrganization'] : ['myOrganization', variables],
      fetcher<MyOrganizationQuery, MyOrganizationQueryVariables>(MyOrganizationDocument, variables),
      options
    );

useMyOrganizationQuery.getKey = (variables?: MyOrganizationQueryVariables) => variables === undefined ? ['myOrganization'] : ['myOrganization', variables];
;

useMyOrganizationQuery.fetcher = (variables?: MyOrganizationQueryVariables, options?: RequestInit['headers']) => fetcher<MyOrganizationQuery, MyOrganizationQueryVariables>(MyOrganizationDocument, variables, options);
export const EditOrganizationDocument = `
    mutation editOrganization($organizationSetupData: OrganizationUpdateInput!) {
  editOrganization(organizationSetupData: $organizationSetupData)
}
    `;
export const useEditOrganizationMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditOrganizationMutation, TError, EditOrganizationMutationVariables, TContext>) =>
    useMutation<EditOrganizationMutation, TError, EditOrganizationMutationVariables, TContext>(
      ['editOrganization'],
      (variables?: EditOrganizationMutationVariables) => fetcher<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, variables)(),
      options
    );
useEditOrganizationMutation.getKey = () => ['editOrganization'];

useEditOrganizationMutation.fetcher = (variables: EditOrganizationMutationVariables, options?: RequestInit['headers']) => fetcher<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, variables, options);
export const GetQualificationsDocument = `
    query getQualifications($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $assetType: TripAssetTypes, $assetId: ObjectId) {
  qualifications(
    search: $search
    skip: $skip
    take: $take
    assetType: $assetType
    assetId: $assetId
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      assetType
      assetId
      label
      number
      required
      startDate
      endDate
      documents {
        _id
        name
        url
      }
    }
  }
}
    `;
export const useGetQualificationsQuery = <
      TData = GetQualificationsQuery,
      TError = Exception
    >(
      variables?: GetQualificationsQueryVariables,
      options?: UseQueryOptions<GetQualificationsQuery, TError, TData>
    ) =>
    useQuery<GetQualificationsQuery, TError, TData>(
      variables === undefined ? ['getQualifications'] : ['getQualifications', variables],
      fetcher<GetQualificationsQuery, GetQualificationsQueryVariables>(GetQualificationsDocument, variables),
      options
    );

useGetQualificationsQuery.getKey = (variables?: GetQualificationsQueryVariables) => variables === undefined ? ['getQualifications'] : ['getQualifications', variables];
;

useGetQualificationsQuery.fetcher = (variables?: GetQualificationsQueryVariables, options?: RequestInit['headers']) => fetcher<GetQualificationsQuery, GetQualificationsQueryVariables>(GetQualificationsDocument, variables, options);
export const GetQualificationDetailsDocument = `
    query getQualificationDetails($id: String!) {
  qualificationById(id: $id) {
    _id
    assetType
    assetId
    label
    number
    startDate
    endDate
    required
    documents {
      _id
      name
      url
    }
  }
}
    `;
export const useGetQualificationDetailsQuery = <
      TData = GetQualificationDetailsQuery,
      TError = Exception
    >(
      variables: GetQualificationDetailsQueryVariables,
      options?: UseQueryOptions<GetQualificationDetailsQuery, TError, TData>
    ) =>
    useQuery<GetQualificationDetailsQuery, TError, TData>(
      ['getQualificationDetails', variables],
      fetcher<GetQualificationDetailsQuery, GetQualificationDetailsQueryVariables>(GetQualificationDetailsDocument, variables),
      options
    );

useGetQualificationDetailsQuery.getKey = (variables: GetQualificationDetailsQueryVariables) => ['getQualificationDetails', variables];
;

useGetQualificationDetailsQuery.fetcher = (variables: GetQualificationDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetQualificationDetailsQuery, GetQualificationDetailsQueryVariables>(GetQualificationDetailsDocument, variables, options);
export const AddQualificationDocument = `
    mutation addQualification($newQualificationData: NewQualificationInput!) {
  addQualification(newQualificationData: $newQualificationData) {
    _id
  }
}
    `;
export const useAddQualificationMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddQualificationMutation, TError, AddQualificationMutationVariables, TContext>) =>
    useMutation<AddQualificationMutation, TError, AddQualificationMutationVariables, TContext>(
      ['addQualification'],
      (variables?: AddQualificationMutationVariables) => fetcher<AddQualificationMutation, AddQualificationMutationVariables>(AddQualificationDocument, variables)(),
      options
    );
useAddQualificationMutation.getKey = () => ['addQualification'];

useAddQualificationMutation.fetcher = (variables: AddQualificationMutationVariables, options?: RequestInit['headers']) => fetcher<AddQualificationMutation, AddQualificationMutationVariables>(AddQualificationDocument, variables, options);
export const EditQualificationDocument = `
    mutation editQualification($id: String!, $editQualificationData: QualificationUpdateInput!) {
  editQualification(id: $id, editQualificationData: $editQualificationData) {
    _id
  }
}
    `;
export const useEditQualificationMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditQualificationMutation, TError, EditQualificationMutationVariables, TContext>) =>
    useMutation<EditQualificationMutation, TError, EditQualificationMutationVariables, TContext>(
      ['editQualification'],
      (variables?: EditQualificationMutationVariables) => fetcher<EditQualificationMutation, EditQualificationMutationVariables>(EditQualificationDocument, variables)(),
      options
    );
useEditQualificationMutation.getKey = () => ['editQualification'];

useEditQualificationMutation.fetcher = (variables: EditQualificationMutationVariables, options?: RequestInit['headers']) => fetcher<EditQualificationMutation, EditQualificationMutationVariables>(EditQualificationDocument, variables, options);
export const DeleteQualificationDocument = `
    mutation deleteQualification($id: String!) {
  deleteQualification(id: $id)
}
    `;
export const useDeleteQualificationMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteQualificationMutation, TError, DeleteQualificationMutationVariables, TContext>) =>
    useMutation<DeleteQualificationMutation, TError, DeleteQualificationMutationVariables, TContext>(
      ['deleteQualification'],
      (variables?: DeleteQualificationMutationVariables) => fetcher<DeleteQualificationMutation, DeleteQualificationMutationVariables>(DeleteQualificationDocument, variables)(),
      options
    );
useDeleteQualificationMutation.getKey = () => ['deleteQualification'];

useDeleteQualificationMutation.fetcher = (variables: DeleteQualificationMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteQualificationMutation, DeleteQualificationMutationVariables>(DeleteQualificationDocument, variables, options);
export const GetAllQualificationsDocument = `
    query getAllQualifications {
  qualifications {
    data {
      _id
      assetType
      assetId
      label
      startDate
      endDate
      required
    }
  }
}
    `;
export const useGetAllQualificationsQuery = <
      TData = GetAllQualificationsQuery,
      TError = Exception
    >(
      variables?: GetAllQualificationsQueryVariables,
      options?: UseQueryOptions<GetAllQualificationsQuery, TError, TData>
    ) =>
    useQuery<GetAllQualificationsQuery, TError, TData>(
      variables === undefined ? ['getAllQualifications'] : ['getAllQualifications', variables],
      fetcher<GetAllQualificationsQuery, GetAllQualificationsQueryVariables>(GetAllQualificationsDocument, variables),
      options
    );

useGetAllQualificationsQuery.getKey = (variables?: GetAllQualificationsQueryVariables) => variables === undefined ? ['getAllQualifications'] : ['getAllQualifications', variables];
;

useGetAllQualificationsQuery.fetcher = (variables?: GetAllQualificationsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllQualificationsQuery, GetAllQualificationsQueryVariables>(GetAllQualificationsDocument, variables, options);
export const GetReasonCodesDocument = `
    query getReasonCodes($search: String, $skip: Int, $take: Int, $filter: JSON) {
  reasonCodes(search: $search, skip: $skip, take: $take, filter: $filter) {
    data {
      _id
      createdAt
      createdBy
      description
      shipmentId
      tripId
      locationId
      type
      updatedAt
    }
  }
}
    `;
export const useGetReasonCodesQuery = <
      TData = GetReasonCodesQuery,
      TError = Exception
    >(
      variables?: GetReasonCodesQueryVariables,
      options?: UseQueryOptions<GetReasonCodesQuery, TError, TData>
    ) =>
    useQuery<GetReasonCodesQuery, TError, TData>(
      variables === undefined ? ['getReasonCodes'] : ['getReasonCodes', variables],
      fetcher<GetReasonCodesQuery, GetReasonCodesQueryVariables>(GetReasonCodesDocument, variables),
      options
    );

useGetReasonCodesQuery.getKey = (variables?: GetReasonCodesQueryVariables) => variables === undefined ? ['getReasonCodes'] : ['getReasonCodes', variables];
;

useGetReasonCodesQuery.fetcher = (variables?: GetReasonCodesQueryVariables, options?: RequestInit['headers']) => fetcher<GetReasonCodesQuery, GetReasonCodesQueryVariables>(GetReasonCodesDocument, variables, options);
export const GetReasonCodeDetailsDocument = `
    query getReasonCodeDetails($id: ObjectId!) {
  reasonCodeById(id: $id) {
    _id
    createdAt
    createdBy
    description
    shipmentId
    tripId
    locationId
    type
    updatedAt
  }
}
    `;
export const useGetReasonCodeDetailsQuery = <
      TData = GetReasonCodeDetailsQuery,
      TError = Exception
    >(
      variables: GetReasonCodeDetailsQueryVariables,
      options?: UseQueryOptions<GetReasonCodeDetailsQuery, TError, TData>
    ) =>
    useQuery<GetReasonCodeDetailsQuery, TError, TData>(
      ['getReasonCodeDetails', variables],
      fetcher<GetReasonCodeDetailsQuery, GetReasonCodeDetailsQueryVariables>(GetReasonCodeDetailsDocument, variables),
      options
    );

useGetReasonCodeDetailsQuery.getKey = (variables: GetReasonCodeDetailsQueryVariables) => ['getReasonCodeDetails', variables];
;

useGetReasonCodeDetailsQuery.fetcher = (variables: GetReasonCodeDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetReasonCodeDetailsQuery, GetReasonCodeDetailsQueryVariables>(GetReasonCodeDetailsDocument, variables, options);
export const AddReasonCodeDocument = `
    mutation addReasonCode($newReasonCodeData: NewReasonCodeInput!) {
  addReasonCode(newReasonCodeData: $newReasonCodeData) {
    _id
  }
}
    `;
export const useAddReasonCodeMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddReasonCodeMutation, TError, AddReasonCodeMutationVariables, TContext>) =>
    useMutation<AddReasonCodeMutation, TError, AddReasonCodeMutationVariables, TContext>(
      ['addReasonCode'],
      (variables?: AddReasonCodeMutationVariables) => fetcher<AddReasonCodeMutation, AddReasonCodeMutationVariables>(AddReasonCodeDocument, variables)(),
      options
    );
useAddReasonCodeMutation.getKey = () => ['addReasonCode'];

useAddReasonCodeMutation.fetcher = (variables: AddReasonCodeMutationVariables, options?: RequestInit['headers']) => fetcher<AddReasonCodeMutation, AddReasonCodeMutationVariables>(AddReasonCodeDocument, variables, options);
export const EditReasonCodeDocument = `
    mutation editReasonCode($id: ObjectId!, $editReasonCodeData: ReasonCodeUpdateInput!) {
  editReasonCode(id: $id, editReasonCodeData: $editReasonCodeData) {
    _id
  }
}
    `;
export const useEditReasonCodeMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditReasonCodeMutation, TError, EditReasonCodeMutationVariables, TContext>) =>
    useMutation<EditReasonCodeMutation, TError, EditReasonCodeMutationVariables, TContext>(
      ['editReasonCode'],
      (variables?: EditReasonCodeMutationVariables) => fetcher<EditReasonCodeMutation, EditReasonCodeMutationVariables>(EditReasonCodeDocument, variables)(),
      options
    );
useEditReasonCodeMutation.getKey = () => ['editReasonCode'];

useEditReasonCodeMutation.fetcher = (variables: EditReasonCodeMutationVariables, options?: RequestInit['headers']) => fetcher<EditReasonCodeMutation, EditReasonCodeMutationVariables>(EditReasonCodeDocument, variables, options);
export const DeleteReasonCodeDocument = `
    mutation deleteReasonCode($id: ObjectId!) {
  deleteReasonCode(id: $id)
}
    `;
export const useDeleteReasonCodeMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReasonCodeMutation, TError, DeleteReasonCodeMutationVariables, TContext>) =>
    useMutation<DeleteReasonCodeMutation, TError, DeleteReasonCodeMutationVariables, TContext>(
      ['deleteReasonCode'],
      (variables?: DeleteReasonCodeMutationVariables) => fetcher<DeleteReasonCodeMutation, DeleteReasonCodeMutationVariables>(DeleteReasonCodeDocument, variables)(),
      options
    );
useDeleteReasonCodeMutation.getKey = () => ['deleteReasonCode'];

useDeleteReasonCodeMutation.fetcher = (variables: DeleteReasonCodeMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteReasonCodeMutation, DeleteReasonCodeMutationVariables>(DeleteReasonCodeDocument, variables, options);
export const GetRelationshipListDocument = `
    query getRelationshipList($search: String, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!]) {
  relationships(
    search: $search
    skip: $skip
    take: $take
    filter: $filter
    orderBy: $orderBy
  ) {
    data {
      _id
      suppliers {
        _id
        code
        name
      }
      shippers {
        _id
        code
        name
      }
      commodities {
        _id
        code
        label
      }
      receivers {
        _id
        code
        name
      }
      customers {
        _id
        code
        name
      }
    }
    count
  }
}
    `;
export const useGetRelationshipListQuery = <
      TData = GetRelationshipListQuery,
      TError = Exception
    >(
      variables?: GetRelationshipListQueryVariables,
      options?: UseQueryOptions<GetRelationshipListQuery, TError, TData>
    ) =>
    useQuery<GetRelationshipListQuery, TError, TData>(
      variables === undefined ? ['getRelationshipList'] : ['getRelationshipList', variables],
      fetcher<GetRelationshipListQuery, GetRelationshipListQueryVariables>(GetRelationshipListDocument, variables),
      options
    );

useGetRelationshipListQuery.getKey = (variables?: GetRelationshipListQueryVariables) => variables === undefined ? ['getRelationshipList'] : ['getRelationshipList', variables];
;

useGetRelationshipListQuery.fetcher = (variables?: GetRelationshipListQueryVariables, options?: RequestInit['headers']) => fetcher<GetRelationshipListQuery, GetRelationshipListQueryVariables>(GetRelationshipListDocument, variables, options);
export const GetRelationshipDetailsDocument = `
    query getRelationshipDetails($id: String!) {
  relationshipById(id: $id) {
    _id
    supplierIds
    shipperIds
    commodityIds
    receiverIds
    customerIds
    suppliers {
      _id
      name
    }
    shippers {
      _id
      name
    }
    commodities {
      _id
      label
    }
    receivers {
      _id
      name
    }
    customers {
      _id
      name
    }
  }
}
    `;
export const useGetRelationshipDetailsQuery = <
      TData = GetRelationshipDetailsQuery,
      TError = Exception
    >(
      variables: GetRelationshipDetailsQueryVariables,
      options?: UseQueryOptions<GetRelationshipDetailsQuery, TError, TData>
    ) =>
    useQuery<GetRelationshipDetailsQuery, TError, TData>(
      ['getRelationshipDetails', variables],
      fetcher<GetRelationshipDetailsQuery, GetRelationshipDetailsQueryVariables>(GetRelationshipDetailsDocument, variables),
      options
    );

useGetRelationshipDetailsQuery.getKey = (variables: GetRelationshipDetailsQueryVariables) => ['getRelationshipDetails', variables];
;

useGetRelationshipDetailsQuery.fetcher = (variables: GetRelationshipDetailsQueryVariables, options?: RequestInit['headers']) => fetcher<GetRelationshipDetailsQuery, GetRelationshipDetailsQueryVariables>(GetRelationshipDetailsDocument, variables, options);
export const AddRelationshipDocument = `
    mutation addRelationship($newRelationshipData: NewRelationshipInput!) {
  addRelationship(newRelationshipData: $newRelationshipData) {
    _id
  }
}
    `;
export const useAddRelationshipMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddRelationshipMutation, TError, AddRelationshipMutationVariables, TContext>) =>
    useMutation<AddRelationshipMutation, TError, AddRelationshipMutationVariables, TContext>(
      ['addRelationship'],
      (variables?: AddRelationshipMutationVariables) => fetcher<AddRelationshipMutation, AddRelationshipMutationVariables>(AddRelationshipDocument, variables)(),
      options
    );
useAddRelationshipMutation.getKey = () => ['addRelationship'];

useAddRelationshipMutation.fetcher = (variables: AddRelationshipMutationVariables, options?: RequestInit['headers']) => fetcher<AddRelationshipMutation, AddRelationshipMutationVariables>(AddRelationshipDocument, variables, options);
export const EditRelationshipDocument = `
    mutation editRelationship($id: String!, $editRelationshipData: RelationshipUpdateInput!) {
  editRelationship(id: $id, editRelationshipData: $editRelationshipData) {
    _id
  }
}
    `;
export const useEditRelationshipMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditRelationshipMutation, TError, EditRelationshipMutationVariables, TContext>) =>
    useMutation<EditRelationshipMutation, TError, EditRelationshipMutationVariables, TContext>(
      ['editRelationship'],
      (variables?: EditRelationshipMutationVariables) => fetcher<EditRelationshipMutation, EditRelationshipMutationVariables>(EditRelationshipDocument, variables)(),
      options
    );
useEditRelationshipMutation.getKey = () => ['editRelationship'];

useEditRelationshipMutation.fetcher = (variables: EditRelationshipMutationVariables, options?: RequestInit['headers']) => fetcher<EditRelationshipMutation, EditRelationshipMutationVariables>(EditRelationshipDocument, variables, options);
export const DeleteRelationshipDocument = `
    mutation deleteRelationship($id: String!) {
  deleteRelationship(id: $id)
}
    `;
export const useDeleteRelationshipMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRelationshipMutation, TError, DeleteRelationshipMutationVariables, TContext>) =>
    useMutation<DeleteRelationshipMutation, TError, DeleteRelationshipMutationVariables, TContext>(
      ['deleteRelationship'],
      (variables?: DeleteRelationshipMutationVariables) => fetcher<DeleteRelationshipMutation, DeleteRelationshipMutationVariables>(DeleteRelationshipDocument, variables)(),
      options
    );
useDeleteRelationshipMutation.getKey = () => ['deleteRelationship'];

useDeleteRelationshipMutation.fetcher = (variables: DeleteRelationshipMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteRelationshipMutation, DeleteRelationshipMutationVariables>(DeleteRelationshipDocument, variables, options);
export const GetAllRelationshipsDocument = `
    query getAllRelationships {
  relationships {
    data {
      supplierIds
      shipperIds
      commodityIds
      receiverIds
      customerIds
    }
  }
}
    `;
export const useGetAllRelationshipsQuery = <
      TData = GetAllRelationshipsQuery,
      TError = Exception
    >(
      variables?: GetAllRelationshipsQueryVariables,
      options?: UseQueryOptions<GetAllRelationshipsQuery, TError, TData>
    ) =>
    useQuery<GetAllRelationshipsQuery, TError, TData>(
      variables === undefined ? ['getAllRelationships'] : ['getAllRelationships', variables],
      fetcher<GetAllRelationshipsQuery, GetAllRelationshipsQueryVariables>(GetAllRelationshipsDocument, variables),
      options
    );

useGetAllRelationshipsQuery.getKey = (variables?: GetAllRelationshipsQueryVariables) => variables === undefined ? ['getAllRelationships'] : ['getAllRelationships', variables];
;

useGetAllRelationshipsQuery.fetcher = (variables?: GetAllRelationshipsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAllRelationshipsQuery, GetAllRelationshipsQueryVariables>(GetAllRelationshipsDocument, variables, options);
export const GenerateReportPdfDocument = `
    mutation generateReportPdf($reportType: ReportType!, $period: PeriodInput!, $timezone: String!, $filter: ReportFilter, $lang: String!) {
  generateReportPdf(
    reportType: $reportType
    period: $period
    timezone: $timezone
    filter: $filter
    lang: $lang
  ) {
    url
  }
}
    `;
export const useGenerateReportPdfMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateReportPdfMutation, TError, GenerateReportPdfMutationVariables, TContext>) =>
    useMutation<GenerateReportPdfMutation, TError, GenerateReportPdfMutationVariables, TContext>(
      ['generateReportPdf'],
      (variables?: GenerateReportPdfMutationVariables) => fetcher<GenerateReportPdfMutation, GenerateReportPdfMutationVariables>(GenerateReportPdfDocument, variables)(),
      options
    );
useGenerateReportPdfMutation.getKey = () => ['generateReportPdf'];

useGenerateReportPdfMutation.fetcher = (variables: GenerateReportPdfMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateReportPdfMutation, GenerateReportPdfMutationVariables>(GenerateReportPdfDocument, variables, options);
export const GenerateReportCsvDocument = `
    mutation generateReportCsv($reportType: ReportType!, $period: PeriodInput!, $timezone: String!, $filter: ReportFilter, $lang: String!) {
  generateReportCsv(
    reportType: $reportType
    period: $period
    timezone: $timezone
    filter: $filter
    lang: $lang
  ) {
    url
  }
}
    `;
export const useGenerateReportCsvMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateReportCsvMutation, TError, GenerateReportCsvMutationVariables, TContext>) =>
    useMutation<GenerateReportCsvMutation, TError, GenerateReportCsvMutationVariables, TContext>(
      ['generateReportCsv'],
      (variables?: GenerateReportCsvMutationVariables) => fetcher<GenerateReportCsvMutation, GenerateReportCsvMutationVariables>(GenerateReportCsvDocument, variables)(),
      options
    );
useGenerateReportCsvMutation.getKey = () => ['generateReportCsv'];

useGenerateReportCsvMutation.fetcher = (variables: GenerateReportCsvMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateReportCsvMutation, GenerateReportCsvMutationVariables>(GenerateReportCsvDocument, variables, options);
export const SendReportPdfDocument = `
    mutation sendReportPdf($reportType: ReportType!, $period: PeriodInput!, $timezone: String!, $filter: ReportFilter, $email: String!, $lang: String!) {
  sendReportPdf(
    reportType: $reportType
    period: $period
    timezone: $timezone
    filter: $filter
    email: $email
    lang: $lang
  ) {
    success
  }
}
    `;
export const useSendReportPdfMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SendReportPdfMutation, TError, SendReportPdfMutationVariables, TContext>) =>
    useMutation<SendReportPdfMutation, TError, SendReportPdfMutationVariables, TContext>(
      ['sendReportPdf'],
      (variables?: SendReportPdfMutationVariables) => fetcher<SendReportPdfMutation, SendReportPdfMutationVariables>(SendReportPdfDocument, variables)(),
      options
    );
useSendReportPdfMutation.getKey = () => ['sendReportPdf'];

useSendReportPdfMutation.fetcher = (variables: SendReportPdfMutationVariables, options?: RequestInit['headers']) => fetcher<SendReportPdfMutation, SendReportPdfMutationVariables>(SendReportPdfDocument, variables, options);
export const GetMetricsDocument = `
    query getMetrics($type: MetricType!, $aggregateBy: [String!]!, $dateRange: DateRangeInput) {
  metrics(type: $type, aggregateBy: $aggregateBy, dateRange: $dateRange) {
    dimensions
    type
    value
  }
}
    `;
export const useGetMetricsQuery = <
      TData = GetMetricsQuery,
      TError = Exception
    >(
      variables: GetMetricsQueryVariables,
      options?: UseQueryOptions<GetMetricsQuery, TError, TData>
    ) =>
    useQuery<GetMetricsQuery, TError, TData>(
      ['getMetrics', variables],
      fetcher<GetMetricsQuery, GetMetricsQueryVariables>(GetMetricsDocument, variables),
      options
    );

useGetMetricsQuery.getKey = (variables: GetMetricsQueryVariables) => ['getMetrics', variables];
;

useGetMetricsQuery.fetcher = (variables: GetMetricsQueryVariables, options?: RequestInit['headers']) => fetcher<GetMetricsQuery, GetMetricsQueryVariables>(GetMetricsDocument, variables, options);
export const GetBulkMetricsDocument = `
    query getBulkMetrics($types: [MetricType!]!, $aggregateBy: [String!]!, $dateRange: DateRangeInput) {
  bulkMetrics(types: $types, aggregateBy: $aggregateBy, dateRange: $dateRange) {
    dimensions
    type
    value
  }
}
    `;
export const useGetBulkMetricsQuery = <
      TData = GetBulkMetricsQuery,
      TError = Exception
    >(
      variables: GetBulkMetricsQueryVariables,
      options?: UseQueryOptions<GetBulkMetricsQuery, TError, TData>
    ) =>
    useQuery<GetBulkMetricsQuery, TError, TData>(
      ['getBulkMetrics', variables],
      fetcher<GetBulkMetricsQuery, GetBulkMetricsQueryVariables>(GetBulkMetricsDocument, variables),
      options
    );

useGetBulkMetricsQuery.getKey = (variables: GetBulkMetricsQueryVariables) => ['getBulkMetrics', variables];
;

useGetBulkMetricsQuery.fetcher = (variables: GetBulkMetricsQueryVariables, options?: RequestInit['headers']) => fetcher<GetBulkMetricsQuery, GetBulkMetricsQueryVariables>(GetBulkMetricsDocument, variables, options);
export const SavedReportsDocument = `
    query savedReports {
  savedReports {
    _id
    name
    reportKey
    filters
    createdBy
    createdAt
    updatedAt
  }
}
    `;
export const useSavedReportsQuery = <
      TData = SavedReportsQuery,
      TError = Exception
    >(
      variables?: SavedReportsQueryVariables,
      options?: UseQueryOptions<SavedReportsQuery, TError, TData>
    ) =>
    useQuery<SavedReportsQuery, TError, TData>(
      variables === undefined ? ['savedReports'] : ['savedReports', variables],
      fetcher<SavedReportsQuery, SavedReportsQueryVariables>(SavedReportsDocument, variables),
      options
    );

useSavedReportsQuery.getKey = (variables?: SavedReportsQueryVariables) => variables === undefined ? ['savedReports'] : ['savedReports', variables];
;

useSavedReportsQuery.fetcher = (variables?: SavedReportsQueryVariables, options?: RequestInit['headers']) => fetcher<SavedReportsQuery, SavedReportsQueryVariables>(SavedReportsDocument, variables, options);
export const CreateSavedReportDocument = `
    mutation createSavedReport($input: NewSavedReportInput!) {
  createSavedReport(input: $input) {
    _id
    name
    reportKey
    filters
  }
}
    `;
export const useCreateSavedReportMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSavedReportMutation, TError, CreateSavedReportMutationVariables, TContext>) =>
    useMutation<CreateSavedReportMutation, TError, CreateSavedReportMutationVariables, TContext>(
      ['createSavedReport'],
      (variables?: CreateSavedReportMutationVariables) => fetcher<CreateSavedReportMutation, CreateSavedReportMutationVariables>(CreateSavedReportDocument, variables)(),
      options
    );
useCreateSavedReportMutation.getKey = () => ['createSavedReport'];

useCreateSavedReportMutation.fetcher = (variables: CreateSavedReportMutationVariables, options?: RequestInit['headers']) => fetcher<CreateSavedReportMutation, CreateSavedReportMutationVariables>(CreateSavedReportDocument, variables, options);
export const UpdateSavedReportDocument = `
    mutation updateSavedReport($id: ObjectId!, $input: SavedReportUpdateInput!) {
  updateSavedReport(id: $id, input: $input) {
    _id
    name
    reportKey
    filters
  }
}
    `;
export const useUpdateSavedReportMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSavedReportMutation, TError, UpdateSavedReportMutationVariables, TContext>) =>
    useMutation<UpdateSavedReportMutation, TError, UpdateSavedReportMutationVariables, TContext>(
      ['updateSavedReport'],
      (variables?: UpdateSavedReportMutationVariables) => fetcher<UpdateSavedReportMutation, UpdateSavedReportMutationVariables>(UpdateSavedReportDocument, variables)(),
      options
    );
useUpdateSavedReportMutation.getKey = () => ['updateSavedReport'];

useUpdateSavedReportMutation.fetcher = (variables: UpdateSavedReportMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateSavedReportMutation, UpdateSavedReportMutationVariables>(UpdateSavedReportDocument, variables, options);
export const DeleteSavedReportDocument = `
    mutation deleteSavedReport($id: ObjectId!) {
  deleteSavedReport(id: $id)
}
    `;
export const useDeleteSavedReportMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSavedReportMutation, TError, DeleteSavedReportMutationVariables, TContext>) =>
    useMutation<DeleteSavedReportMutation, TError, DeleteSavedReportMutationVariables, TContext>(
      ['deleteSavedReport'],
      (variables?: DeleteSavedReportMutationVariables) => fetcher<DeleteSavedReportMutation, DeleteSavedReportMutationVariables>(DeleteSavedReportDocument, variables)(),
      options
    );
useDeleteSavedReportMutation.getKey = () => ['deleteSavedReport'];

useDeleteSavedReportMutation.fetcher = (variables: DeleteSavedReportMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteSavedReportMutation, DeleteSavedReportMutationVariables>(DeleteSavedReportDocument, variables, options);
export const SplitShipmentDocument = `
    mutation splitShipment($shipmentId: String!, $locations: [SplitShipmentLocationInput!]!) {
  splitShipment(shipmentId: $shipmentId, locations: $locations) {
    _id
    tripId
    isFromSplit
    parentShipment {
      _id
    }
  }
}
    `;
export const useSplitShipmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SplitShipmentMutation, TError, SplitShipmentMutationVariables, TContext>) =>
    useMutation<SplitShipmentMutation, TError, SplitShipmentMutationVariables, TContext>(
      ['splitShipment'],
      (variables?: SplitShipmentMutationVariables) => fetcher<SplitShipmentMutation, SplitShipmentMutationVariables>(SplitShipmentDocument, variables)(),
      options
    );
useSplitShipmentMutation.getKey = () => ['splitShipment'];

useSplitShipmentMutation.fetcher = (variables: SplitShipmentMutationVariables, options?: RequestInit['headers']) => fetcher<SplitShipmentMutation, SplitShipmentMutationVariables>(SplitShipmentDocument, variables, options);
export const CancelShipmentSplitDocument = `
    mutation cancelShipmentSplit($shipmentId: String!) {
  cancelShipmentSplit(shipmentId: $shipmentId) {
    _id
  }
}
    `;
export const useCancelShipmentSplitMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CancelShipmentSplitMutation, TError, CancelShipmentSplitMutationVariables, TContext>) =>
    useMutation<CancelShipmentSplitMutation, TError, CancelShipmentSplitMutationVariables, TContext>(
      ['cancelShipmentSplit'],
      (variables?: CancelShipmentSplitMutationVariables) => fetcher<CancelShipmentSplitMutation, CancelShipmentSplitMutationVariables>(CancelShipmentSplitDocument, variables)(),
      options
    );
useCancelShipmentSplitMutation.getKey = () => ['cancelShipmentSplit'];

useCancelShipmentSplitMutation.fetcher = (variables: CancelShipmentSplitMutationVariables, options?: RequestInit['headers']) => fetcher<CancelShipmentSplitMutation, CancelShipmentSplitMutationVariables>(CancelShipmentSplitDocument, variables, options);
export const GetShipmentDocument = `
    query getShipment($id: String!) {
  shipmentById(id: $id) {
    _id
    shipmentNumber
    isApplicableChargeOrderCancellation
    commodityType
    additionalTrailerTypes
    events {
      _id
      coordinates {
        altitude
        heading
        latitude
        longitude
        speed
      }
      createdBy
      date
      shipmentLocation
      type
      label
      description
      metadata
    }
    issues {
      _id
      type
      content
      date
      shipmentLocation
      delayAmount
      attachedDocuments
    }
    constraints {
      type
      value
      unit
    }
    documents {
      _id
      associatedCharge
      accessLevel
      isBillable
      isForRatecons
      isForReceivers
      name
      type
      url
      shipper {
        _id
        name
      }
      receiver {
        _id
        name
      }
    }
    notes {
      _id
      accessLevel
      receiver {
        _id
        name
      }
      shipper {
        _id
        name
      }
      content
    }
    customer {
      _id
      name
      referenceNumberTypes
      address {
        coordinates {
          latitude
          longitude
        }
        label
      }
      contact {
        firstname
        lastname
        phoneNumber
      }
      name
      type
      documentRequirements {
        documentName
        documentType
        attachToInvoice
        requiredForInvoicing
      }
    }
    purchaseOrderNumbers
    billOfLadingNumbers
    referenceNumbers
    purchaseOrderNumbers
    billOfLadingNumbers
    referenceNumbers
    ticketNumbers
    rateConNumbers
    status
    shipmentLocations {
      _id
      name
      addressLabel
      addressTimezone
      addressTimezone
      shipper {
        _id
        name
        address {
          coordinates {
            latitude
            longitude
          }
          label
        }
        addressTimezone
      }
      receiver {
        _id
        name
        address {
          coordinates {
            latitude
            longitude
          }
          label
        }
        addressTimezone
        storageFacilities {
          _id
          identifier
        }
      }
      shippedGoods {
        _id
        quantity
        loadedQuantity
        netLoadedQuantity
        weight
        label
        unit
        goodProfileId
        supplierId
        supplier {
          _id
          name
        }
        pinCode
        alternativePinCodes
      }
      receivedGoods {
        goodId
        quantity
        deliveredQuantity
        netDeliveredQuantity
        goodProfileId
        shipperId
        supplierId
        supplier {
          _id
          name
        }
        pinCode
        alternativePinCodes
        storageFacilityId
        inchesBefore
        inchesAfter
      }
      timeWindows {
        fromDate
        toDate
      }
      location {
        latitude
        longitude
      }
      locationType
    }
    constraints {
      type
      value
      unit
    }
    charges {
      _id
      total
      label
      rate
      unit
      unitType
      reimburseToDriver
      relatedTransactionId
      billingRule {
        _id
        label
        referenceNumber
      }
      ratingTable {
        _id
        label
        referenceNumber
      }
      document {
        name
        url
      }
      taxable
    }
    expenses {
      _id
      label
      rate
      unit
      unitType
      reimburseToDriver
      document {
        name
        url
      }
      customFields {
        key
        value
      }
    }
    route {
      routeDistance
      predictedLoadedDistance
      distanceToStart
      distanceToEnd
      locations {
        _id
        distanceTo
        locationType
        shipmentLocationIds
        shipper {
          _id
          name
        }
        receiver {
          _id
          name
        }
        timeWindows {
          fromDate
          toDate
        }
      }
      firstPickupTime
    }
    createdBy
    dispatcher
    trailerType
    additionalTrailerTypes
    loadType
    tripId
    reasonForCancellation
    isSplit
    isFromSplit
    childShipmentIds
    recurrence {
      freq
      interval
      dtstart
      until
      byweekday {
        weekday
        n
      }
      count
      bysetpos
      bymonth
      bymonthday
      bynmonthday
      byyearday
      byweekno
      byhour
      byminute
      bysecond
    }
    dailyRotationCount
    parentShipment {
      _id
    }
    tags
    customFields {
      key
      value
    }
    groupIds
  }
  invoices(filter: {shipmentIds: [$id]}) {
    data {
      _id
      invoiceNumber
      status
      shipmentIds
      charges {
        _id
        total
        label
        rate
        unit
        unitType
        reimburseToDriver
        relatedTransactionId
        billingRule {
          _id
          label
          referenceNumber
        }
        ratingTable {
          _id
          label
          referenceNumber
        }
        document {
          name
          url
        }
        taxable
        shipmentId
      }
    }
  }
}
    `;
export const useGetShipmentQuery = <
      TData = GetShipmentQuery,
      TError = Exception
    >(
      variables: GetShipmentQueryVariables,
      options?: UseQueryOptions<GetShipmentQuery, TError, TData>
    ) =>
    useQuery<GetShipmentQuery, TError, TData>(
      ['getShipment', variables],
      fetcher<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, variables),
      options
    );

useGetShipmentQuery.getKey = (variables: GetShipmentQueryVariables) => ['getShipment', variables];
;

useGetShipmentQuery.fetcher = (variables: GetShipmentQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentQuery, GetShipmentQueryVariables>(GetShipmentDocument, variables, options);
export const GetShipmentSummaryDocument = `
    query getShipmentSummary($id: String!) {
  shipmentById(id: $id) {
    _id
    billOfLadingNumbers
    purchaseOrderNumbers
    shipmentNumber
    isApplicableChargeOrderCancellation
    referenceNumbers
    purchaseOrderNumbers
    billOfLadingNumbers
    referenceNumbers
    ticketNumbers
    rateConNumbers
    charges {
      total
    }
    trailerType
    additionalTrailerTypes
    status
    customer {
      _id
      name
      referenceNumberTypes
    }
    createdBy
    shipmentLocations {
      _id
      name
      addressLabel
      addressTimezone
      addressTimezone
      location {
        latitude
        longitude
      }
      locationType
      shipper {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      receiver {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      shippedGoods {
        _id
        label
        quantity
        loadedQuantity
        netLoadedQuantity
        weight
        unit
        goodProfileId
        supplierId
        supplier {
          _id
          name
        }
        pinCode
      }
      receivedGoods {
        goodId
        quantity
        deliveredQuantity
        netDeliveredQuantity
        goodProfileId
        supplierId
        supplier {
          _id
          name
        }
        inchesBefore
        inchesAfter
      }
      timeWindows {
        fromDate
        toDate
      }
    }
    route {
      routeDistance
      firstPickupTime
      predictedLoadedDistance
      locations {
        _id
        shipper {
          _id
        }
        receiver {
          _id
        }
        timeWindows {
          fromDate
          toDate
        }
      }
    }
    tripId
  }
  invoices(filter: {shipmentIds: [$id]}) {
    data {
      _id
      invoiceNumber
      status
      shipmentIds
      charges {
        total
        shipmentId
      }
    }
  }
}
    `;
export const useGetShipmentSummaryQuery = <
      TData = GetShipmentSummaryQuery,
      TError = Exception
    >(
      variables: GetShipmentSummaryQueryVariables,
      options?: UseQueryOptions<GetShipmentSummaryQuery, TError, TData>
    ) =>
    useQuery<GetShipmentSummaryQuery, TError, TData>(
      ['getShipmentSummary', variables],
      fetcher<GetShipmentSummaryQuery, GetShipmentSummaryQueryVariables>(GetShipmentSummaryDocument, variables),
      options
    );

useGetShipmentSummaryQuery.getKey = (variables: GetShipmentSummaryQueryVariables) => ['getShipmentSummary', variables];
;

useGetShipmentSummaryQuery.fetcher = (variables: GetShipmentSummaryQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentSummaryQuery, GetShipmentSummaryQueryVariables>(GetShipmentSummaryDocument, variables, options);
export const DeleteShipmentDocument = `
    mutation deleteShipment($deleteShipmentData: ShipmentDeleteInput, $id: String!) {
  deleteShipment(deleteShipmentData: $deleteShipmentData, id: $id) {
    _id
  }
}
    `;
export const useDeleteShipmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteShipmentMutation, TError, DeleteShipmentMutationVariables, TContext>) =>
    useMutation<DeleteShipmentMutation, TError, DeleteShipmentMutationVariables, TContext>(
      ['deleteShipment'],
      (variables?: DeleteShipmentMutationVariables) => fetcher<DeleteShipmentMutation, DeleteShipmentMutationVariables>(DeleteShipmentDocument, variables)(),
      options
    );
useDeleteShipmentMutation.getKey = () => ['deleteShipment'];

useDeleteShipmentMutation.fetcher = (variables: DeleteShipmentMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteShipmentMutation, DeleteShipmentMutationVariables>(DeleteShipmentDocument, variables, options);
export const RestoreShipmentDocument = `
    mutation restoreShipment($id: String!) {
  restoreShipment(id: $id) {
    _id
  }
}
    `;
export const useRestoreShipmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<RestoreShipmentMutation, TError, RestoreShipmentMutationVariables, TContext>) =>
    useMutation<RestoreShipmentMutation, TError, RestoreShipmentMutationVariables, TContext>(
      ['restoreShipment'],
      (variables?: RestoreShipmentMutationVariables) => fetcher<RestoreShipmentMutation, RestoreShipmentMutationVariables>(RestoreShipmentDocument, variables)(),
      options
    );
useRestoreShipmentMutation.getKey = () => ['restoreShipment'];

useRestoreShipmentMutation.fetcher = (variables: RestoreShipmentMutationVariables, options?: RequestInit['headers']) => fetcher<RestoreShipmentMutation, RestoreShipmentMutationVariables>(RestoreShipmentDocument, variables, options);
export const AddShipmentDocumentsDocument = `
    mutation addShipmentDocuments($data: [ShipmentDocumentInfoInput!]!, $shipment: String!) {
  addShipmentDocuments(newDocumentsData: $data, shipment: $shipment) {
    _id
  }
}
    `;
export const useAddShipmentDocumentsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddShipmentDocumentsMutation, TError, AddShipmentDocumentsMutationVariables, TContext>) =>
    useMutation<AddShipmentDocumentsMutation, TError, AddShipmentDocumentsMutationVariables, TContext>(
      ['addShipmentDocuments'],
      (variables?: AddShipmentDocumentsMutationVariables) => fetcher<AddShipmentDocumentsMutation, AddShipmentDocumentsMutationVariables>(AddShipmentDocumentsDocument, variables)(),
      options
    );
useAddShipmentDocumentsMutation.getKey = () => ['addShipmentDocuments'];

useAddShipmentDocumentsMutation.fetcher = (variables: AddShipmentDocumentsMutationVariables, options?: RequestInit['headers']) => fetcher<AddShipmentDocumentsMutation, AddShipmentDocumentsMutationVariables>(AddShipmentDocumentsDocument, variables, options);
export const AddShipmentNotesDocument = `
    mutation addShipmentNotes($data: MultiShipmentNotesInput!) {
  addNotesShipment(newNotesData: $data) {
    _id
  }
}
    `;
export const useAddShipmentNotesMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddShipmentNotesMutation, TError, AddShipmentNotesMutationVariables, TContext>) =>
    useMutation<AddShipmentNotesMutation, TError, AddShipmentNotesMutationVariables, TContext>(
      ['addShipmentNotes'],
      (variables?: AddShipmentNotesMutationVariables) => fetcher<AddShipmentNotesMutation, AddShipmentNotesMutationVariables>(AddShipmentNotesDocument, variables)(),
      options
    );
useAddShipmentNotesMutation.getKey = () => ['addShipmentNotes'];

useAddShipmentNotesMutation.fetcher = (variables: AddShipmentNotesMutationVariables, options?: RequestInit['headers']) => fetcher<AddShipmentNotesMutation, AddShipmentNotesMutationVariables>(AddShipmentNotesDocument, variables, options);
export const EditShipmentNoteDocument = `
    mutation editShipmentNote($data: EditShipmentNoteInput!) {
  editNoteShipment(editNoteData: $data) {
    _id
  }
}
    `;
export const useEditShipmentNoteMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditShipmentNoteMutation, TError, EditShipmentNoteMutationVariables, TContext>) =>
    useMutation<EditShipmentNoteMutation, TError, EditShipmentNoteMutationVariables, TContext>(
      ['editShipmentNote'],
      (variables?: EditShipmentNoteMutationVariables) => fetcher<EditShipmentNoteMutation, EditShipmentNoteMutationVariables>(EditShipmentNoteDocument, variables)(),
      options
    );
useEditShipmentNoteMutation.getKey = () => ['editShipmentNote'];

useEditShipmentNoteMutation.fetcher = (variables: EditShipmentNoteMutationVariables, options?: RequestInit['headers']) => fetcher<EditShipmentNoteMutation, EditShipmentNoteMutationVariables>(EditShipmentNoteDocument, variables, options);
export const DeleteShipmentNoteDocument = `
    mutation deleteShipmentNote($data: DeleteShipmentNoteInput!) {
  deleteShipmentNote(deleteNoteData: $data) {
    _id
  }
}
    `;
export const useDeleteShipmentNoteMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteShipmentNoteMutation, TError, DeleteShipmentNoteMutationVariables, TContext>) =>
    useMutation<DeleteShipmentNoteMutation, TError, DeleteShipmentNoteMutationVariables, TContext>(
      ['deleteShipmentNote'],
      (variables?: DeleteShipmentNoteMutationVariables) => fetcher<DeleteShipmentNoteMutation, DeleteShipmentNoteMutationVariables>(DeleteShipmentNoteDocument, variables)(),
      options
    );
useDeleteShipmentNoteMutation.getKey = () => ['deleteShipmentNote'];

useDeleteShipmentNoteMutation.fetcher = (variables: DeleteShipmentNoteMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteShipmentNoteMutation, DeleteShipmentNoteMutationVariables>(DeleteShipmentNoteDocument, variables, options);
export const DeleteDocumentShipmentDocument = `
    mutation deleteDocumentShipment($data: DeleteShipmentDocumentInput!) {
  deleteDocumentShipment(deleteDocumentData: $data) {
    _id
  }
}
    `;
export const useDeleteDocumentShipmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDocumentShipmentMutation, TError, DeleteDocumentShipmentMutationVariables, TContext>) =>
    useMutation<DeleteDocumentShipmentMutation, TError, DeleteDocumentShipmentMutationVariables, TContext>(
      ['deleteDocumentShipment'],
      (variables?: DeleteDocumentShipmentMutationVariables) => fetcher<DeleteDocumentShipmentMutation, DeleteDocumentShipmentMutationVariables>(DeleteDocumentShipmentDocument, variables)(),
      options
    );
useDeleteDocumentShipmentMutation.getKey = () => ['deleteDocumentShipment'];

useDeleteDocumentShipmentMutation.fetcher = (variables: DeleteDocumentShipmentMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteDocumentShipmentMutation, DeleteDocumentShipmentMutationVariables>(DeleteDocumentShipmentDocument, variables, options);
export const EditDocumentShipmentDocument = `
    mutation editDocumentShipment($data: EditShipmentDocumentInput!) {
  editDocumentShipment(editDocumentData: $data) {
    _id
  }
}
    `;
export const useEditDocumentShipmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditDocumentShipmentMutation, TError, EditDocumentShipmentMutationVariables, TContext>) =>
    useMutation<EditDocumentShipmentMutation, TError, EditDocumentShipmentMutationVariables, TContext>(
      ['editDocumentShipment'],
      (variables?: EditDocumentShipmentMutationVariables) => fetcher<EditDocumentShipmentMutation, EditDocumentShipmentMutationVariables>(EditDocumentShipmentDocument, variables)(),
      options
    );
useEditDocumentShipmentMutation.getKey = () => ['editDocumentShipment'];

useEditDocumentShipmentMutation.fetcher = (variables: EditDocumentShipmentMutationVariables, options?: RequestInit['headers']) => fetcher<EditDocumentShipmentMutation, EditDocumentShipmentMutationVariables>(EditDocumentShipmentDocument, variables, options);
export const ResendDocumentsToReceiversDocument = `
    mutation resendDocumentsToReceivers($shipmentId: ObjectId!) {
  resendDocumentsToReceivers(shipmentId: $shipmentId)
}
    `;
export const useResendDocumentsToReceiversMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ResendDocumentsToReceiversMutation, TError, ResendDocumentsToReceiversMutationVariables, TContext>) =>
    useMutation<ResendDocumentsToReceiversMutation, TError, ResendDocumentsToReceiversMutationVariables, TContext>(
      ['resendDocumentsToReceivers'],
      (variables?: ResendDocumentsToReceiversMutationVariables) => fetcher<ResendDocumentsToReceiversMutation, ResendDocumentsToReceiversMutationVariables>(ResendDocumentsToReceiversDocument, variables)(),
      options
    );
useResendDocumentsToReceiversMutation.getKey = () => ['resendDocumentsToReceivers'];

useResendDocumentsToReceiversMutation.fetcher = (variables: ResendDocumentsToReceiversMutationVariables, options?: RequestInit['headers']) => fetcher<ResendDocumentsToReceiversMutation, ResendDocumentsToReceiversMutationVariables>(ResendDocumentsToReceiversDocument, variables, options);
export const CreateShipmentDocument = `
    mutation createShipment($shipment: NewShipmentInput!) {
  addShipment(newShipmentData: $shipment) {
    _id
    shipmentLocations {
      shipper {
        _id
      }
    }
  }
}
    `;
export const useCreateShipmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CreateShipmentMutation, TError, CreateShipmentMutationVariables, TContext>) =>
    useMutation<CreateShipmentMutation, TError, CreateShipmentMutationVariables, TContext>(
      ['createShipment'],
      (variables?: CreateShipmentMutationVariables) => fetcher<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument, variables)(),
      options
    );
useCreateShipmentMutation.getKey = () => ['createShipment'];

useCreateShipmentMutation.fetcher = (variables: CreateShipmentMutationVariables, options?: RequestInit['headers']) => fetcher<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument, variables, options);
export const GenerateShipmentRouteDocument = `
    mutation generateShipmentRoute($shipment: NewShipmentInput!) {
  generateShipmentRoute(shipmentData: $shipment) {
    locations {
      _id
      locationType
      arrivalTime
      timeWindows {
        fromDate
        toDate
      }
      location {
        latitude
        longitude
      }
      serviceDuration
      setupDuration
      tripShipmentLocationId
      shipmentIds
      shipmentLocationIds
      waitingDuration
    }
    routeDistance
    firstPickupTime
    distanceToStart
    distanceToEnd
    firstPickupTime
    lastDropoffTime
  }
}
    `;
export const useGenerateShipmentRouteMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateShipmentRouteMutation, TError, GenerateShipmentRouteMutationVariables, TContext>) =>
    useMutation<GenerateShipmentRouteMutation, TError, GenerateShipmentRouteMutationVariables, TContext>(
      ['generateShipmentRoute'],
      (variables?: GenerateShipmentRouteMutationVariables) => fetcher<GenerateShipmentRouteMutation, GenerateShipmentRouteMutationVariables>(GenerateShipmentRouteDocument, variables)(),
      options
    );
useGenerateShipmentRouteMutation.getKey = () => ['generateShipmentRoute'];

useGenerateShipmentRouteMutation.fetcher = (variables: GenerateShipmentRouteMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateShipmentRouteMutation, GenerateShipmentRouteMutationVariables>(GenerateShipmentRouteDocument, variables, options);
export const UpdateShipmentDocument = `
    mutation updateShipment($editShipmentData: ShipmentUpdateInput!, $id: String!) {
  editShipment(editShipmentData: $editShipmentData, id: $id) {
    _id
    shipmentLocations {
      shipper {
        _id
      }
    }
  }
}
    `;
export const useUpdateShipmentMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShipmentMutation, TError, UpdateShipmentMutationVariables, TContext>) =>
    useMutation<UpdateShipmentMutation, TError, UpdateShipmentMutationVariables, TContext>(
      ['updateShipment'],
      (variables?: UpdateShipmentMutationVariables) => fetcher<UpdateShipmentMutation, UpdateShipmentMutationVariables>(UpdateShipmentDocument, variables)(),
      options
    );
useUpdateShipmentMutation.getKey = () => ['updateShipment'];

useUpdateShipmentMutation.fetcher = (variables: UpdateShipmentMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateShipmentMutation, UpdateShipmentMutationVariables>(UpdateShipmentDocument, variables, options);
export const GetOwnedTrailerTypesDocument = `
    query getOwnedTrailerTypes {
  ownedTrailerTypes
}
    `;
export const useGetOwnedTrailerTypesQuery = <
      TData = GetOwnedTrailerTypesQuery,
      TError = Exception
    >(
      variables?: GetOwnedTrailerTypesQueryVariables,
      options?: UseQueryOptions<GetOwnedTrailerTypesQuery, TError, TData>
    ) =>
    useQuery<GetOwnedTrailerTypesQuery, TError, TData>(
      variables === undefined ? ['getOwnedTrailerTypes'] : ['getOwnedTrailerTypes', variables],
      fetcher<GetOwnedTrailerTypesQuery, GetOwnedTrailerTypesQueryVariables>(GetOwnedTrailerTypesDocument, variables),
      options
    );

useGetOwnedTrailerTypesQuery.getKey = (variables?: GetOwnedTrailerTypesQueryVariables) => variables === undefined ? ['getOwnedTrailerTypes'] : ['getOwnedTrailerTypes', variables];
;

useGetOwnedTrailerTypesQuery.fetcher = (variables?: GetOwnedTrailerTypesQueryVariables, options?: RequestInit['headers']) => fetcher<GetOwnedTrailerTypesQuery, GetOwnedTrailerTypesQueryVariables>(GetOwnedTrailerTypesDocument, variables, options);
export const GetSignedUrlDocument = `
    mutation getSignedUrl($document: DocumentSignedUrlInput!) {
  documentSignedUrl(newDocumentSignedUrl: $document) {
    key
    url
  }
}
    `;
export const useGetSignedUrlMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GetSignedUrlMutation, TError, GetSignedUrlMutationVariables, TContext>) =>
    useMutation<GetSignedUrlMutation, TError, GetSignedUrlMutationVariables, TContext>(
      ['getSignedUrl'],
      (variables?: GetSignedUrlMutationVariables) => fetcher<GetSignedUrlMutation, GetSignedUrlMutationVariables>(GetSignedUrlDocument, variables)(),
      options
    );
useGetSignedUrlMutation.getKey = () => ['getSignedUrl'];

useGetSignedUrlMutation.fetcher = (variables: GetSignedUrlMutationVariables, options?: RequestInit['headers']) => fetcher<GetSignedUrlMutation, GetSignedUrlMutationVariables>(GetSignedUrlDocument, variables, options);
export const GetShipmentListDocument = `
    query getShipmentList($search: String, $sort: ShipmentSort, $skip: Int, $take: Int, $status: Status, $statuses: [Status!], $receiverId: String, $excludePastShipments: Boolean, $filter: JSON, $orderBy: [OrderByItem!]) {
  shipments(
    search: $search
    sort: $sort
    skip: $skip
    take: $take
    status: $status
    statuses: $statuses
    filter: $filter
    orderBy: $orderBy
    excludeRecurrentShipments: false
    excludeRotationShipments: false
    receiverId: $receiverId
    excludePastShipments: $excludePastShipments
  ) {
    data {
      _id
      isApplicableChargeOrderCancellation
      shipmentNumber
      purchaseOrderNumbers
      billOfLadingNumbers
      referenceNumbers
      ticketNumbers
      rateConNumbers
      status
      trailerType
      additionalTrailerTypes
      shipmentLocations {
        _id
        locationType
        timeWindows {
          fromDate
          toDate
        }
        shippedGoods {
          _id
          goodProfileId
          label
          quantity
          unit
          weight
          supplierId
        }
        shipper {
          _id
        }
      }
      route {
        locations {
          _id
          locationType
          location {
            latitude
            longitude
          }
          name
          addressLabel
          addressTimezone
          shipper {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          receiver {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          timeWindows {
            fromDate
            toDate
          }
        }
        firstPickupTime
        lastDropoffTime
      }
      tripId
      trip {
        _id
        tripNumber
        driver
        tractor
        trailer
        driverEntity {
          _id
          firstname
          lastname
          phoneNumber
          status
        }
        tractorEntity {
          _id
          serialNumber
          licenseNumber
          status
        }
        trailerEntity {
          _id
          serialNumber
          licenseNumber
          status
          type
        }
        carrier
        carrierEntity {
          _id
          name
          contact {
            firstname
            lastname
            phoneNumber
          }
          status
          type
          address {
            label
            coordinates {
              latitude
              longitude
            }
          }
        }
      }
      isSplit
      isFromSplit
      isFromRotation
      parentShipment {
        _id
      }
      recurrence {
        freq
      }
      dailyRotationCount
      tags
      customFields {
        key
        value
      }
      groupIds
    }
    count
  }
}
    `;
export const useGetShipmentListQuery = <
      TData = GetShipmentListQuery,
      TError = Exception
    >(
      variables?: GetShipmentListQueryVariables,
      options?: UseQueryOptions<GetShipmentListQuery, TError, TData>
    ) =>
    useQuery<GetShipmentListQuery, TError, TData>(
      variables === undefined ? ['getShipmentList'] : ['getShipmentList', variables],
      fetcher<GetShipmentListQuery, GetShipmentListQueryVariables>(GetShipmentListDocument, variables),
      options
    );

useGetShipmentListQuery.getKey = (variables?: GetShipmentListQueryVariables) => variables === undefined ? ['getShipmentList'] : ['getShipmentList', variables];
;

useGetShipmentListQuery.fetcher = (variables?: GetShipmentListQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentListQuery, GetShipmentListQueryVariables>(GetShipmentListDocument, variables, options);
export const GetShipmentsByIdsDocument = `
    query getShipmentsByIds($shipmentIds: [ObjectId!]!) {
  shipments(
    ids: $shipmentIds
    statuses: [WAITING_FOR_ASSIGNMENT, IN_PROGRESS, ASSIGNED, COMPLETE, FORECASTED, FORECASTED_LOCKED]
  ) {
    data {
      _id
      shipmentNumber
      commodityType
      tripId
      shipmentLocations {
        _id
        name
        addressLabel
        addressTimezone
        shipper {
          _id
          name
          address {
            coordinates {
              latitude
              longitude
            }
            label
          }
        }
        receiver {
          _id
          name
          address {
            coordinates {
              latitude
              longitude
            }
            label
          }
          addressTimezone
        }
        shippedGoods {
          _id
          quantity
          loadedQuantity
          netLoadedQuantity
          weight
          label
          unit
          goodProfileId
          supplierId
          supplier {
            _id
            name
          }
          pinCode
          alternativePinCodes
        }
        receivedGoods {
          goodId
          quantity
          deliveredQuantity
          netDeliveredQuantity
          goodProfileId
          shipperId
          supplierId
          supplier {
            _id
            name
          }
          pinCode
          alternativePinCodes
          storageFacilityId
        }
        timeWindows {
          fromDate
          toDate
        }
        location {
          latitude
          longitude
        }
        locationType
      }
      referenceNumbers
      isFromSplit
      isFromRotation
      additionalTrailerTypes
      parentShipment {
        _id
      }
      events {
        type
        shipmentLocation
      }
    }
  }
}
    `;
export const useGetShipmentsByIdsQuery = <
      TData = GetShipmentsByIdsQuery,
      TError = Exception
    >(
      variables: GetShipmentsByIdsQueryVariables,
      options?: UseQueryOptions<GetShipmentsByIdsQuery, TError, TData>
    ) =>
    useQuery<GetShipmentsByIdsQuery, TError, TData>(
      ['getShipmentsByIds', variables],
      fetcher<GetShipmentsByIdsQuery, GetShipmentsByIdsQueryVariables>(GetShipmentsByIdsDocument, variables),
      options
    );

useGetShipmentsByIdsQuery.getKey = (variables: GetShipmentsByIdsQueryVariables) => ['getShipmentsByIds', variables];
;

useGetShipmentsByIdsQuery.fetcher = (variables: GetShipmentsByIdsQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentsByIdsQuery, GetShipmentsByIdsQueryVariables>(GetShipmentsByIdsDocument, variables, options);
export const TrackShipmentDocument = `
    query trackShipment($token: String!) {
  trackShipment(token: $token) {
    shipment {
      _id
      trailerType
      loadType
      shipmentNumber
      referenceNumbers
      events {
        _id
        type
        label
        description
        date
        shipmentLocation
        metadata
      }
      shipmentLocations {
        _id
        locationType
      }
    }
    trip {
      _id
      driver {
        _id
        firstname
        lastname
      }
      polyline
      status
      tripNumber
      routeDistance
      firstPickupTime
      shipmentLocations {
        _id
        tripShipmentLocationId
        shipmentId
        shipmentIds
        shipmentLocationIds
        location {
          latitude
          longitude
        }
        locationType
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        shippedGoods {
          _id
          label
          quantity
          unit
          weight
        }
        receivedGoods {
          goodId
          quantity
        }
        arrivalTime
        waitingDuration
        setupDuration
        serviceDuration
        timeWindows {
          fromDate
          toDate
        }
      }
      shipments {
        _id
        status
        trailerType
        shipmentNumber
        referenceNumbers
        events {
          _id
          type
          label
          description
          date
          shipmentLocation
          metadata
        }
        charges {
          _id
          rate
          unit
          total
        }
      }
      lastTrailerLocation {
        latitude
        longitude
        heading
        speed
      }
      lastTrailerLocationDate
    }
  }
}
    `;
export const useTrackShipmentQuery = <
      TData = TrackShipmentQuery,
      TError = Exception
    >(
      variables: TrackShipmentQueryVariables,
      options?: UseQueryOptions<TrackShipmentQuery, TError, TData>
    ) =>
    useQuery<TrackShipmentQuery, TError, TData>(
      ['trackShipment', variables],
      fetcher<TrackShipmentQuery, TrackShipmentQueryVariables>(TrackShipmentDocument, variables),
      options
    );

useTrackShipmentQuery.getKey = (variables: TrackShipmentQueryVariables) => ['trackShipment', variables];
;

useTrackShipmentQuery.fetcher = (variables: TrackShipmentQueryVariables, options?: RequestInit['headers']) => fetcher<TrackShipmentQuery, TrackShipmentQueryVariables>(TrackShipmentDocument, variables, options);
export const TrackShipmentByIdDocument = `
    query trackShipmentById($shipmentId: ObjectId!) {
  trackShipment: trackShipmentById(shipmentId: $shipmentId) {
    shipment {
      _id
      trailerType
      loadType
      shipmentNumber
      referenceNumbers
      events {
        _id
        type
        label
        description
        date
        shipmentLocation
        metadata
      }
      shipmentLocations {
        _id
        locationType
      }
    }
    trip {
      _id
      driver {
        _id
        firstname
        lastname
      }
      polyline
      status
      tripNumber
      routeDistance
      firstPickupTime
      shipmentLocations {
        _id
        tripShipmentLocationId
        shipmentId
        shipmentIds
        shipmentLocationIds
        location {
          latitude
          longitude
        }
        locationType
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        shippedGoods {
          _id
          label
          quantity
          unit
          weight
        }
        receivedGoods {
          goodId
          quantity
        }
        arrivalTime
        waitingDuration
        setupDuration
        serviceDuration
        timeWindows {
          fromDate
          toDate
        }
      }
      shipments {
        _id
        status
        trailerType
        shipmentNumber
        referenceNumbers
        events {
          _id
          type
          label
          description
          date
          shipmentLocation
          metadata
        }
        charges {
          _id
          rate
          unit
          total
        }
      }
      lastTrailerLocation {
        latitude
        longitude
        heading
        speed
      }
      lastTrailerLocationDate
    }
  }
}
    `;
export const useTrackShipmentByIdQuery = <
      TData = TrackShipmentByIdQuery,
      TError = Exception
    >(
      variables: TrackShipmentByIdQueryVariables,
      options?: UseQueryOptions<TrackShipmentByIdQuery, TError, TData>
    ) =>
    useQuery<TrackShipmentByIdQuery, TError, TData>(
      ['trackShipmentById', variables],
      fetcher<TrackShipmentByIdQuery, TrackShipmentByIdQueryVariables>(TrackShipmentByIdDocument, variables),
      options
    );

useTrackShipmentByIdQuery.getKey = (variables: TrackShipmentByIdQueryVariables) => ['trackShipmentById', variables];
;

useTrackShipmentByIdQuery.fetcher = (variables: TrackShipmentByIdQueryVariables, options?: RequestInit['headers']) => fetcher<TrackShipmentByIdQuery, TrackShipmentByIdQueryVariables>(TrackShipmentByIdDocument, variables, options);
export const AddTripDocument = `
    mutation addTrip($newTripData: NewTripInput!) {
  addTrip(newTripData: $newTripData) {
    _id
  }
}
    `;
export const useAddTripMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddTripMutation, TError, AddTripMutationVariables, TContext>) =>
    useMutation<AddTripMutation, TError, AddTripMutationVariables, TContext>(
      ['addTrip'],
      (variables?: AddTripMutationVariables) => fetcher<AddTripMutation, AddTripMutationVariables>(AddTripDocument, variables)(),
      options
    );
useAddTripMutation.getKey = () => ['addTrip'];

useAddTripMutation.fetcher = (variables: AddTripMutationVariables, options?: RequestInit['headers']) => fetcher<AddTripMutation, AddTripMutationVariables>(AddTripDocument, variables, options);
export const GetShipmentListForAutoPlanDocument = `
    query getShipmentListForAutoPlan {
  shipments(
    excludeSplitShipments: true
    excludeRecurrentShipments: true
    excludeRotationShipments: true
    take: 300
    sort: {criteria: DROPOFF_DATE, desc: true}
    statuses: [UNPLANNED, WAITING_FOR_ASSIGNMENT, FORECASTED, FORECASTED_LOCKED]
  ) {
    data {
      _id
      billOfLadingNumbers
      purchaseOrderNumbers
      shipmentNumber
      referenceNumbers
      route {
        routeDistance
        firstPickupTime
      }
      charges {
        total
      }
      trailerType
      loadType
      status
      customer {
        _id
        name
        code
      }
      createdBy
      shipmentLocations {
        _id
        name
        addressLabel
        addressTimezone
        location {
          latitude
          longitude
        }
        locationType
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
          code
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
          code
        }
        shippedGoods {
          _id
          label
          quantity
          weight
          unit
        }
        receivedGoods {
          goodId
          quantity
        }
        timeWindows {
          fromDate
          toDate
        }
      }
      route {
        routeDistance
        firstPickupTime
        firstPickupTime
        lastDropoffTime
        locations {
          _id
          locationType
          location {
            latitude
            longitude
          }
          name
          addressLabel
          addressTimezone
          shipper {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          receiver {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          timeWindows {
            fromDate
            toDate
          }
          arrivalTime
          shipmentId
        }
        violations {
          cause
          duration
          locationId
        }
      }
      tripId
      trip {
        _id
        tripNumber
        driver
        tractor
        trailer
        firstPickupTime
        lastDropoffTime
        routeDistance
        predictedLoadedDistance
        etaFromPreviousTrip
        etaToNextTrip
        status
        shipmentLocations {
          _id
          tripShipmentLocationId
          shipmentId
          shipmentIds
          shipmentLocationIds
          name
          locationType
          timeWindows {
            fromDate
            toDate
          }
          arrivalTime
        }
        violations {
          cause
          duration
          locationId
        }
      }
      tags
      customFields {
        key
        value
      }
      groupIds
    }
  }
}
    `;
export const useGetShipmentListForAutoPlanQuery = <
      TData = GetShipmentListForAutoPlanQuery,
      TError = Exception
    >(
      variables?: GetShipmentListForAutoPlanQueryVariables,
      options?: UseQueryOptions<GetShipmentListForAutoPlanQuery, TError, TData>
    ) =>
    useQuery<GetShipmentListForAutoPlanQuery, TError, TData>(
      variables === undefined ? ['getShipmentListForAutoPlan'] : ['getShipmentListForAutoPlan', variables],
      fetcher<GetShipmentListForAutoPlanQuery, GetShipmentListForAutoPlanQueryVariables>(GetShipmentListForAutoPlanDocument, variables),
      options
    );

useGetShipmentListForAutoPlanQuery.getKey = (variables?: GetShipmentListForAutoPlanQueryVariables) => variables === undefined ? ['getShipmentListForAutoPlan'] : ['getShipmentListForAutoPlan', variables];
;

useGetShipmentListForAutoPlanQuery.fetcher = (variables?: GetShipmentListForAutoPlanQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentListForAutoPlanQuery, GetShipmentListForAutoPlanQueryVariables>(GetShipmentListForAutoPlanDocument, variables, options);
export const GetShipmentListForPlanningDocument = `
    query getShipmentListForPlanning($filter: JSON) {
  shipments(
    excludeSplitShipments: true
    excludeRecurrentShipments: true
    excludeRotationShipments: true
    take: 300
    sort: {criteria: DROPOFF_DATE, desc: true}
    statuses: [ASSIGNED, COMPLETE, IN_PROGRESS, WAITING_FOR_ASSIGNMENT, UNPLANNED, FORECASTED, FORECASTED_LOCKED]
    filter: $filter
  ) {
    data {
      _id
      billOfLadingNumbers
      purchaseOrderNumbers
      ticketNumbers
      rateConNumbers
      shipmentNumber
      referenceNumbers
      route {
        routeDistance
        firstPickupTime
      }
      charges {
        _id
        rate
        unit
        total
      }
      trailerType
      loadType
      status
      events {
        _id
        type
        label
        description
        date
        shipmentLocation
        tripShipmentLocation
        metadata
      }
      customer {
        _id
        name
        code
      }
      createdBy
      shipmentLocations {
        _id
        name
        addressLabel
        addressTimezone
        location {
          latitude
          longitude
        }
        locationType
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
          code
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
          code
        }
        shippedGoods {
          _id
          label
          quantity
          weight
          unit
          goodProfileId
          unitPrice
          pinCode
          alternativePinCodes
          pieces
          pallet
          loadedQuantity
          supplierId
        }
        receivedGoods {
          goodId
          quantity
          goodProfileId
          unitPrice
          pinCode
          alternativePinCodes
          deliveredQuantity
          shipperId
          supplierId
          storageFacilityId
        }
        timeWindows {
          fromDate
          toDate
        }
      }
      route {
        routeDistance
        firstPickupTime
        firstPickupTime
        lastDropoffTime
        locations {
          _id
          tripShipmentLocationId
          locationType
          location {
            latitude
            longitude
          }
          name
          addressLabel
          addressTimezone
          shipper {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          receiver {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          timeWindows {
            fromDate
            toDate
          }
          arrivalTime
          shipmentId
          shipmentIds
          shipmentLocationIds
          waitingDuration
          setupDuration
          serviceDuration
          shippedGoods {
            _id
            label
            quantity
            weight
            unit
            goodProfileId
            unitPrice
            pinCode
            alternativePinCodes
            pieces
            pallet
            loadedQuantity
            supplierId
          }
          receivedGoods {
            goodId
            quantity
            goodProfileId
            unitPrice
            pinCode
            alternativePinCodes
            deliveredQuantity
            shipperId
            supplierId
            storageFacilityId
          }
        }
        violations {
          cause
          duration
          locationId
          message
        }
      }
      tripId
      additionalTrailerTypes
      trip {
        _id
        tripNumber
        driver
        driverEntity {
          _id
          firstname
          lastname
          phoneNumber
          status
        }
        tractor
        tractorEntity {
          _id
          serialNumber
          licenseNumber
          status
        }
        trailer
        trailerEntity {
          _id
          serialNumber
          licenseNumber
          status
          type
        }
        carrier
        carrierEntity {
          _id
          name
          contact {
            firstname
            lastname
            phoneNumber
          }
          status
          type
          address {
            label
            coordinates {
              latitude
              longitude
            }
          }
        }
        additionalTrailers
        firstPickupTime
        lastDropoffTime
        routeDistance
        predictedLoadedDistance
        etaFromPreviousTrip
        etaToNextTrip
        etaStatus
        nextStopName
        etaToNextStopMinutes
        etaToDeliveryMinutes
        liveEtaUpdatedAt
        status
        polyline
        distanceToStart
        distanceToEnd
        totalDistance
        shipmentLocations {
          _id
          tripShipmentLocationId
          shipmentId
          shipmentIds
          shipmentLocationIds
          name
          addressLabel
          addressTimezone
          locationType
          timeWindows {
            fromDate
            toDate
          }
          arrivalTime
          estimatedArrivalTime
          waitingDuration
          setupDuration
          serviceDuration
          distanceTo
          location {
            latitude
            longitude
          }
          shippedGoods {
            _id
            label
            quantity
            weight
            unit
            goodProfileId
            unitPrice
            pinCode
            alternativePinCodes
            pieces
            pallet
            loadedQuantity
            supplierId
            supplier {
              _id
              name
            }
          }
          receivedGoods {
            goodId
            quantity
            goodProfileId
            unitPrice
            pinCode
            alternativePinCodes
            deliveredQuantity
            shipperId
            supplierId
            storageFacilityId
          }
        }
        violations {
          cause
          duration
          locationId
          message
        }
      }
      tags
      customFields {
        key
        value
      }
      groupIds
      recurrence {
        freq
      }
    }
  }
}
    `;
export const useGetShipmentListForPlanningQuery = <
      TData = GetShipmentListForPlanningQuery,
      TError = Exception
    >(
      variables?: GetShipmentListForPlanningQueryVariables,
      options?: UseQueryOptions<GetShipmentListForPlanningQuery, TError, TData>
    ) =>
    useQuery<GetShipmentListForPlanningQuery, TError, TData>(
      variables === undefined ? ['getShipmentListForPlanning'] : ['getShipmentListForPlanning', variables],
      fetcher<GetShipmentListForPlanningQuery, GetShipmentListForPlanningQueryVariables>(GetShipmentListForPlanningDocument, variables),
      options
    );

useGetShipmentListForPlanningQuery.getKey = (variables?: GetShipmentListForPlanningQueryVariables) => variables === undefined ? ['getShipmentListForPlanning'] : ['getShipmentListForPlanning', variables];
;

useGetShipmentListForPlanningQuery.fetcher = (variables?: GetShipmentListForPlanningQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentListForPlanningQuery, GetShipmentListForPlanningQueryVariables>(GetShipmentListForPlanningDocument, variables, options);
export const PlanTripsForDriverDocument = `
    mutation planTripsForDriver($driverId: ObjectId!, $trips: [TripForPlanningInput!]!, $tractorId: ObjectId, $trailerId: ObjectId, $additionalTrailerIds: [ObjectId!]) {
  planTripsForDriver(
    driverId: $driverId
    trips: $trips
    tractorId: $tractorId
    trailerId: $trailerId
    additionalTrailerIds: $additionalTrailerIds
  ) {
    _id
    tripNumber
    shipments {
      _id
    }
    driver {
      _id
    }
    tractor {
      _id
    }
    trailer {
      _id
    }
    additionalTrailers {
      _id
    }
    firstPickupTime
    lastDropoffTime
    routeDistance
    predictedLoadedDistance
    etaFromPreviousTrip
    etaToNextTrip
    distanceToStart
    distanceToEnd
    status
    polyline
    totalDistance
    shipments {
      _id
      shipmentNumber
    }
    shipmentLocations {
      _id
      tripShipmentLocationId
      shipmentId
      shipmentIds
      shipmentLocationIds
      name
      addressLabel
      addressTimezone
      locationType
      timeWindows {
        fromDate
        toDate
      }
      arrivalTime
      waitingDuration
      setupDuration
      serviceDuration
      distanceTo
      location {
        latitude
        longitude
      }
      shippedGoods {
        _id
        label
        quantity
        weight
        unit
        goodProfileId
        unitPrice
        pinCode
        alternativePinCodes
        pieces
        pallet
        loadedQuantity
        supplierId
      }
      receivedGoods {
        goodId
        quantity
        goodProfileId
        unitPrice
        pinCode
        alternativePinCodes
        deliveredQuantity
        shipperId
        supplierId
        storageFacilityId
      }
      shipper {
        _id
        name
      }
      receiver {
        _id
        name
      }
    }
    violations {
      cause
      duration
      locationId
      message
    }
  }
}
    `;
export const usePlanTripsForDriverMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<PlanTripsForDriverMutation, TError, PlanTripsForDriverMutationVariables, TContext>) =>
    useMutation<PlanTripsForDriverMutation, TError, PlanTripsForDriverMutationVariables, TContext>(
      ['planTripsForDriver'],
      (variables?: PlanTripsForDriverMutationVariables) => fetcher<PlanTripsForDriverMutation, PlanTripsForDriverMutationVariables>(PlanTripsForDriverDocument, variables)(),
      options
    );
usePlanTripsForDriverMutation.getKey = () => ['planTripsForDriver'];

usePlanTripsForDriverMutation.fetcher = (variables: PlanTripsForDriverMutationVariables, options?: RequestInit['headers']) => fetcher<PlanTripsForDriverMutation, PlanTripsForDriverMutationVariables>(PlanTripsForDriverDocument, variables, options);
export const SaveTripDocument = `
    mutation saveTrip($saveTripData: SaveTripInput!) {
  saveTrip(saveTripData: $saveTripData) {
    _id
  }
}
    `;
export const useSaveTripMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<SaveTripMutation, TError, SaveTripMutationVariables, TContext>) =>
    useMutation<SaveTripMutation, TError, SaveTripMutationVariables, TContext>(
      ['saveTrip'],
      (variables?: SaveTripMutationVariables) => fetcher<SaveTripMutation, SaveTripMutationVariables>(SaveTripDocument, variables)(),
      options
    );
useSaveTripMutation.getKey = () => ['saveTrip'];

useSaveTripMutation.fetcher = (variables: SaveTripMutationVariables, options?: RequestInit['headers']) => fetcher<SaveTripMutation, SaveTripMutationVariables>(SaveTripDocument, variables, options);
export const CombineShipmentsDocument = `
    mutation combineShipments($generateTripData: GenerateTripInput!, $ignoreDriverShifts: Boolean) {
  combineShipments(
    generateTripData: $generateTripData
    ignoreDriverShifts: $ignoreDriverShifts
  ) {
    _id
    tripNumber
    shipments {
      _id
      shipmentNumber
    }
    driver {
      _id
    }
    tractor {
      _id
    }
    trailer {
      _id
    }
    additionalTrailers {
      _id
    }
    firstPickupTime
    lastDropoffTime
    routeDistance
    predictedLoadedDistance
    etaFromPreviousTrip
    etaToNextTrip
    totalDistance
    distanceToStart
    distanceToEnd
    status
    polyline
    shipmentLocations {
      _id
      tripShipmentLocationId
      shipmentIds
      shipmentLocationIds
      name
      addressLabel
      addressTimezone
      locationType
      timeWindows {
        fromDate
        toDate
      }
      arrivalTime
      waitingDuration
      setupDuration
      serviceDuration
      distanceTo
      location {
        latitude
        longitude
      }
      shippedGoods {
        _id
        label
        quantity
        weight
        unit
        goodProfileId
        unitPrice
        pinCode
        alternativePinCodes
        pieces
        pallet
        loadedQuantity
        supplierId
      }
      receivedGoods {
        goodId
        quantity
        goodProfileId
        unitPrice
        pinCode
        alternativePinCodes
        deliveredQuantity
        shipperId
        supplierId
        storageFacilityId
      }
      shipper {
        _id
        name
      }
      receiver {
        _id
        name
      }
    }
    violations {
      cause
      duration
      locationId
    }
  }
}
    `;
export const useCombineShipmentsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CombineShipmentsMutation, TError, CombineShipmentsMutationVariables, TContext>) =>
    useMutation<CombineShipmentsMutation, TError, CombineShipmentsMutationVariables, TContext>(
      ['combineShipments'],
      (variables?: CombineShipmentsMutationVariables) => fetcher<CombineShipmentsMutation, CombineShipmentsMutationVariables>(CombineShipmentsDocument, variables)(),
      options
    );
useCombineShipmentsMutation.getKey = () => ['combineShipments'];

useCombineShipmentsMutation.fetcher = (variables: CombineShipmentsMutationVariables, options?: RequestInit['headers']) => fetcher<CombineShipmentsMutation, CombineShipmentsMutationVariables>(CombineShipmentsDocument, variables, options);
export const GetAssignmentAssetsDocument = `
    query getAssignmentAssets($includeInactive: Boolean) {
  trailers(includeInactive: $includeInactive) {
    data {
      _id
      serialNumber
      status
      type
      lastKnownLocation {
        latitude
        longitude
      }
      lastKnownLocationDate
      compartments {
        identifier
        capacity
        unit
        minVolume
        maxVolume
        heavyOnly
        hasDoubleBulkheadAfter
      }
      compartmentVolumes {
        _id
        compartmentId
        commodityId
        quantity
        lastUpdated
        lastShipmentId
        lastShipmentNumber
        updatedBy
      }
      mileage
    }
  }
  tractors(includeInactive: $includeInactive) {
    data {
      _id
      serialNumber
      status
      lastKnownLocation {
        latitude
        longitude
      }
      lastKnownLocationDate
      mileage
    }
  }
  drivers(includeInactive: $includeInactive) {
    data {
      _id
      firstname
      lastname
      status
      lastKnownLocation {
        latitude
        longitude
      }
      lastKnownLocationDate
      phoneNumber
      domicile {
        city
        country
        label
      }
      domicileEntity {
        name
        addressTimezone
      }
      license {
        licenseNumber
        expiryDate
      }
      medical {
        number
        expiryDate
      }
      domicileId
    }
  }
  carriers: businessEntities(
    businessEntityTypes: [CARRIER]
    includeInactive: $includeInactive
  ) {
    data {
      _id
      address {
        label
      }
      code
      mcNumber
      contact {
        firstname
        lastname
        email
        phoneNumber
      }
      name
      type
      trailerTypes
      status
    }
    count
  }
  assetLinkings {
    data {
      _id
      driver {
        _id
        firstname
        lastname
      }
      tractor {
        _id
        serialNumber
        mileage
      }
      trailer {
        _id
        serialNumber
        type
        mileage
      }
      additionalTrailers {
        _id
        serialNumber
        type
        mileage
      }
      isHardLinked
      startDate
      endDate
    }
    count
  }
}
    `;
export const useGetAssignmentAssetsQuery = <
      TData = GetAssignmentAssetsQuery,
      TError = Exception
    >(
      variables?: GetAssignmentAssetsQueryVariables,
      options?: UseQueryOptions<GetAssignmentAssetsQuery, TError, TData>
    ) =>
    useQuery<GetAssignmentAssetsQuery, TError, TData>(
      variables === undefined ? ['getAssignmentAssets'] : ['getAssignmentAssets', variables],
      fetcher<GetAssignmentAssetsQuery, GetAssignmentAssetsQueryVariables>(GetAssignmentAssetsDocument, variables),
      options
    );

useGetAssignmentAssetsQuery.getKey = (variables?: GetAssignmentAssetsQueryVariables) => variables === undefined ? ['getAssignmentAssets'] : ['getAssignmentAssets', variables];
;

useGetAssignmentAssetsQuery.fetcher = (variables?: GetAssignmentAssetsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAssignmentAssetsQuery, GetAssignmentAssetsQueryVariables>(GetAssignmentAssetsDocument, variables, options);
export const AssignTripAssetDocument = `
    mutation assignTripAsset($assignmentData: TripAssetAssignment!, $ignoreDriverShifts: Boolean) {
  assignTripAsset(
    tripAssetAssignmentData: $assignmentData
    ignoreDriverShifts: $ignoreDriverShifts
  ) {
    _id
  }
}
    `;
export const useAssignTripAssetMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AssignTripAssetMutation, TError, AssignTripAssetMutationVariables, TContext>) =>
    useMutation<AssignTripAssetMutation, TError, AssignTripAssetMutationVariables, TContext>(
      ['assignTripAsset'],
      (variables?: AssignTripAssetMutationVariables) => fetcher<AssignTripAssetMutation, AssignTripAssetMutationVariables>(AssignTripAssetDocument, variables)(),
      options
    );
useAssignTripAssetMutation.getKey = () => ['assignTripAsset'];

useAssignTripAssetMutation.fetcher = (variables: AssignTripAssetMutationVariables, options?: RequestInit['headers']) => fetcher<AssignTripAssetMutation, AssignTripAssetMutationVariables>(AssignTripAssetDocument, variables, options);
export const AssignTripAssetsDocument = `
    mutation assignTripAssets($assignmentData: [TripAssetAssignment!]!, $ignoreDriverShifts: Boolean) {
  assignTripAssets(
    tripAssetAssignmentData: $assignmentData
    ignoreDriverShifts: $ignoreDriverShifts
  ) {
    _id
  }
}
    `;
export const useAssignTripAssetsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AssignTripAssetsMutation, TError, AssignTripAssetsMutationVariables, TContext>) =>
    useMutation<AssignTripAssetsMutation, TError, AssignTripAssetsMutationVariables, TContext>(
      ['assignTripAssets'],
      (variables?: AssignTripAssetsMutationVariables) => fetcher<AssignTripAssetsMutation, AssignTripAssetsMutationVariables>(AssignTripAssetsDocument, variables)(),
      options
    );
useAssignTripAssetsMutation.getKey = () => ['assignTripAssets'];

useAssignTripAssetsMutation.fetcher = (variables: AssignTripAssetsMutationVariables, options?: RequestInit['headers']) => fetcher<AssignTripAssetsMutation, AssignTripAssetsMutationVariables>(AssignTripAssetsDocument, variables, options);
export const AssignTripTrailerCompartmentsDocument = `
    mutation assignTripTrailerCompartments($tripId: String!, $trailerCompartmentAssignments: [TrailerCompartmentAssignmentInput!]!) {
  assignTripTrailerCompartments(
    tripId: $tripId
    trailerCompartmentAssignments: $trailerCompartmentAssignments
  ) {
    _id
  }
}
    `;
export const useAssignTripTrailerCompartmentsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AssignTripTrailerCompartmentsMutation, TError, AssignTripTrailerCompartmentsMutationVariables, TContext>) =>
    useMutation<AssignTripTrailerCompartmentsMutation, TError, AssignTripTrailerCompartmentsMutationVariables, TContext>(
      ['assignTripTrailerCompartments'],
      (variables?: AssignTripTrailerCompartmentsMutationVariables) => fetcher<AssignTripTrailerCompartmentsMutation, AssignTripTrailerCompartmentsMutationVariables>(AssignTripTrailerCompartmentsDocument, variables)(),
      options
    );
useAssignTripTrailerCompartmentsMutation.getKey = () => ['assignTripTrailerCompartments'];

useAssignTripTrailerCompartmentsMutation.fetcher = (variables: AssignTripTrailerCompartmentsMutationVariables, options?: RequestInit['headers']) => fetcher<AssignTripTrailerCompartmentsMutation, AssignTripTrailerCompartmentsMutationVariables>(AssignTripTrailerCompartmentsDocument, variables, options);
export const ValidateAssetCustomFieldsDocument = `
    mutation validateAssetCustomFields($shipmentId: ObjectId!, $assetType: TripAssetTypes!, $assetId: ObjectId!) {
  validateAssetCustomFields(
    shipmentId: $shipmentId
    assetType: $assetType
    assetId: $assetId
  ) {
    assetId
    assetType
    isRequired
    message
  }
}
    `;
export const useValidateAssetCustomFieldsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateAssetCustomFieldsMutation, TError, ValidateAssetCustomFieldsMutationVariables, TContext>) =>
    useMutation<ValidateAssetCustomFieldsMutation, TError, ValidateAssetCustomFieldsMutationVariables, TContext>(
      ['validateAssetCustomFields'],
      (variables?: ValidateAssetCustomFieldsMutationVariables) => fetcher<ValidateAssetCustomFieldsMutation, ValidateAssetCustomFieldsMutationVariables>(ValidateAssetCustomFieldsDocument, variables)(),
      options
    );
useValidateAssetCustomFieldsMutation.getKey = () => ['validateAssetCustomFields'];

useValidateAssetCustomFieldsMutation.fetcher = (variables: ValidateAssetCustomFieldsMutationVariables, options?: RequestInit['headers']) => fetcher<ValidateAssetCustomFieldsMutation, ValidateAssetCustomFieldsMutationVariables>(ValidateAssetCustomFieldsDocument, variables, options);
export const GetShipmentSummariesDocument = `
    query getShipmentSummaries($status: Status, $plannedForToday: Boolean, $timezone: String) {
  shipments(
    status: $status
    plannedForToday: $plannedForToday
    timezone: $timezone
  ) {
    data {
      _id
      billOfLadingNumbers
      purchaseOrderNumbers
      shipmentNumber
      referenceNumbers
      commodityType
      route {
        routeDistance
        firstPickupTime
      }
      charges {
        total
      }
      trailerType
      status
      customer {
        _id
        name
      }
      createdBy
      shipmentLocations {
        _id
        name
        addressLabel
        addressTimezone
        location {
          latitude
          longitude
        }
        locationType
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        shippedGoods {
          _id
          label
          quantity
          loadedQuantity
          weight
          unit
          supplierId
          supplier {
            _id
            name
          }
          pinCode
          goodProfileId
        }
        receivedGoods {
          goodId
          quantity
          deliveredQuantity
          storageFacilityId
          goodProfileId
          supplierId
          supplier {
            _id
            name
          }
        }
        timeWindows {
          fromDate
          toDate
        }
      }
      route {
        routeDistance
        firstPickupTime
        locations {
          _id
          shipper {
            _id
          }
          receiver {
            _id
          }
          timeWindows {
            fromDate
            toDate
          }
        }
        firstPickupTime
      }
      tripId
    }
  }
}
    `;
export const useGetShipmentSummariesQuery = <
      TData = GetShipmentSummariesQuery,
      TError = Exception
    >(
      variables?: GetShipmentSummariesQueryVariables,
      options?: UseQueryOptions<GetShipmentSummariesQuery, TError, TData>
    ) =>
    useQuery<GetShipmentSummariesQuery, TError, TData>(
      variables === undefined ? ['getShipmentSummaries'] : ['getShipmentSummaries', variables],
      fetcher<GetShipmentSummariesQuery, GetShipmentSummariesQueryVariables>(GetShipmentSummariesDocument, variables),
      options
    );

useGetShipmentSummariesQuery.getKey = (variables?: GetShipmentSummariesQueryVariables) => variables === undefined ? ['getShipmentSummaries'] : ['getShipmentSummaries', variables];
;

useGetShipmentSummariesQuery.fetcher = (variables?: GetShipmentSummariesQueryVariables, options?: RequestInit['headers']) => fetcher<GetShipmentSummariesQuery, GetShipmentSummariesQueryVariables>(GetShipmentSummariesDocument, variables, options);
export const GenerateTripDocument = `
    mutation generateTrip($generateTripData: GenerateTripInput!, $ignoreDriverShifts: Boolean) {
  generateTrip(
    generateTripData: $generateTripData
    ignoreDriverShifts: $ignoreDriverShifts
  ) {
    _id
  }
}
    `;
export const useGenerateTripMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateTripMutation, TError, GenerateTripMutationVariables, TContext>) =>
    useMutation<GenerateTripMutation, TError, GenerateTripMutationVariables, TContext>(
      ['generateTrip'],
      (variables?: GenerateTripMutationVariables) => fetcher<GenerateTripMutation, GenerateTripMutationVariables>(GenerateTripDocument, variables)(),
      options
    );
useGenerateTripMutation.getKey = () => ['generateTrip'];

useGenerateTripMutation.fetcher = (variables: GenerateTripMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateTripMutation, GenerateTripMutationVariables>(GenerateTripDocument, variables, options);
export const CheckShipmentsCombinabilityDocument = `
    mutation checkShipmentsCombinability($generateTripData: GenerateTripInput!) {
  checkShipmentsCombinability(generateTripData: $generateTripData)
}
    `;
export const useCheckShipmentsCombinabilityMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<CheckShipmentsCombinabilityMutation, TError, CheckShipmentsCombinabilityMutationVariables, TContext>) =>
    useMutation<CheckShipmentsCombinabilityMutation, TError, CheckShipmentsCombinabilityMutationVariables, TContext>(
      ['checkShipmentsCombinability'],
      (variables?: CheckShipmentsCombinabilityMutationVariables) => fetcher<CheckShipmentsCombinabilityMutation, CheckShipmentsCombinabilityMutationVariables>(CheckShipmentsCombinabilityDocument, variables)(),
      options
    );
useCheckShipmentsCombinabilityMutation.getKey = () => ['checkShipmentsCombinability'];

useCheckShipmentsCombinabilityMutation.fetcher = (variables: CheckShipmentsCombinabilityMutationVariables, options?: RequestInit['headers']) => fetcher<CheckShipmentsCombinabilityMutation, CheckShipmentsCombinabilityMutationVariables>(CheckShipmentsCombinabilityDocument, variables, options);
export const ChangeTripStartTimeDocument = `
    mutation changeTripStartTime($changeTripStartTimeData: ChangeTripStartTimeInput!) {
  changeTripStartTime(changeTripStartTimeData: $changeTripStartTimeData) {
    _id
  }
}
    `;
export const useChangeTripStartTimeMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeTripStartTimeMutation, TError, ChangeTripStartTimeMutationVariables, TContext>) =>
    useMutation<ChangeTripStartTimeMutation, TError, ChangeTripStartTimeMutationVariables, TContext>(
      ['changeTripStartTime'],
      (variables?: ChangeTripStartTimeMutationVariables) => fetcher<ChangeTripStartTimeMutation, ChangeTripStartTimeMutationVariables>(ChangeTripStartTimeDocument, variables)(),
      options
    );
useChangeTripStartTimeMutation.getKey = () => ['changeTripStartTime'];

useChangeTripStartTimeMutation.fetcher = (variables: ChangeTripStartTimeMutationVariables, options?: RequestInit['headers']) => fetcher<ChangeTripStartTimeMutation, ChangeTripStartTimeMutationVariables>(ChangeTripStartTimeDocument, variables, options);
export const DeleteTripDocument = `
    mutation deleteTrip($id: String!) {
  deleteTrip(id: $id) {
    _id
  }
}
    `;
export const useDeleteTripMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTripMutation, TError, DeleteTripMutationVariables, TContext>) =>
    useMutation<DeleteTripMutation, TError, DeleteTripMutationVariables, TContext>(
      ['deleteTrip'],
      (variables?: DeleteTripMutationVariables) => fetcher<DeleteTripMutation, DeleteTripMutationVariables>(DeleteTripDocument, variables)(),
      options
    );
useDeleteTripMutation.getKey = () => ['deleteTrip'];

useDeleteTripMutation.fetcher = (variables: DeleteTripMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteTripMutation, DeleteTripMutationVariables>(DeleteTripDocument, variables, options);
export const GetTripDocument = `
    query getTrip($id: String!) {
  tripById(id: $id) {
    _id
    tripNumber
    status
    routeDistance
    totalDistance
    loadedDistance
    predictedLoadedDistance
    deadheadDistance
    distanceToStart
    distanceToEnd
    routeStartPoint {
      label
      name
      addressLabel
      type
      distance
    }
    routeEndPoint {
      label
      name
      addressLabel
      type
      distance
    }
    firstPickupTime
    shipmentLocations {
      _id
      tripShipmentLocationId
      shipmentId
      shipmentIds
      shipmentLocationIds
      name
      addressLabel
      addressTimezone
      location {
        latitude
        longitude
      }
      locationType
      shipper {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      timeWindows {
        fromDate
        toDate
      }
      receiver {
        _id
        name
        address {
          label
        }
        addressTimezone
      }
      shippedGoods {
        _id
        label
        quantity
        loadedQuantity
        netLoadedQuantity
        weight
        unit
        goodProfileId
        supplierId
        pinCode
        supplier {
          _id
          name
        }
      }
      receivedGoods {
        goodId
        quantity
        deliveredQuantity
        netDeliveredQuantity
        goodProfileId
        storageFacilityId
      }
      arrivalTime
      estimatedArrivalTime
      waitingDuration
      setupDuration
      serviceDuration
      distanceTo
    }
    violations {
      cause
      duration
      locationId
    }
    shipments {
      _id
      isFromSplit
      isFromRotation
      parentShipment {
        _id
      }
      tags
      shipmentNumber
      referenceNumbers
      status
      charges {
        _id
        rate
        unit
        total
      }
      trailerType
      additionalTrailerTypes
      events {
        _id
        type
        label
        description
        date
        shipmentLocation
        tripShipmentLocation
        coordinates {
          latitude
          longitude
        }
        metadata
      }
      issues {
        _id
        type
        content
        date
        shipmentLocation
        delayAmount
        attachedDocuments
      }
      route {
        locations {
          locationType
          shipper {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          receiver {
            _id
            name
            address {
              label
            }
            addressTimezone
          }
          timeWindows {
            fromDate
            toDate
          }
        }
      }
      tripId
    }
    polyline
    trailer {
      _id
      type
      serialNumber
    }
    additionalTrailers {
      _id
      type
      serialNumber
    }
    tractor {
      _id
      serialNumber
    }
    driver {
      _id
      firstname
      lastname
    }
    trailerCompartmentAssignments {
      trailerId
      compartmentId
      commodityId
      quantity
      targetStorageFacilityId
    }
    carrier {
      _id
      name
      code
      contact {
        email
      }
      additionalContacts {
        email
        includeInInvoicing
      }
    }
    additionalTrailers {
      _id
      type
      serialNumber
    }
    lastTrailerLocation {
      latitude
      longitude
      heading
      speed
    }
    lastTrailerLocationDate
    liveEtaUpdatedAt
    etaStatus
    tags
    customFields {
      key
      value
    }
  }
}
    `;
export const useGetTripQuery = <
      TData = GetTripQuery,
      TError = Exception
    >(
      variables: GetTripQueryVariables,
      options?: UseQueryOptions<GetTripQuery, TError, TData>
    ) =>
    useQuery<GetTripQuery, TError, TData>(
      ['getTrip', variables],
      fetcher<GetTripQuery, GetTripQueryVariables>(GetTripDocument, variables),
      options
    );

useGetTripQuery.getKey = (variables: GetTripQueryVariables) => ['getTrip', variables];
;

useGetTripQuery.fetcher = (variables: GetTripQueryVariables, options?: RequestInit['headers']) => fetcher<GetTripQuery, GetTripQueryVariables>(GetTripDocument, variables, options);
export const GetTripPositionsDocument = `
    query getTripPositions($tripId: String!) {
  tripPositions(tripId: $tripId) {
    coords {
      latitude
      longitude
      speed
    }
    is_moving
    timestamp
  }
}
    `;
export const useGetTripPositionsQuery = <
      TData = GetTripPositionsQuery,
      TError = Exception
    >(
      variables: GetTripPositionsQueryVariables,
      options?: UseQueryOptions<GetTripPositionsQuery, TError, TData>
    ) =>
    useQuery<GetTripPositionsQuery, TError, TData>(
      ['getTripPositions', variables],
      fetcher<GetTripPositionsQuery, GetTripPositionsQueryVariables>(GetTripPositionsDocument, variables),
      options
    );

useGetTripPositionsQuery.getKey = (variables: GetTripPositionsQueryVariables) => ['getTripPositions', variables];
;

useGetTripPositionsQuery.fetcher = (variables: GetTripPositionsQueryVariables, options?: RequestInit['headers']) => fetcher<GetTripPositionsQuery, GetTripPositionsQueryVariables>(GetTripPositionsDocument, variables, options);
export const StartTripDocument = `
    mutation startTrip($startTripData: StartTripInput!) {
  startTrip(startTripData: $startTripData) {
    _id
  }
}
    `;
export const useStartTripMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<StartTripMutation, TError, StartTripMutationVariables, TContext>) =>
    useMutation<StartTripMutation, TError, StartTripMutationVariables, TContext>(
      ['startTrip'],
      (variables?: StartTripMutationVariables) => fetcher<StartTripMutation, StartTripMutationVariables>(StartTripDocument, variables)(),
      options
    );
useStartTripMutation.getKey = () => ['startTrip'];

useStartTripMutation.fetcher = (variables: StartTripMutationVariables, options?: RequestInit['headers']) => fetcher<StartTripMutation, StartTripMutationVariables>(StartTripDocument, variables, options);
export const AddShipmentEventDocument = `
    mutation addShipmentEvent($shipmentEventData: ShipmentEventInput!) {
  addShipmentEvent(shipmentEventData: $shipmentEventData) {
    _id
  }
}
    `;
export const useAddShipmentEventMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<AddShipmentEventMutation, TError, AddShipmentEventMutationVariables, TContext>) =>
    useMutation<AddShipmentEventMutation, TError, AddShipmentEventMutationVariables, TContext>(
      ['addShipmentEvent'],
      (variables?: AddShipmentEventMutationVariables) => fetcher<AddShipmentEventMutation, AddShipmentEventMutationVariables>(AddShipmentEventDocument, variables)(),
      options
    );
useAddShipmentEventMutation.getKey = () => ['addShipmentEvent'];

useAddShipmentEventMutation.fetcher = (variables: AddShipmentEventMutationVariables, options?: RequestInit['headers']) => fetcher<AddShipmentEventMutation, AddShipmentEventMutationVariables>(AddShipmentEventDocument, variables, options);
export const EditShipmentEventDocument = `
    mutation editShipmentEvent($shipmentId: ObjectId!, $eventId: ObjectId!, $shipmentEventData: UpdateShipmentEventInput!) {
  editShipmentEvent(
    eventId: $eventId
    shipmentId: $shipmentId
    shipmentEventData: $shipmentEventData
  ) {
    _id
  }
}
    `;
export const useEditShipmentEventMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<EditShipmentEventMutation, TError, EditShipmentEventMutationVariables, TContext>) =>
    useMutation<EditShipmentEventMutation, TError, EditShipmentEventMutationVariables, TContext>(
      ['editShipmentEvent'],
      (variables?: EditShipmentEventMutationVariables) => fetcher<EditShipmentEventMutation, EditShipmentEventMutationVariables>(EditShipmentEventDocument, variables)(),
      options
    );
useEditShipmentEventMutation.getKey = () => ['editShipmentEvent'];

useEditShipmentEventMutation.fetcher = (variables: EditShipmentEventMutationVariables, options?: RequestInit['headers']) => fetcher<EditShipmentEventMutation, EditShipmentEventMutationVariables>(EditShipmentEventDocument, variables, options);
export const DeleteShipmentEventDocument = `
    mutation deleteShipmentEvent($shipmentId: ObjectId!, $eventId: ObjectId!) {
  deleteShipmentEvent(eventId: $eventId, shipmentId: $shipmentId) {
    _id
  }
}
    `;
export const useDeleteShipmentEventMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteShipmentEventMutation, TError, DeleteShipmentEventMutationVariables, TContext>) =>
    useMutation<DeleteShipmentEventMutation, TError, DeleteShipmentEventMutationVariables, TContext>(
      ['deleteShipmentEvent'],
      (variables?: DeleteShipmentEventMutationVariables) => fetcher<DeleteShipmentEventMutation, DeleteShipmentEventMutationVariables>(DeleteShipmentEventDocument, variables)(),
      options
    );
useDeleteShipmentEventMutation.getKey = () => ['deleteShipmentEvent'];

useDeleteShipmentEventMutation.fetcher = (variables: DeleteShipmentEventMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteShipmentEventMutation, DeleteShipmentEventMutationVariables>(DeleteShipmentEventDocument, variables, options);
export const UpdateGoodDeliveredQuantityDocument = `
    mutation updateGoodDeliveredQuantity($input: UpdateGoodDeliveredQuantityInput!) {
  updateGoodDeliveredQuantity(input: $input) {
    _id
  }
}
    `;
export const useUpdateGoodDeliveredQuantityMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGoodDeliveredQuantityMutation, TError, UpdateGoodDeliveredQuantityMutationVariables, TContext>) =>
    useMutation<UpdateGoodDeliveredQuantityMutation, TError, UpdateGoodDeliveredQuantityMutationVariables, TContext>(
      ['updateGoodDeliveredQuantity'],
      (variables?: UpdateGoodDeliveredQuantityMutationVariables) => fetcher<UpdateGoodDeliveredQuantityMutation, UpdateGoodDeliveredQuantityMutationVariables>(UpdateGoodDeliveredQuantityDocument, variables)(),
      options
    );
useUpdateGoodDeliveredQuantityMutation.getKey = () => ['updateGoodDeliveredQuantity'];

useUpdateGoodDeliveredQuantityMutation.fetcher = (variables: UpdateGoodDeliveredQuantityMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateGoodDeliveredQuantityMutation, UpdateGoodDeliveredQuantityMutationVariables>(UpdateGoodDeliveredQuantityDocument, variables, options);
export const UpdateGoodLoadedQuantityDocument = `
    mutation updateGoodLoadedQuantity($input: UpdateGoodLoadedQuantityInput!) {
  updateGoodLoadedQuantity(input: $input) {
    _id
  }
}
    `;
export const useUpdateGoodLoadedQuantityMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGoodLoadedQuantityMutation, TError, UpdateGoodLoadedQuantityMutationVariables, TContext>) =>
    useMutation<UpdateGoodLoadedQuantityMutation, TError, UpdateGoodLoadedQuantityMutationVariables, TContext>(
      ['updateGoodLoadedQuantity'],
      (variables?: UpdateGoodLoadedQuantityMutationVariables) => fetcher<UpdateGoodLoadedQuantityMutation, UpdateGoodLoadedQuantityMutationVariables>(UpdateGoodLoadedQuantityDocument, variables)(),
      options
    );
useUpdateGoodLoadedQuantityMutation.getKey = () => ['updateGoodLoadedQuantity'];

useUpdateGoodLoadedQuantityMutation.fetcher = (variables: UpdateGoodLoadedQuantityMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateGoodLoadedQuantityMutation, UpdateGoodLoadedQuantityMutationVariables>(UpdateGoodLoadedQuantityDocument, variables, options);
export const GenerateTripsForPendingShipmentsDocument = `
    mutation generateTripsForPendingShipments {
  generateTripsForPendingShipments {
    trips {
      _id
      polyline
      shipmentLocations {
        _id
        tripShipmentLocationId
        shipmentId
        shipmentIds
        shipmentLocationIds
        location {
          latitude
          longitude
        }
        locationType
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        shippedGoods {
          _id
          label
          quantity
          weight
          unit
        }
        receivedGoods {
          goodId
          quantity
        }
        arrivalTime
        waitingDuration
        setupDuration
        serviceDuration
      }
      trailer {
        _id
        type
        serialNumber
      }
      tractor {
        _id
        serialNumber
      }
      driver {
        _id
        firstname
        lastname
      }
      status
      polyline
      shipments {
        _id
        shipmentNumber
        referenceNumbers
        charges {
          _id
          rate
          unit
        }
      }
    }
    unassignedShipmentLocations {
      _id
      location {
        latitude
        longitude
      }
      locationType
      timeWindows {
        fromDate
        toDate
      }
      shipper {
        _id
        name
        address {
          label
        }
      }
      receiver {
        _id
        name
        address {
          label
        }
      }
      shippedGoods {
        _id
        label
        quantity
        weight
        unit
      }
      receivedGoods {
        goodId
        quantity
      }
      shipment {
        _id
        shipmentNumber
        referenceNumbers
        shipmentLocations {
          _id
          shippedGoods {
            _id
            label
            weight
            quantity
            unit
          }
        }
      }
    }
  }
}
    `;
export const useGenerateTripsForPendingShipmentsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateTripsForPendingShipmentsMutation, TError, GenerateTripsForPendingShipmentsMutationVariables, TContext>) =>
    useMutation<GenerateTripsForPendingShipmentsMutation, TError, GenerateTripsForPendingShipmentsMutationVariables, TContext>(
      ['generateTripsForPendingShipments'],
      (variables?: GenerateTripsForPendingShipmentsMutationVariables) => fetcher<GenerateTripsForPendingShipmentsMutation, GenerateTripsForPendingShipmentsMutationVariables>(GenerateTripsForPendingShipmentsDocument, variables)(),
      options
    );
useGenerateTripsForPendingShipmentsMutation.getKey = () => ['generateTripsForPendingShipments'];

useGenerateTripsForPendingShipmentsMutation.fetcher = (variables?: GenerateTripsForPendingShipmentsMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateTripsForPendingShipmentsMutation, GenerateTripsForPendingShipmentsMutationVariables>(GenerateTripsForPendingShipmentsDocument, variables, options);
export const GenerateTripsForShipmentsDocument = `
    mutation generateTripsForShipments($shipmentIds: [ObjectId!]!, $startDate: DateTime!, $endDate: DateTime!) {
  generateTripsForShipments(
    shipmentIds: $shipmentIds
    startDate: $startDate
    endDate: $endDate
  ) {
    trips {
      _id
      tripNumber
      shipments {
        _id
        shipmentNumber
      }
      driver {
        _id
      }
      tractor {
        _id
      }
      trailer {
        _id
      }
      firstPickupTime
      lastDropoffTime
      routeDistance
      predictedLoadedDistance
      etaFromPreviousTrip
      etaToNextTrip
      totalDistance
      distanceToStart
      distanceToEnd
      status
      polyline
      shipmentLocations {
        _id
        name
        tripShipmentLocationId
        addressLabel
        addressTimezone
        locationType
        timeWindows {
          fromDate
          toDate
        }
        arrivalTime
        shipmentId
        shipmentIds
        shipmentLocationIds
        waitingDuration
        setupDuration
        serviceDuration
        distanceTo
        location {
          latitude
          longitude
        }
        shippedGoods {
          _id
          label
          quantity
          weight
          unit
          goodProfileId
        }
        receivedGoods {
          goodId
          quantity
          goodProfileId
        }
      }
      violations {
        cause
        duration
        locationId
      }
    }
    unplannedShipments {
      _id
      shipmentNumber
      referenceNumbers
    }
  }
}
    `;
export const useGenerateTripsForShipmentsMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateTripsForShipmentsMutation, TError, GenerateTripsForShipmentsMutationVariables, TContext>) =>
    useMutation<GenerateTripsForShipmentsMutation, TError, GenerateTripsForShipmentsMutationVariables, TContext>(
      ['generateTripsForShipments'],
      (variables?: GenerateTripsForShipmentsMutationVariables) => fetcher<GenerateTripsForShipmentsMutation, GenerateTripsForShipmentsMutationVariables>(GenerateTripsForShipmentsDocument, variables)(),
      options
    );
useGenerateTripsForShipmentsMutation.getKey = () => ['generateTripsForShipments'];

useGenerateTripsForShipmentsMutation.fetcher = (variables: GenerateTripsForShipmentsMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateTripsForShipmentsMutation, GenerateTripsForShipmentsMutationVariables>(GenerateTripsForShipmentsDocument, variables, options);
export const GetTripListDocument = `
    query getTripList($search: String, $sort: TripSort, $skip: Int, $take: Int, $filter: JSON, $orderBy: [OrderByItem!], $status: Status, $excludeCarrierAssigned: Boolean, $excludeDriverAssigned: Boolean) {
  trips(
    search: $search
    sort: $sort
    skip: $skip
    take: $take
    status: $status
    excludeCarrierAssigned: $excludeCarrierAssigned
    excludeDriverAssigned: $excludeDriverAssigned
    filter: $filter
    orderBy: $orderBy
  ) {
    count
    data {
      _id
      tripNumber
      status
      shipments {
        _id
        shipmentNumber
        referenceNumbers
        isFromSplit
        isFromRotation
        parentShipment {
          _id
        }
      }
      shipmentLocations {
        _id
        tripShipmentLocationId
        shipmentId
        shipmentIds
        shipmentLocationIds
        name
        addressLabel
        addressTimezone
        locationType
        arrivalTime
        waitingDuration
        setupDuration
        serviceDuration
        shipper {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        receiver {
          _id
          name
          address {
            label
          }
          addressTimezone
        }
        timeWindows {
          fromDate
          toDate
        }
      }
      trailer {
        _id
        type
        serialNumber
      }
      tractor {
        _id
        serialNumber
      }
      driver {
        _id
        firstname
        lastname
      }
      carrier {
        _id
        name
        code
      }
      firstPickupTime
      lastDropoffTime
      tags
      customFields {
        key
        value
      }
    }
  }
}
    `;
export const useGetTripListQuery = <
      TData = GetTripListQuery,
      TError = Exception
    >(
      variables?: GetTripListQueryVariables,
      options?: UseQueryOptions<GetTripListQuery, TError, TData>
    ) =>
    useQuery<GetTripListQuery, TError, TData>(
      variables === undefined ? ['getTripList'] : ['getTripList', variables],
      fetcher<GetTripListQuery, GetTripListQueryVariables>(GetTripListDocument, variables),
      options
    );

useGetTripListQuery.getKey = (variables?: GetTripListQueryVariables) => variables === undefined ? ['getTripList'] : ['getTripList', variables];
;

useGetTripListQuery.fetcher = (variables?: GetTripListQueryVariables, options?: RequestInit['headers']) => fetcher<GetTripListQuery, GetTripListQueryVariables>(GetTripListDocument, variables, options);
export const UpdateTripOrderDocument = `
    mutation updateTripOrder($data: UpdateTripOrderInput!) {
  updateTripOrder(updateTripOrderData: $data) {
    _id
  }
}
    `;
export const useUpdateTripOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTripOrderMutation, TError, UpdateTripOrderMutationVariables, TContext>) =>
    useMutation<UpdateTripOrderMutation, TError, UpdateTripOrderMutationVariables, TContext>(
      ['updateTripOrder'],
      (variables?: UpdateTripOrderMutationVariables) => fetcher<UpdateTripOrderMutation, UpdateTripOrderMutationVariables>(UpdateTripOrderDocument, variables)(),
      options
    );
useUpdateTripOrderMutation.getKey = () => ['updateTripOrder'];

useUpdateTripOrderMutation.fetcher = (variables: UpdateTripOrderMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateTripOrderMutation, UpdateTripOrderMutationVariables>(UpdateTripOrderDocument, variables, options);
export const ValidateTripOrderDocument = `
    mutation validateTripOrder($data: UpdateTripOrderInput!) {
  validateTripOrder(validateTripOrderData: $data) {
    cause
    duration
    locationId
  }
}
    `;
export const useValidateTripOrderMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateTripOrderMutation, TError, ValidateTripOrderMutationVariables, TContext>) =>
    useMutation<ValidateTripOrderMutation, TError, ValidateTripOrderMutationVariables, TContext>(
      ['validateTripOrder'],
      (variables?: ValidateTripOrderMutationVariables) => fetcher<ValidateTripOrderMutation, ValidateTripOrderMutationVariables>(ValidateTripOrderDocument, variables)(),
      options
    );
useValidateTripOrderMutation.getKey = () => ['validateTripOrder'];

useValidateTripOrderMutation.fetcher = (variables: ValidateTripOrderMutationVariables, options?: RequestInit['headers']) => fetcher<ValidateTripOrderMutation, ValidateTripOrderMutationVariables>(ValidateTripOrderDocument, variables, options);
export const RemoveShipmentFromTripDocument = `
    mutation removeShipmentFromTrip($shipmentIds: [ObjectId!]!, $tripId: ObjectId!) {
  removeShipmentFromTrip(shipmentIds: $shipmentIds, tripId: $tripId) {
    trip {
      _id
    }
  }
}
    `;
export const useRemoveShipmentFromTripMutation = <
      TError = Exception,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveShipmentFromTripMutation, TError, RemoveShipmentFromTripMutationVariables, TContext>) =>
    useMutation<RemoveShipmentFromTripMutation, TError, RemoveShipmentFromTripMutationVariables, TContext>(
      ['removeShipmentFromTrip'],
      (variables?: RemoveShipmentFromTripMutationVariables) => fetcher<RemoveShipmentFromTripMutation, RemoveShipmentFromTripMutationVariables>(RemoveShipmentFromTripDocument, variables)(),
      options
    );
useRemoveShipmentFromTripMutation.getKey = () => ['removeShipmentFromTrip'];

useRemoveShipmentFromTripMutation.fetcher = (variables: RemoveShipmentFromTripMutationVariables, options?: RequestInit['headers']) => fetcher<RemoveShipmentFromTripMutation, RemoveShipmentFromTripMutationVariables>(RemoveShipmentFromTripDocument, variables, options);